(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode(".rc-dplayer{width:100%;height:100%}.rc-dplayer-controller{font-size:22px}")),document.head.appendChild(e)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
import Aa, { useRef as cn, useMemo as bd, useEffect as va, useState as xd, useCallback as Ed, forwardRef as _d, useImperativeHandle as Sd } from "react";
import { createPortal as Td } from "react-dom";
var Cd = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Fi(o) {
  return o && o.__esModule && Object.prototype.hasOwnProperty.call(o, "default") ? o.default : o;
}
var xi = { exports: {} }, qn = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xs;
function Ld() {
  if (xs)
    return qn;
  xs = 1;
  var o = Aa, e = Symbol.for("react.element"), t = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, r = o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(a, l, d) {
    var h, u = {}, c = null, m = null;
    d !== void 0 && (c = "" + d), l.key !== void 0 && (c = "" + l.key), l.ref !== void 0 && (m = l.ref);
    for (h in l)
      n.call(l, h) && !i.hasOwnProperty(h) && (u[h] = l[h]);
    if (a && a.defaultProps)
      for (h in l = a.defaultProps, l)
        u[h] === void 0 && (u[h] = l[h]);
    return { $$typeof: e, type: a, key: c, ref: m, props: u, _owner: r.current };
  }
  return qn.Fragment = t, qn.jsx = s, qn.jsxs = s, qn;
}
var Xn = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Es;
function wd() {
  return Es || (Es = 1, process.env.NODE_ENV !== "production" && function() {
    var o = Aa, e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), a = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), h = Symbol.for("react.suspense_list"), u = Symbol.for("react.memo"), c = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), f = Symbol.iterator, p = "@@iterator";
    function A(j) {
      if (j === null || typeof j != "object")
        return null;
      var te = f && j[f] || j[p];
      return typeof te == "function" ? te : null;
    }
    var v = o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function b(j) {
      {
        for (var te = arguments.length, ae = new Array(te > 1 ? te - 1 : 0), Ae = 1; Ae < te; Ae++)
          ae[Ae - 1] = arguments[Ae];
        _("error", j, ae);
      }
    }
    function _(j, te, ae) {
      {
        var Ae = v.ReactDebugCurrentFrame, Fe = Ae.getStackAddendum();
        Fe !== "" && (te += "%s", ae = ae.concat([Fe]));
        var Ne = ae.map(function(ke) {
          return String(ke);
        });
        Ne.unshift("Warning: " + te), Function.prototype.apply.call(console[j], console, Ne);
      }
    }
    var T = !1, E = !1, L = !1, k = !1, D = !1, M;
    M = Symbol.for("react.module.reference");
    function O(j) {
      return !!(typeof j == "string" || typeof j == "function" || j === n || j === i || D || j === r || j === d || j === h || k || j === m || T || E || L || typeof j == "object" && j !== null && (j.$$typeof === c || j.$$typeof === u || j.$$typeof === s || j.$$typeof === a || j.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      j.$$typeof === M || j.getModuleId !== void 0));
    }
    function N(j, te, ae) {
      var Ae = j.displayName;
      if (Ae)
        return Ae;
      var Fe = te.displayName || te.name || "";
      return Fe !== "" ? ae + "(" + Fe + ")" : ae;
    }
    function B(j) {
      return j.displayName || "Context";
    }
    function U(j) {
      if (j == null)
        return null;
      if (typeof j.tag == "number" && b("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof j == "function")
        return j.displayName || j.name || null;
      if (typeof j == "string")
        return j;
      switch (j) {
        case n:
          return "Fragment";
        case t:
          return "Portal";
        case i:
          return "Profiler";
        case r:
          return "StrictMode";
        case d:
          return "Suspense";
        case h:
          return "SuspenseList";
      }
      if (typeof j == "object")
        switch (j.$$typeof) {
          case a:
            var te = j;
            return B(te) + ".Consumer";
          case s:
            var ae = j;
            return B(ae._context) + ".Provider";
          case l:
            return N(j, j.render, "ForwardRef");
          case u:
            var Ae = j.displayName || null;
            return Ae !== null ? Ae : U(j.type) || "Memo";
          case c: {
            var Fe = j, Ne = Fe._payload, ke = Fe._init;
            try {
              return U(ke(Ne));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var G = Object.assign, Y = 0, z, J, le, W, Z, ce, ue;
    function re() {
    }
    re.__reactDisabledLog = !0;
    function me() {
      {
        if (Y === 0) {
          z = console.log, J = console.info, le = console.warn, W = console.error, Z = console.group, ce = console.groupCollapsed, ue = console.groupEnd;
          var j = {
            configurable: !0,
            enumerable: !0,
            value: re,
            writable: !0
          };
          Object.defineProperties(console, {
            info: j,
            log: j,
            warn: j,
            error: j,
            group: j,
            groupCollapsed: j,
            groupEnd: j
          });
        }
        Y++;
      }
    }
    function Be() {
      {
        if (Y--, Y === 0) {
          var j = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: G({}, j, {
              value: z
            }),
            info: G({}, j, {
              value: J
            }),
            warn: G({}, j, {
              value: le
            }),
            error: G({}, j, {
              value: W
            }),
            group: G({}, j, {
              value: Z
            }),
            groupCollapsed: G({}, j, {
              value: ce
            }),
            groupEnd: G({}, j, {
              value: ue
            })
          });
        }
        Y < 0 && b("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ye = v.ReactCurrentDispatcher, Le;
    function Pe(j, te, ae) {
      {
        if (Le === void 0)
          try {
            throw Error();
          } catch (Fe) {
            var Ae = Fe.stack.trim().match(/\n( *(at )?)/);
            Le = Ae && Ae[1] || "";
          }
        return `
` + Le + j;
      }
    }
    var Me = !1, qe;
    {
      var ft = typeof WeakMap == "function" ? WeakMap : Map;
      qe = new ft();
    }
    function De(j, te) {
      if (!j || Me)
        return "";
      {
        var ae = qe.get(j);
        if (ae !== void 0)
          return ae;
      }
      var Ae;
      Me = !0;
      var Fe = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ne;
      Ne = ye.current, ye.current = null, me();
      try {
        if (te) {
          var ke = function() {
            throw Error();
          };
          if (Object.defineProperty(ke.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ke, []);
            } catch (yt) {
              Ae = yt;
            }
            Reflect.construct(j, [], ke);
          } else {
            try {
              ke.call();
            } catch (yt) {
              Ae = yt;
            }
            j.call(ke.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (yt) {
            Ae = yt;
          }
          j();
        }
      } catch (yt) {
        if (yt && Ae && typeof yt.stack == "string") {
          for (var Ie = yt.stack.split(`
`), ct = Ae.stack.split(`
`), Ve = Ie.length - 1, Qe = ct.length - 1; Ve >= 1 && Qe >= 0 && Ie[Ve] !== ct[Qe]; )
            Qe--;
          for (; Ve >= 1 && Qe >= 0; Ve--, Qe--)
            if (Ie[Ve] !== ct[Qe]) {
              if (Ve !== 1 || Qe !== 1)
                do
                  if (Ve--, Qe--, Qe < 0 || Ie[Ve] !== ct[Qe]) {
                    var mt = `
` + Ie[Ve].replace(" at new ", " at ");
                    return j.displayName && mt.includes("<anonymous>") && (mt = mt.replace("<anonymous>", j.displayName)), typeof j == "function" && qe.set(j, mt), mt;
                  }
                while (Ve >= 1 && Qe >= 0);
              break;
            }
        }
      } finally {
        Me = !1, ye.current = Ne, Be(), Error.prepareStackTrace = Fe;
      }
      var $t = j ? j.displayName || j.name : "", qt = $t ? Pe($t) : "";
      return typeof j == "function" && qe.set(j, qt), qt;
    }
    function ve(j, te, ae) {
      return De(j, !1);
    }
    function Je(j) {
      var te = j.prototype;
      return !!(te && te.isReactComponent);
    }
    function Xe(j, te, ae) {
      if (j == null)
        return "";
      if (typeof j == "function")
        return De(j, Je(j));
      if (typeof j == "string")
        return Pe(j);
      switch (j) {
        case d:
          return Pe("Suspense");
        case h:
          return Pe("SuspenseList");
      }
      if (typeof j == "object")
        switch (j.$$typeof) {
          case l:
            return ve(j.render);
          case u:
            return Xe(j.type, te, ae);
          case c: {
            var Ae = j, Fe = Ae._payload, Ne = Ae._init;
            try {
              return Xe(Ne(Fe), te, ae);
            } catch {
            }
          }
        }
      return "";
    }
    var Oe = Object.prototype.hasOwnProperty, Ke = {}, We = v.ReactDebugCurrentFrame;
    function tt(j) {
      if (j) {
        var te = j._owner, ae = Xe(j.type, j._source, te ? te.type : null);
        We.setExtraStackFrame(ae);
      } else
        We.setExtraStackFrame(null);
    }
    function et(j, te, ae, Ae, Fe) {
      {
        var Ne = Function.call.bind(Oe);
        for (var ke in j)
          if (Ne(j, ke)) {
            var Ie = void 0;
            try {
              if (typeof j[ke] != "function") {
                var ct = Error((Ae || "React class") + ": " + ae + " type `" + ke + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof j[ke] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ct.name = "Invariant Violation", ct;
              }
              Ie = j[ke](te, ke, Ae, ae, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ve) {
              Ie = Ve;
            }
            Ie && !(Ie instanceof Error) && (tt(Fe), b("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ae || "React class", ae, ke, typeof Ie), tt(null)), Ie instanceof Error && !(Ie.message in Ke) && (Ke[Ie.message] = !0, tt(Fe), b("Failed %s type: %s", ae, Ie.message), tt(null));
          }
      }
    }
    var ze = Array.isArray;
    function $e(j) {
      return ze(j);
    }
    function gt(j) {
      {
        var te = typeof Symbol == "function" && Symbol.toStringTag, ae = te && j[Symbol.toStringTag] || j.constructor.name || "Object";
        return ae;
      }
    }
    function pt(j) {
      try {
        return Lt(j), !1;
      } catch {
        return !0;
      }
    }
    function Lt(j) {
      return "" + j;
    }
    function Et(j) {
      if (pt(j))
        return b("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", gt(j)), Lt(j);
    }
    var _t = v.ReactCurrentOwner, nt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ot, Q, ne;
    ne = {};
    function K(j) {
      if (Oe.call(j, "ref")) {
        var te = Object.getOwnPropertyDescriptor(j, "ref").get;
        if (te && te.isReactWarning)
          return !1;
      }
      return j.ref !== void 0;
    }
    function fe(j) {
      if (Oe.call(j, "key")) {
        var te = Object.getOwnPropertyDescriptor(j, "key").get;
        if (te && te.isReactWarning)
          return !1;
      }
      return j.key !== void 0;
    }
    function Te(j, te) {
      if (typeof j.ref == "string" && _t.current && te && _t.current.stateNode !== te) {
        var ae = U(_t.current.type);
        ne[ae] || (b('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', U(_t.current.type), j.ref), ne[ae] = !0);
      }
    }
    function we(j, te) {
      {
        var ae = function() {
          Ot || (Ot = !0, b("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", te));
        };
        ae.isReactWarning = !0, Object.defineProperty(j, "key", {
          get: ae,
          configurable: !0
        });
      }
    }
    function Ee(j, te) {
      {
        var ae = function() {
          Q || (Q = !0, b("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", te));
        };
        ae.isReactWarning = !0, Object.defineProperty(j, "ref", {
          get: ae,
          configurable: !0
        });
      }
    }
    var Bt = function(j, te, ae, Ae, Fe, Ne, ke) {
      var Ie = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: j,
        key: te,
        ref: ae,
        props: ke,
        // Record the component responsible for creating this element.
        _owner: Ne
      };
      return Ie._store = {}, Object.defineProperty(Ie._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Ie, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ae
      }), Object.defineProperty(Ie, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Fe
      }), Object.freeze && (Object.freeze(Ie.props), Object.freeze(Ie)), Ie;
    };
    function Pt(j, te, ae, Ae, Fe) {
      {
        var Ne, ke = {}, Ie = null, ct = null;
        ae !== void 0 && (Et(ae), Ie = "" + ae), fe(te) && (Et(te.key), Ie = "" + te.key), K(te) && (ct = te.ref, Te(te, Fe));
        for (Ne in te)
          Oe.call(te, Ne) && !nt.hasOwnProperty(Ne) && (ke[Ne] = te[Ne]);
        if (j && j.defaultProps) {
          var Ve = j.defaultProps;
          for (Ne in Ve)
            ke[Ne] === void 0 && (ke[Ne] = Ve[Ne]);
        }
        if (Ie || ct) {
          var Qe = typeof j == "function" ? j.displayName || j.name || "Unknown" : j;
          Ie && we(ke, Qe), ct && Ee(ke, Qe);
        }
        return Bt(j, Ie, ct, Fe, Ae, _t.current, ke);
      }
    }
    var wt = v.ReactCurrentOwner, Gt = v.ReactDebugCurrentFrame;
    function Kt(j) {
      if (j) {
        var te = j._owner, ae = Xe(j.type, j._source, te ? te.type : null);
        Gt.setExtraStackFrame(ae);
      } else
        Gt.setExtraStackFrame(null);
    }
    var Tn;
    Tn = !1;
    function Yt(j) {
      return typeof j == "object" && j !== null && j.$$typeof === e;
    }
    function Cn() {
      {
        if (wt.current) {
          var j = U(wt.current.type);
          if (j)
            return `

Check the render method of \`` + j + "`.";
        }
        return "";
      }
    }
    function ar(j) {
      {
        if (j !== void 0) {
          var te = j.fileName.replace(/^.*[\\\/]/, ""), ae = j.lineNumber;
          return `

Check your code at ` + te + ":" + ae + ".";
        }
        return "";
      }
    }
    var Ln = {};
    function or(j) {
      {
        var te = Cn();
        if (!te) {
          var ae = typeof j == "string" ? j : j.displayName || j.name;
          ae && (te = `

Check the top-level render call using <` + ae + ">.");
        }
        return te;
      }
    }
    function lr(j, te) {
      {
        if (!j._store || j._store.validated || j.key != null)
          return;
        j._store.validated = !0;
        var ae = or(te);
        if (Ln[ae])
          return;
        Ln[ae] = !0;
        var Ae = "";
        j && j._owner && j._owner !== wt.current && (Ae = " It was passed a child from " + U(j._owner.type) + "."), Kt(j), b('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ae, Ae), Kt(null);
      }
    }
    function wn(j, te) {
      {
        if (typeof j != "object")
          return;
        if ($e(j))
          for (var ae = 0; ae < j.length; ae++) {
            var Ae = j[ae];
            Yt(Ae) && lr(Ae, te);
          }
        else if (Yt(j))
          j._store && (j._store.validated = !0);
        else if (j) {
          var Fe = A(j);
          if (typeof Fe == "function" && Fe !== j.entries)
            for (var Ne = Fe.call(j), ke; !(ke = Ne.next()).done; )
              Yt(ke.value) && lr(ke.value, te);
        }
      }
    }
    function rn(j) {
      {
        var te = j.type;
        if (te == null || typeof te == "string")
          return;
        var ae;
        if (typeof te == "function")
          ae = te.propTypes;
        else if (typeof te == "object" && (te.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        te.$$typeof === u))
          ae = te.propTypes;
        else
          return;
        if (ae) {
          var Ae = U(te);
          et(ae, j.props, "prop", Ae, j);
        } else if (te.PropTypes !== void 0 && !Tn) {
          Tn = !0;
          var Fe = U(te);
          b("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Fe || "Unknown");
        }
        typeof te.getDefaultProps == "function" && !te.getDefaultProps.isReactClassApproved && b("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Kr(j) {
      {
        for (var te = Object.keys(j.props), ae = 0; ae < te.length; ae++) {
          var Ae = te[ae];
          if (Ae !== "children" && Ae !== "key") {
            Kt(j), b("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ae), Kt(null);
            break;
          }
        }
        j.ref !== null && (Kt(j), b("Invalid attribute `ref` supplied to `React.Fragment`."), Kt(null));
      }
    }
    function dr(j, te, ae, Ae, Fe, Ne) {
      {
        var ke = O(j);
        if (!ke) {
          var Ie = "";
          (j === void 0 || typeof j == "object" && j !== null && Object.keys(j).length === 0) && (Ie += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ct = ar(Fe);
          ct ? Ie += ct : Ie += Cn();
          var Ve;
          j === null ? Ve = "null" : $e(j) ? Ve = "array" : j !== void 0 && j.$$typeof === e ? (Ve = "<" + (U(j.type) || "Unknown") + " />", Ie = " Did you accidentally export a JSX literal instead of a component?") : Ve = typeof j, b("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ve, Ie);
        }
        var Qe = Pt(j, te, ae, Fe, Ne);
        if (Qe == null)
          return Qe;
        if (ke) {
          var mt = te.children;
          if (mt !== void 0)
            if (Ae)
              if ($e(mt)) {
                for (var $t = 0; $t < mt.length; $t++)
                  wn(mt[$t], j);
                Object.freeze && Object.freeze(mt);
              } else
                b("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wn(mt, j);
        }
        return j === n ? Kr(Qe) : rn(Qe), Qe;
      }
    }
    function cr(j, te, ae) {
      return dr(j, te, ae, !0);
    }
    function ur(j, te, ae) {
      return dr(j, te, ae, !1);
    }
    var $r = ur, Vr = cr;
    Xn.Fragment = n, Xn.jsx = $r, Xn.jsxs = Vr;
  }()), Xn;
}
process.env.NODE_ENV === "production" ? xi.exports = Ld() : xi.exports = wd();
var Ut = xi.exports;
function Rd(o, e) {
  var t = typeof Symbol == "function" && o[Symbol.iterator];
  if (!t)
    return o;
  var n = t.call(o), r, i = [], s;
  try {
    for (; (e === void 0 || e-- > 0) && !(r = n.next()).done; )
      i.push(r.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      r && !r.done && (t = n.return) && t.call(n);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return i;
}
var ba = function(o) {
  return typeof o == "function";
}, Id = process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test";
const xa = Id;
function Mi(o) {
  xa && (ba(o) || console.error("useMemoizedFn expected parameter is a function, got ".concat(typeof o)));
  var e = cn(o);
  e.current = bd(function() {
    return o;
  }, [o]);
  var t = cn();
  return t.current || (t.current = function() {
    for (var n = [], r = 0; r < arguments.length; r++)
      n[r] = arguments[r];
    return e.current.apply(this, n);
  }), t.current;
}
function kd(o, e) {
  if (o === e)
    return !0;
  for (var t = 0; t < o.length; t++)
    if (!Object.is(o[t], e[t]))
      return !1;
  return !0;
}
function Dd(o, e) {
  var t = cn({
    deps: e,
    obj: void 0,
    initialized: !1
  }).current;
  return (t.initialized === !1 || !kd(t.deps, e)) && (t.deps = e, t.obj = o(), t.initialized = !0), t.obj;
}
function Od(o) {
  var e = cn(o);
  return e.current = o, e;
}
var Bd = function(o) {
  xa && (ba(o) || console.error("useUnmount expected parameter is a function, got ".concat(typeof o)));
  var e = Od(o);
  va(function() {
    return function() {
      e.current();
    };
  }, []);
};
const Pd = Bd;
var Fd = function() {
  var o = Rd(xd({}), 2), e = o[1];
  return Ed(function() {
    return e({});
  }, []);
};
const Md = Fd;
var Ea = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(o) {
  (function() {
    var e = {}.hasOwnProperty;
    function t() {
      for (var n = [], r = 0; r < arguments.length; r++) {
        var i = arguments[r];
        if (i) {
          var s = typeof i;
          if (s === "string" || s === "number")
            n.push(i);
          else if (Array.isArray(i)) {
            if (i.length) {
              var a = t.apply(null, i);
              a && n.push(a);
            }
          } else if (s === "object") {
            if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]")) {
              n.push(i.toString());
              continue;
            }
            for (var l in i)
              e.call(i, l) && i[l] && n.push(l);
          }
        }
      }
      return n.join(" ");
    }
    o.exports ? (t.default = t, o.exports = t) : window.classNames = t;
  })();
})(Ea);
var Ud = Ea.exports;
const Ui = /* @__PURE__ */ Fi(Ud);
var _a = { exports: {} };
(function(o, e) {
  (function(t, n) {
    o.exports = n();
  })(self, () => (() => {
    var t = { 916: (s, a, l) => {
      var d = l(471);
      s.exports = function(h) {
        var u, c = "", m = (h = h || {}).video, f = h.options, p = d.$escape, A = h.tran, v = h.icons, b = h.index, _ = d.$each;
        return h.$value, h.$index, c += `<div class="dplayer-mask"></div>
<div class="dplayer-video-wrap">
    `, u = l(568)(m), c += u, c += `
    `, f.logo && (c += `
    <div class="dplayer-logo">
        <img src="`, c += p(f.logo), c += `">
    </div>
    `), c += `
    <div class="dplayer-danmaku"`, f.danmaku && f.danmaku.bottom && (c += ' style="margin-bottom:', c += p(f.danmaku.bottom), c += '"'), c += `>
        <div class="dplayer-danmaku-item dplayer-danmaku-item--demo"></div>
    </div>
    <div class="dplayer-subtitle"></div>
    <div class="dplayer-bezel">
        <span class="dplayer-bezel-icon"></span>
        `, f.danmaku && (c += `
        <span class="dplayer-danloading">`, c += p(A("danmaku-loading")), c += `</span>
        `), c += `
        <span class="diplayer-loading-icon">`, c += v.loading, c += `</span>
    </div>
</div>
<div class="dplayer-controller-mask"></div>
<div class="dplayer-controller">
    <div class="dplayer-icons dplayer-comment-box">
        <button class="dplayer-icon dplayer-comment-setting-icon" data-balloon="`, c += p(A("setting")), c += `" data-balloon-pos="up">
            <span class="dplayer-icon-content">`, c += v.pallette, c += `</span>
        </button>
        <div class="dplayer-comment-setting-box">
            <div class="dplayer-comment-setting-color">
                <div class="dplayer-comment-setting-title">`, c += p(A("set-danmaku-color")), c += `</div>
                <label>
                    <input type="radio" name="dplayer-danmaku-color-`, c += p(b), c += `" value="#fff" checked>
                    <span style="background: #fff;"></span>
                </label>
                <label>
                    <input type="radio" name="dplayer-danmaku-color-`, c += p(b), c += `" value="#e54256">
                    <span style="background: #e54256"></span>
                </label>
                <label>
                    <input type="radio" name="dplayer-danmaku-color-`, c += p(b), c += `" value="#ffe133">
                    <span style="background: #ffe133"></span>
                </label>
                <label>
                    <input type="radio" name="dplayer-danmaku-color-`, c += p(b), c += `" value="#64DD17">
                    <span style="background: #64DD17"></span>
                </label>
                <label>
                    <input type="radio" name="dplayer-danmaku-color-`, c += p(b), c += `" value="#39ccff">
                    <span style="background: #39ccff"></span>
                </label>
                <label>
                    <input type="radio" name="dplayer-danmaku-color-`, c += p(b), c += `" value="#D500F9">
                    <span style="background: #D500F9"></span>
                </label>
            </div>
            <div class="dplayer-comment-setting-type">
                <div class="dplayer-comment-setting-title">`, c += p(A("set-danmaku-type")), c += `</div>
                <label>
                    <input type="radio" name="dplayer-danmaku-type-`, c += p(b), c += `" value="1">
                    <span>`, c += p(A("top")), c += `</span>
                </label>
                <label>
                    <input type="radio" name="dplayer-danmaku-type-`, c += p(b), c += `" value="0" checked>
                    <span>`, c += p(A("rolling")), c += `</span>
                </label>
                <label>
                    <input type="radio" name="dplayer-danmaku-type-`, c += p(b), c += `" value="2">
                    <span>`, c += p(A("bottom")), c += `</span>
                </label>
            </div>
        </div>
        <input class="dplayer-comment-input" type="text" placeholder="`, c += p(A("input-danmaku-enter")), c += `" maxlength="30">
        <button class="dplayer-icon dplayer-send-icon" data-balloon="`, c += p(A("send")), c += `" data-balloon-pos="up">
            <span class="dplayer-icon-content">`, c += v.send, c += `</span>
        </button>
    </div>
    <div class="dplayer-icons dplayer-icons-left">
        <button class="dplayer-icon dplayer-play-icon">
            <span class="dplayer-icon-content">`, c += v.play, c += `</span>
        </button>
        <div class="dplayer-volume">
            <button class="dplayer-icon dplayer-volume-icon">
                <span class="dplayer-icon-content">`, c += v.volumeDown, c += `</span>
            </button>
            <div class="dplayer-volume-bar-wrap" data-balloon-pos="up">
                <div class="dplayer-volume-bar">
                    <div class="dplayer-volume-bar-inner" style="background: `, c += p(f.theme), c += `;">
                        <span class="dplayer-thumb" style="background: `, c += p(f.theme), c += `"></span>
                    </div>
                </div>
            </div>
        </div>
        <span class="dplayer-time">
            <span class="dplayer-ptime">0:00</span> /
            <span class="dplayer-dtime">0:00</span>
        </span>
        `, f.live && (c += `
        <span class="dplayer-live-badge"><span class="dplayer-live-dot" style="background: `, c += p(f.theme), c += ';"></span>', c += p(A("live")), c += `</span>
        `), c += `
    </div>
    <div class="dplayer-icons dplayer-icons-right">
        `, f.video.quality && (c += `
        <div class="dplayer-quality">
            <button class="dplayer-icon dplayer-quality-icon">`, c += p(f.video.quality[f.video.defaultQuality].name), c += `</button>
            <div class="dplayer-quality-mask">
                <div class="dplayer-quality-list">
                `, _(f.video.quality, function(T, E) {
          c += `
                    <div class="dplayer-quality-item" data-index="`, c += p(E), c += '">', c += p(T.name), c += `</div>
                `;
        }), c += `
                </div>
            </div>
        </div>
        `), c += `
        `, f.screenshot && (c += `
        <div class="dplayer-icon dplayer-camera-icon" data-balloon="`, c += p(A("screenshot")), c += `" data-balloon-pos="up">
            <span class="dplayer-icon-content">`, c += v.camera, c += `</span>
        </div>
        `), c += `
        `, f.airplay && (c += `
        <div class="dplayer-icon dplayer-airplay-icon" data-balloon="`, c += p(A("airplay")), c += `" data-balloon-pos="up">
            <span class="dplayer-icon-content">`, c += v.airplay, c += `</span>
        </div>
        `), c += `
        `, f.chromecast && (c += `
        <div class="dplayer-icon dplayer-chromecast-icon" data-balloon="`, c += p(A("chromecast")), c += `" data-balloon-pos="up">
            <span class="dplayer-icon-content">`, c += v.chromecast, c += `</span>
        </div>
        `), c += `
        <div class="dplayer-comment">
            <button class="dplayer-icon dplayer-comment-icon" data-balloon="`, c += p(A("send-danmaku")), c += `" data-balloon-pos="up">
                <span class="dplayer-icon-content">`, c += v.comment, c += `</span>
            </button>
        </div>
        `, f.subtitle && (c += `
        `, typeof f.subtitle.url == "string" ? (c += `
        <div class="dplayer-subtitle-btn">
            <button class="dplayer-icon dplayer-subtitle-icon" data-balloon="`, c += p(A("hide-subs")), c += `" data-balloon-pos="up">
                <span class="dplayer-icon-content">`, c += v.subtitle, c += `</span>
            </button>
        </div>
        `) : (c += `
        <div class="dplayer-subtitles">
            <button class="dplayer-icon dplayer-subtitles-icon" data-balloon="`, c += p(A("subtitle")), c += `" data-balloon-pos="up">
                <span class="dplayer-icon-content">`, c += v.subtitle, c += `</span>
            </button>
            <div class="dplayer-subtitles-box">
                <div class="dplayer-subtitles-panel">
                    `, _(f.subtitle.url, function(T, E) {
          c += `
                        <div class="dplayer-subtitles-item" data-subtitle="`, c += p(T.url), c += `">
                            <!-- if lang, show tran(lang). if lang and name, show name + (tran(lang)). if name, show name. off option use lang for translation. -->
                            <span class="dplayer-label">`, c += p(T.lang ? T.name ? T.name + " (" + A(T.lang) + ")" : A(T.lang) : T.name), c += `</span>
                        </div>
                    `;
        }), c += `
                </div>
            </div>
        </div>
        `), c += `
        `), c += `
        <div class="dplayer-setting">
            <button class="dplayer-icon dplayer-setting-icon" data-balloon="`, c += p(A("setting")), c += `" data-balloon-pos="up">
                <span class="dplayer-icon-content">`, c += v.setting, c += `</span>
            </button>
            <div class="dplayer-setting-box">
                <div class="dplayer-setting-origin-panel">
                    <div class="dplayer-setting-item dplayer-setting-speed">
                        <span class="dplayer-label">`, c += p(A("speed")), c += `</span>
                        <div class="dplayer-toggle">`, c += v.right, c += `</div>
                    </div>
                    <div class="dplayer-setting-item dplayer-setting-loop">
                        <span class="dplayer-label">`, c += p(A("loop")), c += `</span>
                        <div class="dplayer-toggle">
                            <input class="dplayer-toggle-setting-input" type="checkbox" name="dplayer-toggle">
                            <label for="dplayer-toggle"></label>
                        </div>
                    </div>
                    <div class="dplayer-setting-item dplayer-setting-showdan">
                        <span class="dplayer-label">`, c += p(A("show-danmaku")), c += `</span>
                        <div class="dplayer-toggle">
                            <input class="dplayer-showdan-setting-input" type="checkbox" name="dplayer-toggle-dan">
                            <label for="dplayer-toggle-dan"></label>
                        </div>
                    </div>
                    <div class="dplayer-setting-item dplayer-setting-danunlimit">
                        <span class="dplayer-label">`, c += p(A("unlimited-danmaku")), c += `</span>
                        <div class="dplayer-toggle">
                            <input class="dplayer-danunlimit-setting-input" type="checkbox" name="dplayer-toggle-danunlimit">
                            <label for="dplayer-toggle-danunlimit"></label>
                        </div>
                    </div>
                    <div class="dplayer-setting-item dplayer-setting-danmaku">
                        <span class="dplayer-label">`, c += p(A("opacity-danmaku")), c += `</span>
                        <div class="dplayer-danmaku-bar-wrap">
                            <div class="dplayer-danmaku-bar">
                                <div class="dplayer-danmaku-bar-inner">
                                    <span class="dplayer-thumb"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dplayer-setting-speed-panel">
                    `, _(f.playbackSpeed, function(T, E) {
          c += `
                        <div class="dplayer-setting-speed-item" data-speed="`, c += p(T), c += `">
                            <span class="dplayer-label">`, c += p(T === 1 ? A("normal") : T), c += `</span>
                        </div>
                    `;
        }), c += `
                </div>
            </div>
        </div>
        <div class="dplayer-full">
            <button class="dplayer-icon dplayer-full-in-icon" data-balloon="`, c += p(A("web-fullscreen")), c += `" data-balloon-pos="up">
                <span class="dplayer-icon-content">`, c += v.fullWeb, c += `</span>
            </button>
            <button class="dplayer-icon dplayer-full-icon" data-balloon="`, c += p(A("fullscreen")), c += `" data-balloon-pos="up">
                <span class="dplayer-icon-content">`, c += v.full, c += `</span>
            </button>
        </div>
    </div>
    <div class="dplayer-bar-wrap">
        <div class="dplayer-bar-time hidden">00:00</div>
        <div class="dplayer-bar-preview"></div>
        <div class="dplayer-bar">
            <div class="dplayer-loaded" style="width: 0;"></div>
            <div class="dplayer-played" style="width: 0; background: `, c += p(f.theme), c += `">
                <span class="dplayer-thumb" style="background: `, c += p(f.theme), c += `"></span>
            </div>
        </div>
    </div>
</div>
<div class="dplayer-info-panel dplayer-info-panel-hide">
    <div class="dplayer-info-panel-close">[x]</div>
    <div class="dplayer-info-panel-item dplayer-info-panel-item-version">
        <span class="dplayer-info-panel-item-title">Player version</span>
        <span class="dplayer-info-panel-item-data"></span>
    </div>
    <div class="dplayer-info-panel-item dplayer-info-panel-item-fps">
        <span class="dplayer-info-panel-item-title">Player FPS</span>
        <span class="dplayer-info-panel-item-data"></span>
    </div>
    <div class="dplayer-info-panel-item dplayer-info-panel-item-type">
        <span class="dplayer-info-panel-item-title">Video type</span>
        <span class="dplayer-info-panel-item-data"></span>
    </div>
    <div class="dplayer-info-panel-item dplayer-info-panel-item-url">
        <span class="dplayer-info-panel-item-title">Video url</span>
        <span class="dplayer-info-panel-item-data"></span>
    </div>
    <div class="dplayer-info-panel-item dplayer-info-panel-item-resolution">
        <span class="dplayer-info-panel-item-title">Video resolution</span>
        <span class="dplayer-info-panel-item-data"></span>
    </div>
    <div class="dplayer-info-panel-item dplayer-info-panel-item-duration">
        <span class="dplayer-info-panel-item-title">Video duration</span>
        <span class="dplayer-info-panel-item-data"></span>
    </div>
    `, f.danmaku && (c += `
    <div class="dplayer-info-panel-item dplayer-info-panel-item-danmaku-id">
        <span class="dplayer-info-panel-item-title">Danmaku id</span>
        <span class="dplayer-info-panel-item-data"></span>
    </div>
    <div class="dplayer-info-panel-item dplayer-info-panel-item-danmaku-api">
        <span class="dplayer-info-panel-item-title">Danmaku api</span>
        <span class="dplayer-info-panel-item-data"></span>
    </div>
    <div class="dplayer-info-panel-item dplayer-info-panel-item-danmaku-amount">
        <span class="dplayer-info-panel-item-title">Danmaku amount</span>
        <span class="dplayer-info-panel-item-data"></span>
    </div>
    `), c += `
</div>
<div class="dplayer-menu">
    `, _(f.contextmenu, function(T, E) {
          c += `
        <div class="dplayer-menu-item">
            <a`, T.link && (c += ' target="_blank"'), c += ' href="', c += p(T.link || "javascript:void(0);"), c += '">', T.key && (c += " ", c += p(A(T.key))), T.text && (c += " ", c += p(T.text)), c += `</a>
        </div>
    `;
        }), c += `
</div>
<div class="dplayer-notice-list"></div>
<button class="dplayer-mobile-play">
    `, c += v.play, c += `
</button>`;
      };
    }, 568: (s, a, l) => {
      var d = l(471);
      s.exports = function(h) {
        var u = "", c = (h = h || {}).enableSubtitle, m = h.subtitle, f = h.current, p = h.airplay, A = h.pic, v = d.$escape, b = h.screenshot, _ = h.preload, T = h.url;
        return c = m && m.type === "webvtt", u += `
<video
    class="dplayer-video `, f && (u += "dplayer-video-current"), u += `"
    webkit-playsinline
    `, p && (u += ' x-webkit-airplay="allow" '), u += `
    playsinline
    `, A && (u += 'poster="', u += v(A), u += '"'), u += `
    `, (b || c) && (u += 'crossorigin="anonymous"'), u += `
    `, _ && (u += 'preload="', u += v(_), u += '"'), u += `
    `, p ? u += `
    nosrc
    ` : T && (u += `
    src="`, u += v(T), u += `"
    `), u += `
    >
    `, p && (u += `
    <source src="`, u += v(T), u += `">
    `), u += `
    `, c && (u += `
    <track class="dplayer-subtrack" kind="metadata" default src="`, u += v(typeof m.url == "string" ? m.url : m.url[m.index].url), u += `"></track>
    `), u + `
</video>`;
      };
    }, 49: (s, a, l) => {
      l.d(a, { Z: () => m });
      var d = l(415), h = l.n(d), u = l(352), c = l.n(u)()(h());
      c.push([s.id, `:root {
  --balloon-border-radius: 2px;
  --balloon-color: rgba(16, 16, 16, 0.95);
  --balloon-text-color: #fff;
  --balloon-font-size: 12px;
  --balloon-move: 4px; }

button[aria-label][data-balloon-pos] {
  overflow: visible; }

[aria-label][data-balloon-pos] {
  position: relative;
  cursor: pointer; }
  [aria-label][data-balloon-pos]:after {
    opacity: 0;
    pointer-events: none;
    transition: all 0.18s ease-out 0.18s;
    text-indent: 0;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
    font-weight: normal;
    font-style: normal;
    text-shadow: none;
    font-size: 12px;
    font-size: var(--balloon-font-size);
    background: rgba(16, 16, 16, 0.95);
    background: var(--balloon-color);
    border-radius: 2px;
    color: #fff;
    color: var(--balloon-text-color);
    border-radius: var(--balloon-border-radius);
    content: attr(aria-label);
    padding: .5em 1em;
    position: absolute;
    white-space: nowrap;
    z-index: 10; }
  [aria-label][data-balloon-pos]:before {
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-top-color: rgba(16, 16, 16, 0.95);
    border-top-color: var(--balloon-color);
    opacity: 0;
    pointer-events: none;
    transition: all 0.18s ease-out 0.18s;
    content: "";
    position: absolute;
    z-index: 10; }
  [aria-label][data-balloon-pos]:hover:before, [aria-label][data-balloon-pos]:hover:after, [aria-label][data-balloon-pos][data-balloon-visible]:before, [aria-label][data-balloon-pos][data-balloon-visible]:after, [aria-label][data-balloon-pos]:not([data-balloon-nofocus]):focus:before, [aria-label][data-balloon-pos]:not([data-balloon-nofocus]):focus:after {
    opacity: 1;
    pointer-events: none; }
  [aria-label][data-balloon-pos].font-awesome:after {
    font-family: FontAwesome, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; }
  [aria-label][data-balloon-pos][data-balloon-break]:after {
    white-space: pre; }
  [aria-label][data-balloon-pos][data-balloon-break][data-balloon-length]:after {
    white-space: pre-line;
    word-break: break-word; }
  [aria-label][data-balloon-pos][data-balloon-blunt]:before, [aria-label][data-balloon-pos][data-balloon-blunt]:after {
    transition: none; }
  [aria-label][data-balloon-pos][data-balloon-pos="up"]:hover:after, [aria-label][data-balloon-pos][data-balloon-pos="up"][data-balloon-visible]:after, [aria-label][data-balloon-pos][data-balloon-pos="down"]:hover:after, [aria-label][data-balloon-pos][data-balloon-pos="down"][data-balloon-visible]:after {
    transform: translate(-50%, 0); }
  [aria-label][data-balloon-pos][data-balloon-pos="up"]:hover:before, [aria-label][data-balloon-pos][data-balloon-pos="up"][data-balloon-visible]:before, [aria-label][data-balloon-pos][data-balloon-pos="down"]:hover:before, [aria-label][data-balloon-pos][data-balloon-pos="down"][data-balloon-visible]:before {
    transform: translate(-50%, 0); }
  [aria-label][data-balloon-pos][data-balloon-pos*="-left"]:after {
    left: 0; }
  [aria-label][data-balloon-pos][data-balloon-pos*="-left"]:before {
    left: 5px; }
  [aria-label][data-balloon-pos][data-balloon-pos*="-right"]:after {
    right: 0; }
  [aria-label][data-balloon-pos][data-balloon-pos*="-right"]:before {
    right: 5px; }
  [aria-label][data-balloon-pos][data-balloon-po*="-left"]:hover:after, [aria-label][data-balloon-pos][data-balloon-po*="-left"][data-balloon-visible]:after, [aria-label][data-balloon-pos][data-balloon-pos*="-right"]:hover:after, [aria-label][data-balloon-pos][data-balloon-pos*="-right"][data-balloon-visible]:after {
    transform: translate(0, 0); }
  [aria-label][data-balloon-pos][data-balloon-po*="-left"]:hover:before, [aria-label][data-balloon-pos][data-balloon-po*="-left"][data-balloon-visible]:before, [aria-label][data-balloon-pos][data-balloon-pos*="-right"]:hover:before, [aria-label][data-balloon-pos][data-balloon-pos*="-right"][data-balloon-visible]:before {
    transform: translate(0, 0); }
  [aria-label][data-balloon-pos][data-balloon-pos^="up"]:before, [aria-label][data-balloon-pos][data-balloon-pos^="up"]:after {
    bottom: 100%;
    transform-origin: top;
    transform: translate(0, 4px);
    transform: translate(0, var(--balloon-move)); }
  [aria-label][data-balloon-pos][data-balloon-pos^="up"]:after {
    margin-bottom: 10px; }
  [aria-label][data-balloon-pos][data-balloon-pos="up"]:before, [aria-label][data-balloon-pos][data-balloon-pos="up"]:after {
    left: 50%;
    transform: translate(-50%, 4px);
    transform: translate(-50%, var(--balloon-move)); }
  [aria-label][data-balloon-pos][data-balloon-pos^="down"]:before, [aria-label][data-balloon-pos][data-balloon-pos^="down"]:after {
    top: 100%;
    transform: translate(0, calc(4px * -1));
    transform: translate(0, calc(var(--balloon-move) * -1)); }
  [aria-label][data-balloon-pos][data-balloon-pos^="down"]:after {
    margin-top: 10px; }
  [aria-label][data-balloon-pos][data-balloon-pos^="down"]:before {
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-bottom-color: rgba(16, 16, 16, 0.95);
    border-bottom-color: var(--balloon-color); }
  [aria-label][data-balloon-pos][data-balloon-pos="down"]:after, [aria-label][data-balloon-pos][data-balloon-pos="down"]:before {
    left: 50%;
    transform: translate(-50%, calc(4px * -1));
    transform: translate(-50%, calc(var(--balloon-move) * -1)); }
  [aria-label][data-balloon-pos][data-balloon-pos="left"]:hover:after, [aria-label][data-balloon-pos][data-balloon-pos="left"][data-balloon-visible]:after, [aria-label][data-balloon-pos][data-balloon-pos="right"]:hover:after, [aria-label][data-balloon-pos][data-balloon-pos="right"][data-balloon-visible]:after {
    transform: translate(0, -50%); }
  [aria-label][data-balloon-pos][data-balloon-pos="left"]:hover:before, [aria-label][data-balloon-pos][data-balloon-pos="left"][data-balloon-visible]:before, [aria-label][data-balloon-pos][data-balloon-pos="right"]:hover:before, [aria-label][data-balloon-pos][data-balloon-pos="right"][data-balloon-visible]:before {
    transform: translate(0, -50%); }
  [aria-label][data-balloon-pos][data-balloon-pos="left"]:after, [aria-label][data-balloon-pos][data-balloon-pos="left"]:before {
    right: 100%;
    top: 50%;
    transform: translate(4px, -50%);
    transform: translate(var(--balloon-move), -50%); }
  [aria-label][data-balloon-pos][data-balloon-pos="left"]:after {
    margin-right: 10px; }
  [aria-label][data-balloon-pos][data-balloon-pos="left"]:before {
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-left-color: rgba(16, 16, 16, 0.95);
    border-left-color: var(--balloon-color); }
  [aria-label][data-balloon-pos][data-balloon-pos="right"]:after, [aria-label][data-balloon-pos][data-balloon-pos="right"]:before {
    left: 100%;
    top: 50%;
    transform: translate(calc(4px * -1), -50%);
    transform: translate(calc(var(--balloon-move) * -1), -50%); }
  [aria-label][data-balloon-pos][data-balloon-pos="right"]:after {
    margin-left: 10px; }
  [aria-label][data-balloon-pos][data-balloon-pos="right"]:before {
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-right-color: rgba(16, 16, 16, 0.95);
    border-right-color: var(--balloon-color); }
  [aria-label][data-balloon-pos][data-balloon-length]:after {
    white-space: normal; }
  [aria-label][data-balloon-pos][data-balloon-length="small"]:after {
    width: 80px; }
  [aria-label][data-balloon-pos][data-balloon-length="medium"]:after {
    width: 150px; }
  [aria-label][data-balloon-pos][data-balloon-length="large"]:after {
    width: 260px; }
  [aria-label][data-balloon-pos][data-balloon-length="xlarge"]:after {
    width: 380px; }
    @media screen and (max-width: 768px) {
      [aria-label][data-balloon-pos][data-balloon-length="xlarge"]:after {
        width: 90vw; } }
  [aria-label][data-balloon-pos][data-balloon-length="fit"]:after {
    width: 100%; }
`, "", { version: 3, sources: ["webpack://./node_modules/.pnpm/balloon-css@1.2.0/node_modules/balloon-css/balloon.css"], names: [], mappings: "AAAA;EACE,4BAA4B;EAC5B,uCAAuC;EACvC,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB,EAAE;;AAEvB;EACE,iBAAiB,EAAE;;AAErB;EACE,kBAAkB;EAClB,eAAe,EAAE;EACjB;IACE,UAAU;IACV,oBAAoB;IACpB,oCAAoC;IACpC,cAAc;IACd,wIAAwI;IACxI,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,eAAmC;IAAnC,mCAAmC;IACnC,kCAAgC;IAAhC,gCAAgC;IAChC,kBAAkB;IAClB,WAAgC;IAAhC,gCAAgC;IAChC,2CAA2C;IAC3C,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW,EAAE;EACf;IACE,QAAQ;IACR,SAAS;IACT,6BAA6B;IAC7B,wCAAsC;IAAtC,sCAAsC;IACtC,UAAU;IACV,oBAAoB;IACpB,oCAAoC;IACpC,WAAW;IACX,kBAAkB;IAClB,WAAW,EAAE;EACf;IACE,UAAU;IACV,oBAAoB,EAAE;EACxB;IACE,qJAAqJ,EAAE;EACzJ;IACE,gBAAgB,EAAE;EACpB;IACE,qBAAqB;IACrB,sBAAsB,EAAE;EAC1B;IACE,gBAAgB,EAAE;EACpB;IACE,6BAA6B,EAAE;EACjC;IACE,6BAA6B,EAAE;EACjC;IACE,OAAO,EAAE;EACX;IACE,SAAS,EAAE;EACb;IACE,QAAQ,EAAE;EACZ;IACE,UAAU,EAAE;EACd;IACE,0BAA0B,EAAE;EAC9B;IACE,0BAA0B,EAAE;EAC9B;IACE,YAAY;IACZ,qBAAqB;IACrB,4BAA4C;IAA5C,4CAA4C,EAAE;EAChD;IACE,mBAAmB,EAAE;EACvB;IACE,SAAS;IACT,+BAA+C;IAA/C,+CAA+C,EAAE;EACnD;IACE,SAAS;IACT,uCAAuD;IAAvD,uDAAuD,EAAE;EAC3D;IACE,gBAAgB,EAAE;EACpB;IACE,QAAQ;IACR,SAAS;IACT,6BAA6B;IAC7B,2CAAyC;IAAzC,yCAAyC,EAAE;EAC7C;IACE,SAAS;IACT,0CAA0D;IAA1D,0DAA0D,EAAE;EAC9D;IACE,6BAA6B,EAAE;EACjC;IACE,6BAA6B,EAAE;EACjC;IACE,WAAW;IACX,QAAQ;IACR,+BAA+C;IAA/C,+CAA+C,EAAE;EACnD;IACE,kBAAkB,EAAE;EACtB;IACE,QAAQ;IACR,SAAS;IACT,6BAA6B;IAC7B,yCAAuC;IAAvC,uCAAuC,EAAE;EAC3C;IACE,UAAU;IACV,QAAQ;IACR,0CAA0D;IAA1D,0DAA0D,EAAE;EAC9D;IACE,iBAAiB,EAAE;EACrB;IACE,QAAQ;IACR,SAAS;IACT,6BAA6B;IAC7B,0CAAwC;IAAxC,wCAAwC,EAAE;EAC5C;IACE,mBAAmB,EAAE;EACvB;IACE,WAAW,EAAE;EACf;IACE,YAAY,EAAE;EAChB;IACE,YAAY,EAAE;EAChB;IACE,YAAY,EAAE;IACd;MACE;QACE,WAAW,EAAE,EAAE;EACrB;IACE,WAAW,EAAE", sourcesContent: [`:root {
  --balloon-border-radius: 2px;
  --balloon-color: rgba(16, 16, 16, 0.95);
  --balloon-text-color: #fff;
  --balloon-font-size: 12px;
  --balloon-move: 4px; }

button[aria-label][data-balloon-pos] {
  overflow: visible; }

[aria-label][data-balloon-pos] {
  position: relative;
  cursor: pointer; }
  [aria-label][data-balloon-pos]:after {
    opacity: 0;
    pointer-events: none;
    transition: all 0.18s ease-out 0.18s;
    text-indent: 0;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
    font-weight: normal;
    font-style: normal;
    text-shadow: none;
    font-size: var(--balloon-font-size);
    background: var(--balloon-color);
    border-radius: 2px;
    color: var(--balloon-text-color);
    border-radius: var(--balloon-border-radius);
    content: attr(aria-label);
    padding: .5em 1em;
    position: absolute;
    white-space: nowrap;
    z-index: 10; }
  [aria-label][data-balloon-pos]:before {
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-top-color: var(--balloon-color);
    opacity: 0;
    pointer-events: none;
    transition: all 0.18s ease-out 0.18s;
    content: "";
    position: absolute;
    z-index: 10; }
  [aria-label][data-balloon-pos]:hover:before, [aria-label][data-balloon-pos]:hover:after, [aria-label][data-balloon-pos][data-balloon-visible]:before, [aria-label][data-balloon-pos][data-balloon-visible]:after, [aria-label][data-balloon-pos]:not([data-balloon-nofocus]):focus:before, [aria-label][data-balloon-pos]:not([data-balloon-nofocus]):focus:after {
    opacity: 1;
    pointer-events: none; }
  [aria-label][data-balloon-pos].font-awesome:after {
    font-family: FontAwesome, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; }
  [aria-label][data-balloon-pos][data-balloon-break]:after {
    white-space: pre; }
  [aria-label][data-balloon-pos][data-balloon-break][data-balloon-length]:after {
    white-space: pre-line;
    word-break: break-word; }
  [aria-label][data-balloon-pos][data-balloon-blunt]:before, [aria-label][data-balloon-pos][data-balloon-blunt]:after {
    transition: none; }
  [aria-label][data-balloon-pos][data-balloon-pos="up"]:hover:after, [aria-label][data-balloon-pos][data-balloon-pos="up"][data-balloon-visible]:after, [aria-label][data-balloon-pos][data-balloon-pos="down"]:hover:after, [aria-label][data-balloon-pos][data-balloon-pos="down"][data-balloon-visible]:after {
    transform: translate(-50%, 0); }
  [aria-label][data-balloon-pos][data-balloon-pos="up"]:hover:before, [aria-label][data-balloon-pos][data-balloon-pos="up"][data-balloon-visible]:before, [aria-label][data-balloon-pos][data-balloon-pos="down"]:hover:before, [aria-label][data-balloon-pos][data-balloon-pos="down"][data-balloon-visible]:before {
    transform: translate(-50%, 0); }
  [aria-label][data-balloon-pos][data-balloon-pos*="-left"]:after {
    left: 0; }
  [aria-label][data-balloon-pos][data-balloon-pos*="-left"]:before {
    left: 5px; }
  [aria-label][data-balloon-pos][data-balloon-pos*="-right"]:after {
    right: 0; }
  [aria-label][data-balloon-pos][data-balloon-pos*="-right"]:before {
    right: 5px; }
  [aria-label][data-balloon-pos][data-balloon-po*="-left"]:hover:after, [aria-label][data-balloon-pos][data-balloon-po*="-left"][data-balloon-visible]:after, [aria-label][data-balloon-pos][data-balloon-pos*="-right"]:hover:after, [aria-label][data-balloon-pos][data-balloon-pos*="-right"][data-balloon-visible]:after {
    transform: translate(0, 0); }
  [aria-label][data-balloon-pos][data-balloon-po*="-left"]:hover:before, [aria-label][data-balloon-pos][data-balloon-po*="-left"][data-balloon-visible]:before, [aria-label][data-balloon-pos][data-balloon-pos*="-right"]:hover:before, [aria-label][data-balloon-pos][data-balloon-pos*="-right"][data-balloon-visible]:before {
    transform: translate(0, 0); }
  [aria-label][data-balloon-pos][data-balloon-pos^="up"]:before, [aria-label][data-balloon-pos][data-balloon-pos^="up"]:after {
    bottom: 100%;
    transform-origin: top;
    transform: translate(0, var(--balloon-move)); }
  [aria-label][data-balloon-pos][data-balloon-pos^="up"]:after {
    margin-bottom: 10px; }
  [aria-label][data-balloon-pos][data-balloon-pos="up"]:before, [aria-label][data-balloon-pos][data-balloon-pos="up"]:after {
    left: 50%;
    transform: translate(-50%, var(--balloon-move)); }
  [aria-label][data-balloon-pos][data-balloon-pos^="down"]:before, [aria-label][data-balloon-pos][data-balloon-pos^="down"]:after {
    top: 100%;
    transform: translate(0, calc(var(--balloon-move) * -1)); }
  [aria-label][data-balloon-pos][data-balloon-pos^="down"]:after {
    margin-top: 10px; }
  [aria-label][data-balloon-pos][data-balloon-pos^="down"]:before {
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-bottom-color: var(--balloon-color); }
  [aria-label][data-balloon-pos][data-balloon-pos="down"]:after, [aria-label][data-balloon-pos][data-balloon-pos="down"]:before {
    left: 50%;
    transform: translate(-50%, calc(var(--balloon-move) * -1)); }
  [aria-label][data-balloon-pos][data-balloon-pos="left"]:hover:after, [aria-label][data-balloon-pos][data-balloon-pos="left"][data-balloon-visible]:after, [aria-label][data-balloon-pos][data-balloon-pos="right"]:hover:after, [aria-label][data-balloon-pos][data-balloon-pos="right"][data-balloon-visible]:after {
    transform: translate(0, -50%); }
  [aria-label][data-balloon-pos][data-balloon-pos="left"]:hover:before, [aria-label][data-balloon-pos][data-balloon-pos="left"][data-balloon-visible]:before, [aria-label][data-balloon-pos][data-balloon-pos="right"]:hover:before, [aria-label][data-balloon-pos][data-balloon-pos="right"][data-balloon-visible]:before {
    transform: translate(0, -50%); }
  [aria-label][data-balloon-pos][data-balloon-pos="left"]:after, [aria-label][data-balloon-pos][data-balloon-pos="left"]:before {
    right: 100%;
    top: 50%;
    transform: translate(var(--balloon-move), -50%); }
  [aria-label][data-balloon-pos][data-balloon-pos="left"]:after {
    margin-right: 10px; }
  [aria-label][data-balloon-pos][data-balloon-pos="left"]:before {
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-left-color: var(--balloon-color); }
  [aria-label][data-balloon-pos][data-balloon-pos="right"]:after, [aria-label][data-balloon-pos][data-balloon-pos="right"]:before {
    left: 100%;
    top: 50%;
    transform: translate(calc(var(--balloon-move) * -1), -50%); }
  [aria-label][data-balloon-pos][data-balloon-pos="right"]:after {
    margin-left: 10px; }
  [aria-label][data-balloon-pos][data-balloon-pos="right"]:before {
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-right-color: var(--balloon-color); }
  [aria-label][data-balloon-pos][data-balloon-length]:after {
    white-space: normal; }
  [aria-label][data-balloon-pos][data-balloon-length="small"]:after {
    width: 80px; }
  [aria-label][data-balloon-pos][data-balloon-length="medium"]:after {
    width: 150px; }
  [aria-label][data-balloon-pos][data-balloon-length="large"]:after {
    width: 260px; }
  [aria-label][data-balloon-pos][data-balloon-length="xlarge"]:after {
    width: 380px; }
    @media screen and (max-width: 768px) {
      [aria-label][data-balloon-pos][data-balloon-length="xlarge"]:after {
        width: 90vw; } }
  [aria-label][data-balloon-pos][data-balloon-length="fit"]:after {
    width: 100%; }
`], sourceRoot: "" }]);
      const m = c;
    }, 685: (s, a, l) => {
      l.d(a, { Z: () => _ });
      var d = l(415), h = l.n(d), u = l(352), c = l.n(u), m = l(49), f = l(80), p = l.n(f), A = new URL(l(831), l.b), v = c()(h());
      v.i(m.Z);
      var b = p()(A);
      v.push([s.id, `@keyframes my-face {
  2% {
    transform: translate(0, 1.5px) rotate(1.5deg);
  }
  4% {
    transform: translate(0, -1.5px) rotate(-0.5deg);
  }
  6% {
    transform: translate(0, 1.5px) rotate(-1.5deg);
  }
  8% {
    transform: translate(0, -1.5px) rotate(-1.5deg);
  }
  10% {
    transform: translate(0, 2.5px) rotate(1.5deg);
  }
  12% {
    transform: translate(0, -0.5px) rotate(1.5deg);
  }
  14% {
    transform: translate(0, -1.5px) rotate(1.5deg);
  }
  16% {
    transform: translate(0, -0.5px) rotate(-1.5deg);
  }
  18% {
    transform: translate(0, 0.5px) rotate(-1.5deg);
  }
  20% {
    transform: translate(0, -1.5px) rotate(2.5deg);
  }
  22% {
    transform: translate(0, 0.5px) rotate(-1.5deg);
  }
  24% {
    transform: translate(0, 1.5px) rotate(1.5deg);
  }
  26% {
    transform: translate(0, 0.5px) rotate(0.5deg);
  }
  28% {
    transform: translate(0, 0.5px) rotate(1.5deg);
  }
  30% {
    transform: translate(0, -0.5px) rotate(2.5deg);
  }
  32% {
    transform: translate(0, 1.5px) rotate(-0.5deg);
  }
  34% {
    transform: translate(0, 1.5px) rotate(-0.5deg);
  }
  36% {
    transform: translate(0, -1.5px) rotate(2.5deg);
  }
  38% {
    transform: translate(0, 1.5px) rotate(-1.5deg);
  }
  40% {
    transform: translate(0, -0.5px) rotate(2.5deg);
  }
  42% {
    transform: translate(0, 2.5px) rotate(-1.5deg);
  }
  44% {
    transform: translate(0, 1.5px) rotate(0.5deg);
  }
  46% {
    transform: translate(0, -1.5px) rotate(2.5deg);
  }
  48% {
    transform: translate(0, -0.5px) rotate(0.5deg);
  }
  50% {
    transform: translate(0, 0.5px) rotate(0.5deg);
  }
  52% {
    transform: translate(0, 2.5px) rotate(2.5deg);
  }
  54% {
    transform: translate(0, -1.5px) rotate(1.5deg);
  }
  56% {
    transform: translate(0, 2.5px) rotate(2.5deg);
  }
  58% {
    transform: translate(0, 0.5px) rotate(2.5deg);
  }
  60% {
    transform: translate(0, 2.5px) rotate(2.5deg);
  }
  62% {
    transform: translate(0, -0.5px) rotate(2.5deg);
  }
  64% {
    transform: translate(0, -0.5px) rotate(1.5deg);
  }
  66% {
    transform: translate(0, 1.5px) rotate(-0.5deg);
  }
  68% {
    transform: translate(0, -1.5px) rotate(-0.5deg);
  }
  70% {
    transform: translate(0, 1.5px) rotate(0.5deg);
  }
  72% {
    transform: translate(0, 2.5px) rotate(1.5deg);
  }
  74% {
    transform: translate(0, -0.5px) rotate(0.5deg);
  }
  76% {
    transform: translate(0, -0.5px) rotate(2.5deg);
  }
  78% {
    transform: translate(0, -0.5px) rotate(1.5deg);
  }
  80% {
    transform: translate(0, 1.5px) rotate(1.5deg);
  }
  82% {
    transform: translate(0, -0.5px) rotate(0.5deg);
  }
  84% {
    transform: translate(0, 1.5px) rotate(2.5deg);
  }
  86% {
    transform: translate(0, -1.5px) rotate(-1.5deg);
  }
  88% {
    transform: translate(0, -0.5px) rotate(2.5deg);
  }
  90% {
    transform: translate(0, 2.5px) rotate(-0.5deg);
  }
  92% {
    transform: translate(0, 0.5px) rotate(-0.5deg);
  }
  94% {
    transform: translate(0, 2.5px) rotate(0.5deg);
  }
  96% {
    transform: translate(0, -0.5px) rotate(1.5deg);
  }
  98% {
    transform: translate(0, -1.5px) rotate(-0.5deg);
  }
  0%,
  100% {
    transform: translate(0, 0) rotate(0deg);
  }
}
.dplayer {
  position: relative;
  overflow: hidden;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  line-height: 1;
}
.dplayer * {
  box-sizing: content-box;
}
.dplayer svg {
  width: 100%;
  height: 100%;
}
.dplayer svg path,
.dplayer svg circle {
  fill: #fff;
}
.dplayer:-webkit-full-screen {
  width: 100%;
  height: 100%;
  background: #000;
  position: fixed;
  z-index: 100000;
  left: 0;
  top: 0;
  margin: 0;
  padding: 0;
  transform: translate(0, 0);
}
.dplayer.dplayer-no-danmaku .dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-box .dplayer-setting-showdan,
.dplayer.dplayer-no-danmaku .dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-box .dplayer-setting-danmaku,
.dplayer.dplayer-no-danmaku .dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-box .dplayer-setting-danunlimit {
  display: none;
}
.dplayer.dplayer-no-danmaku .dplayer-controller .dplayer-icons .dplayer-comment {
  display: none;
}
.dplayer.dplayer-no-danmaku .dplayer-danmaku {
  display: none;
}
.dplayer.dplayer-live .dplayer-time {
  display: none;
}
.dplayer.dplayer-live .dplayer-bar-wrap {
  display: none;
}
.dplayer.dplayer-live .dplayer-setting-speed {
  display: none;
}
.dplayer.dplayer-live .dplayer-setting-loop {
  display: none;
}
.dplayer.dplayer-live.dplayer-no-danmaku .dplayer-setting {
  display: none;
}
.dplayer.dplayer-arrow .dplayer-danmaku {
  font-size: 18px;
}
.dplayer.dplayer-arrow .dplayer-icon {
  margin: 0 -3px;
}
.dplayer.dplayer-playing .dplayer-danmaku .dplayer-danmaku-move {
  animation-play-state: running;
}
@media (min-width: 900px) {
  .dplayer.dplayer-playing .dplayer-controller-mask {
    opacity: 0;
  }
  .dplayer.dplayer-playing .dplayer-controller {
    opacity: 0;
  }
  .dplayer.dplayer-playing:hover .dplayer-controller-mask {
    opacity: 1;
  }
  .dplayer.dplayer-playing:hover .dplayer-controller {
    opacity: 1;
  }
}
.dplayer.dplayer-loading .dplayer-bezel .diplayer-loading-icon {
  display: block;
}
.dplayer.dplayer-loading .dplayer-danmaku,
.dplayer.dplayer-paused .dplayer-danmaku,
.dplayer.dplayer-loading .dplayer-danmaku-move,
.dplayer.dplayer-paused .dplayer-danmaku-move {
  animation-play-state: paused;
}
.dplayer.dplayer-hide-controller {
  cursor: none;
}
.dplayer.dplayer-hide-controller .dplayer-controller-mask {
  opacity: 0;
  transform: translateY(100%);
}
.dplayer.dplayer-hide-controller .dplayer-controller {
  opacity: 0;
  transform: translateY(100%);
}
.dplayer.dplayer-show-controller .dplayer-controller-mask {
  opacity: 1;
}
.dplayer.dplayer-show-controller .dplayer-controller {
  opacity: 1;
}
.dplayer.dplayer-fulled {
  width: 100% !important;
  height: 100% !important;
}
.dplayer.dplayer-fulled {
  position: fixed;
  z-index: 100000;
  left: 0;
  top: 0;
}
.dplayer.dplayer-mobile .dplayer-controller .dplayer-icons .dplayer-volume,
.dplayer.dplayer-mobile .dplayer-controller .dplayer-icons .dplayer-camera-icon,
.dplayer.dplayer-mobile .dplayer-controller .dplayer-icons .dplayer-airplay-icon,
.dplayer.dplayer-mobile .dplayer-controller .dplayer-icons .dplayer-chromecast-icon,
.dplayer.dplayer-mobile .dplayer-controller .dplayer-icons .dplayer-play-icon {
  display: none;
}
.dplayer.dplayer-mobile .dplayer-controller .dplayer-icons .dplayer-full .dplayer-full-in-icon {
  position: static;
  display: inline-block;
}
.dplayer.dplayer-mobile .dplayer-bar-time {
  display: none;
}
.dplayer.dplayer-mobile.dplayer-hide-controller .dplayer-mobile-play {
  display: none;
}
.dplayer.dplayer-mobile .dplayer-mobile-play {
  display: block;
}
.dplayer-web-fullscreen-fix {
  position: fixed;
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
}
[data-balloon]:before {
  display: none;
}
[data-balloon]:after {
  padding: 0.3em 0.7em;
  background: rgba(17, 17, 17, 0.7);
}
[data-balloon][data-balloon-pos="up"]:after {
  margin-bottom: 0;
}
.dplayer-bezel {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  font-size: 22px;
  color: #fff;
  pointer-events: none;
}
.dplayer-bezel .dplayer-bezel-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -26px 0 0 -26px;
  height: 52px;
  width: 52px;
  padding: 12px;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  opacity: 0;
  pointer-events: none;
}
.dplayer-bezel .dplayer-bezel-icon.dplayer-bezel-transition {
  animation: bezel-hide 0.5s linear;
}
@keyframes bezel-hide {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(2);
  }
}
.dplayer-bezel .dplayer-danloading {
  position: absolute;
  top: 50%;
  margin-top: -7px;
  width: 100%;
  text-align: center;
  font-size: 14px;
  line-height: 14px;
  animation: my-face 5s infinite ease-in-out;
}
.dplayer-bezel .diplayer-loading-icon {
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -18px 0 0 -18px;
  height: 36px;
  width: 36px;
  pointer-events: none;
}
.dplayer-bezel .diplayer-loading-icon .diplayer-loading-hide {
  display: none;
}
.dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot {
  animation: diplayer-loading-dot-fade 0.8s ease infinite;
  opacity: 0;
  transform-origin: 4px 4px;
}
.dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot.diplayer-loading-dot-1 {
  animation-delay: 0.1s;
}
.dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot.diplayer-loading-dot-2 {
  animation-delay: 0.2s;
}
.dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot.diplayer-loading-dot-3 {
  animation-delay: 0.3s;
}
.dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot.diplayer-loading-dot-4 {
  animation-delay: 0.4s;
}
.dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot.diplayer-loading-dot-5 {
  animation-delay: 0.5s;
}
.dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot.diplayer-loading-dot-6 {
  animation-delay: 0.6s;
}
.dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot.diplayer-loading-dot-7 {
  animation-delay: 0.7s;
}
@keyframes diplayer-loading-dot-fade {
  0% {
    opacity: 0.7;
    transform: scale(1.2, 1.2);
  }
  50% {
    opacity: 0.25;
    transform: scale(0.9, 0.9);
  }
  to {
    opacity: 0.25;
    transform: scale(0.85, 0.85);
  }
}
.dplayer-controller-mask {
  background: url(` + b + `) repeat-x bottom;
  height: 98px;
  width: 100%;
  position: absolute;
  bottom: 0;
  transition: all 0.3s ease;
}
.dplayer-controller {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 41px;
  padding: 0 20px;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  transition: all 0.3s ease;
}
.dplayer-controller.dplayer-controller-comment .dplayer-icons {
  display: none;
}
.dplayer-controller.dplayer-controller-comment .dplayer-icons.dplayer-comment-box {
  display: block;
}
.dplayer-controller .dplayer-bar-wrap {
  padding: 5px 0;
  cursor: pointer;
  position: absolute;
  bottom: 33px;
  width: calc(100% - 40px);
  height: 3px;
}
.dplayer-controller .dplayer-bar-wrap:hover .dplayer-bar .dplayer-played .dplayer-thumb {
  transform: scale(1);
}
.dplayer-controller .dplayer-bar-wrap:hover .dplayer-highlight {
  display: block;
  width: 8px;
  transform: translateX(-4px);
  top: 4px;
  height: 40%;
}
.dplayer-controller .dplayer-bar-wrap .dplayer-highlight {
  z-index: 12;
  position: absolute;
  top: 5px;
  width: 6px;
  height: 20%;
  border-radius: 6px;
  background-color: #fff;
  text-align: center;
  transform: translateX(-3px);
  transition: all 0.2s ease-in-out;
}
.dplayer-controller .dplayer-bar-wrap .dplayer-highlight:hover .dplayer-highlight-text {
  display: block;
}
.dplayer-controller .dplayer-bar-wrap .dplayer-highlight:hover ~ .dplayer-bar-preview {
  opacity: 0;
}
.dplayer-controller .dplayer-bar-wrap .dplayer-highlight:hover ~ .dplayer-bar-time {
  opacity: 0;
}
.dplayer-controller .dplayer-bar-wrap .dplayer-highlight .dplayer-highlight-text {
  display: none;
  position: absolute;
  left: 50%;
  top: -24px;
  padding: 5px 8px;
  background-color: rgba(0, 0, 0, 0.62);
  color: #fff;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  transform: translateX(-50%);
}
.dplayer-controller .dplayer-bar-wrap .dplayer-bar-preview {
  position: absolute;
  background: #fff;
  pointer-events: none;
  display: none;
  background-size: 16000px 100%;
}
.dplayer-controller .dplayer-bar-wrap .dplayer-bar-preview-canvas {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
}
.dplayer-controller .dplayer-bar-wrap .dplayer-bar-time {
  position: absolute;
  left: 0px;
  top: -20px;
  border-radius: 4px;
  padding: 5px 7px;
  background-color: rgba(0, 0, 0, 0.62);
  color: #fff;
  font-size: 12px;
  text-align: center;
  opacity: 1;
  transition: opacity 0.1s ease-in-out;
  word-wrap: normal;
  word-break: normal;
  z-index: 2;
  pointer-events: none;
}
.dplayer-controller .dplayer-bar-wrap .dplayer-bar-time.hidden {
  opacity: 0;
}
.dplayer-controller .dplayer-bar-wrap .dplayer-bar {
  position: relative;
  height: 3px;
  width: 100%;
  background: rgba(255, 255, 255, 0.2);
  cursor: pointer;
}
.dplayer-controller .dplayer-bar-wrap .dplayer-bar .dplayer-loaded {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.4);
  height: 3px;
  transition: all 0.5s ease;
  will-change: width;
}
.dplayer-controller .dplayer-bar-wrap .dplayer-bar .dplayer-played {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  height: 3px;
  will-change: width;
}
.dplayer-controller .dplayer-bar-wrap .dplayer-bar .dplayer-played .dplayer-thumb {
  position: absolute;
  top: 0;
  right: 5px;
  margin-top: -4px;
  margin-right: -10px;
  height: 11px;
  width: 11px;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  transform: scale(0);
}
.dplayer-controller .dplayer-icons {
  height: 38px;
  position: absolute;
  bottom: 0;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box {
  display: none;
  position: absolute;
  transition: all 0.3s ease-in-out;
  z-index: 2;
  height: 38px;
  bottom: 0;
  left: 20px;
  right: 20px;
  color: #fff;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-icon {
  padding: 7px;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-icon {
  position: absolute;
  left: 0;
  top: 0;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-send-icon {
  position: absolute;
  right: 0;
  top: 0;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-box {
  position: absolute;
  background: rgba(28, 28, 28, 0.9);
  bottom: 41px;
  left: 0;
  box-shadow: 0 0 25px rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  padding: 10px 10px 16px;
  font-size: 14px;
  width: 204px;
  transition: all 0.3s ease-in-out;
  transform: scale(0);
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-box.dplayer-comment-setting-open {
  transform: scale(1);
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-box input[type=radio] {
  display: none;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-box label {
  cursor: pointer;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-title {
  font-size: 13px;
  color: #fff;
  line-height: 30px;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-type {
  font-size: 0;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-type .dplayer-comment-setting-title {
  margin-bottom: 6px;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-type label:nth-child(2) span {
  border-radius: 4px 0 0 4px;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-type label:nth-child(4) span {
  border-radius: 0 4px 4px 0;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-type span {
  width: 33%;
  padding: 4px 6px;
  line-height: 16px;
  display: inline-block;
  font-size: 12px;
  color: #fff;
  border: 1px solid #fff;
  margin-right: -1px;
  box-sizing: border-box;
  text-align: center;
  cursor: pointer;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-type input:checked + span {
  background: #E4E4E6;
  color: #1c1c1c;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-color {
  font-size: 0;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-color label {
  font-size: 0;
  padding: 6px;
  display: inline-block;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-color span {
  width: 22px;
  height: 22px;
  display: inline-block;
  border-radius: 50%;
  box-sizing: border-box;
  cursor: pointer;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-color span:hover {
  animation: my-face 5s infinite ease-in-out;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-input {
  outline: none;
  border: none;
  padding: 8px 31px;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  border-radius: 4px;
  background: none;
  margin: 0;
  height: 100%;
  box-sizing: border-box;
  width: 100%;
  color: #fff;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-input::-moz-placeholder {
  color: #fff;
  opacity: 0.8;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-input::placeholder {
  color: #fff;
  opacity: 0.8;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-input::-ms-clear {
  display: none;
}
.dplayer-controller .dplayer-icons.dplayer-icons-left .dplayer-icon {
  padding: 7px;
}
.dplayer-controller .dplayer-icons.dplayer-icons-right {
  right: 20px;
}
.dplayer-controller .dplayer-icons.dplayer-icons-right .dplayer-icon {
  padding: 8px;
}
.dplayer-controller .dplayer-icons .dplayer-time,
.dplayer-controller .dplayer-icons .dplayer-live-badge {
  line-height: 38px;
  color: #eee;
  text-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
  vertical-align: middle;
  font-size: 13px;
  cursor: default;
}
.dplayer-controller .dplayer-icons .dplayer-live-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  vertical-align: 4%;
  margin-right: 5px;
  content: '';
  border-radius: 6px;
}
.dplayer-controller .dplayer-icons .dplayer-icon {
  width: 40px;
  height: 100%;
  border: none;
  background-color: transparent;
  outline: none;
  cursor: pointer;
  vertical-align: middle;
  box-sizing: border-box;
  display: inline-block;
}
.dplayer-controller .dplayer-icons .dplayer-icon .dplayer-icon-content {
  transition: all 0.2s ease-in-out;
  opacity: 0.8;
}
.dplayer-controller .dplayer-icons .dplayer-icon:hover .dplayer-icon-content {
  opacity: 1;
}
.dplayer-controller .dplayer-icons .dplayer-icon.dplayer-quality-icon {
  color: #fff;
  width: auto;
  line-height: 22px;
  font-size: 14px;
}
.dplayer-controller .dplayer-icons .dplayer-icon.dplayer-comment-icon {
  padding: 10px 9px 9px;
}
.dplayer-controller .dplayer-icons .dplayer-icon.dplayer-setting-icon {
  padding-top: 8.5px;
}
.dplayer-controller .dplayer-icons .dplayer-icon.dplayer-volume-icon {
  width: 43px;
}
.dplayer-controller .dplayer-icons .dplayer-volume {
  position: relative;
  display: inline-block;
  cursor: pointer;
  height: 100%;
}
.dplayer-controller .dplayer-icons .dplayer-volume:hover .dplayer-volume-bar-wrap .dplayer-volume-bar {
  width: 45px;
}
.dplayer-controller .dplayer-icons .dplayer-volume:hover .dplayer-volume-bar-wrap .dplayer-volume-bar .dplayer-volume-bar-inner .dplayer-thumb {
  transform: scale(1);
}
.dplayer-controller .dplayer-icons .dplayer-volume.dplayer-volume-active .dplayer-volume-bar-wrap .dplayer-volume-bar {
  width: 45px;
}
.dplayer-controller .dplayer-icons .dplayer-volume.dplayer-volume-active .dplayer-volume-bar-wrap .dplayer-volume-bar .dplayer-volume-bar-inner .dplayer-thumb {
  transform: scale(1);
}
.dplayer-controller .dplayer-icons .dplayer-volume .dplayer-volume-bar-wrap {
  display: inline-block;
  margin: 0 10px 0 -5px;
  vertical-align: middle;
  height: 100%;
}
.dplayer-controller .dplayer-icons .dplayer-volume .dplayer-volume-bar-wrap .dplayer-volume-bar {
  position: relative;
  top: 17px;
  width: 0;
  height: 3px;
  background: #aaa;
  transition: all 0.3s ease-in-out;
}
.dplayer-controller .dplayer-icons .dplayer-volume .dplayer-volume-bar-wrap .dplayer-volume-bar .dplayer-volume-bar-inner {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 100%;
  transition: all 0.1s ease;
  will-change: width;
}
.dplayer-controller .dplayer-icons .dplayer-volume .dplayer-volume-bar-wrap .dplayer-volume-bar .dplayer-volume-bar-inner .dplayer-thumb {
  position: absolute;
  top: 0;
  right: 5px;
  margin-top: -4px;
  margin-right: -10px;
  height: 11px;
  width: 11px;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  transform: scale(0);
}
.dplayer-controller .dplayer-icons .dplayer-subtitle-btn {
  display: inline-block;
  height: 100%;
}
.dplayer-controller .dplayer-icons .dplayer-subtitles {
  display: inline-block;
  height: 100%;
}
.dplayer-controller .dplayer-icons .dplayer-subtitles .dplayer-subtitles-box {
  position: absolute;
  right: 0;
  bottom: 50px;
  transform: scale(0);
  width: -moz-fit-content;
  width: fit-content;
  max-width: 240px;
  min-width: 120px;
  border-radius: 2px;
  background: rgba(28, 28, 28, 0.9);
  padding: 7px 0;
  transition: all 0.3s ease-in-out;
  overflow: auto;
  z-index: 2;
}
.dplayer-controller .dplayer-icons .dplayer-subtitles .dplayer-subtitles-box.dplayer-subtitles-panel {
  display: block;
}
.dplayer-controller .dplayer-icons .dplayer-subtitles .dplayer-subtitles-box.dplayer-subtitles-box-open {
  transform: scale(1);
}
.dplayer-controller .dplayer-icons .dplayer-subtitles .dplayer-subtitles-item {
  height: 30px;
  padding: 5px 10px;
  box-sizing: border-box;
  cursor: pointer;
  position: relative;
}
.dplayer-controller .dplayer-icons .dplayer-subtitles .dplayer-subtitles-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.dplayer-controller .dplayer-icons .dplayer-setting {
  display: inline-block;
  height: 100%;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-box {
  position: absolute;
  right: 0;
  bottom: 50px;
  transform: scale(0);
  width: 150px;
  border-radius: 2px;
  background: rgba(28, 28, 28, 0.9);
  padding: 7px 0;
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  z-index: 2;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-box > div {
  display: none;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-box > div.dplayer-setting-origin-panel {
  display: block;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-box.dplayer-setting-box-open {
  transform: scale(1);
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-box.dplayer-setting-box-narrow {
  width: 70px;
  text-align: center;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-box.dplayer-setting-box-speed .dplayer-setting-origin-panel {
  display: none;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-box.dplayer-setting-box-speed .dplayer-setting-speed-panel {
  display: block;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-item,
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-speed-item {
  height: 30px;
  padding: 5px 10px;
  box-sizing: border-box;
  cursor: pointer;
  position: relative;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-item:hover,
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-speed-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-danmaku {
  padding: 5px 0;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-danmaku .dplayer-label {
  padding: 0 10px;
  display: inline;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-danmaku:hover .dplayer-label {
  display: none;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-danmaku:hover .dplayer-danmaku-bar-wrap {
  display: inline-block;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-danmaku.dplayer-setting-danmaku-active .dplayer-label {
  display: none;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-danmaku.dplayer-setting-danmaku-active .dplayer-danmaku-bar-wrap {
  display: inline-block;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-danmaku .dplayer-danmaku-bar-wrap {
  padding: 0 10px;
  box-sizing: border-box;
  display: none;
  vertical-align: middle;
  height: 100%;
  width: 100%;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-danmaku .dplayer-danmaku-bar-wrap .dplayer-danmaku-bar {
  position: relative;
  top: 8.5px;
  width: 100%;
  height: 3px;
  background: #fff;
  transition: all 0.3s ease-in-out;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-danmaku .dplayer-danmaku-bar-wrap .dplayer-danmaku-bar .dplayer-danmaku-bar-inner {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 100%;
  transition: all 0.1s ease;
  background: #aaa;
  will-change: width;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-danmaku .dplayer-danmaku-bar-wrap .dplayer-danmaku-bar .dplayer-danmaku-bar-inner .dplayer-thumb {
  position: absolute;
  top: 0;
  right: 5px;
  margin-top: -4px;
  margin-right: -10px;
  height: 11px;
  width: 11px;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  background: #aaa;
}
.dplayer-controller .dplayer-icons .dplayer-full {
  display: inline-block;
  height: 100%;
  position: relative;
}
.dplayer-controller .dplayer-icons .dplayer-full:hover .dplayer-full-in-icon {
  display: block;
}
.dplayer-controller .dplayer-icons .dplayer-full .dplayer-full-in-icon {
  position: absolute;
  top: -30px;
  z-index: 1;
  display: none;
}
.dplayer-controller .dplayer-icons .dplayer-quality {
  position: relative;
  display: inline-block;
  height: 100%;
  z-index: 2;
}
.dplayer-controller .dplayer-icons .dplayer-quality:hover .dplayer-quality-list {
  display: block;
}
.dplayer-controller .dplayer-icons .dplayer-quality:hover .dplayer-quality-mask {
  display: block;
}
.dplayer-controller .dplayer-icons .dplayer-quality .dplayer-quality-mask {
  display: none;
  position: absolute;
  bottom: 38px;
  left: -18px;
  width: 80px;
  padding-bottom: 12px;
}
.dplayer-controller .dplayer-icons .dplayer-quality .dplayer-quality-list {
  display: none;
  font-size: 12px;
  width: 80px;
  border-radius: 2px;
  background: rgba(28, 28, 28, 0.9);
  padding: 5px 0;
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  color: #fff;
  text-align: center;
}
.dplayer-controller .dplayer-icons .dplayer-quality .dplayer-quality-item {
  height: 25px;
  box-sizing: border-box;
  cursor: pointer;
  line-height: 25px;
}
.dplayer-controller .dplayer-icons .dplayer-quality .dplayer-quality-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.dplayer-controller .dplayer-icons .dplayer-comment {
  display: inline-block;
  height: 100%;
}
.dplayer-controller .dplayer-icons .dplayer-label {
  color: #eee;
  font-size: 13px;
  display: inline-block;
  vertical-align: middle;
  white-space: nowrap;
}
.dplayer-controller .dplayer-icons .dplayer-toggle {
  width: 32px;
  height: 20px;
  text-align: center;
  font-size: 0;
  vertical-align: middle;
  position: absolute;
  top: 5px;
  right: 10px;
}
.dplayer-controller .dplayer-icons .dplayer-toggle input {
  max-height: 0;
  max-width: 0;
  display: none;
}
.dplayer-controller .dplayer-icons .dplayer-toggle input + label {
  display: inline-block;
  position: relative;
  box-shadow: #dfdfdf 0 0 0 0 inset;
  border: 1px solid #dfdfdf;
  height: 20px;
  width: 32px;
  border-radius: 10px;
  box-sizing: border-box;
  cursor: pointer;
  transition: 0.2s ease-in-out;
}
.dplayer-controller .dplayer-icons .dplayer-toggle input + label:before {
  content: "";
  position: absolute;
  display: block;
  height: 18px;
  width: 18px;
  top: 0;
  left: 0;
  border-radius: 15px;
  transition: 0.2s ease-in-out;
}
.dplayer-controller .dplayer-icons .dplayer-toggle input + label:after {
  content: "";
  position: absolute;
  display: block;
  left: 0;
  top: 0;
  border-radius: 15px;
  background: #fff;
  transition: 0.2s ease-in-out;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
  height: 18px;
  width: 18px;
}
.dplayer-controller .dplayer-icons .dplayer-toggle input:checked + label {
  border-color: rgba(255, 255, 255, 0.5);
}
.dplayer-controller .dplayer-icons .dplayer-toggle input:checked + label:before {
  width: 30px;
  background: rgba(255, 255, 255, 0.5);
}
.dplayer-controller .dplayer-icons .dplayer-toggle input:checked + label:after {
  left: 12px;
}
.dplayer-mobile-play {
  display: none;
  width: 50px;
  height: 50px;
  border: none;
  background-color: transparent;
  outline: none;
  cursor: pointer;
  box-sizing: border-box;
  bottom: 0;
  opacity: 0.8;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.dplayer-danmaku {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  font-size: 22px;
  color: #fff;
}
.dplayer-danmaku .dplayer-danmaku-item {
  display: inline-block;
  pointer-events: none;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  cursor: default;
  white-space: nowrap;
  text-shadow: 0.5px 0.5px 0.5px rgba(0, 0, 0, 0.5);
}
.dplayer-danmaku .dplayer-danmaku-item--demo {
  position: absolute;
  visibility: hidden;
}
.dplayer-danmaku .dplayer-danmaku-right {
  position: absolute;
  right: 0;
  transform: translateX(100%);
}
.dplayer-danmaku .dplayer-danmaku-right.dplayer-danmaku-move {
  will-change: transform;
  animation-name: 'danmaku';
  animation-timing-function: linear;
  animation-play-state: paused;
}
@keyframes danmaku {
  from {
    transform: translateX(100%);
  }
}
.dplayer-danmaku .dplayer-danmaku-top,
.dplayer-danmaku .dplayer-danmaku-bottom {
  position: absolute;
  width: 100%;
  text-align: center;
  visibility: hidden;
}
.dplayer-danmaku .dplayer-danmaku-top.dplayer-danmaku-move,
.dplayer-danmaku .dplayer-danmaku-bottom.dplayer-danmaku-move {
  will-change: visibility;
  animation-name: 'danmaku-center';
  animation-timing-function: linear;
  animation-play-state: paused;
}
@keyframes danmaku-center {
  from {
    visibility: visible;
  }
  to {
    visibility: visible;
  }
}
.dplayer-logo {
  pointer-events: none;
  position: absolute;
  left: 20px;
  top: 20px;
  max-width: 50px;
  max-height: 50px;
}
.dplayer-logo img {
  max-width: 100%;
  max-height: 100%;
  background: none;
}
.dplayer-menu {
  position: absolute;
  width: 170px;
  border-radius: 2px;
  background: rgba(28, 28, 28, 0.85);
  padding: 5px 0;
  overflow: hidden;
  z-index: 3;
  display: none;
}
.dplayer-menu.dplayer-menu-show {
  display: block;
}
.dplayer-menu .dplayer-menu-item {
  height: 30px;
  box-sizing: border-box;
  cursor: pointer;
}
.dplayer-menu .dplayer-menu-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.dplayer-menu .dplayer-menu-item a {
  padding: 0 10px;
  line-height: 30px;
  color: #eee;
  font-size: 13px;
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  box-sizing: border-box;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.dplayer-menu .dplayer-menu-item a:hover {
  text-decoration: none;
}
.dplayer-notice-list {
  position: absolute;
  bottom: 60px;
  left: 20px;
}
.dplayer-notice-list .dplayer-notice {
  border-radius: 2px;
  background: rgba(28, 28, 28, 0.9);
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  color: #fff;
  display: table;
  pointer-events: none;
  animation: showNotice 0.3s ease 1 forwards;
}
.dplayer-notice-list .remove-notice {
  animation: removeNotice 0.3s ease 1 forwards;
}
@keyframes showNotice {
  from {
    padding: 0;
    font-size: 0;
    margin-top: 0;
  }
  to {
    padding: 7px 20px;
    font-size: 14px;
    margin-top: 5px;
  }
}
@keyframes removeNotice {
  0% {
    padding: 7px 20px;
    font-size: 14px;
    margin-top: 5px;
  }
  20% {
    font-size: 12px;
  }
  21% {
    font-size: 0;
    padding: 7px 10px;
  }
  100% {
    padding: 0;
    margin-top: 0;
    font-size: 0;
  }
}
.dplayer-subtitle {
  position: absolute;
  bottom: 40px;
  width: 90%;
  left: 5%;
  text-align: center;
  color: #fff;
  text-shadow: 0.5px 0.5px 0.5px rgba(0, 0, 0, 0.5);
  font-size: 20px;
}
.dplayer-subtitle.dplayer-subtitle-hide {
  display: none;
}
.dplayer-mask {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  display: none;
}
.dplayer-mask.dplayer-mask-show {
  display: block;
}
.dplayer-video-wrap {
  position: relative;
  background: #000;
  font-size: 0;
  width: 100%;
  height: 100%;
}
.dplayer-video-wrap .dplayer-video {
  width: 100%;
  height: 100%;
  display: none;
}
.dplayer-video-wrap .dplayer-video-current {
  display: block;
}
.dplayer-video-wrap .dplayer-video-prepare {
  display: none;
}
.dplayer-info-panel {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 400px;
  background: rgba(28, 28, 28, 0.8);
  padding: 10px;
  color: #fff;
  font-size: 12px;
  border-radius: 2px;
}
.dplayer-info-panel-hide {
  display: none;
}
.dplayer-info-panel .dplayer-info-panel-close {
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 10px;
}
.dplayer-info-panel .dplayer-info-panel-item > span {
  display: inline-block;
  vertical-align: middle;
  line-height: 15px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.dplayer-info-panel .dplayer-info-panel-item-title {
  width: 100px;
  text-align: right;
  margin-right: 10px;
}
.dplayer-info-panel .dplayer-info-panel-item-data {
  width: 260px;
}
`, "", { version: 3, sources: ["webpack://./src/css/global.less", "webpack://./src/css/index.less", "webpack://./src/css/player.less", "webpack://./src/css/balloon.less", "webpack://./src/css/bezel.less", "webpack://./src/css/notice.less", "webpack://./src/css/controller.less", "webpack://./src/css/danmaku.less", "webpack://./src/css/logo.less", "webpack://./src/css/menu.less", "webpack://./src/css/subtitle.less", "webpack://./src/css/video.less", "webpack://./src/css/info-panel.less"], names: [], mappings: "AAAA;EACI;IACI,6CAAA;ECEN;EDAE;IACI,+CAAA;ECEN;EDAE;IACI,8CAAA;ECEN;EDAE;IACI,+CAAA;ECEN;EDAE;IACI,6CAAA;ECEN;EDAE;IACI,8CAAA;ECEN;EDAE;IACI,8CAAA;ECEN;EDAE;IACI,+CAAA;ECEN;EDAE;IACI,8CAAA;ECEN;EDAE;IACI,8CAAA;ECEN;EDAE;IACI,8CAAA;ECEN;EDAE;IACI,6CAAA;ECEN;EDAE;IACI,6CAAA;ECEN;EDAE;IACI,6CAAA;ECEN;EDAE;IACI,8CAAA;ECEN;EDAE;IACI,8CAAA;ECEN;EDAE;IACI,8CAAA;ECEN;EDAE;IACI,8CAAA;ECEN;EDAE;IACI,8CAAA;ECEN;EDAE;IACI,8CAAA;ECEN;EDAE;IACI,8CAAA;ECEN;EDAE;IACI,6CAAA;ECEN;EDAE;IACI,8CAAA;ECEN;EDAE;IACI,8CAAA;ECEN;EDAE;IACI,6CAAA;ECEN;EDAE;IACI,6CAAA;ECEN;EDAE;IACI,8CAAA;ECEN;EDAE;IACI,6CAAA;ECEN;EDAE;IACI,6CAAA;ECEN;EDAE;IACI,6CAAA;ECEN;EDAE;IACI,8CAAA;ECEN;EDAE;IACI,8CAAA;ECEN;EDAE;IACI,8CAAA;ECEN;EDAE;IACI,+CAAA;ECEN;EDAE;IACI,6CAAA;ECEN;EDAE;IACI,6CAAA;ECEN;EDAE;IACI,8CAAA;ECEN;EDAE;IACI,8CAAA;ECEN;EDAE;IACI,8CAAA;ECEN;EDAE;IACI,6CAAA;ECEN;EDAE;IACI,8CAAA;ECEN;EDAE;IACI,6CAAA;ECEN;EDAE;IACI,+CAAA;ECEN;EDAE;IACI,8CAAA;ECEN;EDAE;IACI,8CAAA;ECEN;EDAE;IACI,8CAAA;ECEN;EDAE;IACI,6CAAA;ECEN;EDAE;IACI,8CAAA;ECEN;EDAE;IACI,+CAAA;ECEN;EDAE;;IAEI,uCAAA;ECEN;AACF;ACzJA;EACI,kBAAA;EACA,gBAAA;EACA,yBAAA;KAAA,sBAAA;UAAA,iBAAA;EACA,cAAA;AD2JJ;AC/JA;EAOQ,uBAAA;AD2JR;AClKA;EAWQ,WAAA;EACA,YAAA;AD0JR;ACtKA;;EAgBY,UAAA;AD0JZ;ACtJI;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,0BAAA;ADwJR;ACpJI;;;EAKY,aAAA;ADoJhB;ACzJI;EAUQ,aAAA;ADkJZ;AC5JI;EAcQ,aAAA;ADiJZ;AC7II;EAEQ,aAAA;AD8IZ;AChJI;EAKQ,aAAA;AD8IZ;ACnJI;EAQQ,aAAA;AD8IZ;ACtJI;EAWQ,aAAA;AD8IZ;AC3IQ;EAEQ,aAAA;AD4IhB;ACvII;EAEQ,eAAA;ADwIZ;AC1II;EAKQ,cAAA;ADwIZ;ACpII;EAEQ,6BAAA;ADqIZ;AClIQ;EAAA;IAEQ,UAAA;EDoId;ECtIM;IAKQ,UAAA;EDoId;ECjIU;IAEQ,UAAA;EDkIlB;ECpIU;IAKQ,UAAA;EDkIlB;AACF;AC7HI;EAEQ,cAAA;AD8HZ;AC1HI;;;;EAIQ,4BAAA;AD4HZ;ACxHI;EACI,YAAA;AD0HR;AC3HI;EAIQ,UAAA;EACA,2BAAA;AD0HZ;AC/HI;EAQQ,UAAA;EACA,2BAAA;AD0HZ;ACvHI;EAEQ,UAAA;ADwHZ;AC1HI;EAKQ,UAAA;ADwHZ;ACrHI;EAKI,sBAAA;EACA,uBAAA;ADuHR;AC7HI;EACI,eAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;ADyHR;ACrHI;;;;;EAOY,aAAA;ADqHhB;AC5HI;EAUY,gBAAA;EACA,qBAAA;ADqHhB;AChII;EAgBQ,aAAA;ADmHZ;AChHQ;EAEQ,aAAA;ADiHhB;ACtII;EA0BQ,cAAA;AD+GZ;ACzGA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,UAAA;AD2GJ;AElSA;EACI,aAAA;AFoSJ;AEjSA;EACI,oBAAA;EACA,iCAAA;AFmSJ;AEhSA;EACI,gBAAA;AFkSJ;AG9SA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;EACA,oBAAA;AHgTJ;AGxTA;EAUQ,kBAAA;EACA,QAAA;EACA,SAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;AHiTR;AGhTQ;EACI,iCAAA;AHkTZ;AGhTQ;EACI;IACI,UAAA;IACA,mBAAA;EHkTd;EGhTU;IACI,UAAA;IACA,mBAAA;EHkTd;AACF;AGnVA;EAqCQ,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,0CAAA;AHiTR;AG7VA;EA+CQ,aAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;AHiTR;AGvWA;EAwDY,aAAA;AHkTZ;AG1WA;EA2DY,uDAAA;EACA,UAAA;EACA,yBAAA;AHkTZ;AI/WC;EDgEmB,qBAAA;AHkTpB;AIlXC;EDgEmB,qBAAA;AHqTpB;AIrXC;EDgEmB,qBAAA;AHwTpB;AIxXC;EDgEmB,qBAAA;AH2TpB;AI3XC;EDgEmB,qBAAA;AH8TpB;AI9XC;EDgEmB,qBAAA;AHiUpB;AIjYC;EDgEmB,qBAAA;AHoUpB;AGhUQ;EACI;IACI,YAAA;IACA,0BAAA;EHkUd;EGhUU;IACI,aAAA;IACA,0BAAA;EHkUd;EGhUU;IACI,aAAA;IACA,4BAAA;EHkUd;AACF;AKlZA;EACI,mEAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,yBAAA;ALoZJ;AKjZA;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;KAAA,sBAAA;UAAA,iBAAA;EACA,yBAAA;ALmZJ;AKlZI;EAEQ,aAAA;ALmZZ;AKrZI;EAKQ,cAAA;ALmZZ;AKjaA;EAkBQ,cAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,wBAAA;EACA,WAAA;ALkZR;AKjZQ;EAEQ,mBAAA;ALkZhB;AKpZQ;EAKQ,cAAA;EACA,UAAA;EACA,2BAAA;EACA,QAAA;EACA,WAAA;ALkZhB;AKnbA;EAqCY,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,2BAAA;EACA,gCAAA;ALiZZ;AKhZY;EAEQ,cAAA;ALiZpB;AK/YgB;EACI,UAAA;ALiZpB;AK/YgB;EACI,UAAA;ALiZpB;AKxcA;EA2DgB,aAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,qCAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,2BAAA;ALgZhB;AKrdA;EAyEY,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,6BAAA;AL+YZ;AK5dA;EAgFY,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;AL+YZ;AKneA;EA0FY,kBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,qCAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,oCAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;AL4YZ;AK7ZY;EACI,UAAA;AL+ZhB;AKvfA;EA2GY,kBAAA;EACA,WAAA;EACA,WAAA;EACA,oCAAA;EACA,eAAA;AL+YZ;AK9fA;EAiHgB,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;ALgZhB;AKxgBA;EA2HgB,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;ALgZhB;AKhhBA;EAkIoB,kBAAA;EACA,MAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;EACA,mBAAA;ALiZpB;AK7hBA;EAkJQ,YAAA;EACA,kBAAA;EACA,SAAA;AL8YR;AK7YQ;EACI,aAAA;EACA,kBAAA;EACA,gCAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;AL+YZ;AKxZQ;EAWQ,YAAA;ALgZhB;AK3ZQ;EAcQ,kBAAA;EACA,OAAA;EACA,MAAA;ALgZhB;AKhaQ;EAmBQ,kBAAA;EACA,QAAA;EACA,MAAA;ALgZhB;AKraQ;EAwBQ,kBAAA;EACA,iCAAA;EACA,YAAA;EACA,OAAA;EACA,uCAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,gCAAA;EACA,mBAAA;ALgZhB;AK/YgB;EACI,mBAAA;ALiZpB;AKrbQ;EAuCY,aAAA;ALiZpB;AKxbQ;EA0CY,eAAA;ALiZpB;AK3bQ;EA6CY,eAAA;EACA,WAAA;EACA,iBAAA;ALiZpB;AKhcQ;EAkDY,YAAA;ALiZpB;AKncQ;EAoDgB,kBAAA;ALkZxB;AK/YwB;EAEQ,0BAAA;ALgZhC;AK7YwB;EAEQ,0BAAA;AL8YhC;AK5cQ;EAmEgB,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AL4YxB;AKzdQ;EAgFgB,mBAAA;EACA,cAAA;AL4YxB;AK7dQ;EAqFY,YAAA;AL2YpB;AKheQ;EAuFgB,YAAA;EACA,YAAA;EACA,qBAAA;AL4YxB;AKreQ;EA4FgB,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AL4YxB;AK3YwB;EACI,0CAAA;AL6Y5B;AKhfQ;EAyGQ,aAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;AL0YhB;AKzYgB;EACI,WAAA;EACA,YAAA;AL2YpB;AK7YgB;EACI,WAAA;EACA,YAAA;AL2YpB;AKzYgB;EACI,aAAA;AL2YpB;AKvYQ;EAEQ,YAAA;ALwYhB;AKrYQ;EACI,WAAA;ALuYZ;AKxYQ;EAGQ,YAAA;ALwYhB;AKpqBA;;EAiSY,iBAAA;EACA,WAAA;EACA,uCAAA;EACA,sBAAA;EACA,eAAA;EACA,eAAA;ALuYZ;AK7qBA;EAySY,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;ALuYZ;AKtrBA;EAkTY,WAAA;EACA,YAAA;EACA,YAAA;EACA,6BAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,sBAAA;EACA,qBAAA;ALuYZ;AKjsBA;EA4TgB,gCAAA;EACA,YAAA;ALwYhB;AKtYY;EAEQ,UAAA;ALuYpB;AKpYY;EACI,WAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;ALsYhB;AKpYY;EACI,qBAAA;ALsYhB;AKpYY;EACI,kBAAA;ALsYhB;AKpYY;EACI,WAAA;ALsYhB;AKvtBA;EAqVY,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;ALqYZ;AKpYY;EAEQ,WAAA;ALqYpB;AKvYY;EAKQ,mBAAA;ALqYpB;AKlYY;EAEQ,WAAA;ALmYpB;AKrYY;EAKQ,mBAAA;ALmYpB;AKzuBA;EA0WgB,qBAAA;EACA,qBAAA;EACA,sBAAA;EACA,YAAA;ALkYhB;AK/uBA;EA+WoB,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,gCAAA;ALmYpB;AKvvBA;EAsXwB,kBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;ALoYxB;AK/vBA;EA6X4B,kBAAA;EACA,MAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;EACA,mBAAA;ALqY5B;AK5wBA;EA8YY,qBAAA;EACA,YAAA;ALiYZ;AKhxBA;EAkZY,qBAAA;EACA,YAAA;ALiYZ;AKpxBA;EAqZgB,kBAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,cAAA;EACA,gCAAA;EACA,cAAA;EACA,UAAA;ALkYhB;AKjYgB;EACI,cAAA;ALmYpB;AKjYgB;EACI,mBAAA;ALmYpB;AKzyBA;EA0agB,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;ALkYhB;AKjYgB;EACI,0CAAA;ALmYpB;AKnzBA;EAqbY,qBAAA;EACA,YAAA;ALiYZ;AKvzBA;EAwbgB,kBAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,iCAAA;EACA,cAAA;EACA,gCAAA;EACA,gBAAA;EACA,UAAA;ALkYhB;AKjYgB;EACI,aAAA;ALmYpB;AKlYoB;EACI,cAAA;ALoYxB;AKjYgB;EACI,mBAAA;ALmYpB;AKjYgB;EACI,WAAA;EACA,kBAAA;ALmYpB;AKjYgB;EAEQ,aAAA;ALkYxB;AKpYgB;EAKQ,cAAA;ALkYxB;AKv1BA;;EA2dgB,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;ALgYhB;AK/XgB;;EACI,0CAAA;ALkYpB;AKn2BA;EAqegB,cAAA;ALiYhB;AKt2BA;EAueoB,eAAA;EACA,eAAA;ALkYpB;AKhYgB;EAEQ,aAAA;ALiYxB;AKnYgB;EAKQ,qBAAA;ALiYxB;AK9XgB;EAEQ,aAAA;AL+XxB;AKjYgB;EAKQ,qBAAA;AL+XxB;AKt3BA;EA2foB,eAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;AL8XpB;AK93BA;EAkgBwB,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,gCAAA;AL+XxB;AKt4BA;EAygB4B,kBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ALgY5B;AK/4BA;EAihBgC,kBAAA;EACA,MAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;EACA,gBAAA;ALiYhC;AK55BA;EAmiBY,qBAAA;EACA,YAAA;EACA,kBAAA;AL4XZ;AK3XY;EAEQ,cAAA;AL4XpB;AKp6BA;EA4iBgB,kBAAA;EACA,UAAA;EACA,UAAA;EACA,aAAA;AL2XhB;AK16BA;EAmjBY,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,UAAA;AL0XZ;AKzXY;EAEQ,cAAA;AL0XpB;AK5XY;EAKQ,cAAA;AL0XpB;AKt7BA;EAgkBgB,aAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,oBAAA;ALyXhB;AK97BA;EAwkBgB,aAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,iCAAA;EACA,cAAA;EACA,gCAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;ALyXhB;AK18BA;EAolBgB,YAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;ALyXhB;AKxXgB;EACI,0CAAA;AL0XpB;AKn9BA;EA8lBY,qBAAA;EACA,YAAA;ALwXZ;AKv9BA;EAkmBY,WAAA;EACA,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;ALwXZ;AK99BA;EAymBY,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;ALwXZ;AKx+BA;EAknBgB,aAAA;EACA,YAAA;EACA,aAAA;ALyXhB;AK7+BA;EAunBgB,qBAAA;EACA,kBAAA;EACA,iCAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,4BAAA;ALyXhB;AKz/BA;EAmoBgB,WAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,mBAAA;EACA,4BAAA;ALyXhB;AKpgCA;EA8oBgB,WAAA;EACA,kBAAA;EACA,cAAA;EACA,OAAA;EACA,MAAA;EACA,mBAAA;EACA,gBAAA;EACA,4BAAA;EACA,wCAAA;EACA,YAAA;EACA,WAAA;ALyXhB;AKjhCA;EA2pBgB,sCAAA;ALyXhB;AKphCA;EA8pBgB,WAAA;EACA,oCAAA;ALyXhB;AKxhCA;EAkqBgB,UAAA;ALyXhB;AKnXA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,6BAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EAEA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;ALoXJ;AMpjCA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;ANsjCJ;AM7jCA;EASQ,qBAAA;EACA,oBAAA;EACA,yBAAA;KAAA,sBAAA;UAAA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,iDAAA;ANujCR;AMtjCQ;EACI,kBAAA;EACA,kBAAA;ANwjCZ;AMzkCA;EAqBQ,kBAAA;EACA,QAAA;EACA,2BAAA;ANujCR;AMtjCQ;EACI,sBAAA;EACA,yBAAA;EACA,iCAAA;EACA,4BAAA;ANwjCZ;AMrjCI;EACI;IACI,2BAAA;ENujCV;AACF;AMzlCA;;EAsCQ,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;ANujCR;AMtjCQ;;EACI,uBAAA;EACA,gCAAA;EACA,iCAAA;EACA,4BAAA;ANyjCZ;AMtjCI;EACI;IACI,mBAAA;ENwjCV;EMtjCM;IACI,mBAAA;ENwjCV;AACF;AO/mCA;EACI,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;APinCJ;AOvnCA;EAQQ,eAAA;EACA,gBAAA;EACA,gBAAA;APknCR;AQ5nCA;EACI,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,kCAAA;EACA,cAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;AR8nCJ;AQ7nCI;EACI,cAAA;AR+nCR;AQzoCA;EAaQ,YAAA;EACA,sBAAA;EACA,eAAA;AR+nCR;AQ9nCQ;EACI,0CAAA;ARgoCZ;AQjpCA;EAqBY,eAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AR+nCZ;AQ9nCY;EACI,qBAAA;ARgoChB;AIjqCA;EACI,kBAAA;EACA,YAAA;EACA,UAAA;AJmqCJ;AItqCA;EAMQ,kBAAA;EACA,iCAAA;EACA,gCAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;EACA,oBAAA;EACA,0CAAA;AJmqCR;AIhrCA;EAiBQ,4CAAA;AJkqCR;AI9pCA;EACI;IACI,UAAA;IACA,YAAA;IACA,aAAA;EJgqCN;EI9pCE;IACI,iBAAA;IACA,eAAA;IACA,eAAA;EJgqCN;AACF;AI7pCA;EACI;IACI,iBAAA;IACA,eAAA;IACA,eAAA;EJ+pCN;EI7pCE;IACI,eAAA;EJ+pCN;EI7pCE;IACI,YAAA;IACA,iBAAA;EJ+pCN;EI7pCE;IACI,UAAA;IACA,aAAA;IACA,YAAA;EJ+pCN;AACF;ASltCA;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;EACA,iDAAA;EACA,eAAA;ATotCJ;ASntCI;EACI,aAAA;ATqtCR;AU/tCA;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;AViuCJ;AUhuCI;EACI,cAAA;AVkuCR;AU9tCA;EACI,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AVguCJ;AUruCA;EAOQ,WAAA;EACA,YAAA;EACA,aAAA;AViuCR;AU1uCA;EAYQ,cAAA;AViuCR;AU7uCA;EAeQ,aAAA;AViuCR;AW7vCA;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,iCAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AX+vCJ;AW7vCI;EACI,aAAA;AX+vCR;AW3wCA;EAgBQ,eAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AX8vCR;AW1vCQ;EACI,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AX4vCZ;AWzxCA;EAkCQ,YAAA;EACA,iBAAA;EACA,kBAAA;AX0vCR;AW9xCA;EAwCQ,YAAA;AXyvCR", sourcesContent: [`@keyframes my-face {
    2% {
        transform: translate(0, 1.5px) rotate(1.5deg);
    }
    4% {
        transform: translate(0, -1.5px) rotate(-0.5deg);
    }
    6% {
        transform: translate(0, 1.5px) rotate(-1.5deg);
    }
    8% {
        transform: translate(0, -1.5px) rotate(-1.5deg);
    }
    10% {
        transform: translate(0, 2.5px) rotate(1.5deg);
    }
    12% {
        transform: translate(0, -0.5px) rotate(1.5deg);
    }
    14% {
        transform: translate(0, -1.5px) rotate(1.5deg);
    }
    16% {
        transform: translate(0, -0.5px) rotate(-1.5deg);
    }
    18% {
        transform: translate(0, 0.5px) rotate(-1.5deg);
    }
    20% {
        transform: translate(0, -1.5px) rotate(2.5deg);
    }
    22% {
        transform: translate(0, 0.5px) rotate(-1.5deg);
    }
    24% {
        transform: translate(0, 1.5px) rotate(1.5deg);
    }
    26% {
        transform: translate(0, 0.5px) rotate(0.5deg);
    }
    28% {
        transform: translate(0, 0.5px) rotate(1.5deg);
    }
    30% {
        transform: translate(0, -0.5px) rotate(2.5deg);
    }
    32% {
        transform: translate(0, 1.5px) rotate(-0.5deg);
    }
    34% {
        transform: translate(0, 1.5px) rotate(-0.5deg);
    }
    36% {
        transform: translate(0, -1.5px) rotate(2.5deg);
    }
    38% {
        transform: translate(0, 1.5px) rotate(-1.5deg);
    }
    40% {
        transform: translate(0, -0.5px) rotate(2.5deg);
    }
    42% {
        transform: translate(0, 2.5px) rotate(-1.5deg);
    }
    44% {
        transform: translate(0, 1.5px) rotate(0.5deg);
    }
    46% {
        transform: translate(0, -1.5px) rotate(2.5deg);
    }
    48% {
        transform: translate(0, -0.5px) rotate(0.5deg);
    }
    50% {
        transform: translate(0, 0.5px) rotate(0.5deg);
    }
    52% {
        transform: translate(0, 2.5px) rotate(2.5deg);
    }
    54% {
        transform: translate(0, -1.5px) rotate(1.5deg);
    }
    56% {
        transform: translate(0, 2.5px) rotate(2.5deg);
    }
    58% {
        transform: translate(0, 0.5px) rotate(2.5deg);
    }
    60% {
        transform: translate(0, 2.5px) rotate(2.5deg);
    }
    62% {
        transform: translate(0, -0.5px) rotate(2.5deg);
    }
    64% {
        transform: translate(0, -0.5px) rotate(1.5deg);
    }
    66% {
        transform: translate(0, 1.5px) rotate(-0.5deg);
    }
    68% {
        transform: translate(0, -1.5px) rotate(-0.5deg);
    }
    70% {
        transform: translate(0, 1.5px) rotate(0.5deg);
    }
    72% {
        transform: translate(0, 2.5px) rotate(1.5deg);
    }
    74% {
        transform: translate(0, -0.5px) rotate(0.5deg);
    }
    76% {
        transform: translate(0, -0.5px) rotate(2.5deg);
    }
    78% {
        transform: translate(0, -0.5px) rotate(1.5deg);
    }
    80% {
        transform: translate(0, 1.5px) rotate(1.5deg);
    }
    82% {
        transform: translate(0, -0.5px) rotate(0.5deg);
    }
    84% {
        transform: translate(0, 1.5px) rotate(2.5deg);
    }
    86% {
        transform: translate(0, -1.5px) rotate(-1.5deg);
    }
    88% {
        transform: translate(0, -0.5px) rotate(2.5deg);
    }
    90% {
        transform: translate(0, 2.5px) rotate(-0.5deg);
    }
    92% {
        transform: translate(0, 0.5px) rotate(-0.5deg);
    }
    94% {
        transform: translate(0, 2.5px) rotate(0.5deg);
    }
    96% {
        transform: translate(0, -0.5px) rotate(1.5deg);
    }
    98% {
        transform: translate(0, -1.5px) rotate(-0.5deg);
    }
    0%,
    100% {
        transform: translate(0, 0) rotate(0deg);
    }
}`, `@import '../../node_modules/balloon-css/balloon.css';
@keyframes my-face {
  2% {
    transform: translate(0, 1.5px) rotate(1.5deg);
  }
  4% {
    transform: translate(0, -1.5px) rotate(-0.5deg);
  }
  6% {
    transform: translate(0, 1.5px) rotate(-1.5deg);
  }
  8% {
    transform: translate(0, -1.5px) rotate(-1.5deg);
  }
  10% {
    transform: translate(0, 2.5px) rotate(1.5deg);
  }
  12% {
    transform: translate(0, -0.5px) rotate(1.5deg);
  }
  14% {
    transform: translate(0, -1.5px) rotate(1.5deg);
  }
  16% {
    transform: translate(0, -0.5px) rotate(-1.5deg);
  }
  18% {
    transform: translate(0, 0.5px) rotate(-1.5deg);
  }
  20% {
    transform: translate(0, -1.5px) rotate(2.5deg);
  }
  22% {
    transform: translate(0, 0.5px) rotate(-1.5deg);
  }
  24% {
    transform: translate(0, 1.5px) rotate(1.5deg);
  }
  26% {
    transform: translate(0, 0.5px) rotate(0.5deg);
  }
  28% {
    transform: translate(0, 0.5px) rotate(1.5deg);
  }
  30% {
    transform: translate(0, -0.5px) rotate(2.5deg);
  }
  32% {
    transform: translate(0, 1.5px) rotate(-0.5deg);
  }
  34% {
    transform: translate(0, 1.5px) rotate(-0.5deg);
  }
  36% {
    transform: translate(0, -1.5px) rotate(2.5deg);
  }
  38% {
    transform: translate(0, 1.5px) rotate(-1.5deg);
  }
  40% {
    transform: translate(0, -0.5px) rotate(2.5deg);
  }
  42% {
    transform: translate(0, 2.5px) rotate(-1.5deg);
  }
  44% {
    transform: translate(0, 1.5px) rotate(0.5deg);
  }
  46% {
    transform: translate(0, -1.5px) rotate(2.5deg);
  }
  48% {
    transform: translate(0, -0.5px) rotate(0.5deg);
  }
  50% {
    transform: translate(0, 0.5px) rotate(0.5deg);
  }
  52% {
    transform: translate(0, 2.5px) rotate(2.5deg);
  }
  54% {
    transform: translate(0, -1.5px) rotate(1.5deg);
  }
  56% {
    transform: translate(0, 2.5px) rotate(2.5deg);
  }
  58% {
    transform: translate(0, 0.5px) rotate(2.5deg);
  }
  60% {
    transform: translate(0, 2.5px) rotate(2.5deg);
  }
  62% {
    transform: translate(0, -0.5px) rotate(2.5deg);
  }
  64% {
    transform: translate(0, -0.5px) rotate(1.5deg);
  }
  66% {
    transform: translate(0, 1.5px) rotate(-0.5deg);
  }
  68% {
    transform: translate(0, -1.5px) rotate(-0.5deg);
  }
  70% {
    transform: translate(0, 1.5px) rotate(0.5deg);
  }
  72% {
    transform: translate(0, 2.5px) rotate(1.5deg);
  }
  74% {
    transform: translate(0, -0.5px) rotate(0.5deg);
  }
  76% {
    transform: translate(0, -0.5px) rotate(2.5deg);
  }
  78% {
    transform: translate(0, -0.5px) rotate(1.5deg);
  }
  80% {
    transform: translate(0, 1.5px) rotate(1.5deg);
  }
  82% {
    transform: translate(0, -0.5px) rotate(0.5deg);
  }
  84% {
    transform: translate(0, 1.5px) rotate(2.5deg);
  }
  86% {
    transform: translate(0, -1.5px) rotate(-1.5deg);
  }
  88% {
    transform: translate(0, -0.5px) rotate(2.5deg);
  }
  90% {
    transform: translate(0, 2.5px) rotate(-0.5deg);
  }
  92% {
    transform: translate(0, 0.5px) rotate(-0.5deg);
  }
  94% {
    transform: translate(0, 2.5px) rotate(0.5deg);
  }
  96% {
    transform: translate(0, -0.5px) rotate(1.5deg);
  }
  98% {
    transform: translate(0, -1.5px) rotate(-0.5deg);
  }
  0%,
  100% {
    transform: translate(0, 0) rotate(0deg);
  }
}
.dplayer {
  position: relative;
  overflow: hidden;
  user-select: none;
  line-height: 1;
}
.dplayer * {
  box-sizing: content-box;
}
.dplayer svg {
  width: 100%;
  height: 100%;
}
.dplayer svg path,
.dplayer svg circle {
  fill: #fff;
}
.dplayer:-webkit-full-screen {
  width: 100%;
  height: 100%;
  background: #000;
  position: fixed;
  z-index: 100000;
  left: 0;
  top: 0;
  margin: 0;
  padding: 0;
  transform: translate(0, 0);
}
.dplayer.dplayer-no-danmaku .dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-box .dplayer-setting-showdan,
.dplayer.dplayer-no-danmaku .dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-box .dplayer-setting-danmaku,
.dplayer.dplayer-no-danmaku .dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-box .dplayer-setting-danunlimit {
  display: none;
}
.dplayer.dplayer-no-danmaku .dplayer-controller .dplayer-icons .dplayer-comment {
  display: none;
}
.dplayer.dplayer-no-danmaku .dplayer-danmaku {
  display: none;
}
.dplayer.dplayer-live .dplayer-time {
  display: none;
}
.dplayer.dplayer-live .dplayer-bar-wrap {
  display: none;
}
.dplayer.dplayer-live .dplayer-setting-speed {
  display: none;
}
.dplayer.dplayer-live .dplayer-setting-loop {
  display: none;
}
.dplayer.dplayer-live.dplayer-no-danmaku .dplayer-setting {
  display: none;
}
.dplayer.dplayer-arrow .dplayer-danmaku {
  font-size: 18px;
}
.dplayer.dplayer-arrow .dplayer-icon {
  margin: 0 -3px;
}
.dplayer.dplayer-playing .dplayer-danmaku .dplayer-danmaku-move {
  animation-play-state: running;
}
@media (min-width: 900px) {
  .dplayer.dplayer-playing .dplayer-controller-mask {
    opacity: 0;
  }
  .dplayer.dplayer-playing .dplayer-controller {
    opacity: 0;
  }
  .dplayer.dplayer-playing:hover .dplayer-controller-mask {
    opacity: 1;
  }
  .dplayer.dplayer-playing:hover .dplayer-controller {
    opacity: 1;
  }
}
.dplayer.dplayer-loading .dplayer-bezel .diplayer-loading-icon {
  display: block;
}
.dplayer.dplayer-loading .dplayer-danmaku,
.dplayer.dplayer-paused .dplayer-danmaku,
.dplayer.dplayer-loading .dplayer-danmaku-move,
.dplayer.dplayer-paused .dplayer-danmaku-move {
  animation-play-state: paused;
}
.dplayer.dplayer-hide-controller {
  cursor: none;
}
.dplayer.dplayer-hide-controller .dplayer-controller-mask {
  opacity: 0;
  transform: translateY(100%);
}
.dplayer.dplayer-hide-controller .dplayer-controller {
  opacity: 0;
  transform: translateY(100%);
}
.dplayer.dplayer-show-controller .dplayer-controller-mask {
  opacity: 1;
}
.dplayer.dplayer-show-controller .dplayer-controller {
  opacity: 1;
}
.dplayer.dplayer-fulled {
  position: fixed;
  z-index: 100000;
  left: 0;
  top: 0;
  width: 100% !important;
  height: 100% !important;
}
.dplayer.dplayer-mobile .dplayer-controller .dplayer-icons .dplayer-volume,
.dplayer.dplayer-mobile .dplayer-controller .dplayer-icons .dplayer-camera-icon,
.dplayer.dplayer-mobile .dplayer-controller .dplayer-icons .dplayer-airplay-icon,
.dplayer.dplayer-mobile .dplayer-controller .dplayer-icons .dplayer-chromecast-icon,
.dplayer.dplayer-mobile .dplayer-controller .dplayer-icons .dplayer-play-icon {
  display: none;
}
.dplayer.dplayer-mobile .dplayer-controller .dplayer-icons .dplayer-full .dplayer-full-in-icon {
  position: static;
  display: inline-block;
}
.dplayer.dplayer-mobile .dplayer-bar-time {
  display: none;
}
.dplayer.dplayer-mobile.dplayer-hide-controller .dplayer-mobile-play {
  display: none;
}
.dplayer.dplayer-mobile .dplayer-mobile-play {
  display: block;
}
.dplayer-web-fullscreen-fix {
  position: fixed;
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
}
[data-balloon]:before {
  display: none;
}
[data-balloon]:after {
  padding: 0.3em 0.7em;
  background: rgba(17, 17, 17, 0.7);
}
[data-balloon][data-balloon-pos="up"]:after {
  margin-bottom: 0;
}
.dplayer-bezel {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  font-size: 22px;
  color: #fff;
  pointer-events: none;
}
.dplayer-bezel .dplayer-bezel-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -26px 0 0 -26px;
  height: 52px;
  width: 52px;
  padding: 12px;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  opacity: 0;
  pointer-events: none;
}
.dplayer-bezel .dplayer-bezel-icon.dplayer-bezel-transition {
  animation: bezel-hide 0.5s linear;
}
@keyframes bezel-hide {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(2);
  }
}
.dplayer-bezel .dplayer-danloading {
  position: absolute;
  top: 50%;
  margin-top: -7px;
  width: 100%;
  text-align: center;
  font-size: 14px;
  line-height: 14px;
  animation: my-face 5s infinite ease-in-out;
}
.dplayer-bezel .diplayer-loading-icon {
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -18px 0 0 -18px;
  height: 36px;
  width: 36px;
  pointer-events: none;
}
.dplayer-bezel .diplayer-loading-icon .diplayer-loading-hide {
  display: none;
}
.dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot {
  animation: diplayer-loading-dot-fade 0.8s ease infinite;
  opacity: 0;
  transform-origin: 4px 4px;
}
.dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot.diplayer-loading-dot-1 {
  animation-delay: 0.1s;
}
.dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot.diplayer-loading-dot-2 {
  animation-delay: 0.2s;
}
.dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot.diplayer-loading-dot-3 {
  animation-delay: 0.3s;
}
.dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot.diplayer-loading-dot-4 {
  animation-delay: 0.4s;
}
.dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot.diplayer-loading-dot-5 {
  animation-delay: 0.5s;
}
.dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot.diplayer-loading-dot-6 {
  animation-delay: 0.6s;
}
.dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot.diplayer-loading-dot-7 {
  animation-delay: 0.7s;
}
@keyframes diplayer-loading-dot-fade {
  0% {
    opacity: 0.7;
    transform: scale(1.2, 1.2);
  }
  50% {
    opacity: 0.25;
    transform: scale(0.9, 0.9);
  }
  to {
    opacity: 0.25;
    transform: scale(0.85, 0.85);
  }
}
.dplayer-controller-mask {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAADGCAYAAAAT+OqFAAAAdklEQVQoz42QQQ7AIAgEF/T/D+kbq/RWAlnQyyazA4aoAB4FsBSA/bFjuF1EOL7VbrIrBuusmrt4ZZORfb6ehbWdnRHEIiITaEUKa5EJqUakRSaEYBJSCY2dEstQY7AuxahwXFrvZmWl2rh4JZ07z9dLtesfNj5q0FU3A5ObbwAAAABJRU5ErkJggg==) repeat-x bottom;
  height: 98px;
  width: 100%;
  position: absolute;
  bottom: 0;
  transition: all 0.3s ease;
}
.dplayer-controller {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 41px;
  padding: 0 20px;
  user-select: none;
  transition: all 0.3s ease;
}
.dplayer-controller.dplayer-controller-comment .dplayer-icons {
  display: none;
}
.dplayer-controller.dplayer-controller-comment .dplayer-icons.dplayer-comment-box {
  display: block;
}
.dplayer-controller .dplayer-bar-wrap {
  padding: 5px 0;
  cursor: pointer;
  position: absolute;
  bottom: 33px;
  width: calc(100% - 40px);
  height: 3px;
}
.dplayer-controller .dplayer-bar-wrap:hover .dplayer-bar .dplayer-played .dplayer-thumb {
  transform: scale(1);
}
.dplayer-controller .dplayer-bar-wrap:hover .dplayer-highlight {
  display: block;
  width: 8px;
  transform: translateX(-4px);
  top: 4px;
  height: 40%;
}
.dplayer-controller .dplayer-bar-wrap .dplayer-highlight {
  z-index: 12;
  position: absolute;
  top: 5px;
  width: 6px;
  height: 20%;
  border-radius: 6px;
  background-color: #fff;
  text-align: center;
  transform: translateX(-3px);
  transition: all 0.2s ease-in-out;
}
.dplayer-controller .dplayer-bar-wrap .dplayer-highlight:hover .dplayer-highlight-text {
  display: block;
}
.dplayer-controller .dplayer-bar-wrap .dplayer-highlight:hover ~ .dplayer-bar-preview {
  opacity: 0;
}
.dplayer-controller .dplayer-bar-wrap .dplayer-highlight:hover ~ .dplayer-bar-time {
  opacity: 0;
}
.dplayer-controller .dplayer-bar-wrap .dplayer-highlight .dplayer-highlight-text {
  display: none;
  position: absolute;
  left: 50%;
  top: -24px;
  padding: 5px 8px;
  background-color: rgba(0, 0, 0, 0.62);
  color: #fff;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  transform: translateX(-50%);
}
.dplayer-controller .dplayer-bar-wrap .dplayer-bar-preview {
  position: absolute;
  background: #fff;
  pointer-events: none;
  display: none;
  background-size: 16000px 100%;
}
.dplayer-controller .dplayer-bar-wrap .dplayer-bar-preview-canvas {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
}
.dplayer-controller .dplayer-bar-wrap .dplayer-bar-time {
  position: absolute;
  left: 0px;
  top: -20px;
  border-radius: 4px;
  padding: 5px 7px;
  background-color: rgba(0, 0, 0, 0.62);
  color: #fff;
  font-size: 12px;
  text-align: center;
  opacity: 1;
  transition: opacity 0.1s ease-in-out;
  word-wrap: normal;
  word-break: normal;
  z-index: 2;
  pointer-events: none;
}
.dplayer-controller .dplayer-bar-wrap .dplayer-bar-time.hidden {
  opacity: 0;
}
.dplayer-controller .dplayer-bar-wrap .dplayer-bar {
  position: relative;
  height: 3px;
  width: 100%;
  background: rgba(255, 255, 255, 0.2);
  cursor: pointer;
}
.dplayer-controller .dplayer-bar-wrap .dplayer-bar .dplayer-loaded {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.4);
  height: 3px;
  transition: all 0.5s ease;
  will-change: width;
}
.dplayer-controller .dplayer-bar-wrap .dplayer-bar .dplayer-played {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  height: 3px;
  will-change: width;
}
.dplayer-controller .dplayer-bar-wrap .dplayer-bar .dplayer-played .dplayer-thumb {
  position: absolute;
  top: 0;
  right: 5px;
  margin-top: -4px;
  margin-right: -10px;
  height: 11px;
  width: 11px;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  transform: scale(0);
}
.dplayer-controller .dplayer-icons {
  height: 38px;
  position: absolute;
  bottom: 0;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box {
  display: none;
  position: absolute;
  transition: all 0.3s ease-in-out;
  z-index: 2;
  height: 38px;
  bottom: 0;
  left: 20px;
  right: 20px;
  color: #fff;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-icon {
  padding: 7px;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-icon {
  position: absolute;
  left: 0;
  top: 0;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-send-icon {
  position: absolute;
  right: 0;
  top: 0;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-box {
  position: absolute;
  background: rgba(28, 28, 28, 0.9);
  bottom: 41px;
  left: 0;
  box-shadow: 0 0 25px rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  padding: 10px 10px 16px;
  font-size: 14px;
  width: 204px;
  transition: all 0.3s ease-in-out;
  transform: scale(0);
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-box.dplayer-comment-setting-open {
  transform: scale(1);
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-box input[type=radio] {
  display: none;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-box label {
  cursor: pointer;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-title {
  font-size: 13px;
  color: #fff;
  line-height: 30px;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-type {
  font-size: 0;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-type .dplayer-comment-setting-title {
  margin-bottom: 6px;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-type label:nth-child(2) span {
  border-radius: 4px 0 0 4px;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-type label:nth-child(4) span {
  border-radius: 0 4px 4px 0;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-type span {
  width: 33%;
  padding: 4px 6px;
  line-height: 16px;
  display: inline-block;
  font-size: 12px;
  color: #fff;
  border: 1px solid #fff;
  margin-right: -1px;
  box-sizing: border-box;
  text-align: center;
  cursor: pointer;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-type input:checked + span {
  background: #E4E4E6;
  color: #1c1c1c;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-color {
  font-size: 0;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-color label {
  font-size: 0;
  padding: 6px;
  display: inline-block;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-color span {
  width: 22px;
  height: 22px;
  display: inline-block;
  border-radius: 50%;
  box-sizing: border-box;
  cursor: pointer;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-color span:hover {
  animation: my-face 5s infinite ease-in-out;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-input {
  outline: none;
  border: none;
  padding: 8px 31px;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  border-radius: 4px;
  background: none;
  margin: 0;
  height: 100%;
  box-sizing: border-box;
  width: 100%;
  color: #fff;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-input::placeholder {
  color: #fff;
  opacity: 0.8;
}
.dplayer-controller .dplayer-icons.dplayer-comment-box .dplayer-comment-input::-ms-clear {
  display: none;
}
.dplayer-controller .dplayer-icons.dplayer-icons-left .dplayer-icon {
  padding: 7px;
}
.dplayer-controller .dplayer-icons.dplayer-icons-right {
  right: 20px;
}
.dplayer-controller .dplayer-icons.dplayer-icons-right .dplayer-icon {
  padding: 8px;
}
.dplayer-controller .dplayer-icons .dplayer-time,
.dplayer-controller .dplayer-icons .dplayer-live-badge {
  line-height: 38px;
  color: #eee;
  text-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
  vertical-align: middle;
  font-size: 13px;
  cursor: default;
}
.dplayer-controller .dplayer-icons .dplayer-live-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  vertical-align: 4%;
  margin-right: 5px;
  content: '';
  border-radius: 6px;
}
.dplayer-controller .dplayer-icons .dplayer-icon {
  width: 40px;
  height: 100%;
  border: none;
  background-color: transparent;
  outline: none;
  cursor: pointer;
  vertical-align: middle;
  box-sizing: border-box;
  display: inline-block;
}
.dplayer-controller .dplayer-icons .dplayer-icon .dplayer-icon-content {
  transition: all 0.2s ease-in-out;
  opacity: 0.8;
}
.dplayer-controller .dplayer-icons .dplayer-icon:hover .dplayer-icon-content {
  opacity: 1;
}
.dplayer-controller .dplayer-icons .dplayer-icon.dplayer-quality-icon {
  color: #fff;
  width: auto;
  line-height: 22px;
  font-size: 14px;
}
.dplayer-controller .dplayer-icons .dplayer-icon.dplayer-comment-icon {
  padding: 10px 9px 9px;
}
.dplayer-controller .dplayer-icons .dplayer-icon.dplayer-setting-icon {
  padding-top: 8.5px;
}
.dplayer-controller .dplayer-icons .dplayer-icon.dplayer-volume-icon {
  width: 43px;
}
.dplayer-controller .dplayer-icons .dplayer-volume {
  position: relative;
  display: inline-block;
  cursor: pointer;
  height: 100%;
}
.dplayer-controller .dplayer-icons .dplayer-volume:hover .dplayer-volume-bar-wrap .dplayer-volume-bar {
  width: 45px;
}
.dplayer-controller .dplayer-icons .dplayer-volume:hover .dplayer-volume-bar-wrap .dplayer-volume-bar .dplayer-volume-bar-inner .dplayer-thumb {
  transform: scale(1);
}
.dplayer-controller .dplayer-icons .dplayer-volume.dplayer-volume-active .dplayer-volume-bar-wrap .dplayer-volume-bar {
  width: 45px;
}
.dplayer-controller .dplayer-icons .dplayer-volume.dplayer-volume-active .dplayer-volume-bar-wrap .dplayer-volume-bar .dplayer-volume-bar-inner .dplayer-thumb {
  transform: scale(1);
}
.dplayer-controller .dplayer-icons .dplayer-volume .dplayer-volume-bar-wrap {
  display: inline-block;
  margin: 0 10px 0 -5px;
  vertical-align: middle;
  height: 100%;
}
.dplayer-controller .dplayer-icons .dplayer-volume .dplayer-volume-bar-wrap .dplayer-volume-bar {
  position: relative;
  top: 17px;
  width: 0;
  height: 3px;
  background: #aaa;
  transition: all 0.3s ease-in-out;
}
.dplayer-controller .dplayer-icons .dplayer-volume .dplayer-volume-bar-wrap .dplayer-volume-bar .dplayer-volume-bar-inner {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 100%;
  transition: all 0.1s ease;
  will-change: width;
}
.dplayer-controller .dplayer-icons .dplayer-volume .dplayer-volume-bar-wrap .dplayer-volume-bar .dplayer-volume-bar-inner .dplayer-thumb {
  position: absolute;
  top: 0;
  right: 5px;
  margin-top: -4px;
  margin-right: -10px;
  height: 11px;
  width: 11px;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  transform: scale(0);
}
.dplayer-controller .dplayer-icons .dplayer-subtitle-btn {
  display: inline-block;
  height: 100%;
}
.dplayer-controller .dplayer-icons .dplayer-subtitles {
  display: inline-block;
  height: 100%;
}
.dplayer-controller .dplayer-icons .dplayer-subtitles .dplayer-subtitles-box {
  position: absolute;
  right: 0;
  bottom: 50px;
  transform: scale(0);
  width: fit-content;
  max-width: 240px;
  min-width: 120px;
  border-radius: 2px;
  background: rgba(28, 28, 28, 0.9);
  padding: 7px 0;
  transition: all 0.3s ease-in-out;
  overflow: auto;
  z-index: 2;
}
.dplayer-controller .dplayer-icons .dplayer-subtitles .dplayer-subtitles-box.dplayer-subtitles-panel {
  display: block;
}
.dplayer-controller .dplayer-icons .dplayer-subtitles .dplayer-subtitles-box.dplayer-subtitles-box-open {
  transform: scale(1);
}
.dplayer-controller .dplayer-icons .dplayer-subtitles .dplayer-subtitles-item {
  height: 30px;
  padding: 5px 10px;
  box-sizing: border-box;
  cursor: pointer;
  position: relative;
}
.dplayer-controller .dplayer-icons .dplayer-subtitles .dplayer-subtitles-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.dplayer-controller .dplayer-icons .dplayer-setting {
  display: inline-block;
  height: 100%;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-box {
  position: absolute;
  right: 0;
  bottom: 50px;
  transform: scale(0);
  width: 150px;
  border-radius: 2px;
  background: rgba(28, 28, 28, 0.9);
  padding: 7px 0;
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  z-index: 2;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-box > div {
  display: none;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-box > div.dplayer-setting-origin-panel {
  display: block;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-box.dplayer-setting-box-open {
  transform: scale(1);
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-box.dplayer-setting-box-narrow {
  width: 70px;
  text-align: center;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-box.dplayer-setting-box-speed .dplayer-setting-origin-panel {
  display: none;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-box.dplayer-setting-box-speed .dplayer-setting-speed-panel {
  display: block;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-item,
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-speed-item {
  height: 30px;
  padding: 5px 10px;
  box-sizing: border-box;
  cursor: pointer;
  position: relative;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-item:hover,
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-speed-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-danmaku {
  padding: 5px 0;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-danmaku .dplayer-label {
  padding: 0 10px;
  display: inline;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-danmaku:hover .dplayer-label {
  display: none;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-danmaku:hover .dplayer-danmaku-bar-wrap {
  display: inline-block;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-danmaku.dplayer-setting-danmaku-active .dplayer-label {
  display: none;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-danmaku.dplayer-setting-danmaku-active .dplayer-danmaku-bar-wrap {
  display: inline-block;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-danmaku .dplayer-danmaku-bar-wrap {
  padding: 0 10px;
  box-sizing: border-box;
  display: none;
  vertical-align: middle;
  height: 100%;
  width: 100%;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-danmaku .dplayer-danmaku-bar-wrap .dplayer-danmaku-bar {
  position: relative;
  top: 8.5px;
  width: 100%;
  height: 3px;
  background: #fff;
  transition: all 0.3s ease-in-out;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-danmaku .dplayer-danmaku-bar-wrap .dplayer-danmaku-bar .dplayer-danmaku-bar-inner {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 100%;
  transition: all 0.1s ease;
  background: #aaa;
  will-change: width;
}
.dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-danmaku .dplayer-danmaku-bar-wrap .dplayer-danmaku-bar .dplayer-danmaku-bar-inner .dplayer-thumb {
  position: absolute;
  top: 0;
  right: 5px;
  margin-top: -4px;
  margin-right: -10px;
  height: 11px;
  width: 11px;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  background: #aaa;
}
.dplayer-controller .dplayer-icons .dplayer-full {
  display: inline-block;
  height: 100%;
  position: relative;
}
.dplayer-controller .dplayer-icons .dplayer-full:hover .dplayer-full-in-icon {
  display: block;
}
.dplayer-controller .dplayer-icons .dplayer-full .dplayer-full-in-icon {
  position: absolute;
  top: -30px;
  z-index: 1;
  display: none;
}
.dplayer-controller .dplayer-icons .dplayer-quality {
  position: relative;
  display: inline-block;
  height: 100%;
  z-index: 2;
}
.dplayer-controller .dplayer-icons .dplayer-quality:hover .dplayer-quality-list {
  display: block;
}
.dplayer-controller .dplayer-icons .dplayer-quality:hover .dplayer-quality-mask {
  display: block;
}
.dplayer-controller .dplayer-icons .dplayer-quality .dplayer-quality-mask {
  display: none;
  position: absolute;
  bottom: 38px;
  left: -18px;
  width: 80px;
  padding-bottom: 12px;
}
.dplayer-controller .dplayer-icons .dplayer-quality .dplayer-quality-list {
  display: none;
  font-size: 12px;
  width: 80px;
  border-radius: 2px;
  background: rgba(28, 28, 28, 0.9);
  padding: 5px 0;
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  color: #fff;
  text-align: center;
}
.dplayer-controller .dplayer-icons .dplayer-quality .dplayer-quality-item {
  height: 25px;
  box-sizing: border-box;
  cursor: pointer;
  line-height: 25px;
}
.dplayer-controller .dplayer-icons .dplayer-quality .dplayer-quality-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.dplayer-controller .dplayer-icons .dplayer-comment {
  display: inline-block;
  height: 100%;
}
.dplayer-controller .dplayer-icons .dplayer-label {
  color: #eee;
  font-size: 13px;
  display: inline-block;
  vertical-align: middle;
  white-space: nowrap;
}
.dplayer-controller .dplayer-icons .dplayer-toggle {
  width: 32px;
  height: 20px;
  text-align: center;
  font-size: 0;
  vertical-align: middle;
  position: absolute;
  top: 5px;
  right: 10px;
}
.dplayer-controller .dplayer-icons .dplayer-toggle input {
  max-height: 0;
  max-width: 0;
  display: none;
}
.dplayer-controller .dplayer-icons .dplayer-toggle input + label {
  display: inline-block;
  position: relative;
  box-shadow: #dfdfdf 0 0 0 0 inset;
  border: 1px solid #dfdfdf;
  height: 20px;
  width: 32px;
  border-radius: 10px;
  box-sizing: border-box;
  cursor: pointer;
  transition: 0.2s ease-in-out;
}
.dplayer-controller .dplayer-icons .dplayer-toggle input + label:before {
  content: "";
  position: absolute;
  display: block;
  height: 18px;
  width: 18px;
  top: 0;
  left: 0;
  border-radius: 15px;
  transition: 0.2s ease-in-out;
}
.dplayer-controller .dplayer-icons .dplayer-toggle input + label:after {
  content: "";
  position: absolute;
  display: block;
  left: 0;
  top: 0;
  border-radius: 15px;
  background: #fff;
  transition: 0.2s ease-in-out;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
  height: 18px;
  width: 18px;
}
.dplayer-controller .dplayer-icons .dplayer-toggle input:checked + label {
  border-color: rgba(255, 255, 255, 0.5);
}
.dplayer-controller .dplayer-icons .dplayer-toggle input:checked + label:before {
  width: 30px;
  background: rgba(255, 255, 255, 0.5);
}
.dplayer-controller .dplayer-icons .dplayer-toggle input:checked + label:after {
  left: 12px;
}
.dplayer-mobile-play {
  display: none;
  width: 50px;
  height: 50px;
  border: none;
  background-color: transparent;
  outline: none;
  cursor: pointer;
  box-sizing: border-box;
  bottom: 0;
  opacity: 0.8;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.dplayer-danmaku {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  font-size: 22px;
  color: #fff;
}
.dplayer-danmaku .dplayer-danmaku-item {
  display: inline-block;
  pointer-events: none;
  user-select: none;
  cursor: default;
  white-space: nowrap;
  text-shadow: 0.5px 0.5px 0.5px rgba(0, 0, 0, 0.5);
}
.dplayer-danmaku .dplayer-danmaku-item--demo {
  position: absolute;
  visibility: hidden;
}
.dplayer-danmaku .dplayer-danmaku-right {
  position: absolute;
  right: 0;
  transform: translateX(100%);
}
.dplayer-danmaku .dplayer-danmaku-right.dplayer-danmaku-move {
  will-change: transform;
  animation-name: 'danmaku';
  animation-timing-function: linear;
  animation-play-state: paused;
}
@keyframes danmaku {
  from {
    transform: translateX(100%);
  }
}
.dplayer-danmaku .dplayer-danmaku-top,
.dplayer-danmaku .dplayer-danmaku-bottom {
  position: absolute;
  width: 100%;
  text-align: center;
  visibility: hidden;
}
.dplayer-danmaku .dplayer-danmaku-top.dplayer-danmaku-move,
.dplayer-danmaku .dplayer-danmaku-bottom.dplayer-danmaku-move {
  will-change: visibility;
  animation-name: 'danmaku-center';
  animation-timing-function: linear;
  animation-play-state: paused;
}
@keyframes danmaku-center {
  from {
    visibility: visible;
  }
  to {
    visibility: visible;
  }
}
.dplayer-logo {
  pointer-events: none;
  position: absolute;
  left: 20px;
  top: 20px;
  max-width: 50px;
  max-height: 50px;
}
.dplayer-logo img {
  max-width: 100%;
  max-height: 100%;
  background: none;
}
.dplayer-menu {
  position: absolute;
  width: 170px;
  border-radius: 2px;
  background: rgba(28, 28, 28, 0.85);
  padding: 5px 0;
  overflow: hidden;
  z-index: 3;
  display: none;
}
.dplayer-menu.dplayer-menu-show {
  display: block;
}
.dplayer-menu .dplayer-menu-item {
  height: 30px;
  box-sizing: border-box;
  cursor: pointer;
}
.dplayer-menu .dplayer-menu-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.dplayer-menu .dplayer-menu-item a {
  padding: 0 10px;
  line-height: 30px;
  color: #eee;
  font-size: 13px;
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  box-sizing: border-box;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.dplayer-menu .dplayer-menu-item a:hover {
  text-decoration: none;
}
.dplayer-notice-list {
  position: absolute;
  bottom: 60px;
  left: 20px;
}
.dplayer-notice-list .dplayer-notice {
  border-radius: 2px;
  background: rgba(28, 28, 28, 0.9);
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  color: #fff;
  display: table;
  pointer-events: none;
  animation: showNotice 0.3s ease 1 forwards;
}
.dplayer-notice-list .remove-notice {
  animation: removeNotice 0.3s ease 1 forwards;
}
@keyframes showNotice {
  from {
    padding: 0;
    font-size: 0;
    margin-top: 0;
  }
  to {
    padding: 7px 20px;
    font-size: 14px;
    margin-top: 5px;
  }
}
@keyframes removeNotice {
  0% {
    padding: 7px 20px;
    font-size: 14px;
    margin-top: 5px;
  }
  20% {
    font-size: 12px;
  }
  21% {
    font-size: 0;
    padding: 7px 10px;
  }
  100% {
    padding: 0;
    margin-top: 0;
    font-size: 0;
  }
}
.dplayer-subtitle {
  position: absolute;
  bottom: 40px;
  width: 90%;
  left: 5%;
  text-align: center;
  color: #fff;
  text-shadow: 0.5px 0.5px 0.5px rgba(0, 0, 0, 0.5);
  font-size: 20px;
}
.dplayer-subtitle.dplayer-subtitle-hide {
  display: none;
}
.dplayer-mask {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  display: none;
}
.dplayer-mask.dplayer-mask-show {
  display: block;
}
.dplayer-video-wrap {
  position: relative;
  background: #000;
  font-size: 0;
  width: 100%;
  height: 100%;
}
.dplayer-video-wrap .dplayer-video {
  width: 100%;
  height: 100%;
  display: none;
}
.dplayer-video-wrap .dplayer-video-current {
  display: block;
}
.dplayer-video-wrap .dplayer-video-prepare {
  display: none;
}
.dplayer-info-panel {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 400px;
  background: rgba(28, 28, 28, 0.8);
  padding: 10px;
  color: #fff;
  font-size: 12px;
  border-radius: 2px;
}
.dplayer-info-panel-hide {
  display: none;
}
.dplayer-info-panel .dplayer-info-panel-close {
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 10px;
}
.dplayer-info-panel .dplayer-info-panel-item > span {
  display: inline-block;
  vertical-align: middle;
  line-height: 15px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.dplayer-info-panel .dplayer-info-panel-item-title {
  width: 100px;
  text-align: right;
  margin-right: 10px;
}
.dplayer-info-panel .dplayer-info-panel-item-data {
  width: 260px;
}
`, `.dplayer {
    position: relative;
    overflow: hidden;
    user-select: none;
    line-height: 1;

    * {
        box-sizing: content-box;
    }

    svg {
        width: 100%;
        height: 100%;

        path,
        circle {
            fill: #fff;
        }
    }

    &:-webkit-full-screen {
        width: 100%;
        height: 100%;
        background: #000;
        position: fixed;
        z-index: 100000;
        left: 0;
        top: 0;
        margin: 0;
        padding: 0;
        transform: translate(0, 0);
        
    }

    &.dplayer-no-danmaku {
        .dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-box {
            .dplayer-setting-showdan,
            .dplayer-setting-danmaku,
            .dplayer-setting-danunlimit {
                display: none;
            }
        }

        .dplayer-controller .dplayer-icons .dplayer-comment {
            display: none;
        }

        .dplayer-danmaku {
            display: none;
        }
    }

    &.dplayer-live {
        .dplayer-time {
            display: none;
        }
        .dplayer-bar-wrap {
            display: none;
        }
        .dplayer-setting-speed {
            display: none;
        }
        .dplayer-setting-loop {
            display: none;
        }

        &.dplayer-no-danmaku {
            .dplayer-setting {
                display: none;
            }
        }
    }

    &.dplayer-arrow {
        .dplayer-danmaku {
            font-size: 18px;
        }
        .dplayer-icon {
            margin: 0 -3px;
        }
    }

    &.dplayer-playing {
        .dplayer-danmaku .dplayer-danmaku-move {
            animation-play-state: running;
        }

        @media (min-width: 900px) {
            .dplayer-controller-mask {
                opacity: 0;
            }
            .dplayer-controller {
                opacity: 0;
            }

            &:hover {
                .dplayer-controller-mask {
                    opacity: 1;
                }
                .dplayer-controller {
                    opacity: 1;
                }
            }
        }
    }

    &.dplayer-loading {
        .dplayer-bezel .diplayer-loading-icon {
            display: block;
        }
    }

    &.dplayer-loading,
    &.dplayer-paused {
        .dplayer-danmaku,
        .dplayer-danmaku-move {
            animation-play-state: paused;
        }
    }

    &.dplayer-hide-controller {
        cursor: none;

        .dplayer-controller-mask {
            opacity: 0;
            transform: translateY(100%);
        }
        .dplayer-controller {
            opacity: 0;
            transform: translateY(100%);
        }
    }
    &.dplayer-show-controller {
        .dplayer-controller-mask {
            opacity: 1;
        }
        .dplayer-controller {
            opacity: 1;
        }
    }
    &.dplayer-fulled {
        position: fixed;
        z-index: 100000;
        left: 0;
        top: 0;
        width: 100% !important;
        height: 100% !important;
    }
    &.dplayer-mobile {
        .dplayer-controller .dplayer-icons {
            .dplayer-volume,
            .dplayer-camera-icon,
            .dplayer-airplay-icon,
            .dplayer-chromecast-icon,
            .dplayer-play-icon {
                display: none;
            }
            .dplayer-full .dplayer-full-in-icon {
                position: static;
                display: inline-block;
            }
        }

        .dplayer-bar-time {
            display: none;
        }

        &.dplayer-hide-controller {
            .dplayer-mobile-play {
                display: none;
            }
        }

        .dplayer-mobile-play {
            display: block;
        }
    }
}

// To hide scroll bar, apply this class to <body>
.dplayer-web-fullscreen-fix {
    position: fixed;
    top: 0;
    left: 0;
    margin: 0;
    padding: 0;
}
`, `@import '../../node_modules/balloon-css/balloon.css';

[data-balloon]:before {
    display: none;
}

[data-balloon]:after {
    padding: 0.3em 0.7em;
    background: rgba(17, 17, 17, 0.7);
}

[data-balloon][data-balloon-pos="up"]:after {
    margin-bottom: 0;
}`, `.dplayer-bezel {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    font-size: 22px;
    color: #fff;
    pointer-events: none;
    .dplayer-bezel-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        margin: -26px 0 0 -26px;
        height: 52px;
        width: 52px;
        padding: 12px;
        box-sizing: border-box;
        background: rgba(0, 0, 0, .5);
        border-radius: 50%;
        opacity: 0;
        pointer-events: none;
        &.dplayer-bezel-transition {
            animation: bezel-hide .5s linear;
        }
        @keyframes bezel-hide {
            from {
                opacity: 1;
                transform: scale(1);
            }
            to {
                opacity: 0;
                transform: scale(2);
            }
        }
    }
    .dplayer-danloading {
        position: absolute;
        top: 50%;
        margin-top: -7px;
        width: 100%;
        text-align: center;
        font-size: 14px;
        line-height: 14px;
        animation: my-face 5s infinite ease-in-out;
    }
    .diplayer-loading-icon {
        display: none;
        position: absolute;
        top: 50%;
        left: 50%;
        margin: -18px 0 0 -18px;
        height: 36px;
        width: 36px;
        pointer-events: none;
        .diplayer-loading-hide {
            display: none;
        }
        .diplayer-loading-dot {
            animation: diplayer-loading-dot-fade .8s ease infinite;
            opacity: 0;
            transform-origin: 4px 4px;
            each(range(7), {
                &.diplayer-loading-dot-@{value} {
                    animation-delay: (@value * 0.1s);
                }
            });
        }
        @keyframes diplayer-loading-dot-fade {
            0% {
                opacity: .7;
                transform: scale(1.2, 1.2)
            }
            50% {
                opacity: .25;
                transform: scale(.9, .9)
            }
            to {
                opacity: .25;
                transform: scale(.85, .85)
            }
        }
    }
}`, `.dplayer-notice-list{
    position: absolute;
    bottom: 60px;
    left: 20px;

    .dplayer-notice {
        border-radius: 2px;
        background: rgba(28, 28, 28, 0.9);
        transition: all .3s ease-in-out;
        overflow: hidden;
        color: #fff;
        display: table;
        pointer-events: none;
        animation: showNotice .3s ease 1 forwards;
    }

    .remove-notice{
        animation: removeNotice .3s ease 1 forwards;
    }
}

@keyframes showNotice {
    from {
        padding: 0;
        font-size: 0;
        margin-top: 0;
    }
    to {
        padding: 7px 20px;
        font-size: 14px;
        margin-top: 5px;
    }
}

@keyframes removeNotice {
    0%{
        padding: 7px 20px;
        font-size: 14px;
        margin-top: 5px;
    }
    20%{
        font-size: 12px;
    }
    21%{
        font-size: 0;
        padding: 7px 10px;
    }
    100%{
        padding: 0;
        margin-top: 0;
        font-size: 0;
    }
}
`, `.dplayer-controller-mask {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAADGCAYAAAAT+OqFAAAAdklEQVQoz42QQQ7AIAgEF/T/D+kbq/RWAlnQyyazA4aoAB4FsBSA/bFjuF1EOL7VbrIrBuusmrt4ZZORfb6ehbWdnRHEIiITaEUKa5EJqUakRSaEYBJSCY2dEstQY7AuxahwXFrvZmWl2rh4JZ07z9dLtesfNj5q0FU3A5ObbwAAAABJRU5ErkJggg==) repeat-x bottom;
    height: 98px;
    width: 100%;
    position: absolute;
    bottom: 0;
    transition: all 0.3s ease;
}

.dplayer-controller {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 41px;
    padding: 0 20px;
    user-select: none;
    transition: all 0.3s ease;
    &.dplayer-controller-comment {
        .dplayer-icons {
            display: none;
        }
        .dplayer-icons.dplayer-comment-box {
            display: block;
        }
    }
    .dplayer-bar-wrap {
        padding: 5px 0;
        cursor: pointer;
        position: absolute;
        bottom: 33px;
        width: calc(100% - 40px);
        height: 3px;
        &:hover {
            .dplayer-bar .dplayer-played .dplayer-thumb {
                transform: scale(1);
            }
            .dplayer-highlight {
                display: block;
                width: 8px;
                transform: translateX(-4px);
                top: 4px;
                height: 40%;
            }
        }
        .dplayer-highlight {
            z-index: 12;
            position: absolute;
            top: 5px;
            width: 6px;
            height: 20%;
            border-radius: 6px;
            background-color: #fff;
            text-align: center;
            transform: translateX(-3px);
            transition: all .2s ease-in-out;
            &:hover {
                .dplayer-highlight-text {
                    display: block;
                }
                &~.dplayer-bar-preview {
                    opacity: 0;
                }
                &~.dplayer-bar-time {
                    opacity: 0;
                }
            }
            .dplayer-highlight-text {
                display: none;
                position: absolute;
                left: 50%;
                top: -24px;
                padding: 5px 8px;
                background-color: rgba(0, 0, 0, .62);
                color: #fff;
                border-radius: 4px;
                font-size: 12px;
                white-space: nowrap;
                transform: translateX(-50%);
            }
        }
        .dplayer-bar-preview {
            position: absolute;
            background: #fff;
            pointer-events: none;
            display: none;
            background-size: 16000px 100%;
        }
        .dplayer-bar-preview-canvas {
            position: absolute;
            width: 100%;
            height: 100%;
            z-index: 1;
            pointer-events: none;
        }
        .dplayer-bar-time {
            &.hidden {
                opacity: 0;
            }
            position: absolute;
            left: 0px;
            top: -20px;
            border-radius: 4px;
            padding: 5px 7px;
            background-color: rgba(0, 0, 0, 0.62);
            color: #fff;
            font-size: 12px;
            text-align: center;
            opacity: 1;
            transition: opacity .1s ease-in-out;
            word-wrap: normal;
            word-break: normal;
            z-index: 2;
            pointer-events: none;
        }
        .dplayer-bar {
            position: relative;
            height: 3px;
            width: 100%;
            background: rgba(255, 255, 255, .2);
            cursor: pointer;
            .dplayer-loaded {
                position: absolute;
                left: 0;
                top: 0;
                bottom: 0;
                background: rgba(255, 255, 255, .4);
                height: 3px;
                transition: all 0.5s ease;
                will-change: width;
            }
            .dplayer-played {
                position: absolute;
                left: 0;
                top: 0;
                bottom: 0;
                height: 3px;
                will-change: width;
                .dplayer-thumb {
                    position: absolute;
                    top: 0;
                    right: 5px;
                    margin-top: -4px;
                    margin-right: -10px;
                    height: 11px;
                    width: 11px;
                    border-radius: 50%;
                    cursor: pointer;
                    transition: all .3s ease-in-out;
                    transform: scale(0);
                }
            }
        }
    }
    .dplayer-icons {
        height: 38px;
        position: absolute;
        bottom: 0;
        &.dplayer-comment-box {
            display: none;
            position: absolute;
            transition: all .3s ease-in-out;
            z-index: 2;
            height: 38px;
            bottom: 0;
            left: 20px;
            right: 20px;
            color: #fff;
            .dplayer-icon {
                padding: 7px;
            }
            .dplayer-comment-setting-icon {
                position: absolute;
                left: 0;
                top: 0;
            }
            .dplayer-send-icon {
                position: absolute;
                right: 0;
                top: 0;
            }
            .dplayer-comment-setting-box {
                position: absolute;
                background: rgba(28, 28, 28, 0.9);
                bottom: 41px;
                left: 0;
                box-shadow: 0 0 25px rgba(0, 0, 0, .3);
                border-radius: 4px;
                padding: 10px 10px 16px;
                font-size: 14px;
                width: 204px;
                transition: all .3s ease-in-out;
                transform: scale(0);
                &.dplayer-comment-setting-open {
                    transform: scale(1);
                }
                input[type=radio] {
                    display: none;
                }
                label {
                    cursor: pointer;
                }
                .dplayer-comment-setting-title {
                    font-size: 13px;
                    color: #fff;
                    line-height: 30px;
                }
                .dplayer-comment-setting-type {
                    font-size: 0;
                    .dplayer-comment-setting-title {
                        margin-bottom: 6px;
                    }
                    label {
                        &:nth-child(2) {
                            span {
                                border-radius: 4px 0 0 4px;
                            }
                        }
                        &:nth-child(4) {
                            span {
                                border-radius: 0 4px 4px 0;
                            }
                        }
                    }
                    span {
                        width: 33%;
                        padding: 4px 6px;
                        line-height: 16px;
                        display: inline-block;
                        font-size: 12px;
                        color: #fff;
                        border: 1px solid #fff;
                        margin-right: -1px;
                        box-sizing: border-box;
                        text-align: center;
                        cursor: pointer;
                    }
                    input:checked+span {
                        background: #E4E4E6;
                        color: #1c1c1c;
                    }
                }
                .dplayer-comment-setting-color {
                    font-size: 0;
                    label {
                        font-size: 0;
                        padding: 6px;
                        display: inline-block;
                    }
                    span {
                        width: 22px;
                        height: 22px;
                        display: inline-block;
                        border-radius: 50%;
                        box-sizing: border-box;
                        cursor: pointer;
                        &:hover {
                            animation: my-face 5s infinite ease-in-out;
                        }
                    }
                }
            }
            .dplayer-comment-input {
                outline: none;
                border: none;
                padding: 8px 31px;
                font-size: 14px;
                line-height: 18px;
                text-align: center;
                border-radius: 4px;
                background: none;
                margin: 0;
                height: 100%;
                box-sizing: border-box;
                width: 100%;
                color: #fff;
                &::placeholder {
                    color: #fff;
                    opacity: 0.8;
                }
                &::-ms-clear {
                    display: none;
                }
            }
        }
        &.dplayer-icons-left {
            .dplayer-icon {
                padding: 7px;
            }
        }
        &.dplayer-icons-right {
            right: 20px;
            .dplayer-icon {
                padding: 8px;
            }
        }
        .dplayer-time,
        .dplayer-live-badge {
            line-height: 38px;
            color: #eee;
            text-shadow: 0 0 2px rgba(0, 0, 0, .5);
            vertical-align: middle;
            font-size: 13px;
            cursor: default;
        }
        .dplayer-live-dot {
            display: inline-block;
            width: 6px;
            height: 6px;
            vertical-align: 4%;
            margin-right: 5px;
            content: '';
            border-radius: 6px;
        }
        .dplayer-icon {
            width: 40px;
            height: 100%;
            border: none;
            background-color: transparent;
            outline: none;
            cursor: pointer;
            vertical-align: middle;
            box-sizing: border-box;
            display: inline-block;
            .dplayer-icon-content {
                transition: all .2s ease-in-out;
                opacity: .8;
            }
            &:hover {
                .dplayer-icon-content {
                    opacity: 1;
                }
            }
            &.dplayer-quality-icon {
                color: #fff;
                width: auto;
                line-height: 22px;
                font-size: 14px;
            }
            &.dplayer-comment-icon {
                padding: 10px 9px 9px;
            }
            &.dplayer-setting-icon {
                padding-top: 8.5px;
            }
            &.dplayer-volume-icon {
                width: 43px;
            }
        }
        .dplayer-volume {
            position: relative;
            display: inline-block;
            cursor: pointer;
            height: 100%;
            &:hover {
                .dplayer-volume-bar-wrap .dplayer-volume-bar {
                    width: 45px;
                }
                .dplayer-volume-bar-wrap .dplayer-volume-bar .dplayer-volume-bar-inner .dplayer-thumb {
                    transform: scale(1);
                }
            }
            &.dplayer-volume-active {
                .dplayer-volume-bar-wrap .dplayer-volume-bar {
                    width: 45px;
                }
                .dplayer-volume-bar-wrap .dplayer-volume-bar .dplayer-volume-bar-inner .dplayer-thumb {
                    transform: scale(1);
                }
            }
            .dplayer-volume-bar-wrap {
                display: inline-block;
                margin: 0 10px 0 -5px;
                vertical-align: middle;
                height: 100%;
                .dplayer-volume-bar {
                    position: relative;
                    top: 17px;
                    width: 0;
                    height: 3px;
                    background: #aaa;
                    transition: all 0.3s ease-in-out;
                    .dplayer-volume-bar-inner {
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        height: 100%;
                        transition: all 0.1s ease;
                        will-change: width;
                        .dplayer-thumb {
                            position: absolute;
                            top: 0;
                            right: 5px;
                            margin-top: -4px;
                            margin-right: -10px;
                            height: 11px;
                            width: 11px;
                            border-radius: 50%;
                            cursor: pointer;
                            transition: all .3s ease-in-out;
                            transform: scale(0);
                        }
                    }
                }
            }
        }
        .dplayer-subtitle-btn {
            display: inline-block;
            height: 100%;
        }
        .dplayer-subtitles {
            display: inline-block;
            height: 100%;
            .dplayer-subtitles-box {
                position: absolute;
                right: 0;
                bottom: 50px;
                transform: scale(0);
                width: fit-content;
                max-width: 240px;
                min-width: 120px;
                border-radius: 2px;
                background: rgba(28, 28, 28, 0.9);
                padding: 7px 0;
                transition: all .3s ease-in-out;
                overflow: auto;
                z-index: 2;
                &.dplayer-subtitles-panel {
                    display: block;
                }
                &.dplayer-subtitles-box-open {
                    transform: scale(1);
                }
            }
            .dplayer-subtitles-item {
                height: 30px;
                padding: 5px 10px;
                box-sizing: border-box;
                cursor: pointer;
                position: relative;
                &:hover {
                    background-color: rgba(255, 255, 255, .1);
                }
            }
        }
        .dplayer-setting {
            display: inline-block;
            height: 100%;
            .dplayer-setting-box {
                position: absolute;
                right: 0;
                bottom: 50px;
                transform: scale(0);
                width: 150px;
                border-radius: 2px;
                background: rgba(28, 28, 28, 0.9);
                padding: 7px 0;
                transition: all .3s ease-in-out;
                overflow: hidden;
                z-index: 2;
                &>div {
                    display: none;
                    &.dplayer-setting-origin-panel {
                        display: block;
                    }
                }
                &.dplayer-setting-box-open {
                    transform: scale(1);
                }
                &.dplayer-setting-box-narrow {
                    width: 70px;
                    text-align: center;
                }
                &.dplayer-setting-box-speed {
                    .dplayer-setting-origin-panel {
                        display: none;
                    }
                    .dplayer-setting-speed-panel {
                        display: block;
                    }
                }
            }
            .dplayer-setting-item,
            .dplayer-setting-speed-item {
                height: 30px;
                padding: 5px 10px;
                box-sizing: border-box;
                cursor: pointer;
                position: relative;
                &:hover {
                    background-color: rgba(255, 255, 255, .1);
                }
            }
            .dplayer-setting-danmaku {
                padding: 5px 0;
                .dplayer-label {
                    padding: 0 10px;
                    display: inline;
                }
                &:hover {
                    .dplayer-label {
                        display: none;
                    }
                    .dplayer-danmaku-bar-wrap {
                        display: inline-block;
                    }
                }
                &.dplayer-setting-danmaku-active {
                    .dplayer-label {
                        display: none;
                    }
                    .dplayer-danmaku-bar-wrap {
                        display: inline-block;
                    }
                }
                .dplayer-danmaku-bar-wrap {
                    padding: 0 10px;
                    box-sizing: border-box;
                    display: none;
                    vertical-align: middle;
                    height: 100%;
                    width: 100%;
                    .dplayer-danmaku-bar {
                        position: relative;
                        top: 8.5px;
                        width: 100%;
                        height: 3px;
                        background: #fff;
                        transition: all 0.3s ease-in-out;
                        .dplayer-danmaku-bar-inner {
                            position: absolute;
                            bottom: 0;
                            left: 0;
                            height: 100%;
                            transition: all 0.1s ease;
                            background: #aaa;
                            will-change: width;
                            .dplayer-thumb {
                                position: absolute;
                                top: 0;
                                right: 5px;
                                margin-top: -4px;
                                margin-right: -10px;
                                height: 11px;
                                width: 11px;
                                border-radius: 50%;
                                cursor: pointer;
                                transition: all .3s ease-in-out;
                                background: #aaa;
                            }
                        }
                    }
                }
            }
        }
        .dplayer-full {
            display: inline-block;
            height: 100%;
            position: relative;
            &:hover {
                .dplayer-full-in-icon {
                    display: block;
                }
            }
            .dplayer-full-in-icon {
                position: absolute;
                top: -30px;
                z-index: 1;
                display: none;
            }
        }
        .dplayer-quality {
            position: relative;
            display: inline-block;
            height: 100%;
            z-index: 2;
            &:hover {
                .dplayer-quality-list {
                    display: block;
                }
                .dplayer-quality-mask {
                    display: block;
                }
            }
            .dplayer-quality-mask {
                display: none;
                position: absolute;
                bottom: 38px;
                left: -18px;
                width: 80px;
                padding-bottom: 12px;
            }
            .dplayer-quality-list {
                display: none;
                font-size: 12px;
                width: 80px;
                border-radius: 2px;
                background: rgba(28, 28, 28, 0.9);
                padding: 5px 0;
                transition: all .3s ease-in-out;
                overflow: hidden;
                color: #fff;
                text-align: center;
            }
            .dplayer-quality-item {
                height: 25px;
                box-sizing: border-box;
                cursor: pointer;
                line-height: 25px;
                &:hover {
                    background-color: rgba(255, 255, 255, .1);
                }
            }
        }
        .dplayer-comment {
            display: inline-block;
            height: 100%;
        }
        .dplayer-label {
            color: #eee;
            font-size: 13px;
            display: inline-block;
            vertical-align: middle;
            white-space: nowrap;
        }
        .dplayer-toggle {
            width: 32px;
            height: 20px;
            text-align: center;
            font-size: 0;
            vertical-align: middle;
            position: absolute;
            top: 5px;
            right: 10px;
            input {
                max-height: 0;
                max-width: 0;
                display: none;
            }
            input+label {
                display: inline-block;
                position: relative;
                box-shadow: rgb(223, 223, 223) 0 0 0 0 inset;
                border: 1px solid rgb(223, 223, 223);
                height: 20px;
                width: 32px;
                border-radius: 10px;
                box-sizing: border-box;
                cursor: pointer;
                transition: .2s ease-in-out;
            }
            input+label:before {
                content: "";
                position: absolute;
                display: block;
                height: 18px;
                width: 18px;
                top: 0;
                left: 0;
                border-radius: 15px;
                transition: .2s ease-in-out;
            }
            input+label:after {
                content: "";
                position: absolute;
                display: block;
                left: 0;
                top: 0;
                border-radius: 15px;
                background: #fff;
                transition: .2s ease-in-out;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
                height: 18px;
                width: 18px;
            }
            input:checked+label {
                border-color: rgba(255, 255, 255, 0.5);
            }
            input:checked+label:before {
                width: 30px;
                background: rgba(255, 255, 255, 0.5);
            }
            input:checked+label:after {
                left: 12px;
            }
        }
    }
}

.dplayer-mobile-play {
    display: none;
    width: 50px;
    height: 50px;
    border: none;
    background-color: transparent;
    outline: none;
    cursor: pointer;
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    opacity: 0.8;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}`, `.dplayer-danmaku {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    font-size: 22px;
    color: #fff;
    .dplayer-danmaku-item {
        display: inline-block;
        pointer-events: none;
        user-select: none;
        cursor: default;
        white-space: nowrap;
        text-shadow: .5px .5px .5px rgba(0, 0, 0, .5);
        &--demo {
            position: absolute;
            visibility: hidden;
        }
    }
    .dplayer-danmaku-right {
        position: absolute;
        right: 0;
        transform: translateX(100%);
        &.dplayer-danmaku-move {
            will-change: transform;
            animation-name: 'danmaku';
            animation-timing-function: linear;
            animation-play-state: paused;
        }
    }
    @keyframes danmaku {
        from {
            transform: translateX(100%);
        }
    }
    .dplayer-danmaku-top,
    .dplayer-danmaku-bottom {
        position: absolute;
        width: 100%;
        text-align: center;
        visibility: hidden;
        &.dplayer-danmaku-move {
            will-change: visibility;
            animation-name: 'danmaku-center';
            animation-timing-function: linear;
            animation-play-state: paused;
        }
    }
    @keyframes danmaku-center {
        from {
            visibility: visible;
        }
        to {
            visibility: visible;
        }
    }
}`, `.dplayer-logo {
    pointer-events: none;
    position: absolute;
    left: 20px;
    top: 20px;
    max-width: 50px;
    max-height: 50px;
    img {
        max-width: 100%;
        max-height: 100%;
        background: none;
    }
}`, `.dplayer-menu {
    position: absolute;
    width: 170px;
    border-radius: 2px;
    background: rgba(28, 28, 28, 0.85);
    padding: 5px 0;
    overflow: hidden;
    z-index: 3;
    display: none;
    &.dplayer-menu-show {
        display: block;
    }
    .dplayer-menu-item {
        height: 30px;
        box-sizing: border-box;
        cursor: pointer;
        &:hover {
            background-color: rgba(255, 255, 255, .1);
        }
        a {
            display: inline-block;
            padding: 0 10px;
            line-height: 30px;
            color: #eee;
            font-size: 13px;
            display: inline-block;
            vertical-align: middle;
            width: 100%;
            box-sizing: border-box;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            &:hover {
                text-decoration: none;
            }
        }
    }
}`, `.dplayer-subtitle {
    position: absolute;
    bottom: 40px;
    width: 90%;
    left: 5%;
    text-align: center;
    color: #fff;
    text-shadow: 0.5px 0.5px 0.5px rgba(0, 0, 0, 0.5);
    font-size: 20px;
    &.dplayer-subtitle-hide {
        display: none;
    }
}`, `.dplayer-mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    display: none;
    &.dplayer-mask-show {
        display: block;
    }
}

.dplayer-video-wrap {
    position: relative;
    background: #000;
    font-size: 0;
    width: 100%;
    height: 100%;
    .dplayer-video {
        width: 100%;
        height: 100%;
        display: none;
    }
    .dplayer-video-current {
        display: block;
    }
    .dplayer-video-prepare {
        display: none;
    }
}`, `.dplayer-info-panel {
    position: absolute;
    top: 10px;
    left: 10px;
    width: 400px;
    background: rgba(28, 28, 28, 0.8);
    padding: 10px;
    color: #fff;
    font-size: 12px;
    border-radius: 2px;

    &-hide {
        display: none;
    }

    .dplayer-info-panel-close {
        cursor: pointer;
        position: absolute;
        right: 10px;
        top: 10px;
    }

    .dplayer-info-panel-item {
        & > span {
            display: inline-block;
            vertical-align: middle;
            line-height: 15px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
    }

    .dplayer-info-panel-item-title {
        width: 100px;
        text-align: right;
        margin-right: 10px;
    }
    
    .dplayer-info-panel-item-data {
        width: 260px;
    }
}`], sourceRoot: "" }]);
      const _ = v;
    }, 856: (s) => {
      var a = [];
      function l(u) {
        for (var c = -1, m = 0; m < a.length; m++)
          if (a[m].identifier === u) {
            c = m;
            break;
          }
        return c;
      }
      function d(u, c) {
        for (var m = {}, f = [], p = 0; p < u.length; p++) {
          var A = u[p], v = c.base ? A[0] + c.base : A[0], b = m[v] || 0, _ = "".concat(v, " ").concat(b);
          m[v] = b + 1;
          var T = l(_), E = { css: A[1], media: A[2], sourceMap: A[3], supports: A[4], layer: A[5] };
          if (T !== -1)
            a[T].references++, a[T].updater(E);
          else {
            var L = h(E, c);
            c.byIndex = p, a.splice(p, 0, { identifier: _, updater: L, references: 1 });
          }
          f.push(_);
        }
        return f;
      }
      function h(u, c) {
        var m = c.domAPI(c);
        return m.update(u), function(f) {
          if (f) {
            if (f.css === u.css && f.media === u.media && f.sourceMap === u.sourceMap && f.supports === u.supports && f.layer === u.layer)
              return;
            m.update(u = f);
          } else
            m.remove();
        };
      }
      s.exports = function(u, c) {
        var m = d(u = u || [], c = c || {});
        return function(f) {
          f = f || [];
          for (var p = 0; p < m.length; p++) {
            var A = l(m[p]);
            a[A].references--;
          }
          for (var v = d(f, c), b = 0; b < m.length; b++) {
            var _ = l(m[b]);
            a[_].references === 0 && (a[_].updater(), a.splice(_, 1));
          }
          m = v;
        };
      };
    }, 370: (s) => {
      var a = {};
      s.exports = function(l, d) {
        var h = function(u) {
          if (a[u] === void 0) {
            var c = document.querySelector(u);
            if (window.HTMLIFrameElement && c instanceof window.HTMLIFrameElement)
              try {
                c = c.contentDocument.head;
              } catch {
                c = null;
              }
            a[u] = c;
          }
          return a[u];
        }(l);
        if (!h)
          throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
        h.appendChild(d);
      };
    }, 278: (s) => {
      s.exports = function(a) {
        var l = document.createElement("style");
        return a.setAttributes(l, a.attributes), a.insert(l, a.options), l;
      };
    }, 458: (s, a, l) => {
      s.exports = function(d) {
        var h = l.nc;
        h && d.setAttribute("nonce", h);
      };
    }, 470: (s) => {
      s.exports = function(a) {
        var l = a.insertStyleElement(a);
        return { update: function(d) {
          (function(h, u, c) {
            var m = "";
            c.supports && (m += "@supports (".concat(c.supports, ") {")), c.media && (m += "@media ".concat(c.media, " {"));
            var f = c.layer !== void 0;
            f && (m += "@layer".concat(c.layer.length > 0 ? " ".concat(c.layer) : "", " {")), m += c.css, f && (m += "}"), c.media && (m += "}"), c.supports && (m += "}");
            var p = c.sourceMap;
            p && typeof btoa < "u" && (m += `
/*# sourceMappingURL=data:application/json;base64,`.concat(btoa(unescape(encodeURIComponent(JSON.stringify(p)))), " */")), u.styleTagTransform(m, h, u.options);
          })(l, a, d);
        }, remove: function() {
          (function(d) {
            if (d.parentNode === null)
              return !1;
            d.parentNode.removeChild(d);
          })(l);
        } };
      };
    }, 488: (s) => {
      s.exports = function(a, l) {
        if (l.styleSheet)
          l.styleSheet.cssText = a;
        else {
          for (; l.firstChild; )
            l.removeChild(l.firstChild);
          l.appendChild(document.createTextNode(a));
        }
      };
    }, 251: (s) => {
      s.exports = '<svg viewBox="0 0 288 288" xmlns="http://www.w3.org/2000/svg"><path d="M288 90v96c0 20-16 36-36 36h-10c-16 0-16-24 0-24h10c7 0 12-5 12-12V90c0-7-5-12-12-12H36c-7 0-12 5-12 12v96c0 7 5 12 12 12h10c16 0 16 24 0 24H36c-20 0-36-16-36-36V90c0-20 16-36 36-36h216c20 0 36 16 36 36zm-120 62l48 68c14 20 1 38-20 38H92c-21 0-34-18-20-38l48-68c13-18 35-18 48 0z"></path></svg>';
    }, 113: (s) => {
      s.exports = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 32 32"><path d="M16 23c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6zM16 13c-2.206 0-4 1.794-4 4s1.794 4 4 4c2.206 0 4-1.794 4-4s-1.794-4-4-4zM27 28h-22c-1.654 0-3-1.346-3-3v-16c0-1.654 1.346-3 3-3h3c0.552 0 1 0.448 1 1s-0.448 1-1 1h-3c-0.551 0-1 0.449-1 1v16c0 0.552 0.449 1 1 1h22c0.552 0 1-0.448 1-1v-16c0-0.551-0.448-1-1-1h-11c-0.552 0-1-0.448-1-1s0.448-1 1-1h11c1.654 0 3 1.346 3 3v16c0 1.654-1.346 3-3 3zM24 10.5c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5zM15 4c0 0.552-0.448 1-1 1h-4c-0.552 0-1-0.448-1-1v0c0-0.552 0.448-1 1-1h4c0.552 0 1 0.448 1 1v0z"></path></svg>';
    }, 193: (s) => {
      s.exports = '<svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="chromecast" class="svg-inline--fa fa-chromecast fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M447.8,64H64c-23.6,0-42.7,19.1-42.7,42.7v63.9H64v-63.9h383.8v298.6H298.6V448H448c23.6,0,42.7-19.1,42.7-42.7V106.7 C490.7,83.1,471.4,64,447.8,64z M21.3,383.6L21.3,383.6l0,63.9h63.9C85.2,412.2,56.6,383.6,21.3,383.6L21.3,383.6z M21.3,298.6V341 c58.9,0,106.6,48.1,106.6,107h42.7C170.7,365.6,103.7,298.7,21.3,298.6z M213.4,448h42.7c-0.5-129.5-105.3-234.3-234.8-234.6l0,42.4 C127.3,255.6,213.3,342,213.4,448z"></path></svg>';
    }, 338: (s) => {
      s.exports = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 32 32"><path d="M27.090 0.131h-22.731c-2.354 0-4.262 1.839-4.262 4.109v16.401c0 2.269 1.908 4.109 4.262 4.109h4.262v-2.706h8.469l-8.853 8.135 1.579 1.451 7.487-6.88h9.787c2.353 0 4.262-1.84 4.262-4.109v-16.401c0-2.27-1.909-4.109-4.262-4.109v0zM28.511 19.304c0 1.512-1.272 2.738-2.841 2.738h-8.425l-0.076-0.070-0.076 0.070h-11.311c-1.569 0-2.841-1.226-2.841-2.738v-13.696c0-1.513 1.272-2.739 2.841-2.739h19.889c1.569 0 2.841-0.142 2.841 1.37v15.064z"></path></svg>';
    }, 807: (s) => {
      s.exports = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 32 32"><path d="M27.128 0.38h-22.553c-2.336 0-4.229 1.825-4.229 4.076v16.273c0 2.251 1.893 4.076 4.229 4.076h4.229v-2.685h8.403l-8.784 8.072 1.566 1.44 7.429-6.827h9.71c2.335 0 4.229-1.825 4.229-4.076v-16.273c0-2.252-1.894-4.076-4.229-4.076zM28.538 19.403c0 1.5-1.262 2.717-2.819 2.717h-8.36l-0.076-0.070-0.076 0.070h-11.223c-1.557 0-2.819-1.217-2.819-2.717v-13.589c0-1.501 1.262-2.718 2.819-2.718h19.734c1.557 0 2.819-0.141 2.819 1.359v14.947zM9.206 10.557c-1.222 0-2.215 0.911-2.215 2.036s0.992 2.035 2.215 2.035c1.224 0 2.216-0.911 2.216-2.035s-0.992-2.036-2.216-2.036zM22.496 10.557c-1.224 0-2.215 0.911-2.215 2.036s0.991 2.035 2.215 2.035c1.224 0 2.215-0.911 2.215-2.035s-0.991-2.036-2.215-2.036zM15.852 10.557c-1.224 0-2.215 0.911-2.215 2.036s0.991 2.035 2.215 2.035c1.222 0 2.215-0.911 2.215-2.035s-0.992-2.036-2.215-2.036z"></path></svg>';
    }, 300: (s) => {
      s.exports = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 32 33"><path d="M24.965 24.38h-18.132c-1.366 0-2.478-1.113-2.478-2.478v-11.806c0-1.364 1.111-2.478 2.478-2.478h18.132c1.366 0 2.478 1.113 2.478 2.478v11.806c0 1.364-1.11 2.478-2.478 2.478zM6.833 10.097v11.806h18.134l-0.002-11.806h-18.132zM2.478 28.928h5.952c0.684 0 1.238-0.554 1.238-1.239 0-0.684-0.554-1.238-1.238-1.238h-5.952v-5.802c0-0.684-0.554-1.239-1.238-1.239s-1.239 0.556-1.239 1.239v5.802c0 1.365 1.111 2.478 2.478 2.478zM30.761 19.412c-0.684 0-1.238 0.554-1.238 1.238v5.801h-5.951c-0.686 0-1.239 0.554-1.239 1.238 0 0.686 0.554 1.239 1.239 1.239h5.951c1.366 0 2.478-1.111 2.478-2.478v-5.801c0-0.683-0.554-1.238-1.239-1.238zM0 5.55v5.802c0 0.683 0.554 1.238 1.238 1.238s1.238-0.555 1.238-1.238v-5.802h5.952c0.684 0 1.238-0.554 1.238-1.238s-0.554-1.238-1.238-1.238h-5.951c-1.366-0.001-2.478 1.111-2.478 2.476zM32 11.35v-5.801c0-1.365-1.11-2.478-2.478-2.478h-5.951c-0.686 0-1.239 0.554-1.239 1.238s0.554 1.238 1.239 1.238h5.951v5.801c0 0.683 0.554 1.237 1.238 1.237 0.686 0.002 1.239-0.553 1.239-1.236z"></path></svg>';
    }, 574: (s) => {
      s.exports = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 32 33"><path d="M6.667 28h-5.333c-0.8 0-1.333-0.533-1.333-1.333v-5.333c0-0.8 0.533-1.333 1.333-1.333s1.333 0.533 1.333 1.333v4h4c0.8 0 1.333 0.533 1.333 1.333s-0.533 1.333-1.333 1.333zM30.667 28h-5.333c-0.8 0-1.333-0.533-1.333-1.333s0.533-1.333 1.333-1.333h4v-4c0-0.8 0.533-1.333 1.333-1.333s1.333 0.533 1.333 1.333v5.333c0 0.8-0.533 1.333-1.333 1.333zM30.667 12c-0.8 0-1.333-0.533-1.333-1.333v-4h-4c-0.8 0-1.333-0.533-1.333-1.333s0.533-1.333 1.333-1.333h5.333c0.8 0 1.333 0.533 1.333 1.333v5.333c0 0.8-0.533 1.333-1.333 1.333zM1.333 12c-0.8 0-1.333-0.533-1.333-1.333v-5.333c0-0.8 0.533-1.333 1.333-1.333h5.333c0.8 0 1.333 0.533 1.333 1.333s-0.533 1.333-1.333 1.333h-4v4c0 0.8-0.533 1.333-1.333 1.333z"></path></svg>';
    }, 182: (s) => {
      s.exports = '<svg version="1.1" viewBox="0 0 22 22"><svg x="7" y="1"><circle class="diplayer-loading-dot diplayer-loading-dot-0" cx="4" cy="4" r="2"></circle></svg><svg x="11" y="3"><circle class="diplayer-loading-dot diplayer-loading-dot-1" cx="4" cy="4" r="2"></circle></svg><svg x="13" y="7"><circle class="diplayer-loading-dot diplayer-loading-dot-2" cx="4" cy="4" r="2"></circle></svg><svg x="11" y="11"><circle class="diplayer-loading-dot diplayer-loading-dot-3" cx="4" cy="4" r="2"></circle></svg><svg x="7" y="13"><circle class="diplayer-loading-dot diplayer-loading-dot-4" cx="4" cy="4" r="2"></circle></svg><svg x="3" y="11"><circle class="diplayer-loading-dot diplayer-loading-dot-5" cx="4" cy="4" r="2"></circle></svg><svg x="1" y="7"><circle class="diplayer-loading-dot diplayer-loading-dot-6" cx="4" cy="4" r="2"></circle></svg><svg x="3" y="3"><circle class="diplayer-loading-dot diplayer-loading-dot-7" cx="4" cy="4" r="2"></circle></svg></svg>';
    }, 965: (s) => {
      s.exports = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 32 32"><path d="M19.357 2.88c1.749 0 3.366 0.316 4.851 0.946 1.485 0.632 2.768 1.474 3.845 2.533s1.922 2.279 2.532 3.661c0.611 1.383 0.915 2.829 0.915 4.334 0 1.425-0.304 2.847-0.915 4.271-0.611 1.425-1.587 2.767-2.928 4.028-0.855 0.813-1.811 1.607-2.869 2.38s-2.136 1.465-3.233 2.075c-1.099 0.61-2.198 1.098-3.296 1.465-1.098 0.366-2.115 0.549-3.051 0.549-1.343 0-2.441-0.438-3.296-1.311-0.854-0.876-1.281-2.41-1.281-4.608 0-0.366 0.020-0.773 0.060-1.221s0.062-0.895 0.062-1.343c0-0.773-0.183-1.353-0.55-1.738-0.366-0.387-0.793-0.58-1.281-0.58-0.652 0-1.21 0.295-1.678 0.886s-0.926 1.23-1.373 1.921c-0.447 0.693-0.905 1.334-1.372 1.923s-1.028 0.886-1.679 0.886c-0.529 0-1.048-0.427-1.556-1.282s-0.763-2.259-0.763-4.212c0-2.197 0.529-4.241 1.587-6.133s2.462-3.529 4.21-4.912c1.75-1.383 3.762-2.471 6.041-3.264 2.277-0.796 4.617-1.212 7.018-1.253zM7.334 15.817c0.569 0 1.047-0.204 1.434-0.611s0.579-0.875 0.579-1.404c0-0.569-0.193-1.047-0.579-1.434s-0.864-0.579-1.434-0.579c-0.529 0-0.987 0.193-1.373 0.579s-0.58 0.864-0.58 1.434c0 0.53 0.194 0.998 0.58 1.404 0.388 0.407 0.845 0.611 1.373 0.611zM12.216 11.79c0.691 0 1.292-0.254 1.8-0.763s0.762-1.107 0.762-1.8c0-0.732-0.255-1.343-0.762-1.831-0.509-0.489-1.109-0.732-1.8-0.732-0.732 0-1.342 0.244-1.831 0.732-0.488 0.488-0.732 1.098-0.732 1.831 0 0.693 0.244 1.292 0.732 1.8s1.099 0.763 1.831 0.763zM16.366 25.947c0.692 0 1.282-0.214 1.77-0.64s0.732-0.987 0.732-1.678-0.244-1.261-0.732-1.709c-0.489-0.448-1.078-0.671-1.77-0.671-0.65 0-1.21 0.223-1.678 0.671s-0.702 1.018-0.702 1.709c0 0.692 0.234 1.25 0.702 1.678s1.027 0.64 1.678 0.64zM19.113 9.592c0.651 0 1.129-0.203 1.433-0.611 0.305-0.406 0.459-0.874 0.459-1.404 0-0.488-0.154-0.947-0.459-1.373-0.304-0.427-0.782-0.641-1.433-0.641-0.529 0-1.008 0.193-1.434 0.58s-0.64 0.865-0.64 1.434c0 0.571 0.213 1.049 0.64 1.434 0.427 0.389 0.905 0.581 1.434 0.581zM24.848 12.826c0.57 0 1.067-0.213 1.495-0.64 0.427-0.427 0.64-0.947 0.64-1.556 0-0.57-0.214-1.068-0.64-1.495-0.428-0.427-0.927-0.64-1.495-0.64-0.611 0-1.129 0.213-1.555 0.64-0.428 0.427-0.642 0.926-0.642 1.495 0 0.611 0.213 1.129 0.642 1.556s0.947 0.64 1.555 0.64z"></path></svg>';
    }, 74: (s) => {
      s.exports = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 17 32"><path d="M14.080 4.8q2.88 0 2.88 2.048v18.24q0 2.112-2.88 2.112t-2.88-2.112v-18.24q0-2.048 2.88-2.048zM2.88 4.8q2.88 0 2.88 2.048v18.24q0 2.112-2.88 2.112t-2.88-2.112v-18.24q0-2.048 2.88-2.048z"></path></svg>';
    }, 730: (s) => {
      s.exports = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 16 32"><path d="M15.552 15.168q0.448 0.32 0.448 0.832 0 0.448-0.448 0.768l-13.696 8.512q-0.768 0.512-1.312 0.192t-0.544-1.28v-16.448q0-0.96 0.544-1.28t1.312 0.192z"></path></svg>';
    }, 428: (s) => {
      s.exports = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 32 32"><path d="M22 16l-10.105-10.6-1.895 1.987 8.211 8.613-8.211 8.612 1.895 1.988 8.211-8.613z"></path></svg>';
    }, 254: (s) => {
      s.exports = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 32 32"><path d="M13.725 30l3.9-5.325-3.9-1.125v6.45zM0 17.5l11.050 3.35 13.6-11.55-10.55 12.425 11.8 3.65 6.1-23.375-32 15.5z"></path></svg>';
    }, 934: (s) => {
      s.exports = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 32 28"><path d="M28.633 17.104c0.035 0.21 0.026 0.463-0.026 0.76s-0.14 0.598-0.262 0.904c-0.122 0.306-0.271 0.581-0.445 0.825s-0.367 0.419-0.576 0.524c-0.209 0.105-0.393 0.157-0.55 0.157s-0.332-0.035-0.524-0.105c-0.175-0.052-0.393-0.1-0.655-0.144s-0.528-0.052-0.799-0.026c-0.271 0.026-0.541 0.083-0.812 0.17s-0.502 0.236-0.694 0.445c-0.419 0.437-0.664 0.934-0.734 1.493s0.009 1.092 0.236 1.598c0.175 0.349 0.148 0.699-0.079 1.048-0.105 0.14-0.271 0.284-0.498 0.432s-0.476 0.284-0.747 0.406-0.555 0.218-0.851 0.288c-0.297 0.070-0.559 0.105-0.786 0.105-0.157 0-0.306-0.061-0.445-0.183s-0.236-0.253-0.288-0.393h-0.026c-0.192-0.541-0.52-1.009-0.982-1.402s-1-0.589-1.611-0.589c-0.594 0-1.131 0.197-1.611 0.589s-0.816 0.851-1.009 1.375c-0.087 0.21-0.218 0.362-0.393 0.458s-0.367 0.144-0.576 0.144c-0.244 0-0.52-0.044-0.825-0.131s-0.611-0.197-0.917-0.327c-0.306-0.131-0.581-0.284-0.825-0.458s-0.428-0.349-0.55-0.524c-0.087-0.122-0.135-0.266-0.144-0.432s0.057-0.397 0.197-0.694c0.192-0.402 0.266-0.86 0.223-1.375s-0.266-0.991-0.668-1.428c-0.244-0.262-0.541-0.432-0.891-0.511s-0.681-0.109-0.995-0.092c-0.367 0.017-0.742 0.087-1.127 0.21-0.244 0.070-0.489 0.052-0.734-0.052-0.192-0.070-0.371-0.231-0.537-0.485s-0.314-0.533-0.445-0.838c-0.131-0.306-0.231-0.62-0.301-0.943s-0.087-0.59-0.052-0.799c0.052-0.384 0.227-0.629 0.524-0.734 0.524-0.21 0.995-0.555 1.415-1.035s0.629-1.017 0.629-1.611c0-0.611-0.21-1.144-0.629-1.598s-0.891-0.786-1.415-0.996c-0.157-0.052-0.288-0.179-0.393-0.38s-0.157-0.406-0.157-0.616c0-0.227 0.035-0.48 0.105-0.76s0.162-0.55 0.275-0.812 0.244-0.502 0.393-0.72c0.148-0.218 0.31-0.38 0.485-0.485 0.14-0.087 0.275-0.122 0.406-0.105s0.275 0.052 0.432 0.105c0.524 0.21 1.070 0.275 1.637 0.197s1.070-0.327 1.506-0.747c0.21-0.209 0.362-0.467 0.458-0.773s0.157-0.607 0.183-0.904c0.026-0.297 0.026-0.568 0-0.812s-0.048-0.419-0.065-0.524c-0.035-0.105-0.066-0.227-0.092-0.367s-0.013-0.262 0.039-0.367c0.105-0.244 0.293-0.458 0.563-0.642s0.563-0.336 0.878-0.458c0.314-0.122 0.62-0.214 0.917-0.275s0.533-0.092 0.707-0.092c0.227 0 0.406 0.074 0.537 0.223s0.223 0.301 0.275 0.458c0.192 0.471 0.507 0.886 0.943 1.244s0.952 0.537 1.546 0.537c0.611 0 1.153-0.17 1.624-0.511s0.803-0.773 0.996-1.297c0.070-0.14 0.179-0.284 0.327-0.432s0.301-0.223 0.458-0.223c0.244 0 0.511 0.035 0.799 0.105s0.572 0.166 0.851 0.288c0.279 0.122 0.537 0.279 0.773 0.472s0.423 0.402 0.563 0.629c0.087 0.14 0.113 0.293 0.079 0.458s-0.070 0.284-0.105 0.354c-0.227 0.506-0.297 1.039-0.21 1.598s0.341 1.048 0.76 1.467c0.419 0.419 0.934 0.651 1.546 0.694s1.179-0.057 1.703-0.301c0.14-0.087 0.31-0.122 0.511-0.105s0.371 0.096 0.511 0.236c0.262 0.244 0.493 0.616 0.694 1.113s0.336 1 0.406 1.506c0.035 0.297-0.013 0.528-0.144 0.694s-0.266 0.275-0.406 0.327c-0.542 0.192-1.004 0.528-1.388 1.009s-0.576 1.026-0.576 1.637c0 0.594 0.162 1.113 0.485 1.559s0.747 0.764 1.27 0.956c0.122 0.070 0.227 0.14 0.314 0.21 0.192 0.157 0.323 0.358 0.393 0.602v0zM16.451 19.462c0.786 0 1.528-0.149 2.227-0.445s1.305-0.707 1.821-1.231c0.515-0.524 0.921-1.131 1.218-1.821s0.445-1.428 0.445-2.214c0-0.786-0.148-1.524-0.445-2.214s-0.703-1.292-1.218-1.808c-0.515-0.515-1.122-0.921-1.821-1.218s-1.441-0.445-2.227-0.445c-0.786 0-1.524 0.148-2.214 0.445s-1.292 0.703-1.808 1.218c-0.515 0.515-0.921 1.118-1.218 1.808s-0.445 1.428-0.445 2.214c0 0.786 0.149 1.524 0.445 2.214s0.703 1.297 1.218 1.821c0.515 0.524 1.118 0.934 1.808 1.231s1.428 0.445 2.214 0.445v0z"></path></svg>';
    }, 410: (s) => {
      s.exports = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 32 32"><path d="M26.667 5.333h-21.333c-0 0-0.001 0-0.001 0-1.472 0-2.666 1.194-2.666 2.666 0 0 0 0.001 0 0.001v-0 16c0 0 0 0.001 0 0.001 0 1.472 1.194 2.666 2.666 2.666 0 0 0.001 0 0.001 0h21.333c0 0 0.001 0 0.001 0 1.472 0 2.666-1.194 2.666-2.666 0-0 0-0.001 0-0.001v0-16c0-0 0-0.001 0-0.001 0-1.472-1.194-2.666-2.666-2.666-0 0-0.001 0-0.001 0h0zM5.333 16h5.333v2.667h-5.333v-2.667zM18.667 24h-13.333v-2.667h13.333v2.667zM26.667 24h-5.333v-2.667h5.333v2.667zM26.667 18.667h-13.333v-2.667h13.333v2.667z"></path></svg>';
    }, 644: (s) => {
      s.exports = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 21 32"><path d="M13.728 6.272v19.456q0 0.448-0.352 0.8t-0.8 0.32-0.8-0.32l-5.952-5.952h-4.672q-0.48 0-0.8-0.352t-0.352-0.8v-6.848q0-0.48 0.352-0.8t0.8-0.352h4.672l5.952-5.952q0.32-0.32 0.8-0.32t0.8 0.32 0.352 0.8zM20.576 16q0 1.344-0.768 2.528t-2.016 1.664q-0.16 0.096-0.448 0.096-0.448 0-0.8-0.32t-0.32-0.832q0-0.384 0.192-0.64t0.544-0.448 0.608-0.384 0.512-0.64 0.192-1.024-0.192-1.024-0.512-0.64-0.608-0.384-0.544-0.448-0.192-0.64q0-0.48 0.32-0.832t0.8-0.32q0.288 0 0.448 0.096 1.248 0.48 2.016 1.664t0.768 2.528z"></path></svg>';
    }, 324: (s) => {
      s.exports = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 21 32"><path d="M13.728 6.272v19.456q0 0.448-0.352 0.8t-0.8 0.32-0.8-0.32l-5.952-5.952h-4.672q-0.48 0-0.8-0.352t-0.352-0.8v-6.848q0-0.48 0.352-0.8t0.8-0.352h4.672l5.952-5.952q0.32-0.32 0.8-0.32t0.8 0.32 0.352 0.8z"></path></svg>';
    }, 437: (s) => {
      s.exports = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 21 32"><path d="M13.728 6.272v19.456q0 0.448-0.352 0.8t-0.8 0.32-0.8-0.32l-5.952-5.952h-4.672q-0.48 0-0.8-0.352t-0.352-0.8v-6.848q0-0.48 0.352-0.8t0.8-0.352h4.672l5.952-5.952q0.32-0.32 0.8-0.32t0.8 0.32 0.352 0.8zM20.576 16q0 1.344-0.768 2.528t-2.016 1.664q-0.16 0.096-0.448 0.096-0.448 0-0.8-0.32t-0.32-0.832q0-0.384 0.192-0.64t0.544-0.448 0.608-0.384 0.512-0.64 0.192-1.024-0.192-1.024-0.512-0.64-0.608-0.384-0.544-0.448-0.192-0.64q0-0.48 0.32-0.832t0.8-0.32q0.288 0 0.448 0.096 1.248 0.48 2.016 1.664t0.768 2.528zM25.152 16q0 2.72-1.536 5.056t-4 3.36q-0.256 0.096-0.448 0.096-0.48 0-0.832-0.352t-0.32-0.8q0-0.704 0.672-1.056 1.024-0.512 1.376-0.8 1.312-0.96 2.048-2.4t0.736-3.104-0.736-3.104-2.048-2.4q-0.352-0.288-1.376-0.8-0.672-0.352-0.672-1.056 0-0.448 0.32-0.8t0.8-0.352q0.224 0 0.48 0.096 2.496 1.056 4 3.36t1.536 5.056z"></path></svg>';
    }, 897: (s, a, l) => {
      var d = typeof self < "u" ? self : typeof window < "u" ? window : l.g !== void 0 ? l.g : {}, h = Object.create(d), u = /["&'<>]/;
      function c(m) {
        return typeof m != "string" && (m = m == null ? "" : typeof m == "function" ? c(m.call(m)) : JSON.stringify(m)), m;
      }
      h.$escape = function(m) {
        return function(f) {
          var p = "" + f, A = u.exec(p);
          if (!A)
            return f;
          var v = "", b = void 0, _ = void 0, T = void 0;
          for (b = A.index, _ = 0; b < p.length; b++) {
            switch (p.charCodeAt(b)) {
              case 34:
                T = "&#34;";
                break;
              case 38:
                T = "&#38;";
                break;
              case 39:
                T = "&#39;";
                break;
              case 60:
                T = "&#60;";
                break;
              case 62:
                T = "&#62;";
                break;
              default:
                continue;
            }
            _ !== b && (v += p.substring(_, b)), _ = b + 1, v += T;
          }
          return _ !== b ? v + p.substring(_, b) : v;
        }(c(m));
      }, h.$each = function(m, f) {
        if (Array.isArray(m))
          for (var p = 0, A = m.length; p < A; p++)
            f(m[p], p);
        else
          for (var v in m)
            f(m[v], v);
      }, s.exports = h;
    }, 471: (s, a, l) => {
      s.exports = l(897);
    }, 352: (s) => {
      s.exports = function(a) {
        var l = [];
        return l.toString = function() {
          return this.map(function(d) {
            var h = "", u = d[5] !== void 0;
            return d[4] && (h += "@supports (".concat(d[4], ") {")), d[2] && (h += "@media ".concat(d[2], " {")), u && (h += "@layer".concat(d[5].length > 0 ? " ".concat(d[5]) : "", " {")), h += a(d), u && (h += "}"), d[2] && (h += "}"), d[4] && (h += "}"), h;
          }).join("");
        }, l.i = function(d, h, u, c, m) {
          typeof d == "string" && (d = [[null, d, void 0]]);
          var f = {};
          if (u)
            for (var p = 0; p < this.length; p++) {
              var A = this[p][0];
              A != null && (f[A] = !0);
            }
          for (var v = 0; v < d.length; v++) {
            var b = [].concat(d[v]);
            u && f[b[0]] || (m !== void 0 && (b[5] === void 0 || (b[1] = "@layer".concat(b[5].length > 0 ? " ".concat(b[5]) : "", " {").concat(b[1], "}")), b[5] = m), h && (b[2] && (b[1] = "@media ".concat(b[2], " {").concat(b[1], "}")), b[2] = h), c && (b[4] ? (b[1] = "@supports (".concat(b[4], ") {").concat(b[1], "}"), b[4] = c) : b[4] = "".concat(c)), l.push(b));
          }
        }, l;
      };
    }, 80: (s) => {
      s.exports = function(a, l) {
        return l || (l = {}), a && (a = String(a.__esModule ? a.default : a), /^['"].*['"]$/.test(a) && (a = a.slice(1, -1)), l.hash && (a += l.hash), /["'() \t\n]|(%20)/.test(a) || l.needQuotes ? '"'.concat(a.replace(/"/g, '\\"').replace(/\n/g, "\\n"), '"') : a);
      };
    }, 415: (s) => {
      s.exports = function(a) {
        var l = a[1], d = a[3];
        if (!d)
          return l;
        if (typeof btoa == "function") {
          var h = btoa(unescape(encodeURIComponent(JSON.stringify(d)))), u = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(h), c = "/*# ".concat(u, " */");
          return [l].concat([c]).join(`
`);
        }
        return [l].join(`
`);
      };
    }, 937: (s) => {
      function a(l) {
        return a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(d) {
          return typeof d;
        } : function(d) {
          return d && typeof Symbol == "function" && d.constructor === Symbol && d !== Symbol.prototype ? "symbol" : typeof d;
        }, a(l);
      }
      s.exports = (typeof self > "u" ? "undefined" : a(self)) == "object" ? self.FormData : window.FormData;
    }, 831: (s) => {
      s.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAADGCAYAAAAT+OqFAAAAdklEQVQoz42QQQ7AIAgEF/T/D+kbq/RWAlnQyyazA4aoAB4FsBSA/bFjuF1EOL7VbrIrBuusmrt4ZZORfb6ehbWdnRHEIiITaEUKa5EJqUakRSaEYBJSCY2dEstQY7AuxahwXFrvZmWl2rh4JZ07z9dLtesfNj5q0FU3A5ObbwAAAABJRU5ErkJggg==";
    } }, n = {};
    function r(s) {
      var a = n[s];
      if (a !== void 0)
        return a.exports;
      var l = n[s] = { id: s, exports: {} };
      return t[s](l, l.exports, r), l.exports;
    }
    r.m = t, r.n = (s) => {
      var a = s && s.__esModule ? () => s.default : () => s;
      return r.d(a, { a }), a;
    }, r.d = (s, a) => {
      for (var l in a)
        r.o(a, l) && !r.o(s, l) && Object.defineProperty(s, l, { enumerable: !0, get: a[l] });
    }, r.g = function() {
      if (typeof globalThis == "object")
        return globalThis;
      try {
        return this || new Function("return this")();
      } catch {
        if (typeof window == "object")
          return window;
      }
    }(), r.o = (s, a) => Object.prototype.hasOwnProperty.call(s, a), r.b = document.baseURI || self.location.href, r.nc = void 0;
    var i = {};
    return (() => {
      r.d(i, { default: () => vd });
      var s = r(856), a = r.n(s), l = r(470), d = r.n(l), h = r(370), u = r.n(h), c = r(458), m = r.n(c), f = r(278), p = r.n(f), A = r(488), v = r.n(A), b = r(685), _ = {};
      _.styleTagTransform = v(), _.setAttributes = m(), _.insert = u().bind(null, "head"), _.domAPI = d(), _.insertStyleElement = p(), a()(b.Z, _), b.Z && b.Z.locals && b.Z.locals;
      function T(y) {
        return T = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
          return typeof x;
        } : function(x) {
          return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
        }, T(y);
      }
      function E(y, x) {
        this.name = "AggregateError", this.errors = y, this.message = x || "";
      }
      E.prototype = Error.prototype;
      function L(y) {
        return L = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
          return typeof x;
        } : function(x) {
          return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
        }, L(y);
      }
      var k = setTimeout;
      function D(y) {
        return !!(y && y.length !== void 0);
      }
      function M() {
      }
      function O(y) {
        if (!(this instanceof O))
          throw new TypeError("Promises must be constructed via new");
        if (typeof y != "function")
          throw new TypeError("not a function");
        this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], z(y, this);
      }
      function N(y, x) {
        for (; y._state === 3; )
          y = y._value;
        y._state !== 0 ? (y._handled = !0, O._immediateFn(function() {
          var w = y._state === 1 ? x.onFulfilled : x.onRejected;
          if (w !== null) {
            var g;
            try {
              g = w(y._value);
            } catch (S) {
              return void U(x.promise, S);
            }
            B(x.promise, g);
          } else
            (y._state === 1 ? B : U)(x.promise, y._value);
        })) : y._deferreds.push(x);
      }
      function B(y, x) {
        try {
          if (x === y)
            throw new TypeError("A promise cannot be resolved with itself.");
          if (x && (L(x) === "object" || typeof x == "function")) {
            var w = x.then;
            if (x instanceof O)
              return y._state = 3, y._value = x, void G(y);
            if (typeof w == "function")
              return void z((g = w, S = x, function() {
                g.apply(S, arguments);
              }), y);
          }
          y._state = 1, y._value = x, G(y);
        } catch (C) {
          U(y, C);
        }
        var g, S;
      }
      function U(y, x) {
        y._state = 2, y._value = x, G(y);
      }
      function G(y) {
        y._state === 2 && y._deferreds.length === 0 && O._immediateFn(function() {
          y._handled || O._unhandledRejectionFn(y._value);
        });
        for (var x = 0, w = y._deferreds.length; x < w; x++)
          N(y, y._deferreds[x]);
        y._deferreds = null;
      }
      function Y(y, x, w) {
        this.onFulfilled = typeof y == "function" ? y : null, this.onRejected = typeof x == "function" ? x : null, this.promise = w;
      }
      function z(y, x) {
        var w = !1;
        try {
          y(function(g) {
            w || (w = !0, B(x, g));
          }, function(g) {
            w || (w = !0, U(x, g));
          });
        } catch (g) {
          if (w)
            return;
          w = !0, U(x, g);
        }
      }
      O.prototype.catch = function(y) {
        return this.then(null, y);
      }, O.prototype.then = function(y, x) {
        var w = new this.constructor(M);
        return N(this, new Y(y, x, w)), w;
      }, O.prototype.finally = function(y) {
        var x = this.constructor;
        return this.then(function(w) {
          return x.resolve(y()).then(function() {
            return w;
          });
        }, function(w) {
          return x.resolve(y()).then(function() {
            return x.reject(w);
          });
        });
      }, O.all = function(y) {
        return new O(function(x, w) {
          if (!D(y))
            return w(new TypeError("Promise.all accepts an array"));
          var g = Array.prototype.slice.call(y);
          if (g.length === 0)
            return x([]);
          var S = g.length;
          function C(P, F) {
            try {
              if (F && (L(F) === "object" || typeof F == "function")) {
                var H = F.then;
                if (typeof H == "function")
                  return void H.call(F, function(X) {
                    C(P, X);
                  }, w);
              }
              g[P] = F, --S == 0 && x(g);
            } catch (X) {
              w(X);
            }
          }
          for (var R = 0; R < g.length; R++)
            C(R, g[R]);
        });
      }, O.any = function(y) {
        var x = this;
        return new x(function(w, g) {
          if (!y || y.length === void 0)
            return g(new TypeError("Promise.any accepts an array"));
          var S = Array.prototype.slice.call(y);
          if (S.length === 0)
            return g();
          for (var C = [], R = 0; R < S.length; R++)
            try {
              x.resolve(S[R]).then(w).catch(function(P) {
                C.push(P), C.length === S.length && g(new E(C, "All promises were rejected"));
              });
            } catch (P) {
              g(P);
            }
        });
      }, O.allSettled = function(y) {
        return new this(function(x, w) {
          if (!y || y.length === void 0)
            return w(new TypeError(T(y) + " " + y + " is not iterable(cannot read property Symbol(Symbol.iterator))"));
          var g = Array.prototype.slice.call(y);
          if (g.length === 0)
            return x([]);
          var S = g.length;
          function C(P, F) {
            if (F && (T(F) === "object" || typeof F == "function")) {
              var H = F.then;
              if (typeof H == "function")
                return void H.call(F, function(X) {
                  C(P, X);
                }, function(X) {
                  g[P] = { status: "rejected", reason: X }, --S == 0 && x(g);
                });
            }
            g[P] = { status: "fulfilled", value: F }, --S == 0 && x(g);
          }
          for (var R = 0; R < g.length; R++)
            C(R, g[R]);
        });
      }, O.resolve = function(y) {
        return y && L(y) === "object" && y.constructor === O ? y : new O(function(x) {
          x(y);
        });
      }, O.reject = function(y) {
        return new O(function(x, w) {
          w(y);
        });
      }, O.race = function(y) {
        return new O(function(x, w) {
          if (!D(y))
            return w(new TypeError("Promise.race accepts an array"));
          for (var g = 0, S = y.length; g < S; g++)
            O.resolve(y[g]).then(x, w);
        });
      }, O._immediateFn = typeof setImmediate == "function" && function(y) {
        setImmediate(y);
      } || function(y) {
        k(y, 0);
      }, O._unhandledRejectionFn = function(y) {
        typeof console < "u" && console && console.warn("Possible Unhandled Promise Rejection:", y);
      };
      const J = O;
      var le = /mobile/i.test(window.navigator.userAgent);
      const W = { secondToTime: function(y) {
        if ((y = y || 0) === 0 || y === 1 / 0 || y.toString() === "NaN")
          return "00:00";
        var x = Math.floor(y / 3600), w = Math.floor((y - 3600 * x) / 60), g = Math.floor(y - 3600 * x - 60 * w);
        return (x > 0 ? [x, w, g] : [w, g]).map(function(S) {
          return S < 10 ? "0" + S : "" + S;
        }).join(":");
      }, getElementViewLeft: function(y) {
        var x = y.offsetLeft, w = y.offsetParent, g = document.body.scrollLeft + document.documentElement.scrollLeft;
        if (document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement)
          for (; w !== null && w !== y; )
            x += w.offsetLeft, w = w.offsetParent;
        else
          for (; w !== null; )
            x += w.offsetLeft, w = w.offsetParent;
        return x - g;
      }, getBoundingClientRectViewLeft: function(y) {
        var x = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);
        if (y.getBoundingClientRect) {
          if (typeof this.getBoundingClientRectViewLeft.offset != "number") {
            var w = document.createElement("div");
            w.style.cssText = "position:absolute;top:0;left:0;", document.body.appendChild(w), this.getBoundingClientRectViewLeft.offset = -w.getBoundingClientRect().top - x, document.body.removeChild(w), w = null;
          }
          var g = y.getBoundingClientRect(), S = this.getBoundingClientRectViewLeft.offset;
          return g.left + S;
        }
        return this.getElementViewLeft(y);
      }, getScrollPosition: function() {
        return { left: window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0, top: window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0 };
      }, setScrollPosition: function(y) {
        var x = y.left, w = x === void 0 ? 0 : x, g = y.top, S = g === void 0 ? 0 : g;
        this.isFirefox ? (document.documentElement.scrollLeft = w, document.documentElement.scrollTop = S) : window.scrollTo(w, S);
      }, isMobile: le, isFirefox: /firefox/i.test(window.navigator.userAgent), isChrome: /chrome/i.test(window.navigator.userAgent), isSafari: /safari/i.test(window.navigator.userAgent), storage: { set: function(y, x) {
        localStorage.setItem(y, x);
      }, get: function(y) {
        return localStorage.getItem(y);
      } }, nameMap: { dragStart: le ? "touchstart" : "mousedown", dragMove: le ? "touchmove" : "mousemove", dragEnd: le ? "touchend" : "mouseup" }, color2Number: function(y) {
        return y[0] === "#" && (y = y.substr(1)), y.length === 3 && (y = "".concat(y[0]).concat(y[0]).concat(y[1]).concat(y[1]).concat(y[2]).concat(y[2])), parseInt(y, 16) + 0 & 16777215;
      }, number2Color: function(y) {
        return "#" + ("00000" + y.toString(16)).slice(-6);
      }, number2Type: function(y) {
        switch (y) {
          case 0:
          default:
            return "right";
          case 1:
            return "top";
          case 2:
            return "bottom";
        }
      } };
      function Z(y, x) {
        return function() {
          return y.apply(x, arguments);
        };
      }
      function ce(y) {
        return ce = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
          return typeof x;
        } : function(x) {
          return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
        }, ce(y);
      }
      var ue, re = Object.prototype.toString, me = Object.getPrototypeOf, Be = (ue = /* @__PURE__ */ Object.create(null), function(y) {
        var x = re.call(y);
        return ue[x] || (ue[x] = x.slice(8, -1).toLowerCase());
      }), ye = function(y) {
        return y = y.toLowerCase(), function(x) {
          return Be(x) === y;
        };
      }, Le = function(y) {
        return function(x) {
          return ce(x) === y;
        };
      }, Pe = Array.isArray, Me = Le("undefined"), qe = ye("ArrayBuffer"), ft = Le("string"), De = Le("function"), ve = Le("number"), Je = function(y) {
        return y !== null && ce(y) === "object";
      }, Xe = function(y) {
        if (Be(y) !== "object")
          return !1;
        var x = me(y);
        return !(x !== null && x !== Object.prototype && Object.getPrototypeOf(x) !== null || Symbol.toStringTag in y || Symbol.iterator in y);
      }, Oe = ye("Date"), Ke = ye("File"), We = ye("Blob"), tt = ye("FileList"), et = ye("URLSearchParams");
      function ze(y, x) {
        var w, g, S = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, C = S.allOwnKeys, R = C !== void 0 && C;
        if (y != null)
          if (ce(y) !== "object" && (y = [y]), Pe(y))
            for (w = 0, g = y.length; w < g; w++)
              x.call(null, y[w], w, y);
          else {
            var P, F = R ? Object.getOwnPropertyNames(y) : Object.keys(y), H = F.length;
            for (w = 0; w < H; w++)
              P = F[w], x.call(null, y[P], P, y);
          }
      }
      function $e(y, x) {
        x = x.toLowerCase();
        for (var w, g = Object.keys(y), S = g.length; S-- > 0; )
          if (x === (w = g[S]).toLowerCase())
            return w;
        return null;
      }
      var gt, pt, Lt = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : Cd, Et = function(y) {
        return !Me(y) && y !== Lt;
      }, _t = (gt = typeof Uint8Array < "u" && me(Uint8Array), function(y) {
        return gt && y instanceof gt;
      }), nt = ye("HTMLFormElement"), Ot = (pt = Object.prototype.hasOwnProperty, function(y, x) {
        return pt.call(y, x);
      }), Q = ye("RegExp"), ne = function(y, x) {
        var w = Object.getOwnPropertyDescriptors(y), g = {};
        ze(w, function(S, C) {
          x(S, C, y) !== !1 && (g[C] = S);
        }), Object.defineProperties(y, g);
      };
      const K = { isArray: Pe, isArrayBuffer: qe, isBuffer: function(y) {
        return y !== null && !Me(y) && y.constructor !== null && !Me(y.constructor) && De(y.constructor.isBuffer) && y.constructor.isBuffer(y);
      }, isFormData: function(y) {
        var x = "[object FormData]";
        return y && (typeof FormData == "function" && y instanceof FormData || re.call(y) === x || De(y.toString) && y.toString() === x);
      }, isArrayBufferView: function(y) {
        return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(y) : y && y.buffer && qe(y.buffer);
      }, isString: ft, isNumber: ve, isBoolean: function(y) {
        return y === !0 || y === !1;
      }, isObject: Je, isPlainObject: Xe, isUndefined: Me, isDate: Oe, isFile: Ke, isBlob: We, isRegExp: Q, isFunction: De, isStream: function(y) {
        return Je(y) && De(y.pipe);
      }, isURLSearchParams: et, isTypedArray: _t, isFileList: tt, forEach: ze, merge: function y() {
        for (var x = Et(this) && this || {}, w = x.caseless, g = {}, S = function(P, F) {
          var H = w && $e(g, F) || F;
          Xe(g[H]) && Xe(P) ? g[H] = y(g[H], P) : Xe(P) ? g[H] = y({}, P) : Pe(P) ? g[H] = P.slice() : g[H] = P;
        }, C = 0, R = arguments.length; C < R; C++)
          arguments[C] && ze(arguments[C], S);
        return g;
      }, extend: function(y, x, w) {
        var g = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, S = g.allOwnKeys;
        return ze(x, function(C, R) {
          w && De(C) ? y[R] = Z(C, w) : y[R] = C;
        }, { allOwnKeys: S }), y;
      }, trim: function(y) {
        return y.trim ? y.trim() : y.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
      }, stripBOM: function(y) {
        return y.charCodeAt(0) === 65279 && (y = y.slice(1)), y;
      }, inherits: function(y, x, w, g) {
        y.prototype = Object.create(x.prototype, g), y.prototype.constructor = y, Object.defineProperty(y, "super", { value: x.prototype }), w && Object.assign(y.prototype, w);
      }, toFlatObject: function(y, x, w, g) {
        var S, C, R, P = {};
        if (x = x || {}, y == null)
          return x;
        do {
          for (C = (S = Object.getOwnPropertyNames(y)).length; C-- > 0; )
            R = S[C], g && !g(R, y, x) || P[R] || (x[R] = y[R], P[R] = !0);
          y = w !== !1 && me(y);
        } while (y && (!w || w(y, x)) && y !== Object.prototype);
        return x;
      }, kindOf: Be, kindOfTest: ye, endsWith: function(y, x, w) {
        y = String(y), (w === void 0 || w > y.length) && (w = y.length), w -= x.length;
        var g = y.indexOf(x, w);
        return g !== -1 && g === w;
      }, toArray: function(y) {
        if (!y)
          return null;
        if (Pe(y))
          return y;
        var x = y.length;
        if (!ve(x))
          return null;
        for (var w = new Array(x); x-- > 0; )
          w[x] = y[x];
        return w;
      }, forEachEntry: function(y, x) {
        for (var w, g = (y && y[Symbol.iterator]).call(y); (w = g.next()) && !w.done; ) {
          var S = w.value;
          x.call(y, S[0], S[1]);
        }
      }, matchAll: function(y, x) {
        for (var w, g = []; (w = y.exec(x)) !== null; )
          g.push(w);
        return g;
      }, isHTMLForm: nt, hasOwnProperty: Ot, hasOwnProp: Ot, reduceDescriptors: ne, freezeMethods: function(y) {
        ne(y, function(x, w) {
          if (De(y) && ["arguments", "caller", "callee"].indexOf(w) !== -1)
            return !1;
          var g = y[w];
          De(g) && (x.enumerable = !1, "writable" in x ? x.writable = !1 : x.set || (x.set = function() {
            throw Error("Can not rewrite read-only method '" + w + "'");
          }));
        });
      }, toObjectSet: function(y, x) {
        var w = {}, g = function(S) {
          S.forEach(function(C) {
            w[C] = !0;
          });
        };
        return Pe(y) ? g(y) : g(String(y).split(x)), w;
      }, toCamelCase: function(y) {
        return y.toLowerCase().replace(/[_-\s]([a-z\d])(\w*)/g, function(x, w, g) {
          return w.toUpperCase() + g;
        });
      }, noop: function() {
      }, toFiniteNumber: function(y, x) {
        return y = +y, Number.isFinite(y) ? y : x;
      }, findKey: $e, global: Lt, isContextDefined: Et, toJSONObject: function(y) {
        var x = new Array(10);
        return function w(g, S) {
          if (Je(g)) {
            if (x.indexOf(g) >= 0)
              return;
            if (!("toJSON" in g)) {
              x[S] = g;
              var C = Pe(g) ? [] : {};
              return ze(g, function(R, P) {
                var F = w(R, S + 1);
                !Me(F) && (C[P] = F);
              }), x[S] = void 0, C;
            }
          }
          return g;
        }(y, 0);
      } };
      function fe(y, x, w, g, S) {
        Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = y, this.name = "AxiosError", x && (this.code = x), w && (this.config = w), g && (this.request = g), S && (this.response = S);
      }
      K.inherits(fe, Error, { toJSON: function() {
        return { message: this.message, name: this.name, description: this.description, number: this.number, fileName: this.fileName, lineNumber: this.lineNumber, columnNumber: this.columnNumber, stack: this.stack, config: K.toJSONObject(this.config), code: this.code, status: this.response && this.response.status ? this.response.status : null };
      } });
      var Te = fe.prototype, we = {};
      ["ERR_BAD_OPTION_VALUE", "ERR_BAD_OPTION", "ECONNABORTED", "ETIMEDOUT", "ERR_NETWORK", "ERR_FR_TOO_MANY_REDIRECTS", "ERR_DEPRECATED", "ERR_BAD_RESPONSE", "ERR_BAD_REQUEST", "ERR_CANCELED", "ERR_NOT_SUPPORT", "ERR_INVALID_URL"].forEach(function(y) {
        we[y] = { value: y };
      }), Object.defineProperties(fe, we), Object.defineProperty(Te, "isAxiosError", { value: !0 }), fe.from = function(y, x, w, g, S, C) {
        var R = Object.create(Te);
        return K.toFlatObject(y, R, function(P) {
          return P !== Error.prototype;
        }, function(P) {
          return P !== "isAxiosError";
        }), fe.call(R, y.message, x, w, g, S), R.cause = y, R.name = y.name, C && Object.assign(R, C), R;
      };
      const Ee = fe, Bt = r(937);
      function Pt(y) {
        return Pt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
          return typeof x;
        } : function(x) {
          return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
        }, Pt(y);
      }
      function wt(y) {
        return K.isPlainObject(y) || K.isArray(y);
      }
      function Gt(y) {
        return K.endsWith(y, "[]") ? y.slice(0, -2) : y;
      }
      function Kt(y, x, w) {
        return y ? y.concat(x).map(function(g, S) {
          return g = Gt(g), !w && S ? "[" + g + "]" : g;
        }).join(w ? "." : "") : x;
      }
      var Tn = K.toFlatObject(K, {}, null, function(y) {
        return /^is[A-Z]/.test(y);
      });
      const Yt = function(y, x, w) {
        if (!K.isObject(y))
          throw new TypeError("target must be an object");
        x = x || new (Bt || FormData)();
        var g, S = (w = K.toFlatObject(w, { metaTokens: !0, dots: !1, indexes: !1 }, !1, function(he, de) {
          return !K.isUndefined(de[he]);
        })).metaTokens, C = w.visitor || X, R = w.dots, P = w.indexes, F = (w.Blob || typeof Blob < "u" && Blob) && (g = x) && K.isFunction(g.append) && g[Symbol.toStringTag] === "FormData" && g[Symbol.iterator];
        if (!K.isFunction(C))
          throw new TypeError("visitor must be a function");
        function H(he) {
          if (he === null)
            return "";
          if (K.isDate(he))
            return he.toISOString();
          if (!F && K.isBlob(he))
            throw new Ee("Blob is not supported. Use a Buffer instead.");
          return K.isArrayBuffer(he) || K.isTypedArray(he) ? F && typeof Blob == "function" ? new Blob([he]) : Buffer.from(he) : he;
        }
        function X(he, de, se) {
          var pe = he;
          if (he && !se && Pt(he) === "object") {
            if (K.endsWith(de, "{}"))
              de = S ? de : de.slice(0, -2), he = JSON.stringify(he);
            else if (K.isArray(he) && function(_e) {
              return K.isArray(_e) && !_e.some(wt);
            }(he) || K.isFileList(he) || K.endsWith(de, "[]") && (pe = K.toArray(he)))
              return de = Gt(de), pe.forEach(function(_e, at) {
                !K.isUndefined(_e) && _e !== null && x.append(P === !0 ? Kt([de], at, R) : P === null ? de : de + "[]", H(_e));
              }), !1;
          }
          return !!wt(he) || (x.append(Kt(se, de, R), H(he)), !1);
        }
        var ie = [], oe = Object.assign(Tn, { defaultVisitor: X, convertValue: H, isVisitable: wt });
        if (!K.isObject(y))
          throw new TypeError("data must be an object");
        return function he(de, se) {
          if (!K.isUndefined(de)) {
            if (ie.indexOf(de) !== -1)
              throw Error("Circular reference detected in " + se.join("."));
            ie.push(de), K.forEach(de, function(pe, _e) {
              (!(K.isUndefined(pe) || pe === null) && C.call(x, pe, K.isString(_e) ? _e.trim() : _e, se, oe)) === !0 && he(pe, se ? se.concat(_e) : [_e]);
            }), ie.pop();
          }
        }(y), x;
      };
      function Cn(y) {
        var x = { "!": "%21", "'": "%27", "(": "%28", ")": "%29", "~": "%7E", "%20": "+", "%00": "\0" };
        return encodeURIComponent(y).replace(/[!'()~]|%20|%00/g, function(w) {
          return x[w];
        });
      }
      function ar(y, x) {
        this._pairs = [], y && Yt(y, this, x);
      }
      var Ln = ar.prototype;
      Ln.append = function(y, x) {
        this._pairs.push([y, x]);
      }, Ln.toString = function(y) {
        var x = y ? function(w) {
          return y.call(this, w, Cn);
        } : Cn;
        return this._pairs.map(function(w) {
          return x(w[0]) + "=" + x(w[1]);
        }, "").join("&");
      };
      const or = ar;
      function lr(y) {
        return encodeURIComponent(y).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
      }
      function wn(y, x, w) {
        if (!x)
          return y;
        var g, S = w && w.encode || lr, C = w && w.serialize;
        if (g = C ? C(x, w) : K.isURLSearchParams(x) ? x.toString() : new or(x, w).toString(S)) {
          var R = y.indexOf("#");
          R !== -1 && (y = y.slice(0, R)), y += (y.indexOf("?") === -1 ? "?" : "&") + g;
        }
        return y;
      }
      function rn(y) {
        return rn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
          return typeof x;
        } : function(x) {
          return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
        }, rn(y);
      }
      function Kr(y, x) {
        for (var w = 0; w < x.length; w++) {
          var g = x[w];
          g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(y, (S = function(C, R) {
            if (rn(C) !== "object" || C === null)
              return C;
            var P = C[Symbol.toPrimitive];
            if (P !== void 0) {
              var F = P.call(C, "string");
              if (rn(F) !== "object")
                return F;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(C);
          }(g.key), rn(S) === "symbol" ? S : String(S)), g);
        }
        var S;
      }
      var dr = function() {
        function y() {
          (function(g, S) {
            if (!(g instanceof S))
              throw new TypeError("Cannot call a class as a function");
          })(this, y), this.handlers = [];
        }
        var x, w;
        return x = y, w = [{ key: "use", value: function(g, S, C) {
          return this.handlers.push({ fulfilled: g, rejected: S, synchronous: !!C && C.synchronous, runWhen: C ? C.runWhen : null }), this.handlers.length - 1;
        } }, { key: "eject", value: function(g) {
          this.handlers[g] && (this.handlers[g] = null);
        } }, { key: "clear", value: function() {
          this.handlers && (this.handlers = []);
        } }, { key: "forEach", value: function(g) {
          K.forEach(this.handlers, function(S) {
            S !== null && g(S);
          });
        } }], w && Kr(x.prototype, w), Object.defineProperty(x, "prototype", { writable: !1 }), y;
      }();
      const cr = dr, ur = { silentJSONParsing: !0, forcedJSONParsing: !0, clarifyTimeoutError: !1 }, $r = typeof URLSearchParams < "u" ? URLSearchParams : or, Vr = FormData;
      var j, te = (typeof navigator > "u" || (j = navigator.product) !== "ReactNative" && j !== "NativeScript" && j !== "NS") && typeof window < "u" && typeof document < "u", ae = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function";
      const Ae = { isBrowser: !0, classes: { URLSearchParams: $r, FormData: Vr, Blob }, isStandardBrowserEnv: te, isStandardBrowserWebWorkerEnv: ae, protocols: ["http", "https", "file", "blob", "url", "data"] }, Fe = function(y) {
        function x(g, S, C, R) {
          var P = g[R++], F = Number.isFinite(+P), H = R >= g.length;
          return P = !P && K.isArray(C) ? C.length : P, H ? (K.hasOwnProp(C, P) ? C[P] = [C[P], S] : C[P] = S, !F) : (C[P] && K.isObject(C[P]) || (C[P] = []), x(g, S, C[P], R) && K.isArray(C[P]) && (C[P] = function(X) {
            var ie, oe, he = {}, de = Object.keys(X), se = de.length;
            for (ie = 0; ie < se; ie++)
              he[oe = de[ie]] = X[oe];
            return he;
          }(C[P])), !F);
        }
        if (K.isFormData(y) && K.isFunction(y.entries)) {
          var w = {};
          return K.forEachEntry(y, function(g, S) {
            x(function(C) {
              return K.matchAll(/\w+|\[(\w*)]/g, C).map(function(R) {
                return R[0] === "[]" ? "" : R[1] || R[0];
              });
            }(g), S, w, 0);
          }), w;
        }
        return null;
      };
      var Ne = { "Content-Type": void 0 }, ke = { transitional: ur, adapter: ["xhr", "http"], transformRequest: [function(y, x) {
        var w, g = x.getContentType() || "", S = g.indexOf("application/json") > -1, C = K.isObject(y);
        if (C && K.isHTMLForm(y) && (y = new FormData(y)), K.isFormData(y))
          return S && S ? JSON.stringify(Fe(y)) : y;
        if (K.isArrayBuffer(y) || K.isBuffer(y) || K.isStream(y) || K.isFile(y) || K.isBlob(y))
          return y;
        if (K.isArrayBufferView(y))
          return y.buffer;
        if (K.isURLSearchParams(y))
          return x.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), y.toString();
        if (C) {
          if (g.indexOf("application/x-www-form-urlencoded") > -1)
            return function(P, F) {
              return Yt(P, new Ae.classes.URLSearchParams(), Object.assign({ visitor: function(H, X, ie, oe) {
                return Ae.isNode && K.isBuffer(H) ? (this.append(X, H.toString("base64")), !1) : oe.defaultVisitor.apply(this, arguments);
              } }, F));
            }(y, this.formSerializer).toString();
          if ((w = K.isFileList(y)) || g.indexOf("multipart/form-data") > -1) {
            var R = this.env && this.env.FormData;
            return Yt(w ? { "files[]": y } : y, R && new R(), this.formSerializer);
          }
        }
        return C || S ? (x.setContentType("application/json", !1), function(P, F, H) {
          if (K.isString(P))
            try {
              return (0, JSON.parse)(P), K.trim(P);
            } catch (X) {
              if (X.name !== "SyntaxError")
                throw X;
            }
          return (0, JSON.stringify)(P);
        }(y)) : y;
      }], transformResponse: [function(y) {
        var x = this.transitional || ke.transitional, w = x && x.forcedJSONParsing, g = this.responseType === "json";
        if (y && K.isString(y) && (w && !this.responseType || g)) {
          var S = !(x && x.silentJSONParsing) && g;
          try {
            return JSON.parse(y);
          } catch (C) {
            if (S)
              throw C.name === "SyntaxError" ? Ee.from(C, Ee.ERR_BAD_RESPONSE, this, null, this.response) : C;
          }
        }
        return y;
      }], timeout: 0, xsrfCookieName: "XSRF-TOKEN", xsrfHeaderName: "X-XSRF-TOKEN", maxContentLength: -1, maxBodyLength: -1, env: { FormData: Ae.classes.FormData, Blob: Ae.classes.Blob }, validateStatus: function(y) {
        return y >= 200 && y < 300;
      }, headers: { common: { Accept: "application/json, text/plain, */*" } } };
      K.forEach(["delete", "get", "head"], function(y) {
        ke.headers[y] = {};
      }), K.forEach(["post", "put", "patch"], function(y) {
        ke.headers[y] = K.merge(Ne);
      });
      const Ie = ke;
      var ct = K.toObjectSet(["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"]);
      function Ve(y) {
        return Ve = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
          return typeof x;
        } : function(x) {
          return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
        }, Ve(y);
      }
      function Qe(y, x) {
        (x == null || x > y.length) && (x = y.length);
        for (var w = 0, g = new Array(x); w < x; w++)
          g[w] = y[w];
        return g;
      }
      function mt(y, x) {
        for (var w = 0; w < x.length; w++) {
          var g = x[w];
          g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(y, (S = function(C, R) {
            if (Ve(C) !== "object" || C === null)
              return C;
            var P = C[Symbol.toPrimitive];
            if (P !== void 0) {
              var F = P.call(C, "string");
              if (Ve(F) !== "object")
                return F;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(C);
          }(g.key), Ve(S) === "symbol" ? S : String(S)), g);
        }
        var S;
      }
      var $t = Symbol("internals");
      function qt(y) {
        return y && String(y).trim().toLowerCase();
      }
      function yt(y) {
        return y === !1 || y == null ? y : K.isArray(y) ? y.map(yt) : String(y);
      }
      function ns(y, x, w, g) {
        return K.isFunction(g) ? g.call(this, x, w) : K.isString(x) ? K.isString(g) ? x.indexOf(g) !== -1 : K.isRegExp(g) ? g.test(x) : void 0 : void 0;
      }
      var hr = function(y, x) {
        function w(R) {
          (function(P, F) {
            if (!(P instanceof F))
              throw new TypeError("Cannot call a class as a function");
          })(this, w), R && this.set(R);
        }
        var g, S, C;
        return g = w, S = [{ key: "set", value: function(R, P, F) {
          var H = this;
          function X(_e, at, rt) {
            var je = qt(at);
            if (!je)
              throw new Error("header name must be a non-empty string");
            var Zt = K.findKey(H, je);
            (!Zt || H[Zt] === void 0 || rt === !0 || rt === void 0 && H[Zt] !== !1) && (H[Zt || at] = yt(_e));
          }
          var ie, oe, he, de, se, pe = function(_e, at) {
            return K.forEach(_e, function(rt, je) {
              return X(rt, je, at);
            });
          };
          return K.isPlainObject(R) || R instanceof this.constructor ? pe(R, P) : K.isString(R) && (R = R.trim()) && !/^[-_a-zA-Z]+$/.test(R.trim()) ? pe((se = {}, (ie = R) && ie.split(`
`).forEach(function(_e) {
            de = _e.indexOf(":"), oe = _e.substring(0, de).trim().toLowerCase(), he = _e.substring(de + 1).trim(), !oe || se[oe] && ct[oe] || (oe === "set-cookie" ? se[oe] ? se[oe].push(he) : se[oe] = [he] : se[oe] = se[oe] ? se[oe] + ", " + he : he);
          }), se), P) : R != null && X(P, R, F), this;
        } }, { key: "get", value: function(R, P) {
          if (R = qt(R)) {
            var F = K.findKey(this, R);
            if (F) {
              var H = this[F];
              if (!P)
                return H;
              if (P === !0)
                return function(X) {
                  for (var ie, oe = /* @__PURE__ */ Object.create(null), he = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g; ie = he.exec(X); )
                    oe[ie[1]] = ie[2];
                  return oe;
                }(H);
              if (K.isFunction(P))
                return P.call(this, H, F);
              if (K.isRegExp(P))
                return P.exec(H);
              throw new TypeError("parser must be boolean|regexp|function");
            }
          }
        } }, { key: "has", value: function(R, P) {
          if (R = qt(R)) {
            var F = K.findKey(this, R);
            return !(!F || P && !ns(0, this[F], F, P));
          }
          return !1;
        } }, { key: "delete", value: function(R, P) {
          var F = this, H = !1;
          function X(ie) {
            if (ie = qt(ie)) {
              var oe = K.findKey(F, ie);
              !oe || P && !ns(0, F[oe], oe, P) || (delete F[oe], H = !0);
            }
          }
          return K.isArray(R) ? R.forEach(X) : X(R), H;
        } }, { key: "clear", value: function() {
          return Object.keys(this).forEach(this.delete.bind(this));
        } }, { key: "normalize", value: function(R) {
          var P = this, F = {};
          return K.forEach(this, function(H, X) {
            var ie = K.findKey(F, X);
            if (ie)
              return P[ie] = yt(H), void delete P[X];
            var oe = R ? function(he) {
              return he.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, function(de, se, pe) {
                return se.toUpperCase() + pe;
              });
            }(X) : String(X).trim();
            oe !== X && delete P[X], P[oe] = yt(H), F[oe] = !0;
          }), this;
        } }, { key: "concat", value: function() {
          for (var R, P = arguments.length, F = new Array(P), H = 0; H < P; H++)
            F[H] = arguments[H];
          return (R = this.constructor).concat.apply(R, [this].concat(F));
        } }, { key: "toJSON", value: function(R) {
          var P = /* @__PURE__ */ Object.create(null);
          return K.forEach(this, function(F, H) {
            F != null && F !== !1 && (P[H] = R && K.isArray(F) ? F.join(", ") : F);
          }), P;
        } }, { key: Symbol.iterator, value: function() {
          return Object.entries(this.toJSON())[Symbol.iterator]();
        } }, { key: "toString", value: function() {
          return Object.entries(this.toJSON()).map(function(R) {
            var P, F, H = (F = 2, function(X) {
              if (Array.isArray(X))
                return X;
            }(P = R) || function(X, ie) {
              var oe = X == null ? null : typeof Symbol < "u" && X[Symbol.iterator] || X["@@iterator"];
              if (oe != null) {
                var he, de, se, pe, _e = [], at = !0, rt = !1;
                try {
                  if (se = (oe = oe.call(X)).next, ie === 0) {
                    if (Object(oe) !== oe)
                      return;
                    at = !1;
                  } else
                    for (; !(at = (he = se.call(oe)).done) && (_e.push(he.value), _e.length !== ie); at = !0)
                      ;
                } catch (je) {
                  rt = !0, de = je;
                } finally {
                  try {
                    if (!at && oe.return != null && (pe = oe.return(), Object(pe) !== pe))
                      return;
                  } finally {
                    if (rt)
                      throw de;
                  }
                }
                return _e;
              }
            }(P, F) || function(X, ie) {
              if (X) {
                if (typeof X == "string")
                  return Qe(X, ie);
                var oe = Object.prototype.toString.call(X).slice(8, -1);
                return oe === "Object" && X.constructor && (oe = X.constructor.name), oe === "Map" || oe === "Set" ? Array.from(X) : oe === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(oe) ? Qe(X, ie) : void 0;
              }
            }(P, F) || function() {
              throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }());
            return H[0] + ": " + H[1];
          }).join(`
`);
        } }, { key: Symbol.toStringTag, get: function() {
          return "AxiosHeaders";
        } }], C = [{ key: "from", value: function(R) {
          return R instanceof this ? R : new this(R);
        } }, { key: "concat", value: function(R) {
          for (var P = new this(R), F = arguments.length, H = new Array(F > 1 ? F - 1 : 0), X = 1; X < F; X++)
            H[X - 1] = arguments[X];
          return H.forEach(function(ie) {
            return P.set(ie);
          }), P;
        } }, { key: "accessor", value: function(R) {
          var P = (this[$t] = this[$t] = { accessors: {} }).accessors, F = this.prototype;
          function H(X) {
            var ie = qt(X);
            P[ie] || (function(oe, he) {
              var de = K.toCamelCase(" " + he);
              ["get", "set", "has"].forEach(function(se) {
                Object.defineProperty(oe, se + de, { value: function(pe, _e, at) {
                  return this[se].call(this, he, pe, _e, at);
                }, configurable: !0 });
              });
            }(F, X), P[ie] = !0);
          }
          return K.isArray(R) ? R.forEach(H) : H(R), this;
        } }], S && mt(g.prototype, S), C && mt(g, C), Object.defineProperty(g, "prototype", { writable: !1 }), w;
      }();
      hr.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent"]), K.freezeMethods(hr.prototype), K.freezeMethods(hr);
      const Vt = hr;
      function Wr(y, x) {
        var w = this || Ie, g = x || w, S = Vt.from(g.headers), C = g.data;
        return K.forEach(y, function(R) {
          C = R.call(w, C, S.normalize(), x ? x.status : void 0);
        }), S.normalize(), C;
      }
      function rs(y) {
        return !(!y || !y.__CANCEL__);
      }
      function is(y, x, w) {
        Ee.call(this, y ?? "canceled", Ee.ERR_CANCELED, x, w), this.name = "CanceledError";
      }
      K.inherits(is, Ee, { __CANCEL__: !0 });
      const fr = is, Ro = Ae.isStandardBrowserEnv ? { write: function(y, x, w, g, S, C) {
        var R = [];
        R.push(y + "=" + encodeURIComponent(x)), K.isNumber(w) && R.push("expires=" + new Date(w).toGMTString()), K.isString(g) && R.push("path=" + g), K.isString(S) && R.push("domain=" + S), C === !0 && R.push("secure"), document.cookie = R.join("; ");
      }, read: function(y) {
        var x = document.cookie.match(new RegExp("(^|;\\s*)(" + y + ")=([^;]*)"));
        return x ? decodeURIComponent(x[3]) : null;
      }, remove: function(y) {
        this.write(y, "", Date.now() - 864e5);
      } } : { write: function() {
      }, read: function() {
        return null;
      }, remove: function() {
      } };
      function ss(y, x) {
        return y && !/^([a-z][a-z\d+\-.]*:)?\/\//i.test(x) ? function(w, g) {
          return g ? w.replace(/\/+$/, "") + "/" + g.replace(/^\/+/, "") : w;
        }(y, x) : x;
      }
      const Io = Ae.isStandardBrowserEnv ? function() {
        var y, x = /(msie|trident)/i.test(navigator.userAgent), w = document.createElement("a");
        function g(S) {
          var C = S;
          return x && (w.setAttribute("href", C), C = w.href), w.setAttribute("href", C), { href: w.href, protocol: w.protocol ? w.protocol.replace(/:$/, "") : "", host: w.host, search: w.search ? w.search.replace(/^\?/, "") : "", hash: w.hash ? w.hash.replace(/^#/, "") : "", hostname: w.hostname, port: w.port, pathname: w.pathname.charAt(0) === "/" ? w.pathname : "/" + w.pathname };
        }
        return y = g(window.location.href), function(S) {
          var C = K.isString(S) ? g(S) : S;
          return C.protocol === y.protocol && C.host === y.host;
        };
      }() : function() {
        return !0;
      };
      function as(y, x) {
        var w = 0, g = function(S, C) {
          S = S || 10;
          var R, P = new Array(S), F = new Array(S), H = 0, X = 0;
          return C = C !== void 0 ? C : 1e3, function(ie) {
            var oe = Date.now(), he = F[X];
            R || (R = oe), P[H] = ie, F[H] = oe;
            for (var de = X, se = 0; de !== H; )
              se += P[de++], de %= S;
            if ((H = (H + 1) % S) === X && (X = (X + 1) % S), !(oe - R < C)) {
              var pe = he && oe - he;
              return pe ? Math.round(1e3 * se / pe) : void 0;
            }
          };
        }(50, 250);
        return function(S) {
          var C = S.loaded, R = S.lengthComputable ? S.total : void 0, P = C - w, F = g(P);
          w = C;
          var H = { loaded: C, total: R, progress: R ? C / R : void 0, bytes: P, rate: F || void 0, estimated: F && R && C <= R ? (R - C) / F : void 0, event: S };
          H[x ? "download" : "upload"] = !0, y(H);
        };
      }
      var Hr = { http: null, xhr: typeof XMLHttpRequest < "u" && function(y) {
        return new Promise(function(x, w) {
          var g, S = y.data, C = Vt.from(y.headers).normalize(), R = y.responseType;
          function P() {
            y.cancelToken && y.cancelToken.unsubscribe(g), y.signal && y.signal.removeEventListener("abort", g);
          }
          K.isFormData(S) && (Ae.isStandardBrowserEnv || Ae.isStandardBrowserWebWorkerEnv) && C.setContentType(!1);
          var F = new XMLHttpRequest();
          if (y.auth) {
            var H = y.auth.username || "", X = y.auth.password ? unescape(encodeURIComponent(y.auth.password)) : "";
            C.set("Authorization", "Basic " + btoa(H + ":" + X));
          }
          var ie = ss(y.baseURL, y.url);
          function oe() {
            if (F) {
              var pe = Vt.from("getAllResponseHeaders" in F && F.getAllResponseHeaders());
              (function(_e, at, rt) {
                var je = rt.config.validateStatus;
                rt.status && je && !je(rt.status) ? at(new Ee("Request failed with status code " + rt.status, [Ee.ERR_BAD_REQUEST, Ee.ERR_BAD_RESPONSE][Math.floor(rt.status / 100) - 4], rt.config, rt.request, rt)) : _e(rt);
              })(function(_e) {
                x(_e), P();
              }, function(_e) {
                w(_e), P();
              }, { data: R && R !== "text" && R !== "json" ? F.response : F.responseText, status: F.status, statusText: F.statusText, headers: pe, config: y, request: F }), F = null;
            }
          }
          if (F.open(y.method.toUpperCase(), wn(ie, y.params, y.paramsSerializer), !0), F.timeout = y.timeout, "onloadend" in F ? F.onloadend = oe : F.onreadystatechange = function() {
            F && F.readyState === 4 && (F.status !== 0 || F.responseURL && F.responseURL.indexOf("file:") === 0) && setTimeout(oe);
          }, F.onabort = function() {
            F && (w(new Ee("Request aborted", Ee.ECONNABORTED, y, F)), F = null);
          }, F.onerror = function() {
            w(new Ee("Network Error", Ee.ERR_NETWORK, y, F)), F = null;
          }, F.ontimeout = function() {
            var pe = y.timeout ? "timeout of " + y.timeout + "ms exceeded" : "timeout exceeded", _e = y.transitional || ur;
            y.timeoutErrorMessage && (pe = y.timeoutErrorMessage), w(new Ee(pe, _e.clarifyTimeoutError ? Ee.ETIMEDOUT : Ee.ECONNABORTED, y, F)), F = null;
          }, Ae.isStandardBrowserEnv) {
            var he = (y.withCredentials || Io(ie)) && y.xsrfCookieName && Ro.read(y.xsrfCookieName);
            he && C.set(y.xsrfHeaderName, he);
          }
          S === void 0 && C.setContentType(null), "setRequestHeader" in F && K.forEach(C.toJSON(), function(pe, _e) {
            F.setRequestHeader(_e, pe);
          }), K.isUndefined(y.withCredentials) || (F.withCredentials = !!y.withCredentials), R && R !== "json" && (F.responseType = y.responseType), typeof y.onDownloadProgress == "function" && F.addEventListener("progress", as(y.onDownloadProgress, !0)), typeof y.onUploadProgress == "function" && F.upload && F.upload.addEventListener("progress", as(y.onUploadProgress)), (y.cancelToken || y.signal) && (g = function(pe) {
            F && (w(!pe || pe.type ? new fr(null, y, F) : pe), F.abort(), F = null);
          }, y.cancelToken && y.cancelToken.subscribe(g), y.signal && (y.signal.aborted ? g() : y.signal.addEventListener("abort", g)));
          var de, se = (de = /^([-+\w]{1,25})(:?\/\/|:)/.exec(ie)) && de[1] || "";
          se && Ae.protocols.indexOf(se) === -1 ? w(new Ee("Unsupported protocol " + se + ":", Ee.ERR_BAD_REQUEST, y)) : F.send(S || null);
        });
      } };
      K.forEach(Hr, function(y, x) {
        if (y) {
          try {
            Object.defineProperty(y, "name", { value: x });
          } catch {
          }
          Object.defineProperty(y, "adapterName", { value: x });
        }
      });
      function zr(y) {
        if (y.cancelToken && y.cancelToken.throwIfRequested(), y.signal && y.signal.aborted)
          throw new fr(null, y);
      }
      function os(y) {
        return zr(y), y.headers = Vt.from(y.headers), y.data = Wr.call(y, y.transformRequest), ["post", "put", "patch"].indexOf(y.method) !== -1 && y.headers.setContentType("application/x-www-form-urlencoded", !1), function(x) {
          for (var w, g, S = (x = K.isArray(x) ? x : [x]).length, C = 0; C < S && (w = x[C], !(g = K.isString(w) ? Hr[w.toLowerCase()] : w)); C++)
            ;
          if (!g)
            throw g === !1 ? new Ee("Adapter ".concat(w, " is not supported by the environment"), "ERR_NOT_SUPPORT") : new Error(K.hasOwnProp(Hr, w) ? "Adapter '".concat(w, "' is not available in the build") : "Unknown adapter '".concat(w, "'"));
          if (!K.isFunction(g))
            throw new TypeError("adapter is not a function");
          return g;
        }(y.adapter || Ie.adapter)(y).then(function(x) {
          return zr(y), x.data = Wr.call(y, y.transformResponse, x), x.headers = Vt.from(x.headers), x;
        }, function(x) {
          return rs(x) || (zr(y), x && x.response && (x.response.data = Wr.call(y, y.transformResponse, x.response), x.response.headers = Vt.from(x.response.headers))), Promise.reject(x);
        });
      }
      var ls = function(y) {
        return y instanceof Vt ? y.toJSON() : y;
      };
      function fn(y, x) {
        x = x || {};
        var w = {};
        function g(H, X, ie) {
          return K.isPlainObject(H) && K.isPlainObject(X) ? K.merge.call({ caseless: ie }, H, X) : K.isPlainObject(X) ? K.merge({}, X) : K.isArray(X) ? X.slice() : X;
        }
        function S(H, X, ie) {
          return K.isUndefined(X) ? K.isUndefined(H) ? void 0 : g(void 0, H, ie) : g(H, X, ie);
        }
        function C(H, X) {
          if (!K.isUndefined(X))
            return g(void 0, X);
        }
        function R(H, X) {
          return K.isUndefined(X) ? K.isUndefined(H) ? void 0 : g(void 0, H) : g(void 0, X);
        }
        function P(H, X, ie) {
          return ie in x ? g(H, X) : ie in y ? g(void 0, H) : void 0;
        }
        var F = { url: C, method: C, data: C, baseURL: R, transformRequest: R, transformResponse: R, paramsSerializer: R, timeout: R, timeoutMessage: R, withCredentials: R, adapter: R, responseType: R, xsrfCookieName: R, xsrfHeaderName: R, onUploadProgress: R, onDownloadProgress: R, decompress: R, maxContentLength: R, maxBodyLength: R, beforeRedirect: R, transport: R, httpAgent: R, httpsAgent: R, cancelToken: R, socketPath: R, responseEncoding: R, validateStatus: P, headers: function(H, X) {
          return S(ls(H), ls(X), !0);
        } };
        return K.forEach(Object.keys(y).concat(Object.keys(x)), function(H) {
          var X = F[H] || S, ie = X(y[H], x[H], H);
          K.isUndefined(ie) && X !== P || (w[H] = ie);
        }), w;
      }
      function pr(y) {
        return pr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
          return typeof x;
        } : function(x) {
          return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
        }, pr(y);
      }
      var Yr = {};
      ["object", "boolean", "number", "function", "string", "symbol"].forEach(function(y, x) {
        Yr[y] = function(w) {
          return pr(w) === y || "a" + (x < 1 ? "n " : " ") + y;
        };
      });
      var ds = {};
      Yr.transitional = function(y, x, w) {
        function g(S, C) {
          return "[Axios v1.2.3] Transitional option '" + S + "'" + C + (w ? ". " + w : "");
        }
        return function(S, C, R) {
          if (y === !1)
            throw new Ee(g(C, " has been removed" + (x ? " in " + x : "")), Ee.ERR_DEPRECATED);
          return x && !ds[C] && (ds[C] = !0, console.warn(g(C, " has been deprecated since v" + x + " and will be removed in the near future"))), !y || y(S, C, R);
        };
      };
      const qr = { assertOptions: function(y, x, w) {
        if (pr(y) !== "object")
          throw new Ee("options must be an object", Ee.ERR_BAD_OPTION_VALUE);
        for (var g = Object.keys(y), S = g.length; S-- > 0; ) {
          var C = g[S], R = x[C];
          if (R) {
            var P = y[C], F = P === void 0 || R(P, C, y);
            if (F !== !0)
              throw new Ee("option " + C + " must be " + F, Ee.ERR_BAD_OPTION_VALUE);
          } else if (w !== !0)
            throw new Ee("Unknown option " + C, Ee.ERR_BAD_OPTION);
        }
      }, validators: Yr };
      function Rn(y) {
        return Rn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
          return typeof x;
        } : function(x) {
          return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
        }, Rn(y);
      }
      function ko(y, x) {
        for (var w = 0; w < x.length; w++) {
          var g = x[w];
          g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(y, (S = function(C, R) {
            if (Rn(C) !== "object" || C === null)
              return C;
            var P = C[Symbol.toPrimitive];
            if (P !== void 0) {
              var F = P.call(C, "string");
              if (Rn(F) !== "object")
                return F;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(C);
          }(g.key), Rn(S) === "symbol" ? S : String(S)), g);
        }
        var S;
      }
      var Xt = qr.validators, mr = function() {
        function y(g) {
          (function(S, C) {
            if (!(S instanceof C))
              throw new TypeError("Cannot call a class as a function");
          })(this, y), this.defaults = g, this.interceptors = { request: new cr(), response: new cr() };
        }
        var x, w;
        return x = y, (w = [{ key: "request", value: function(g, S) {
          typeof g == "string" ? (S = S || {}).url = g : S = g || {};
          var C, R = S = fn(this.defaults, S), P = R.transitional, F = R.paramsSerializer, H = R.headers;
          P !== void 0 && qr.assertOptions(P, { silentJSONParsing: Xt.transitional(Xt.boolean), forcedJSONParsing: Xt.transitional(Xt.boolean), clarifyTimeoutError: Xt.transitional(Xt.boolean) }, !1), F !== void 0 && qr.assertOptions(F, { encode: Xt.function, serialize: Xt.function }, !0), S.method = (S.method || this.defaults.method || "get").toLowerCase(), (C = H && K.merge(H.common, H[S.method])) && K.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function(je) {
            delete H[je];
          }), S.headers = Vt.concat(C, H);
          var X = [], ie = !0;
          this.interceptors.request.forEach(function(je) {
            typeof je.runWhen == "function" && je.runWhen(S) === !1 || (ie = ie && je.synchronous, X.unshift(je.fulfilled, je.rejected));
          });
          var oe, he = [];
          this.interceptors.response.forEach(function(je) {
            he.push(je.fulfilled, je.rejected);
          });
          var de, se = 0;
          if (!ie) {
            var pe = [os.bind(this), void 0];
            for (pe.unshift.apply(pe, X), pe.push.apply(pe, he), de = pe.length, oe = Promise.resolve(S); se < de; )
              oe = oe.then(pe[se++], pe[se++]);
            return oe;
          }
          de = X.length;
          var _e = S;
          for (se = 0; se < de; ) {
            var at = X[se++], rt = X[se++];
            try {
              _e = at(_e);
            } catch (je) {
              rt.call(this, je);
              break;
            }
          }
          try {
            oe = os.call(this, _e);
          } catch (je) {
            return Promise.reject(je);
          }
          for (se = 0, de = he.length; se < de; )
            oe = oe.then(he[se++], he[se++]);
          return oe;
        } }, { key: "getUri", value: function(g) {
          return wn(ss((g = fn(this.defaults, g)).baseURL, g.url), g.params, g.paramsSerializer);
        } }]) && ko(x.prototype, w), Object.defineProperty(x, "prototype", { writable: !1 }), y;
      }();
      K.forEach(["delete", "get", "head", "options"], function(y) {
        mr.prototype[y] = function(x, w) {
          return this.request(fn(w || {}, { method: y, url: x, data: (w || {}).data }));
        };
      }), K.forEach(["post", "put", "patch"], function(y) {
        function x(w) {
          return function(g, S, C) {
            return this.request(fn(C || {}, { method: y, headers: w ? { "Content-Type": "multipart/form-data" } : {}, url: g, data: S }));
          };
        }
        mr.prototype[y] = x(), mr.prototype[y + "Form"] = x(!0);
      });
      const gr = mr;
      function In(y) {
        return In = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
          return typeof x;
        } : function(x) {
          return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
        }, In(y);
      }
      function cs(y, x) {
        for (var w = 0; w < x.length; w++) {
          var g = x[w];
          g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(y, (S = function(C, R) {
            if (In(C) !== "object" || C === null)
              return C;
            var P = C[Symbol.toPrimitive];
            if (P !== void 0) {
              var F = P.call(C, "string");
              if (In(F) !== "object")
                return F;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(C);
          }(g.key), In(S) === "symbol" ? S : String(S)), g);
        }
        var S;
      }
      var Do = function() {
        function y(S) {
          if (function(P, F) {
            if (!(P instanceof F))
              throw new TypeError("Cannot call a class as a function");
          }(this, y), typeof S != "function")
            throw new TypeError("executor must be a function.");
          var C;
          this.promise = new Promise(function(P) {
            C = P;
          });
          var R = this;
          this.promise.then(function(P) {
            if (R._listeners) {
              for (var F = R._listeners.length; F-- > 0; )
                R._listeners[F](P);
              R._listeners = null;
            }
          }), this.promise.then = function(P) {
            var F, H = new Promise(function(X) {
              R.subscribe(X), F = X;
            }).then(P);
            return H.cancel = function() {
              R.unsubscribe(F);
            }, H;
          }, S(function(P, F, H) {
            R.reason || (R.reason = new fr(P, F, H), C(R.reason));
          });
        }
        var x, w, g;
        return x = y, w = [{ key: "throwIfRequested", value: function() {
          if (this.reason)
            throw this.reason;
        } }, { key: "subscribe", value: function(S) {
          this.reason ? S(this.reason) : this._listeners ? this._listeners.push(S) : this._listeners = [S];
        } }, { key: "unsubscribe", value: function(S) {
          if (this._listeners) {
            var C = this._listeners.indexOf(S);
            C !== -1 && this._listeners.splice(C, 1);
          }
        } }], g = [{ key: "source", value: function() {
          var S;
          return { token: new y(function(C) {
            S = C;
          }), cancel: S };
        } }], w && cs(x.prototype, w), g && cs(x, g), Object.defineProperty(x, "prototype", { writable: !1 }), y;
      }();
      const Oo = Do;
      function us(y, x) {
        (x == null || x > y.length) && (x = y.length);
        for (var w = 0, g = new Array(x); w < x; w++)
          g[w] = y[w];
        return g;
      }
      var Xr = { Continue: 100, SwitchingProtocols: 101, Processing: 102, EarlyHints: 103, Ok: 200, Created: 201, Accepted: 202, NonAuthoritativeInformation: 203, NoContent: 204, ResetContent: 205, PartialContent: 206, MultiStatus: 207, AlreadyReported: 208, ImUsed: 226, MultipleChoices: 300, MovedPermanently: 301, Found: 302, SeeOther: 303, NotModified: 304, UseProxy: 305, Unused: 306, TemporaryRedirect: 307, PermanentRedirect: 308, BadRequest: 400, Unauthorized: 401, PaymentRequired: 402, Forbidden: 403, NotFound: 404, MethodNotAllowed: 405, NotAcceptable: 406, ProxyAuthenticationRequired: 407, RequestTimeout: 408, Conflict: 409, Gone: 410, LengthRequired: 411, PreconditionFailed: 412, PayloadTooLarge: 413, UriTooLong: 414, UnsupportedMediaType: 415, RangeNotSatisfiable: 416, ExpectationFailed: 417, ImATeapot: 418, MisdirectedRequest: 421, UnprocessableEntity: 422, Locked: 423, FailedDependency: 424, TooEarly: 425, UpgradeRequired: 426, PreconditionRequired: 428, TooManyRequests: 429, RequestHeaderFieldsTooLarge: 431, UnavailableForLegalReasons: 451, InternalServerError: 500, NotImplemented: 501, BadGateway: 502, ServiceUnavailable: 503, GatewayTimeout: 504, HttpVersionNotSupported: 505, VariantAlsoNegotiates: 506, InsufficientStorage: 507, LoopDetected: 508, NotExtended: 510, NetworkAuthenticationRequired: 511 };
      Object.entries(Xr).forEach(function(y) {
        var x, w, g = (w = 2, function(R) {
          if (Array.isArray(R))
            return R;
        }(x = y) || function(R, P) {
          var F = R == null ? null : typeof Symbol < "u" && R[Symbol.iterator] || R["@@iterator"];
          if (F != null) {
            var H, X, ie, oe, he = [], de = !0, se = !1;
            try {
              if (ie = (F = F.call(R)).next, P === 0) {
                if (Object(F) !== F)
                  return;
                de = !1;
              } else
                for (; !(de = (H = ie.call(F)).done) && (he.push(H.value), he.length !== P); de = !0)
                  ;
            } catch (pe) {
              se = !0, X = pe;
            } finally {
              try {
                if (!de && F.return != null && (oe = F.return(), Object(oe) !== oe))
                  return;
              } finally {
                if (se)
                  throw X;
              }
            }
            return he;
          }
        }(x, w) || function(R, P) {
          if (R) {
            if (typeof R == "string")
              return us(R, P);
            var F = Object.prototype.toString.call(R).slice(8, -1);
            return F === "Object" && R.constructor && (F = R.constructor.name), F === "Map" || F === "Set" ? Array.from(R) : F === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(F) ? us(R, P) : void 0;
          }
        }(x, w) || function() {
          throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        }()), S = g[0], C = g[1];
        Xr[C] = S;
      });
      const Bo = Xr;
      var st = function y(x) {
        var w = new gr(x), g = Z(gr.prototype.request, w);
        return K.extend(g, gr.prototype, w, { allOwnKeys: !0 }), K.extend(g, w, null, { allOwnKeys: !0 }), g.create = function(S) {
          return y(fn(x, S));
        }, g;
      }(Ie);
      st.Axios = gr, st.CanceledError = fr, st.CancelToken = Oo, st.isCancel = rs, st.VERSION = "1.2.3", st.toFormData = Yt, st.AxiosError = Ee, st.Cancel = st.CanceledError, st.all = function(y) {
        return Promise.all(y);
      }, st.spread = function(y) {
        return function(x) {
          return y.apply(null, x);
        };
      }, st.isAxiosError = function(y) {
        return K.isObject(y) && y.isAxiosError === !0;
      }, st.mergeConfig = fn, st.AxiosHeaders = Vt, st.formToJSON = function(y) {
        return Fe(K.isHTMLForm(y) ? new FormData(y) : y);
      }, st.HttpStatusCode = Bo, st.default = st;
      const hs = st, Po = { send: function(y) {
        hs.post(y.url, y.data).then(function(x) {
          var w = x.data;
          w && w.code === 0 ? y.success && y.success(w) : y.error && y.error(w && w.msg);
        }).catch(function(x) {
          console.error(x), y.error && y.error();
        });
      }, read: function(y) {
        hs.get(y.url).then(function(x) {
          var w = x.data;
          w && w.code === 0 ? y.success && y.success(w.data.map(function(g) {
            return { time: g[0], type: g[1], color: g[2], author: g[3], text: g[4] };
          })) : y.error && y.error(w && w.msg);
        }).catch(function(x) {
          console.error(x), y.error && y.error();
        });
      } };
      function Qr(y) {
        return Qr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
          return typeof x;
        } : function(x) {
          return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
        }, Qr(y);
      }
      function Fo(y) {
        var x = this;
        this.lang = y, this.fallbackLang = this.lang.includes("-") ? this.lang.split("-")[0] : this.lang, this.tran = function(w) {
          return w = w.toLowerCase(), pn[x.lang] && pn[x.lang][w] ? pn[x.lang][w] : pn[x.fallbackLang] && pn[x.fallbackLang][w] ? pn[x.fallbackLang][w] : Zr[w] ? Zr[w] : w;
        };
      }
      var Zr = { "danmaku-loading": "Danmaku is loading", top: "Top", bottom: "Bottom", rolling: "Rolling", "input-danmaku-enter": "Input danmaku, hit Enter", "about-author": "About author", "dplayer-feedback": "DPlayer feedback", "about-dplayer": "About DPlayer", loop: "Loop", speed: "Speed", "opacity-danmaku": "Opacity for danmaku", normal: "Normal", "please-input-danmaku": "Please input danmaku content!", "set-danmaku-color": "Set danmaku color", "set-danmaku-type": "Set danmaku type", "show-danmaku": "Show danmaku", "video-failed": "Video load failed", "danmaku-failed": "Danmaku load failed", "danmaku-send-failed": "Danmaku send failed", "switching-quality": "Switching to %q quality", "switched-quality": "Switched to %q quality", ff: "FF %s s", rew: "REW %s s", "unlimited-danmaku": "Unlimited danmaku", "send-danmaku": "Send danmaku", setting: "Setting", fullscreen: "Full screen", "web-fullscreen": "Web full screen", send: "Send", screenshot: "Screenshot", airplay: "AirPlay", chromecast: "ChromeCast", subtitle: "Subtitle", off: "Off", "show-subs": "Show subtitle", "hide-subs": "Hide subtitle", volume: "Volume", live: "Live", "video-info": "Video info" }, pn = { en: Zr, "zh-cn": { "danmaku-loading": "弹幕加载中", top: "顶部", bottom: "底部", rolling: "滚动", "input-danmaku-enter": "输入弹幕，回车发送", "about-author": "关于作者", "dplayer-feedback": "播放器意见反馈", "about-dplayer": "关于 DPlayer 播放器", loop: "洗脑循环", speed: "速度", "opacity-danmaku": "弹幕透明度", normal: "正常", "please-input-danmaku": "要输入弹幕内容啊喂！", "set-danmaku-color": "设置弹幕颜色", "set-danmaku-type": "设置弹幕类型", "show-danmaku": "显示弹幕", "video-failed": "视频加载失败", "danmaku-failed": "弹幕加载失败", "danmaku-send-failed": "弹幕发送失败", "switching-quality": "正在切换至 %q 画质", "switched-quality": "已经切换至 %q 画质", ff: "快进 %s 秒", rew: "快退 %s 秒", "unlimited-danmaku": "海量弹幕", "send-danmaku": "发送弹幕", setting: "设置", fullscreen: "全屏", "web-fullscreen": "页面全屏", send: "发送", screenshot: "截图", airplay: "无线投屏", chromecast: "ChromeCast", subtitle: "字幕", off: "关闭", "show-subs": "显示字幕", "hide-subs": "隐藏字幕", volume: "音量", live: "直播", "video-info": "视频统计信息" }, "zh-tw": { "danmaku-loading": "彈幕載入中", top: "頂部", bottom: "底部", rolling: "滾動", "input-danmaku-enter": "輸入彈幕，Enter 發送", "about-author": "關於作者", "dplayer-feedback": "播放器意見回饋", "about-dplayer": "關於 DPlayer 播放器", loop: "循環播放", speed: "速度", "opacity-danmaku": "彈幕透明度", normal: "正常", "please-input-danmaku": "請輸入彈幕內容啊！", "set-danmaku-color": "設定彈幕顏色", "set-danmaku-type": "設定彈幕類型", "show-danmaku": "顯示彈幕", "video-failed": "影片載入失敗", "danmaku-failed": "彈幕載入失敗", "danmaku-send-failed": "彈幕發送失敗", "switching-quality": "正在切換至 %q 畫質", "switched-quality": "已經切換至 %q 畫質", ff: "快進 %s 秒", rew: "快退 %s 秒", "unlimited-danmaku": "巨量彈幕", "send-danmaku": "發送彈幕", setting: "設定", fullscreen: "全螢幕", "web-fullscreen": "頁面全螢幕", send: "發送", screenshot: "截圖", airplay: "無線投屏", chromecast: "ChromeCast", subtitle: "字幕", off: "關閉", "show-subs": "顯示字幕", "hide-subs": "隱藏字幕", volume: "音量", live: "直播", "video-info": "影片統計訊息" }, "ko-kr": { "danmaku-loading": "Danmaku를 불러오는 중입니다.", top: "Top", bottom: "Bottom", rolling: "Rolling", "input-danmaku-enter": "Danmaku를 입력하고 Enter를 누르세요.", "about-author": "만든이", "dplayer-feedback": "피드백 보내기", "about-dplayer": "DPlayer 정보", loop: "반복", speed: "배속", "opacity-danmaku": "Danmaku 불투명도", normal: "표준", "please-input-danmaku": "Danmaku를 입력하세요!", "set-danmaku-color": "Danmaku 색상", "set-danmaku-type": "Danmaku 설정", "show-danmaku": "Danmaku 표시", "video-failed": "비디오를 불러오지 못했습니다.", "danmaku-failed": "Danmaku를 불러오지 못했습니다.", "danmaku-send-failed": "Danmaku 전송에 실패했습니다.", "Switching to": "", "Switched to": "", "switching-quality": "전환 %q 화질", "switched-quality": "전환 됨 %q 화질", ff: "앞으로 %s 초", rew: "뒤로 %s 초", "unlimited-danmaku": "끝없는 Danmaku", "send-danmaku": "Danmaku 보내기", setting: "설정", fullscreen: "전체 화면", "web-fullscreen": "웹 내 전체화면", send: "보내기", screenshot: "화면 캡쳐", airplay: "에어플레이", chromecast: "ChromeCast", subtitle: "부제", off: "끄다", "show-subs": "자막 보이기", "hide-subs": "자막 숨기기", Volume: "볼륨", live: "생방송", "video-info": "비디오 정보" }, de: { "danmaku-loading": "Danmaku lädt...", top: "Oben", bottom: "Unten", rolling: "Rollend", "input-danmaku-enter": "Drücke Enter nach dem Einfügen vom Danmaku", "about-author": "Über den Autor", "dplayer-feedback": "DPlayer Feedback", "about-dplayer": "Über DPlayer", loop: "Wiederholen", speed: "Geschwindigkeit", "opacity-danmaku": "Transparenz für Danmaku", normal: "Normal", "please-input-danmaku": "Bitte Danmaku Inhalt eingeben!", "set-danmaku-color": "Danmaku Farbe festlegen", "set-danmaku-type": "Danmaku Typ festlegen", "show-danmaku": "Zeige Danmaku", "video-failed": "Das Video konnte nicht geladen werden", "danmaku-failed": "Danmaku konnte nicht geladen werden", "danmaku-send-failed": "Das senden von Danmaku ist fehgeschlagen", "switching-quality": "Wechsle zur %q Qualität", "switched-quality": "Zur %q Qualität gewechselt", ff: "%s s Vorwärts", rew: "%s s Zurück", "unlimited-danmaku": "Unlimitiertes Danmaku", "send-danmaku": "Sende Danmaku", setting: "Einstellungen", fullscreen: "Vollbild", "web-fullscreen": "Browser Vollbild", send: "Senden", screenshot: "Screenshot", airplay: "AirPlay", "show-subs": "Zeige Untertitel", chromecast: "ChromeCast", subtitle: "Untertitel", off: "Schließung", "hide-subs": "Verstecke Untertitel", volume: "Lautstärke", live: "Live", "video-info": "Video Info" } }, Mo = r(730), Uo = r.n(Mo), No = r(74), jo = r.n(No), Go = r(437), Ko = r.n(Go), $o = r(644), Vo = r.n($o), Wo = r(324), Ho = r.n(Wo), zo = r(574), Yo = r.n(zo), qo = r(300), Xo = r.n(qo), Qo = r(934), Zo = r.n(Qo), Jo = r(428), el = r.n(Jo), tl = r(807), nl = r.n(tl), rl = r(338), il = r.n(rl), sl = r(254), al = r.n(sl), ol = r(965), ll = r.n(ol), dl = r(113), cl = r.n(dl), ul = r(251), hl = r.n(ul), fl = r(410), pl = r.n(fl), ml = r(182), gl = r.n(ml), yl = r(193), Al = r.n(yl);
      const Rt = { play: Uo(), pause: jo(), volumeUp: Ko(), volumeDown: Vo(), volumeOff: Ho(), full: Yo(), fullWeb: Xo(), setting: Zo(), right: el(), comment: nl(), commentOff: il(), send: al(), pallette: ll(), camera: cl(), subtitle: pl(), loading: gl(), airplay: hl(), chromecast: Al() };
      var vl = r(916), bl = r.n(vl);
      function kn(y) {
        return kn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
          return typeof x;
        } : function(x) {
          return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
        }, kn(y);
      }
      function fs(y, x) {
        for (var w = 0; w < x.length; w++) {
          var g = x[w];
          g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(y, (S = function(C, R) {
            if (kn(C) !== "object" || C === null)
              return C;
            var P = C[Symbol.toPrimitive];
            if (P !== void 0) {
              var F = P.call(C, "string");
              if (kn(F) !== "object")
                return F;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(C);
          }(g.key), kn(S) === "symbol" ? S : String(S)), g);
        }
        var S;
      }
      var xl = function() {
        function y(S) {
          (function(C, R) {
            if (!(C instanceof R))
              throw new TypeError("Cannot call a class as a function");
          })(this, y), this.container = S.container, this.options = S.options, this.index = S.index, this.tran = S.tran, this.init();
        }
        var x, w, g;
        return x = y, g = [{ key: "NewNotice", value: function(S, C, R) {
          var P = document.createElement("div");
          return P.classList.add("dplayer-notice"), P.style.opacity = C, P.innerText = S, R && (P.id = "dplayer-notice-".concat(R)), P;
        } }], (w = [{ key: "init", value: function() {
          this.container.innerHTML = bl()({ options: this.options, index: this.index, tran: this.tran, icons: Rt, mobile: W.isMobile, video: { current: !0, pic: this.options.video.pic, screenshot: this.options.screenshot, airplay: !(!W.isSafari || W.isChrome) && this.options.airplay, chromecast: this.options.chromecast, preload: this.options.preload, url: this.options.video.url, subtitle: this.options.subtitle } }), this.volumeBar = this.container.querySelector(".dplayer-volume-bar-inner"), this.volumeBarWrap = this.container.querySelector(".dplayer-volume-bar"), this.volumeBarWrapWrap = this.container.querySelector(".dplayer-volume-bar-wrap"), this.volumeButton = this.container.querySelector(".dplayer-volume"), this.volumeButtonIcon = this.container.querySelector(".dplayer-volume-icon"), this.volumeIcon = this.container.querySelector(".dplayer-volume-icon .dplayer-icon-content"), this.playedBar = this.container.querySelector(".dplayer-played"), this.loadedBar = this.container.querySelector(".dplayer-loaded"), this.playedBarWrap = this.container.querySelector(".dplayer-bar-wrap"), this.playedBarTime = this.container.querySelector(".dplayer-bar-time"), this.danmaku = this.container.querySelector(".dplayer-danmaku"), this.danmakuLoading = this.container.querySelector(".dplayer-danloading"), this.video = this.container.querySelector(".dplayer-video-current"), this.bezel = this.container.querySelector(".dplayer-bezel-icon"), this.playButton = this.container.querySelector(".dplayer-play-icon"), this.mobilePlayButton = this.container.querySelector(".dplayer-mobile-play"), this.videoWrap = this.container.querySelector(".dplayer-video-wrap"), this.controllerMask = this.container.querySelector(".dplayer-controller-mask"), this.ptime = this.container.querySelector(".dplayer-ptime"), this.settingButton = this.container.querySelector(".dplayer-setting-icon"), this.settingBox = this.container.querySelector(".dplayer-setting-box"), this.mask = this.container.querySelector(".dplayer-mask"), this.loop = this.container.querySelector(".dplayer-setting-loop"), this.loopToggle = this.container.querySelector(".dplayer-setting-loop .dplayer-toggle-setting-input"), this.showDanmaku = this.container.querySelector(".dplayer-setting-showdan"), this.showDanmakuToggle = this.container.querySelector(".dplayer-showdan-setting-input"), this.unlimitDanmaku = this.container.querySelector(".dplayer-setting-danunlimit"), this.unlimitDanmakuToggle = this.container.querySelector(".dplayer-danunlimit-setting-input"), this.speed = this.container.querySelector(".dplayer-setting-speed"), this.speedItem = this.container.querySelectorAll(".dplayer-setting-speed-item"), this.danmakuOpacityBar = this.container.querySelector(".dplayer-danmaku-bar-inner"), this.danmakuOpacityBarWrap = this.container.querySelector(".dplayer-danmaku-bar"), this.danmakuOpacityBarWrapWrap = this.container.querySelector(".dplayer-danmaku-bar-wrap"), this.danmakuOpacityBox = this.container.querySelector(".dplayer-setting-danmaku"), this.dtime = this.container.querySelector(".dplayer-dtime"), this.controller = this.container.querySelector(".dplayer-controller"), this.commentInput = this.container.querySelector(".dplayer-comment-input"), this.commentButton = this.container.querySelector(".dplayer-comment-icon"), this.commentSettingBox = this.container.querySelector(".dplayer-comment-setting-box"), this.commentSettingButton = this.container.querySelector(".dplayer-comment-setting-icon"), this.commentSettingFill = this.container.querySelector(".dplayer-comment-setting-icon path"), this.commentSendButton = this.container.querySelector(".dplayer-send-icon"), this.commentSendFill = this.container.querySelector(".dplayer-send-icon path"), this.commentColorSettingBox = this.container.querySelector(".dplayer-comment-setting-color"), this.browserFullButton = this.container.querySelector(".dplayer-full-icon"), this.webFullButton = this.container.querySelector(".dplayer-full-in-icon"), this.menu = this.container.querySelector(".dplayer-menu"), this.menuItem = this.container.querySelectorAll(".dplayer-menu-item"), this.qualityList = this.container.querySelector(".dplayer-quality-list"), this.camareButton = this.container.querySelector(".dplayer-camera-icon"), this.airplayButton = this.container.querySelector(".dplayer-airplay-icon"), this.chromecastButton = this.container.querySelector(".dplayer-chromecast-icon"), this.subtitleButton = this.container.querySelector(".dplayer-subtitle-icon"), this.subtitleButtonInner = this.container.querySelector(".dplayer-subtitle-icon .dplayer-icon-content"), this.subtitlesButton = this.container.querySelector(".dplayer-subtitles-icon"), this.subtitlesBox = this.container.querySelector(".dplayer-subtitles-box"), this.subtitlesItem = this.container.querySelectorAll(".dplayer-subtitles-item"), this.subtitle = this.container.querySelector(".dplayer-subtitle"), this.subtrack = this.container.querySelector(".dplayer-subtrack"), this.qualityButton = this.container.querySelector(".dplayer-quality-icon"), this.barPreview = this.container.querySelector(".dplayer-bar-preview"), this.barWrap = this.container.querySelector(".dplayer-bar-wrap"), this.noticeList = this.container.querySelector(".dplayer-notice-list"), this.infoPanel = this.container.querySelector(".dplayer-info-panel"), this.infoPanelClose = this.container.querySelector(".dplayer-info-panel-close"), this.infoVersion = this.container.querySelector(".dplayer-info-panel-item-version .dplayer-info-panel-item-data"), this.infoFPS = this.container.querySelector(".dplayer-info-panel-item-fps .dplayer-info-panel-item-data"), this.infoType = this.container.querySelector(".dplayer-info-panel-item-type .dplayer-info-panel-item-data"), this.infoUrl = this.container.querySelector(".dplayer-info-panel-item-url .dplayer-info-panel-item-data"), this.infoResolution = this.container.querySelector(".dplayer-info-panel-item-resolution .dplayer-info-panel-item-data"), this.infoDuration = this.container.querySelector(".dplayer-info-panel-item-duration .dplayer-info-panel-item-data"), this.infoDanmakuId = this.container.querySelector(".dplayer-info-panel-item-danmaku-id .dplayer-info-panel-item-data"), this.infoDanmakuApi = this.container.querySelector(".dplayer-info-panel-item-danmaku-api .dplayer-info-panel-item-data"), this.infoDanmakuAmount = this.container.querySelector(".dplayer-info-panel-item-danmaku-amount .dplayer-info-panel-item-data");
        } }]) && fs(x.prototype, w), g && fs(x, g), Object.defineProperty(x, "prototype", { writable: !1 }), y;
      }();
      const ps = xl;
      function mn(y) {
        return mn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
          return typeof x;
        } : function(x) {
          return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
        }, mn(y);
      }
      function El(y, x) {
        for (var w = 0; w < x.length; w++) {
          var g = x[w];
          g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(y, (S = function(C, R) {
            if (mn(C) !== "object" || C === null)
              return C;
            var P = C[Symbol.toPrimitive];
            if (P !== void 0) {
              var F = P.call(C, "string");
              if (mn(F) !== "object")
                return F;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(C);
          }(g.key), mn(S) === "symbol" ? S : String(S)), g);
        }
        var S;
      }
      var _l = function() {
        function y(g) {
          (function(S, C) {
            if (!(S instanceof C))
              throw new TypeError("Cannot call a class as a function");
          })(this, y), this.options = g, this.player = this.options.player, this.container = this.options.container, this.danTunnel = { right: {}, top: {}, bottom: {} }, this.danIndex = 0, this.dan = [], this.showing = !0, this._opacity = this.options.opacity, this.events = this.options.events, this.unlimited = this.options.unlimited, this._measure(""), this.load();
        }
        var x, w;
        return x = y, w = [{ key: "load", value: function() {
          var g, S = this;
          g = this.options.api.maximum ? "".concat(this.options.api.address, "v3/?id=").concat(this.options.api.id, "&max=").concat(this.options.api.maximum) : "".concat(this.options.api.address, "v3/?id=").concat(this.options.api.id);
          var C = (this.options.api.addition || []).slice(0);
          C.push(g), this.events && this.events.trigger("danmaku_load_start", C), this._readAllEndpoints(C, function(R) {
            S.dan = [].concat.apply([], R).sort(function(P, F) {
              return P.time - F.time;
            }), window.requestAnimationFrame(function() {
              S.frame();
            }), S.options.callback(), S.events && S.events.trigger("danmaku_load_end");
          });
        } }, { key: "reload", value: function(g) {
          this.options.api = g, this.dan = [], this.clear(), this.load();
        } }, { key: "_readAllEndpoints", value: function(g, S) {
          for (var C = this, R = [], P = 0, F = function(X) {
            C.options.apiBackend.read({ url: g[X], success: function(ie) {
              R[X] = ie, ++P === g.length && S(R);
            }, error: function(ie) {
              C.options.error(ie || C.options.tran("danmaku-failed")), R[X] = [], ++P === g.length && S(R);
            } });
          }, H = 0; H < g.length; ++H)
            F(H);
        } }, { key: "send", value: function(g, S) {
          var C = this, R = { token: this.options.api.token, id: this.options.api.id, author: this.options.api.user, time: this.options.time(), text: g.text, color: g.color, type: g.type };
          this.options.apiBackend.send({ url: this.options.api.address + "v3/", data: R, success: S, error: function(F) {
            C.options.error(F || C.options.tran("danmaku-failed"));
          } }), this.dan.splice(this.danIndex, 0, R), this.danIndex++;
          var P = { text: this.htmlEncode(R.text), color: R.color, type: R.type, border: "2px solid ".concat(this.options.borderColor) };
          this.draw(P), this.events && this.events.trigger("danmaku_send", R);
        } }, { key: "frame", value: function() {
          var g = this;
          if (this.dan.length && !this.paused && this.showing) {
            for (var S = this.dan[this.danIndex], C = []; S && this.options.time() > parseFloat(S.time); )
              C.push(S), S = this.dan[++this.danIndex];
            this.draw(C);
          }
          window.requestAnimationFrame(function() {
            g.frame();
          });
        } }, { key: "opacity", value: function(g) {
          if (g !== void 0) {
            for (var S = this.container.getElementsByClassName("dplayer-danmaku-item"), C = 0; C < S.length; C++)
              S[C].style.opacity = g;
            this._opacity = g, this.events && this.events.trigger("danmaku_opacity", this._opacity);
          }
          return this._opacity;
        } }, { key: "draw", value: function(g) {
          var S = this;
          if (this.showing) {
            var C = this.options.height, R = this.container.offsetWidth, P = this.container.offsetHeight, F = parseInt(P / C), H = function(se) {
              var pe = se.offsetWidth || parseInt(se.style.width), _e = se.getBoundingClientRect().right || S.container.getBoundingClientRect().right + pe;
              return S.container.getBoundingClientRect().right - _e;
            }, X = function(se) {
              return (R + se) / 5;
            }, ie = function(se, pe, _e) {
              for (var at = R / X(_e), rt = function(sn) {
                var yn = S.danTunnel[pe][sn + ""];
                if (!yn || !yn.length)
                  return S.danTunnel[pe][sn + ""] = [se], se.addEventListener("animationend", function() {
                    S.danTunnel[pe][sn + ""].splice(0, 1);
                  }), { v: sn % F };
                if (pe !== "right")
                  return "continue";
                for (var Yn = 0; Yn < yn.length; Yn++) {
                  var bs = H(yn[Yn]) - 10;
                  if (bs <= R - at * X(parseInt(yn[Yn].style.width)) || bs <= 0)
                    break;
                  if (Yn === yn.length - 1)
                    return S.danTunnel[pe][sn + ""].push(se), se.addEventListener("animationend", function() {
                      S.danTunnel[pe][sn + ""].splice(0, 1);
                    }), { v: sn % F };
                }
              }, je = 0; S.unlimited || je < F; je++) {
                var Zt = rt(je);
                if (Zt !== "continue" && mn(Zt) === "object")
                  return Zt.v;
              }
              return -1;
            };
            Object.prototype.toString.call(g) !== "[object Array]" && (g = [g]);
            for (var oe = document.createDocumentFragment(), he = function() {
              g[de].type = W.number2Type(g[de].type), g[de].color || (g[de].color = 16777215);
              var se = document.createElement("div");
              se.classList.add("dplayer-danmaku-item"), se.classList.add("dplayer-danmaku-".concat(g[de].type)), g[de].border ? se.innerHTML = '<span style="border:'.concat(g[de].border, '">').concat(g[de].text, "</span>") : se.innerHTML = g[de].text, se.style.opacity = S._opacity, se.style.color = W.number2Color(g[de].color), se.addEventListener("animationend", function() {
                S.container.removeChild(se);
              });
              var pe, _e = S._measure(g[de].text);
              switch (g[de].type) {
                case "right":
                  (pe = ie(se, g[de].type, _e)) >= 0 && (se.style.width = _e + 1 + "px", se.style.top = C * pe + "px", se.style.transform = "translateX(-".concat(R, "px)"));
                  break;
                case "top":
                  (pe = ie(se, g[de].type)) >= 0 && (se.style.top = C * pe + "px");
                  break;
                case "bottom":
                  (pe = ie(se, g[de].type)) >= 0 && (se.style.bottom = C * pe + "px");
                  break;
                default:
                  console.error("Can't handled danmaku type: ".concat(g[de].type));
              }
              pe >= 0 && (se.classList.add("dplayer-danmaku-move"), se.style.animationDuration = S._danAnimation(g[de].type), oe.appendChild(se));
            }, de = 0; de < g.length; de++)
              he();
            return this.container.appendChild(oe), oe;
          }
        } }, { key: "play", value: function() {
          this.paused = !1;
        } }, { key: "pause", value: function() {
          this.paused = !0;
        } }, { key: "_measure", value: function(g) {
          if (!this.context) {
            var S = getComputedStyle(this.container.getElementsByClassName("dplayer-danmaku-item")[0], null);
            this.context = document.createElement("canvas").getContext("2d"), this.context.font = S.getPropertyValue("font");
          }
          return this.context.measureText(g).width;
        } }, { key: "seek", value: function() {
          this.clear();
          for (var g = 0; g < this.dan.length; g++) {
            if (this.dan[g].time >= this.options.time()) {
              this.danIndex = g;
              break;
            }
            this.danIndex = this.dan.length;
          }
        } }, { key: "clear", value: function() {
          this.danTunnel = { right: {}, top: {}, bottom: {} }, this.danIndex = 0, this.options.container.innerHTML = "", this.events && this.events.trigger("danmaku_clear");
        } }, { key: "htmlEncode", value: function(g) {
          return g.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;").replace(/\//g, "&#x2f;");
        } }, { key: "resize", value: function() {
          for (var g = this.container.offsetWidth, S = this.container.getElementsByClassName("dplayer-danmaku-item"), C = 0; C < S.length; C++)
            S[C].style.transform = "translateX(-".concat(g, "px)");
        } }, { key: "hide", value: function() {
          this.showing = !1, this.pause(), this.clear(), this.events && this.events.trigger("danmaku_hide");
        } }, { key: "show", value: function() {
          this.seek(), this.showing = !0, this.play(), this.events && this.events.trigger("danmaku_show");
        } }, { key: "unlimit", value: function(g) {
          this.unlimited = g;
        } }, { key: "speed", value: function(g) {
          this.options.api.speedRate = g;
        } }, { key: "_danAnimation", value: function(g) {
          var S = this.options.api.speedRate || 1, C = !!this.player.fullScreen.isFullScreen();
          return { top: "".concat((C ? 6 : 4) / S, "s"), right: "".concat((C ? 8 : 5) / S, "s"), bottom: "".concat((C ? 6 : 4) / S, "s") }[g];
        } }], w && El(x.prototype, w), Object.defineProperty(x, "prototype", { writable: !1 }), y;
      }();
      const Sl = _l;
      function Dn(y) {
        return Dn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
          return typeof x;
        } : function(x) {
          return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
        }, Dn(y);
      }
      function Tl(y, x) {
        for (var w = 0; w < x.length; w++) {
          var g = x[w];
          g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(y, (S = function(C, R) {
            if (Dn(C) !== "object" || C === null)
              return C;
            var P = C[Symbol.toPrimitive];
            if (P !== void 0) {
              var F = P.call(C, "string");
              if (Dn(F) !== "object")
                return F;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(C);
          }(g.key), Dn(S) === "symbol" ? S : String(S)), g);
        }
        var S;
      }
      const Cl = function() {
        function y() {
          (function(g, S) {
            if (!(g instanceof S))
              throw new TypeError("Cannot call a class as a function");
          })(this, y), this.events = {}, this.videoEvents = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "mozaudioavailable", "pause", "play", "playing", "progress", "ratechange", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], this.playerEvents = ["screenshot", "thumbnails_show", "thumbnails_hide", "danmaku_show", "danmaku_hide", "danmaku_clear", "danmaku_loaded", "danmaku_send", "danmaku_opacity", "contextmenu_show", "contextmenu_hide", "notice_show", "notice_hide", "quality_start", "quality_end", "destroy", "resize", "fullscreen", "fullscreen_cancel", "webfullscreen", "webfullscreen_cancel", "subtitle_show", "subtitle_hide", "subtitle_change"];
        }
        var x, w;
        return x = y, (w = [{ key: "on", value: function(g, S) {
          this.type(g) && typeof S == "function" && (this.events[g] || (this.events[g] = []), this.events[g].push(S));
        } }, { key: "trigger", value: function(g, S) {
          if (this.events[g] && this.events[g].length)
            for (var C = 0; C < this.events[g].length; C++)
              this.events[g][C](S);
        } }, { key: "type", value: function(g) {
          return this.playerEvents.indexOf(g) !== -1 ? "player" : this.videoEvents.indexOf(g) !== -1 ? "video" : (console.error("Unknown event name: ".concat(g)), null);
        } }]) && Tl(x.prototype, w), Object.defineProperty(x, "prototype", { writable: !1 }), y;
      }();
      function On(y) {
        return On = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
          return typeof x;
        } : function(x) {
          return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
        }, On(y);
      }
      function Ll(y, x) {
        for (var w = 0; w < x.length; w++) {
          var g = x[w];
          g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(y, (S = function(C, R) {
            if (On(C) !== "object" || C === null)
              return C;
            var P = C[Symbol.toPrimitive];
            if (P !== void 0) {
              var F = P.call(C, "string");
              if (On(F) !== "object")
                return F;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(C);
          }(g.key), On(S) === "symbol" ? S : String(S)), g);
        }
        var S;
      }
      var wl = function() {
        function y(g) {
          var S = this;
          (function(C, R) {
            if (!(C instanceof R))
              throw new TypeError("Cannot call a class as a function");
          })(this, y), this.player = g, this.lastScrollPosition = { left: 0, top: 0 }, this.player.events.on("webfullscreen", function() {
            S.player.resize();
          }), this.player.events.on("webfullscreen_cancel", function() {
            S.player.resize(), W.setScrollPosition(S.lastScrollPosition);
          }), this.fullscreenchange = function() {
            S.player.resize(), S.isFullScreen("browser") ? S.player.events.trigger("fullscreen") : (W.setScrollPosition(S.lastScrollPosition), S.player.events.trigger("fullscreen_cancel"));
          }, this.docfullscreenchange = function() {
            var C = document.fullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
            C && C !== S.player.container || (S.player.resize(), C ? S.player.events.trigger("fullscreen") : (W.setScrollPosition(S.lastScrollPosition), S.player.events.trigger("fullscreen_cancel")));
          }, /Firefox/.test(navigator.userAgent) ? (document.addEventListener("mozfullscreenchange", this.docfullscreenchange), document.addEventListener("fullscreenchange", this.docfullscreenchange)) : (this.player.container.addEventListener("fullscreenchange", this.fullscreenchange), this.player.container.addEventListener("webkitfullscreenchange", this.fullscreenchange), document.addEventListener("msfullscreenchange", this.docfullscreenchange), document.addEventListener("MSFullscreenChange", this.docfullscreenchange));
        }
        var x, w;
        return x = y, w = [{ key: "isFullScreen", value: function() {
          var g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "browser";
          switch (g) {
            case "browser":
              return document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
            case "web":
              return this.player.container.classList.contains("dplayer-fulled");
          }
        } }, { key: "request", value: function() {
          var g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "browser", S = g === "browser" ? "web" : "browser", C = this.isFullScreen(S);
          switch (C || (this.lastScrollPosition = W.getScrollPosition()), g) {
            case "browser":
              this.player.container.requestFullscreen ? this.player.container.requestFullscreen() : this.player.container.mozRequestFullScreen ? this.player.container.mozRequestFullScreen() : this.player.container.webkitRequestFullscreen ? this.player.container.webkitRequestFullscreen() : this.player.video.webkitEnterFullscreen ? this.player.video.webkitEnterFullscreen() : this.player.video.webkitEnterFullScreen ? this.player.video.webkitEnterFullScreen() : this.player.container.msRequestFullscreen && this.player.container.msRequestFullscreen();
              break;
            case "web":
              this.player.container.classList.add("dplayer-fulled"), document.body.classList.add("dplayer-web-fullscreen-fix"), this.player.events.trigger("webfullscreen");
          }
          C && this.cancel(S);
        } }, { key: "cancel", value: function() {
          var g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "browser";
          switch (g) {
            case "browser":
              document.cancelFullScreen ? document.cancelFullScreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitCancelFullScreen ? document.webkitCancelFullScreen() : document.webkitCancelFullscreen ? document.webkitCancelFullscreen() : document.msCancelFullScreen ? document.msCancelFullScreen() : document.msExitFullscreen && document.msExitFullscreen();
              break;
            case "web":
              this.player.container.classList.remove("dplayer-fulled"), document.body.classList.remove("dplayer-web-fullscreen-fix"), this.player.events.trigger("webfullscreen_cancel");
          }
        } }, { key: "toggle", value: function() {
          var g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "browser";
          this.isFullScreen(g) ? this.cancel(g) : this.request(g);
        } }, { key: "destroy", value: function() {
          /Firefox/.test(navigator.userAgent) ? (document.removeEventListener("mozfullscreenchange", this.docfullscreenchange), document.removeEventListener("fullscreenchange", this.docfullscreenchange)) : (this.player.container.removeEventListener("fullscreenchange", this.fullscreenchange), this.player.container.removeEventListener("webkitfullscreenchange", this.fullscreenchange), document.removeEventListener("msfullscreenchange", this.docfullscreenchange), document.removeEventListener("MSFullscreenChange", this.docfullscreenchange));
        } }], w && Ll(x.prototype, w), Object.defineProperty(x, "prototype", { writable: !1 }), y;
      }();
      const Rl = wl;
      function Bn(y) {
        return Bn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
          return typeof x;
        } : function(x) {
          return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
        }, Bn(y);
      }
      function Il(y, x) {
        for (var w = 0; w < x.length; w++) {
          var g = x[w];
          g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(y, (S = function(C, R) {
            if (Bn(C) !== "object" || C === null)
              return C;
            var P = C[Symbol.toPrimitive];
            if (P !== void 0) {
              var F = P.call(C, "string");
              if (Bn(F) !== "object")
                return F;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(C);
          }(g.key), Bn(S) === "symbol" ? S : String(S)), g);
        }
        var S;
      }
      var kl = function() {
        function y(g) {
          (function(S, C) {
            if (!(S instanceof C))
              throw new TypeError("Cannot call a class as a function");
          })(this, y), this.storageName = { opacity: "dplayer-danmaku-opacity", volume: "dplayer-volume", unlimited: "dplayer-danmaku-unlimited", danmaku: "dplayer-danmaku-show", subtitle: "dplayer-subtitle-show" }, this.default = { opacity: 0.7, volume: g.options.hasOwnProperty("volume") ? g.options.volume : 0.7, unlimited: (g.options.danmaku && g.options.danmaku.unlimited ? 1 : 0) || 0, danmaku: 1, subtitle: 1 }, this.data = {}, this.init();
        }
        var x, w;
        return x = y, (w = [{ key: "init", value: function() {
          for (var g in this.storageName) {
            var S = this.storageName[g];
            this.data[g] = parseFloat(W.storage.get(S) || this.default[g]);
          }
        } }, { key: "get", value: function(g) {
          return this.data[g];
        } }, { key: "set", value: function(g, S) {
          this.data[g] = S, W.storage.set(this.storageName[g], S);
        } }]) && Il(x.prototype, w), Object.defineProperty(x, "prototype", { writable: !1 }), y;
      }();
      const Dl = kl;
      function Pn(y) {
        return Pn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
          return typeof x;
        } : function(x) {
          return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
        }, Pn(y);
      }
      function Ol(y, x) {
        for (var w = 0; w < x.length; w++) {
          var g = x[w];
          g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(y, (S = function(C, R) {
            if (Pn(C) !== "object" || C === null)
              return C;
            var P = C[Symbol.toPrimitive];
            if (P !== void 0) {
              var F = P.call(C, "string");
              if (Pn(F) !== "object")
                return F;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(C);
          }(g.key), Pn(S) === "symbol" ? S : String(S)), g);
        }
        var S;
      }
      var Bl = function() {
        function y(g, S, C, R) {
          (function(P, F) {
            if (!(P instanceof F))
              throw new TypeError("Cannot call a class as a function");
          })(this, y), this.container = g, this.video = S, this.options = C, this.events = R, this.init();
        }
        var x, w;
        return x = y, w = [{ key: "init", value: function() {
          var g = this;
          if (this.container.style.fontSize = this.options.fontSize, this.container.style.bottom = this.options.bottom, this.container.style.color = this.options.color, this.video.textTracks && this.video.textTracks[0]) {
            var S = this.video.textTracks[0];
            S.oncuechange = function() {
              var C = S.activeCues[S.activeCues.length - 1];
              if (g.container.innerHTML = "", C) {
                var R = document.createElement("div");
                R.appendChild(C.getCueAsHTML());
                var P = R.innerHTML.split(/\r?\n/).map(function(F) {
                  return "<p>".concat(F, "</p>");
                }).join("");
                g.container.innerHTML = P;
              }
              g.events.trigger("subtitle_change");
            };
          }
        } }, { key: "show", value: function() {
          this.container.classList.remove("dplayer-subtitle-hide"), this.events.trigger("subtitle_show");
        } }, { key: "hide", value: function() {
          this.container.classList.add("dplayer-subtitle-hide"), this.events.trigger("subtitle_hide");
        } }, { key: "toggle", value: function() {
          this.container.classList.contains("dplayer-subtitle-hide") ? this.show() : this.hide();
        } }], w && Ol(x.prototype, w), Object.defineProperty(x, "prototype", { writable: !1 }), y;
      }();
      const Pl = Bl;
      function Fn(y) {
        return Fn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
          return typeof x;
        } : function(x) {
          return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
        }, Fn(y);
      }
      function Fl(y, x) {
        for (var w = 0; w < x.length; w++) {
          var g = x[w];
          g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(y, (S = function(C, R) {
            if (Fn(C) !== "object" || C === null)
              return C;
            var P = C[Symbol.toPrimitive];
            if (P !== void 0) {
              var F = P.call(C, "string");
              if (Fn(F) !== "object")
                return F;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(C);
          }(g.key), Fn(S) === "symbol" ? S : String(S)), g);
        }
        var S;
      }
      var Ml = function() {
        function y(g) {
          var S = this;
          (function(F, H) {
            if (!(F instanceof H))
              throw new TypeError("Cannot call a class as a function");
          })(this, y), this.player = g, this.player.template.mask.addEventListener("click", function() {
            S.hide();
          }), this.player.template.subtitlesButton.addEventListener("click", function() {
            S.adaptiveHeight(), S.show();
          });
          for (var C = this.player.template.subtitlesItem.length - 1, R = function(F) {
            S.player.template.subtitlesItem[F].addEventListener("click", function() {
              S.hide(), S.player.options.subtitle.index !== F && (S.player.template.subtitle.innerHTML = "<p></p>", S.player.template.subtrack.src = S.player.template.subtitlesItem[F].dataset.subtitle, S.player.options.subtitle.index = F, S.player.template.subtitle.classList.contains("dplayer-subtitle-hide") && S.subContainerShow());
            });
          }, P = 0; P < C; P++)
            R(P);
          this.player.template.subtitlesItem[C].addEventListener("click", function() {
            S.hide(), S.player.options.subtitle.index !== C && (S.player.template.subtitle.innerHTML = "<p></p>", S.player.template.subtrack.src = "", S.player.options.subtitle.index = C, S.subContainerHide());
          });
        }
        var x, w;
        return x = y, (w = [{ key: "subContainerShow", value: function() {
          this.player.template.subtitle.classList.remove("dplayer-subtitle-hide"), this.player.events.trigger("subtitle_show");
        } }, { key: "subContainerHide", value: function() {
          this.player.template.subtitle.classList.add("dplayer-subtitle-hide"), this.player.events.trigger("subtitle_hide");
        } }, { key: "hide", value: function() {
          this.player.template.subtitlesBox.classList.remove("dplayer-subtitles-box-open"), this.player.template.mask.classList.remove("dplayer-mask-show"), this.player.controller.disableAutoHide = !1;
        } }, { key: "show", value: function() {
          this.player.template.subtitlesBox.classList.add("dplayer-subtitles-box-open"), this.player.template.mask.classList.add("dplayer-mask-show"), this.player.controller.disableAutoHide = !0;
        } }, { key: "adaptiveHeight", value: function() {
          var g = 30 * this.player.template.subtitlesItem.length + 14, S = 0.8 * this.player.template.videoWrap.offsetHeight;
          g >= S - 50 ? (this.player.template.subtitlesBox.style.bottom = "8px", this.player.template.subtitlesBox.style["max-height"] = S - 8 + "px") : (this.player.template.subtitlesBox.style.bottom = "50px", this.player.template.subtitlesBox.style["max-height"] = S - 50 + "px");
        } }]) && Fl(x.prototype, w), Object.defineProperty(x, "prototype", { writable: !1 }), y;
      }();
      const Ul = Ml;
      function Mn(y) {
        return Mn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
          return typeof x;
        } : function(x) {
          return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
        }, Mn(y);
      }
      function Nl(y, x) {
        for (var w = 0; w < x.length; w++) {
          var g = x[w];
          g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(y, (S = function(C, R) {
            if (Mn(C) !== "object" || C === null)
              return C;
            var P = C[Symbol.toPrimitive];
            if (P !== void 0) {
              var F = P.call(C, "string");
              if (Mn(F) !== "object")
                return F;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(C);
          }(g.key), Mn(S) === "symbol" ? S : String(S)), g);
        }
        var S;
      }
      var jl = function() {
        function y(g) {
          (function(S, C) {
            if (!(S instanceof C))
              throw new TypeError("Cannot call a class as a function");
          })(this, y), this.elements = {}, this.elements.volume = g.volumeBar, this.elements.played = g.playedBar, this.elements.loaded = g.loadedBar, this.elements.danmaku = g.danmakuOpacityBar;
        }
        var x, w;
        return x = y, (w = [{ key: "set", value: function(g, S, C) {
          S = Math.max(S, 0), S = Math.min(S, 1), this.elements[g].style[C] = 100 * S + "%";
        } }, { key: "get", value: function(g) {
          return parseFloat(this.elements[g].style.width) / 100;
        } }]) && Nl(x.prototype, w), Object.defineProperty(x, "prototype", { writable: !1 }), y;
      }();
      const Gl = jl;
      function Un(y) {
        return Un = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
          return typeof x;
        } : function(x) {
          return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
        }, Un(y);
      }
      function Kl(y, x) {
        for (var w = 0; w < x.length; w++) {
          var g = x[w];
          g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(y, (S = function(C, R) {
            if (Un(C) !== "object" || C === null)
              return C;
            var P = C[Symbol.toPrimitive];
            if (P !== void 0) {
              var F = P.call(C, "string");
              if (Un(F) !== "object")
                return F;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(C);
          }(g.key), Un(S) === "symbol" ? S : String(S)), g);
        }
        var S;
      }
      var $l = function() {
        function y(g) {
          (function(S, C) {
            if (!(S instanceof C))
              throw new TypeError("Cannot call a class as a function");
          })(this, y), this.player = g, window.requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(S) {
            window.setTimeout(S, 1e3 / 60);
          }, this.types = ["loading", "info", "fps"], this.init();
        }
        var x, w;
        return x = y, (w = [{ key: "init", value: function() {
          var g = this;
          this.types.map(function(S) {
            return S !== "fps" && g["init".concat(S, "Checker")](), S;
          });
        } }, { key: "initloadingChecker", value: function() {
          var g = this, S = 0, C = 0, R = !1;
          this.loadingChecker = setInterval(function() {
            g.enableloadingChecker && (C = g.player.video.currentTime, R || C !== S || g.player.video.paused || (g.player.container.classList.add("dplayer-loading"), R = !0), R && C > S && !g.player.video.paused && (g.player.container.classList.remove("dplayer-loading"), R = !1), S = C);
          }, 100);
        } }, { key: "initfpsChecker", value: function() {
          var g = this;
          window.requestAnimationFrame(function() {
            if (g.enablefpsChecker)
              if (g.initfpsChecker(), g.fpsStart) {
                g.fpsIndex++;
                var S = /* @__PURE__ */ new Date();
                S - g.fpsStart > 1e3 && (g.player.infoPanel.fps(g.fpsIndex / (S - g.fpsStart) * 1e3), g.fpsStart = /* @__PURE__ */ new Date(), g.fpsIndex = 0);
              } else
                g.fpsStart = /* @__PURE__ */ new Date(), g.fpsIndex = 0;
            else
              g.fpsStart = 0, g.fpsIndex = 0;
          });
        } }, { key: "initinfoChecker", value: function() {
          var g = this;
          this.infoChecker = setInterval(function() {
            g.enableinfoChecker && g.player.infoPanel.update();
          }, 1e3);
        } }, { key: "enable", value: function(g) {
          this["enable".concat(g, "Checker")] = !0, g === "fps" && this.initfpsChecker();
        } }, { key: "disable", value: function(g) {
          this["enable".concat(g, "Checker")] = !1;
        } }, { key: "destroy", value: function() {
          var g = this;
          this.types.map(function(S) {
            return g["enable".concat(S, "Checker")] = !1, g["".concat(S, "Checker")] && clearInterval(g["".concat(S, "Checker")]), S;
          });
        } }]) && Kl(x.prototype, w), Object.defineProperty(x, "prototype", { writable: !1 }), y;
      }();
      const Vl = $l;
      function Nn(y) {
        return Nn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
          return typeof x;
        } : function(x) {
          return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
        }, Nn(y);
      }
      function Wl(y, x) {
        for (var w = 0; w < x.length; w++) {
          var g = x[w];
          g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(y, (S = function(C, R) {
            if (Nn(C) !== "object" || C === null)
              return C;
            var P = C[Symbol.toPrimitive];
            if (P !== void 0) {
              var F = P.call(C, "string");
              if (Nn(F) !== "object")
                return F;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(C);
          }(g.key), Nn(S) === "symbol" ? S : String(S)), g);
        }
        var S;
      }
      const Hl = function() {
        function y(g) {
          var S = this;
          (function(C, R) {
            if (!(C instanceof R))
              throw new TypeError("Cannot call a class as a function");
          })(this, y), this.container = g, this.container.addEventListener("animationend", function() {
            S.container.classList.remove("dplayer-bezel-transition");
          });
        }
        var x, w;
        return x = y, (w = [{ key: "switch", value: function(g) {
          this.container.innerHTML = g, this.container.classList.add("dplayer-bezel-transition");
        } }]) && Wl(x.prototype, w), Object.defineProperty(x, "prototype", { writable: !1 }), y;
      }();
      function jn(y) {
        return jn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
          return typeof x;
        } : function(x) {
          return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
        }, jn(y);
      }
      function zl(y, x) {
        for (var w = 0; w < x.length; w++) {
          var g = x[w];
          g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(y, (S = function(C, R) {
            if (jn(C) !== "object" || C === null)
              return C;
            var P = C[Symbol.toPrimitive];
            if (P !== void 0) {
              var F = P.call(C, "string");
              if (jn(F) !== "object")
                return F;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(C);
          }(g.key), jn(S) === "symbol" ? S : String(S)), g);
        }
        var S;
      }
      var Yl = function() {
        function y(g) {
          (function(S, C) {
            if (!(S instanceof C))
              throw new TypeError("Cannot call a class as a function");
          })(this, y), this.container = g.container, this.barWidth = g.barWidth, this.container.style.backgroundImage = "url('".concat(g.url, "')"), this.events = g.events;
        }
        var x, w;
        return x = y, (w = [{ key: "resize", value: function(g, S, C) {
          this.container.style.width = "".concat(g, "px"), this.container.style.height = "".concat(S, "px"), this.container.style.top = "".concat(2 - S, "px"), this.barWidth = C;
        } }, { key: "show", value: function() {
          this.container.style.display = "block", this.events && this.events.trigger("thumbnails_show");
        } }, { key: "move", value: function(g) {
          this.container.style.backgroundPosition = "-".concat(160 * (Math.ceil(g / this.barWidth * 100) - 1), "px 0"), this.container.style.left = "".concat(Math.min(Math.max(g - this.container.offsetWidth / 2, -10), this.barWidth - 150), "px");
        } }, { key: "hide", value: function() {
          this.container.style.display = "none", this.events && this.events.trigger("thumbnails_hide");
        } }]) && zl(x.prototype, w), Object.defineProperty(x, "prototype", { writable: !1 }), y;
      }();
      const ql = Yl;
      function Gn(y) {
        return Gn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
          return typeof x;
        } : function(x) {
          return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
        }, Gn(y);
      }
      function Xl(y, x) {
        for (var w = 0; w < x.length; w++) {
          var g = x[w];
          g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(y, (S = function(C, R) {
            if (Gn(C) !== "object" || C === null)
              return C;
            var P = C[Symbol.toPrimitive];
            if (P !== void 0) {
              var F = P.call(C, "string");
              if (Gn(F) !== "object")
                return F;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(C);
          }(g.key), Gn(S) === "symbol" ? S : String(S)), g);
        }
        var S;
      }
      var Qt, ms = !0, Jr = !1, Ql = function() {
        function y(g) {
          (function(S, C) {
            if (!(S instanceof C))
              throw new TypeError("Cannot call a class as a function");
          })(this, y), this.player = g, this.autoHideTimer = 0, W.isMobile || (this.setAutoHideHandler = this.setAutoHide.bind(this), this.player.container.addEventListener("mousemove", this.setAutoHideHandler), this.player.container.addEventListener("click", this.setAutoHideHandler), this.player.on("play", this.setAutoHideHandler), this.player.on("pause", this.setAutoHideHandler)), this.initPlayButton(), this.initThumbnails(), this.initPlayedBar(), this.initFullButton(), this.initQualityButton(), this.initScreenshotButton(), this.player.options.subtitle && typeof this.player.options.subtitle.url == "string" && this.initSubtitleButton(), this.initHighlights(), this.initAirplayButton(), this.initChromecastButton(), W.isMobile || this.initVolumeButton();
        }
        var x, w;
        return x = y, (w = [{ key: "initPlayButton", value: function() {
          var g = this;
          this.player.template.playButton.addEventListener("click", function() {
            g.player.toggle();
          }), this.player.template.mobilePlayButton.addEventListener("click", function() {
            g.player.toggle();
          }), W.isMobile ? (this.player.template.videoWrap.addEventListener("click", function() {
            g.toggle();
          }), this.player.template.controllerMask.addEventListener("click", function() {
            g.toggle();
          })) : this.player.options.preventClickToggle || (this.player.template.videoWrap.addEventListener("click", function() {
            g.player.toggle();
          }), this.player.template.controllerMask.addEventListener("click", function() {
            g.player.toggle();
          }));
        } }, { key: "initHighlights", value: function() {
          var g = this;
          this.player.on("durationchange", function() {
            if (g.player.video.duration !== 1 && g.player.video.duration !== 1 / 0 && g.player.options.highlight) {
              var S = g.player.template.playedBarWrap.querySelectorAll(".dplayer-highlight");
              [].slice.call(S, 0).forEach(function(P) {
                g.player.template.playedBarWrap.removeChild(P);
              });
              for (var C = 0; C < g.player.options.highlight.length; C++)
                if (g.player.options.highlight[C].text && g.player.options.highlight[C].time) {
                  var R = document.createElement("div");
                  R.classList.add("dplayer-highlight"), R.style.left = g.player.options.highlight[C].time / g.player.video.duration * 100 + "%", R.innerHTML = '<span class="dplayer-highlight-text">' + g.player.options.highlight[C].text + "</span>", g.player.template.playedBarWrap.insertBefore(R, g.player.template.playedBarTime);
                }
            }
          });
        } }, { key: "initThumbnails", value: function() {
          var g = this;
          this.player.options.video.thumbnails && (this.thumbnails = new ql({ container: this.player.template.barPreview, barWidth: this.player.template.barWrap.offsetWidth, url: this.player.options.video.thumbnails, events: this.player.events }), this.player.on("loadedmetadata", function() {
            g.thumbnails.resize(160, g.player.video.videoHeight / g.player.video.videoWidth * 160, g.player.template.barWrap.offsetWidth);
          }));
        } }, { key: "initPlayedBar", value: function() {
          var g = this, S = function(R) {
            var P = ((R.clientX || R.changedTouches[0].clientX) - W.getBoundingClientRectViewLeft(g.player.template.playedBarWrap)) / g.player.template.playedBarWrap.clientWidth;
            P = Math.max(P, 0), P = Math.min(P, 1), g.player.bar.set("played", P, "width"), g.player.template.ptime.innerHTML = W.secondToTime(P * g.player.video.duration);
          }, C = function R(P) {
            document.removeEventListener(W.nameMap.dragEnd, R), document.removeEventListener(W.nameMap.dragMove, S);
            var F = ((P.clientX || P.changedTouches[0].clientX) - W.getBoundingClientRectViewLeft(g.player.template.playedBarWrap)) / g.player.template.playedBarWrap.clientWidth;
            F = Math.max(F, 0), F = Math.min(F, 1), g.player.bar.set("played", F, "width"), g.player.seek(g.player.bar.get("played") * g.player.video.duration), g.player.timer.enable("progress");
          };
          this.player.template.playedBarWrap.addEventListener(W.nameMap.dragStart, function() {
            g.player.timer.disable("progress"), document.addEventListener(W.nameMap.dragMove, S), document.addEventListener(W.nameMap.dragEnd, C);
          }), this.player.template.playedBarWrap.addEventListener(W.nameMap.dragMove, function(R) {
            if (g.player.video.duration) {
              var P = g.player.template.playedBarWrap.getBoundingClientRect().left, F = (R.clientX || R.changedTouches[0].clientX) - P;
              if (F < 0 || F > g.player.template.playedBarWrap.offsetWidth)
                return;
              var H = g.player.video.duration * (F / g.player.template.playedBarWrap.offsetWidth);
              W.isMobile && g.thumbnails && g.thumbnails.show(), g.thumbnails && g.thumbnails.move(F), g.player.template.playedBarTime.style.left = "".concat(F - (H >= 3600 ? 25 : 20), "px"), g.player.template.playedBarTime.innerText = W.secondToTime(H), g.player.template.playedBarTime.classList.remove("hidden");
            }
          }), this.player.template.playedBarWrap.addEventListener(W.nameMap.dragEnd, function() {
            W.isMobile && g.thumbnails && g.thumbnails.hide();
          }), W.isMobile || (this.player.template.playedBarWrap.addEventListener("mouseenter", function() {
            g.player.video.duration && (g.thumbnails && g.thumbnails.show(), g.player.template.playedBarTime.classList.remove("hidden"));
          }), this.player.template.playedBarWrap.addEventListener("mouseleave", function() {
            g.player.video.duration && (g.thumbnails && g.thumbnails.hide(), g.player.template.playedBarTime.classList.add("hidden"));
          }));
        } }, { key: "initFullButton", value: function() {
          var g = this;
          this.player.template.browserFullButton.addEventListener("click", function() {
            g.player.fullScreen.toggle("browser");
          }), this.player.template.webFullButton.addEventListener("click", function() {
            g.player.fullScreen.toggle("web");
          });
        } }, { key: "initVolumeButton", value: function() {
          var g = this, S = function(R) {
            var P = R || window.event, F = ((P.clientX || P.changedTouches[0].clientX) - W.getBoundingClientRectViewLeft(g.player.template.volumeBarWrap) - 5.5) / 35;
            g.player.volume(F);
          }, C = function R() {
            document.removeEventListener(W.nameMap.dragEnd, R), document.removeEventListener(W.nameMap.dragMove, S), g.player.template.volumeButton.classList.remove("dplayer-volume-active");
          };
          this.player.template.volumeBarWrapWrap.addEventListener("click", function(R) {
            var P = R || window.event, F = ((P.clientX || P.changedTouches[0].clientX) - W.getBoundingClientRectViewLeft(g.player.template.volumeBarWrap) - 5.5) / 35;
            g.player.volume(F);
          }), this.player.template.volumeBarWrapWrap.addEventListener(W.nameMap.dragStart, function() {
            document.addEventListener(W.nameMap.dragMove, S), document.addEventListener(W.nameMap.dragEnd, C), g.player.template.volumeButton.classList.add("dplayer-volume-active");
          }), this.player.template.volumeButtonIcon.addEventListener("click", function() {
            g.player.video.muted ? (g.player.video.muted = !1, g.player.switchVolumeIcon(), g.player.bar.set("volume", g.player.volume(), "width")) : (g.player.video.muted = !0, g.player.template.volumeIcon.innerHTML = Rt.volumeOff, g.player.bar.set("volume", 0, "width"));
          });
        } }, { key: "initQualityButton", value: function() {
          var g = this;
          this.player.options.video.quality && this.player.template.qualityList.addEventListener("click", function(S) {
            S.target.classList.contains("dplayer-quality-item") && g.player.switchQuality(S.target.dataset.index);
          });
        } }, { key: "initScreenshotButton", value: function() {
          var g = this;
          this.player.options.screenshot && this.player.template.camareButton.addEventListener("click", function() {
            var S, C = document.createElement("canvas");
            C.width = g.player.video.videoWidth, C.height = g.player.video.videoHeight, C.getContext("2d").drawImage(g.player.video, 0, 0, C.width, C.height), C.toBlob(function(R) {
              S = URL.createObjectURL(R);
              var P = document.createElement("a");
              P.href = S, P.download = "DPlayer.png", P.style.display = "none", document.body.appendChild(P), P.click(), document.body.removeChild(P), URL.revokeObjectURL(S), g.player.events.trigger("screenshot", S);
            });
          });
        } }, { key: "initAirplayButton", value: function() {
          this.player.options.airplay && (window.WebKitPlaybackTargetAvailabilityEvent ? this.player.video.addEventListener("webkitplaybacktargetavailabilitychanged", (function(g) {
            g.availability === "available" ? this.template.airplayButton.disable = !1 : this.template.airplayButton.disable = !0, this.template.airplayButton.addEventListener("click", (function() {
              this.video.webkitShowPlaybackTargetPicker();
            }).bind(this));
          }).bind(this.player)) : this.player.template.airplayButton.style.display = "none");
        } }, { key: "initChromecast", value: function() {
          var g = window.document.createElement("script");
          g.setAttribute("type", "text/javascript"), g.setAttribute("src", "https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1"), window.document.body.appendChild(g), window.__onGCastApiAvailable = function(S) {
            if (S) {
              var C = new (Qt = window.chrome.cast).SessionRequest(Qt.media.DEFAULT_MEDIA_RECEIVER_APP_ID), R = new Qt.ApiConfig(C, function() {
              }, function(P) {
                P === Qt.ReceiverAvailability.AVAILABLE && console.log("chromecast: ", P);
              });
              Qt.initialize(R, function() {
              });
            }
          };
        } }, { key: "initChromecastButton", value: function() {
          var g = this;
          if (this.player.options.chromecast) {
            ms && (ms = !1, this.initChromecast());
            var S = function(R, P) {
              g.currentMedia = P;
            }, C = function(R) {
              console.error("Error launching media", R);
            };
            this.player.template.chromecastButton.addEventListener("click", function() {
              Jr ? (Jr = !1, g.currentMedia.stop(), g.session.stop(), g.initChromecast()) : (Jr = !0, Qt.requestSession(function(R) {
                var P, F, H;
                g.session = R, P = g.player.options.video.url, F = new Qt.media.MediaInfo(P), H = new Qt.media.LoadRequest(F), g.session ? g.session.loadMedia(H, S.bind(g, "loadMedia"), C).play() : window.open(P);
              }, function(R) {
                R.code === "cancel" ? g.session = void 0 : console.error("Error selecting a cast device", R);
              }));
            });
          }
        } }, { key: "initSubtitleButton", value: function() {
          var g = this;
          this.player.events.on("subtitle_show", function() {
            g.player.template.subtitleButton.dataset.balloon = g.player.tran("hide-subs"), g.player.template.subtitleButtonInner.style.opacity = "", g.player.user.set("subtitle", 1);
          }), this.player.events.on("subtitle_hide", function() {
            g.player.template.subtitleButton.dataset.balloon = g.player.tran("show-subs"), g.player.template.subtitleButtonInner.style.opacity = "0.4", g.player.user.set("subtitle", 0);
          }), this.player.template.subtitleButton.addEventListener("click", function() {
            g.player.subtitle.toggle();
          });
        } }, { key: "setAutoHide", value: function() {
          var g = this;
          this.show(), clearTimeout(this.autoHideTimer), this.autoHideTimer = setTimeout(function() {
            !g.player.video.played.length || g.player.paused || g.disableAutoHide || g.hide();
          }, 3e3);
        } }, { key: "show", value: function() {
          this.player.container.classList.remove("dplayer-hide-controller");
        } }, { key: "hide", value: function() {
          this.player.container.classList.add("dplayer-hide-controller"), this.player.setting.hide(), this.player.comment && this.player.comment.hide();
        } }, { key: "isShow", value: function() {
          return !this.player.container.classList.contains("dplayer-hide-controller");
        } }, { key: "toggle", value: function() {
          this.isShow() ? this.hide() : this.show();
        } }, { key: "destroy", value: function() {
          W.isMobile || (this.player.container.removeEventListener("mousemove", this.setAutoHideHandler), this.player.container.removeEventListener("click", this.setAutoHideHandler)), clearTimeout(this.autoHideTimer);
        } }]) && Xl(x.prototype, w), Object.defineProperty(x, "prototype", { writable: !1 }), y;
      }();
      const Zl = Ql;
      function Kn(y) {
        return Kn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
          return typeof x;
        } : function(x) {
          return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
        }, Kn(y);
      }
      function Jl(y, x) {
        for (var w = 0; w < x.length; w++) {
          var g = x[w];
          g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(y, (S = function(C, R) {
            if (Kn(C) !== "object" || C === null)
              return C;
            var P = C[Symbol.toPrimitive];
            if (P !== void 0) {
              var F = P.call(C, "string");
              if (Kn(F) !== "object")
                return F;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(C);
          }(g.key), Kn(S) === "symbol" ? S : String(S)), g);
        }
        var S;
      }
      var ed = function() {
        function y(g) {
          var S = this;
          (function(H, X) {
            if (!(H instanceof X))
              throw new TypeError("Cannot call a class as a function");
          })(this, y), this.player = g, this.player.template.mask.addEventListener("click", function() {
            S.hide();
          }), this.player.template.settingButton.addEventListener("click", function() {
            S.show();
          }), this.loop = this.player.options.loop, this.player.template.loopToggle.checked = this.loop, this.player.template.loop.addEventListener("click", function() {
            S.player.template.loopToggle.checked = !S.player.template.loopToggle.checked, S.player.template.loopToggle.checked ? S.loop = !0 : S.loop = !1, S.hide();
          }), this.showDanmaku = this.player.user.get("danmaku"), this.showDanmaku || this.player.danmaku && this.player.danmaku.hide(), this.player.template.showDanmakuToggle.checked = this.showDanmaku, this.player.template.showDanmaku.addEventListener("click", function() {
            S.player.template.showDanmakuToggle.checked = !S.player.template.showDanmakuToggle.checked, S.player.template.showDanmakuToggle.checked ? (S.showDanmaku = !0, S.player.danmaku.show()) : (S.showDanmaku = !1, S.player.danmaku.hide()), S.player.user.set("danmaku", S.showDanmaku ? 1 : 0), S.hide();
          }), this.unlimitDanmaku = this.player.user.get("unlimited"), this.player.template.unlimitDanmakuToggle.checked = this.unlimitDanmaku, this.player.template.unlimitDanmaku.addEventListener("click", function() {
            S.player.template.unlimitDanmakuToggle.checked = !S.player.template.unlimitDanmakuToggle.checked, S.player.template.unlimitDanmakuToggle.checked ? (S.unlimitDanmaku = !0, S.player.danmaku.unlimit(!0)) : (S.unlimitDanmaku = !1, S.player.danmaku.unlimit(!1)), S.player.user.set("unlimited", S.unlimitDanmaku ? 1 : 0), S.hide();
          }), this.player.template.speed.addEventListener("click", function() {
            S.player.template.settingBox.classList.add("dplayer-setting-box-narrow"), S.player.template.settingBox.classList.add("dplayer-setting-box-speed");
          });
          for (var C = function(H) {
            S.player.template.speedItem[H].addEventListener("click", function() {
              S.player.speed(S.player.template.speedItem[H].dataset.speed), S.hide();
            });
          }, R = 0; R < this.player.template.speedItem.length; R++)
            C(R);
          if (this.player.danmaku) {
            this.player.on("danmaku_opacity", function(H) {
              S.player.bar.set("danmaku", H, "width"), S.player.user.set("opacity", H);
            }), this.player.danmaku.opacity(this.player.user.get("opacity"));
            var P = function(H) {
              var X = H || window.event, ie = ((X.clientX || X.changedTouches[0].clientX) - W.getBoundingClientRectViewLeft(S.player.template.danmakuOpacityBarWrap)) / 130;
              ie = Math.max(ie, 0), ie = Math.min(ie, 1), S.player.danmaku.opacity(ie);
            }, F = function H() {
              document.removeEventListener(W.nameMap.dragEnd, H), document.removeEventListener(W.nameMap.dragMove, P), S.player.template.danmakuOpacityBox.classList.remove("dplayer-setting-danmaku-active");
            };
            this.player.template.danmakuOpacityBarWrapWrap.addEventListener("click", function(H) {
              var X = H || window.event, ie = ((X.clientX || X.changedTouches[0].clientX) - W.getBoundingClientRectViewLeft(S.player.template.danmakuOpacityBarWrap)) / 130;
              ie = Math.max(ie, 0), ie = Math.min(ie, 1), S.player.danmaku.opacity(ie);
            }), this.player.template.danmakuOpacityBarWrapWrap.addEventListener(W.nameMap.dragStart, function() {
              document.addEventListener(W.nameMap.dragMove, P), document.addEventListener(W.nameMap.dragEnd, F), S.player.template.danmakuOpacityBox.classList.add("dplayer-setting-danmaku-active");
            });
          }
        }
        var x, w;
        return x = y, (w = [{ key: "hide", value: function() {
          var g = this;
          this.player.template.settingBox.classList.remove("dplayer-setting-box-open"), this.player.template.mask.classList.remove("dplayer-mask-show"), setTimeout(function() {
            g.player.template.settingBox.classList.remove("dplayer-setting-box-narrow"), g.player.template.settingBox.classList.remove("dplayer-setting-box-speed");
          }, 300), this.player.controller.disableAutoHide = !1;
        } }, { key: "show", value: function() {
          this.player.template.settingBox.classList.add("dplayer-setting-box-open"), this.player.template.mask.classList.add("dplayer-mask-show"), this.player.controller.disableAutoHide = !0;
        } }]) && Jl(x.prototype, w), Object.defineProperty(x, "prototype", { writable: !1 }), y;
      }();
      const td = ed;
      function $n(y) {
        return $n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
          return typeof x;
        } : function(x) {
          return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
        }, $n(y);
      }
      function nd(y, x) {
        for (var w = 0; w < x.length; w++) {
          var g = x[w];
          g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(y, (S = function(C, R) {
            if ($n(C) !== "object" || C === null)
              return C;
            var P = C[Symbol.toPrimitive];
            if (P !== void 0) {
              var F = P.call(C, "string");
              if ($n(F) !== "object")
                return F;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(C);
          }(g.key), $n(S) === "symbol" ? S : String(S)), g);
        }
        var S;
      }
      var rd = function() {
        function y(g) {
          var S = this;
          (function(C, R) {
            if (!(C instanceof R))
              throw new TypeError("Cannot call a class as a function");
          })(this, y), this.player = g, this.player.template.mask.addEventListener("click", function() {
            S.hide();
          }), this.player.template.commentButton.addEventListener("click", function() {
            S.show();
          }), this.player.template.commentSettingButton.addEventListener("click", function() {
            S.toggleSetting();
          }), this.player.template.commentColorSettingBox.addEventListener("click", function() {
            if (S.player.template.commentColorSettingBox.querySelector("input:checked+span")) {
              var C = S.player.template.commentColorSettingBox.querySelector("input:checked").value;
              S.player.template.commentSettingFill.style.fill = C, S.player.template.commentInput.style.color = C, S.player.template.commentSendFill.style.fill = C;
            }
          }), this.player.template.commentInput.addEventListener("click", function() {
            S.hideSetting();
          }), this.player.template.commentInput.addEventListener("keydown", function(C) {
            (C || window.event).keyCode === 13 && S.send();
          }), this.player.template.commentSendButton.addEventListener("click", function() {
            S.send();
          });
        }
        var x, w;
        return x = y, (w = [{ key: "show", value: function() {
          this.player.controller.disableAutoHide = !0, this.player.template.controller.classList.add("dplayer-controller-comment"), this.player.template.mask.classList.add("dplayer-mask-show"), this.player.container.classList.add("dplayer-show-controller"), this.player.template.commentInput.focus();
        } }, { key: "hide", value: function() {
          this.player.template.controller.classList.remove("dplayer-controller-comment"), this.player.template.mask.classList.remove("dplayer-mask-show"), this.player.container.classList.remove("dplayer-show-controller"), this.player.controller.disableAutoHide = !1, this.hideSetting();
        } }, { key: "showSetting", value: function() {
          this.player.template.commentSettingBox.classList.add("dplayer-comment-setting-open");
        } }, { key: "hideSetting", value: function() {
          this.player.template.commentSettingBox.classList.remove("dplayer-comment-setting-open");
        } }, { key: "toggleSetting", value: function() {
          this.player.template.commentSettingBox.classList.contains("dplayer-comment-setting-open") ? this.hideSetting() : this.showSetting();
        } }, { key: "send", value: function() {
          var g = this;
          this.player.template.commentInput.blur(), this.player.template.commentInput.value.replace(/^\s+|\s+$/g, "") ? this.player.danmaku.send({ text: this.player.template.commentInput.value, color: W.color2Number(this.player.container.querySelector(".dplayer-comment-setting-color input:checked").value), type: parseInt(this.player.container.querySelector(".dplayer-comment-setting-type input:checked").value) }, function() {
            g.player.template.commentInput.value = "", g.hide();
          }) : this.player.notice(this.player.tran("please-input-danmaku"));
        } }]) && nd(x.prototype, w), Object.defineProperty(x, "prototype", { writable: !1 }), y;
      }();
      const id = rd;
      function Vn(y) {
        return Vn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
          return typeof x;
        } : function(x) {
          return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
        }, Vn(y);
      }
      function sd(y, x) {
        for (var w = 0; w < x.length; w++) {
          var g = x[w];
          g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(y, (S = function(C, R) {
            if (Vn(C) !== "object" || C === null)
              return C;
            var P = C[Symbol.toPrimitive];
            if (P !== void 0) {
              var F = P.call(C, "string");
              if (Vn(F) !== "object")
                return F;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(C);
          }(g.key), Vn(S) === "symbol" ? S : String(S)), g);
        }
        var S;
      }
      var ad = function() {
        function y(g) {
          (function(S, C) {
            if (!(S instanceof C))
              throw new TypeError("Cannot call a class as a function");
          })(this, y), this.player = g, this.doHotKeyHandler = this.doHotKey.bind(this), this.cancelFullScreenHandler = this.cancelFullScreen.bind(this), this.player.options.hotkey && document.addEventListener("keydown", this.doHotKeyHandler), document.addEventListener("keydown", this.cancelFullScreenHandler);
        }
        var x, w;
        return x = y, (w = [{ key: "doHotKey", value: function(g) {
          if (this.player.focus) {
            var S = document.activeElement.tagName.toUpperCase(), C = document.activeElement.getAttribute("contenteditable");
            if (S !== "INPUT" && S !== "TEXTAREA" && C !== "" && C !== "true") {
              var R, P = g || window.event;
              switch (P.keyCode) {
                case 32:
                  P.preventDefault(), this.player.toggle();
                  break;
                case 37:
                  if (P.preventDefault(), this.player.options.live)
                    break;
                  this.player.seek(this.player.video.currentTime - 5), this.player.controller.setAutoHide();
                  break;
                case 39:
                  if (P.preventDefault(), this.player.options.live)
                    break;
                  this.player.seek(this.player.video.currentTime + 5), this.player.controller.setAutoHide();
                  break;
                case 38:
                  P.preventDefault(), R = this.player.volume() + 0.1, this.player.volume(R);
                  break;
                case 40:
                  P.preventDefault(), R = this.player.volume() - 0.1, this.player.volume(R);
              }
            }
          }
        } }, { key: "cancelFullScreen", value: function(g) {
          (g || window.event).keyCode === 27 && this.player.fullScreen.isFullScreen("web") && this.player.fullScreen.cancel("web");
        } }, { key: "destroy", value: function() {
          this.player.options.hotkey && document.removeEventListener("keydown", this.doHotKeyHandler), document.removeEventListener("keydown", this.cancelFullScreenHandler);
        } }]) && sd(x.prototype, w), Object.defineProperty(x, "prototype", { writable: !1 }), y;
      }();
      const od = ad;
      function Wn(y) {
        return Wn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
          return typeof x;
        } : function(x) {
          return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
        }, Wn(y);
      }
      function ld(y, x) {
        for (var w = 0; w < x.length; w++) {
          var g = x[w];
          g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(y, (S = function(C, R) {
            if (Wn(C) !== "object" || C === null)
              return C;
            var P = C[Symbol.toPrimitive];
            if (P !== void 0) {
              var F = P.call(C, "string");
              if (Wn(F) !== "object")
                return F;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(C);
          }(g.key), Wn(S) === "symbol" ? S : String(S)), g);
        }
        var S;
      }
      var dd = function() {
        function y(g) {
          var S = this;
          (function(C, R) {
            if (!(C instanceof R))
              throw new TypeError("Cannot call a class as a function");
          })(this, y), this.player = g, this.shown = !1, Array.prototype.slice.call(this.player.template.menuItem).forEach(function(C, R) {
            S.player.options.contextmenu[R].click && C.addEventListener("click", function() {
              S.player.options.contextmenu[R].click(S.player), S.hide();
            });
          }), this.contextmenuHandler = function(C) {
            if (S.shown)
              S.hide();
            else {
              var R = C || window.event;
              R.preventDefault();
              var P = S.player.container.getBoundingClientRect();
              S.show(R.clientX - P.left, R.clientY - P.top), S.player.template.mask.addEventListener("click", function() {
                S.hide();
              });
            }
          }, this.player.container.addEventListener("contextmenu", this.contextmenuHandler);
        }
        var x, w;
        return x = y, (w = [{ key: "show", value: function(g, S) {
          this.player.template.menu.classList.add("dplayer-menu-show");
          var C = this.player.container.getBoundingClientRect();
          g + this.player.template.menu.offsetWidth >= C.width ? (this.player.template.menu.style.right = C.width - g + "px", this.player.template.menu.style.left = "initial") : (this.player.template.menu.style.left = g + "px", this.player.template.menu.style.right = "initial"), S + this.player.template.menu.offsetHeight >= C.height ? (this.player.template.menu.style.bottom = C.height - S + "px", this.player.template.menu.style.top = "initial") : (this.player.template.menu.style.top = S + "px", this.player.template.menu.style.bottom = "initial"), this.player.template.mask.classList.add("dplayer-mask-show"), this.shown = !0, this.player.events.trigger("contextmenu_show");
        } }, { key: "hide", value: function() {
          this.player.template.mask.classList.remove("dplayer-mask-show"), this.player.template.menu.classList.remove("dplayer-menu-show"), this.shown = !1, this.player.events.trigger("contextmenu_hide");
        } }, { key: "destroy", value: function() {
          this.player.container.removeEventListener("contextmenu", this.contextmenuHandler);
        } }]) && ld(x.prototype, w), Object.defineProperty(x, "prototype", { writable: !1 }), y;
      }();
      const cd = dd;
      function Hn(y) {
        return Hn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
          return typeof x;
        } : function(x) {
          return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
        }, Hn(y);
      }
      function ud(y, x) {
        for (var w = 0; w < x.length; w++) {
          var g = x[w];
          g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(y, (S = function(C, R) {
            if (Hn(C) !== "object" || C === null)
              return C;
            var P = C[Symbol.toPrimitive];
            if (P !== void 0) {
              var F = P.call(C, "string");
              if (Hn(F) !== "object")
                return F;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(C);
          }(g.key), Hn(S) === "symbol" ? S : String(S)), g);
        }
        var S;
      }
      var hd = function() {
        function y(g) {
          var S = this;
          (function(C, R) {
            if (!(C instanceof R))
              throw new TypeError("Cannot call a class as a function");
          })(this, y), this.container = g.template.infoPanel, this.template = g.template, this.video = g.video, this.player = g, this.template.infoPanelClose.addEventListener("click", function() {
            S.hide();
          });
        }
        var x, w;
        return x = y, (w = [{ key: "show", value: function() {
          this.beginTime = Date.now(), this.update(), this.player.timer.enable("info"), this.player.timer.enable("fps"), this.container.classList.remove("dplayer-info-panel-hide");
        } }, { key: "hide", value: function() {
          this.player.timer.disable("info"), this.player.timer.disable("fps"), this.container.classList.add("dplayer-info-panel-hide");
        } }, { key: "triggle", value: function() {
          this.container.classList.contains("dplayer-info-panel-hide") ? this.show() : this.hide();
        } }, { key: "update", value: function() {
          this.template.infoVersion.innerHTML = "v".concat("1.27.1", " ").concat("v1.27.0-12-g4f61091"), this.template.infoType.innerHTML = this.player.type, this.template.infoUrl.innerHTML = this.player.options.video.url, this.template.infoResolution.innerHTML = "".concat(this.player.video.videoWidth, " x ").concat(this.player.video.videoHeight), this.template.infoDuration.innerHTML = this.player.video.duration, this.player.options.danmaku && (this.template.infoDanmakuId.innerHTML = this.player.options.danmaku.id, this.template.infoDanmakuApi.innerHTML = this.player.options.danmaku.api, this.template.infoDanmakuAmount.innerHTML = this.player.danmaku.dan.length);
        } }, { key: "fps", value: function(g) {
          this.template.infoFPS.innerHTML = "".concat(g.toFixed(1));
        } }]) && ud(x.prototype, w), Object.defineProperty(x, "prototype", { writable: !1 }), y;
      }();
      const fd = hd;
      var pd = r(568), md = r.n(pd);
      function zn(y) {
        return zn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
          return typeof x;
        } : function(x) {
          return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
        }, zn(y);
      }
      function gs(y, x) {
        var w = Object.keys(y);
        if (Object.getOwnPropertySymbols) {
          var g = Object.getOwnPropertySymbols(y);
          x && (g = g.filter(function(S) {
            return Object.getOwnPropertyDescriptor(y, S).enumerable;
          })), w.push.apply(w, g);
        }
        return w;
      }
      function gd(y, x, w) {
        return (x = As(x)) in y ? Object.defineProperty(y, x, { value: w, enumerable: !0, configurable: !0, writable: !0 }) : y[x] = w, y;
      }
      function ys(y, x) {
        for (var w = 0; w < x.length; w++) {
          var g = x[w];
          g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(y, As(g.key), g);
        }
      }
      function As(y) {
        var x = function(w, g) {
          if (zn(w) !== "object" || w === null)
            return w;
          var S = w[Symbol.toPrimitive];
          if (S !== void 0) {
            var C = S.call(w, "string");
            if (zn(C) !== "object")
              return C;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return String(w);
        }(y);
        return zn(x) === "symbol" ? x : String(x);
      }
      var vs = 0, gn = [], yd = function() {
        function y(S) {
          var C = this;
          (function(R, P) {
            if (!(R instanceof P))
              throw new TypeError("Cannot call a class as a function");
          })(this, y), this.options = function(R) {
            var P = { container: R.element || document.getElementsByClassName("dplayer")[0], live: !1, autoplay: !1, theme: "#b7daff", loop: !1, lang: (navigator.language || navigator.browserLanguage).toLowerCase(), screenshot: !1, airplay: !0, chromecast: !1, hotkey: !0, preload: "metadata", volume: 0.7, playbackSpeed: [0.5, 0.75, 1, 1.25, 1.5, 2], apiBackend: Po, video: {}, contextmenu: [], mutex: !0, pluginOptions: { hls: {}, flv: {}, dash: {}, webtorrent: {} }, preventClickToggle: !1 };
            for (var F in P)
              P.hasOwnProperty(F) && !R.hasOwnProperty(F) && (R[F] = P[F]);
            return R.video && !R.video.type && (R.video.type = "auto"), Qr(R.danmaku) === "object" && R.danmaku && !R.danmaku.user && (R.danmaku.user = "DIYgod"), R.subtitle && (!R.subtitle.type && (R.subtitle.type = "webvtt"), !R.subtitle.fontSize && (R.subtitle.fontSize = "20px"), !R.subtitle.bottom && (R.subtitle.bottom = "40px"), !R.subtitle.color && (R.subtitle.color = "#fff")), R.video.quality && (R.video.url = R.video.quality[R.video.defaultQuality].url), R.lang && (R.lang = R.lang.toLowerCase()), R.contextmenu = R.contextmenu.concat([{ key: "video-info", click: function(H) {
              H.infoPanel.triggle();
            } }, { key: "about-author", link: "https://diygod.me" }, { text: "DPlayer v".concat("1.27.1"), link: "https://github.com/MoePlayer/DPlayer" }]), R;
          }(function(R) {
            for (var P = 1; P < arguments.length; P++) {
              var F = arguments[P] != null ? arguments[P] : {};
              P % 2 ? gs(Object(F), !0).forEach(function(H) {
                gd(R, H, F[H]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(R, Object.getOwnPropertyDescriptors(F)) : gs(Object(F)).forEach(function(H) {
                Object.defineProperty(R, H, Object.getOwnPropertyDescriptor(F, H));
              });
            }
            return R;
          }({ preload: S.video.type === "webtorrent" ? "none" : "metadata" }, S)), this.options.video.quality && (this.qualityIndex = this.options.video.defaultQuality, this.quality = this.options.video.quality[this.options.video.defaultQuality]), this.tran = new Fo(this.options.lang).tran, this.events = new Cl(), this.user = new Dl(this), this.container = this.options.container, this.noticeList = {}, this.container.classList.add("dplayer"), this.options.danmaku || this.container.classList.add("dplayer-no-danmaku"), this.options.live ? this.container.classList.add("dplayer-live") : this.container.classList.remove("dplayer-live"), W.isMobile && this.container.classList.add("dplayer-mobile"), this.arrow = this.container.offsetWidth <= 500, this.arrow && this.container.classList.add("dplayer-arrow"), this.options.subtitle && Array.isArray(this.options.subtitle.url) && (this.options.subtitle.url.push({ subtitle: "", lang: "off" }), this.options.subtitle.defaultSubtitle && (typeof this.options.subtitle.defaultSubtitle == "string" ? this.options.subtitle.index = this.options.subtitle.url.findIndex(function(R) {
            return R.lang === C.options.subtitle.defaultSubtitle || R.name === C.options.subtitle.defaultSubtitle;
          }) : typeof this.options.subtitle.defaultSubtitle == "number" && (this.options.subtitle.index = this.options.subtitle.defaultSubtitle)), (this.options.subtitle.index === -1 || !this.options.subtitle.index || this.options.subtitle.index > this.options.subtitle.url.length - 1) && (this.options.subtitle.index = this.options.subtitle.url.findIndex(function(R) {
            return R.lang === C.options.lang;
          })), this.options.subtitle.index === -1 && (this.options.subtitle.index = this.options.subtitle.url.length - 1)), this.template = new ps({ container: this.container, options: this.options, index: vs, tran: this.tran }), this.video = this.template.video, this.bar = new Gl(this.template), this.bezel = new Hl(this.template.bezel), this.fullScreen = new Rl(this), this.controller = new Zl(this), this.options.danmaku && (this.danmaku = new Sl({ player: this, container: this.template.danmaku, opacity: this.user.get("opacity"), callback: function() {
            setTimeout(function() {
              C.template.danmakuLoading.style.display = "none", C.options.autoplay && C.play();
            }, 0);
          }, error: function(R) {
            C.notice(R);
          }, apiBackend: this.options.apiBackend, borderColor: this.options.theme, height: this.arrow ? 24 : 30, time: function() {
            return C.video.currentTime;
          }, unlimited: this.user.get("unlimited"), api: { id: this.options.danmaku.id, address: this.options.danmaku.api, token: this.options.danmaku.token, maximum: this.options.danmaku.maximum, addition: this.options.danmaku.addition, user: this.options.danmaku.user, speedRate: this.options.danmaku.speedRate }, events: this.events, tran: function(R) {
            return C.tran(R);
          } }), this.comment = new id(this)), this.setting = new td(this), this.plugins = {}, this.docClickFun = function() {
            C.focus = !1;
          }, this.containerClickFun = function() {
            C.focus = !0;
          }, document.addEventListener("click", this.docClickFun, !0), this.container.addEventListener("click", this.containerClickFun, !0), this.paused = !0, this.timer = new Vl(this), this.hotkey = new od(this), this.contextmenu = new cd(this), this.initVideo(this.video, this.quality && this.quality.type || this.options.video.type), this.infoPanel = new fd(this), !this.danmaku && this.options.autoplay && this.play(), vs++, gn.push(this);
        }
        var x, w, g;
        return x = y, w = [{ key: "seek", value: function(S) {
          S = Math.max(S, 0), this.video.duration && (S = Math.min(S, this.video.duration)), this.video.currentTime < S ? this.notice("".concat(this.tran("ff").replace("%s", (S - this.video.currentTime).toFixed(0)))) : this.video.currentTime > S && this.notice("".concat(this.tran("rew").replace("%s", (this.video.currentTime - S).toFixed(0)))), this.video.currentTime = S, this.danmaku && this.danmaku.seek(), this.bar.set("played", S / this.video.duration, "width"), this.template.ptime.innerHTML = W.secondToTime(S);
        } }, { key: "play", value: function(S) {
          var C = this;
          if (this.paused = !1, this.video.paused && !W.isMobile && this.bezel.switch(Rt.play), this.template.playButton.innerHTML = Rt.pause, this.template.mobilePlayButton.innerHTML = Rt.pause, S || J.resolve(this.video.play()).catch(function() {
            C.pause();
          }).then(function() {
          }), this.timer.enable("loading"), this.container.classList.remove("dplayer-paused"), this.container.classList.add("dplayer-playing"), this.danmaku && this.danmaku.play(), this.options.mutex)
            for (var R = 0; R < gn.length; R++)
              this !== gn[R] && gn[R].pause();
        } }, { key: "pause", value: function(S) {
          this.paused = !0, this.container.classList.remove("dplayer-loading"), this.video.paused || W.isMobile || this.bezel.switch(Rt.pause), this.template.playButton.innerHTML = Rt.play, this.template.mobilePlayButton.innerHTML = Rt.play, S || this.video.pause(), this.timer.disable("loading"), this.container.classList.remove("dplayer-playing"), this.container.classList.add("dplayer-paused"), this.danmaku && this.danmaku.pause();
        } }, { key: "switchVolumeIcon", value: function() {
          this.volume() >= 0.95 ? this.template.volumeIcon.innerHTML = Rt.volumeUp : this.volume() > 0 ? this.template.volumeIcon.innerHTML = Rt.volumeDown : this.template.volumeIcon.innerHTML = Rt.volumeOff;
        } }, { key: "volume", value: function(S, C, R) {
          if (S = parseFloat(S), !isNaN(S)) {
            S = Math.max(S, 0), S = Math.min(S, 1), this.bar.set("volume", S, "width");
            var P = "".concat((100 * S).toFixed(0), "%");
            this.template.volumeBarWrapWrap.dataset.balloon = P, C || this.user.set("volume", S), R || this.notice("".concat(this.tran("volume"), " ").concat((100 * S).toFixed(0), "%"), void 0, void 0, "volume"), this.video.volume = S, this.video.muted && (this.video.muted = !1), this.switchVolumeIcon();
          }
          return this.video.volume;
        } }, { key: "toggle", value: function() {
          this.video.paused ? this.play() : this.pause();
        } }, { key: "on", value: function(S, C) {
          this.events.on(S, C);
        } }, { key: "switchVideo", value: function(S, C) {
          this.pause(), this.video.poster = S.pic ? S.pic : "", this.video.src = S.url, this.initMSE(this.video, S.type || "auto"), C && (this.template.danmakuLoading.style.display = "block", this.bar.set("played", 0, "width"), this.bar.set("loaded", 0, "width"), this.template.ptime.innerHTML = "00:00", this.template.danmaku.innerHTML = "", this.danmaku && this.danmaku.reload({ id: C.id, address: C.api, token: C.token, maximum: C.maximum, addition: C.addition, user: C.user }));
        } }, { key: "initMSE", value: function(S, C) {
          var R = this;
          if (this.type = C, this.options.video.customType && this.options.video.customType[C])
            Object.prototype.toString.call(this.options.video.customType[C]) === "[object Function]" ? this.options.video.customType[C](this.video, this) : console.error("Illegal customType: ".concat(C));
          else
            switch (this.type === "auto" && (/m3u8(#|\?|$)/i.exec(S.src) ? this.type = "hls" : /.flv(#|\?|$)/i.exec(S.src) ? this.type = "flv" : /.mpd(#|\?|$)/i.exec(S.src) ? this.type = "dash" : this.type = "normal"), this.type === "hls" && (S.canPlayType("application/x-mpegURL") || S.canPlayType("application/vnd.apple.mpegURL")) && (this.type = "normal"), this.type) {
              case "hls":
                if (window.Hls)
                  if (window.Hls.isSupported()) {
                    var P = this.options.pluginOptions.hls, F = new window.Hls(P);
                    this.plugins.hls = F, F.loadSource(S.src), F.attachMedia(S), this.events.on("destroy", function() {
                      F.destroy(), delete R.plugins.hls;
                    });
                  } else
                    this.notice("Error: Hls is not supported.");
                else
                  this.notice("Error: Can't find Hls.");
                break;
              case "flv":
                if (window.flvjs)
                  if (window.flvjs.isSupported()) {
                    var H = window.flvjs.createPlayer(Object.assign(this.options.pluginOptions.flv.mediaDataSource || {}, { type: "flv", url: S.src }), this.options.pluginOptions.flv.config);
                    this.plugins.flvjs = H, H.attachMediaElement(S), H.load(), this.events.on("destroy", function() {
                      H.unload(), H.detachMediaElement(), H.destroy(), delete R.plugins.flvjs;
                    });
                  } else
                    this.notice("Error: flvjs is not supported.");
                else
                  this.notice("Error: Can't find flvjs.");
                break;
              case "dash":
                if (window.dashjs) {
                  var X = window.dashjs.MediaPlayer().create().initialize(S, S.src, !1), ie = this.options.pluginOptions.dash;
                  X.updateSettings(ie), this.plugins.dash = X, this.events.on("destroy", function() {
                    window.dashjs.MediaPlayer().reset(), delete R.plugins.dash;
                  });
                } else
                  this.notice("Error: Can't find dashjs.");
                break;
              case "webtorrent":
                if (window.WebTorrent)
                  if (window.WebTorrent.WEBRTC_SUPPORT) {
                    this.container.classList.add("dplayer-loading");
                    var oe = this.options.pluginOptions.webtorrent, he = new window.WebTorrent(oe);
                    this.plugins.webtorrent = he;
                    var de = S.src;
                    S.src = "", S.preload = "metadata", S.addEventListener("durationchange", function() {
                      return R.container.classList.remove("dplayer-loading");
                    }, { once: !0 }), he.add(de, function(se) {
                      se.files.find(function(pe) {
                        return pe.name.endsWith(".mp4");
                      }).renderTo(R.video, { autoplay: R.options.autoplay, controls: !1 });
                    }), this.events.on("destroy", function() {
                      he.remove(de), he.destroy(), delete R.plugins.webtorrent;
                    });
                  } else
                    this.notice("Error: Webtorrent is not supported.");
                else
                  this.notice("Error: Can't find Webtorrent.");
            }
        } }, { key: "initVideo", value: function(S, C) {
          var R = this;
          this.initMSE(S, C), this.on("durationchange", function() {
            S.duration !== 1 && S.duration !== 1 / 0 && (R.template.dtime.innerHTML = W.secondToTime(S.duration));
          }), this.on("progress", function() {
            var H = S.buffered.length ? S.buffered.end(S.buffered.length - 1) / S.duration : 0;
            R.bar.set("loaded", H, "width");
          }), this.on("error", function() {
            R.video.error && R.tran && R.notice && R.type !== "webtorrent" && R.notice(R.tran("video-failed"));
          }), this.on("ended", function() {
            R.bar.set("played", 1, "width"), R.setting.loop ? (R.seek(0), R.play()) : R.pause(), R.danmaku && (R.danmaku.danIndex = 0);
          }), this.on("play", function() {
            R.paused && R.play(!0);
          }), this.on("pause", function() {
            R.paused || R.pause(!0);
          }), this.on("timeupdate", function() {
            R.bar.set("played", R.video.currentTime / R.video.duration, "width");
            var H = W.secondToTime(R.video.currentTime);
            R.template.ptime.innerHTML !== H && (R.template.ptime.innerHTML = H);
          });
          for (var P = function(H) {
            S.addEventListener(R.events.videoEvents[H], function(X) {
              R.events.trigger(R.events.videoEvents[H], X);
            });
          }, F = 0; F < this.events.videoEvents.length; F++)
            P(F);
          this.volume(this.user.get("volume"), !0, !0), this.options.subtitle && (this.subtitle = new Pl(this.template.subtitle, this.video, this.options.subtitle, this.events), Array.isArray(this.options.subtitle.url) && (this.subtitles = new Ul(this)), this.user.get("subtitle") || this.subtitle.hide());
        } }, { key: "switchQuality", value: function(S) {
          var C = this;
          if (S = typeof S == "string" ? parseInt(S) : S, this.qualityIndex !== S && !this.switchingQuality) {
            this.prevIndex = this.qualityIndex, this.qualityIndex = S, this.switchingQuality = !0, this.quality = this.options.video.quality[S], this.template.qualityButton.innerHTML = this.quality.name;
            var R = this.video.paused;
            this.video.pause();
            var P = md()({ current: !1, pic: null, screenshot: this.options.screenshot, preload: "auto", url: this.quality.url, subtitle: this.options.subtitle }), F = new DOMParser().parseFromString(P, "text/html").body.firstChild;
            this.template.videoWrap.insertBefore(F, this.template.videoWrap.getElementsByTagName("div")[0]), this.prevVideo = this.video, this.video = F, this.initVideo(this.video, this.quality.type || this.options.video.type), this.seek(this.prevVideo.currentTime), this.notice("".concat(this.tran("switching-quality").replace("%q", this.quality.name)), -1, void 0, "switch-quality"), this.events.trigger("quality_start", this.quality), this.on("canplay", function() {
              if (C.prevVideo) {
                if (C.video.currentTime !== C.prevVideo.currentTime)
                  return void C.seek(C.prevVideo.currentTime);
                C.template.videoWrap.removeChild(C.prevVideo), C.video.classList.add("dplayer-video-current"), R || C.video.play(), C.prevVideo = null, C.notice("".concat(C.tran("switched-quality").replace("%q", C.quality.name)), void 0, void 0, "switch-quality"), C.switchingQuality = !1, C.events.trigger("quality_end");
              }
            }), this.on("error", function() {
              C.video.error && C.prevVideo && (C.template.videoWrap.removeChild(C.video), C.video = C.prevVideo, R || C.video.play(), C.qualityIndex = C.prevIndex, C.quality = C.options.video.quality[C.qualityIndex], C.noticeTime = setTimeout(function() {
                C.template.notice.style.opacity = 0, C.events.trigger("notice_hide");
              }, 3e3), C.prevVideo = null, C.switchingQuality = !1);
            });
          }
        } }, { key: "notice", value: function(S) {
          var C, R, P, F = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2e3, H = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0.8, X = arguments.length > 3 ? arguments[3] : void 0;
          if (X && ((C = document.getElementById("dplayer-notice-".concat(X))) && (C.innerHTML = S), this.noticeList[X] && (clearTimeout(this.noticeList[X]), this.noticeList[X] = null)), !C) {
            var ie = ps.NewNotice(S, H, X);
            this.template.noticeList.appendChild(ie), C = ie;
          }
          this.events.trigger("notice_show", C), F > 0 && (this.noticeList[X] = setTimeout((R = C, P = this, function() {
            R.addEventListener("animationend", function() {
              P.template.noticeList.removeChild(R);
            }), R.classList.add("remove-notice"), P.events.trigger("notice_hide"), P.noticeList[X] = null;
          }), F));
        } }, { key: "resize", value: function() {
          this.danmaku && this.danmaku.resize(), this.controller.thumbnails && this.controller.thumbnails.resize(160, this.video.videoHeight / this.video.videoWidth * 160, this.template.barWrap.offsetWidth), this.events.trigger("resize");
        } }, { key: "speed", value: function(S) {
          this.video.playbackRate = S;
        } }, { key: "destroy", value: function() {
          gn.splice(gn.indexOf(this), 1), this.pause(), document.removeEventListener("click", this.docClickFun, !0), this.container.removeEventListener("click", this.containerClickFun, !0), this.fullScreen.destroy(), this.hotkey.destroy(), this.contextmenu.destroy(), this.controller.destroy(), this.timer.destroy(), this.video.src = "", this.container.innerHTML = "", this.events.trigger("destroy");
        } }], g = [{ key: "version", get: function() {
          return "1.27.1";
        } }], w && ys(x.prototype, w), g && ys(x, g), Object.defineProperty(x, "prototype", { writable: !1 }), y;
      }();
      const Ad = yd;
      console.log(`
`.concat(" %c DPlayer v", "1.27.1", " ").concat("v1.27.0-12-g4f61091", " %c https://dplayer.diygod.dev ", `
`, `
`), "color: #fadfa3; background: #030307; padding:5px 0;", "background: #fadfa3; padding:5px 0;");
      const vd = Ad;
    })(), i.default;
  })());
})(_a);
var Nd = _a.exports;
const jd = /* @__PURE__ */ Fi(Nd), Sa = (o = "", e = "-") => {
  const t = (r) => o && r ? `${o}${e}${r}` : r, n = (r) => {
    if (typeof r == "string" || typeof r == "number")
      return t(r);
    if (Array.isArray(r) && r.length)
      return r.map(n);
    if (r != null && typeof r == "object") {
      const i = {};
      return Object.entries(r).forEach(([s, a]) => {
        i[t(s)] = a;
      }), i;
    }
    return r;
  };
  return (...r) => r.length === 0 ? o : Ui(...r.map(n));
}, Gd = Sa("rc-dplayer"), _s = ({
  position: o,
  children: e,
  playerDom: t
}) => {
  var n;
  if (e) {
    const r = (n = t || document.body) == null ? void 0 : n.querySelector(
      `.dplayer-icons-${o}`
    );
    return r ? Td(e, r) : null;
  }
  return null;
}, Kd = ({
  customControllers: o,
  dom: e
}) => {
  const [t, n] = Dd(
    () => [
      o.filter((i) => i.position === "left"),
      o.filter((i) => i.position === "right")
    ],
    [o]
  ), r = Mi(
    (i) => i.map(({ key: s, component: a, onClick: l }) => /* @__PURE__ */ Ut.jsx("div", { className: "dplayer-icon", onClick: l, children: /* @__PURE__ */ Ut.jsx(
      "span",
      {
        className: Ui(
          "dplayer-icon-content",
          `${Gd("controller")}`
        ),
        children: a
      }
    ) }, s))
  );
  return /* @__PURE__ */ Ut.jsxs(Ut.Fragment, { children: [
    /* @__PURE__ */ Ut.jsx(_s, { position: "left", playerDom: e.current, children: r(t) }),
    /* @__PURE__ */ Ut.jsx(_s, { position: "right", playerDom: e.current, children: r(n) })
  ] });
};
var un = /* @__PURE__ */ ((o) => (o.hls = "m3u8", o.flv = "flv", o.default = "default", o))(un || {}), Ce = /* @__PURE__ */ ((o) => (o.abort = "abort", o.canplay = "canplay", o.canplaythrough = "canplaythrough", o.durationchange = "durationchange", o.emptied = "emptied", o.ended = "ended", o.error = "error", o.loadeddata = "loadeddata", o.loadedmetadata = "loadedmetadata", o.loadstart = "loadstart", o.mozaudioavailable = "mozaudioavailable", o.pause = "pause", o.play = "play", o.playing = "playing", o.progress = "progress", o.ratechange = "ratechange", o.seeked = "seeked", o.seeking = "seeking", o.stalled = "stalled", o.suspend = "suspend", o.timeupdate = "timeupdate", o.volumechange = "volumechange", o.waiting = "waiting", o.screenshot = "screenshot", o.thumbnails_show = "thumbnails_show", o.thumbnails_hide = "thumbnails_hide", o.danmaku_show = "danmaku_show", o.danmaku_hide = "danmaku_hide", o.danmaku_clear = "danmaku_clear", o.danmaku_loaded = "danmaku_loaded", o.danmaku_send = "danmaku_send", o.danmaku_opacity = "danmaku_opacity", o.contextmenu_show = "contextmenu_show", o.contextmenu_hide = "contextmenu_hide", o.notice_show = "notice_show", o.notice_hide = "notice_hide", o.quality_start = "quality_start", o.quality_end = "quality_end", o.destroy = "destroy", o.resize = "resize", o.fullscreen = "fullscreen", o.fullscreen_cancel = "fullscreen_cancel", o.subtitle_show = "subtitle_show", o.subtitle_hide = "subtitle_hide", o.subtitle_change = "subtitle_change", o))(Ce || {});
const $d = (o) => {
  const e = (t, n, r) => {
    r && t.on(n, r);
  };
  return Mi((t) => {
    e(t, Ce.abort, o.onAbort), e(t, Ce.canplay, o.onCanPlay), e(t, Ce.canplaythrough, o.onCanPlayThrough), e(t, Ce.durationchange, o.onDurationChange), e(t, Ce.emptied, o.onEmptied), e(t, Ce.ended, o.onEnded), e(t, Ce.error, o.onError), e(t, Ce.loadeddata, o.onLoadedData), e(t, Ce.loadedmetadata, o.onLoadedMetadata), e(t, Ce.loadstart, o.onLoadStart), e(t, Ce.pause, o.onPause), e(t, Ce.play, o.onPlay), e(t, Ce.playing, o.onPlaying), e(t, Ce.progress, o.onProgress), e(t, Ce.ratechange, o.onRateChange), e(t, Ce.seeked, o.onSeeked), e(t, Ce.seeking, o.onSeeking), e(t, Ce.stalled, o.onStalled), e(t, Ce.suspend, o.onSuspend), e(t, Ce.timeupdate, o.onTimeUpdate), e(t, Ce.volumechange, o.onVolumeChange), e(t, Ce.waiting, o.onWaiting), e(t, Ce.resize, o.onResize), e(t, Ce.screenshot, o.onScreenshot), e(t, Ce.thumbnails_show, o.onThumbnailsShow), e(t, Ce.thumbnails_hide, o.onThumbnailsHide), e(t, Ce.danmaku_show, o.onDanmakuShow), e(t, Ce.danmaku_hide, o.onDanmakuHide), e(t, Ce.danmaku_clear, o.onDanmakuClear), e(t, Ce.danmaku_loaded, o.onDanmakuLoaded), e(t, Ce.danmaku_send, o.onDanmakuSend), e(t, Ce.danmaku_opacity, o.onDanmakuOpacity), e(t, Ce.contextmenu_show, o.onContextmenuShow), e(t, Ce.contextmenu_hide, o.onContextmenuHide), e(t, Ce.notice_show, o.onNoticeShow), e(t, Ce.notice_hide, o.onNoticeHide), e(t, Ce.quality_start, o.onQualityStart), e(t, Ce.quality_end, o.onQualityEnd), e(t, Ce.destroy, o.onDestroy), e(t, Ce.fullscreen, o.onFullscreen), e(
      t,
      Ce.fullscreen_cancel,
      o.onFullscreenCancel
    ), e(t, Ce.subtitle_show, o.onSubtitleShow), e(t, Ce.subtitle_hide, o.onSubtitleHide), e(t, Ce.subtitle_change, o.onSubtitleChange);
  });
};
function Vd(o) {
  return o && o.__esModule && Object.prototype.hasOwnProperty.call(o, "default") ? o.default : o;
}
var Ta = { exports: {} };
(function(o, e) {
  (function(t) {
    var n = /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/, r = /^(?=([^\/?#]*))\1([^]*)$/, i = /(?:\/|^)\.(?=\/)/g, s = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g, a = {
      // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
      // E.g
      // With opts.alwaysNormalize = false (default, spec compliant)
      // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
      // With opts.alwaysNormalize = true (not spec compliant)
      // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
      buildAbsoluteURL: function(l, d, h) {
        if (h = h || {}, l = l.trim(), d = d.trim(), !d) {
          if (!h.alwaysNormalize)
            return l;
          var u = a.parseURL(l);
          if (!u)
            throw new Error("Error trying to parse base URL.");
          return u.path = a.normalizePath(
            u.path
          ), a.buildURLFromParts(u);
        }
        var c = a.parseURL(d);
        if (!c)
          throw new Error("Error trying to parse relative URL.");
        if (c.scheme)
          return h.alwaysNormalize ? (c.path = a.normalizePath(c.path), a.buildURLFromParts(c)) : d;
        var m = a.parseURL(l);
        if (!m)
          throw new Error("Error trying to parse base URL.");
        if (!m.netLoc && m.path && m.path[0] !== "/") {
          var f = r.exec(m.path);
          m.netLoc = f[1], m.path = f[2];
        }
        m.netLoc && !m.path && (m.path = "/");
        var p = {
          // 2c) Otherwise, the embedded URL inherits the scheme of
          // the base URL.
          scheme: m.scheme,
          netLoc: c.netLoc,
          path: null,
          params: c.params,
          query: c.query,
          fragment: c.fragment
        };
        if (!c.netLoc && (p.netLoc = m.netLoc, c.path[0] !== "/"))
          if (!c.path)
            p.path = m.path, c.params || (p.params = m.params, c.query || (p.query = m.query));
          else {
            var A = m.path, v = A.substring(0, A.lastIndexOf("/") + 1) + c.path;
            p.path = a.normalizePath(v);
          }
        return p.path === null && (p.path = h.alwaysNormalize ? a.normalizePath(c.path) : c.path), a.buildURLFromParts(p);
      },
      parseURL: function(l) {
        var d = n.exec(l);
        return d ? {
          scheme: d[1] || "",
          netLoc: d[2] || "",
          path: d[3] || "",
          params: d[4] || "",
          query: d[5] || "",
          fragment: d[6] || ""
        } : null;
      },
      normalizePath: function(l) {
        for (l = l.split("").reverse().join("").replace(i, ""); l.length !== (l = l.replace(s, "")).length; )
          ;
        return l.split("").reverse().join("");
      },
      buildURLFromParts: function(l) {
        return l.scheme + l.netLoc + l.path + l.params + l.query + l.fragment;
      }
    };
    o.exports = a;
  })();
})(Ta);
var Ni = Ta.exports;
function Ss(o, e) {
  var t = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(o);
    e && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(o, r).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function it(o) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Ss(Object(t), !0).forEach(function(n) {
      Wd(o, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(t)) : Ss(Object(t)).forEach(function(n) {
      Object.defineProperty(o, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return o;
}
function Wd(o, e, t) {
  return e = zd(e), e in o ? Object.defineProperty(o, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : o[e] = t, o;
}
function lt() {
  return lt = Object.assign ? Object.assign.bind() : function(o) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    }
    return o;
  }, lt.apply(this, arguments);
}
function Hd(o, e) {
  if (typeof o != "object" || o === null)
    return o;
  var t = o[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(o, e || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function zd(o) {
  var e = Hd(o, "string");
  return typeof e == "symbol" ? e : String(e);
}
const ge = Number.isFinite || function(o) {
  return typeof o == "number" && isFinite(o);
};
let I = /* @__PURE__ */ function(o) {
  return o.MEDIA_ATTACHING = "hlsMediaAttaching", o.MEDIA_ATTACHED = "hlsMediaAttached", o.MEDIA_DETACHING = "hlsMediaDetaching", o.MEDIA_DETACHED = "hlsMediaDetached", o.BUFFER_RESET = "hlsBufferReset", o.BUFFER_CODECS = "hlsBufferCodecs", o.BUFFER_CREATED = "hlsBufferCreated", o.BUFFER_APPENDING = "hlsBufferAppending", o.BUFFER_APPENDED = "hlsBufferAppended", o.BUFFER_EOS = "hlsBufferEos", o.BUFFER_FLUSHING = "hlsBufferFlushing", o.BUFFER_FLUSHED = "hlsBufferFlushed", o.MANIFEST_LOADING = "hlsManifestLoading", o.MANIFEST_LOADED = "hlsManifestLoaded", o.MANIFEST_PARSED = "hlsManifestParsed", o.LEVEL_SWITCHING = "hlsLevelSwitching", o.LEVEL_SWITCHED = "hlsLevelSwitched", o.LEVEL_LOADING = "hlsLevelLoading", o.LEVEL_LOADED = "hlsLevelLoaded", o.LEVEL_UPDATED = "hlsLevelUpdated", o.LEVEL_PTS_UPDATED = "hlsLevelPtsUpdated", o.LEVELS_UPDATED = "hlsLevelsUpdated", o.AUDIO_TRACKS_UPDATED = "hlsAudioTracksUpdated", o.AUDIO_TRACK_SWITCHING = "hlsAudioTrackSwitching", o.AUDIO_TRACK_SWITCHED = "hlsAudioTrackSwitched", o.AUDIO_TRACK_LOADING = "hlsAudioTrackLoading", o.AUDIO_TRACK_LOADED = "hlsAudioTrackLoaded", o.SUBTITLE_TRACKS_UPDATED = "hlsSubtitleTracksUpdated", o.SUBTITLE_TRACKS_CLEARED = "hlsSubtitleTracksCleared", o.SUBTITLE_TRACK_SWITCH = "hlsSubtitleTrackSwitch", o.SUBTITLE_TRACK_LOADING = "hlsSubtitleTrackLoading", o.SUBTITLE_TRACK_LOADED = "hlsSubtitleTrackLoaded", o.SUBTITLE_FRAG_PROCESSED = "hlsSubtitleFragProcessed", o.CUES_PARSED = "hlsCuesParsed", o.NON_NATIVE_TEXT_TRACKS_FOUND = "hlsNonNativeTextTracksFound", o.INIT_PTS_FOUND = "hlsInitPtsFound", o.FRAG_LOADING = "hlsFragLoading", o.FRAG_LOAD_EMERGENCY_ABORTED = "hlsFragLoadEmergencyAborted", o.FRAG_LOADED = "hlsFragLoaded", o.FRAG_DECRYPTED = "hlsFragDecrypted", o.FRAG_PARSING_INIT_SEGMENT = "hlsFragParsingInitSegment", o.FRAG_PARSING_USERDATA = "hlsFragParsingUserdata", o.FRAG_PARSING_METADATA = "hlsFragParsingMetadata", o.FRAG_PARSED = "hlsFragParsed", o.FRAG_BUFFERED = "hlsFragBuffered", o.FRAG_CHANGED = "hlsFragChanged", o.FPS_DROP = "hlsFpsDrop", o.FPS_DROP_LEVEL_CAPPING = "hlsFpsDropLevelCapping", o.MAX_AUTO_LEVEL_UPDATED = "hlsMaxAutoLevelUpdated", o.ERROR = "hlsError", o.DESTROYING = "hlsDestroying", o.KEY_LOADING = "hlsKeyLoading", o.KEY_LOADED = "hlsKeyLoaded", o.LIVE_BACK_BUFFER_REACHED = "hlsLiveBackBufferReached", o.BACK_BUFFER_REACHED = "hlsBackBufferReached", o.STEERING_MANIFEST_LOADED = "hlsSteeringManifestLoaded", o;
}({}), xe = /* @__PURE__ */ function(o) {
  return o.NETWORK_ERROR = "networkError", o.MEDIA_ERROR = "mediaError", o.KEY_SYSTEM_ERROR = "keySystemError", o.MUX_ERROR = "muxError", o.OTHER_ERROR = "otherError", o;
}({}), q = /* @__PURE__ */ function(o) {
  return o.KEY_SYSTEM_NO_KEYS = "keySystemNoKeys", o.KEY_SYSTEM_NO_ACCESS = "keySystemNoAccess", o.KEY_SYSTEM_NO_SESSION = "keySystemNoSession", o.KEY_SYSTEM_NO_CONFIGURED_LICENSE = "keySystemNoConfiguredLicense", o.KEY_SYSTEM_LICENSE_REQUEST_FAILED = "keySystemLicenseRequestFailed", o.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED = "keySystemServerCertificateRequestFailed", o.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED = "keySystemServerCertificateUpdateFailed", o.KEY_SYSTEM_SESSION_UPDATE_FAILED = "keySystemSessionUpdateFailed", o.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED = "keySystemStatusOutputRestricted", o.KEY_SYSTEM_STATUS_INTERNAL_ERROR = "keySystemStatusInternalError", o.MANIFEST_LOAD_ERROR = "manifestLoadError", o.MANIFEST_LOAD_TIMEOUT = "manifestLoadTimeOut", o.MANIFEST_PARSING_ERROR = "manifestParsingError", o.MANIFEST_INCOMPATIBLE_CODECS_ERROR = "manifestIncompatibleCodecsError", o.LEVEL_EMPTY_ERROR = "levelEmptyError", o.LEVEL_LOAD_ERROR = "levelLoadError", o.LEVEL_LOAD_TIMEOUT = "levelLoadTimeOut", o.LEVEL_PARSING_ERROR = "levelParsingError", o.LEVEL_SWITCH_ERROR = "levelSwitchError", o.AUDIO_TRACK_LOAD_ERROR = "audioTrackLoadError", o.AUDIO_TRACK_LOAD_TIMEOUT = "audioTrackLoadTimeOut", o.SUBTITLE_LOAD_ERROR = "subtitleTrackLoadError", o.SUBTITLE_TRACK_LOAD_TIMEOUT = "subtitleTrackLoadTimeOut", o.FRAG_LOAD_ERROR = "fragLoadError", o.FRAG_LOAD_TIMEOUT = "fragLoadTimeOut", o.FRAG_DECRYPT_ERROR = "fragDecryptError", o.FRAG_PARSING_ERROR = "fragParsingError", o.FRAG_GAP = "fragGap", o.REMUX_ALLOC_ERROR = "remuxAllocError", o.KEY_LOAD_ERROR = "keyLoadError", o.KEY_LOAD_TIMEOUT = "keyLoadTimeOut", o.BUFFER_ADD_CODEC_ERROR = "bufferAddCodecError", o.BUFFER_INCOMPATIBLE_CODECS_ERROR = "bufferIncompatibleCodecsError", o.BUFFER_APPEND_ERROR = "bufferAppendError", o.BUFFER_APPENDING_ERROR = "bufferAppendingError", o.BUFFER_STALLED_ERROR = "bufferStalledError", o.BUFFER_FULL_ERROR = "bufferFullError", o.BUFFER_SEEK_OVER_HOLE = "bufferSeekOverHole", o.BUFFER_NUDGE_ON_STALL = "bufferNudgeOnStall", o.INTERNAL_EXCEPTION = "internalException", o.INTERNAL_ABORTED = "aborted", o.UNKNOWN = "unknown", o;
}({});
const ln = function() {
}, Ei = {
  trace: ln,
  debug: ln,
  log: ln,
  warn: ln,
  info: ln,
  error: ln
};
let Zn = Ei;
function Yd(o) {
  const e = self.console[o];
  return e ? e.bind(self.console, `[${o}] >`) : ln;
}
function qd(o, ...e) {
  e.forEach(function(t) {
    Zn[t] = o[t] ? o[t].bind(o) : Yd(t);
  });
}
function Xd(o, e) {
  if (self.console && o === !0 || typeof o == "object") {
    qd(
      o,
      // Remove out from list here to hard-disable a log-level
      // 'trace',
      "debug",
      "log",
      "info",
      "warn",
      "error"
    );
    try {
      Zn.log(`Debug logs enabled for "${e}" in hls.js version ${void 0}`);
    } catch {
      Zn = Ei;
    }
  } else
    Zn = Ei;
}
const V = Zn, Qd = /^(\d+)x(\d+)$/, Ts = /(.+?)=(".*?"|.*?)(?:,|$)/g;
class Ze {
  constructor(e) {
    typeof e == "string" && (e = Ze.parseAttrList(e));
    for (const t in e)
      e.hasOwnProperty(t) && (t.substring(0, 2) === "X-" && (this.clientAttrs = this.clientAttrs || [], this.clientAttrs.push(t)), this[t] = e[t]);
  }
  decimalInteger(e) {
    const t = parseInt(this[e], 10);
    return t > Number.MAX_SAFE_INTEGER ? 1 / 0 : t;
  }
  hexadecimalInteger(e) {
    if (this[e]) {
      let t = (this[e] || "0x").slice(2);
      t = (t.length & 1 ? "0" : "") + t;
      const n = new Uint8Array(t.length / 2);
      for (let r = 0; r < t.length / 2; r++)
        n[r] = parseInt(t.slice(r * 2, r * 2 + 2), 16);
      return n;
    } else
      return null;
  }
  hexadecimalIntegerAsNumber(e) {
    const t = parseInt(this[e], 16);
    return t > Number.MAX_SAFE_INTEGER ? 1 / 0 : t;
  }
  decimalFloatingPoint(e) {
    return parseFloat(this[e]);
  }
  optionalFloat(e, t) {
    const n = this[e];
    return n ? parseFloat(n) : t;
  }
  enumeratedString(e) {
    return this[e];
  }
  bool(e) {
    return this[e] === "YES";
  }
  decimalResolution(e) {
    const t = Qd.exec(this[e]);
    if (t !== null)
      return {
        width: parseInt(t[1], 10),
        height: parseInt(t[2], 10)
      };
  }
  static parseAttrList(e) {
    let t;
    const n = {}, r = '"';
    for (Ts.lastIndex = 0; (t = Ts.exec(e)) !== null; ) {
      let i = t[2];
      i.indexOf(r) === 0 && i.lastIndexOf(r) === i.length - 1 && (i = i.slice(1, -1));
      const s = t[1].trim();
      n[s] = i;
    }
    return n;
  }
}
function Zd(o) {
  return o !== "ID" && o !== "CLASS" && o !== "START-DATE" && o !== "DURATION" && o !== "END-DATE" && o !== "END-ON-NEXT";
}
function Jd(o) {
  return o === "SCTE35-OUT" || o === "SCTE35-IN";
}
class Ca {
  constructor(e, t) {
    if (this.attr = void 0, this._startDate = void 0, this._endDate = void 0, this._badValueForSameId = void 0, t) {
      const n = t.attr;
      for (const r in n)
        if (Object.prototype.hasOwnProperty.call(e, r) && e[r] !== n[r]) {
          V.warn(`DATERANGE tag attribute: "${r}" does not match for tags with ID: "${e.ID}"`), this._badValueForSameId = r;
          break;
        }
      e = lt(new Ze({}), n, e);
    }
    if (this.attr = e, this._startDate = new Date(e["START-DATE"]), "END-DATE" in this.attr) {
      const n = new Date(this.attr["END-DATE"]);
      ge(n.getTime()) && (this._endDate = n);
    }
  }
  get id() {
    return this.attr.ID;
  }
  get class() {
    return this.attr.CLASS;
  }
  get startDate() {
    return this._startDate;
  }
  get endDate() {
    if (this._endDate)
      return this._endDate;
    const e = this.duration;
    return e !== null ? new Date(this._startDate.getTime() + e * 1e3) : null;
  }
  get duration() {
    if ("DURATION" in this.attr) {
      const e = this.attr.decimalFloatingPoint("DURATION");
      if (ge(e))
        return e;
    } else if (this._endDate)
      return (this._endDate.getTime() - this._startDate.getTime()) / 1e3;
    return null;
  }
  get plannedDuration() {
    return "PLANNED-DURATION" in this.attr ? this.attr.decimalFloatingPoint("PLANNED-DURATION") : null;
  }
  get endOnNext() {
    return this.attr.bool("END-ON-NEXT");
  }
  get isValid() {
    return !!this.id && !this._badValueForSameId && ge(this.startDate.getTime()) && (this.duration === null || this.duration >= 0) && (!this.endOnNext || !!this.class);
  }
}
class Nr {
  constructor() {
    this.aborted = !1, this.loaded = 0, this.retry = 0, this.total = 0, this.chunkCount = 0, this.bwEstimate = 0, this.loading = {
      start: 0,
      first: 0,
      end: 0
    }, this.parsing = {
      start: 0,
      end: 0
    }, this.buffering = {
      start: 0,
      first: 0,
      end: 0
    };
  }
}
var Ge = {
  AUDIO: "audio",
  VIDEO: "video",
  AUDIOVIDEO: "audiovideo"
};
class La {
  constructor(e) {
    this._byteRange = null, this._url = null, this.baseurl = void 0, this.relurl = void 0, this.elementaryStreams = {
      [Ge.AUDIO]: null,
      [Ge.VIDEO]: null,
      [Ge.AUDIOVIDEO]: null
    }, this.baseurl = e;
  }
  // setByteRange converts a EXT-X-BYTERANGE attribute into a two element array
  setByteRange(e, t) {
    const n = e.split("@", 2), r = [];
    n.length === 1 ? r[0] = t ? t.byteRangeEndOffset : 0 : r[0] = parseInt(n[1]), r[1] = parseInt(n[0]) + r[0], this._byteRange = r;
  }
  get byteRange() {
    return this._byteRange ? this._byteRange : [];
  }
  get byteRangeStartOffset() {
    return this.byteRange[0];
  }
  get byteRangeEndOffset() {
    return this.byteRange[1];
  }
  get url() {
    return !this._url && this.baseurl && this.relurl && (this._url = Ni.buildAbsoluteURL(this.baseurl, this.relurl, {
      alwaysNormalize: !0
    })), this._url || "";
  }
  set url(e) {
    this._url = e;
  }
}
class ei extends La {
  constructor(e, t) {
    super(t), this._decryptdata = null, this.rawProgramDateTime = null, this.programDateTime = null, this.tagList = [], this.duration = 0, this.sn = 0, this.levelkeys = void 0, this.type = void 0, this.loader = null, this.keyLoader = null, this.level = -1, this.cc = 0, this.startPTS = void 0, this.endPTS = void 0, this.startDTS = void 0, this.endDTS = void 0, this.start = 0, this.deltaPTS = void 0, this.maxStartPTS = void 0, this.minEndPTS = void 0, this.stats = new Nr(), this.urlId = 0, this.data = void 0, this.bitrateTest = !1, this.title = null, this.initSegment = null, this.endList = void 0, this.gap = void 0, this.type = e;
  }
  get decryptdata() {
    const {
      levelkeys: e
    } = this;
    if (!e && !this._decryptdata)
      return null;
    if (!this._decryptdata && this.levelkeys && !this.levelkeys.NONE) {
      const t = this.levelkeys.identity;
      if (t)
        this._decryptdata = t.getDecryptData(this.sn);
      else {
        const n = Object.keys(this.levelkeys);
        if (n.length === 1)
          return this._decryptdata = this.levelkeys[n[0]].getDecryptData(this.sn);
      }
    }
    return this._decryptdata;
  }
  get end() {
    return this.start + this.duration;
  }
  get endProgramDateTime() {
    if (this.programDateTime === null || !ge(this.programDateTime))
      return null;
    const e = ge(this.duration) ? this.duration : 0;
    return this.programDateTime + e * 1e3;
  }
  get encrypted() {
    var e;
    if ((e = this._decryptdata) != null && e.encrypted)
      return !0;
    if (this.levelkeys) {
      const t = Object.keys(this.levelkeys), n = t.length;
      if (n > 1 || n === 1 && this.levelkeys[t[0]].encrypted)
        return !0;
    }
    return !1;
  }
  setKeyFormat(e) {
    if (this.levelkeys) {
      const t = this.levelkeys[e];
      t && !this._decryptdata && (this._decryptdata = t.getDecryptData(this.sn));
    }
  }
  abortRequests() {
    var e, t;
    (e = this.loader) == null || e.abort(), (t = this.keyLoader) == null || t.abort();
  }
  setElementaryStreamInfo(e, t, n, r, i, s = !1) {
    const {
      elementaryStreams: a
    } = this, l = a[e];
    if (!l) {
      a[e] = {
        startPTS: t,
        endPTS: n,
        startDTS: r,
        endDTS: i,
        partial: s
      };
      return;
    }
    l.startPTS = Math.min(l.startPTS, t), l.endPTS = Math.max(l.endPTS, n), l.startDTS = Math.min(l.startDTS, r), l.endDTS = Math.max(l.endDTS, i);
  }
  clearElementaryStreamInfo() {
    const {
      elementaryStreams: e
    } = this;
    e[Ge.AUDIO] = null, e[Ge.VIDEO] = null, e[Ge.AUDIOVIDEO] = null;
  }
}
class ec extends La {
  constructor(e, t, n, r, i) {
    super(n), this.fragOffset = 0, this.duration = 0, this.gap = !1, this.independent = !1, this.relurl = void 0, this.fragment = void 0, this.index = void 0, this.stats = new Nr(), this.duration = e.decimalFloatingPoint("DURATION"), this.gap = e.bool("GAP"), this.independent = e.bool("INDEPENDENT"), this.relurl = e.enumeratedString("URI"), this.fragment = t, this.index = r;
    const s = e.enumeratedString("BYTERANGE");
    s && this.setByteRange(s, i), i && (this.fragOffset = i.fragOffset + i.duration);
  }
  get start() {
    return this.fragment.start + this.fragOffset;
  }
  get end() {
    return this.start + this.duration;
  }
  get loaded() {
    const {
      elementaryStreams: e
    } = this;
    return !!(e.audio || e.video || e.audiovideo);
  }
}
const tc = 10;
class nc {
  constructor(e) {
    this.PTSKnown = !1, this.alignedSliding = !1, this.averagetargetduration = void 0, this.endCC = 0, this.endSN = 0, this.fragments = void 0, this.fragmentHint = void 0, this.partList = null, this.dateRanges = void 0, this.live = !0, this.ageHeader = 0, this.advancedDateTime = void 0, this.updated = !0, this.advanced = !0, this.availabilityDelay = void 0, this.misses = 0, this.startCC = 0, this.startSN = 0, this.startTimeOffset = null, this.targetduration = 0, this.totalduration = 0, this.type = null, this.url = void 0, this.m3u8 = "", this.version = null, this.canBlockReload = !1, this.canSkipUntil = 0, this.canSkipDateRanges = !1, this.skippedSegments = 0, this.recentlyRemovedDateranges = void 0, this.partHoldBack = 0, this.holdBack = 0, this.partTarget = 0, this.preloadHint = void 0, this.renditionReports = void 0, this.tuneInGoal = 0, this.deltaUpdateFailed = void 0, this.driftStartTime = 0, this.driftEndTime = 0, this.driftStart = 0, this.driftEnd = 0, this.encryptedFragments = void 0, this.playlistParsingError = null, this.variableList = null, this.hasVariableRefs = !1, this.fragments = [], this.encryptedFragments = [], this.dateRanges = {}, this.url = e;
  }
  reloaded(e) {
    if (!e) {
      this.advanced = !0, this.updated = !0;
      return;
    }
    const t = this.lastPartSn - e.lastPartSn, n = this.lastPartIndex - e.lastPartIndex;
    this.updated = this.endSN !== e.endSN || !!n || !!t || !this.live, this.advanced = this.endSN > e.endSN || t > 0 || t === 0 && n > 0, this.updated || this.advanced ? this.misses = Math.floor(e.misses * 0.6) : this.misses = e.misses + 1, this.availabilityDelay = e.availabilityDelay;
  }
  get hasProgramDateTime() {
    return this.fragments.length ? ge(this.fragments[this.fragments.length - 1].programDateTime) : !1;
  }
  get levelTargetDuration() {
    return this.averagetargetduration || this.targetduration || tc;
  }
  get drift() {
    const e = this.driftEndTime - this.driftStartTime;
    return e > 0 ? (this.driftEnd - this.driftStart) * 1e3 / e : 1;
  }
  get edge() {
    return this.partEnd || this.fragmentEnd;
  }
  get partEnd() {
    var e;
    return (e = this.partList) != null && e.length ? this.partList[this.partList.length - 1].end : this.fragmentEnd;
  }
  get fragmentEnd() {
    var e;
    return (e = this.fragments) != null && e.length ? this.fragments[this.fragments.length - 1].end : 0;
  }
  get age() {
    return this.advancedDateTime ? Math.max(Date.now() - this.advancedDateTime, 0) / 1e3 : 0;
  }
  get lastPartIndex() {
    var e;
    return (e = this.partList) != null && e.length ? this.partList[this.partList.length - 1].index : -1;
  }
  get lastPartSn() {
    var e;
    return (e = this.partList) != null && e.length ? this.partList[this.partList.length - 1].fragment.sn : this.endSN;
  }
}
function ji(o) {
  return Uint8Array.from(atob(o), (e) => e.charCodeAt(0));
}
function rc(o) {
  const e = _i(o).subarray(0, 16), t = new Uint8Array(16);
  return t.set(e, 16 - e.length), t;
}
function ic(o) {
  const e = function(n, r, i) {
    const s = n[r];
    n[r] = n[i], n[i] = s;
  };
  e(o, 0, 3), e(o, 1, 2), e(o, 4, 5), e(o, 6, 7);
}
function sc(o) {
  const e = o.split(":");
  let t = null;
  if (e[0] === "data" && e.length === 2) {
    const n = e[1].split(";"), r = n[n.length - 1].split(",");
    if (r.length === 2) {
      const i = r[0] === "base64", s = r[1];
      i ? (n.splice(-1, 1), t = ji(s)) : t = rc(s);
    }
  }
  return t;
}
function _i(o) {
  return Uint8Array.from(unescape(encodeURIComponent(o)), (e) => e.charCodeAt(0));
}
var Ye = {
  CLEARKEY: "org.w3.clearkey",
  FAIRPLAY: "com.apple.fps",
  PLAYREADY: "com.microsoft.playready",
  WIDEVINE: "com.widevine.alpha"
}, bt = {
  CLEARKEY: "org.w3.clearkey",
  FAIRPLAY: "com.apple.streamingkeydelivery",
  PLAYREADY: "com.microsoft.playready",
  WIDEVINE: "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed"
};
function Cs(o) {
  switch (o) {
    case bt.FAIRPLAY:
      return Ye.FAIRPLAY;
    case bt.PLAYREADY:
      return Ye.PLAYREADY;
    case bt.WIDEVINE:
      return Ye.WIDEVINE;
    case bt.CLEARKEY:
      return Ye.CLEARKEY;
  }
}
var wa = {
  WIDEVINE: "edef8ba979d64acea3c827dcd51d21ed"
};
function ac(o) {
  if (o === wa.WIDEVINE)
    return Ye.WIDEVINE;
}
function Ls(o) {
  switch (o) {
    case Ye.FAIRPLAY:
      return bt.FAIRPLAY;
    case Ye.PLAYREADY:
      return bt.PLAYREADY;
    case Ye.WIDEVINE:
      return bt.WIDEVINE;
    case Ye.CLEARKEY:
      return bt.CLEARKEY;
  }
}
function ti(o) {
  const {
    drmSystems: e,
    widevineLicenseUrl: t
  } = o, n = e ? [Ye.FAIRPLAY, Ye.WIDEVINE, Ye.PLAYREADY, Ye.CLEARKEY].filter((r) => !!e[r]) : [];
  return !n[Ye.WIDEVINE] && t && n.push(Ye.WIDEVINE), n;
}
const Ra = function() {
  return typeof self < "u" && self.navigator && self.navigator.requestMediaKeySystemAccess ? self.navigator.requestMediaKeySystemAccess.bind(self.navigator) : null;
}();
function oc(o, e, t, n) {
  let r;
  switch (o) {
    case Ye.FAIRPLAY:
      r = ["cenc", "sinf"];
      break;
    case Ye.WIDEVINE:
    case Ye.PLAYREADY:
      r = ["cenc"];
      break;
    case Ye.CLEARKEY:
      r = ["cenc", "keyids"];
      break;
    default:
      throw new Error(`Unknown key-system: ${o}`);
  }
  return lc(r, e, t, n);
}
function lc(o, e, t, n) {
  return [{
    initDataTypes: o,
    persistentState: n.persistentState || "optional",
    distinctiveIdentifier: n.distinctiveIdentifier || "optional",
    sessionTypes: n.sessionTypes || [n.sessionType || "temporary"],
    audioCapabilities: e.map((i) => ({
      contentType: `audio/mp4; codecs="${i}"`,
      robustness: n.audioRobustness || "",
      encryptionScheme: n.audioEncryptionScheme || null
    })),
    videoCapabilities: t.map((i) => ({
      contentType: `video/mp4; codecs="${i}"`,
      robustness: n.videoRobustness || "",
      encryptionScheme: n.videoEncryptionScheme || null
    }))
  }];
}
function hn(o, e, t) {
  return Uint8Array.prototype.slice ? o.slice(e, t) : new Uint8Array(Array.prototype.slice.call(o, e, t));
}
const Gi = (o, e) => e + 10 <= o.length && o[e] === 73 && o[e + 1] === 68 && o[e + 2] === 51 && o[e + 3] < 255 && o[e + 4] < 255 && o[e + 6] < 128 && o[e + 7] < 128 && o[e + 8] < 128 && o[e + 9] < 128, Ia = (o, e) => e + 10 <= o.length && o[e] === 51 && o[e + 1] === 68 && o[e + 2] === 73 && o[e + 3] < 255 && o[e + 4] < 255 && o[e + 6] < 128 && o[e + 7] < 128 && o[e + 8] < 128 && o[e + 9] < 128, tr = (o, e) => {
  const t = e;
  let n = 0;
  for (; Gi(o, e); ) {
    n += 10;
    const r = jr(o, e + 6);
    n += r, Ia(o, e + 10) && (n += 10), e += n;
  }
  if (n > 0)
    return o.subarray(t, t + n);
}, jr = (o, e) => {
  let t = 0;
  return t = (o[e] & 127) << 21, t |= (o[e + 1] & 127) << 14, t |= (o[e + 2] & 127) << 7, t |= o[e + 3] & 127, t;
}, dc = (o, e) => Gi(o, e) && jr(o, e + 6) + 10 <= o.length - e, Ki = (o) => {
  const e = Da(o);
  for (let t = 0; t < e.length; t++) {
    const n = e[t];
    if (ka(n))
      return mc(n);
  }
}, ka = (o) => o && o.key === "PRIV" && o.info === "com.apple.streaming.transportStreamTimestamp", cc = (o) => {
  const e = String.fromCharCode(o[0], o[1], o[2], o[3]), t = jr(o, 4), n = 10;
  return {
    type: e,
    size: t,
    data: o.subarray(n, n + t)
  };
}, Da = (o) => {
  let e = 0;
  const t = [];
  for (; Gi(o, e); ) {
    const n = jr(o, e + 6);
    e += 10;
    const r = e + n;
    for (; e + 8 < r; ) {
      const i = cc(o.subarray(e)), s = uc(i);
      s && t.push(s), e += i.size + 10;
    }
    Ia(o, e) && (e += 10);
  }
  return t;
}, uc = (o) => o.type === "PRIV" ? hc(o) : o.type[0] === "W" ? pc(o) : fc(o), hc = (o) => {
  if (o.size < 2)
    return;
  const e = jt(o.data, !0), t = new Uint8Array(o.data.subarray(e.length + 1));
  return {
    key: o.type,
    info: e,
    data: t.buffer
  };
}, fc = (o) => {
  if (o.size < 2)
    return;
  if (o.type === "TXXX") {
    let t = 1;
    const n = jt(o.data.subarray(t), !0);
    t += n.length + 1;
    const r = jt(o.data.subarray(t));
    return {
      key: o.type,
      info: n,
      data: r
    };
  }
  const e = jt(o.data.subarray(1));
  return {
    key: o.type,
    data: e
  };
}, pc = (o) => {
  if (o.type === "WXXX") {
    if (o.size < 2)
      return;
    let t = 1;
    const n = jt(o.data.subarray(t), !0);
    t += n.length + 1;
    const r = jt(o.data.subarray(t));
    return {
      key: o.type,
      info: n,
      data: r
    };
  }
  const e = jt(o.data);
  return {
    key: o.type,
    data: e
  };
}, mc = (o) => {
  if (o.data.byteLength === 8) {
    const e = new Uint8Array(o.data), t = e[3] & 1;
    let n = (e[4] << 23) + (e[5] << 15) + (e[6] << 7) + e[7];
    return n /= 45, t && (n += 4772185884e-2), Math.round(n);
  }
}, jt = (o, e = !1) => {
  const t = gc();
  if (t) {
    const d = t.decode(o);
    if (e) {
      const h = d.indexOf("\0");
      return h !== -1 ? d.substring(0, h) : d;
    }
    return d.replace(/\0/g, "");
  }
  const n = o.length;
  let r, i, s, a = "", l = 0;
  for (; l < n; ) {
    if (r = o[l++], r === 0 && e)
      return a;
    if (r === 0 || r === 3)
      continue;
    switch (r >> 4) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
        a += String.fromCharCode(r);
        break;
      case 12:
      case 13:
        i = o[l++], a += String.fromCharCode((r & 31) << 6 | i & 63);
        break;
      case 14:
        i = o[l++], s = o[l++], a += String.fromCharCode((r & 15) << 12 | (i & 63) << 6 | (s & 63) << 0);
        break;
    }
  }
  return a;
};
let ni;
function gc() {
  return !ni && typeof self.TextDecoder < "u" && (ni = new self.TextDecoder("utf-8")), ni;
}
const Mt = {
  hexDump: function(o) {
    let e = "";
    for (let t = 0; t < o.length; t++) {
      let n = o[t].toString(16);
      n.length < 2 && (n = "0" + n), e += n;
    }
    return e;
  }
}, kr = Math.pow(2, 32) - 1, yc = [].push, Oa = {
  video: 1,
  audio: 2,
  id3: 3,
  text: 4
};
function ot(o) {
  return String.fromCharCode.apply(null, o);
}
function Ba(o, e) {
  const t = o[e] << 8 | o[e + 1];
  return t < 0 ? 65536 + t : t;
}
function Se(o, e) {
  const t = Pa(o, e);
  return t < 0 ? 4294967296 + t : t;
}
function Pa(o, e) {
  return o[e] << 24 | o[e + 1] << 16 | o[e + 2] << 8 | o[e + 3];
}
function ri(o, e, t) {
  o[e] = t >> 24, o[e + 1] = t >> 16 & 255, o[e + 2] = t >> 8 & 255, o[e + 3] = t & 255;
}
function Re(o, e) {
  const t = [];
  if (!e.length)
    return t;
  const n = o.byteLength;
  for (let r = 0; r < n; ) {
    const i = Se(o, r), s = ot(o.subarray(r + 4, r + 8)), a = i > 1 ? r + i : n;
    if (s === e[0])
      if (e.length === 1)
        t.push(o.subarray(r + 8, a));
      else {
        const l = Re(o.subarray(r + 8, a), e.slice(1));
        l.length && yc.apply(t, l);
      }
    r = a;
  }
  return t;
}
function Ac(o) {
  const e = [], t = o[0];
  let n = 8;
  const r = Se(o, n);
  n += 4;
  const i = 0, s = 0;
  t === 0 ? n += 8 : n += 16, n += 2;
  let a = o.length + s;
  const l = Ba(o, n);
  n += 2;
  for (let d = 0; d < l; d++) {
    let h = n;
    const u = Se(o, h);
    h += 4;
    const c = u & 2147483647;
    if ((u & 2147483648) >>> 31 === 1)
      return V.warn("SIDX has hierarchical references (not supported)"), null;
    const f = Se(o, h);
    h += 4, e.push({
      referenceSize: c,
      subsegmentDuration: f,
      // unscaled
      info: {
        duration: f / r,
        start: a,
        end: a + c - 1
      }
    }), a += c, h += 4, n = h;
  }
  return {
    earliestPresentationTime: i,
    timescale: r,
    version: t,
    referencesCount: l,
    references: e
  };
}
function Fa(o) {
  const e = [], t = Re(o, ["moov", "trak"]);
  for (let r = 0; r < t.length; r++) {
    const i = t[r], s = Re(i, ["tkhd"])[0];
    if (s) {
      let a = s[0];
      const l = Se(s, a === 0 ? 12 : 20), d = Re(i, ["mdia", "mdhd"])[0];
      if (d) {
        a = d[0];
        const h = Se(d, a === 0 ? 12 : 20), u = Re(i, ["mdia", "hdlr"])[0];
        if (u) {
          const c = ot(u.subarray(8, 12)), m = {
            soun: Ge.AUDIO,
            vide: Ge.VIDEO
          }[c];
          if (m) {
            const f = Re(i, ["mdia", "minf", "stbl", "stsd"])[0], p = vc(f);
            e[l] = {
              timescale: h,
              type: m
            }, e[m] = it({
              timescale: h,
              id: l
            }, p);
          }
        }
      }
    }
  }
  return Re(o, ["moov", "mvex", "trex"]).forEach((r) => {
    const i = Se(r, 4), s = e[i];
    s && (s.default = {
      duration: Se(r, 12),
      flags: Se(r, 20)
    });
  }), e;
}
function vc(o) {
  const e = o.subarray(8), t = e.subarray(8 + 78), n = ot(e.subarray(4, 8));
  let r = n;
  const i = n === "enca" || n === "encv";
  if (i) {
    const a = Re(e, [n])[0].subarray(n === "enca" ? 28 : 78);
    Re(a, ["sinf"]).forEach((d) => {
      const h = Re(d, ["schm"])[0];
      if (h) {
        const u = ot(h.subarray(4, 8));
        if (u === "cbcs" || u === "cenc") {
          const c = Re(d, ["frma"])[0];
          c && (r = ot(c));
        }
      }
    });
  }
  switch (r) {
    case "avc1":
    case "avc2":
    case "avc3":
    case "avc4":
      r += "." + yr(o[111]) + yr(o[112]) + yr(o[113]);
      break;
    case "mp4a": {
      const s = Re(e, [n])[0], a = Re(s.subarray(28), ["esds"])[0];
      a && a.length > 12 && a[11] !== 0 && (r += "." + yr(a[11]), r += "." + (a[12] >>> 2 & 63).toString(16).toUpperCase());
      break;
    }
    case "hvc1":
    case "hev1": {
      const s = Re(t, ["hvcC"])[0], a = s[1], l = ["", "A", "B", "C"][a >> 6], d = a & 31, h = Se(s, 2), u = (a & 32) >> 5 ? "H" : "L", c = s[12], m = s.subarray(6, 12);
      r += "." + l + d, r += "." + h.toString(16).toUpperCase(), r += "." + u + c;
      let f = "";
      for (let p = m.length; p--; ) {
        const A = m[p];
        (A || f) && (f = "." + A.toString(16).toUpperCase() + f);
      }
      r += f;
      break;
    }
    case "dvh1":
    case "dvhe": {
      const s = Re(t, ["dvcC"])[0], a = s[2] >> 1 & 127, l = s[2] << 5 & 32 | s[3] >> 3 & 31;
      r += "." + Ft(a) + "." + Ft(l);
      break;
    }
    case "vp09": {
      const s = Re(t, ["vpcC"])[0], a = s[4], l = s[5], d = s[6] >> 4 & 15;
      r += "." + Ft(a) + "." + Ft(l) + "." + Ft(d);
      break;
    }
    case "av01": {
      const s = Re(t, ["av1C"])[0], a = s[1] >>> 5, l = s[1] & 31, d = s[2] >>> 7 ? "H" : "M", h = (s[2] & 64) >> 6, u = (s[2] & 32) >> 5, c = a === 2 && h ? u ? 12 : 10 : h ? 10 : 8, m = (s[2] & 16) >> 4, f = (s[2] & 8) >> 3, p = (s[2] & 4) >> 2, A = s[2] & 3, v = 1, b = 1, _ = 1, T = 0;
      r += "." + a + "." + Ft(l) + d + "." + Ft(c) + "." + m + "." + f + p + A + "." + Ft(v) + "." + Ft(b) + "." + Ft(_) + "." + T;
      break;
    }
  }
  return {
    codec: r,
    encrypted: i
  };
}
function yr(o) {
  return ("0" + o.toString(16).toUpperCase()).slice(-2);
}
function Ft(o) {
  return (o < 10 ? "0" : "") + o;
}
function bc(o, e) {
  if (!o || !e)
    return o;
  const t = e.keyId;
  return t && e.isCommonEncryption && Re(o, ["moov", "trak"]).forEach((r) => {
    const s = Re(r, ["mdia", "minf", "stbl", "stsd"])[0].subarray(8);
    let a = Re(s, ["enca"]);
    const l = a.length > 0;
    l || (a = Re(s, ["encv"])), a.forEach((d) => {
      const h = l ? d.subarray(28) : d.subarray(78);
      Re(h, ["sinf"]).forEach((c) => {
        const m = Ma(c);
        if (m) {
          const f = m.subarray(8, 24);
          f.some((p) => p !== 0) || (V.log(`[eme] Patching keyId in 'enc${l ? "a" : "v"}>sinf>>tenc' box: ${Mt.hexDump(f)} -> ${Mt.hexDump(t)}`), m.set(t, 8));
        }
      });
    });
  }), o;
}
function Ma(o) {
  const e = Re(o, ["schm"])[0];
  if (e) {
    const t = ot(e.subarray(4, 8));
    if (t === "cbcs" || t === "cenc")
      return Re(o, ["schi", "tenc"])[0];
  }
  return V.error("[eme] missing 'schm' box"), null;
}
function xc(o, e) {
  return Re(e, ["moof", "traf"]).reduce((t, n) => {
    const r = Re(n, ["tfdt"])[0], i = r[0], s = Re(n, ["tfhd"]).reduce((a, l) => {
      const d = Se(l, 4), h = o[d];
      if (h) {
        let u = Se(r, 4);
        if (i === 1) {
          if (u === kr)
            return V.warn("[mp4-demuxer]: Ignoring assumed invalid signed 64-bit track fragment decode time"), a;
          u *= kr + 1, u += Se(r, 8);
        }
        const c = h.timescale || 9e4, m = u / c;
        if (isFinite(m) && (a === null || m < a))
          return m;
      }
      return a;
    }, null);
    return s !== null && isFinite(s) && (t === null || s < t) ? s : t;
  }, null);
}
function Ec(o, e) {
  let t = 0, n = 0, r = 0;
  const i = Re(o, ["moof", "traf"]);
  for (let s = 0; s < i.length; s++) {
    const a = i[s], l = Re(a, ["tfhd"])[0], d = Se(l, 4), h = e[d];
    if (!h)
      continue;
    const u = h.default, c = Se(l, 0) | (u == null ? void 0 : u.flags);
    let m = u == null ? void 0 : u.duration;
    c & 8 && (c & 2 ? m = Se(l, 12) : m = Se(l, 8));
    const f = h.timescale || 9e4, p = Re(a, ["trun"]);
    for (let A = 0; A < p.length; A++) {
      if (t = _c(p[A]), !t && m) {
        const v = Se(p[A], 4);
        t = m * v;
      }
      h.type === Ge.VIDEO ? n += t / f : h.type === Ge.AUDIO && (r += t / f);
    }
  }
  if (n === 0 && r === 0) {
    let s = 0;
    const a = Re(o, ["sidx"]);
    for (let l = 0; l < a.length; l++) {
      const d = Ac(a[l]);
      d != null && d.references && (s += d.references.reduce((h, u) => h + u.info.duration || 0, 0));
    }
    return s;
  }
  return n || r;
}
function _c(o) {
  const e = Se(o, 0);
  let t = 8;
  e & 1 && (t += 4), e & 4 && (t += 4);
  let n = 0;
  const r = Se(o, 4);
  for (let i = 0; i < r; i++) {
    if (e & 256) {
      const s = Se(o, t);
      n += s, t += 4;
    }
    e & 512 && (t += 4), e & 1024 && (t += 4), e & 2048 && (t += 4);
  }
  return n;
}
function Sc(o, e, t) {
  Re(e, ["moof", "traf"]).forEach((n) => {
    Re(n, ["tfhd"]).forEach((r) => {
      const i = Se(r, 4), s = o[i];
      if (!s)
        return;
      const a = s.timescale || 9e4;
      Re(n, ["tfdt"]).forEach((l) => {
        const d = l[0], h = t * a;
        if (h) {
          let u = Se(l, 4);
          if (d === 0)
            u -= h, u = Math.max(u, 0), ri(l, 4, u);
          else {
            u *= Math.pow(2, 32), u += Se(l, 8), u -= h, u = Math.max(u, 0);
            const c = Math.floor(u / (kr + 1)), m = Math.floor(u % (kr + 1));
            ri(l, 4, c), ri(l, 8, m);
          }
        }
      });
    });
  });
}
function Tc(o) {
  const e = {
    valid: null,
    remainder: null
  }, t = Re(o, ["moof"]);
  if (t) {
    if (t.length < 2)
      return e.remainder = o, e;
  } else
    return e;
  const n = t[t.length - 1];
  return e.valid = hn(o, 0, n.byteOffset - 8), e.remainder = hn(o, n.byteOffset - 8), e;
}
function xt(o, e) {
  const t = new Uint8Array(o.length + e.length);
  return t.set(o), t.set(e, o.length), t;
}
function ws(o, e) {
  const t = [], n = e.samples, r = e.timescale, i = e.id;
  let s = !1;
  return Re(n, ["moof"]).map((l) => {
    const d = l.byteOffset - 8;
    Re(l, ["traf"]).map((u) => {
      const c = Re(u, ["tfdt"]).map((m) => {
        const f = m[0];
        let p = Se(m, 4);
        return f === 1 && (p *= Math.pow(2, 32), p += Se(m, 8)), p / r;
      })[0];
      return c !== void 0 && (o = c), Re(u, ["tfhd"]).map((m) => {
        const f = Se(m, 4), p = Se(m, 0) & 16777215, A = (p & 1) !== 0, v = (p & 2) !== 0, b = (p & 8) !== 0;
        let _ = 0;
        const T = (p & 16) !== 0;
        let E = 0;
        const L = (p & 32) !== 0;
        let k = 8;
        f === i && (A && (k += 8), v && (k += 4), b && (_ = Se(m, k), k += 4), T && (E = Se(m, k), k += 4), L && (k += 4), e.type === "video" && (s = Cc(e.codec)), Re(u, ["trun"]).map((D) => {
          const M = D[0], O = Se(D, 0) & 16777215, N = (O & 1) !== 0;
          let B = 0;
          const U = (O & 4) !== 0, G = (O & 256) !== 0;
          let Y = 0;
          const z = (O & 512) !== 0;
          let J = 0;
          const le = (O & 1024) !== 0, W = (O & 2048) !== 0;
          let Z = 0;
          const ce = Se(D, 4);
          let ue = 8;
          N && (B = Se(D, ue), ue += 4), U && (ue += 4);
          let re = B + d;
          for (let me = 0; me < ce; me++) {
            if (G ? (Y = Se(D, ue), ue += 4) : Y = _, z ? (J = Se(D, ue), ue += 4) : J = E, le && (ue += 4), W && (M === 0 ? Z = Se(D, ue) : Z = Pa(D, ue), ue += 4), e.type === Ge.VIDEO) {
              let Be = 0;
              for (; Be < J; ) {
                const ye = Se(n, re);
                if (re += 4, Lc(s, n[re])) {
                  const Le = n.subarray(re, re + ye);
                  $i(Le, s ? 2 : 1, o + Z / r, t);
                }
                re += ye, Be += ye + 4;
              }
            }
            o += Y / r;
          }
        }));
      });
    });
  }), t;
}
function Cc(o) {
  if (!o)
    return !1;
  const e = o.indexOf("."), t = e < 0 ? o : o.substring(0, e);
  return t === "hvc1" || t === "hev1" || // Dolby Vision
  t === "dvh1" || t === "dvhe";
}
function Lc(o, e) {
  if (o) {
    const t = e >> 1 & 63;
    return t === 39 || t === 40;
  } else
    return (e & 31) === 6;
}
function $i(o, e, t, n) {
  const r = Ua(o);
  let i = 0;
  i += e;
  let s = 0, a = 0, l = !1, d = 0;
  for (; i < r.length; ) {
    s = 0;
    do {
      if (i >= r.length)
        break;
      d = r[i++], s += d;
    } while (d === 255);
    a = 0;
    do {
      if (i >= r.length)
        break;
      d = r[i++], a += d;
    } while (d === 255);
    const h = r.length - i;
    if (!l && s === 4 && i < r.length) {
      if (l = !0, r[i++] === 181) {
        const c = Ba(r, i);
        if (i += 2, c === 49) {
          const m = Se(r, i);
          if (i += 4, m === 1195456820) {
            const f = r[i++];
            if (f === 3) {
              const p = r[i++], A = 31 & p, v = 64 & p, b = v ? 2 + A * 3 : 0, _ = new Uint8Array(b);
              if (v) {
                _[0] = p;
                for (let T = 1; T < b; T++)
                  _[T] = r[i++];
              }
              n.push({
                type: f,
                payloadType: s,
                pts: t,
                bytes: _
              });
            }
          }
        }
      }
    } else if (s === 5 && a < h) {
      if (l = !0, a > 16) {
        const u = [];
        for (let f = 0; f < 16; f++) {
          const p = r[i++].toString(16);
          u.push(p.length == 1 ? "0" + p : p), (f === 3 || f === 5 || f === 7 || f === 9) && u.push("-");
        }
        const c = a - 16, m = new Uint8Array(c);
        for (let f = 0; f < c; f++)
          m[f] = r[i++];
        n.push({
          payloadType: s,
          pts: t,
          uuid: u.join(""),
          userData: jt(m),
          userDataBytes: m
        });
      }
    } else if (a < h)
      i += a;
    else if (a > h)
      break;
  }
}
function Ua(o) {
  const e = o.byteLength, t = [];
  let n = 1;
  for (; n < e - 2; )
    o[n] === 0 && o[n + 1] === 0 && o[n + 2] === 3 ? (t.push(n + 2), n += 2) : n++;
  if (t.length === 0)
    return o;
  const r = e - t.length, i = new Uint8Array(r);
  let s = 0;
  for (n = 0; n < r; s++, n++)
    s === t[0] && (s++, t.shift()), i[n] = o[s];
  return i;
}
function wc(o) {
  const e = o[0];
  let t = "", n = "", r = 0, i = 0, s = 0, a = 0, l = 0, d = 0;
  if (e === 0) {
    for (; ot(o.subarray(d, d + 1)) !== "\0"; )
      t += ot(o.subarray(d, d + 1)), d += 1;
    for (t += ot(o.subarray(d, d + 1)), d += 1; ot(o.subarray(d, d + 1)) !== "\0"; )
      n += ot(o.subarray(d, d + 1)), d += 1;
    n += ot(o.subarray(d, d + 1)), d += 1, r = Se(o, 12), i = Se(o, 16), a = Se(o, 20), l = Se(o, 24), d = 28;
  } else if (e === 1) {
    d += 4, r = Se(o, d), d += 4;
    const u = Se(o, d);
    d += 4;
    const c = Se(o, d);
    for (d += 4, s = 2 ** 32 * u + c, Number.isSafeInteger(s) || (s = Number.MAX_SAFE_INTEGER, V.warn("Presentation time exceeds safe integer limit and wrapped to max safe integer in parsing emsg box")), a = Se(o, d), d += 4, l = Se(o, d), d += 4; ot(o.subarray(d, d + 1)) !== "\0"; )
      t += ot(o.subarray(d, d + 1)), d += 1;
    for (t += ot(o.subarray(d, d + 1)), d += 1; ot(o.subarray(d, d + 1)) !== "\0"; )
      n += ot(o.subarray(d, d + 1)), d += 1;
    n += ot(o.subarray(d, d + 1)), d += 1;
  }
  const h = o.subarray(d, o.byteLength);
  return {
    schemeIdUri: t,
    value: n,
    timeScale: r,
    presentationTime: s,
    presentationTimeDelta: i,
    eventDuration: a,
    id: l,
    payload: h
  };
}
function Rc(o, ...e) {
  const t = e.length;
  let n = 8, r = t;
  for (; r--; )
    n += e[r].byteLength;
  const i = new Uint8Array(n);
  for (i[0] = n >> 24 & 255, i[1] = n >> 16 & 255, i[2] = n >> 8 & 255, i[3] = n & 255, i.set(o, 4), r = 0, n = 8; r < t; r++)
    i.set(e[r], n), n += e[r].byteLength;
  return i;
}
function Ic(o, e, t) {
  if (o.byteLength !== 16)
    throw new RangeError("Invalid system id");
  let n, r;
  if (e) {
    n = 1, r = new Uint8Array(e.length * 16);
    for (let a = 0; a < e.length; a++) {
      const l = e[a];
      if (l.byteLength !== 16)
        throw new RangeError("Invalid key");
      r.set(l, a * 16);
    }
  } else
    n = 0, r = new Uint8Array();
  let i;
  n > 0 ? (i = new Uint8Array(4), e.length > 0 && new DataView(i.buffer).setUint32(0, e.length, !1)) : i = new Uint8Array();
  const s = new Uint8Array(4);
  return t && t.byteLength > 0 && new DataView(s.buffer).setUint32(0, t.byteLength, !1), Rc(
    [112, 115, 115, 104],
    new Uint8Array([
      n,
      0,
      0,
      0
      // Flags
    ]),
    o,
    // 16 bytes
    i,
    r,
    s,
    t || new Uint8Array()
  );
}
function kc(o) {
  if (!(o instanceof ArrayBuffer) || o.byteLength < 32)
    return null;
  const e = {
    version: 0,
    systemId: "",
    kids: null,
    data: null
  }, t = new DataView(o), n = t.getUint32(0);
  if (o.byteLength !== n && n > 44 || t.getUint32(4) !== 1886614376 || (e.version = t.getUint32(8) >>> 24, e.version > 1))
    return null;
  e.systemId = Mt.hexDump(new Uint8Array(o, 12, 16));
  const i = t.getUint32(28);
  if (e.version === 0) {
    if (n - 32 < i)
      return null;
    e.data = new Uint8Array(o, 32, i);
  } else if (e.version === 1) {
    e.kids = [];
    for (let s = 0; s < i; s++)
      e.kids.push(new Uint8Array(o, 32 + s * 16, 16));
  }
  return e;
}
let Ar = {};
class nr {
  static clearKeyUriToKeyIdMap() {
    Ar = {};
  }
  constructor(e, t, n, r = [1], i = null) {
    this.uri = void 0, this.method = void 0, this.keyFormat = void 0, this.keyFormatVersions = void 0, this.encrypted = void 0, this.isCommonEncryption = void 0, this.iv = null, this.key = null, this.keyId = null, this.pssh = null, this.method = e, this.uri = t, this.keyFormat = n, this.keyFormatVersions = r, this.iv = i, this.encrypted = e ? e !== "NONE" : !1, this.isCommonEncryption = this.encrypted && e !== "AES-128";
  }
  isSupported() {
    if (this.method) {
      if (this.method === "AES-128" || this.method === "NONE")
        return !0;
      if (this.keyFormat === "identity")
        return this.method === "SAMPLE-AES";
      switch (this.keyFormat) {
        case bt.FAIRPLAY:
        case bt.WIDEVINE:
        case bt.PLAYREADY:
        case bt.CLEARKEY:
          return ["ISO-23001-7", "SAMPLE-AES", "SAMPLE-AES-CENC", "SAMPLE-AES-CTR"].indexOf(this.method) !== -1;
      }
    }
    return !1;
  }
  getDecryptData(e) {
    if (!this.encrypted || !this.uri)
      return null;
    if (this.method === "AES-128" && this.uri && !this.iv) {
      typeof e != "number" && (this.method === "AES-128" && !this.iv && V.warn(`missing IV for initialization segment with method="${this.method}" - compliance issue`), e = 0);
      const n = Dc(e);
      return new nr(this.method, this.uri, "identity", this.keyFormatVersions, n);
    }
    const t = sc(this.uri);
    if (t)
      switch (this.keyFormat) {
        case bt.WIDEVINE:
          this.pssh = t, t.length >= 22 && (this.keyId = t.subarray(t.length - 22, t.length - 6));
          break;
        case bt.PLAYREADY: {
          const n = new Uint8Array([154, 4, 240, 121, 152, 64, 66, 134, 171, 146, 230, 91, 224, 136, 95, 149]);
          this.pssh = Ic(n, null, t);
          const r = new Uint16Array(t.buffer, t.byteOffset, t.byteLength / 2), i = String.fromCharCode.apply(null, Array.from(r)), s = i.substring(i.indexOf("<"), i.length), d = new DOMParser().parseFromString(s, "text/xml").getElementsByTagName("KID")[0];
          if (d) {
            const h = d.childNodes[0] ? d.childNodes[0].nodeValue : d.getAttribute("VALUE");
            if (h) {
              const u = ji(h).subarray(0, 16);
              ic(u), this.keyId = u;
            }
          }
          break;
        }
        default: {
          let n = t.subarray(0, 16);
          if (n.length !== 16) {
            const r = new Uint8Array(16);
            r.set(n, 16 - n.length), n = r;
          }
          this.keyId = n;
          break;
        }
      }
    if (!this.keyId || this.keyId.byteLength !== 16) {
      let n = Ar[this.uri];
      if (!n) {
        const r = Object.keys(Ar).length % Number.MAX_SAFE_INTEGER;
        n = new Uint8Array(16), new DataView(n.buffer, 12, 4).setUint32(0, r), Ar[this.uri] = n;
      }
      this.keyId = n;
    }
    return this;
  }
}
function Dc(o) {
  const e = new Uint8Array(16);
  for (let t = 12; t < 16; t++)
    e[t] = o >> 8 * (15 - t) & 255;
  return e;
}
const Na = /\{\$([a-zA-Z0-9-_]+)\}/g;
function Rs(o) {
  return Na.test(o);
}
function vt(o, e, t) {
  if (o.variableList !== null || o.hasVariableRefs)
    for (let n = t.length; n--; ) {
      const r = t[n], i = e[r];
      i && (e[r] = Si(o, i));
    }
}
function Si(o, e) {
  if (o.variableList !== null || o.hasVariableRefs) {
    const t = o.variableList;
    return e.replace(Na, (n) => {
      const r = n.substring(2, n.length - 1), i = t == null ? void 0 : t[r];
      return i === void 0 ? (o.playlistParsingError || (o.playlistParsingError = new Error(`Missing preceding EXT-X-DEFINE tag for Variable Reference: "${r}"`)), n) : i;
    });
  }
  return e;
}
function Is(o, e, t) {
  let n = o.variableList;
  n || (o.variableList = n = {});
  let r, i;
  if ("QUERYPARAM" in e) {
    r = e.QUERYPARAM;
    try {
      const s = new self.URL(t).searchParams;
      if (s.has(r))
        i = s.get(r);
      else
        throw new Error(`"${r}" does not match any query parameter in URI: "${t}"`);
    } catch (s) {
      o.playlistParsingError || (o.playlistParsingError = new Error(`EXT-X-DEFINE QUERYPARAM: ${s.message}`));
    }
  } else
    r = e.NAME, i = e.VALUE;
  r in n ? o.playlistParsingError || (o.playlistParsingError = new Error(`EXT-X-DEFINE duplicate Variable Name declarations: "${r}"`)) : n[r] = i || "";
}
function Oc(o, e, t) {
  const n = e.IMPORT;
  if (t && n in t) {
    let r = o.variableList;
    r || (o.variableList = r = {}), r[n] = t[n];
  } else
    o.playlistParsingError || (o.playlistParsingError = new Error(`EXT-X-DEFINE IMPORT attribute not found in Multivariant Playlist: "${n}"`));
}
function Gr(o = !0) {
  return typeof self > "u" ? void 0 : (o || !self.MediaSource) && self.ManagedMediaSource || self.MediaSource || self.WebKitMediaSource;
}
const Ti = {
  audio: {
    a3ds: 1,
    "ac-3": 0.95,
    "ac-4": 1,
    alac: 0.9,
    alaw: 1,
    dra1: 1,
    "dts+": 1,
    "dts-": 1,
    dtsc: 1,
    dtse: 1,
    dtsh: 1,
    "ec-3": 0.9,
    enca: 1,
    fLaC: 0.9,
    // MP4-RA listed codec entry for FLAC
    flac: 0.9,
    // legacy browser codec name for FLAC
    FLAC: 0.9,
    // some manifests may list "FLAC" with Apple's tools
    g719: 1,
    g726: 1,
    m4ae: 1,
    mha1: 1,
    mha2: 1,
    mhm1: 1,
    mhm2: 1,
    mlpa: 1,
    mp4a: 1,
    "raw ": 1,
    Opus: 1,
    opus: 1,
    // browsers expect this to be lowercase despite MP4RA says 'Opus'
    samr: 1,
    sawb: 1,
    sawp: 1,
    sevc: 1,
    sqcp: 1,
    ssmv: 1,
    twos: 1,
    ulaw: 1
  },
  video: {
    avc1: 1,
    avc2: 1,
    avc3: 1,
    avc4: 1,
    avcp: 1,
    av01: 0.8,
    drac: 1,
    dva1: 1,
    dvav: 1,
    dvh1: 0.7,
    dvhe: 0.7,
    encv: 1,
    hev1: 0.75,
    hvc1: 0.75,
    mjp2: 1,
    mp4v: 1,
    mvc1: 1,
    mvc2: 1,
    mvc3: 1,
    mvc4: 1,
    resv: 1,
    rv60: 1,
    s263: 1,
    svc1: 1,
    svc2: 1,
    "vc-1": 1,
    vp08: 1,
    vp09: 0.9
  },
  text: {
    stpp: 1,
    wvtt: 1
  }
};
function Bc(o, e) {
  const t = Ti[e];
  return !!t && !!t[o.slice(0, 4)];
}
function ii(o, e, t = !0) {
  return !o.split(",").some((n) => !ja(n, e, t));
}
function ja(o, e, t = !0) {
  var n;
  const r = Gr(t);
  return (n = r == null ? void 0 : r.isTypeSupported(Ci(o, e))) != null ? n : !1;
}
function Ci(o, e) {
  return `${e}/mp4;codecs="${o}"`;
}
function Dr(o) {
  return o.split(",").reduce((e, t) => {
    const n = Ti.video[t];
    return n ? (n * 2 + e) / (e ? 3 : 2) : (Ti.audio[t] + e) / (e ? 2 : 1);
  }, 0);
}
const si = {};
function Pc(o, e = !0) {
  if (si[o])
    return si[o];
  const t = {
    flac: ["flac", "fLaC", "FLAC"],
    opus: ["opus", "Opus"]
  }[o];
  for (let n = 0; n < t.length; n++)
    if (ja(t[n], "audio", e))
      return si[o] = t[n], t[n];
  return o;
}
const Fc = /flac|opus/i;
function Or(o, e = !0) {
  return o.replace(Fc, (t) => Pc(t.toLowerCase(), e));
}
function ks(o, e) {
  return o && o !== "mp4a" ? o : e;
}
const Ds = /#EXT-X-STREAM-INF:([^\r\n]*)(?:[\r\n](?:#[^\r\n]*)?)*([^\r\n]+)|#EXT-X-(SESSION-DATA|SESSION-KEY|DEFINE|CONTENT-STEERING|START):([^\r\n]*)[\r\n]+/g, Os = /#EXT-X-MEDIA:(.*)/g, Mc = /^#EXT(?:INF|-X-TARGETDURATION):/m, Bs = new RegExp([
  /#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,
  // duration (#EXTINF:<duration>,<title>), group 1 => duration, group 2 => title
  /(?!#) *(\S[\S ]*)/.source,
  // segment URI, group 3 => the URI (note newline is not eaten)
  /#EXT-X-BYTERANGE:*(.+)/.source,
  // next segment's byterange, group 4 => range spec (x@y)
  /#EXT-X-PROGRAM-DATE-TIME:(.+)/.source,
  // next segment's program date/time group 5 => the datetime spec
  /#.*/.source
  // All other non-segment oriented tags will match with all groups empty
].join("|"), "g"), Uc = new RegExp([/#(EXTM3U)/.source, /#EXT-X-(DATERANGE|DEFINE|KEY|MAP|PART|PART-INF|PLAYLIST-TYPE|PRELOAD-HINT|RENDITION-REPORT|SERVER-CONTROL|SKIP|START):(.+)/.source, /#EXT-X-(BITRATE|DISCONTINUITY-SEQUENCE|MEDIA-SEQUENCE|TARGETDURATION|VERSION): *(\d+)/.source, /#EXT-X-(DISCONTINUITY|ENDLIST|GAP)/.source, /(#)([^:]*):(.*)/.source, /(#)(.*)(?:.*)\r?\n?/.source].join("|"));
class Dt {
  static findGroup(e, t) {
    for (let n = 0; n < e.length; n++) {
      const r = e[n];
      if (r.id === t)
        return r;
    }
  }
  static convertAVC1ToAVCOTI(e) {
    const t = e.split(".");
    if (t.length > 2) {
      let n = t.shift() + ".";
      return n += parseInt(t.shift()).toString(16), n += ("000" + parseInt(t.shift()).toString(16)).slice(-4), n;
    }
    return e;
  }
  static resolve(e, t) {
    return Ni.buildAbsoluteURL(t, e, {
      alwaysNormalize: !0
    });
  }
  static isMediaPlaylist(e) {
    return Mc.test(e);
  }
  static parseMasterPlaylist(e, t) {
    const n = Rs(e), r = {
      contentSteering: null,
      levels: [],
      playlistParsingError: null,
      sessionData: null,
      sessionKeys: null,
      startTimeOffset: null,
      variableList: null,
      hasVariableRefs: n
    }, i = [];
    Ds.lastIndex = 0;
    let s;
    for (; (s = Ds.exec(e)) != null; )
      if (s[1]) {
        var a;
        const d = new Ze(s[1]);
        vt(r, d, ["CODECS", "SUPPLEMENTAL-CODECS", "ALLOWED-CPC", "PATHWAY-ID", "STABLE-VARIANT-ID", "AUDIO", "VIDEO", "SUBTITLES", "CLOSED-CAPTIONS", "NAME"]);
        const h = Si(r, s[2]), u = {
          attrs: d,
          bitrate: d.decimalInteger("BANDWIDTH") || d.decimalInteger("AVERAGE-BANDWIDTH"),
          name: d.NAME,
          url: Dt.resolve(h, t)
        }, c = d.decimalResolution("RESOLUTION");
        c && (u.width = c.width, u.height = c.height), Nc((d.CODECS || "").split(/[ ,]+/).filter((m) => m), u), u.videoCodec && u.videoCodec.indexOf("avc1") !== -1 && (u.videoCodec = Dt.convertAVC1ToAVCOTI(u.videoCodec)), (a = u.unknownCodecs) != null && a.length || i.push(u), r.levels.push(u);
      } else if (s[3]) {
        const d = s[3], h = s[4];
        switch (d) {
          case "SESSION-DATA": {
            const u = new Ze(h);
            vt(r, u, ["DATA-ID", "LANGUAGE", "VALUE", "URI"]);
            const c = u["DATA-ID"];
            c && (r.sessionData === null && (r.sessionData = {}), r.sessionData[c] = u);
            break;
          }
          case "SESSION-KEY": {
            const u = Ps(h, t, r);
            u.encrypted && u.isSupported() ? (r.sessionKeys === null && (r.sessionKeys = []), r.sessionKeys.push(u)) : V.warn(`[Keys] Ignoring invalid EXT-X-SESSION-KEY tag: "${h}"`);
            break;
          }
          case "DEFINE": {
            {
              const u = new Ze(h);
              vt(r, u, ["NAME", "VALUE", "QUERYPARAM"]), Is(r, u, t);
            }
            break;
          }
          case "CONTENT-STEERING": {
            const u = new Ze(h);
            vt(r, u, ["SERVER-URI", "PATHWAY-ID"]), r.contentSteering = {
              uri: Dt.resolve(u["SERVER-URI"], t),
              pathwayId: u["PATHWAY-ID"] || "."
            };
            break;
          }
          case "START": {
            r.startTimeOffset = Fs(h);
            break;
          }
        }
      }
    const l = i.length > 0 && i.length < r.levels.length;
    return r.levels = l ? i : r.levels, r.levels.length === 0 && (r.playlistParsingError = new Error("no levels found in manifest")), r;
  }
  static parseMasterPlaylistMedia(e, t, n) {
    let r;
    const i = {}, s = n.levels, a = {
      AUDIO: s.map((d) => ({
        id: d.attrs.AUDIO,
        audioCodec: d.audioCodec
      })),
      SUBTITLES: s.map((d) => ({
        id: d.attrs.SUBTITLES,
        textCodec: d.textCodec
      })),
      "CLOSED-CAPTIONS": []
    };
    let l = 0;
    for (Os.lastIndex = 0; (r = Os.exec(e)) !== null; ) {
      const d = new Ze(r[1]), h = d.TYPE;
      if (h) {
        const u = a[h], c = i[h] || [];
        i[h] = c, vt(n, d, ["URI", "GROUP-ID", "LANGUAGE", "ASSOC-LANGUAGE", "STABLE-RENDITION-ID", "NAME", "INSTREAM-ID", "CHARACTERISTICS", "CHANNELS"]);
        const m = {
          attrs: d,
          bitrate: 0,
          id: l++,
          groupId: d["GROUP-ID"] || "",
          instreamId: d["INSTREAM-ID"],
          name: d.NAME || d.LANGUAGE || "",
          type: h,
          default: d.bool("DEFAULT"),
          autoselect: d.bool("AUTOSELECT"),
          forced: d.bool("FORCED"),
          lang: d.LANGUAGE,
          url: d.URI ? Dt.resolve(d.URI, t) : ""
        };
        if (u != null && u.length) {
          const f = Dt.findGroup(u, m.groupId) || u[0];
          Ms(m, f, "audioCodec"), Ms(m, f, "textCodec");
        }
        c.push(m);
      }
    }
    return i;
  }
  static parseLevelPlaylist(e, t, n, r, i, s) {
    const a = new nc(t), l = a.fragments;
    let d = null, h = 0, u = 0, c = 0, m = 0, f = null, p = new ei(r, t), A, v, b, _ = -1, T = !1;
    for (Bs.lastIndex = 0, a.m3u8 = e, a.hasVariableRefs = Rs(e); (A = Bs.exec(e)) !== null; ) {
      T && (T = !1, p = new ei(r, t), p.start = c, p.sn = h, p.cc = m, p.level = n, d && (p.initSegment = d, p.rawProgramDateTime = d.rawProgramDateTime, d.rawProgramDateTime = null));
      const D = A[1];
      if (D) {
        p.duration = parseFloat(D);
        const M = (" " + A[2]).slice(1);
        p.title = M || null, p.tagList.push(M ? ["INF", D, M] : ["INF", D]);
      } else if (A[3]) {
        if (ge(p.duration)) {
          p.start = c, b && js(p, b, a), p.sn = h, p.level = n, p.cc = m, p.urlId = i, l.push(p);
          const M = (" " + A[3]).slice(1);
          p.relurl = Si(a, M), Us(p, f), f = p, c += p.duration, h++, u = 0, T = !0;
        }
      } else if (A[4]) {
        const M = (" " + A[4]).slice(1);
        f ? p.setByteRange(M, f) : p.setByteRange(M);
      } else if (A[5])
        p.rawProgramDateTime = (" " + A[5]).slice(1), p.tagList.push(["PROGRAM-DATE-TIME", p.rawProgramDateTime]), _ === -1 && (_ = l.length);
      else {
        if (A = A[0].match(Uc), !A) {
          V.warn("No matches on slow regex match for level playlist!");
          continue;
        }
        for (v = 1; v < A.length && !(typeof A[v] < "u"); v++)
          ;
        const M = (" " + A[v]).slice(1), O = (" " + A[v + 1]).slice(1), N = A[v + 2] ? (" " + A[v + 2]).slice(1) : "";
        switch (M) {
          case "PLAYLIST-TYPE":
            a.type = O.toUpperCase();
            break;
          case "MEDIA-SEQUENCE":
            h = a.startSN = parseInt(O);
            break;
          case "SKIP": {
            const B = new Ze(O);
            vt(a, B, ["RECENTLY-REMOVED-DATERANGES"]);
            const U = B.decimalInteger("SKIPPED-SEGMENTS");
            if (ge(U)) {
              a.skippedSegments = U;
              for (let Y = U; Y--; )
                l.unshift(null);
              h += U;
            }
            const G = B.enumeratedString("RECENTLY-REMOVED-DATERANGES");
            G && (a.recentlyRemovedDateranges = G.split("	"));
            break;
          }
          case "TARGETDURATION":
            a.targetduration = Math.max(parseInt(O), 1);
            break;
          case "VERSION":
            a.version = parseInt(O);
            break;
          case "EXTM3U":
            break;
          case "ENDLIST":
            a.live = !1;
            break;
          case "#":
            (O || N) && p.tagList.push(N ? [O, N] : [O]);
            break;
          case "DISCONTINUITY":
            m++, p.tagList.push(["DIS"]);
            break;
          case "GAP":
            p.gap = !0, p.tagList.push([M]);
            break;
          case "BITRATE":
            p.tagList.push([M, O]);
            break;
          case "DATERANGE": {
            const B = new Ze(O);
            vt(a, B, ["ID", "CLASS", "START-DATE", "END-DATE", "SCTE35-CMD", "SCTE35-OUT", "SCTE35-IN"]), vt(a, B, B.clientAttrs);
            const U = new Ca(B, a.dateRanges[B.ID]);
            U.isValid || a.skippedSegments ? a.dateRanges[U.id] = U : V.warn(`Ignoring invalid DATERANGE tag: "${O}"`), p.tagList.push(["EXT-X-DATERANGE", O]);
            break;
          }
          case "DEFINE": {
            {
              const B = new Ze(O);
              vt(a, B, ["NAME", "VALUE", "IMPORT", "QUERYPARAM"]), "IMPORT" in B ? Oc(a, B, s) : Is(a, B, t);
            }
            break;
          }
          case "DISCONTINUITY-SEQUENCE":
            m = parseInt(O);
            break;
          case "KEY": {
            const B = Ps(O, t, a);
            if (B.isSupported()) {
              if (B.method === "NONE") {
                b = void 0;
                break;
              }
              b || (b = {}), b[B.keyFormat] && (b = lt({}, b)), b[B.keyFormat] = B;
            } else
              V.warn(`[Keys] Ignoring invalid EXT-X-KEY tag: "${O}"`);
            break;
          }
          case "START":
            a.startTimeOffset = Fs(O);
            break;
          case "MAP": {
            const B = new Ze(O);
            if (vt(a, B, ["BYTERANGE", "URI"]), p.duration) {
              const U = new ei(r, t);
              Ns(U, B, n, b), d = U, p.initSegment = d, d.rawProgramDateTime && !p.rawProgramDateTime && (p.rawProgramDateTime = d.rawProgramDateTime);
            } else
              Ns(p, B, n, b), d = p, T = !0;
            break;
          }
          case "SERVER-CONTROL": {
            const B = new Ze(O);
            a.canBlockReload = B.bool("CAN-BLOCK-RELOAD"), a.canSkipUntil = B.optionalFloat("CAN-SKIP-UNTIL", 0), a.canSkipDateRanges = a.canSkipUntil > 0 && B.bool("CAN-SKIP-DATERANGES"), a.partHoldBack = B.optionalFloat("PART-HOLD-BACK", 0), a.holdBack = B.optionalFloat("HOLD-BACK", 0);
            break;
          }
          case "PART-INF": {
            const B = new Ze(O);
            a.partTarget = B.decimalFloatingPoint("PART-TARGET");
            break;
          }
          case "PART": {
            let B = a.partList;
            B || (B = a.partList = []);
            const U = u > 0 ? B[B.length - 1] : void 0, G = u++, Y = new Ze(O);
            vt(a, Y, ["BYTERANGE", "URI"]);
            const z = new ec(Y, p, t, G, U);
            B.push(z), p.duration += z.duration;
            break;
          }
          case "PRELOAD-HINT": {
            const B = new Ze(O);
            vt(a, B, ["URI"]), a.preloadHint = B;
            break;
          }
          case "RENDITION-REPORT": {
            const B = new Ze(O);
            vt(a, B, ["URI"]), a.renditionReports = a.renditionReports || [], a.renditionReports.push(B);
            break;
          }
          default:
            V.warn(`line parsed but not handled: ${A}`);
            break;
        }
      }
    }
    f && !f.relurl ? (l.pop(), c -= f.duration, a.partList && (a.fragmentHint = f)) : a.partList && (Us(p, f), p.cc = m, a.fragmentHint = p, b && js(p, b, a));
    const E = l.length, L = l[0], k = l[E - 1];
    if (c += a.skippedSegments * a.targetduration, c > 0 && E && k) {
      a.averagetargetduration = c / E;
      const D = k.sn;
      a.endSN = D !== "initSegment" ? D : 0, a.live || (k.endList = !0), L && (a.startCC = L.cc);
    } else
      a.endSN = 0, a.startCC = 0;
    return a.fragmentHint && (c += a.fragmentHint.duration), a.totalduration = c, a.endCC = m, _ > 0 && jc(l, _), a;
  }
}
function Ps(o, e, t) {
  var n, r;
  const i = new Ze(o);
  vt(t, i, ["KEYFORMAT", "KEYFORMATVERSIONS", "URI", "IV", "URI"]);
  const s = (n = i.METHOD) != null ? n : "", a = i.URI, l = i.hexadecimalInteger("IV"), d = i.KEYFORMATVERSIONS, h = (r = i.KEYFORMAT) != null ? r : "identity";
  a && i.IV && !l && V.error(`Invalid IV: ${i.IV}`);
  const u = a ? Dt.resolve(a, e) : "", c = (d || "1").split("/").map(Number).filter(Number.isFinite);
  return new nr(s, u, h, c, l);
}
function Fs(o) {
  const t = new Ze(o).decimalFloatingPoint("TIME-OFFSET");
  return ge(t) ? t : null;
}
function Nc(o, e) {
  ["video", "audio", "text"].forEach((t) => {
    const n = o.filter((r) => Bc(r, t));
    n.length && (e[`${t}Codec`] = n.join(","), o = o.filter((r) => n.indexOf(r) === -1));
  }), e.unknownCodecs = o;
}
function Ms(o, e, t) {
  const n = e[t];
  n && (o[t] = n);
}
function jc(o, e) {
  let t = o[e];
  for (let n = e; n--; ) {
    const r = o[n];
    if (!r)
      return;
    r.programDateTime = t.programDateTime - r.duration * 1e3, t = r;
  }
}
function Us(o, e) {
  o.rawProgramDateTime ? o.programDateTime = Date.parse(o.rawProgramDateTime) : e != null && e.programDateTime && (o.programDateTime = e.endProgramDateTime), ge(o.programDateTime) || (o.programDateTime = null, o.rawProgramDateTime = null);
}
function Ns(o, e, t, n) {
  o.relurl = e.URI, e.BYTERANGE && o.setByteRange(e.BYTERANGE), o.level = t, o.sn = "initSegment", n && (o.levelkeys = n), o.initSegment = null;
}
function js(o, e, t) {
  o.levelkeys = e;
  const {
    encryptedFragments: n
  } = t;
  (!n.length || n[n.length - 1].levelkeys !== e) && Object.keys(e).some((r) => e[r].isCommonEncryption) && n.push(o);
}
var Ue = {
  MANIFEST: "manifest",
  LEVEL: "level",
  AUDIO_TRACK: "audioTrack",
  SUBTITLE_TRACK: "subtitleTrack"
}, be = {
  MAIN: "main",
  AUDIO: "audio",
  SUBTITLE: "subtitle"
};
function Gs(o) {
  const {
    type: e
  } = o;
  switch (e) {
    case Ue.AUDIO_TRACK:
      return be.AUDIO;
    case Ue.SUBTITLE_TRACK:
      return be.SUBTITLE;
    default:
      return be.MAIN;
  }
}
function ai(o, e) {
  let t = o.url;
  return (t === void 0 || t.indexOf("data:") === 0) && (t = e.url), t;
}
class Gc {
  constructor(e) {
    this.hls = void 0, this.loaders = /* @__PURE__ */ Object.create(null), this.variableList = null, this.hls = e, this.registerListeners();
  }
  startLoad(e) {
  }
  stopLoad() {
    this.destroyInternalLoaders();
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(I.MANIFEST_LOADING, this.onManifestLoading, this), e.on(I.LEVEL_LOADING, this.onLevelLoading, this), e.on(I.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this), e.on(I.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(I.MANIFEST_LOADING, this.onManifestLoading, this), e.off(I.LEVEL_LOADING, this.onLevelLoading, this), e.off(I.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this), e.off(I.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
  }
  /**
   * Returns defaults or configured loader-type overloads (pLoader and loader config params)
   */
  createInternalLoader(e) {
    const t = this.hls.config, n = t.pLoader, r = t.loader, i = n || r, s = new i(t);
    return this.loaders[e.type] = s, s;
  }
  getInternalLoader(e) {
    return this.loaders[e.type];
  }
  resetInternalLoader(e) {
    this.loaders[e] && delete this.loaders[e];
  }
  /**
   * Call `destroy` on all internal loader instances mapped (one per context type)
   */
  destroyInternalLoaders() {
    for (const e in this.loaders) {
      const t = this.loaders[e];
      t && t.destroy(), this.resetInternalLoader(e);
    }
  }
  destroy() {
    this.variableList = null, this.unregisterListeners(), this.destroyInternalLoaders();
  }
  onManifestLoading(e, t) {
    const {
      url: n
    } = t;
    this.variableList = null, this.load({
      id: null,
      level: 0,
      responseType: "text",
      type: Ue.MANIFEST,
      url: n,
      deliveryDirectives: null
    });
  }
  onLevelLoading(e, t) {
    const {
      id: n,
      level: r,
      url: i,
      deliveryDirectives: s
    } = t;
    this.load({
      id: n,
      level: r,
      responseType: "text",
      type: Ue.LEVEL,
      url: i,
      deliveryDirectives: s
    });
  }
  onAudioTrackLoading(e, t) {
    const {
      id: n,
      groupId: r,
      url: i,
      deliveryDirectives: s
    } = t;
    this.load({
      id: n,
      groupId: r,
      level: null,
      responseType: "text",
      type: Ue.AUDIO_TRACK,
      url: i,
      deliveryDirectives: s
    });
  }
  onSubtitleTrackLoading(e, t) {
    const {
      id: n,
      groupId: r,
      url: i,
      deliveryDirectives: s
    } = t;
    this.load({
      id: n,
      groupId: r,
      level: null,
      responseType: "text",
      type: Ue.SUBTITLE_TRACK,
      url: i,
      deliveryDirectives: s
    });
  }
  load(e) {
    var t;
    const n = this.hls.config;
    let r = this.getInternalLoader(e);
    if (r) {
      const d = r.context;
      if (d && d.url === e.url) {
        V.trace("[playlist-loader]: playlist request ongoing");
        return;
      }
      V.log(`[playlist-loader]: aborting previous loader for type: ${e.type}`), r.abort();
    }
    let i;
    if (e.type === Ue.MANIFEST ? i = n.manifestLoadPolicy.default : i = lt({}, n.playlistLoadPolicy.default, {
      timeoutRetry: null,
      errorRetry: null
    }), r = this.createInternalLoader(e), ge((t = e.deliveryDirectives) == null ? void 0 : t.part)) {
      let d;
      if (e.type === Ue.LEVEL && e.level !== null ? d = this.hls.levels[e.level].details : e.type === Ue.AUDIO_TRACK && e.id !== null ? d = this.hls.audioTracks[e.id].details : e.type === Ue.SUBTITLE_TRACK && e.id !== null && (d = this.hls.subtitleTracks[e.id].details), d) {
        const h = d.partTarget, u = d.targetduration;
        if (h && u) {
          const c = Math.max(h * 3, u * 0.8) * 1e3;
          i = lt({}, i, {
            maxTimeToFirstByteMs: Math.min(c, i.maxTimeToFirstByteMs),
            maxLoadTimeMs: Math.min(c, i.maxTimeToFirstByteMs)
          });
        }
      }
    }
    const s = i.errorRetry || i.timeoutRetry || {}, a = {
      loadPolicy: i,
      timeout: i.maxLoadTimeMs,
      maxRetry: s.maxNumRetry || 0,
      retryDelay: s.retryDelayMs || 0,
      maxRetryDelay: s.maxRetryDelayMs || 0
    }, l = {
      onSuccess: (d, h, u, c) => {
        const m = this.getInternalLoader(u);
        this.resetInternalLoader(u.type);
        const f = d.data;
        if (f.indexOf("#EXTM3U") !== 0) {
          this.handleManifestParsingError(d, u, new Error("no EXTM3U delimiter"), c || null, h);
          return;
        }
        h.parsing.start = performance.now(), Dt.isMediaPlaylist(f) ? this.handleTrackOrLevelPlaylist(d, h, u, c || null, m) : this.handleMasterPlaylist(d, h, u, c);
      },
      onError: (d, h, u, c) => {
        this.handleNetworkError(h, u, !1, d, c);
      },
      onTimeout: (d, h, u) => {
        this.handleNetworkError(h, u, !0, void 0, d);
      }
    };
    r.load(e, a, l);
  }
  handleMasterPlaylist(e, t, n, r) {
    const i = this.hls, s = e.data, a = ai(e, n), l = Dt.parseMasterPlaylist(s, a);
    if (l.playlistParsingError) {
      this.handleManifestParsingError(e, n, l.playlistParsingError, r, t);
      return;
    }
    const {
      contentSteering: d,
      levels: h,
      sessionData: u,
      sessionKeys: c,
      startTimeOffset: m,
      variableList: f
    } = l;
    this.variableList = f;
    const {
      AUDIO: p = [],
      SUBTITLES: A,
      "CLOSED-CAPTIONS": v
    } = Dt.parseMasterPlaylistMedia(s, a, l);
    p.length && !p.some((_) => !_.url) && h[0].audioCodec && !h[0].attrs.AUDIO && (V.log("[playlist-loader]: audio codec signaled in quality level, but no embedded audio track signaled, create one"), p.unshift({
      type: "main",
      name: "main",
      groupId: "main",
      default: !1,
      autoselect: !1,
      forced: !1,
      id: -1,
      attrs: new Ze({}),
      bitrate: 0,
      url: ""
    })), i.trigger(I.MANIFEST_LOADED, {
      levels: h,
      audioTracks: p,
      subtitles: A,
      captions: v,
      contentSteering: d,
      url: a,
      stats: t,
      networkDetails: r,
      sessionData: u,
      sessionKeys: c,
      startTimeOffset: m,
      variableList: f
    });
  }
  handleTrackOrLevelPlaylist(e, t, n, r, i) {
    const s = this.hls, {
      id: a,
      level: l,
      type: d
    } = n, h = ai(e, n), u = ge(a) ? a : 0, c = ge(l) ? l : u, m = Gs(n), f = Dt.parseLevelPlaylist(e.data, h, c, m, u, this.variableList);
    if (d === Ue.MANIFEST) {
      const p = {
        attrs: new Ze({}),
        bitrate: 0,
        details: f,
        name: "",
        url: h
      };
      s.trigger(I.MANIFEST_LOADED, {
        levels: [p],
        audioTracks: [],
        url: h,
        stats: t,
        networkDetails: r,
        sessionData: null,
        sessionKeys: null,
        contentSteering: null,
        startTimeOffset: null,
        variableList: null
      });
    }
    t.parsing.end = performance.now(), n.levelDetails = f, this.handlePlaylistLoaded(f, e, t, n, r, i);
  }
  handleManifestParsingError(e, t, n, r, i) {
    this.hls.trigger(I.ERROR, {
      type: xe.NETWORK_ERROR,
      details: q.MANIFEST_PARSING_ERROR,
      fatal: t.type === Ue.MANIFEST,
      url: e.url,
      err: n,
      error: n,
      reason: n.message,
      response: e,
      context: t,
      networkDetails: r,
      stats: i
    });
  }
  handleNetworkError(e, t, n = !1, r, i) {
    let s = `A network ${n ? "timeout" : "error" + (r ? " (status " + r.code + ")" : "")} occurred while loading ${e.type}`;
    e.type === Ue.LEVEL ? s += `: ${e.level} id: ${e.id}` : (e.type === Ue.AUDIO_TRACK || e.type === Ue.SUBTITLE_TRACK) && (s += ` id: ${e.id} group-id: "${e.groupId}"`);
    const a = new Error(s);
    V.warn(`[playlist-loader]: ${s}`);
    let l = q.UNKNOWN, d = !1;
    const h = this.getInternalLoader(e);
    switch (e.type) {
      case Ue.MANIFEST:
        l = n ? q.MANIFEST_LOAD_TIMEOUT : q.MANIFEST_LOAD_ERROR, d = !0;
        break;
      case Ue.LEVEL:
        l = n ? q.LEVEL_LOAD_TIMEOUT : q.LEVEL_LOAD_ERROR, d = !1;
        break;
      case Ue.AUDIO_TRACK:
        l = n ? q.AUDIO_TRACK_LOAD_TIMEOUT : q.AUDIO_TRACK_LOAD_ERROR, d = !1;
        break;
      case Ue.SUBTITLE_TRACK:
        l = n ? q.SUBTITLE_TRACK_LOAD_TIMEOUT : q.SUBTITLE_LOAD_ERROR, d = !1;
        break;
    }
    h && this.resetInternalLoader(e.type);
    const u = {
      type: xe.NETWORK_ERROR,
      details: l,
      fatal: d,
      url: e.url,
      loader: h,
      context: e,
      error: a,
      networkDetails: t,
      stats: i
    };
    if (r) {
      const c = (t == null ? void 0 : t.url) || e.url;
      u.response = it({
        url: c,
        data: void 0
      }, r);
    }
    this.hls.trigger(I.ERROR, u);
  }
  handlePlaylistLoaded(e, t, n, r, i, s) {
    const a = this.hls, {
      type: l,
      level: d,
      id: h,
      groupId: u,
      deliveryDirectives: c
    } = r, m = ai(t, r), f = Gs(r), p = typeof r.level == "number" && f === be.MAIN ? d : void 0;
    if (!e.fragments.length) {
      const v = new Error("No Segments found in Playlist");
      a.trigger(I.ERROR, {
        type: xe.NETWORK_ERROR,
        details: q.LEVEL_EMPTY_ERROR,
        fatal: !1,
        url: m,
        error: v,
        reason: v.message,
        response: t,
        context: r,
        level: p,
        parent: f,
        networkDetails: i,
        stats: n
      });
      return;
    }
    e.targetduration || (e.playlistParsingError = new Error("Missing Target Duration"));
    const A = e.playlistParsingError;
    if (A) {
      a.trigger(I.ERROR, {
        type: xe.NETWORK_ERROR,
        details: q.LEVEL_PARSING_ERROR,
        fatal: !1,
        url: m,
        error: A,
        reason: A.message,
        response: t,
        context: r,
        level: p,
        parent: f,
        networkDetails: i,
        stats: n
      });
      return;
    }
    switch (e.live && s && (s.getCacheAge && (e.ageHeader = s.getCacheAge() || 0), (!s.getCacheAge || isNaN(e.ageHeader)) && (e.ageHeader = 0)), l) {
      case Ue.MANIFEST:
      case Ue.LEVEL:
        a.trigger(I.LEVEL_LOADED, {
          details: e,
          level: p || 0,
          id: h || 0,
          stats: n,
          networkDetails: i,
          deliveryDirectives: c
        });
        break;
      case Ue.AUDIO_TRACK:
        a.trigger(I.AUDIO_TRACK_LOADED, {
          details: e,
          id: h || 0,
          groupId: u || "",
          stats: n,
          networkDetails: i,
          deliveryDirectives: c
        });
        break;
      case Ue.SUBTITLE_TRACK:
        a.trigger(I.SUBTITLE_TRACK_LOADED, {
          details: e,
          id: h || 0,
          groupId: u || "",
          stats: n,
          networkDetails: i,
          deliveryDirectives: c
        });
        break;
    }
  }
}
function Ga(o, e) {
  let t;
  try {
    t = new Event("addtrack");
  } catch {
    t = document.createEvent("Event"), t.initEvent("addtrack", !1, !1);
  }
  t.track = o, e.dispatchEvent(t);
}
function Ka(o, e) {
  const t = o.mode;
  if (t === "disabled" && (o.mode = "hidden"), o.cues && !o.cues.getCueById(e.id))
    try {
      if (o.addCue(e), !o.cues.getCueById(e.id))
        throw new Error(`addCue is failed for: ${e}`);
    } catch (n) {
      V.debug(`[texttrack-utils]: ${n}`);
      try {
        const r = new self.TextTrackCue(e.startTime, e.endTime, e.text);
        r.id = e.id, o.addCue(r);
      } catch (r) {
        V.debug(`[texttrack-utils]: Legacy TextTrackCue fallback failed: ${r}`);
      }
    }
  t === "disabled" && (o.mode = t);
}
function _n(o) {
  const e = o.mode;
  if (e === "disabled" && (o.mode = "hidden"), o.cues)
    for (let t = o.cues.length; t--; )
      o.removeCue(o.cues[t]);
  e === "disabled" && (o.mode = e);
}
function Li(o, e, t, n) {
  const r = o.mode;
  if (r === "disabled" && (o.mode = "hidden"), o.cues && o.cues.length > 0) {
    const i = $c(o.cues, e, t);
    for (let s = 0; s < i.length; s++)
      (!n || n(i[s])) && o.removeCue(i[s]);
  }
  r === "disabled" && (o.mode = r);
}
function Kc(o, e) {
  if (e < o[0].startTime)
    return 0;
  const t = o.length - 1;
  if (e > o[t].endTime)
    return -1;
  let n = 0, r = t;
  for (; n <= r; ) {
    const i = Math.floor((r + n) / 2);
    if (e < o[i].startTime)
      r = i - 1;
    else if (e > o[i].startTime && n < t)
      n = i + 1;
    else
      return i;
  }
  return o[n].startTime - e < e - o[r].startTime ? n : r;
}
function $c(o, e, t) {
  const n = [], r = Kc(o, e);
  if (r > -1)
    for (let i = r, s = o.length; i < s; i++) {
      const a = o[i];
      if (a.startTime >= e && a.endTime <= t)
        n.push(a);
      else if (a.startTime > t)
        return n;
    }
  return n;
}
var kt = {
  audioId3: "org.id3",
  dateRange: "com.apple.quicktime.HLS",
  emsg: "https://aomedia.org/emsg/ID3"
};
const Vc = 0.25;
function wi() {
  if (!(typeof self > "u"))
    return self.WebKitDataCue || self.VTTCue || self.TextTrackCue;
}
const vr = (() => {
  const o = wi();
  try {
    new o(0, Number.POSITIVE_INFINITY, "");
  } catch {
    return Number.MAX_VALUE;
  }
  return Number.POSITIVE_INFINITY;
})();
function oi(o, e) {
  return o.getTime() / 1e3 - e;
}
function Wc(o) {
  return Uint8Array.from(o.replace(/^0x/, "").replace(/([\da-fA-F]{2}) ?/g, "0x$1 ").replace(/ +$/, "").split(" ")).buffer;
}
class Hc {
  constructor(e) {
    this.hls = void 0, this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {}, this.hls = e, this._registerListeners();
  }
  destroy() {
    this._unregisterListeners(), this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {}, this.hls = null;
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(I.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(I.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(I.MANIFEST_LOADING, this.onManifestLoading, this), e.on(I.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this), e.on(I.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(I.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(I.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(I.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(I.MANIFEST_LOADING, this.onManifestLoading, this), e.off(I.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this), e.off(I.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(I.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  // Add ID3 metatadata text track.
  onMediaAttached(e, t) {
    this.media = t.media;
  }
  onMediaDetaching() {
    this.id3Track && (_n(this.id3Track), this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {});
  }
  onManifestLoading() {
    this.dateRangeCuesAppended = {};
  }
  createTrack(e) {
    const t = this.getID3Track(e.textTracks);
    return t.mode = "hidden", t;
  }
  getID3Track(e) {
    if (this.media) {
      for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n.kind === "metadata" && n.label === "id3")
          return Ga(n, this.media), n;
      }
      return this.media.addTextTrack("metadata", "id3");
    }
  }
  onFragParsingMetadata(e, t) {
    if (!this.media)
      return;
    const {
      hls: {
        config: {
          enableEmsgMetadataCues: n,
          enableID3MetadataCues: r
        }
      }
    } = this;
    if (!n && !r)
      return;
    const {
      samples: i
    } = t;
    this.id3Track || (this.id3Track = this.createTrack(this.media));
    const s = wi();
    for (let a = 0; a < i.length; a++) {
      const l = i[a].type;
      if (l === kt.emsg && !n || !r)
        continue;
      const d = Da(i[a].data);
      if (d) {
        const h = i[a].pts;
        let u = h + i[a].duration;
        u > vr && (u = vr), u - h <= 0 && (u = h + Vc);
        for (let m = 0; m < d.length; m++) {
          const f = d[m];
          if (!ka(f)) {
            this.updateId3CueEnds(h, l);
            const p = new s(h, u, "");
            p.value = f, l && (p.type = l), this.id3Track.addCue(p);
          }
        }
      }
    }
  }
  updateId3CueEnds(e, t) {
    var n;
    const r = (n = this.id3Track) == null ? void 0 : n.cues;
    if (r)
      for (let i = r.length; i--; ) {
        const s = r[i];
        s.type === t && s.startTime < e && s.endTime === vr && (s.endTime = e);
      }
  }
  onBufferFlushing(e, {
    startOffset: t,
    endOffset: n,
    type: r
  }) {
    const {
      id3Track: i,
      hls: s
    } = this;
    if (!s)
      return;
    const {
      config: {
        enableEmsgMetadataCues: a,
        enableID3MetadataCues: l
      }
    } = s;
    if (i && (a || l)) {
      let d;
      r === "audio" ? d = (h) => h.type === kt.audioId3 && l : r === "video" ? d = (h) => h.type === kt.emsg && a : d = (h) => h.type === kt.audioId3 && l || h.type === kt.emsg && a, Li(i, t, n, d);
    }
  }
  onLevelUpdated(e, {
    details: t
  }) {
    if (!this.media || !t.hasProgramDateTime || !this.hls.config.enableDateRangeMetadataCues)
      return;
    const {
      dateRangeCuesAppended: n,
      id3Track: r
    } = this, {
      dateRanges: i
    } = t, s = Object.keys(i);
    if (r) {
      const h = Object.keys(n).filter((u) => !s.includes(u));
      for (let u = h.length; u--; ) {
        const c = h[u];
        Object.keys(n[c].cues).forEach((m) => {
          r.removeCue(n[c].cues[m]);
        }), delete n[c];
      }
    }
    const a = t.fragments[t.fragments.length - 1];
    if (s.length === 0 || !ge(a == null ? void 0 : a.programDateTime))
      return;
    this.id3Track || (this.id3Track = this.createTrack(this.media));
    const l = a.programDateTime / 1e3 - a.start, d = wi();
    for (let h = 0; h < s.length; h++) {
      const u = s[h], c = i[u], m = n[u], f = (m == null ? void 0 : m.cues) || {};
      let p = (m == null ? void 0 : m.durationKnown) || !1;
      const A = oi(c.startDate, l);
      let v = vr;
      const b = c.endDate;
      if (b)
        v = oi(b, l), p = !0;
      else if (c.endOnNext && !p) {
        const T = s.reduce((E, L) => {
          const k = i[L];
          return k.class === c.class && k.id !== L && k.startDate > c.startDate && E.push(k), E;
        }, []).sort((E, L) => E.startDate.getTime() - L.startDate.getTime())[0];
        T && (v = oi(T.startDate, l), p = !0);
      }
      const _ = Object.keys(c.attr);
      for (let T = 0; T < _.length; T++) {
        const E = _[T];
        if (!Zd(E))
          continue;
        let L = f[E];
        if (L)
          p && !m.durationKnown && (L.endTime = v);
        else {
          let k = c.attr[E];
          L = new d(A, v, ""), Jd(E) && (k = Wc(k)), L.value = {
            key: E,
            data: k
          }, L.type = kt.dateRange, L.id = u, this.id3Track.addCue(L), f[E] = L;
        }
      }
      n[u] = {
        cues: f,
        dateRange: c,
        durationKnown: p
      };
    }
  }
}
class zc {
  constructor(e) {
    this.hls = void 0, this.config = void 0, this.media = null, this.levelDetails = null, this.currentTime = 0, this.stallCount = 0, this._latency = null, this.timeupdateHandler = () => this.timeupdate(), this.hls = e, this.config = e.config, this.registerListeners();
  }
  get latency() {
    return this._latency || 0;
  }
  get maxLatency() {
    const {
      config: e,
      levelDetails: t
    } = this;
    return e.liveMaxLatencyDuration !== void 0 ? e.liveMaxLatencyDuration : t ? e.liveMaxLatencyDurationCount * t.targetduration : 0;
  }
  get targetLatency() {
    const {
      levelDetails: e
    } = this;
    if (e === null)
      return null;
    const {
      holdBack: t,
      partHoldBack: n,
      targetduration: r
    } = e, {
      liveSyncDuration: i,
      liveSyncDurationCount: s,
      lowLatencyMode: a
    } = this.config, l = this.hls.userConfig;
    let d = a && n || t;
    (l.liveSyncDuration || l.liveSyncDurationCount || d === 0) && (d = i !== void 0 ? i : s * r);
    const h = r, u = 1;
    return d + Math.min(this.stallCount * u, h);
  }
  get liveSyncPosition() {
    const e = this.estimateLiveEdge(), t = this.targetLatency, n = this.levelDetails;
    if (e === null || t === null || n === null)
      return null;
    const r = n.edge, i = e - t - this.edgeStalled, s = r - n.totalduration, a = r - (this.config.lowLatencyMode && n.partTarget || n.targetduration);
    return Math.min(Math.max(s, i), a);
  }
  get drift() {
    const {
      levelDetails: e
    } = this;
    return e === null ? 1 : e.drift;
  }
  get edgeStalled() {
    const {
      levelDetails: e
    } = this;
    if (e === null)
      return 0;
    const t = (this.config.lowLatencyMode && e.partTarget || e.targetduration) * 3;
    return Math.max(e.age - t, 0);
  }
  get forwardBufferLength() {
    const {
      media: e,
      levelDetails: t
    } = this;
    if (!e || !t)
      return 0;
    const n = e.buffered.length;
    return (n ? e.buffered.end(n - 1) : t.edge) - this.currentTime;
  }
  destroy() {
    this.unregisterListeners(), this.onMediaDetaching(), this.levelDetails = null, this.hls = this.timeupdateHandler = null;
  }
  registerListeners() {
    this.hls.on(I.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.on(I.MEDIA_DETACHING, this.onMediaDetaching, this), this.hls.on(I.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.on(I.LEVEL_UPDATED, this.onLevelUpdated, this), this.hls.on(I.ERROR, this.onError, this);
  }
  unregisterListeners() {
    this.hls.off(I.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.off(I.MEDIA_DETACHING, this.onMediaDetaching, this), this.hls.off(I.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.off(I.LEVEL_UPDATED, this.onLevelUpdated, this), this.hls.off(I.ERROR, this.onError, this);
  }
  onMediaAttached(e, t) {
    this.media = t.media, this.media.addEventListener("timeupdate", this.timeupdateHandler);
  }
  onMediaDetaching() {
    this.media && (this.media.removeEventListener("timeupdate", this.timeupdateHandler), this.media = null);
  }
  onManifestLoading() {
    this.levelDetails = null, this._latency = null, this.stallCount = 0;
  }
  onLevelUpdated(e, {
    details: t
  }) {
    this.levelDetails = t, t.advanced && this.timeupdate(), !t.live && this.media && this.media.removeEventListener("timeupdate", this.timeupdateHandler);
  }
  onError(e, t) {
    var n;
    t.details === q.BUFFER_STALLED_ERROR && (this.stallCount++, (n = this.levelDetails) != null && n.live && V.warn("[playback-rate-controller]: Stall detected, adjusting target latency"));
  }
  timeupdate() {
    const {
      media: e,
      levelDetails: t
    } = this;
    if (!e || !t)
      return;
    this.currentTime = e.currentTime;
    const n = this.computeLatency();
    if (n === null)
      return;
    this._latency = n;
    const {
      lowLatencyMode: r,
      maxLiveSyncPlaybackRate: i
    } = this.config;
    if (!r || i === 1)
      return;
    const s = this.targetLatency;
    if (s === null)
      return;
    const a = n - s, l = Math.min(this.maxLatency, s + t.targetduration), d = a < l;
    if (t.live && d && a > 0.05 && this.forwardBufferLength > 1) {
      const h = Math.min(2, Math.max(1, i)), u = Math.round(2 / (1 + Math.exp(-0.75 * a - this.edgeStalled)) * 20) / 20;
      e.playbackRate = Math.min(h, Math.max(1, u));
    } else
      e.playbackRate !== 1 && e.playbackRate !== 0 && (e.playbackRate = 1);
  }
  estimateLiveEdge() {
    const {
      levelDetails: e
    } = this;
    return e === null ? null : e.edge + e.age;
  }
  computeLatency() {
    const e = this.estimateLiveEdge();
    return e === null ? null : e - this.currentTime;
  }
}
const Ri = ["NONE", "TYPE-0", "TYPE-1", null];
function Yc(o) {
  return Ri.indexOf(o) > -1;
}
const Ii = ["SDR", "PQ", "HLG"];
function qc(o) {
  return !!o && Ii.indexOf(o) > -1;
}
var Jn = {
  No: "",
  Yes: "YES",
  v2: "v2"
};
function Xc(o, e) {
  const {
    canSkipUntil: t,
    canSkipDateRanges: n,
    endSN: r
  } = o, i = e !== void 0 ? e - r : 0;
  return t && i < t ? n ? Jn.v2 : Jn.Yes : Jn.No;
}
class Ks {
  constructor(e, t, n) {
    this.msn = void 0, this.part = void 0, this.skip = void 0, this.msn = e, this.part = t, this.skip = n;
  }
  addDirectives(e) {
    const t = new self.URL(e);
    return this.msn !== void 0 && t.searchParams.set("_HLS_msn", this.msn.toString()), this.part !== void 0 && t.searchParams.set("_HLS_part", this.part.toString()), this.skip && t.searchParams.set("_HLS_skip", this.skip), t.href;
  }
}
class rr {
  constructor(e) {
    this._attrs = void 0, this.audioCodec = void 0, this.bitrate = void 0, this.codecSet = void 0, this.frameRate = void 0, this.height = void 0, this.id = void 0, this.name = void 0, this.videoCodec = void 0, this.width = void 0, this.unknownCodecs = void 0, this.audioGroupIds = void 0, this.details = void 0, this.fragmentError = 0, this.loadError = 0, this.loaded = void 0, this.realBitrate = 0, this.textGroupIds = void 0, this.url = void 0, this.supportedPromise = void 0, this.supportedResult = void 0, this._urlId = 0, this._avgBitrate = 0, this.url = [e.url], this._attrs = [e.attrs], this.bitrate = e.bitrate, e.details && (this.details = e.details), this.id = e.id || 0, this.name = e.name, this.width = e.width || 0, this.height = e.height || 0, this.frameRate = e.attrs.optionalFloat("FRAME-RATE", 0), this._avgBitrate = this.attrs.decimalInteger("AVERAGE-BANDWIDTH"), this.audioCodec = e.audioCodec, this.videoCodec = e.videoCodec, this.unknownCodecs = e.unknownCodecs, this.codecSet = [e.videoCodec, e.audioCodec].filter((t) => !!t).map((t) => t.substring(0, 4)).join(",");
  }
  get maxBitrate() {
    return Math.max(this.realBitrate, this.bitrate);
  }
  get averageBitrate() {
    return this._avgBitrate || this.realBitrate || this.bitrate;
  }
  get attrs() {
    return this._attrs[this._urlId];
  }
  get codecs() {
    return this.attrs.CODECS || "";
  }
  get pathwayId() {
    return this.attrs["PATHWAY-ID"] || ".";
  }
  get videoRange() {
    return this.attrs["VIDEO-RANGE"] || "SDR";
  }
  get score() {
    return this.attrs.optionalFloat("SCORE", 0);
  }
  get uri() {
    return this.url[this._urlId] || "";
  }
  get urlId() {
    return this._urlId;
  }
  set urlId(e) {
    const t = e % this.url.length;
    this._urlId !== t && (this.fragmentError = 0, this.loadError = 0, this.details = void 0, this._urlId = t);
  }
  get audioGroupId() {
    var e;
    return (e = this.audioGroupIds) == null ? void 0 : e[this.urlId];
  }
  get textGroupId() {
    var e;
    return (e = this.textGroupIds) == null ? void 0 : e[this.urlId];
  }
  addFallback(e) {
    this.url.push(e.url), this._attrs.push(e.attrs);
  }
}
function Br(o, e, t) {
  t && (e === "audio" ? (o.audioGroupIds || (o.audioGroupIds = []), o.audioGroupIds[o.url.length - 1] = t) : e === "text" && (o.textGroupIds || (o.textGroupIds = []), o.textGroupIds[o.url.length - 1] = t));
}
function li(o, e) {
  const t = e.startPTS;
  if (ge(t)) {
    let n = 0, r;
    e.sn > o.sn ? (n = t - o.start, r = o) : (n = o.start - t, r = e), r.duration !== n && (r.duration = n);
  } else
    e.sn > o.sn ? o.cc === e.cc && o.minEndPTS ? e.start = o.start + (o.minEndPTS - o.start) : e.start = o.start + o.duration : e.start = Math.max(o.start - e.duration, 0);
}
function $a(o, e, t, n, r, i) {
  n - t <= 0 && (V.warn("Fragment should have a positive duration", e), n = t + e.duration, i = r + e.duration);
  let a = t, l = n;
  const d = e.startPTS, h = e.endPTS;
  if (ge(d)) {
    const A = Math.abs(d - t);
    ge(e.deltaPTS) ? e.deltaPTS = Math.max(A, e.deltaPTS) : e.deltaPTS = A, a = Math.max(t, d), t = Math.min(t, d), r = Math.min(r, e.startDTS), l = Math.min(n, h), n = Math.max(n, h), i = Math.max(i, e.endDTS);
  }
  const u = t - e.start;
  e.start !== 0 && (e.start = t), e.duration = n - e.start, e.startPTS = t, e.maxStartPTS = a, e.startDTS = r, e.endPTS = n, e.minEndPTS = l, e.endDTS = i;
  const c = e.sn;
  if (!o || c < o.startSN || c > o.endSN)
    return 0;
  let m;
  const f = c - o.startSN, p = o.fragments;
  for (p[f] = e, m = f; m > 0; m--)
    li(p[m], p[m - 1]);
  for (m = f; m < p.length - 1; m++)
    li(p[m], p[m + 1]);
  return o.fragmentHint && li(p[p.length - 1], o.fragmentHint), o.PTSKnown = o.alignedSliding = !0, u;
}
function Qc(o, e) {
  let t = null;
  const n = o.fragments;
  for (let l = n.length - 1; l >= 0; l--) {
    const d = n[l].initSegment;
    if (d) {
      t = d;
      break;
    }
  }
  o.fragmentHint && delete o.fragmentHint.endPTS;
  let r = 0, i;
  if (eu(o, e, (l, d) => {
    l.relurl && (r = l.cc - d.cc), ge(l.startPTS) && ge(l.endPTS) && (d.start = d.startPTS = l.startPTS, d.startDTS = l.startDTS, d.maxStartPTS = l.maxStartPTS, d.endPTS = l.endPTS, d.endDTS = l.endDTS, d.minEndPTS = l.minEndPTS, d.duration = l.endPTS - l.startPTS, d.duration && (i = d), e.PTSKnown = e.alignedSliding = !0), d.elementaryStreams = l.elementaryStreams, d.loader = l.loader, d.stats = l.stats, d.urlId = l.urlId, l.initSegment && (d.initSegment = l.initSegment, t = l.initSegment);
  }), t && (e.fragmentHint ? e.fragments.concat(e.fragmentHint) : e.fragments).forEach((d) => {
    var h;
    (!d.initSegment || d.initSegment.relurl === ((h = t) == null ? void 0 : h.relurl)) && (d.initSegment = t);
  }), e.skippedSegments)
    if (e.deltaUpdateFailed = e.fragments.some((l) => !l), e.deltaUpdateFailed) {
      V.warn("[level-helper] Previous playlist missing segments skipped in delta playlist");
      for (let l = e.skippedSegments; l--; )
        e.fragments.shift();
      e.startSN = e.fragments[0].sn, e.startCC = e.fragments[0].cc;
    } else
      e.canSkipDateRanges && (e.dateRanges = Zc(o.dateRanges, e.dateRanges, e.recentlyRemovedDateranges));
  const s = e.fragments;
  if (r) {
    V.warn("discontinuity sliding from playlist, take drift into account");
    for (let l = 0; l < s.length; l++)
      s[l].cc += r;
  }
  e.skippedSegments && (e.startCC = e.fragments[0].cc), Jc(o.partList, e.partList, (l, d) => {
    d.elementaryStreams = l.elementaryStreams, d.stats = l.stats;
  }), i ? $a(e, i, i.startPTS, i.endPTS, i.startDTS, i.endDTS) : Va(o, e), s.length && (e.totalduration = e.edge - s[0].start), e.driftStartTime = o.driftStartTime, e.driftStart = o.driftStart;
  const a = e.advancedDateTime;
  if (e.advanced && a) {
    const l = e.edge;
    e.driftStart || (e.driftStartTime = a, e.driftStart = l), e.driftEndTime = a, e.driftEnd = l;
  } else
    e.driftEndTime = o.driftEndTime, e.driftEnd = o.driftEnd, e.advancedDateTime = o.advancedDateTime;
}
function Zc(o, e, t) {
  const n = lt({}, o);
  return t && t.forEach((r) => {
    delete n[r];
  }), Object.keys(e).forEach((r) => {
    const i = new Ca(e[r].attr, n[r]);
    i.isValid ? n[r] = i : V.warn(`Ignoring invalid Playlist Delta Update DATERANGE tag: "${JSON.stringify(e[r].attr)}"`);
  }), n;
}
function Jc(o, e, t) {
  if (o && e) {
    let n = 0;
    for (let r = 0, i = o.length; r <= i; r++) {
      const s = o[r], a = e[r + n];
      s && a && s.index === a.index && s.fragment.sn === a.fragment.sn ? t(s, a) : n--;
    }
  }
}
function eu(o, e, t) {
  const n = e.skippedSegments, r = Math.max(o.startSN, e.startSN) - e.startSN, i = (o.fragmentHint ? 1 : 0) + (n ? e.endSN : Math.min(o.endSN, e.endSN)) - e.startSN, s = e.startSN - o.startSN, a = e.fragmentHint ? e.fragments.concat(e.fragmentHint) : e.fragments, l = o.fragmentHint ? o.fragments.concat(o.fragmentHint) : o.fragments;
  for (let d = r; d <= i; d++) {
    const h = l[s + d];
    let u = a[d];
    n && !u && d < n && (u = e.fragments[d] = h), h && u && t(h, u);
  }
}
function Va(o, e) {
  const t = e.startSN + e.skippedSegments - o.startSN, n = o.fragments;
  t < 0 || t >= n.length || ki(e, n[t].start);
}
function ki(o, e) {
  if (e) {
    const t = o.fragments;
    for (let n = o.skippedSegments; n < t.length; n++)
      t[n].start += e;
    o.fragmentHint && (o.fragmentHint.start += e);
  }
}
function tu(o, e = 1 / 0) {
  let t = 1e3 * o.targetduration;
  if (o.updated) {
    const n = o.fragments, r = 4;
    if (n.length && t * r > e) {
      const i = n[n.length - 1].duration * 1e3;
      i < t && (t = i);
    }
  } else
    t /= 2;
  return Math.round(t);
}
function nu(o, e, t) {
  if (!(o != null && o.details))
    return null;
  const n = o.details;
  let r = n.fragments[e - n.startSN];
  return r || (r = n.fragmentHint, r && r.sn === e) ? r : e < n.startSN && t && t.sn === e ? t : null;
}
function $s(o, e, t) {
  var n;
  return o != null && o.details ? Wa((n = o.details) == null ? void 0 : n.partList, e, t) : null;
}
function Wa(o, e, t) {
  if (o)
    for (let n = o.length; n--; ) {
      const r = o[n];
      if (r.index === t && r.fragment.sn === e)
        return r;
    }
  return null;
}
function Ha(o) {
  o.forEach((e, t) => {
    const {
      details: n
    } = e;
    n != null && n.fragments && n.fragments.forEach((r) => {
      r.level = t;
    });
  });
}
function Pr(o) {
  switch (o.details) {
    case q.FRAG_LOAD_TIMEOUT:
    case q.KEY_LOAD_TIMEOUT:
    case q.LEVEL_LOAD_TIMEOUT:
    case q.MANIFEST_LOAD_TIMEOUT:
      return !0;
  }
  return !1;
}
function Vs(o, e) {
  const t = Pr(e);
  return o.default[`${t ? "timeout" : "error"}Retry`];
}
function Vi(o, e) {
  const t = o.backoff === "linear" ? 1 : Math.pow(2, e);
  return Math.min(t * o.retryDelayMs, o.maxRetryDelayMs);
}
function Ws(o) {
  return it(it({}, o), {
    errorRetry: null,
    timeoutRetry: null
  });
}
function Fr(o, e, t, n) {
  if (!o)
    return !1;
  const r = n == null ? void 0 : n.code, i = e < o.maxNumRetry && (ru(r) || !!t);
  return o.shouldRetry ? o.shouldRetry(o, e, t, n, i) : i;
}
function ru(o) {
  return o === 0 && navigator.onLine === !1 || !!o && (o < 400 || o > 499);
}
const za = {
  /**
   * Searches for an item in an array which matches a certain condition.
   * This requires the condition to only match one item in the array,
   * and for the array to be ordered.
   *
   * @param list The array to search.
   * @param comparisonFn
   *      Called and provided a candidate item as the first argument.
   *      Should return:
   *          > -1 if the item should be located at a lower index than the provided item.
   *          > 1 if the item should be located at a higher index than the provided item.
   *          > 0 if the item is the item you're looking for.
   *
   * @returns the object if found, otherwise returns null
   */
  search: function(o, e) {
    let t = 0, n = o.length - 1, r = null, i = null;
    for (; t <= n; ) {
      r = (t + n) / 2 | 0, i = o[r];
      const s = e(i);
      if (s > 0)
        t = r + 1;
      else if (s < 0)
        n = r - 1;
      else
        return i;
    }
    return null;
  }
};
function iu(o, e, t) {
  if (e === null || !Array.isArray(o) || !o.length || !ge(e))
    return null;
  const n = o[0].programDateTime;
  if (e < (n || 0))
    return null;
  const r = o[o.length - 1].endProgramDateTime;
  if (e >= (r || 0))
    return null;
  t = t || 0;
  for (let i = 0; i < o.length; ++i) {
    const s = o[i];
    if (su(e, t, s))
      return s;
  }
  return null;
}
function ir(o, e, t = 0, n = 0) {
  let r = null;
  if (o) {
    r = e[o.sn - e[0].sn + 1] || null;
    const s = o.endDTS - t;
    s > 0 && s < 15e-7 && (t += 15e-7);
  } else
    t === 0 && e[0].start === 0 && (r = e[0]);
  if (r && (!o || o.level === r.level) && Di(t, n, r) === 0)
    return r;
  const i = za.search(e, Di.bind(null, t, n));
  return i && (i !== o || !r) ? i : r;
}
function Di(o = 0, e = 0, t) {
  if (t.start <= o && t.start + t.duration > o)
    return 0;
  const n = Math.min(e, t.duration + (t.deltaPTS ? t.deltaPTS : 0));
  return t.start + t.duration - n <= o ? 1 : t.start - n > o && t.start ? -1 : 0;
}
function su(o, e, t) {
  const n = Math.min(e, t.duration + (t.deltaPTS ? t.deltaPTS : 0)) * 1e3;
  return (t.endProgramDateTime || 0) - n > o;
}
function au(o, e) {
  return za.search(o, (t) => t.cc < e ? 1 : t.cc > e ? -1 : 0);
}
const ou = 3e5;
var ut = {
  DoNothing: 0,
  SendEndCallback: 1,
  SendAlternateToPenaltyBox: 2,
  RemoveAlternatePermanently: 3,
  InsertDiscontinuity: 4,
  RetryRequest: 5
}, Tt = {
  None: 0,
  MoveAllAlternatesMatchingHost: 1,
  MoveAllAlternatesMatchingHDCP: 2,
  SwitchToSDR: 4
};
class lu {
  constructor(e) {
    this.hls = void 0, this.playlistError = 0, this.penalizedRenditions = {}, this.log = void 0, this.warn = void 0, this.error = void 0, this.hls = e, this.log = V.log.bind(V, "[info]:"), this.warn = V.warn.bind(V, "[warning]:"), this.error = V.error.bind(V, "[error]:"), this.registerListeners();
  }
  registerListeners() {
    const e = this.hls;
    e.on(I.ERROR, this.onError, this), e.on(I.MANIFEST_LOADING, this.onManifestLoading, this), e.on(I.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  unregisterListeners() {
    const e = this.hls;
    e && (e.off(I.ERROR, this.onError, this), e.off(I.ERROR, this.onErrorOut, this), e.off(I.MANIFEST_LOADING, this.onManifestLoading, this), e.off(I.LEVEL_UPDATED, this.onLevelUpdated, this));
  }
  destroy() {
    this.unregisterListeners(), this.hls = null, this.penalizedRenditions = {};
  }
  startLoad(e) {
  }
  stopLoad() {
    this.playlistError = 0;
  }
  getVariantLevelIndex(e) {
    return (e == null ? void 0 : e.type) === be.MAIN ? e.level : this.hls.loadLevel;
  }
  onManifestLoading() {
    this.playlistError = 0, this.penalizedRenditions = {};
  }
  onLevelUpdated() {
    this.playlistError = 0;
  }
  onError(e, t) {
    var n, r;
    if (t.fatal)
      return;
    const i = this.hls, s = t.context;
    switch (t.details) {
      case q.FRAG_LOAD_ERROR:
      case q.FRAG_LOAD_TIMEOUT:
      case q.KEY_LOAD_ERROR:
      case q.KEY_LOAD_TIMEOUT:
        t.errorAction = this.getFragRetryOrSwitchAction(t);
        return;
      case q.FRAG_PARSING_ERROR:
        if ((n = t.frag) != null && n.gap) {
          t.errorAction = {
            action: ut.DoNothing,
            flags: Tt.None
          };
          return;
        }
      case q.FRAG_GAP:
      case q.FRAG_DECRYPT_ERROR: {
        t.errorAction = this.getFragRetryOrSwitchAction(t), t.errorAction.action = ut.SendAlternateToPenaltyBox;
        return;
      }
      case q.LEVEL_EMPTY_ERROR:
      case q.LEVEL_PARSING_ERROR:
        {
          var a, l;
          const d = t.parent === be.MAIN ? t.level : i.loadLevel;
          t.details === q.LEVEL_EMPTY_ERROR && ((a = t.context) != null && (l = a.levelDetails) != null && l.live) ? t.errorAction = this.getPlaylistRetryOrSwitchAction(t, d) : (t.levelRetry = !1, t.errorAction = this.getLevelSwitchAction(t, d));
        }
        return;
      case q.LEVEL_LOAD_ERROR:
      case q.LEVEL_LOAD_TIMEOUT:
        typeof (s == null ? void 0 : s.level) == "number" && (t.errorAction = this.getPlaylistRetryOrSwitchAction(t, s.level));
        return;
      case q.AUDIO_TRACK_LOAD_ERROR:
      case q.AUDIO_TRACK_LOAD_TIMEOUT:
      case q.SUBTITLE_LOAD_ERROR:
      case q.SUBTITLE_TRACK_LOAD_TIMEOUT:
        if (s) {
          const d = i.levels[i.loadLevel];
          if (d && (s.type === Ue.AUDIO_TRACK && s.groupId === d.audioGroupId || s.type === Ue.SUBTITLE_TRACK && s.groupId === d.textGroupId)) {
            t.errorAction = this.getPlaylistRetryOrSwitchAction(t, i.loadLevel), t.errorAction.action = ut.SendAlternateToPenaltyBox, t.errorAction.flags = Tt.MoveAllAlternatesMatchingHost;
            return;
          }
        }
        return;
      case q.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED:
        {
          const d = i.levels[i.loadLevel], h = d == null ? void 0 : d.attrs["HDCP-LEVEL"];
          h ? t.errorAction = {
            action: ut.SendAlternateToPenaltyBox,
            flags: Tt.MoveAllAlternatesMatchingHDCP,
            hdcpLevel: h
          } : this.keySystemError(t);
        }
        return;
      case q.BUFFER_ADD_CODEC_ERROR:
      case q.REMUX_ALLOC_ERROR:
      case q.BUFFER_APPEND_ERROR:
        t.errorAction = this.getLevelSwitchAction(t, (r = t.level) != null ? r : i.loadLevel);
        return;
      case q.INTERNAL_EXCEPTION:
      case q.BUFFER_APPENDING_ERROR:
      case q.BUFFER_FULL_ERROR:
      case q.LEVEL_SWITCH_ERROR:
      case q.BUFFER_STALLED_ERROR:
      case q.BUFFER_SEEK_OVER_HOLE:
      case q.BUFFER_NUDGE_ON_STALL:
        t.errorAction = {
          action: ut.DoNothing,
          flags: Tt.None
        };
        return;
    }
    t.type === xe.KEY_SYSTEM_ERROR && this.keySystemError(t);
  }
  keySystemError(e) {
    const t = this.getVariantLevelIndex(e.frag);
    e.levelRetry = !1, e.errorAction = this.getLevelSwitchAction(e, t);
  }
  getPlaylistRetryOrSwitchAction(e, t) {
    const n = this.hls, r = Vs(n.config.playlistLoadPolicy, e), i = this.playlistError++;
    if (Fr(r, i, Pr(e), e.response))
      return {
        action: ut.RetryRequest,
        flags: Tt.None,
        retryConfig: r,
        retryCount: i
      };
    const a = this.getLevelSwitchAction(e, t);
    return r && (a.retryConfig = r, a.retryCount = i), a;
  }
  getFragRetryOrSwitchAction(e) {
    const t = this.hls, n = this.getVariantLevelIndex(e.frag), r = t.levels[n], {
      fragLoadPolicy: i,
      keyLoadPolicy: s
    } = t.config, a = Vs(e.details.startsWith("key") ? s : i, e), l = t.levels.reduce((h, u) => h + u.fragmentError, 0);
    if (r && (e.details !== q.FRAG_GAP && r.fragmentError++, Fr(a, l, Pr(e), e.response)))
      return {
        action: ut.RetryRequest,
        flags: Tt.None,
        retryConfig: a,
        retryCount: l
      };
    const d = this.getLevelSwitchAction(e, n);
    return a && (d.retryConfig = a, d.retryCount = l), d;
  }
  getLevelSwitchAction(e, t) {
    const n = this.hls;
    t == null && (t = n.loadLevel);
    const r = this.hls.levels[t];
    if (r) {
      var i, s;
      const a = e.details;
      r.loadError++, a === q.BUFFER_APPEND_ERROR && r.fragmentError++;
      let l = -1;
      const {
        levels: d,
        loadLevel: h,
        minAutoLevel: u,
        maxAutoLevel: c
      } = n;
      n.autoLevelEnabled || (n.loadLevel = -1);
      const m = (i = e.frag) == null ? void 0 : i.type, p = (m === be.AUDIO && a === q.FRAG_PARSING_ERROR || e.sourceBufferName === "audio" && (a === q.BUFFER_ADD_CODEC_ERROR || a === q.BUFFER_APPEND_ERROR)) && d.some(({
        audioCodec: T
      }) => r.audioCodec !== T), v = e.sourceBufferName === "video" && (a === q.BUFFER_ADD_CODEC_ERROR || a === q.BUFFER_APPEND_ERROR) && d.some(({
        codecSet: T,
        audioCodec: E
      }) => r.codecSet !== T && r.audioCodec === E), {
        type: b,
        groupId: _
      } = (s = e.context) != null ? s : {};
      for (let T = d.length; T--; ) {
        const E = (T + h) % d.length;
        if (E !== h && E >= u && E <= c && d[E].loadError === 0) {
          const L = d[E];
          if (a === q.FRAG_GAP && e.frag) {
            const k = d[E].details;
            if (k) {
              const D = ir(e.frag, k.fragments, e.frag.start);
              if (D != null && D.gap)
                continue;
            }
          } else {
            if (b === Ue.AUDIO_TRACK && _ === L.audioGroupId || b === Ue.SUBTITLE_TRACK && _ === L.textGroupId)
              continue;
            if (m === be.AUDIO && r.audioGroupId === L.audioGroupId || m === be.SUBTITLE && r.textGroupId === L.textGroupId || p && r.audioCodec === L.audioCodec || v && r.codecSet === L.codecSet || r.audioCodec !== L.audioCodec)
              continue;
          }
          l = E;
          break;
        }
      }
      if (l > -1 && n.loadLevel !== l)
        return e.levelRetry = !0, this.playlistError = 0, {
          action: ut.SendAlternateToPenaltyBox,
          flags: Tt.None,
          nextAutoLevel: l
        };
    }
    return {
      action: ut.SendAlternateToPenaltyBox,
      flags: Tt.MoveAllAlternatesMatchingHost
    };
  }
  onErrorOut(e, t) {
    var n;
    switch ((n = t.errorAction) == null ? void 0 : n.action) {
      case ut.DoNothing:
        break;
      case ut.SendAlternateToPenaltyBox:
        this.sendAlternateToPenaltyBox(t), !t.errorAction.resolved && t.details !== q.FRAG_GAP && (t.fatal = !0);
        break;
    }
    if (t.fatal) {
      this.hls.stopLoad();
      return;
    }
  }
  sendAlternateToPenaltyBox(e) {
    const t = this.hls, n = e.errorAction;
    if (!n)
      return;
    const {
      flags: r,
      hdcpLevel: i,
      nextAutoLevel: s
    } = n;
    switch (r) {
      case Tt.None:
        this.switchLevel(e, s);
        break;
      case Tt.MoveAllAlternatesMatchingHost:
        n.resolved || (n.resolved = this.redundantFailover(e));
        break;
      case Tt.MoveAllAlternatesMatchingHDCP:
        i && (t.maxHdcpLevel = Ri[Ri.indexOf(i) - 1], n.resolved = !0), this.warn(`Restricting playback to HDCP-LEVEL of "${t.maxHdcpLevel}" or lower`);
        break;
    }
    n.resolved || this.switchLevel(e, s);
  }
  switchLevel(e, t) {
    t !== void 0 && e.errorAction && (this.warn(`switching to level ${t} after ${e.details}`), this.hls.nextAutoLevel = t, e.errorAction.resolved = !0, this.hls.nextLoadLevel = this.hls.nextAutoLevel);
  }
  redundantFailover(e) {
    const {
      hls: t,
      penalizedRenditions: n
    } = this, r = e.parent === be.MAIN ? e.level || 0 : t.loadLevel, i = t.levels[r], s = i.url.length, a = e.frag ? e.frag.urlId : i.urlId;
    i.urlId === a && (!e.frag || i.details) && this.penalizeRendition(i, e);
    for (let l = 1; l < s; l++) {
      const d = (a + l) % s, h = n[d];
      if (!h || du(h, e, n[a]))
        return this.warn(`Switching to Redundant Stream ${d + 1}/${s}: "${i.url[d]}" after ${e.details}`), this.playlistError = 0, t.levels.forEach((u) => {
          u.urlId = d;
        }), t.nextLoadLevel = r, !0;
    }
    return !1;
  }
  penalizeRendition(e, t) {
    const {
      penalizedRenditions: n
    } = this, r = n[e.urlId] || {
      lastErrorPerfMs: 0,
      errors: [],
      details: void 0
    };
    r.lastErrorPerfMs = performance.now(), r.errors.push(t), r.details = e.details, n[e.urlId] = r;
  }
}
function du(o, e, t) {
  if (performance.now() - o.lastErrorPerfMs > ou)
    return !0;
  const n = o.details;
  if (e.details === q.FRAG_GAP && n && e.frag) {
    const r = e.frag.start, i = ir(null, n.fragments, r);
    if (i && !i.gap)
      return !0;
  }
  if (t && o.errors.length < t.errors.length) {
    const r = o.errors[o.errors.length - 1];
    if (n && r.frag && e.frag && Math.abs(r.frag.start - e.frag.start) > n.targetduration * 3)
      return !0;
  }
  return !1;
}
class Wi {
  constructor(e, t) {
    this.hls = void 0, this.timer = -1, this.requestScheduled = -1, this.canLoad = !1, this.log = void 0, this.warn = void 0, this.log = V.log.bind(V, `${t}:`), this.warn = V.warn.bind(V, `${t}:`), this.hls = e;
  }
  destroy() {
    this.clearTimer(), this.hls = this.log = this.warn = null;
  }
  clearTimer() {
    this.timer !== -1 && (self.clearTimeout(this.timer), this.timer = -1);
  }
  startLoad() {
    this.canLoad = !0, this.requestScheduled = -1, this.loadPlaylist();
  }
  stopLoad() {
    this.canLoad = !1, this.clearTimer();
  }
  switchParams(e, t) {
    const n = t == null ? void 0 : t.renditionReports;
    if (n) {
      let r = -1;
      for (let i = 0; i < n.length; i++) {
        const s = n[i];
        let a;
        try {
          a = new self.URL(s.URI, t.url).href;
        } catch (l) {
          V.warn(`Could not construct new URL for Rendition Report: ${l}`), a = s.URI || "";
        }
        if (a === e) {
          r = i;
          break;
        } else
          a === e.substring(0, a.length) && (r = i);
      }
      if (r !== -1) {
        const i = n[r], s = parseInt(i["LAST-MSN"]) || (t == null ? void 0 : t.lastPartSn);
        let a = parseInt(i["LAST-PART"]) || (t == null ? void 0 : t.lastPartIndex);
        if (this.hls.config.lowLatencyMode) {
          const l = Math.min(t.age - t.partTarget, t.targetduration);
          a >= 0 && l > t.partTarget && (a += 1);
        }
        return new Ks(s, a >= 0 ? a : void 0, Jn.No);
      }
    }
  }
  loadPlaylist(e) {
    this.requestScheduled === -1 && (this.requestScheduled = self.performance.now());
  }
  shouldLoadPlaylist(e) {
    return this.canLoad && !!e && !!e.url && (!e.details || e.details.live);
  }
  shouldReloadPlaylist(e) {
    return this.timer === -1 && this.requestScheduled === -1 && this.shouldLoadPlaylist(e);
  }
  playlistLoaded(e, t, n) {
    const {
      details: r,
      stats: i
    } = t, s = self.performance.now(), a = i.loading.first ? Math.max(0, s - i.loading.first) : 0;
    if (r.advancedDateTime = Date.now() - a, r.live || n != null && n.live) {
      if (r.reloaded(n), n && this.log(`live playlist ${e} ${r.advanced ? "REFRESHED " + r.lastPartSn + "-" + r.lastPartIndex : r.updated ? "UPDATED" : "MISSED"}`), n && r.fragments.length > 0 && Qc(n, r), !this.canLoad || !r.live)
        return;
      let l, d, h;
      if (r.canBlockReload && r.endSN && r.advanced) {
        const A = this.hls.config.lowLatencyMode, v = r.lastPartSn, b = r.endSN, _ = r.lastPartIndex, T = _ !== -1, E = v === b, L = A ? 0 : _;
        T ? (d = E ? b + 1 : v, h = E ? L : _ + 1) : d = b + 1;
        const k = r.age, D = k + r.ageHeader;
        let M = Math.min(D - r.partTarget, r.targetduration * 1.5);
        if (M > 0) {
          if (n && M > n.tuneInGoal)
            this.warn(`CDN Tune-in goal increased from: ${n.tuneInGoal} to: ${M} with playlist age: ${r.age}`), M = 0;
          else {
            const O = Math.floor(M / r.targetduration);
            if (d += O, h !== void 0) {
              const N = Math.round(M % r.targetduration / r.partTarget);
              h += N;
            }
            this.log(`CDN Tune-in age: ${r.ageHeader}s last advanced ${k.toFixed(2)}s goal: ${M} skip sn ${O} to part ${h}`);
          }
          r.tuneInGoal = M;
        }
        if (l = this.getDeliveryDirectives(r, t.deliveryDirectives, d, h), A || !E) {
          this.loadPlaylist(l);
          return;
        }
      } else
        (r.canBlockReload || r.canSkipUntil) && (l = this.getDeliveryDirectives(r, t.deliveryDirectives, d, h));
      const u = this.hls.mainForwardBufferInfo, c = u ? u.end - u.len : 0, m = (r.edge - c) * 1e3, f = tu(r, m);
      r.updated && s > this.requestScheduled + f && (this.requestScheduled = i.loading.start), d !== void 0 && r.canBlockReload ? this.requestScheduled = i.loading.first + f - (r.partTarget * 1e3 || 1e3) : this.requestScheduled === -1 || this.requestScheduled + f < s ? this.requestScheduled = s : this.requestScheduled - s <= 0 && (this.requestScheduled += f);
      let p = this.requestScheduled - s;
      p = Math.max(0, p), this.log(`reload live playlist ${e} in ${Math.round(p)} ms`), this.timer = self.setTimeout(() => this.loadPlaylist(l), p);
    } else
      this.clearTimer();
  }
  getDeliveryDirectives(e, t, n, r) {
    let i = Xc(e, n);
    return t != null && t.skip && e.deltaUpdateFailed && (n = t.msn, r = t.part, i = Jn.No), new Ks(n, r, i);
  }
  checkRetry(e) {
    const t = e.details, n = Pr(e), r = e.errorAction, {
      action: i,
      retryCount: s = 0,
      retryConfig: a
    } = r || {}, l = !!r && !!a && (i === ut.RetryRequest || !r.resolved && i === ut.SendAlternateToPenaltyBox);
    if (l) {
      var d;
      if (this.requestScheduled = -1, s >= a.maxNumRetry)
        return !1;
      if (n && (d = e.context) != null && d.deliveryDirectives)
        this.warn(`Retrying playlist loading ${s + 1}/${a.maxNumRetry} after "${t}" without delivery-directives`), this.loadPlaylist();
      else {
        const h = Vi(a, s);
        this.timer = self.setTimeout(() => this.loadPlaylist(), h), this.warn(`Retrying playlist loading ${s + 1}/${a.maxNumRetry} after "${t}" in ${h}ms`);
      }
      e.levelRetry = !0, r.resolved = !0;
    }
    return l;
  }
}
class An {
  //  About half of the estimated value will be from the last |halfLife| samples by weight.
  constructor(e, t = 0, n = 0) {
    this.halfLife = void 0, this.alpha_ = void 0, this.estimate_ = void 0, this.totalWeight_ = void 0, this.halfLife = e, this.alpha_ = e ? Math.exp(Math.log(0.5) / e) : 0, this.estimate_ = t, this.totalWeight_ = n;
  }
  sample(e, t) {
    const n = Math.pow(this.alpha_, e);
    this.estimate_ = t * (1 - n) + n * this.estimate_, this.totalWeight_ += e;
  }
  getTotalWeight() {
    return this.totalWeight_;
  }
  getEstimate() {
    if (this.alpha_) {
      const e = 1 - Math.pow(this.alpha_, this.totalWeight_);
      if (e)
        return this.estimate_ / e;
    }
    return this.estimate_;
  }
}
class cu {
  constructor(e, t, n, r = 100) {
    this.defaultEstimate_ = void 0, this.minWeight_ = void 0, this.minDelayMs_ = void 0, this.slow_ = void 0, this.fast_ = void 0, this.defaultTTFB_ = void 0, this.ttfb_ = void 0, this.defaultEstimate_ = n, this.minWeight_ = 1e-3, this.minDelayMs_ = 50, this.slow_ = new An(e), this.fast_ = new An(t), this.defaultTTFB_ = r, this.ttfb_ = new An(e);
  }
  update(e, t) {
    const {
      slow_: n,
      fast_: r,
      ttfb_: i
    } = this;
    n.halfLife !== e && (this.slow_ = new An(e, n.getEstimate(), n.getTotalWeight())), r.halfLife !== t && (this.fast_ = new An(t, r.getEstimate(), r.getTotalWeight())), i.halfLife !== e && (this.ttfb_ = new An(e, i.getEstimate(), i.getTotalWeight()));
  }
  sample(e, t) {
    e = Math.max(e, this.minDelayMs_);
    const n = 8 * t, r = e / 1e3, i = n / r;
    this.fast_.sample(r, i), this.slow_.sample(r, i);
  }
  sampleTTFB(e) {
    const t = e / 1e3, n = Math.sqrt(2) * Math.exp(-Math.pow(t, 2) / 2);
    this.ttfb_.sample(n, Math.max(e, 5));
  }
  canEstimate() {
    return this.fast_.getTotalWeight() >= this.minWeight_;
  }
  getEstimate() {
    return this.canEstimate() ? Math.min(this.fast_.getEstimate(), this.slow_.getEstimate()) : this.defaultEstimate_;
  }
  getEstimateTTFB() {
    return this.ttfb_.getTotalWeight() >= this.minWeight_ ? this.ttfb_.getEstimate() : this.defaultTTFB_;
  }
  destroy() {
  }
}
const Ya = {
  supported: !0,
  configurations: [],
  decodingInfoResults: [{
    supported: !0,
    powerEfficient: !0,
    smooth: !0
  }]
}, Hs = {};
function uu(o, e, t, n, r, i) {
  const s = o.audioCodec ? o.audioGroupId : null, a = s ? e.groups[s].channels : null;
  return typeof (t == null ? void 0 : t.decodingInfo) == "function" && o.videoCodec !== void 0 && (o.width > 1920 && o.height > 1088 || o.height > 1920 && o.width > 1088 || o.frameRate > Math.max(r, 30) || o.videoRange !== "SDR" && o.videoRange !== n || o.bitrate > Math.max(i, 8e6)) || !!a && Object.keys(a).length > 1;
}
function hu(o, e, t) {
  const n = o.videoCodec, r = o.audioCodec;
  if (!n || !r)
    return Promise.resolve(Ya);
  const i = {
    width: o.width,
    height: o.height,
    bitrate: Math.ceil(Math.max(o.bitrate * 0.9, o.averageBitrate)),
    // Assume a framerate of 30fps since MediaCapabilities will not accept Level default of 0.
    framerate: o.frameRate || 30
  }, s = o.videoRange;
  s !== "SDR" && (i.transferFunction = s.toLowerCase());
  const a = n.split(",").map((h) => ({
    type: "media-source",
    video: it(it({}, i), {}, {
      contentType: Ci(h, "video")
    })
  })), l = o.audioGroupId;
  if (r && l) {
    var d;
    (d = e.groups[l]) == null || d.tracks.forEach((h) => {
      if (h.groupId === l) {
        const u = h.attrs.CHANNELS || "", c = parseFloat(u);
        ge(c) && c > 2 && a.push.apply(a, r.split(",").map((m) => ({
          type: "media-source",
          audio: {
            contentType: Ci(m, "audio"),
            channels: "" + c
            // spatialRendering:
            //   audioCodec === 'ec-3' && channels.indexOf('JOC'),
          }
        })));
      }
    });
  }
  return Promise.all(a.map((h) => {
    const u = fu(h);
    return Hs[u] || (Hs[u] = t.decodingInfo(h));
  })).then((h) => ({
    supported: !h.some((u) => !u.supported),
    configurations: a,
    decodingInfoResults: h
  })).catch((h) => ({
    supported: !1,
    configurations: a,
    decodingInfoResults: [],
    error: h
  }));
}
function fu(o) {
  const {
    audio: e,
    video: t
  } = o, n = t || e;
  if (n) {
    const r = n.contentType.split('"')[1];
    if (t)
      return `r${t.height}x${t.width}f${Math.ceil(t.framerate)}${t.transferFunction || "sd"}_${r}_${Math.ceil(t.bitrate / 1e5)}`;
    if (e)
      return `c${e.channels}${e.spatialRendering ? "s" : "n"}_${r}`;
  }
  return "";
}
function pu(o, e, t) {
  const n = Object.keys(o);
  let r = !0, i = !1, s = 1 / 0, a = 1 / 0, l = 1 / 0, d = 0;
  for (let m = n.length; m--; ) {
    const f = o[n[m]];
    r = f.channels[2] > 0, s = Math.min(s, f.minHeight), a = Math.min(a, f.minFramerate), l = Math.min(l, f.minBitrate), e && (i || (i = f.videoRanges[e] > 0));
  }
  s = ge(s) ? s : 0, a = ge(a) ? a : 0;
  const h = Math.max(1080, s), u = Math.max(30, a);
  return l = ge(l) ? l : t, t = Math.max(l, t), i || (e = void 0), {
    codecSet: n.reduce((m, f) => {
      const p = o[f];
      return f === m ? m : p.minBitrate > t ? (an(f, `min bitrate of ${p.minBitrate} > current estimate of ${t}`), m) : p.hasDefaultAudio ? r && p.channels[2] === 0 ? (an(f, "no renditions with stereo sound found"), m) : p.minHeight > h ? (an(f, `min resolution of ${p.minHeight} > maximum of ${h}`), m) : p.minFramerate > u ? (an(f, `min framerate of ${p.minFramerate} > maximum of ${u}`), m) : e && p.videoRanges[e] === 0 ? (an(f, `no variants with VIDEO-RANGE of ${e} found`), m) : p.maxScore < d ? (an(f, `max score of ${p.maxScore} < selected max of ${d}`), m) : m && (Dr(f) >= Dr(m) || p.fragmentError > o[m].fragmentError) ? m : (d = p.maxScore, f) : (an(f, "no renditions with default or auto-select sound found"), m);
    }, void 0),
    videoRange: e,
    minFramerate: a,
    minBitrate: l
  };
}
function an(o, e) {
  V.log(`[abr] start candidates with "${o}" ignored because ${e}`);
}
function mu(o) {
  return o.reduce((e, t) => {
    let n = e.groups[t.groupId];
    n || (n = e.groups[t.groupId] = {
      tracks: [],
      channels: {
        2: 0
      },
      hasDefault: !1,
      hasAutoSelect: !1
    }), n.tracks.push(t);
    const r = t.attrs.CHANNELS || "2";
    return n.channels[r] = (n.channels[r] || 0) + 1, n.hasDefault = n.hasDefault || t.default, n.hasAutoSelect = n.hasAutoSelect || t.autoselect, n.hasDefault && (e.hasDefaultAudio = !0), n.hasAutoSelect && (e.hasAutoSelectAudio = !0), e;
  }, {
    hasDefaultAudio: !1,
    hasAutoSelectAudio: !1,
    groups: {}
  });
}
function gu(o, e, t, n) {
  return o.slice(t, n + 1).reduce((r, i) => {
    if (!i.codecSet)
      return r;
    const s = i.audioGroupId ? e.groups[i.audioGroupId] : null;
    let a = r[i.codecSet];
    a || (r[i.codecSet] = a = {
      minBitrate: 1 / 0,
      minHeight: 1 / 0,
      minFramerate: 1 / 0,
      maxScore: 0,
      videoRanges: {
        SDR: 0
      },
      channels: {
        2: 0
      },
      hasDefaultAudio: !s,
      fragmentError: 0
    }), a.minBitrate = Math.min(a.minBitrate, i.bitrate);
    const l = Math.min(i.height, i.width);
    return a.minHeight = Math.min(a.minHeight, l), a.minFramerate = Math.min(a.minFramerate, i.frameRate), a.maxScore = Math.max(a.maxScore, i.score), a.fragmentError += i.fragmentError, a.videoRanges[i.videoRange] = (a.videoRanges[i.videoRange] || 0) + 1, s && (a.hasDefaultAudio = a.hasDefaultAudio || e.hasDefaultAudio ? s.hasDefault : s.hasAutoSelect || !e.hasDefaultAudio && !e.hasAutoSelectAudio, Object.keys(s.channels).forEach((d) => {
      a.channels[d] = (a.channels[d] || 0) + s.channels[d];
    })), r;
  }, {});
}
class yu {
  constructor(e) {
    this.hls = void 0, this.lastLevelLoadSec = 0, this.lastLoadedFragLevel = -1, this._nextAutoLevel = -1, this.nextAutoLevelKey = "", this.audioTracksByGroup = null, this.codecTiers = null, this.timer = -1, this.onCheck = this._abandonRulesCheck.bind(this), this.fragCurrent = null, this.partCurrent = null, this.bitrateTestDelay = 0, this.bwEstimator = void 0, this.hls = e, this.bwEstimator = this.initEstimator(), this.registerListeners();
  }
  resetEstimator(e) {
    e && (V.log(`setting initial bwe to ${e}`), this.hls.config.abrEwmaDefaultEstimate = e), this.bwEstimator = this.initEstimator();
  }
  initEstimator() {
    const e = this.hls.config;
    return new cu(e.abrEwmaSlowVoD, e.abrEwmaFastVoD, e.abrEwmaDefaultEstimate);
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(I.MANIFEST_LOADING, this.onManifestLoading, this), e.on(I.FRAG_LOADING, this.onFragLoading, this), e.on(I.FRAG_LOADED, this.onFragLoaded, this), e.on(I.FRAG_BUFFERED, this.onFragBuffered, this), e.on(I.LEVEL_SWITCHING, this.onLevelSwitching, this), e.on(I.LEVEL_LOADED, this.onLevelLoaded, this), e.on(I.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(I.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e && (e.off(I.MANIFEST_LOADING, this.onManifestLoading, this), e.off(I.FRAG_LOADING, this.onFragLoading, this), e.off(I.FRAG_LOADED, this.onFragLoaded, this), e.off(I.FRAG_BUFFERED, this.onFragBuffered, this), e.off(I.LEVEL_SWITCHING, this.onLevelSwitching, this), e.off(I.LEVEL_LOADED, this.onLevelLoaded, this), e.off(I.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(I.ERROR, this.onError, this));
  }
  destroy() {
    this.unregisterListeners(), this.clearTimer(), this.hls = this.onCheck = null, this.fragCurrent = this.partCurrent = null;
  }
  onManifestLoading(e, t) {
    this.lastLoadedFragLevel = -1, this.lastLevelLoadSec = 0, this.fragCurrent = this.partCurrent = null, this.audioTracksByGroup = null, this.onLevelsUpdated(), this.clearTimer();
  }
  onLevelsUpdated() {
    this.lastLoadedFragLevel > -1 && this.fragCurrent && (this.lastLoadedFragLevel = this.fragCurrent.level), this._nextAutoLevel = -1, this.nextAutoLevelKey = "", this.codecTiers = null;
  }
  onFragLoading(e, t) {
    const n = t.frag;
    if (!this.ignoreFragment(n)) {
      if (!n.bitrateTest) {
        var r;
        this.fragCurrent = n, this.partCurrent = (r = t.part) != null ? r : null;
      }
      this.clearTimer(), this.timer = self.setInterval(this.onCheck, 100);
    }
  }
  onLevelSwitching(e, t) {
    this.clearTimer();
  }
  onError(e, t) {
    if (!t.fatal)
      switch (t.details) {
        case q.BUFFER_ADD_CODEC_ERROR:
        case q.BUFFER_APPEND_ERROR:
          this.lastLoadedFragLevel = -1;
      }
  }
  getTimeToLoadFrag(e, t, n, r) {
    const i = e + n / t, s = r ? this.lastLevelLoadSec : 0;
    return i + s;
  }
  onLevelLoaded(e, t) {
    const n = this.hls.config, {
      loading: r
    } = t.stats, i = r.end - r.start;
    ge(i) && (this.lastLevelLoadSec = i / 1e3), t.details.live ? this.bwEstimator.update(n.abrEwmaSlowLive, n.abrEwmaFastLive) : this.bwEstimator.update(n.abrEwmaSlowVoD, n.abrEwmaFastVoD);
  }
  /*
      This method monitors the download rate of the current fragment, and will downswitch if that fragment will not load
      quickly enough to prevent underbuffering
    */
  _abandonRulesCheck() {
    const {
      fragCurrent: e,
      partCurrent: t,
      hls: n
    } = this, {
      autoLevelEnabled: r,
      media: i
    } = n;
    if (!e || !i)
      return;
    const s = performance.now(), a = t ? t.stats : e.stats, l = t ? t.duration : e.duration, d = s - a.loading.start, h = n.minAutoLevel;
    if (a.aborted || a.loaded && a.loaded === a.total || e.level <= h) {
      this.clearTimer(), this._nextAutoLevel = -1;
      return;
    }
    if (!r || i.paused || !i.playbackRate || !i.readyState)
      return;
    const u = n.mainForwardBufferInfo;
    if (u === null)
      return;
    const c = this.bwEstimator.getEstimateTTFB(), m = Math.abs(i.playbackRate);
    if (d <= Math.max(c, 1e3 * (l / (m * 2))))
      return;
    const f = u.len / m;
    if (f >= 2 * l / m)
      return;
    const p = a.loading.first ? a.loading.first - a.loading.start : -1, A = a.loaded && p > -1, v = this.getBwEstimate(), b = n.levels, _ = b[e.level], T = a.total || Math.max(a.loaded, Math.round(l * _.maxBitrate / 8));
    let E = A ? d - p : d;
    E < 1 && A && (E = Math.min(d, a.loaded * 8 / v));
    const L = A ? a.loaded * 1e3 / E : 0, k = L ? (T - a.loaded) / L : T * 8 / v + c / 1e3;
    if (k <= f)
      return;
    const D = L ? L * 8 : v;
    let M = Number.POSITIVE_INFINITY, O;
    for (O = e.level - 1; O > h; O--) {
      const N = b[O].maxBitrate;
      if (M = this.getTimeToLoadFrag(c / 1e3, D, l * N, !b[O].details), M < f)
        break;
    }
    M >= k || M > l * 10 || (n.nextLoadLevel = O, A ? this.bwEstimator.sample(d - Math.min(c, p), a.loaded) : this.bwEstimator.sampleTTFB(d), this.clearTimer(), V.warn(`[abr] Fragment ${e.sn}${t ? " part " + t.index : ""} of level ${e.level} is loading too slowly;
      Time to underbuffer: ${f.toFixed(3)} s
      Estimated load time for current fragment: ${k.toFixed(3)} s
      Estimated load time for down switch fragment: ${M.toFixed(3)} s
      TTFB estimate: ${p}
      Current BW estimate: ${ge(v) ? (v / 1024).toFixed(3) : "Unknown"} Kb/s
      New BW estimate: ${(this.getBwEstimate() / 1024).toFixed(3)} Kb/s
      Aborting and switching to level ${O}`), e.loader && (this.fragCurrent = this.partCurrent = null, e.abortRequests()), n.trigger(I.FRAG_LOAD_EMERGENCY_ABORTED, {
      frag: e,
      part: t,
      stats: a
    }));
  }
  onFragLoaded(e, {
    frag: t,
    part: n
  }) {
    const r = n ? n.stats : t.stats;
    if (t.type === be.MAIN && this.bwEstimator.sampleTTFB(r.loading.first - r.loading.start), !this.ignoreFragment(t)) {
      if (this.clearTimer(), this._nextAutoLevel = -1, this.hls.config.abrMaxWithRealBitrate) {
        const i = n ? n.duration : t.duration, s = this.hls.levels[t.level], a = (s.loaded ? s.loaded.bytes : 0) + r.loaded, l = (s.loaded ? s.loaded.duration : 0) + i;
        s.loaded = {
          bytes: a,
          duration: l
        }, s.realBitrate = Math.round(8 * a / l);
      }
      if (t.bitrateTest) {
        const i = {
          stats: r,
          frag: t,
          part: n,
          id: t.type
        };
        this.onFragBuffered(I.FRAG_BUFFERED, i), t.bitrateTest = !1;
      } else
        this.lastLoadedFragLevel = t.level;
    }
  }
  onFragBuffered(e, t) {
    const {
      frag: n,
      part: r
    } = t, i = r != null && r.stats.loaded ? r.stats : n.stats;
    if (i.aborted || this.ignoreFragment(n))
      return;
    const s = i.parsing.end - i.loading.start - Math.min(i.loading.first - i.loading.start, this.bwEstimator.getEstimateTTFB());
    this.bwEstimator.sample(s, i.loaded), i.bwEstimate = this.getBwEstimate(), n.bitrateTest ? this.bitrateTestDelay = s / 1e3 : this.bitrateTestDelay = 0;
  }
  ignoreFragment(e) {
    return e.type !== be.MAIN || e.sn === "initSegment";
  }
  clearTimer() {
    this.timer > -1 && (self.clearInterval(this.timer), this.timer = -1);
  }
  get firstAutoLevel() {
    const {
      maxAutoLevel: e,
      minAutoLevel: t
    } = this.hls, n = this.hls.config.maxStarvationDelay, r = this.findBestLevel(this.getBwEstimate(), t, e, 0, n, 1, 1);
    if (r > -1)
      return r;
    const i = this.hls.firstLevel, s = Math.min(Math.max(i, t), e);
    return V.warn(`[abr] Could not find best starting auto level. Defaulting to first in playlist ${i} clamped to ${s}`), s;
  }
  get forcedAutoLevel() {
    return this.nextAutoLevelKey ? -1 : this._nextAutoLevel;
  }
  // return next auto level
  get nextAutoLevel() {
    const e = this._nextAutoLevel, n = this.bwEstimator.canEstimate(), r = this.lastLoadedFragLevel > -1;
    if (e !== -1 && (!n || !r || this.nextAutoLevelKey === this.getAutoLevelKey()))
      return e;
    let i = n && r ? this.getNextABRAutoLevel() : this.firstAutoLevel;
    if (e !== -1) {
      const s = this.hls.levels;
      if (s.length > Math.max(e, i) && s[e].loadError < s[i].loadError)
        return e;
    }
    return e !== -1 && (i = Math.min(e, i)), this._nextAutoLevel = i, this.nextAutoLevelKey = this.getAutoLevelKey(), i;
  }
  getAutoLevelKey() {
    var e;
    return `${this.getBwEstimate()}_${(e = this.hls.mainForwardBufferInfo) == null ? void 0 : e.len}`;
  }
  getNextABRAutoLevel() {
    const {
      fragCurrent: e,
      partCurrent: t,
      hls: n
    } = this, {
      maxAutoLevel: r,
      config: i,
      minAutoLevel: s,
      media: a
    } = n, l = t ? t.duration : e ? e.duration : 0, d = a && a.playbackRate !== 0 ? Math.abs(a.playbackRate) : 1, h = this.getBwEstimate(), u = n.mainForwardBufferInfo, c = (u ? u.len : 0) / d;
    let m = i.abrBandWidthFactor, f = i.abrBandWidthUpFactor;
    if (c) {
      const _ = this.findBestLevel(h, s, r, c, 0, m, f);
      if (_ >= 0)
        return _;
    }
    let p = l ? Math.min(l, i.maxStarvationDelay) : i.maxStarvationDelay;
    if (!c) {
      const _ = this.bitrateTestDelay;
      _ && (p = (l ? Math.min(l, i.maxLoadingDelay) : i.maxLoadingDelay) - _, V.info(`[abr] bitrate test took ${Math.round(1e3 * _)}ms, set first fragment max fetchDuration to ${Math.round(1e3 * p)} ms`), m = f = 1);
    }
    const A = this.findBestLevel(h, s, r, c, p, m, f);
    if (V.info(`[abr] ${c ? "rebuffering expected" : "buffer is empty"}, optimal quality level ${A}`), A > -1)
      return A;
    const v = n.levels[s], b = n.levels[n.loadLevel];
    return (v == null ? void 0 : v.bitrate) < (b == null ? void 0 : b.bitrate) ? s : n.loadLevel;
  }
  getBwEstimate() {
    return this.bwEstimator.canEstimate() ? this.bwEstimator.getEstimate() : this.hls.config.abrEwmaDefaultEstimate;
  }
  findBestLevel(e, t, n, r, i, s, a) {
    var l;
    const d = r + i, h = this.lastLoadedFragLevel, u = h === -1 ? this.hls.firstLevel : h, {
      fragCurrent: c,
      partCurrent: m
    } = this, {
      levels: f,
      allAudioTracks: p,
      loadLevel: A
    } = this.hls;
    if (f.length === 1)
      return 0;
    const v = f[u], b = !!(v != null && (l = v.details) != null && l.live), _ = A === -1 || h === -1;
    let T, E = "SDR", L = (v == null ? void 0 : v.frameRate) || 0;
    const k = this.audioTracksByGroup || (this.audioTracksByGroup = mu(p));
    if (_) {
      const U = this.codecTiers || (this.codecTiers = gu(f, k, t, n)), {
        codecSet: G,
        videoRange: Y,
        minFramerate: z,
        minBitrate: J
      } = pu(U, E, e);
      T = G, E = Y, L = z, e = Math.max(e, J);
    } else
      T = v == null ? void 0 : v.codecSet, E = v == null ? void 0 : v.videoRange;
    const D = m ? m.duration : c ? c.duration : 0, M = this.bwEstimator.getEstimateTTFB() / 1e3, O = [];
    for (let U = n; U >= t; U--) {
      var N, B;
      const G = f[U], Y = U > u;
      if (!G)
        continue;
      if (this.hls.config.useMediaCapabilities && !G.supportedResult && !G.supportedPromise) {
        const ue = navigator.mediaCapabilities;
        uu(G, k, ue, E, L, e) ? (G.supportedPromise = hu(G, k, ue), G.supportedPromise.then((re) => {
          G.supportedResult = re, re.error ? V.warn(`[abr] MediaCapabilities decodingInfo error: "${re.error}" for level ${U} ${JSON.stringify(re)}`) : re.supported || (V.warn(`[abr] Removing unsupported level ${U} after MediaCapabilities decodingInfo check failed ${JSON.stringify(re)}`), U > 0 && this.hls.removeLevel(U));
        })) : G.supportedResult = Ya;
      }
      if (T && G.codecSet !== T || E && G.videoRange !== E || Y && L > G.frameRate || !Y && L > 0 && L < G.frameRate || !((N = G.supportedResult) != null && (B = N.decodingInfoResults) != null && B[0].smooth)) {
        O.push(U);
        continue;
      }
      const z = G.details, J = (m ? z == null ? void 0 : z.partTarget : z == null ? void 0 : z.averagetargetduration) || D;
      let le;
      Y ? le = a * e : le = s * e;
      const W = D && r >= D * 2 && i === 0 ? f[U].averageBitrate : f[U].maxBitrate, Z = this.getTimeToLoadFrag(M, le, W * J, z === void 0);
      if (
        // if adjusted bw is greater than level bitrate AND
        le >= W && // no level change, or new level has no error history
        (U === h || G.loadError === 0 && G.fragmentError === 0) && // fragment fetchDuration unknown OR live stream OR fragment fetchDuration less than max allowed fetch duration, then this level matches
        // we don't account for max Fetch Duration for live streams, this is to avoid switching down when near the edge of live sliding window ...
        // special case to support startLevel = -1 (bitrateTest) on live streams : in that case we should not exit loop so that findBestLevel will return -1
        (Z <= M || !ge(Z) || b && !this.bitrateTestDelay || Z < d)
      )
        return U !== A && (O.length && V.trace(`[abr] Skipped level(s) ${O.join(",")} of ${n} max with CODECS and VIDEO-RANGE:"${f[O[0]].codecs}" ${f[O[0]].videoRange}; not compatible with "${v.codecs}" ${E}`), V.info(`[abr] switch candidate:${u}->${U} adjustedbw(${Math.round(le)})-bitrate=${Math.round(le - W)} ttfb:${M.toFixed(1)} avgDuration:${J.toFixed(1)} maxFetchDuration:${d.toFixed(1)} fetchDuration:${Z.toFixed(1)} firstSelection:${_} codecSet:${T} videoRange:${E} hls.loadLevel:${A}`)), U;
    }
    return -1;
  }
  set nextAutoLevel(e) {
    const t = Math.max(this.hls.minAutoLevel, e);
    this._nextAutoLevel != t && (this.nextAutoLevelKey = "", this._nextAutoLevel = t);
  }
}
class Au {
  constructor() {
    this._boundTick = void 0, this._tickTimer = null, this._tickInterval = null, this._tickCallCount = 0, this._boundTick = this.tick.bind(this);
  }
  destroy() {
    this.onHandlerDestroying(), this.onHandlerDestroyed();
  }
  onHandlerDestroying() {
    this.clearNextTick(), this.clearInterval();
  }
  onHandlerDestroyed() {
  }
  hasInterval() {
    return !!this._tickInterval;
  }
  hasNextTick() {
    return !!this._tickTimer;
  }
  /**
   * @param millis - Interval time (ms)
   * @eturns True when interval has been scheduled, false when already scheduled (no effect)
   */
  setInterval(e) {
    return this._tickInterval ? !1 : (this._tickCallCount = 0, this._tickInterval = self.setInterval(this._boundTick, e), !0);
  }
  /**
   * @returns True when interval was cleared, false when none was set (no effect)
   */
  clearInterval() {
    return this._tickInterval ? (self.clearInterval(this._tickInterval), this._tickInterval = null, !0) : !1;
  }
  /**
   * @returns True when timeout was cleared, false when none was set (no effect)
   */
  clearNextTick() {
    return this._tickTimer ? (self.clearTimeout(this._tickTimer), this._tickTimer = null, !0) : !1;
  }
  /**
   * Will call the subclass doTick implementation in this main loop tick
   * or in the next one (via setTimeout(,0)) in case it has already been called
   * in this tick (in case this is a re-entrant call).
   */
  tick() {
    this._tickCallCount++, this._tickCallCount === 1 && (this.doTick(), this._tickCallCount > 1 && this.tickImmediate(), this._tickCallCount = 0);
  }
  tickImmediate() {
    this.clearNextTick(), this._tickTimer = self.setTimeout(this._boundTick, 0);
  }
  /**
   * For subclass to implement task logic
   * @abstract
   */
  doTick() {
  }
}
var dt = {
  NOT_LOADED: "NOT_LOADED",
  APPENDING: "APPENDING",
  PARTIAL: "PARTIAL",
  OK: "OK"
};
class vu {
  constructor(e) {
    this.activePartLists = /* @__PURE__ */ Object.create(null), this.endListFragments = /* @__PURE__ */ Object.create(null), this.fragments = /* @__PURE__ */ Object.create(null), this.timeRanges = /* @__PURE__ */ Object.create(null), this.bufferPadding = 0.2, this.hls = void 0, this.hasGaps = !1, this.hls = e, this._registerListeners();
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(I.BUFFER_APPENDED, this.onBufferAppended, this), e.on(I.FRAG_BUFFERED, this.onFragBuffered, this), e.on(I.FRAG_LOADED, this.onFragLoaded, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(I.BUFFER_APPENDED, this.onBufferAppended, this), e.off(I.FRAG_BUFFERED, this.onFragBuffered, this), e.off(I.FRAG_LOADED, this.onFragLoaded, this);
  }
  destroy() {
    this._unregisterListeners(), this.fragments = // @ts-ignore
    this.activePartLists = // @ts-ignore
    this.endListFragments = this.timeRanges = null;
  }
  /**
   * Return a Fragment or Part with an appended range that matches the position and levelType
   * Otherwise, return null
   */
  getAppendedFrag(e, t) {
    const n = this.activePartLists[t];
    if (n)
      for (let r = n.length; r--; ) {
        const i = n[r];
        if (!i)
          break;
        const s = i.end;
        if (i.start <= e && s !== null && e <= s)
          return i;
      }
    return this.getBufferedFrag(e, t);
  }
  /**
   * Return a buffered Fragment that matches the position and levelType.
   * A buffered Fragment is one whose loading, parsing and appending is done (completed or "partial" meaning aborted).
   * If not found any Fragment, return null
   */
  getBufferedFrag(e, t) {
    const {
      fragments: n
    } = this, r = Object.keys(n);
    for (let i = r.length; i--; ) {
      const s = n[r[i]];
      if ((s == null ? void 0 : s.body.type) === t && s.buffered) {
        const a = s.body;
        if (a.start <= e && e <= a.end)
          return a;
      }
    }
    return null;
  }
  /**
   * Partial fragments effected by coded frame eviction will be removed
   * The browser will unload parts of the buffer to free up memory for new buffer data
   * Fragments will need to be reloaded when the buffer is freed up, removing partial fragments will allow them to reload(since there might be parts that are still playable)
   */
  detectEvictedFragments(e, t, n, r) {
    this.timeRanges && (this.timeRanges[e] = t);
    const i = (r == null ? void 0 : r.fragment.sn) || -1;
    Object.keys(this.fragments).forEach((s) => {
      const a = this.fragments[s];
      if (!a || i >= a.body.sn)
        return;
      if (!a.buffered && !a.loaded) {
        a.body.type === n && this.removeFragment(a.body);
        return;
      }
      const l = a.range[e];
      l && l.time.some((d) => {
        const h = !this.isTimeBuffered(d.startPTS, d.endPTS, t);
        return h && this.removeFragment(a.body), h;
      });
    });
  }
  /**
   * Checks if the fragment passed in is loaded in the buffer properly
   * Partially loaded fragments will be registered as a partial fragment
   */
  detectPartialFragments(e) {
    const t = this.timeRanges, {
      frag: n,
      part: r
    } = e;
    if (!t || n.sn === "initSegment")
      return;
    const i = vn(n), s = this.fragments[i];
    if (!s || s.buffered && n.gap)
      return;
    const a = !n.relurl;
    Object.keys(t).forEach((l) => {
      const d = n.elementaryStreams[l];
      if (!d)
        return;
      const h = t[l], u = a || d.partial === !0;
      s.range[l] = this.getBufferedTimes(n, r, u, h);
    }), s.loaded = null, Object.keys(s.range).length ? (s.buffered = !0, (s.body.endList = n.endList || s.body.endList) && (this.endListFragments[s.body.type] = s), br(s) || this.removeParts(n.sn - 1, n.type)) : this.removeFragment(s.body);
  }
  removeParts(e, t) {
    const n = this.activePartLists[t];
    n && (this.activePartLists[t] = n.filter((r) => r.fragment.sn >= e));
  }
  fragBuffered(e, t) {
    const n = vn(e);
    let r = this.fragments[n];
    !r && t && (r = this.fragments[n] = {
      body: e,
      appendedPTS: null,
      loaded: null,
      buffered: !1,
      range: /* @__PURE__ */ Object.create(null)
    }, e.gap && (this.hasGaps = !0)), r && (r.loaded = null, r.buffered = !0);
  }
  getBufferedTimes(e, t, n, r) {
    const i = {
      time: [],
      partial: n
    }, s = e.start, a = e.end, l = e.minEndPTS || a, d = e.maxStartPTS || s;
    for (let h = 0; h < r.length; h++) {
      const u = r.start(h) - this.bufferPadding, c = r.end(h) + this.bufferPadding;
      if (d >= u && l <= c) {
        i.time.push({
          startPTS: Math.max(s, r.start(h)),
          endPTS: Math.min(a, r.end(h))
        });
        break;
      } else if (s < c && a > u) {
        const m = Math.max(s, r.start(h)), f = Math.min(a, r.end(h));
        f > m && (i.partial = !0, i.time.push({
          startPTS: m,
          endPTS: f
        }));
      } else if (a <= u)
        break;
    }
    return i;
  }
  /**
   * Gets the partial fragment for a certain time
   */
  getPartialFragment(e) {
    let t = null, n, r, i, s = 0;
    const {
      bufferPadding: a,
      fragments: l
    } = this;
    return Object.keys(l).forEach((d) => {
      const h = l[d];
      h && br(h) && (r = h.body.start - a, i = h.body.end + a, e >= r && e <= i && (n = Math.min(e - r, i - e), s <= n && (t = h.body, s = n)));
    }), t;
  }
  isEndListAppended(e) {
    const t = this.endListFragments[e];
    return t !== void 0 && (t.buffered || br(t));
  }
  getState(e) {
    const t = vn(e), n = this.fragments[t];
    return n ? n.buffered ? br(n) ? dt.PARTIAL : dt.OK : dt.APPENDING : dt.NOT_LOADED;
  }
  isTimeBuffered(e, t, n) {
    let r, i;
    for (let s = 0; s < n.length; s++) {
      if (r = n.start(s) - this.bufferPadding, i = n.end(s) + this.bufferPadding, e >= r && t <= i)
        return !0;
      if (t <= r)
        return !1;
    }
    return !1;
  }
  onFragLoaded(e, t) {
    const {
      frag: n,
      part: r
    } = t;
    if (n.sn === "initSegment" || n.bitrateTest)
      return;
    const i = r ? null : t, s = vn(n);
    this.fragments[s] = {
      body: n,
      appendedPTS: null,
      loaded: i,
      buffered: !1,
      range: /* @__PURE__ */ Object.create(null)
    };
  }
  onBufferAppended(e, t) {
    const {
      frag: n,
      part: r,
      timeRanges: i
    } = t;
    if (n.sn === "initSegment")
      return;
    const s = n.type;
    if (r) {
      let a = this.activePartLists[s];
      a || (this.activePartLists[s] = a = []), a.push(r);
    }
    this.timeRanges = i, Object.keys(i).forEach((a) => {
      const l = i[a];
      this.detectEvictedFragments(a, l, s, r);
    });
  }
  onFragBuffered(e, t) {
    this.detectPartialFragments(t);
  }
  hasFragment(e) {
    const t = vn(e);
    return !!this.fragments[t];
  }
  hasParts(e) {
    var t;
    return !!((t = this.activePartLists[e]) != null && t.length);
  }
  removeFragmentsInRange(e, t, n, r, i) {
    r && !this.hasGaps || Object.keys(this.fragments).forEach((s) => {
      const a = this.fragments[s];
      if (!a)
        return;
      const l = a.body;
      l.type !== n || r && !l.gap || l.start < t && l.end > e && (a.buffered || i) && this.removeFragment(l);
    });
  }
  removeFragment(e) {
    const t = vn(e);
    e.stats.loaded = 0, e.clearElementaryStreamInfo();
    const n = this.activePartLists[e.type];
    if (n) {
      const r = e.sn;
      this.activePartLists[e.type] = n.filter((i) => i.fragment.sn !== r);
    }
    delete this.fragments[t], e.endList && delete this.endListFragments[e.type];
  }
  removeAllFragments() {
    this.fragments = /* @__PURE__ */ Object.create(null), this.endListFragments = /* @__PURE__ */ Object.create(null), this.activePartLists = /* @__PURE__ */ Object.create(null), this.hasGaps = !1;
  }
}
function br(o) {
  var e, t, n;
  return o.buffered && (o.body.gap || ((e = o.range.video) == null ? void 0 : e.partial) || ((t = o.range.audio) == null ? void 0 : t.partial) || ((n = o.range.audiovideo) == null ? void 0 : n.partial));
}
function vn(o) {
  return `${o.type}_${o.level}_${o.urlId}_${o.sn}`;
}
const bu = {
  length: 0,
  start: () => 0,
  end: () => 0
};
class He {
  /**
   * Return true if `media`'s buffered include `position`
   */
  static isBuffered(e, t) {
    try {
      if (e) {
        const n = He.getBuffered(e);
        for (let r = 0; r < n.length; r++)
          if (t >= n.start(r) && t <= n.end(r))
            return !0;
      }
    } catch {
    }
    return !1;
  }
  static bufferInfo(e, t, n) {
    try {
      if (e) {
        const r = He.getBuffered(e), i = [];
        let s;
        for (s = 0; s < r.length; s++)
          i.push({
            start: r.start(s),
            end: r.end(s)
          });
        return this.bufferedInfo(i, t, n);
      }
    } catch {
    }
    return {
      len: 0,
      start: t,
      end: t,
      nextStart: void 0
    };
  }
  static bufferedInfo(e, t, n) {
    t = Math.max(0, t), e.sort(function(d, h) {
      const u = d.start - h.start;
      return u || h.end - d.end;
    });
    let r = [];
    if (n)
      for (let d = 0; d < e.length; d++) {
        const h = r.length;
        if (h) {
          const u = r[h - 1].end;
          e[d].start - u < n ? e[d].end > u && (r[h - 1].end = e[d].end) : r.push(e[d]);
        } else
          r.push(e[d]);
      }
    else
      r = e;
    let i = 0, s, a = t, l = t;
    for (let d = 0; d < r.length; d++) {
      const h = r[d].start, u = r[d].end;
      if (t + n >= h && t < u)
        a = h, l = u, i = l - t;
      else if (t + n < h) {
        s = h;
        break;
      }
    }
    return {
      len: i,
      start: a || 0,
      end: l || 0,
      nextStart: s
    };
  }
  /**
   * Safe method to get buffered property.
   * SourceBuffer.buffered may throw if SourceBuffer is removed from it's MediaSource
   */
  static getBuffered(e) {
    try {
      return e.buffered;
    } catch (t) {
      return V.log("failed to get media.buffered", t), bu;
    }
  }
}
class Hi {
  constructor(e, t, n, r = 0, i = -1, s = !1) {
    this.level = void 0, this.sn = void 0, this.part = void 0, this.id = void 0, this.size = void 0, this.partial = void 0, this.transmuxing = xr(), this.buffering = {
      audio: xr(),
      video: xr(),
      audiovideo: xr()
    }, this.level = e, this.sn = t, this.id = n, this.size = r, this.part = i, this.partial = s;
  }
}
function xr() {
  return {
    start: 0,
    executeStart: 0,
    executeEnd: 0,
    end: 0
  };
}
function Cr(o, e) {
  for (let n = 0, r = o.length; n < r; n++) {
    var t;
    if (((t = o[n]) == null ? void 0 : t.cc) === e)
      return o[n];
  }
  return null;
}
function xu(o, e, t) {
  return !!(e && (t.endCC > t.startCC || o && o.cc < t.startCC));
}
function Eu(o, e) {
  const t = o.fragments, n = e.fragments;
  if (!n.length || !t.length) {
    V.log("No fragments to align");
    return;
  }
  const r = Cr(t, n[0].cc);
  if (!r || r && !r.startPTS) {
    V.log("No frag in previous level to align on");
    return;
  }
  return r;
}
function zs(o, e) {
  if (o) {
    const t = o.start + e;
    o.start = o.startPTS = t, o.endPTS = t + o.duration;
  }
}
function qa(o, e) {
  const t = e.fragments;
  for (let n = 0, r = t.length; n < r; n++)
    zs(t[n], o);
  e.fragmentHint && zs(e.fragmentHint, o), e.alignedSliding = !0;
}
function _u(o, e, t) {
  e && (Su(o, t, e), !t.alignedSliding && e && Mr(t, e), !t.alignedSliding && e && !t.skippedSegments && Va(e, t));
}
function Su(o, e, t) {
  if (xu(o, t, e)) {
    const n = Eu(t, e);
    n && ge(n.start) && (V.log(`Adjusting PTS using last level due to CC increase within current level ${e.url}`), qa(n.start, e));
  }
}
function Mr(o, e) {
  if (!o.hasProgramDateTime || !e.hasProgramDateTime)
    return;
  const t = o.fragments, n = e.fragments;
  if (!t.length || !n.length)
    return;
  let r, i;
  const s = Math.min(e.endCC, o.endCC);
  e.startCC < s && o.startCC < s && (r = Cr(n, s), i = Cr(t, s)), (!r || !i) && (r = n[Math.floor(n.length / 2)], i = Cr(t, r.cc) || t[Math.floor(t.length / 2)]);
  const a = r.programDateTime, l = i.programDateTime;
  if (!a || !l)
    return;
  const d = (l - a) / 1e3 - (i.start - r.start);
  qa(d, o);
}
const Ys = Math.pow(2, 17);
class Tu {
  constructor(e) {
    this.config = void 0, this.loader = null, this.partLoadTimeout = -1, this.config = e;
  }
  destroy() {
    this.loader && (this.loader.destroy(), this.loader = null);
  }
  abort() {
    this.loader && this.loader.abort();
  }
  load(e, t) {
    const n = e.url;
    if (!n)
      return Promise.reject(new Ht({
        type: xe.NETWORK_ERROR,
        details: q.FRAG_LOAD_ERROR,
        fatal: !1,
        frag: e,
        error: new Error(`Fragment does not have a ${n ? "part list" : "url"}`),
        networkDetails: null
      }));
    this.abort();
    const r = this.config, i = r.fLoader, s = r.loader;
    return new Promise((a, l) => {
      if (this.loader && this.loader.destroy(), e.gap)
        if (e.tagList.some((m) => m[0] === "GAP")) {
          l(Xs(e));
          return;
        } else
          e.gap = !1;
      const d = this.loader = e.loader = i ? new i(r) : new s(r), h = qs(e), u = Ws(r.fragLoadPolicy.default), c = {
        loadPolicy: u,
        timeout: u.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0,
        highWaterMark: e.sn === "initSegment" ? 1 / 0 : Ys
      };
      e.stats = d.stats, d.load(h, c, {
        onSuccess: (m, f, p, A) => {
          this.resetLoader(e, d);
          let v = m.data;
          p.resetIV && e.decryptdata && (e.decryptdata.iv = new Uint8Array(v.slice(0, 16)), v = v.slice(16)), a({
            frag: e,
            part: null,
            payload: v,
            networkDetails: A
          });
        },
        onError: (m, f, p, A) => {
          this.resetLoader(e, d), l(new Ht({
            type: xe.NETWORK_ERROR,
            details: q.FRAG_LOAD_ERROR,
            fatal: !1,
            frag: e,
            response: it({
              url: n,
              data: void 0
            }, m),
            error: new Error(`HTTP Error ${m.code} ${m.text}`),
            networkDetails: p,
            stats: A
          }));
        },
        onAbort: (m, f, p) => {
          this.resetLoader(e, d), l(new Ht({
            type: xe.NETWORK_ERROR,
            details: q.INTERNAL_ABORTED,
            fatal: !1,
            frag: e,
            error: new Error("Aborted"),
            networkDetails: p,
            stats: m
          }));
        },
        onTimeout: (m, f, p) => {
          this.resetLoader(e, d), l(new Ht({
            type: xe.NETWORK_ERROR,
            details: q.FRAG_LOAD_TIMEOUT,
            fatal: !1,
            frag: e,
            error: new Error(`Timeout after ${c.timeout}ms`),
            networkDetails: p,
            stats: m
          }));
        },
        onProgress: (m, f, p, A) => {
          t && t({
            frag: e,
            part: null,
            payload: p,
            networkDetails: A
          });
        }
      });
    });
  }
  loadPart(e, t, n) {
    this.abort();
    const r = this.config, i = r.fLoader, s = r.loader;
    return new Promise((a, l) => {
      if (this.loader && this.loader.destroy(), e.gap || t.gap) {
        l(Xs(e, t));
        return;
      }
      const d = this.loader = e.loader = i ? new i(r) : new s(r), h = qs(e, t), u = Ws(r.fragLoadPolicy.default), c = {
        loadPolicy: u,
        timeout: u.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0,
        highWaterMark: Ys
      };
      t.stats = d.stats, d.load(h, c, {
        onSuccess: (m, f, p, A) => {
          this.resetLoader(e, d), this.updateStatsFromPart(e, t);
          const v = {
            frag: e,
            part: t,
            payload: m.data,
            networkDetails: A
          };
          n(v), a(v);
        },
        onError: (m, f, p, A) => {
          this.resetLoader(e, d), l(new Ht({
            type: xe.NETWORK_ERROR,
            details: q.FRAG_LOAD_ERROR,
            fatal: !1,
            frag: e,
            part: t,
            response: it({
              url: h.url,
              data: void 0
            }, m),
            error: new Error(`HTTP Error ${m.code} ${m.text}`),
            networkDetails: p,
            stats: A
          }));
        },
        onAbort: (m, f, p) => {
          e.stats.aborted = t.stats.aborted, this.resetLoader(e, d), l(new Ht({
            type: xe.NETWORK_ERROR,
            details: q.INTERNAL_ABORTED,
            fatal: !1,
            frag: e,
            part: t,
            error: new Error("Aborted"),
            networkDetails: p,
            stats: m
          }));
        },
        onTimeout: (m, f, p) => {
          this.resetLoader(e, d), l(new Ht({
            type: xe.NETWORK_ERROR,
            details: q.FRAG_LOAD_TIMEOUT,
            fatal: !1,
            frag: e,
            part: t,
            error: new Error(`Timeout after ${c.timeout}ms`),
            networkDetails: p,
            stats: m
          }));
        }
      });
    });
  }
  updateStatsFromPart(e, t) {
    const n = e.stats, r = t.stats, i = r.total;
    if (n.loaded += r.loaded, i) {
      const l = Math.round(e.duration / t.duration), d = Math.min(Math.round(n.loaded / i), l), u = (l - d) * Math.round(n.loaded / d);
      n.total = n.loaded + u;
    } else
      n.total = Math.max(n.loaded, n.total);
    const s = n.loading, a = r.loading;
    s.start ? s.first += a.first - a.start : (s.start = a.start, s.first = a.first), s.end = a.end;
  }
  resetLoader(e, t) {
    e.loader = null, this.loader === t && (self.clearTimeout(this.partLoadTimeout), this.loader = null), t.destroy();
  }
}
function qs(o, e = null) {
  const t = e || o, n = {
    frag: o,
    part: e,
    responseType: "arraybuffer",
    url: t.url,
    headers: {},
    rangeStart: 0,
    rangeEnd: 0
  }, r = t.byteRangeStartOffset, i = t.byteRangeEndOffset;
  if (ge(r) && ge(i)) {
    var s;
    let a = r, l = i;
    if (o.sn === "initSegment" && ((s = o.decryptdata) == null ? void 0 : s.method) === "AES-128") {
      const d = i - r;
      d % 16 && (l = i + (16 - d % 16)), r !== 0 && (n.resetIV = !0, a = r - 16);
    }
    n.rangeStart = a, n.rangeEnd = l;
  }
  return n;
}
function Xs(o, e) {
  const t = new Error(`GAP ${o.gap ? "tag" : "attribute"} found`), n = {
    type: xe.MEDIA_ERROR,
    details: q.FRAG_GAP,
    fatal: !1,
    frag: o,
    error: t,
    networkDetails: null
  };
  return e && (n.part = e), (e || o).stats.aborted = !0, new Ht(n);
}
class Ht extends Error {
  constructor(e) {
    super(e.error.message), this.data = void 0, this.data = e;
  }
}
class Cu {
  constructor(e, t) {
    this.subtle = void 0, this.aesIV = void 0, this.subtle = e, this.aesIV = t;
  }
  decrypt(e, t) {
    return this.subtle.decrypt({
      name: "AES-CBC",
      iv: this.aesIV
    }, t, e);
  }
}
class Lu {
  constructor(e, t) {
    this.subtle = void 0, this.key = void 0, this.subtle = e, this.key = t;
  }
  expandKey() {
    return this.subtle.importKey("raw", this.key, {
      name: "AES-CBC"
    }, !1, ["encrypt", "decrypt"]);
  }
}
function wu(o) {
  const e = o.byteLength, t = e && new DataView(o.buffer).getUint8(e - 1);
  return t ? hn(o, 0, e - t) : o;
}
class Ru {
  constructor() {
    this.rcon = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], this.subMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)], this.invSubMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)], this.sBox = new Uint32Array(256), this.invSBox = new Uint32Array(256), this.key = new Uint32Array(0), this.ksRows = 0, this.keySize = 0, this.keySchedule = void 0, this.invKeySchedule = void 0, this.initTable();
  }
  // Using view.getUint32() also swaps the byte order.
  uint8ArrayToUint32Array_(e) {
    const t = new DataView(e), n = new Uint32Array(4);
    for (let r = 0; r < 4; r++)
      n[r] = t.getUint32(r * 4);
    return n;
  }
  initTable() {
    const e = this.sBox, t = this.invSBox, n = this.subMix, r = n[0], i = n[1], s = n[2], a = n[3], l = this.invSubMix, d = l[0], h = l[1], u = l[2], c = l[3], m = new Uint32Array(256);
    let f = 0, p = 0, A = 0;
    for (A = 0; A < 256; A++)
      A < 128 ? m[A] = A << 1 : m[A] = A << 1 ^ 283;
    for (A = 0; A < 256; A++) {
      let v = p ^ p << 1 ^ p << 2 ^ p << 3 ^ p << 4;
      v = v >>> 8 ^ v & 255 ^ 99, e[f] = v, t[v] = f;
      const b = m[f], _ = m[b], T = m[_];
      let E = m[v] * 257 ^ v * 16843008;
      r[f] = E << 24 | E >>> 8, i[f] = E << 16 | E >>> 16, s[f] = E << 8 | E >>> 24, a[f] = E, E = T * 16843009 ^ _ * 65537 ^ b * 257 ^ f * 16843008, d[v] = E << 24 | E >>> 8, h[v] = E << 16 | E >>> 16, u[v] = E << 8 | E >>> 24, c[v] = E, f ? (f = b ^ m[m[m[T ^ b]]], p ^= m[m[p]]) : f = p = 1;
    }
  }
  expandKey(e) {
    const t = this.uint8ArrayToUint32Array_(e);
    let n = !0, r = 0;
    for (; r < t.length && n; )
      n = t[r] === this.key[r], r++;
    if (n)
      return;
    this.key = t;
    const i = this.keySize = t.length;
    if (i !== 4 && i !== 6 && i !== 8)
      throw new Error("Invalid aes key size=" + i);
    const s = this.ksRows = (i + 6 + 1) * 4;
    let a, l;
    const d = this.keySchedule = new Uint32Array(s), h = this.invKeySchedule = new Uint32Array(s), u = this.sBox, c = this.rcon, m = this.invSubMix, f = m[0], p = m[1], A = m[2], v = m[3];
    let b, _;
    for (a = 0; a < s; a++) {
      if (a < i) {
        b = d[a] = t[a];
        continue;
      }
      _ = b, a % i === 0 ? (_ = _ << 8 | _ >>> 24, _ = u[_ >>> 24] << 24 | u[_ >>> 16 & 255] << 16 | u[_ >>> 8 & 255] << 8 | u[_ & 255], _ ^= c[a / i | 0] << 24) : i > 6 && a % i === 4 && (_ = u[_ >>> 24] << 24 | u[_ >>> 16 & 255] << 16 | u[_ >>> 8 & 255] << 8 | u[_ & 255]), d[a] = b = (d[a - i] ^ _) >>> 0;
    }
    for (l = 0; l < s; l++)
      a = s - l, l & 3 ? _ = d[a] : _ = d[a - 4], l < 4 || a <= 4 ? h[l] = _ : h[l] = f[u[_ >>> 24]] ^ p[u[_ >>> 16 & 255]] ^ A[u[_ >>> 8 & 255]] ^ v[u[_ & 255]], h[l] = h[l] >>> 0;
  }
  // Adding this as a method greatly improves performance.
  networkToHostOrderSwap(e) {
    return e << 24 | (e & 65280) << 8 | (e & 16711680) >> 8 | e >>> 24;
  }
  decrypt(e, t, n) {
    const r = this.keySize + 6, i = this.invKeySchedule, s = this.invSBox, a = this.invSubMix, l = a[0], d = a[1], h = a[2], u = a[3], c = this.uint8ArrayToUint32Array_(n);
    let m = c[0], f = c[1], p = c[2], A = c[3];
    const v = new Int32Array(e), b = new Int32Array(v.length);
    let _, T, E, L, k, D, M, O, N, B, U, G, Y, z;
    const J = this.networkToHostOrderSwap;
    for (; t < v.length; ) {
      for (N = J(v[t]), B = J(v[t + 1]), U = J(v[t + 2]), G = J(v[t + 3]), k = N ^ i[0], D = G ^ i[1], M = U ^ i[2], O = B ^ i[3], Y = 4, z = 1; z < r; z++)
        _ = l[k >>> 24] ^ d[D >> 16 & 255] ^ h[M >> 8 & 255] ^ u[O & 255] ^ i[Y], T = l[D >>> 24] ^ d[M >> 16 & 255] ^ h[O >> 8 & 255] ^ u[k & 255] ^ i[Y + 1], E = l[M >>> 24] ^ d[O >> 16 & 255] ^ h[k >> 8 & 255] ^ u[D & 255] ^ i[Y + 2], L = l[O >>> 24] ^ d[k >> 16 & 255] ^ h[D >> 8 & 255] ^ u[M & 255] ^ i[Y + 3], k = _, D = T, M = E, O = L, Y = Y + 4;
      _ = s[k >>> 24] << 24 ^ s[D >> 16 & 255] << 16 ^ s[M >> 8 & 255] << 8 ^ s[O & 255] ^ i[Y], T = s[D >>> 24] << 24 ^ s[M >> 16 & 255] << 16 ^ s[O >> 8 & 255] << 8 ^ s[k & 255] ^ i[Y + 1], E = s[M >>> 24] << 24 ^ s[O >> 16 & 255] << 16 ^ s[k >> 8 & 255] << 8 ^ s[D & 255] ^ i[Y + 2], L = s[O >>> 24] << 24 ^ s[k >> 16 & 255] << 16 ^ s[D >> 8 & 255] << 8 ^ s[M & 255] ^ i[Y + 3], b[t] = J(_ ^ m), b[t + 1] = J(L ^ f), b[t + 2] = J(E ^ p), b[t + 3] = J(T ^ A), m = N, f = B, p = U, A = G, t = t + 4;
    }
    return b.buffer;
  }
}
const Iu = 16;
class zi {
  constructor(e, {
    removePKCS7Padding: t = !0
  } = {}) {
    if (this.logEnabled = !0, this.removePKCS7Padding = void 0, this.subtle = null, this.softwareDecrypter = null, this.key = null, this.fastAesKey = null, this.remainderData = null, this.currentIV = null, this.currentResult = null, this.useSoftware = void 0, this.useSoftware = e.enableSoftwareAES, this.removePKCS7Padding = t, t)
      try {
        const n = self.crypto;
        n && (this.subtle = n.subtle || n.webkitSubtle);
      } catch {
      }
    this.subtle === null && (this.useSoftware = !0);
  }
  destroy() {
    this.subtle = null, this.softwareDecrypter = null, this.key = null, this.fastAesKey = null, this.remainderData = null, this.currentIV = null, this.currentResult = null;
  }
  isSync() {
    return this.useSoftware;
  }
  flush() {
    const {
      currentResult: e,
      remainderData: t
    } = this;
    if (!e || t)
      return this.reset(), null;
    const n = new Uint8Array(e);
    return this.reset(), this.removePKCS7Padding ? wu(n) : n;
  }
  reset() {
    this.currentResult = null, this.currentIV = null, this.remainderData = null, this.softwareDecrypter && (this.softwareDecrypter = null);
  }
  decrypt(e, t, n) {
    return this.useSoftware ? new Promise((r, i) => {
      this.softwareDecrypt(new Uint8Array(e), t, n);
      const s = this.flush();
      s ? r(s.buffer) : i(new Error("[softwareDecrypt] Failed to decrypt data"));
    }) : this.webCryptoDecrypt(new Uint8Array(e), t, n);
  }
  // Software decryption is progressive. Progressive decryption may not return a result on each call. Any cached
  // data is handled in the flush() call
  softwareDecrypt(e, t, n) {
    const {
      currentIV: r,
      currentResult: i,
      remainderData: s
    } = this;
    this.logOnce("JS AES decrypt"), s && (e = xt(s, e), this.remainderData = null);
    const a = this.getValidChunk(e);
    if (!a.length)
      return null;
    r && (n = r);
    let l = this.softwareDecrypter;
    l || (l = this.softwareDecrypter = new Ru()), l.expandKey(t);
    const d = i;
    return this.currentResult = l.decrypt(a.buffer, 0, n), this.currentIV = hn(a, -16).buffer, d || null;
  }
  webCryptoDecrypt(e, t, n) {
    const r = this.subtle;
    return (this.key !== t || !this.fastAesKey) && (this.key = t, this.fastAesKey = new Lu(r, t)), this.fastAesKey.expandKey().then((i) => r ? (this.logOnce("WebCrypto AES decrypt"), new Cu(r, new Uint8Array(n)).decrypt(e.buffer, i)) : Promise.reject(new Error("web crypto not initialized"))).catch((i) => (V.warn(`[decrypter]: WebCrypto Error, disable WebCrypto API, ${i.name}: ${i.message}`), this.onWebCryptoError(e, t, n)));
  }
  onWebCryptoError(e, t, n) {
    this.useSoftware = !0, this.logEnabled = !0, this.softwareDecrypt(e, t, n);
    const r = this.flush();
    if (r)
      return r.buffer;
    throw new Error("WebCrypto and softwareDecrypt: failed to decrypt data");
  }
  getValidChunk(e) {
    let t = e;
    const n = e.length - e.length % Iu;
    return n !== e.length && (t = hn(e, 0, n), this.remainderData = hn(e, n)), t;
  }
  logOnce(e) {
    this.logEnabled && (V.log(`[decrypter]: ${e}`), this.logEnabled = !1);
  }
}
const ku = {
  toString: function(o) {
    let e = "";
    const t = o.length;
    for (let n = 0; n < t; n++)
      e += `[${o.start(n).toFixed(3)}-${o.end(n).toFixed(3)}]`;
    return e;
  }
}, ee = {
  STOPPED: "STOPPED",
  IDLE: "IDLE",
  KEY_LOADING: "KEY_LOADING",
  FRAG_LOADING: "FRAG_LOADING",
  FRAG_LOADING_WAITING_RETRY: "FRAG_LOADING_WAITING_RETRY",
  WAITING_TRACK: "WAITING_TRACK",
  PARSING: "PARSING",
  PARSED: "PARSED",
  ENDED: "ENDED",
  ERROR: "ERROR",
  WAITING_INIT_PTS: "WAITING_INIT_PTS",
  WAITING_LEVEL: "WAITING_LEVEL"
};
class Yi extends Au {
  constructor(e, t, n, r, i) {
    super(), this.hls = void 0, this.fragPrevious = null, this.fragCurrent = null, this.fragmentTracker = void 0, this.transmuxer = null, this._state = ee.STOPPED, this.playlistType = void 0, this.media = null, this.mediaBuffer = null, this.config = void 0, this.bitrateTest = !1, this.lastCurrentTime = 0, this.nextLoadPosition = 0, this.startPosition = 0, this.startTimeOffset = null, this.loadedmetadata = !1, this.retryDate = 0, this.levels = null, this.fragmentLoader = void 0, this.keyLoader = void 0, this.levelLastLoaded = null, this.startFragRequested = !1, this.decrypter = void 0, this.initPTS = [], this.onvseeking = null, this.onvended = null, this.logPrefix = "", this.log = void 0, this.warn = void 0, this.playlistType = i, this.logPrefix = r, this.log = V.log.bind(V, `${r}:`), this.warn = V.warn.bind(V, `${r}:`), this.hls = e, this.fragmentLoader = new Tu(e.config), this.keyLoader = n, this.fragmentTracker = t, this.config = e.config, this.decrypter = new zi(e.config), e.on(I.MANIFEST_LOADED, this.onManifestLoaded, this);
  }
  doTick() {
    this.onTickEnd();
  }
  onTickEnd() {
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  startLoad(e) {
  }
  stopLoad() {
    this.fragmentLoader.abort(), this.keyLoader.abort(this.playlistType);
    const e = this.fragCurrent;
    e != null && e.loader && (e.abortRequests(), this.fragmentTracker.removeFragment(e)), this.resetTransmuxer(), this.fragCurrent = null, this.fragPrevious = null, this.clearInterval(), this.clearNextTick(), this.state = ee.STOPPED;
  }
  _streamEnded(e, t) {
    if (t.live || e.nextStart || !e.end || !this.media)
      return !1;
    const n = t.partList;
    if (n != null && n.length) {
      const i = n[n.length - 1];
      return He.isBuffered(this.media, i.start + i.duration / 2);
    }
    const r = t.fragments[t.fragments.length - 1].type;
    return this.fragmentTracker.isEndListAppended(r);
  }
  getLevelDetails() {
    if (this.levels && this.levelLastLoaded !== null) {
      var e;
      return (e = this.levelLastLoaded) == null ? void 0 : e.details;
    }
  }
  onMediaAttached(e, t) {
    const n = this.media = this.mediaBuffer = t.media;
    this.onvseeking = this.onMediaSeeking.bind(this), this.onvended = this.onMediaEnded.bind(this), n.addEventListener("seeking", this.onvseeking), n.addEventListener("ended", this.onvended);
    const r = this.config;
    this.levels && r.autoStartLoad && this.state === ee.STOPPED && this.startLoad(r.startPosition);
  }
  onMediaDetaching() {
    const e = this.media;
    e != null && e.ended && (this.log("MSE detaching and video ended, reset startPosition"), this.startPosition = this.lastCurrentTime = 0), e && this.onvseeking && this.onvended && (e.removeEventListener("seeking", this.onvseeking), e.removeEventListener("ended", this.onvended), this.onvseeking = this.onvended = null), this.keyLoader && this.keyLoader.detach(), this.media = this.mediaBuffer = null, this.loadedmetadata = !1, this.fragmentTracker.removeAllFragments(), this.stopLoad();
  }
  onMediaSeeking() {
    const {
      config: e,
      fragCurrent: t,
      media: n,
      mediaBuffer: r,
      state: i
    } = this, s = n ? n.currentTime : 0, a = He.bufferInfo(r || n, s, e.maxBufferHole);
    if (this.log(`media seeking to ${ge(s) ? s.toFixed(3) : s}, state: ${i}`), this.state === ee.ENDED)
      this.resetLoadingState();
    else if (t) {
      const l = e.maxFragLookUpTolerance, d = t.start - l, h = t.start + t.duration + l;
      if (!a.len || h < a.start || d > a.end) {
        const u = s > h;
        (s < d || u) && (u && t.loader && (this.log("seeking outside of buffer while fragment load in progress, cancel fragment load"), t.abortRequests(), this.resetLoadingState()), this.fragPrevious = null);
      }
    }
    n && (this.fragmentTracker.removeFragmentsInRange(s, 1 / 0, this.playlistType, !0), this.lastCurrentTime = s), !this.loadedmetadata && !a.len && (this.nextLoadPosition = this.startPosition = s), this.tickImmediate();
  }
  onMediaEnded() {
    this.startPosition = this.lastCurrentTime = 0;
  }
  onManifestLoaded(e, t) {
    this.startTimeOffset = t.startTimeOffset, this.initPTS = [];
  }
  onHandlerDestroying() {
    this.stopLoad(), super.onHandlerDestroying();
  }
  onHandlerDestroyed() {
    this.state = ee.STOPPED, this.fragmentLoader && this.fragmentLoader.destroy(), this.keyLoader && this.keyLoader.destroy(), this.decrypter && this.decrypter.destroy(), this.hls = this.log = this.warn = this.decrypter = this.keyLoader = this.fragmentLoader = this.fragmentTracker = null, super.onHandlerDestroyed();
  }
  loadFragment(e, t, n) {
    this._loadFragForPlayback(e, t, n);
  }
  _loadFragForPlayback(e, t, n) {
    const r = (i) => {
      if (this.fragContextChanged(e)) {
        this.warn(`Fragment ${e.sn}${i.part ? " p: " + i.part.index : ""} of level ${e.level} was dropped during download.`), this.fragmentTracker.removeFragment(e);
        return;
      }
      e.stats.chunkCount++, this._handleFragmentLoadProgress(i);
    };
    this._doFragLoad(e, t, n, r).then((i) => {
      if (!i)
        return;
      const s = this.state;
      if (this.fragContextChanged(e)) {
        (s === ee.FRAG_LOADING || !this.fragCurrent && s === ee.PARSING) && (this.fragmentTracker.removeFragment(e), this.state = ee.IDLE);
        return;
      }
      "payload" in i && (this.log(`Loaded fragment ${e.sn} of level ${e.level}`), this.hls.trigger(I.FRAG_LOADED, i)), this._handleFragmentLoadComplete(i);
    }).catch((i) => {
      this.state === ee.STOPPED || this.state === ee.ERROR || (this.warn(i), this.resetFragmentLoading(e));
    });
  }
  clearTrackerIfNeeded(e) {
    var t;
    const {
      fragmentTracker: n
    } = this;
    if (n.getState(e) === dt.APPENDING) {
      const i = e.type, s = this.getFwdBufferInfo(this.mediaBuffer, i), a = Math.max(e.duration, s ? s.len : this.config.maxBufferLength);
      this.reduceMaxBufferLength(a) && n.removeFragment(e);
    } else
      ((t = this.mediaBuffer) == null ? void 0 : t.buffered.length) === 0 ? n.removeAllFragments() : n.hasParts(e.type) && (n.detectPartialFragments({
        frag: e,
        part: null,
        stats: e.stats,
        id: e.type
      }), n.getState(e) === dt.PARTIAL && n.removeFragment(e));
  }
  checkLiveUpdate(e) {
    if (e.updated && !e.live) {
      const t = e.fragments[e.fragments.length - 1];
      this.fragmentTracker.detectPartialFragments({
        frag: t,
        part: null,
        stats: t.stats,
        id: t.type
      });
    }
    e.fragments[0] || (e.deltaUpdateFailed = !0);
  }
  flushMainBuffer(e, t, n = null) {
    if (!(e - t))
      return;
    const r = {
      startOffset: e,
      endOffset: t,
      type: n
    };
    this.hls.trigger(I.BUFFER_FLUSHING, r);
  }
  _loadInitSegment(e, t) {
    this._doFragLoad(e, t).then((n) => {
      if (!n || this.fragContextChanged(e) || !this.levels)
        throw new Error("init load aborted");
      return n;
    }).then((n) => {
      const {
        hls: r
      } = this, {
        payload: i
      } = n, s = e.decryptdata;
      if (i && i.byteLength > 0 && s && s.key && s.iv && s.method === "AES-128") {
        const a = self.performance.now();
        return this.decrypter.decrypt(new Uint8Array(i), s.key.buffer, s.iv.buffer).catch((l) => {
          throw r.trigger(I.ERROR, {
            type: xe.MEDIA_ERROR,
            details: q.FRAG_DECRYPT_ERROR,
            fatal: !1,
            error: l,
            reason: l.message,
            frag: e
          }), l;
        }).then((l) => {
          const d = self.performance.now();
          return r.trigger(I.FRAG_DECRYPTED, {
            frag: e,
            payload: l,
            stats: {
              tstart: a,
              tdecrypt: d
            }
          }), n.payload = l, this.completeInitSegmentLoad(n);
        });
      }
      return this.completeInitSegmentLoad(n);
    }).catch((n) => {
      this.state === ee.STOPPED || this.state === ee.ERROR || (this.warn(n), this.resetFragmentLoading(e));
    });
  }
  completeInitSegmentLoad(e) {
    const {
      levels: t
    } = this;
    if (!t)
      throw new Error("init load aborted, missing levels");
    const n = e.frag.stats;
    this.state = ee.IDLE, e.frag.data = new Uint8Array(e.payload), n.parsing.start = n.buffering.start = self.performance.now(), n.parsing.end = n.buffering.end = self.performance.now(), this.tick();
  }
  fragContextChanged(e) {
    const {
      fragCurrent: t
    } = this;
    return !e || !t || e.level !== t.level || e.sn !== t.sn || e.urlId !== t.urlId;
  }
  fragBufferedComplete(e, t) {
    var n, r, i, s;
    const a = this.mediaBuffer ? this.mediaBuffer : this.media;
    if (this.log(`Buffered ${e.type} sn: ${e.sn}${t ? " part: " + t.index : ""} of ${this.playlistType === be.MAIN ? "level" : "track"} ${e.level} (frag:[${((n = e.startPTS) != null ? n : NaN).toFixed(3)}-${((r = e.endPTS) != null ? r : NaN).toFixed(3)}] > buffer:${a ? ku.toString(He.getBuffered(a)) : "(detached)"})`), e.sn !== "initSegment") {
      var l;
      if (e.type !== be.SUBTITLE) {
        const h = e.elementaryStreams;
        if (!Object.keys(h).some((u) => !!h[u])) {
          this.state = ee.IDLE;
          return;
        }
      }
      const d = (l = this.levels) == null ? void 0 : l[e.level];
      d != null && d.fragmentError && (this.log(`Resetting level fragment error count of ${d.fragmentError} on frag buffered`), d.fragmentError = 0);
    }
    this.state = ee.IDLE, a && (!this.loadedmetadata && e.type == be.MAIN && a.buffered.length && ((i = this.fragCurrent) == null ? void 0 : i.sn) === ((s = this.fragPrevious) == null ? void 0 : s.sn) && (this.loadedmetadata = !0, this.seekToStartPos()), this.tick());
  }
  seekToStartPos() {
  }
  _handleFragmentLoadComplete(e) {
    const {
      transmuxer: t
    } = this;
    if (!t)
      return;
    const {
      frag: n,
      part: r,
      partsLoaded: i
    } = e, s = !i || i.length === 0 || i.some((l) => !l), a = new Hi(n.level, n.sn, n.stats.chunkCount + 1, 0, r ? r.index : -1, !s);
    t.flush(a);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _handleFragmentLoadProgress(e) {
  }
  _doFragLoad(e, t, n = null, r) {
    var i;
    const s = t == null ? void 0 : t.details;
    if (!this.levels || !s)
      throw new Error(`frag load aborted, missing level${s ? "" : " detail"}s`);
    let a = null;
    if (e.encrypted && !((i = e.decryptdata) != null && i.key) ? (this.log(`Loading key for ${e.sn} of [${s.startSN}-${s.endSN}], ${this.logPrefix === "[stream-controller]" ? "level" : "track"} ${e.level}`), this.state = ee.KEY_LOADING, this.fragCurrent = e, a = this.keyLoader.load(e).then((h) => {
      if (!this.fragContextChanged(h.frag))
        return this.hls.trigger(I.KEY_LOADED, h), this.state === ee.KEY_LOADING && (this.state = ee.IDLE), h;
    }), this.hls.trigger(I.KEY_LOADING, {
      frag: e
    }), this.fragCurrent === null && (a = Promise.reject(new Error("frag load aborted, context changed in KEY_LOADING")))) : !e.encrypted && s.encryptedFragments.length && this.keyLoader.loadClear(e, s.encryptedFragments), n = Math.max(e.start, n || 0), this.config.lowLatencyMode && e.sn !== "initSegment") {
      const h = s.partList;
      if (h && r) {
        n > e.end && s.fragmentHint && (e = s.fragmentHint);
        const u = this.getNextPart(h, e, n);
        if (u > -1) {
          const c = h[u];
          this.log(`Loading part sn: ${e.sn} p: ${c.index} cc: ${e.cc} of playlist [${s.startSN}-${s.endSN}] parts [0-${u}-${h.length - 1}] ${this.logPrefix === "[stream-controller]" ? "level" : "track"}: ${e.level}, target: ${parseFloat(n.toFixed(3))}`), this.nextLoadPosition = c.start + c.duration, this.state = ee.FRAG_LOADING;
          let m;
          return a ? m = a.then((f) => !f || this.fragContextChanged(f.frag) ? null : this.doFragPartsLoad(e, c, t, r)).catch((f) => this.handleFragLoadError(f)) : m = this.doFragPartsLoad(e, c, t, r).catch((f) => this.handleFragLoadError(f)), this.hls.trigger(I.FRAG_LOADING, {
            frag: e,
            part: c,
            targetBufferTime: n
          }), this.fragCurrent === null ? Promise.reject(new Error("frag load aborted, context changed in FRAG_LOADING parts")) : m;
        } else if (!e.url || this.loadedEndOfParts(h, n))
          return Promise.resolve(null);
      }
    }
    this.log(`Loading fragment ${e.sn} cc: ${e.cc} ${s ? "of [" + s.startSN + "-" + s.endSN + "] " : ""}${this.logPrefix === "[stream-controller]" ? "level" : "track"}: ${e.level}, target: ${parseFloat(n.toFixed(3))}`), ge(e.sn) && !this.bitrateTest && (this.nextLoadPosition = e.start + e.duration), this.state = ee.FRAG_LOADING;
    const l = this.config.progressive;
    let d;
    return l && a ? d = a.then((h) => !h || this.fragContextChanged(h == null ? void 0 : h.frag) ? null : this.fragmentLoader.load(e, r)).catch((h) => this.handleFragLoadError(h)) : d = Promise.all([this.fragmentLoader.load(e, l ? r : void 0), a]).then(([h]) => (!l && h && r && r(h), h)).catch((h) => this.handleFragLoadError(h)), this.hls.trigger(I.FRAG_LOADING, {
      frag: e,
      targetBufferTime: n
    }), this.fragCurrent === null ? Promise.reject(new Error("frag load aborted, context changed in FRAG_LOADING")) : d;
  }
  doFragPartsLoad(e, t, n, r) {
    return new Promise((i, s) => {
      var a;
      const l = [], d = (a = n.details) == null ? void 0 : a.partList, h = (u) => {
        this.fragmentLoader.loadPart(e, u, r).then((c) => {
          l[u.index] = c;
          const m = c.part;
          this.hls.trigger(I.FRAG_LOADED, c);
          const f = $s(n, e.sn, u.index + 1) || Wa(d, e.sn, u.index + 1);
          if (f)
            h(f);
          else
            return i({
              frag: e,
              part: m,
              partsLoaded: l
            });
        }).catch(s);
      };
      h(t);
    });
  }
  handleFragLoadError(e) {
    if ("data" in e) {
      const t = e.data;
      e.data && t.details === q.INTERNAL_ABORTED ? this.handleFragLoadAborted(t.frag, t.part) : this.hls.trigger(I.ERROR, t);
    } else
      this.hls.trigger(I.ERROR, {
        type: xe.OTHER_ERROR,
        details: q.INTERNAL_EXCEPTION,
        err: e,
        error: e,
        fatal: !0
      });
    return null;
  }
  _handleTransmuxerFlush(e) {
    const t = this.getCurrentContext(e);
    if (!t || this.state !== ee.PARSING) {
      !this.fragCurrent && this.state !== ee.STOPPED && this.state !== ee.ERROR && (this.state = ee.IDLE);
      return;
    }
    const {
      frag: n,
      part: r,
      level: i
    } = t, s = self.performance.now();
    n.stats.parsing.end = s, r && (r.stats.parsing.end = s), this.updateLevelTiming(n, r, i, e.partial);
  }
  getCurrentContext(e) {
    const {
      levels: t,
      fragCurrent: n
    } = this, {
      level: r,
      sn: i,
      part: s
    } = e;
    if (!(t != null && t[r]))
      return this.warn(`Levels object was unset while buffering fragment ${i} of level ${r}. The current chunk will not be buffered.`), null;
    const a = t[r], l = s > -1 ? $s(a, i, s) : null, d = l ? l.fragment : nu(a, i, n);
    return d ? (n && n !== d && (d.stats = n.stats), {
      frag: d,
      part: l,
      level: a
    }) : null;
  }
  bufferFragmentData(e, t, n, r, i) {
    var s;
    if (!e || this.state !== ee.PARSING)
      return;
    const {
      data1: a,
      data2: l
    } = e;
    let d = a;
    if (a && l && (d = xt(a, l)), !((s = d) != null && s.length))
      return;
    const h = {
      type: e.type,
      frag: t,
      part: n,
      chunkMeta: r,
      parent: t.type,
      data: d
    };
    if (this.hls.trigger(I.BUFFER_APPENDING, h), e.dropped && e.independent && !n) {
      if (i)
        return;
      this.flushBufferGap(t);
    }
  }
  flushBufferGap(e) {
    const t = this.media;
    if (!t)
      return;
    if (!He.isBuffered(t, t.currentTime)) {
      this.flushMainBuffer(0, e.start);
      return;
    }
    const n = t.currentTime, r = He.bufferInfo(t, n, 0), i = e.duration, s = Math.min(this.config.maxFragLookUpTolerance * 2, i * 0.25), a = Math.max(Math.min(e.start - s, r.end - s), n + s);
    e.start - a > s && this.flushMainBuffer(a, e.start);
  }
  getFwdBufferInfo(e, t) {
    const n = this.getLoadPosition();
    return ge(n) ? this.getFwdBufferInfoAtPos(e, n, t) : null;
  }
  getFwdBufferInfoAtPos(e, t, n) {
    const {
      config: {
        maxBufferHole: r
      }
    } = this, i = He.bufferInfo(e, t, r);
    if (i.len === 0 && i.nextStart !== void 0) {
      const s = this.fragmentTracker.getBufferedFrag(t, n);
      if (s && i.nextStart < s.end)
        return He.bufferInfo(e, t, Math.max(i.nextStart, r));
    }
    return i;
  }
  getMaxBufferLength(e) {
    const {
      config: t
    } = this;
    let n;
    return e ? n = Math.max(8 * t.maxBufferSize / e, t.maxBufferLength) : n = t.maxBufferLength, Math.min(n, t.maxMaxBufferLength);
  }
  reduceMaxBufferLength(e) {
    const t = this.config, n = e || t.maxBufferLength;
    return t.maxMaxBufferLength >= n ? (t.maxMaxBufferLength /= 2, this.warn(`Reduce max buffer length to ${t.maxMaxBufferLength}s`), !0) : !1;
  }
  getAppendedFrag(e, t = be.MAIN) {
    const n = this.fragmentTracker.getAppendedFrag(e, be.MAIN);
    return n && "fragment" in n ? n.fragment : n;
  }
  getNextFragment(e, t) {
    const n = t.fragments, r = n.length;
    if (!r)
      return null;
    const {
      config: i
    } = this, s = n[0].start;
    let a;
    if (t.live) {
      const l = i.initialLiveManifestSize;
      if (r < l)
        return this.warn(`Not enough fragments to start playback (have: ${r}, need: ${l})`), null;
      (!t.PTSKnown && !this.startFragRequested && this.startPosition === -1 || e < s) && (a = this.getInitialLiveFragment(t, n), this.startPosition = this.nextLoadPosition = a ? this.hls.liveSyncPosition || a.start : e);
    } else
      e <= s && (a = n[0]);
    if (!a) {
      const l = i.lowLatencyMode ? t.partEnd : t.fragmentEnd;
      a = this.getFragmentAtPosition(e, l, t);
    }
    return this.mapToInitFragWhenRequired(a);
  }
  isLoopLoading(e, t) {
    const n = this.fragmentTracker.getState(e);
    return (n === dt.OK || n === dt.PARTIAL && !!e.gap) && this.nextLoadPosition > t;
  }
  getNextFragmentLoopLoading(e, t, n, r, i) {
    const s = e.gap, a = this.getNextFragment(this.nextLoadPosition, t);
    if (a === null)
      return a;
    if (e = a, s && e && !e.gap && n.nextStart) {
      const l = this.getFwdBufferInfoAtPos(this.mediaBuffer ? this.mediaBuffer : this.media, n.nextStart, r);
      if (l !== null && n.len + l.len >= i)
        return this.log(`buffer full after gaps in "${r}" playlist starting at sn: ${e.sn}`), null;
    }
    return e;
  }
  mapToInitFragWhenRequired(e) {
    return e != null && e.initSegment && !(e != null && e.initSegment.data) && !this.bitrateTest ? e.initSegment : e;
  }
  getNextPart(e, t, n) {
    let r = -1, i = !1, s = !0;
    for (let a = 0, l = e.length; a < l; a++) {
      const d = e[a];
      if (s = s && !d.independent, r > -1 && n < d.start)
        break;
      const h = d.loaded;
      h ? r = -1 : (i || d.independent || s) && d.fragment === t && (r = a), i = h;
    }
    return r;
  }
  loadedEndOfParts(e, t) {
    const n = e[e.length - 1];
    return n && t > n.start && n.loaded;
  }
  /*
   This method is used find the best matching first fragment for a live playlist. This fragment is used to calculate the
   "sliding" of the playlist, which is its offset from the start of playback. After sliding we can compute the real
   start and end times for each fragment in the playlist (after which this method will not need to be called).
  */
  getInitialLiveFragment(e, t) {
    const n = this.fragPrevious;
    let r = null;
    if (n) {
      if (e.hasProgramDateTime && (this.log(`Live playlist, switching playlist, load frag with same PDT: ${n.programDateTime}`), r = iu(t, n.endProgramDateTime, this.config.maxFragLookUpTolerance)), !r) {
        const i = n.sn + 1;
        if (i >= e.startSN && i <= e.endSN) {
          const s = t[i - e.startSN];
          n.cc === s.cc && (r = s, this.log(`Live playlist, switching playlist, load frag with next SN: ${r.sn}`));
        }
        r || (r = au(t, n.cc), r && this.log(`Live playlist, switching playlist, load frag with same CC: ${r.sn}`));
      }
    } else {
      const i = this.hls.liveSyncPosition;
      i !== null && (r = this.getFragmentAtPosition(i, this.bitrateTest ? e.fragmentEnd : e.edge, e));
    }
    return r;
  }
  /*
  This method finds the best matching fragment given the provided position.
   */
  getFragmentAtPosition(e, t, n) {
    const {
      config: r
    } = this;
    let {
      fragPrevious: i
    } = this, {
      fragments: s,
      endSN: a
    } = n;
    const {
      fragmentHint: l
    } = n, d = r.maxFragLookUpTolerance, h = n.partList, u = !!(r.lowLatencyMode && h != null && h.length && l);
    u && l && !this.bitrateTest && (s = s.concat(l), a = l.sn);
    let c;
    if (e < t) {
      const m = e > t - d ? 0 : d;
      c = ir(i, s, e, m);
    } else
      c = s[s.length - 1];
    if (c) {
      const m = c.sn - n.startSN, f = this.fragmentTracker.getState(c);
      if ((f === dt.OK || f === dt.PARTIAL && c.gap) && (i = c), i && c.sn === i.sn && (!u || h[0].fragment.sn > c.sn) && i && c.level === i.level) {
        const A = s[m + 1];
        c.sn < a && this.fragmentTracker.getState(A) !== dt.OK ? c = A : c = null;
      }
    }
    return c;
  }
  synchronizeToLiveEdge(e) {
    const {
      config: t,
      media: n
    } = this;
    if (!n)
      return;
    const r = this.hls.liveSyncPosition, i = n.currentTime, s = e.fragments[0].start, a = e.edge, l = i >= s - t.maxFragLookUpTolerance && i <= a;
    if (r !== null && n.duration > r && (i < r || !l)) {
      const d = t.liveMaxLatencyDuration !== void 0 ? t.liveMaxLatencyDuration : t.liveMaxLatencyDurationCount * e.targetduration;
      (!l && n.readyState < 4 || i < a - d) && (this.loadedmetadata || (this.nextLoadPosition = r), n.readyState && (this.warn(`Playback: ${i.toFixed(3)} is located too far from the end of live sliding playlist: ${a}, reset currentTime to : ${r.toFixed(3)}`), n.currentTime = r));
    }
  }
  alignPlaylists(e, t, n) {
    const r = e.fragments.length;
    if (!r)
      return this.warn("No fragments in live playlist"), 0;
    const i = e.fragments[0].start, s = !t, a = e.alignedSliding && ge(i);
    if (s || !a && !i) {
      const {
        fragPrevious: l
      } = this;
      _u(l, n, e);
      const d = e.fragments[0].start;
      return this.log(`Live playlist sliding: ${d.toFixed(2)} start-sn: ${t ? t.startSN : "na"}->${e.startSN} prev-sn: ${l ? l.sn : "na"} fragments: ${r}`), d;
    }
    return i;
  }
  waitForCdnTuneIn(e) {
    return e.live && e.canBlockReload && e.partTarget && e.tuneInGoal > Math.max(e.partHoldBack, e.partTarget * 3);
  }
  setStartPosition(e, t) {
    let n = this.startPosition;
    if (n < t && (n = -1), n === -1 || this.lastCurrentTime === -1) {
      const r = this.startTimeOffset !== null, i = r ? this.startTimeOffset : e.startTimeOffset;
      i !== null && ge(i) ? (n = t + i, i < 0 && (n += e.totalduration), n = Math.min(Math.max(t, n), t + e.totalduration), this.log(`Start time offset ${i} found in ${r ? "multivariant" : "media"} playlist, adjust startPosition to ${n}`), this.startPosition = n) : e.live ? n = this.hls.liveSyncPosition || t : this.startPosition = n = 0, this.lastCurrentTime = n;
    }
    this.nextLoadPosition = n;
  }
  getLoadPosition() {
    const {
      media: e
    } = this;
    let t = 0;
    return this.loadedmetadata && e ? t = e.currentTime : this.nextLoadPosition && (t = this.nextLoadPosition), t;
  }
  handleFragLoadAborted(e, t) {
    this.transmuxer && e.sn !== "initSegment" && e.stats.aborted && (this.warn(`Fragment ${e.sn}${t ? " part " + t.index : ""} of level ${e.level} was aborted`), this.resetFragmentLoading(e));
  }
  resetFragmentLoading(e) {
    (!this.fragCurrent || !this.fragContextChanged(e) && this.state !== ee.FRAG_LOADING_WAITING_RETRY) && (this.state = ee.IDLE);
  }
  onFragmentOrKeyLoadError(e, t) {
    if (t.chunkMeta && !t.frag) {
      const h = this.getCurrentContext(t.chunkMeta);
      h && (t.frag = h.frag);
    }
    const n = t.frag;
    if (!n || n.type !== e || !this.levels)
      return;
    if (this.fragContextChanged(n)) {
      var r;
      this.warn(`Frag load error must match current frag to retry ${n.url} > ${(r = this.fragCurrent) == null ? void 0 : r.url}`);
      return;
    }
    const i = t.details === q.FRAG_GAP;
    i && this.fragmentTracker.fragBuffered(n, !0);
    const s = t.errorAction, {
      action: a,
      retryCount: l = 0,
      retryConfig: d
    } = s || {};
    if (s && a === ut.RetryRequest && d) {
      this.resetStartWhenNotLoaded(this.levelLastLoaded);
      const h = Vi(d, l);
      this.warn(`Fragment ${n.sn} of ${e} ${n.level} errored with ${t.details}, retrying loading ${l + 1}/${d.maxNumRetry} in ${h}ms`), s.resolved = !0, this.retryDate = self.performance.now() + h, this.state = ee.FRAG_LOADING_WAITING_RETRY;
    } else if (d && s)
      if (this.resetFragmentErrors(e), l < d.maxNumRetry)
        !i && a !== ut.RemoveAlternatePermanently && (s.resolved = !0);
      else {
        V.warn(`${t.details} reached or exceeded max retry (${l})`);
        return;
      }
    else
      (s == null ? void 0 : s.action) === ut.SendAlternateToPenaltyBox ? this.state = ee.WAITING_LEVEL : this.state = ee.ERROR;
    this.tickImmediate();
  }
  reduceLengthAndFlushBuffer(e) {
    if (this.state === ee.PARSING || this.state === ee.PARSED) {
      const t = e.parent, n = this.getFwdBufferInfo(this.mediaBuffer, t), r = n && n.len > 0.5;
      r && this.reduceMaxBufferLength(n.len);
      const i = !r;
      return i && this.warn(`Buffer full error while media.currentTime is not buffered, flush ${t} buffer`), e.frag && (this.fragmentTracker.removeFragment(e.frag), this.nextLoadPosition = e.frag.start), this.resetLoadingState(), i;
    }
    return !1;
  }
  resetFragmentErrors(e) {
    e === be.AUDIO && (this.fragCurrent = null), this.loadedmetadata || (this.startFragRequested = !1), this.state !== ee.STOPPED && (this.state = ee.IDLE);
  }
  afterBufferFlushed(e, t, n) {
    if (!e)
      return;
    const r = He.getBuffered(e);
    this.fragmentTracker.detectEvictedFragments(t, r, n), this.state === ee.ENDED && this.resetLoadingState();
  }
  resetLoadingState() {
    this.log("Reset loading state"), this.fragCurrent = null, this.fragPrevious = null, this.state = ee.IDLE;
  }
  resetStartWhenNotLoaded(e) {
    if (!this.loadedmetadata) {
      this.startFragRequested = !1;
      const t = e ? e.details : null;
      t != null && t.live ? (this.startPosition = -1, this.setStartPosition(t, 0), this.resetLoadingState()) : this.nextLoadPosition = this.startPosition;
    }
  }
  resetWhenMissingContext(e) {
    this.warn(`The loading context changed while buffering fragment ${e.sn} of level ${e.level}. This chunk will not be buffered.`), this.removeUnbufferedFrags(), this.resetStartWhenNotLoaded(this.levelLastLoaded), this.resetLoadingState();
  }
  removeUnbufferedFrags(e = 0) {
    this.fragmentTracker.removeFragmentsInRange(e, 1 / 0, this.playlistType, !1, !0);
  }
  updateLevelTiming(e, t, n, r) {
    var i;
    const s = n.details;
    if (!s) {
      this.warn("level.details undefined");
      return;
    }
    if (!Object.keys(e.elementaryStreams).reduce((l, d) => {
      const h = e.elementaryStreams[d];
      if (h) {
        const u = h.endPTS - h.startPTS;
        if (u <= 0)
          return this.warn(`Could not parse fragment ${e.sn} ${d} duration reliably (${u})`), l || !1;
        const c = r ? 0 : $a(s, e, h.startPTS, h.endPTS, h.startDTS, h.endDTS);
        return this.hls.trigger(I.LEVEL_PTS_UPDATED, {
          details: s,
          level: n,
          drift: c,
          type: d,
          frag: e,
          start: h.startPTS,
          end: h.endPTS
        }), !0;
      }
      return l;
    }, !1) && ((i = this.transmuxer) == null ? void 0 : i.error) === null) {
      const l = new Error(`Found no media in fragment ${e.sn} of level ${e.level} resetting transmuxer to fallback to playlist timing`);
      if (n.fragmentError === 0 && (n.fragmentError++, e.gap = !0, this.fragmentTracker.removeFragment(e), this.fragmentTracker.fragBuffered(e, !0)), this.warn(l.message), this.hls.trigger(I.ERROR, {
        type: xe.MEDIA_ERROR,
        details: q.FRAG_PARSING_ERROR,
        fatal: !1,
        error: l,
        frag: e,
        reason: `Found no media in msn ${e.sn} of level "${n.url}"`
      }), !this.hls)
        return;
      this.resetTransmuxer();
    }
    this.state = ee.PARSED, this.hls.trigger(I.FRAG_PARSED, {
      frag: e,
      part: t
    });
  }
  resetTransmuxer() {
    this.transmuxer && (this.transmuxer.destroy(), this.transmuxer = null);
  }
  recoverWorkerError(e) {
    e.event === "demuxerWorker" && (this.fragmentTracker.removeAllFragments(), this.resetTransmuxer(), this.resetStartWhenNotLoaded(this.levelLastLoaded), this.resetLoadingState());
  }
  set state(e) {
    const t = this._state;
    t !== e && (this._state = e, this.log(`${t}->${e}`));
  }
  get state() {
    return this._state;
  }
}
class Xa {
  constructor() {
    this.chunks = [], this.dataLength = 0;
  }
  push(e) {
    this.chunks.push(e), this.dataLength += e.length;
  }
  flush() {
    const {
      chunks: e,
      dataLength: t
    } = this;
    let n;
    if (e.length)
      e.length === 1 ? n = e[0] : n = Du(e, t);
    else
      return new Uint8Array(0);
    return this.reset(), n;
  }
  reset() {
    this.chunks.length = 0, this.dataLength = 0;
  }
}
function Du(o, e) {
  const t = new Uint8Array(e);
  let n = 0;
  for (let r = 0; r < o.length; r++) {
    const i = o[r];
    t.set(i, n), n += i.length;
  }
  return t;
}
function Ou() {
  return typeof __HLS_WORKER_BUNDLE__ == "function";
}
function Bu() {
  const o = new self.Blob([`var exports={};var module={exports:exports};function define(f){f()};define.amd=true;(${__HLS_WORKER_BUNDLE__.toString()})(true);`], {
    type: "text/javascript"
  }), e = self.URL.createObjectURL(o);
  return {
    worker: new self.Worker(e),
    objectURL: e
  };
}
function Pu(o) {
  const e = new self.URL(o, self.location.href).href;
  return {
    worker: new self.Worker(e),
    scriptURL: e
  };
}
function Nt(o = "", e = 9e4) {
  return {
    type: o,
    id: -1,
    pid: -1,
    inputTimeScale: e,
    sequenceNumber: -1,
    samples: [],
    dropped: 0
  };
}
class qi {
  constructor() {
    this._audioTrack = void 0, this._id3Track = void 0, this.frameIndex = 0, this.cachedData = null, this.basePTS = null, this.initPTS = null, this.lastPTS = null;
  }
  resetInitSegment(e, t, n, r) {
    this._id3Track = {
      type: "id3",
      id: 3,
      pid: -1,
      inputTimeScale: 9e4,
      sequenceNumber: 0,
      samples: [],
      dropped: 0
    };
  }
  resetTimeStamp(e) {
    this.initPTS = e, this.resetContiguity();
  }
  resetContiguity() {
    this.basePTS = null, this.lastPTS = null, this.frameIndex = 0;
  }
  canParse(e, t) {
    return !1;
  }
  appendFrame(e, t, n) {
  }
  // feed incoming data to the front of the parsing pipeline
  demux(e, t) {
    this.cachedData && (e = xt(this.cachedData, e), this.cachedData = null);
    let n = tr(e, 0), r = n ? n.length : 0, i;
    const s = this._audioTrack, a = this._id3Track, l = n ? Ki(n) : void 0, d = e.length;
    for ((this.basePTS === null || this.frameIndex === 0 && ge(l)) && (this.basePTS = Fu(l, t, this.initPTS), this.lastPTS = this.basePTS), this.lastPTS === null && (this.lastPTS = this.basePTS), n && n.length > 0 && a.samples.push({
      pts: this.lastPTS,
      dts: this.lastPTS,
      data: n,
      type: kt.audioId3,
      duration: Number.POSITIVE_INFINITY
    }); r < d; ) {
      if (this.canParse(e, r)) {
        const h = this.appendFrame(s, e, r);
        h ? (this.frameIndex++, this.lastPTS = h.sample.pts, r += h.length, i = r) : r = d;
      } else
        dc(e, r) ? (n = tr(e, r), a.samples.push({
          pts: this.lastPTS,
          dts: this.lastPTS,
          data: n,
          type: kt.audioId3,
          duration: Number.POSITIVE_INFINITY
        }), r += n.length, i = r) : r++;
      if (r === d && i !== d) {
        const h = hn(e, i);
        this.cachedData ? this.cachedData = xt(this.cachedData, h) : this.cachedData = h;
      }
    }
    return {
      audioTrack: s,
      videoTrack: Nt(),
      id3Track: a,
      textTrack: Nt()
    };
  }
  demuxSampleAes(e, t, n) {
    return Promise.reject(new Error(`[${this}] This demuxer does not support Sample-AES decryption`));
  }
  flush(e) {
    const t = this.cachedData;
    return t && (this.cachedData = null, this.demux(t, 0)), {
      audioTrack: this._audioTrack,
      videoTrack: Nt(),
      id3Track: this._id3Track,
      textTrack: Nt()
    };
  }
  destroy() {
  }
}
const Fu = (o, e, t) => {
  if (ge(o))
    return o * 90;
  const n = t ? t.baseTime * 9e4 / t.timescale : 0;
  return e * 9e4 + n;
};
function Mu(o, e, t, n) {
  let r, i, s, a;
  const l = navigator.userAgent.toLowerCase(), d = n, h = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350];
  r = ((e[t + 2] & 192) >>> 6) + 1;
  const u = (e[t + 2] & 60) >>> 2;
  if (u > h.length - 1) {
    o.trigger(I.ERROR, {
      type: xe.MEDIA_ERROR,
      details: q.FRAG_PARSING_ERROR,
      fatal: !0,
      reason: `invalid ADTS sampling index:${u}`
    });
    return;
  }
  return s = (e[t + 2] & 1) << 2, s |= (e[t + 3] & 192) >>> 6, V.log(`manifest codec:${n}, ADTS type:${r}, samplingIndex:${u}`), /firefox/i.test(l) ? u >= 6 ? (r = 5, a = new Array(4), i = u - 3) : (r = 2, a = new Array(2), i = u) : l.indexOf("android") !== -1 ? (r = 2, a = new Array(2), i = u) : (r = 5, a = new Array(4), n && (n.indexOf("mp4a.40.29") !== -1 || n.indexOf("mp4a.40.5") !== -1) || !n && u >= 6 ? i = u - 3 : ((n && n.indexOf("mp4a.40.2") !== -1 && (u >= 6 && s === 1 || /vivaldi/i.test(l)) || !n && s === 1) && (r = 2, a = new Array(2)), i = u)), a[0] = r << 3, a[0] |= (u & 14) >> 1, a[1] |= (u & 1) << 7, a[1] |= s << 3, r === 5 && (a[1] |= (i & 14) >> 1, a[2] = (i & 1) << 7, a[2] |= 8, a[3] = 0), {
    config: a,
    samplerate: h[u],
    channelCount: s,
    codec: "mp4a.40." + r,
    manifestCodec: d
  };
}
function Qa(o, e) {
  return o[e] === 255 && (o[e + 1] & 246) === 240;
}
function Za(o, e) {
  return o[e + 1] & 1 ? 7 : 9;
}
function Xi(o, e) {
  return (o[e + 3] & 3) << 11 | o[e + 4] << 3 | (o[e + 5] & 224) >>> 5;
}
function Uu(o, e) {
  return e + 5 < o.length;
}
function Ur(o, e) {
  return e + 1 < o.length && Qa(o, e);
}
function Nu(o, e) {
  return Uu(o, e) && Qa(o, e) && Xi(o, e) <= o.length - e;
}
function ju(o, e) {
  if (Ur(o, e)) {
    const t = Za(o, e);
    if (e + t >= o.length)
      return !1;
    const n = Xi(o, e);
    if (n <= t)
      return !1;
    const r = e + n;
    return r === o.length || Ur(o, r);
  }
  return !1;
}
function Ja(o, e, t, n, r) {
  if (!o.samplerate) {
    const i = Mu(e, t, n, r);
    if (!i)
      return;
    o.config = i.config, o.samplerate = i.samplerate, o.channelCount = i.channelCount, o.codec = i.codec, o.manifestCodec = i.manifestCodec, V.log(`parsed codec:${o.codec}, rate:${i.samplerate}, channels:${i.channelCount}`);
  }
}
function eo(o) {
  return 1024 * 9e4 / o;
}
function Gu(o, e) {
  const t = Za(o, e);
  if (e + t <= o.length) {
    const n = Xi(o, e) - t;
    if (n > 0)
      return {
        headerLength: t,
        frameLength: n
      };
  }
}
function to(o, e, t, n, r) {
  const i = eo(o.samplerate), s = n + r * i, a = Gu(e, t);
  let l;
  if (a) {
    const {
      frameLength: u,
      headerLength: c
    } = a, m = c + u, f = Math.max(0, t + m - e.length);
    f ? (l = new Uint8Array(m - c), l.set(e.subarray(t + c, e.length), 0)) : l = e.subarray(t + c, t + m);
    const p = {
      unit: l,
      pts: s
    };
    return f || o.samples.push(p), {
      sample: p,
      length: m,
      missing: f
    };
  }
  const d = e.length - t;
  return l = new Uint8Array(d), l.set(e.subarray(t, e.length), 0), {
    sample: {
      unit: l,
      pts: s
    },
    length: d,
    missing: -1
  };
}
let Er = null;
const Ku = [32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160], $u = [44100, 48e3, 32e3, 22050, 24e3, 16e3, 11025, 12e3, 8e3], Vu = [
  // MPEG 2.5
  [
    0,
    // Reserved
    72,
    // Layer3
    144,
    // Layer2
    12
    // Layer1
  ],
  // Reserved
  [
    0,
    // Reserved
    0,
    // Layer3
    0,
    // Layer2
    0
    // Layer1
  ],
  // MPEG 2
  [
    0,
    // Reserved
    72,
    // Layer3
    144,
    // Layer2
    12
    // Layer1
  ],
  // MPEG 1
  [
    0,
    // Reserved
    144,
    // Layer3
    144,
    // Layer2
    12
    // Layer1
  ]
], Wu = [
  0,
  // Reserved
  1,
  // Layer3
  1,
  // Layer2
  4
  // Layer1
];
function no(o, e, t, n, r) {
  if (t + 24 > e.length)
    return;
  const i = ro(e, t);
  if (i && t + i.frameLength <= e.length) {
    const s = i.samplesPerFrame * 9e4 / i.sampleRate, a = n + r * s, l = {
      unit: e.subarray(t, t + i.frameLength),
      pts: a,
      dts: a
    };
    return o.config = [], o.channelCount = i.channelCount, o.samplerate = i.sampleRate, o.samples.push(l), {
      sample: l,
      length: i.frameLength,
      missing: 0
    };
  }
}
function ro(o, e) {
  const t = o[e + 1] >> 3 & 3, n = o[e + 1] >> 1 & 3, r = o[e + 2] >> 4 & 15, i = o[e + 2] >> 2 & 3;
  if (t !== 1 && r !== 0 && r !== 15 && i !== 3) {
    const s = o[e + 2] >> 1 & 1, a = o[e + 3] >> 6, l = t === 3 ? 3 - n : n === 3 ? 3 : 4, d = Ku[l * 14 + r - 1] * 1e3, u = $u[(t === 3 ? 0 : t === 2 ? 1 : 2) * 3 + i], c = a === 3 ? 1 : 2, m = Vu[t][n], f = Wu[n], p = m * 8 * f, A = Math.floor(m * d / u + s) * f;
    if (Er === null) {
      const _ = (navigator.userAgent || "").match(/Chrome\/(\d+)/i);
      Er = _ ? parseInt(_[1]) : 0;
    }
    return !!Er && Er <= 87 && n === 2 && d >= 224e3 && a === 0 && (o[e + 3] = o[e + 3] | 128), {
      sampleRate: u,
      channelCount: c,
      frameLength: A,
      samplesPerFrame: p
    };
  }
}
function Qi(o, e) {
  return o[e] === 255 && (o[e + 1] & 224) === 224 && (o[e + 1] & 6) !== 0;
}
function io(o, e) {
  return e + 1 < o.length && Qi(o, e);
}
function Hu(o, e) {
  return Qi(o, e) && 4 <= o.length - e;
}
function so(o, e) {
  if (e + 1 < o.length && Qi(o, e)) {
    const n = ro(o, e);
    let r = 4;
    n != null && n.frameLength && (r = n.frameLength);
    const i = e + r;
    return i === o.length || io(o, i);
  }
  return !1;
}
class zu extends qi {
  constructor(e, t) {
    super(), this.observer = void 0, this.config = void 0, this.observer = e, this.config = t;
  }
  resetInitSegment(e, t, n, r) {
    super.resetInitSegment(e, t, n, r), this._audioTrack = {
      container: "audio/adts",
      type: "audio",
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: "aac",
      samples: [],
      manifestCodec: t,
      duration: r,
      inputTimeScale: 9e4,
      dropped: 0
    };
  }
  // Source for probe info - https://wiki.multimedia.cx/index.php?title=ADTS
  static probe(e) {
    if (!e)
      return !1;
    const t = tr(e, 0);
    let n = (t == null ? void 0 : t.length) || 0;
    if (so(e, n))
      return !1;
    for (let r = e.length; n < r; n++)
      if (ju(e, n))
        return V.log("ADTS sync word found !"), !0;
    return !1;
  }
  canParse(e, t) {
    return Nu(e, t);
  }
  appendFrame(e, t, n) {
    Ja(e, this.observer, t, n, e.manifestCodec);
    const r = to(e, t, n, this.basePTS, this.frameIndex);
    if (r && r.missing === 0)
      return r;
  }
}
const Yu = /\/emsg[-/]ID3/i;
class qu {
  constructor(e, t) {
    this.remainderData = null, this.timeOffset = 0, this.config = void 0, this.videoTrack = void 0, this.audioTrack = void 0, this.id3Track = void 0, this.txtTrack = void 0, this.config = t;
  }
  resetTimeStamp() {
  }
  resetInitSegment(e, t, n, r) {
    const i = this.videoTrack = Nt("video", 1), s = this.audioTrack = Nt("audio", 1), a = this.txtTrack = Nt("text", 1);
    if (this.id3Track = Nt("id3", 1), this.timeOffset = 0, !(e != null && e.byteLength))
      return;
    const l = Fa(e);
    if (l.video) {
      const {
        id: d,
        timescale: h,
        codec: u
      } = l.video;
      i.id = d, i.timescale = a.timescale = h, i.codec = u;
    }
    if (l.audio) {
      const {
        id: d,
        timescale: h,
        codec: u
      } = l.audio;
      s.id = d, s.timescale = h, s.codec = u;
    }
    a.id = Oa.text, i.sampleDuration = 0, i.duration = s.duration = r;
  }
  resetContiguity() {
    this.remainderData = null;
  }
  static probe(e) {
    return e = e.length > 16384 ? e.subarray(0, 16384) : e, Re(e, ["moof"]).length > 0;
  }
  demux(e, t) {
    this.timeOffset = t;
    let n = e;
    const r = this.videoTrack, i = this.txtTrack;
    if (this.config.progressive) {
      this.remainderData && (n = xt(this.remainderData, e));
      const a = Tc(n);
      this.remainderData = a.remainder, r.samples = a.valid || new Uint8Array();
    } else
      r.samples = n;
    const s = this.extractID3Track(r, t);
    return i.samples = ws(t, r), {
      videoTrack: r,
      audioTrack: this.audioTrack,
      id3Track: s,
      textTrack: this.txtTrack
    };
  }
  flush() {
    const e = this.timeOffset, t = this.videoTrack, n = this.txtTrack;
    t.samples = this.remainderData || new Uint8Array(), this.remainderData = null;
    const r = this.extractID3Track(t, this.timeOffset);
    return n.samples = ws(e, t), {
      videoTrack: t,
      audioTrack: Nt(),
      id3Track: r,
      textTrack: Nt()
    };
  }
  extractID3Track(e, t) {
    const n = this.id3Track;
    if (e.samples.length) {
      const r = Re(e.samples, ["emsg"]);
      r && r.forEach((i) => {
        const s = wc(i);
        if (Yu.test(s.schemeIdUri)) {
          const a = ge(s.presentationTime) ? s.presentationTime / s.timeScale : t + s.presentationTimeDelta / s.timeScale;
          let l = s.eventDuration === 4294967295 ? Number.POSITIVE_INFINITY : s.eventDuration / s.timeScale;
          l <= 1e-3 && (l = Number.POSITIVE_INFINITY);
          const d = s.payload;
          n.samples.push({
            data: d,
            len: d.byteLength,
            dts: a,
            pts: a,
            type: kt.emsg,
            duration: l
          });
        }
      });
    }
    return n;
  }
  demuxSampleAes(e, t, n) {
    return Promise.reject(new Error("The MP4 demuxer does not support SAMPLE-AES decryption"));
  }
  destroy() {
  }
}
const ao = (o, e) => {
  let t = 0, n = 5;
  e += n;
  const r = new Uint32Array(1), i = new Uint32Array(1), s = new Uint8Array(1);
  for (; n > 0; ) {
    s[0] = o[e];
    const a = Math.min(n, 8), l = 8 - a;
    i[0] = 4278190080 >>> 24 + l << l, r[0] = (s[0] & i[0]) >> l, t = t ? t << a | r[0] : r[0], e += 1, n -= a;
  }
  return t;
};
class Xu extends qi {
  constructor(e) {
    super(), this.observer = void 0, this.observer = e;
  }
  resetInitSegment(e, t, n, r) {
    super.resetInitSegment(e, t, n, r), this._audioTrack = {
      container: "audio/ac-3",
      type: "audio",
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: "ac3",
      samples: [],
      manifestCodec: t,
      duration: r,
      inputTimeScale: 9e4,
      dropped: 0
    };
  }
  canParse(e, t) {
    return t + 64 < e.length;
  }
  appendFrame(e, t, n) {
    const r = oo(e, t, n, this.basePTS, this.frameIndex);
    if (r !== -1)
      return {
        sample: e.samples[e.samples.length - 1],
        length: r,
        missing: 0
      };
  }
  static probe(e) {
    if (!e)
      return !1;
    const t = tr(e, 0);
    if (!t)
      return !1;
    const n = t.length;
    return e[n] === 11 && e[n + 1] === 119 && Ki(t) !== void 0 && // check the bsid to confirm ac-3
    ao(e, n) < 16;
  }
}
function oo(o, e, t, n, r) {
  if (t + 8 > e.length || e[t] !== 11 || e[t + 1] !== 119)
    return -1;
  const i = e[t + 4] >> 6;
  if (i >= 3)
    return -1;
  const a = [48e3, 44100, 32e3][i], l = e[t + 4] & 63, h = [64, 69, 96, 64, 70, 96, 80, 87, 120, 80, 88, 120, 96, 104, 144, 96, 105, 144, 112, 121, 168, 112, 122, 168, 128, 139, 192, 128, 140, 192, 160, 174, 240, 160, 175, 240, 192, 208, 288, 192, 209, 288, 224, 243, 336, 224, 244, 336, 256, 278, 384, 256, 279, 384, 320, 348, 480, 320, 349, 480, 384, 417, 576, 384, 418, 576, 448, 487, 672, 448, 488, 672, 512, 557, 768, 512, 558, 768, 640, 696, 960, 640, 697, 960, 768, 835, 1152, 768, 836, 1152, 896, 975, 1344, 896, 976, 1344, 1024, 1114, 1536, 1024, 1115, 1536, 1152, 1253, 1728, 1152, 1254, 1728, 1280, 1393, 1920, 1280, 1394, 1920][l * 3 + i] * 2;
  if (t + h > e.length)
    return -1;
  const u = e[t + 6] >> 5;
  let c = 0;
  u === 2 ? c += 2 : (u & 1 && u !== 1 && (c += 2), u & 4 && (c += 2));
  const m = (e[t + 6] << 8 | e[t + 7]) >> 12 - c & 1, p = [2, 1, 2, 3, 3, 4, 4, 5][u] + m, A = e[t + 5] >> 3, v = e[t + 5] & 7, b = new Uint8Array([i << 6 | A << 1 | v >> 2, (v & 3) << 6 | u << 3 | m << 2 | l >> 4, l << 4 & 224]), _ = 1536 / a * 9e4, T = n + r * _, E = e.subarray(t, t + h);
  return o.config = b, o.channelCount = p, o.samplerate = a, o.samples.push({
    unit: E,
    pts: T
  }), h;
}
class lo {
  constructor() {
    this.VideoSample = null;
  }
  createVideoSample(e, t, n, r) {
    return {
      key: e,
      frame: !1,
      pts: t,
      dts: n,
      units: [],
      debug: r,
      length: 0
    };
  }
  getLastNalUnit(e) {
    var t;
    let n = this.VideoSample, r;
    if ((!n || n.units.length === 0) && (n = e[e.length - 1]), (t = n) != null && t.units) {
      const i = n.units;
      r = i[i.length - 1];
    }
    return r;
  }
  pushAccessUnit(e, t) {
    if (e.units.length && e.frame) {
      if (e.pts === void 0) {
        const n = t.samples, r = n.length;
        if (r) {
          const i = n[r - 1];
          e.pts = i.pts, e.dts = i.dts;
        } else {
          t.dropped++;
          return;
        }
      }
      t.samples.push(e);
    }
    e.debug.length && V.log(e.pts + "/" + e.dts + ":" + e.debug);
  }
}
class er {
  constructor(e) {
    this.data = void 0, this.bytesAvailable = void 0, this.word = void 0, this.bitsAvailable = void 0, this.data = e, this.bytesAvailable = e.byteLength, this.word = 0, this.bitsAvailable = 0;
  }
  // ():void
  loadWord() {
    const e = this.data, t = this.bytesAvailable, n = e.byteLength - t, r = new Uint8Array(4), i = Math.min(4, t);
    if (i === 0)
      throw new Error("no bytes available");
    r.set(e.subarray(n, n + i)), this.word = new DataView(r.buffer).getUint32(0), this.bitsAvailable = i * 8, this.bytesAvailable -= i;
  }
  // (count:int):void
  skipBits(e) {
    let t;
    e = Math.min(e, this.bytesAvailable * 8 + this.bitsAvailable), this.bitsAvailable > e ? (this.word <<= e, this.bitsAvailable -= e) : (e -= this.bitsAvailable, t = e >> 3, e -= t << 3, this.bytesAvailable -= t, this.loadWord(), this.word <<= e, this.bitsAvailable -= e);
  }
  // (size:int):uint
  readBits(e) {
    let t = Math.min(this.bitsAvailable, e);
    const n = this.word >>> 32 - t;
    if (e > 32 && V.error("Cannot read more than 32 bits at a time"), this.bitsAvailable -= t, this.bitsAvailable > 0)
      this.word <<= t;
    else if (this.bytesAvailable > 0)
      this.loadWord();
    else
      throw new Error("no bits available");
    return t = e - t, t > 0 && this.bitsAvailable ? n << t | this.readBits(t) : n;
  }
  // ():uint
  skipLZ() {
    let e;
    for (e = 0; e < this.bitsAvailable; ++e)
      if (this.word & 2147483648 >>> e)
        return this.word <<= e, this.bitsAvailable -= e, e;
    return this.loadWord(), e + this.skipLZ();
  }
  // ():void
  skipUEG() {
    this.skipBits(1 + this.skipLZ());
  }
  // ():void
  skipEG() {
    this.skipBits(1 + this.skipLZ());
  }
  // ():uint
  readUEG() {
    const e = this.skipLZ();
    return this.readBits(e + 1) - 1;
  }
  // ():int
  readEG() {
    const e = this.readUEG();
    return 1 & e ? 1 + e >>> 1 : -1 * (e >>> 1);
  }
  // Some convenience functions
  // :Boolean
  readBoolean() {
    return this.readBits(1) === 1;
  }
  // ():int
  readUByte() {
    return this.readBits(8);
  }
  // ():int
  readUShort() {
    return this.readBits(16);
  }
  // ():int
  readUInt() {
    return this.readBits(32);
  }
  /**
   * Advance the ExpGolomb decoder past a scaling list. The scaling
   * list is optionally transmitted as part of a sequence parameter
   * set and is not relevant to transmuxing.
   * @param count the number of entries in this scaling list
   * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
   */
  skipScalingList(e) {
    let t = 8, n = 8, r;
    for (let i = 0; i < e; i++)
      n !== 0 && (r = this.readEG(), n = (t + r + 256) % 256), t = n === 0 ? t : n;
  }
  /**
   * Read a sequence parameter set and return some interesting video
   * properties. A sequence parameter set is the H264 metadata that
   * describes the properties of upcoming video frames.
   * @returns an object with configuration parsed from the
   * sequence parameter set, including the dimensions of the
   * associated video frames.
   */
  readSPS() {
    let e = 0, t = 0, n = 0, r = 0, i, s, a;
    const l = this.readUByte.bind(this), d = this.readBits.bind(this), h = this.readUEG.bind(this), u = this.readBoolean.bind(this), c = this.skipBits.bind(this), m = this.skipEG.bind(this), f = this.skipUEG.bind(this), p = this.skipScalingList.bind(this);
    l();
    const A = l();
    if (d(5), c(3), l(), f(), A === 100 || A === 110 || A === 122 || A === 244 || A === 44 || A === 83 || A === 86 || A === 118 || A === 128) {
      const L = h();
      if (L === 3 && c(1), f(), f(), c(1), u())
        for (s = L !== 3 ? 8 : 12, a = 0; a < s; a++)
          u() && (a < 6 ? p(16) : p(64));
    }
    f();
    const v = h();
    if (v === 0)
      h();
    else if (v === 1)
      for (c(1), m(), m(), i = h(), a = 0; a < i; a++)
        m();
    f(), c(1);
    const b = h(), _ = h(), T = d(1);
    T === 0 && c(1), c(1), u() && (e = h(), t = h(), n = h(), r = h());
    let E = [1, 1];
    if (u() && u())
      switch (l()) {
        case 1:
          E = [1, 1];
          break;
        case 2:
          E = [12, 11];
          break;
        case 3:
          E = [10, 11];
          break;
        case 4:
          E = [16, 11];
          break;
        case 5:
          E = [40, 33];
          break;
        case 6:
          E = [24, 11];
          break;
        case 7:
          E = [20, 11];
          break;
        case 8:
          E = [32, 11];
          break;
        case 9:
          E = [80, 33];
          break;
        case 10:
          E = [18, 11];
          break;
        case 11:
          E = [15, 11];
          break;
        case 12:
          E = [64, 33];
          break;
        case 13:
          E = [160, 99];
          break;
        case 14:
          E = [4, 3];
          break;
        case 15:
          E = [3, 2];
          break;
        case 16:
          E = [2, 1];
          break;
        case 255: {
          E = [l() << 8 | l(), l() << 8 | l()];
          break;
        }
      }
    return {
      width: Math.ceil((b + 1) * 16 - e * 2 - t * 2),
      height: (2 - T) * (_ + 1) * 16 - (T ? 2 : 4) * (n + r),
      pixelRatio: E
    };
  }
  readSliceType() {
    return this.readUByte(), this.readUEG(), this.readUEG();
  }
  destroy() {
    this.data = null;
  }
}
class Qu extends lo {
  parseAVCPES(e, t, n, r, i) {
    const s = this.parseAVCNALu(e, n.data);
    let a = this.VideoSample, l, d = !1;
    n.data = null, a && s.length && !e.audFound && (this.pushAccessUnit(a, e), a = this.VideoSample = this.createVideoSample(!1, n.pts, n.dts, "")), s.forEach((h) => {
      var u;
      switch (h.type) {
        case 1: {
          let p = !1;
          l = !0;
          const A = h.data;
          if (d && A.length > 4) {
            const v = new er(A).readSliceType();
            (v === 2 || v === 4 || v === 7 || v === 9) && (p = !0);
          }
          if (p) {
            var c;
            (c = a) != null && c.frame && !a.key && (this.pushAccessUnit(a, e), a = this.VideoSample = null);
          }
          a || (a = this.VideoSample = this.createVideoSample(!0, n.pts, n.dts, "")), a.frame = !0, a.key = p;
          break;
        }
        case 5:
          l = !0, (u = a) != null && u.frame && !a.key && (this.pushAccessUnit(a, e), a = this.VideoSample = null), a || (a = this.VideoSample = this.createVideoSample(!0, n.pts, n.dts, "")), a.key = !0, a.frame = !0;
          break;
        case 6: {
          l = !0, $i(h.data, 1, n.pts, t.samples);
          break;
        }
        case 7: {
          var m, f;
          l = !0, d = !0;
          const p = h.data, v = new er(p).readSPS();
          if (!e.sps || e.width !== v.width || e.height !== v.height || ((m = e.pixelRatio) == null ? void 0 : m[0]) !== v.pixelRatio[0] || ((f = e.pixelRatio) == null ? void 0 : f[1]) !== v.pixelRatio[1]) {
            e.width = v.width, e.height = v.height, e.pixelRatio = v.pixelRatio, e.sps = [p], e.duration = i;
            const b = p.subarray(1, 4);
            let _ = "avc1.";
            for (let T = 0; T < 3; T++) {
              let E = b[T].toString(16);
              E.length < 2 && (E = "0" + E), _ += E;
            }
            e.codec = _;
          }
          break;
        }
        case 8:
          l = !0, e.pps = [h.data];
          break;
        case 9:
          l = !0, e.audFound = !0, a && this.pushAccessUnit(a, e), a = this.VideoSample = this.createVideoSample(!1, n.pts, n.dts, "");
          break;
        case 12:
          l = !0;
          break;
        default:
          l = !1, a && (a.debug += "unknown NAL " + h.type + " ");
          break;
      }
      a && l && a.units.push(h);
    }), r && a && (this.pushAccessUnit(a, e), this.VideoSample = null);
  }
  parseAVCNALu(e, t) {
    const n = t.byteLength;
    let r = e.naluState || 0;
    const i = r, s = [];
    let a = 0, l, d, h, u = -1, c = 0;
    for (r === -1 && (u = 0, c = t[0] & 31, r = 0, a = 1); a < n; ) {
      if (l = t[a++], !r) {
        r = l ? 0 : 1;
        continue;
      }
      if (r === 1) {
        r = l ? 0 : 2;
        continue;
      }
      if (!l)
        r = 3;
      else if (l === 1) {
        if (d = a - r - 1, u >= 0) {
          const m = {
            data: t.subarray(u, d),
            type: c
          };
          s.push(m);
        } else {
          const m = this.getLastNalUnit(e.samples);
          m && (i && a <= 4 - i && m.state && (m.data = m.data.subarray(0, m.data.byteLength - i)), d > 0 && (m.data = xt(m.data, t.subarray(0, d)), m.state = 0));
        }
        a < n ? (h = t[a] & 31, u = a, c = h, r = 0) : r = -1;
      } else
        r = 0;
    }
    if (u >= 0 && r >= 0) {
      const m = {
        data: t.subarray(u, n),
        type: c,
        state: r
      };
      s.push(m);
    }
    if (s.length === 0) {
      const m = this.getLastNalUnit(e.samples);
      m && (m.data = xt(m.data, t));
    }
    return e.naluState = r, s;
  }
}
class nn {
  static _ebsp2rbsp(e) {
    const t = e, n = t.byteLength, r = new Uint8Array(n);
    let i = 0;
    for (let s = 0; s < n; s++)
      s >= 2 && t[s] === 3 && t[s - 1] === 0 && t[s - 2] === 0 || (r[i] = t[s], i++);
    return new Uint8Array(r.buffer, 0, i);
  }
  static parseVPS(e) {
    const t = nn._ebsp2rbsp(e), n = new er(t);
    n.readUByte(), n.readUByte(), n.readBits(4), n.readBits(2), n.readBits(6);
    const r = n.readBits(3), i = n.readBoolean();
    return {
      num_temporal_layers: r + 1,
      temporal_id_nested: i
    };
  }
  static parseSPS(e) {
    const t = nn._ebsp2rbsp(e);
    let n = new er(t);
    n.readUByte(), n.readUByte();
    let r = 0, i = 0, s = 0, a = 0;
    n.readBits(4);
    const l = n.readBits(3);
    n.readBoolean();
    const d = n.readBits(2), h = n.readBoolean(), u = n.readBits(5), c = n.readUByte(), m = n.readUByte(), f = n.readUByte(), p = n.readUByte(), A = n.readUByte(), v = n.readUByte(), b = n.readUByte(), _ = n.readUByte(), T = n.readUByte(), E = n.readUByte(), L = n.readUByte(), k = [], D = [];
    for (let Oe = 0; Oe < l; Oe++)
      k.push(n.readBoolean()), D.push(n.readBoolean());
    if (l > 0)
      for (let Oe = l; Oe < 8; Oe++)
        n.readBits(2);
    for (let Oe = 0; Oe < l; Oe++)
      k[Oe] && (n.readUByte(), n.readUByte(), n.readUByte(), n.readUByte(), n.readUByte(), n.readUByte(), n.readUByte(), n.readUByte(), n.readUByte(), n.readUByte(), n.readUByte()), D[Oe] && n.readUByte();
    n.readUEG();
    const M = n.readUEG();
    M == 3 && n.readBits(1);
    const O = n.readUEG(), N = n.readUEG();
    n.readBoolean() && (r += n.readUEG(), i += n.readUEG(), s += n.readUEG(), a += n.readUEG());
    const U = n.readUEG(), G = n.readUEG(), Y = n.readUEG(), z = n.readBoolean();
    for (let Oe = z ? 0 : l; Oe <= l; Oe++)
      n.readUEG(), n.readUEG(), n.readUEG();
    if (n.readUEG(), n.readUEG(), n.readUEG(), n.readUEG(), n.readUEG(), n.readUEG(), n.readBoolean() && n.readBoolean())
      for (let Ke = 0; Ke < 4; Ke++)
        for (let We = 0; We < (Ke === 3 ? 2 : 6); We++)
          if (!n.readBoolean())
            n.readUEG();
          else {
            const et = Math.min(64, 1 << 4 + (Ke << 1));
            Ke > 1 && n.readEG();
            for (let ze = 0; ze < et; ze++)
              n.readEG();
          }
    n.readBoolean(), n.readBoolean(), n.readBoolean() && (n.readUByte(), n.readUEG(), n.readUEG(), n.readBoolean());
    const W = n.readUEG();
    let Z = 0;
    for (let Oe = 0; Oe < W; Oe++) {
      let Ke = !1;
      if (Oe !== 0 && (Ke = n.readBoolean()), Ke) {
        Oe === W && n.readUEG(), n.readBoolean(), n.readUEG();
        let We = 0;
        for (let tt = 0; tt <= Z; tt++) {
          const et = n.readBoolean();
          let ze = !1;
          et || (ze = n.readBoolean()), (et || ze) && We++;
        }
        Z = We;
      } else {
        const We = n.readUEG(), tt = n.readUEG();
        Z = We + tt;
        for (let et = 0; et < We; et++)
          n.readUEG(), n.readBoolean();
        for (let et = 0; et < tt; et++)
          n.readUEG(), n.readBoolean();
      }
    }
    if (n.readBoolean()) {
      const Oe = n.readUEG();
      for (let Ke = 0; Ke < Oe; Ke++) {
        for (let We = 0; We < Y + 4; We++)
          n.readBits(1);
        n.readBits(1);
      }
    }
    let ue = !1, re = 0, me = 1, Be = 1, ye = !1, Le = 1, Pe = 1;
    if (n.readBoolean(), n.readBoolean(), n.readBoolean()) {
      if (n.readBoolean()) {
        const $e = n.readUByte(), gt = [1, 12, 10, 16, 40, 24, 20, 32, 80, 18, 15, 64, 160, 4, 3, 2], pt = [1, 11, 11, 11, 33, 11, 11, 11, 33, 11, 11, 33, 99, 3, 2, 1];
        $e > 0 && $e <= 16 ? (me = gt[$e - 1], Be = pt[$e - 1]) : $e === 255 && (me = n.readBits(16), Be = n.readBits(16));
      }
      if (n.readBoolean() && n.readBoolean(), n.readBoolean() && (n.readBits(3), n.readBoolean(), n.readBoolean() && (n.readUByte(), n.readUByte(), n.readUByte())), n.readBoolean() && (n.readUEG(), n.readUEG()), n.readBoolean(), n.readBoolean(), n.readBoolean(), ue = n.readBoolean(), ue && (n.readUEG(), n.readUEG(), n.readUEG(), n.readUEG()), n.readBoolean() && (Le = n.readBits(32), Pe = n.readBits(32), n.readBoolean() && n.readUEG(), n.readBoolean())) {
        let pt = !1, Lt = !1, Et = !1;
        pt = n.readBoolean(), Lt = n.readBoolean(), (pt || Lt) && (Et = n.readBoolean(), Et && (n.readUByte(), n.readBits(5), n.readBoolean(), n.readBits(5)), n.readBits(4), n.readBits(4), Et && n.readBits(4), n.readBits(5), n.readBits(5), n.readBits(5));
        for (let _t = 0; _t <= l; _t++) {
          const nt = n.readBoolean();
          ye = nt;
          let Ot = !0, Q = 1;
          nt || (Ot = n.readBoolean());
          let ne = !1;
          if (Ot ? n.readUEG() : ne = n.readBoolean(), ne || (Q = n.readUEG() + 1), pt) {
            for (let K = 0; K < Q; K++)
              n.readUEG(), n.readUEG(), Et && (n.readUEG(), n.readUEG());
            n.readBoolean();
          }
          if (Lt) {
            for (let K = 0; K < Q; K++)
              n.readUEG(), n.readUEG(), Et && (n.readUEG(), n.readUEG());
            n.readBoolean();
          }
        }
      }
      n.readBoolean() && (n.readBoolean(), n.readBoolean(), n.readBoolean(), re = n.readUEG(), n.readUEG(), n.readUEG(), n.readUEG(), n.readUEG());
    }
    n.readBoolean();
    const qe = `hvc1.${u}.1.L${L}.B0`, ft = M === 1 || M === 2 ? 2 : 1, De = M === 1 ? 2 : 1, ve = O - (r + i) * ft, Je = N - (s + a) * De;
    let Xe = 1;
    return me !== 1 && Be !== 1 && (Xe = me / Be), n.destroy(), n = null, {
      codec_mimetype: qe,
      level_string: nn.getLevelString(L),
      profile_idc: u,
      bit_depth: U + 8,
      ref_frames: 1,
      // FIXME!!!
      chroma_format: M,
      chroma_format_string: nn.getChromaFormatString(M),
      general_level_idc: L,
      general_profile_space: d,
      general_tier_flag: h,
      general_profile_idc: u,
      general_profile_compatibility_flags_1: c,
      general_profile_compatibility_flags_2: m,
      general_profile_compatibility_flags_3: f,
      general_profile_compatibility_flags_4: p,
      general_constraint_indicator_flags_1: A,
      general_constraint_indicator_flags_2: v,
      general_constraint_indicator_flags_3: b,
      general_constraint_indicator_flags_4: _,
      general_constraint_indicator_flags_5: T,
      general_constraint_indicator_flags_6: E,
      min_spatial_segmentation_idc: re,
      constant_frame_rate: 0,
      chroma_format_idc: M,
      bit_depth_luma_minus8: U,
      bit_depth_chroma_minus8: G,
      frame_rate: {
        fixed: ye,
        fps: Pe / Le,
        fps_den: Le,
        fps_num: Pe
      },
      sar_ratio: {
        width: me,
        height: Be
      },
      codec_size: {
        width: ve,
        height: Je
      },
      present_size: {
        width: ve * Xe,
        height: Je
      }
    };
  }
  static parsePPS(e) {
    const t = nn._ebsp2rbsp(e), n = new er(t);
    n.readUByte(), n.readUByte(), n.readUEG(), n.readUEG(), n.readBoolean(), n.readBoolean(), n.readBits(3), n.readBoolean(), n.readBoolean(), n.readUEG(), n.readUEG(), n.readEG(), n.readBoolean(), n.readBoolean(), n.readBoolean() && n.readUEG(), n.readEG(), n.readEG(), n.readBoolean(), n.readBoolean(), n.readBoolean(), n.readBoolean();
    const i = n.readBoolean(), s = n.readBoolean();
    let a = 1;
    return s && i ? a = 0 : s ? a = 3 : i && (a = 2), {
      parallelismType: a
    };
  }
  static getChromaFormatString(e) {
    switch (e) {
      case 0:
        return "4:0:0";
      case 1:
        return "4:2:0";
      case 2:
        return "4:2:2";
      case 3:
        return "4:4:4";
      default:
        return "Unknown";
    }
  }
  static getProfileString(e) {
    switch (e) {
      case 1:
        return "Main";
      case 2:
        return "Main10";
      case 3:
        return "MainSP";
      case 4:
        return "Rext";
      case 9:
        return "SCC";
      default:
        return "Unknown";
    }
  }
  static getLevelString(e) {
    return (e / 30).toFixed(1);
  }
}
class Zu extends lo {
  parseAVCPES(e, t, n, r, i) {
    const s = this.parseAVCNALu(e, n.data);
    let a = this.VideoSample, l;
    n.data = null, a && s.length && !e.audFound && (this.pushAccessUnit(a, e), a = this.VideoSample = this.createVideoSample(!1, n.pts, n.dts, "")), s.forEach((d) => {
      switch (d.type) {
        case 0:
        case 1: {
          l = !0, a || (a = this.VideoSample = this.createVideoSample(!0, n.pts, n.dts, "")), a.frame = !0;
          break;
        }
        case 19:
        case 20:
        case 21:
          l = !0, a || (a = this.VideoSample = this.createVideoSample(!0, n.pts, n.dts, "")), a.key = !0, a.frame = !0;
          break;
        case 32:
          l = !0, e.vps || (e.vps = [d.data]);
          break;
        case 33:
          if (l = !0, !e.sps) {
            const h = d.data, u = nn.parseSPS(h);
            e.width = u.codec_size.width, e.height = u.codec_size.height, e.pixelRatio = [u.sar_ratio.width, u.sar_ratio.height], e.sps = [h], e.duration = i, e.codec = u.codec_mimetype, e.details = it(it({}, e.details), u);
          }
          break;
        case 34:
          if (l = !0, !e.pps) {
            e.pps = [d.data];
            const h = nn.parsePPS(d.data);
            e.details = it(it({}, e.details), h);
          }
          break;
        case 35:
          l = !1, e.audFound = !0, a && this.pushAccessUnit(a, e), a = this.VideoSample = this.createVideoSample(!1, n.pts, n.dts, "");
          break;
        case 39: {
          l = !0, $i(d.data, 1, n.pts, t.samples);
          break;
        }
        default:
          l = !0;
          break;
      }
      a && l && a.units.push(d);
    }), r && a && (this.pushAccessUnit(a, e), this.VideoSample = null);
  }
  parseAVCNALu(e, t) {
    const n = t.byteLength;
    let r = e.naluState || 0;
    const i = r, s = [];
    let a = 0, l, d, h, u = -1, c = 0;
    for (r === -1 && (u = 0, c = t[0] >> 1 & 63, r = 0, a = 1); a < n; ) {
      if (l = t[a++], !r) {
        r = l ? 0 : 1;
        continue;
      }
      if (r === 1) {
        r = l ? 0 : 2;
        continue;
      }
      if (!l)
        r = 3;
      else if (l === 1) {
        if (d = a - r - 1, u >= 0) {
          const m = {
            data: t.subarray(u, d),
            type: c
          };
          s.push(m);
        } else {
          const m = this.getLastNalUnit(e.samples);
          m && (i && a <= 4 - i && m.state && (m.data = m.data.subarray(0, m.data.byteLength - i)), d > 0 && (m.data = xt(m.data, t.subarray(0, d)), m.state = 0));
        }
        a < n ? (h = t[a] >> 1 & 63, u = a, c = h, r = 0) : r = -1;
      } else
        r = 0;
    }
    if (u >= 0 && r >= 0) {
      const m = {
        data: t.subarray(u, n),
        type: c,
        state: r
      };
      s.push(m);
    }
    if (s.length === 0) {
      const m = this.getLastNalUnit(e.samples);
      m && (m.data = xt(m.data, t));
    }
    return e.naluState = r, s;
  }
}
class Ju {
  constructor(e, t, n) {
    this.keyData = void 0, this.decrypter = void 0, this.keyData = n, this.decrypter = new zi(t, {
      removePKCS7Padding: !1
    });
  }
  decryptBuffer(e) {
    return this.decrypter.decrypt(e, this.keyData.key.buffer, this.keyData.iv.buffer);
  }
  // AAC - encrypt all full 16 bytes blocks starting from offset 16
  decryptAacSample(e, t, n) {
    const r = e[t].unit;
    if (r.length <= 16)
      return;
    const i = r.subarray(16, r.length - r.length % 16), s = i.buffer.slice(i.byteOffset, i.byteOffset + i.length);
    this.decryptBuffer(s).then((a) => {
      const l = new Uint8Array(a);
      r.set(l, 16), this.decrypter.isSync() || this.decryptAacSamples(e, t + 1, n);
    });
  }
  decryptAacSamples(e, t, n) {
    for (; ; t++) {
      if (t >= e.length) {
        n();
        return;
      }
      if (!(e[t].unit.length < 32) && (this.decryptAacSample(e, t, n), !this.decrypter.isSync()))
        return;
    }
  }
  // AVC - encrypt one 16 bytes block out of ten, starting from offset 32
  getAvcEncryptedData(e) {
    const t = Math.floor((e.length - 48) / 160) * 16 + 16, n = new Int8Array(t);
    let r = 0;
    for (let i = 32; i < e.length - 16; i += 160, r += 16)
      n.set(e.subarray(i, i + 16), r);
    return n;
  }
  getAvcDecryptedUnit(e, t) {
    const n = new Uint8Array(t);
    let r = 0;
    for (let i = 32; i < e.length - 16; i += 160, r += 16)
      e.set(n.subarray(r, r + 16), i);
    return e;
  }
  decryptAvcSample(e, t, n, r, i) {
    const s = Ua(i.data), a = this.getAvcEncryptedData(s);
    this.decryptBuffer(a.buffer).then((l) => {
      i.data = this.getAvcDecryptedUnit(s, l), this.decrypter.isSync() || this.decryptAvcSamples(e, t, n + 1, r);
    });
  }
  decryptAvcSamples(e, t, n, r) {
    if (e instanceof Uint8Array)
      throw new Error("Cannot decrypt samples of type Uint8Array");
    for (; ; t++, n = 0) {
      if (t >= e.length) {
        r();
        return;
      }
      const i = e[t].units;
      for (; !(n >= i.length); n++) {
        const s = i[n];
        if (!(s.data.length <= 48 || s.type !== 1 && s.type !== 5) && (this.decryptAvcSample(e, t, n, r, s), !this.decrypter.isSync()))
          return;
      }
    }
  }
}
const ht = 188;
class en {
  constructor(e, t, n) {
    this.observer = void 0, this.config = void 0, this.typeSupported = void 0, this.sampleAes = null, this.pmtParsed = !1, this.audioCodec = void 0, this.videoCodec = void 0, this._duration = 0, this._pmtId = -1, this._videoTrack = void 0, this._audioTrack = void 0, this._id3Track = void 0, this._txtTrack = void 0, this.aacOverFlow = null, this.remainderData = null, this.videoParser = void 0, this.hevcVideoParser = void 0, this.observer = e, this.config = t, this.typeSupported = n, this.videoParser = new Qu(), this.hevcVideoParser = new Zu();
  }
  static probe(e) {
    const t = en.syncOffset(e);
    return t > 0 && V.warn(`MPEG2-TS detected but first sync word found @ offset ${t}`), t !== -1;
  }
  static syncOffset(e) {
    const t = e.length;
    let n = Math.min(ht * 5, e.length - ht) + 1, r = 0;
    for (; r < n; ) {
      let i = !1, s = -1, a = 0;
      for (let l = r; l < t; l += ht)
        if (e[l] === 71) {
          if (a++, s === -1 && (s = l, s !== 0 && (n = Math.min(s + ht * 99, e.length - ht) + 1)), i || (i = Oi(e, l) === 0), i && a > 1 && (s === 0 && a > 2 || l + ht > n))
            return s;
        } else {
          if (a)
            return -1;
          break;
        }
      r++;
    }
    return -1;
  }
  /**
   * Creates a track model internal to demuxer used to drive remuxing input
   */
  static createTrack(e, t) {
    return {
      container: e === "video" || e === "audio" ? "video/mp2t" : void 0,
      type: e,
      id: Oa[e],
      pid: -1,
      segmentVideoCodec: "",
      inputTimeScale: 9e4,
      sequenceNumber: 0,
      samples: [],
      dropped: 0,
      duration: e === "audio" ? t : void 0
    };
  }
  /**
   * Initializes a new init segment on the demuxer/remuxer interface. Needed for discontinuities/track-switches (or at stream start)
   * Resets all internal track instances of the demuxer.
   */
  resetInitSegment(e, t, n, r) {
    this.pmtParsed = !1, this._pmtId = -1, this._videoTrack = en.createTrack("video"), this._audioTrack = en.createTrack("audio", r), this._id3Track = en.createTrack("id3"), this._txtTrack = en.createTrack("text"), this._audioTrack.segmentCodec = "aac", this.aacOverFlow = null, this.remainderData = null, this.audioCodec = t, this.videoCodec = n, this._duration = r;
  }
  resetTimeStamp() {
  }
  resetContiguity() {
    const {
      _audioTrack: e,
      _videoTrack: t,
      _id3Track: n
    } = this;
    e && (e.pesData = null), t && (t.pesData = null), n && (n.pesData = null), this.aacOverFlow = null, this.remainderData = null;
  }
  parseVideoAVCPES(e, t, n, r, i) {
    e.segmentCodec === "avc" && this.videoParser.parseAVCPES(e, t, n, r, i), e.segmentCodec === "hevc" && this.hevcVideoParser.parseAVCPES(e, t, n, r, i);
  }
  demux(e, t, n = !1, r = !1) {
    n || (this.sampleAes = null);
    let i;
    const s = this._videoTrack, a = this._audioTrack, l = this._id3Track, d = this._txtTrack;
    let h = s.pid, u = s.pesData, c = a.pid, m = l.pid, f = a.pesData, p = l.pesData, A = null, v = this.pmtParsed, b = this._pmtId, _ = e.length;
    if (this.remainderData && (e = xt(this.remainderData, e), _ = e.length, this.remainderData = null), _ < ht && !r)
      return this.remainderData = e, {
        audioTrack: a,
        videoTrack: s,
        id3Track: l,
        textTrack: d
      };
    const T = Math.max(0, en.syncOffset(e));
    _ -= (_ - T) % ht, _ < e.byteLength && !r && (this.remainderData = new Uint8Array(e.buffer, _, e.buffer.byteLength - _));
    let E = 0;
    for (let k = T; k < _; k += ht)
      if (e[k] === 71) {
        const D = !!(e[k + 1] & 64), M = Oi(e, k), O = (e[k + 3] & 48) >> 4;
        let N;
        if (O > 1) {
          if (N = k + 5 + e[k + 4], N === k + ht)
            continue;
        } else
          N = k + 4;
        switch (M) {
          case h:
            D && (u && (i = bn(u)) && this.parseVideoAVCPES(s, d, i, !1, this._duration), u = {
              data: [],
              size: 0
            }), u && (u.data.push(e.subarray(N, k + ht)), u.size += k + ht - N);
            break;
          case c:
            if (D) {
              if (f && (i = bn(f)))
                switch (a.segmentCodec) {
                  case "aac":
                    this.parseAACPES(a, i);
                    break;
                  case "mp3":
                    this.parseMPEGPES(a, i);
                    break;
                  case "ac3":
                    this.parseAC3PES(a, i);
                    break;
                }
              f = {
                data: [],
                size: 0
              };
            }
            f && (f.data.push(e.subarray(N, k + ht)), f.size += k + ht - N);
            break;
          case m:
            D && (p && (i = bn(p)) && this.parseID3PES(l, i), p = {
              data: [],
              size: 0
            }), p && (p.data.push(e.subarray(N, k + ht)), p.size += k + ht - N);
            break;
          case 0:
            D && (N += e[N] + 1), b = this._pmtId = eh(e, N);
            break;
          case b: {
            D && (N += e[N] + 1);
            const B = th(e, N, this.typeSupported, n);
            h = B.videoPid, h > 0 && (s.pid = h, s.segmentCodec = B.segmentVideoCodec), c = B.audioPid, c > 0 && (a.pid = c, a.segmentCodec = B.segmentAudioCodec), m = B.id3Pid, m > 0 && (l.pid = m), A !== null && !v && (V.warn(`MPEG-TS PMT found at ${k} after unknown PID '${A}'. Backtracking to sync byte @${T} to parse all TS packets.`), A = null, k = T - 188), v = this.pmtParsed = !0;
            break;
          }
          case 17:
          case 8191:
            break;
          default:
            A = M;
            break;
        }
      } else
        E++;
    if (E > 0) {
      const k = new Error(`Found ${E} TS packet/s that do not start with 0x47`);
      this.observer.emit(I.ERROR, I.ERROR, {
        type: xe.MEDIA_ERROR,
        details: q.FRAG_PARSING_ERROR,
        fatal: !1,
        error: k,
        reason: k.message
      });
    }
    s.pesData = u, a.pesData = f, l.pesData = p;
    const L = {
      audioTrack: a,
      videoTrack: s,
      id3Track: l,
      textTrack: d
    };
    return r && this.extractRemainingSamples(L), L;
  }
  flush() {
    const {
      remainderData: e
    } = this;
    this.remainderData = null;
    let t;
    return e ? t = this.demux(e, -1, !1, !0) : t = {
      videoTrack: this._videoTrack,
      audioTrack: this._audioTrack,
      id3Track: this._id3Track,
      textTrack: this._txtTrack
    }, this.extractRemainingSamples(t), this.sampleAes ? this.decrypt(t, this.sampleAes) : t;
  }
  extractRemainingSamples(e) {
    const {
      audioTrack: t,
      videoTrack: n,
      id3Track: r,
      textTrack: i
    } = e, s = n.pesData, a = t.pesData, l = r.pesData;
    let d;
    if (s && (d = bn(s)) ? (this.videoParser.parseAVCPES(n, i, d, !0, this._duration), n.pesData = null) : n.pesData = s, a && (d = bn(a))) {
      switch (t.segmentCodec) {
        case "aac":
          this.parseAACPES(t, d);
          break;
        case "mp3":
          this.parseMPEGPES(t, d);
          break;
        case "ac3":
          this.parseAC3PES(t, d);
          break;
      }
      t.pesData = null;
    } else
      a != null && a.size && V.log("last AAC PES packet truncated,might overlap between fragments"), t.pesData = a;
    l && (d = bn(l)) ? (this.parseID3PES(r, d), r.pesData = null) : r.pesData = l;
  }
  demuxSampleAes(e, t, n) {
    const r = this.demux(e, n, !0, !this.config.progressive), i = this.sampleAes = new Ju(this.observer, this.config, t);
    return this.decrypt(r, i);
  }
  decrypt(e, t) {
    return new Promise((n) => {
      const {
        audioTrack: r,
        videoTrack: i
      } = e;
      r.samples && r.segmentCodec === "aac" ? t.decryptAacSamples(r.samples, 0, () => {
        i.samples ? t.decryptAvcSamples(i.samples, 0, 0, () => {
          n(e);
        }) : n(e);
      }) : i.samples && t.decryptAvcSamples(i.samples, 0, 0, () => {
        n(e);
      });
    });
  }
  destroy() {
    this._duration = 0;
  }
  parseAACPES(e, t) {
    let n = 0;
    const r = this.aacOverFlow;
    let i = t.data;
    if (r) {
      this.aacOverFlow = null;
      const u = r.missing, c = r.sample.unit.byteLength;
      if (u === -1)
        i = xt(r.sample.unit, i);
      else {
        const m = c - u;
        r.sample.unit.set(i.subarray(0, u), m), e.samples.push(r.sample), n = r.missing;
      }
    }
    let s, a;
    for (s = n, a = i.length; s < a - 1 && !Ur(i, s); s++)
      ;
    if (s !== n) {
      let u;
      const c = s < a - 1;
      c ? u = `AAC PES did not start with ADTS header,offset:${s}` : u = "No ADTS header found in AAC PES";
      const m = new Error(u);
      if (V.warn(`parsing error: ${u}`), this.observer.emit(I.ERROR, I.ERROR, {
        type: xe.MEDIA_ERROR,
        details: q.FRAG_PARSING_ERROR,
        fatal: !1,
        levelRetry: c,
        error: m,
        reason: u
      }), !c)
        return;
    }
    Ja(e, this.observer, i, s, this.audioCodec);
    let l;
    if (t.pts !== void 0)
      l = t.pts;
    else if (r) {
      const u = eo(e.samplerate);
      l = r.sample.pts + u;
    } else {
      V.warn("[tsdemuxer]: AAC PES unknown PTS");
      return;
    }
    let d = 0, h;
    for (; s < a; )
      if (h = to(e, i, s, l, d), s += h.length, h.missing) {
        this.aacOverFlow = h;
        break;
      } else
        for (d++; s < a - 1 && !Ur(i, s); s++)
          ;
  }
  parseMPEGPES(e, t) {
    const n = t.data, r = n.length;
    let i = 0, s = 0;
    const a = t.pts;
    if (a === void 0) {
      V.warn("[tsdemuxer]: MPEG PES unknown PTS");
      return;
    }
    for (; s < r; )
      if (io(n, s)) {
        const l = no(e, n, s, a, i);
        if (l)
          s += l.length, i++;
        else
          break;
      } else
        s++;
  }
  parseAC3PES(e, t) {
    {
      const n = t.data, r = t.pts;
      if (r === void 0) {
        V.warn("[tsdemuxer]: AC3 PES unknown PTS");
        return;
      }
      const i = n.length;
      let s = 0, a = 0, l;
      for (; a < i && (l = oo(e, n, a, r, s++)) > 0; )
        a += l;
    }
  }
  parseID3PES(e, t) {
    if (t.pts === void 0) {
      V.warn("[tsdemuxer]: ID3 PES unknown PTS");
      return;
    }
    const n = lt({}, t, {
      type: this._videoTrack ? kt.emsg : kt.audioId3,
      duration: Number.POSITIVE_INFINITY
    });
    e.samples.push(n);
  }
}
function Oi(o, e) {
  return ((o[e + 1] & 31) << 8) + o[e + 2];
}
function eh(o, e) {
  return (o[e + 10] & 31) << 8 | o[e + 11];
}
function th(o, e, t, n) {
  const r = {
    audioPid: -1,
    videoPid: -1,
    id3Pid: -1,
    segmentVideoCodec: "avc",
    segmentAudioCodec: "aac"
  }, i = (o[e + 1] & 15) << 8 | o[e + 2], s = e + 3 + i - 4, a = (o[e + 10] & 15) << 8 | o[e + 11];
  for (e += 12 + a; e < s; ) {
    const l = Oi(o, e), d = (o[e + 3] & 15) << 8 | o[e + 4];
    switch (o[e]) {
      case 207:
        if (!n) {
          di("ADTS AAC");
          break;
        }
      case 15:
        r.audioPid === -1 && (r.audioPid = l);
        break;
      case 21:
        r.id3Pid === -1 && (r.id3Pid = l);
        break;
      case 219:
        if (!n) {
          di("H.264");
          break;
        }
      case 27:
        r.videoPid === -1 && (r.videoPid = l, r.segmentVideoCodec = "avc");
        break;
      case 3:
      case 4:
        !t.mpeg && !t.mp3 ? V.log("MPEG audio found, not supported in this browser") : r.audioPid === -1 && (r.audioPid = l, r.segmentAudioCodec = "mp3");
        break;
      case 193:
        if (!n) {
          di("AC-3");
          break;
        }
      case 129:
        t.ac3 ? r.audioPid === -1 && (r.audioPid = l, r.segmentAudioCodec = "ac3") : V.log("AC-3 audio found, not supported in this browser");
        break;
      case 6:
        if (r.audioPid === -1 && d > 0) {
          let h = e + 5, u = d;
          for (; u > 2; ) {
            switch (o[h]) {
              case 106:
                t.ac3 !== !0 ? V.log("AC-3 audio found, not supported in this browser for now") : (r.audioPid = l, r.segmentAudioCodec = "ac3");
                break;
            }
            const m = o[h + 1] + 2;
            h += m, u -= m;
          }
        }
        break;
      case 194:
      case 135:
        V.warn("Unsupported EC-3 in M2TS found");
        break;
      case 36:
        r.videoPid === -1 && (r.videoPid = l, r.segmentVideoCodec = "hevc");
        break;
    }
    e += d + 5;
  }
  return r;
}
function di(o) {
  V.log(`${o} with AES-128-CBC encryption found in unencrypted stream`);
}
function bn(o) {
  let e = 0, t, n, r, i, s;
  const a = o.data;
  if (!o || o.size === 0)
    return null;
  for (; a[0].length < 19 && a.length > 1; )
    a[0] = xt(a[0], a[1]), a.splice(1, 1);
  if (t = a[0], (t[0] << 16) + (t[1] << 8) + t[2] === 1) {
    if (n = (t[4] << 8) + t[5], n && n > o.size - 6)
      return null;
    const d = t[7];
    d & 192 && (i = (t[9] & 14) * 536870912 + // 1 << 29
    (t[10] & 255) * 4194304 + // 1 << 22
    (t[11] & 254) * 16384 + // 1 << 14
    (t[12] & 255) * 128 + // 1 << 7
    (t[13] & 254) / 2, d & 64 ? (s = (t[14] & 14) * 536870912 + // 1 << 29
    (t[15] & 255) * 4194304 + // 1 << 22
    (t[16] & 254) * 16384 + // 1 << 14
    (t[17] & 255) * 128 + // 1 << 7
    (t[18] & 254) / 2, i - s > 60 * 9e4 && (V.warn(`${Math.round((i - s) / 9e4)}s delta between PTS and DTS, align them`), i = s)) : s = i), r = t[8];
    let h = r + 9;
    if (o.size <= h)
      return null;
    o.size -= h;
    const u = new Uint8Array(o.size);
    for (let c = 0, m = a.length; c < m; c++) {
      t = a[c];
      let f = t.byteLength;
      if (h)
        if (h > f) {
          h -= f;
          continue;
        } else
          t = t.subarray(h), f -= h, h = 0;
      u.set(t, e), e += f;
    }
    return n && (n -= r + 3), {
      data: u,
      pts: i,
      dts: s,
      len: n
    };
  }
  return null;
}
class nh extends qi {
  resetInitSegment(e, t, n, r) {
    super.resetInitSegment(e, t, n, r), this._audioTrack = {
      container: "audio/mpeg",
      type: "audio",
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: "mp3",
      samples: [],
      manifestCodec: t,
      duration: r,
      inputTimeScale: 9e4,
      dropped: 0
    };
  }
  static probe(e) {
    if (!e)
      return !1;
    const t = tr(e, 0);
    let n = (t == null ? void 0 : t.length) || 0;
    if (t && e[n] === 11 && e[n + 1] === 119 && Ki(t) !== void 0 && // check the bsid to confirm ac-3 or ec-3 (not mp3)
    ao(e, n) <= 16)
      return !1;
    for (let r = e.length; n < r; n++)
      if (so(e, n))
        return V.log("MPEG Audio sync word found !"), !0;
    return !1;
  }
  canParse(e, t) {
    return Hu(e, t);
  }
  appendFrame(e, t, n) {
    if (this.basePTS !== null)
      return no(e, t, n, this.basePTS, this.frameIndex);
  }
}
class Qs {
  static getSilentFrame(e, t) {
    switch (e) {
      case "mp4a.40.2":
        if (t === 1)
          return new Uint8Array([0, 200, 0, 128, 35, 128]);
        if (t === 2)
          return new Uint8Array([33, 0, 73, 144, 2, 25, 0, 35, 128]);
        if (t === 3)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 142]);
        if (t === 4)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 128, 44, 128, 8, 2, 56]);
        if (t === 5)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 56]);
        if (t === 6)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 0, 178, 0, 32, 8, 224]);
        break;
      default:
        if (t === 1)
          return new Uint8Array([1, 64, 34, 128, 163, 78, 230, 128, 186, 8, 0, 0, 0, 28, 6, 241, 193, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
        if (t === 2)
          return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
        if (t === 3)
          return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
        break;
    }
  }
}
class rh {
  // sps, pps: require Nalu without 4 byte length-header
  constructor(e, t, n, r) {
    this.data = void 0;
    const i = 23 + (3 + 2 + e.byteLength) + (3 + 2 + t.byteLength) + (3 + 2 + n.byteLength), s = this.data = new Uint8Array(i);
    s[0] = 1, s[1] = (r.general_profile_space & 3) << 6 | (r.general_tier_flag ? 1 : 0) << 5 | r.general_profile_idc & 31, s[2] = r.general_profile_compatibility_flags_1, s[3] = r.general_profile_compatibility_flags_2, s[4] = r.general_profile_compatibility_flags_3, s[5] = r.general_profile_compatibility_flags_4, s[6] = r.general_constraint_indicator_flags_1, s[7] = r.general_constraint_indicator_flags_2, s[8] = r.general_constraint_indicator_flags_3, s[9] = r.general_constraint_indicator_flags_4, s[10] = r.general_constraint_indicator_flags_5, s[11] = r.general_constraint_indicator_flags_6, s[12] = r.general_level_idc, s[13] = 240 | (r.min_spatial_segmentation_idc & 3840) >> 8, s[14] = r.min_spatial_segmentation_idc & 255, s[15] = 252 | r.parallelismType & 3, s[16] = 252 | r.chroma_format_idc & 3, s[17] = 248 | r.bit_depth_luma_minus8 & 7, s[18] = 248 | r.bit_depth_chroma_minus8 & 7, s[19] = 0, s[20] = 0, s[21] = (r.constant_frame_rate & 3) << 6 | (r.num_temporal_layers & 7) << 3 | (r.temporal_id_nested ? 1 : 0) << 2 | 3, s[22] = 3, s[23 + 0 + 0] = 160, s[23 + 0 + 1] = 0, s[23 + 0 + 2] = 1, s[23 + 0 + 3] = (e.byteLength & 65280) >> 8, s[23 + 0 + 4] = (e.byteLength & 255) >> 0, s.set(e, 23 + 0 + 5), s[23 + (5 + e.byteLength) + 0] = 161, s[23 + (5 + e.byteLength) + 1] = 0, s[23 + (5 + e.byteLength) + 2] = 1, s[23 + (5 + e.byteLength) + 3] = (t.byteLength & 65280) >> 8, s[23 + (5 + e.byteLength) + 4] = (t.byteLength & 255) >> 0, s.set(t, 23 + (5 + e.byteLength) + 5), s[23 + (5 + e.byteLength + 5 + t.byteLength) + 0] = 162, s[23 + (5 + e.byteLength + 5 + t.byteLength) + 1] = 0, s[23 + (5 + e.byteLength + 5 + t.byteLength) + 2] = 1, s[23 + (5 + e.byteLength + 5 + t.byteLength) + 3] = (n.byteLength & 65280) >> 8, s[23 + (5 + e.byteLength + 5 + t.byteLength) + 4] = (n.byteLength & 255) >> 0, s.set(n, 23 + (5 + e.byteLength + 5 + t.byteLength) + 5);
  }
  getData() {
    return this.data;
  }
}
const Jt = Math.pow(2, 32) - 1;
class $ {
  static init() {
    $.types = {
      avc1: [],
      // codingname
      avcC: [],
      hvc1: [],
      hvcC: [],
      av01: [],
      av1C: [],
      btrt: [],
      dinf: [],
      dref: [],
      esds: [],
      ftyp: [],
      hdlr: [],
      mdat: [],
      mdhd: [],
      mdia: [],
      mfhd: [],
      minf: [],
      moof: [],
      moov: [],
      mp4a: [],
      ".mp3": [],
      dac3: [],
      "ac-3": [],
      mvex: [],
      mvhd: [],
      pasp: [],
      sdtp: [],
      stbl: [],
      stco: [],
      stsc: [],
      stsd: [],
      stsz: [],
      stts: [],
      tfdt: [],
      tfhd: [],
      traf: [],
      trak: [],
      trun: [],
      trex: [],
      tkhd: [],
      vmhd: [],
      smhd: []
    };
    let e;
    for (e in $.types)
      $.types.hasOwnProperty(e) && ($.types[e] = [e.charCodeAt(0), e.charCodeAt(1), e.charCodeAt(2), e.charCodeAt(3)]);
    const t = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      // pre_defined
      118,
      105,
      100,
      101,
      // handler_type: 'vide'
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      86,
      105,
      100,
      101,
      111,
      72,
      97,
      110,
      100,
      108,
      101,
      114,
      0
      // name: 'VideoHandler'
    ]), n = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      // pre_defined
      115,
      111,
      117,
      110,
      // handler_type: 'soun'
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      83,
      111,
      117,
      110,
      100,
      72,
      97,
      110,
      100,
      108,
      101,
      114,
      0
      // name: 'SoundHandler'
    ]);
    $.HDLR_TYPES = {
      video: t,
      audio: n
    };
    const r = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      1,
      // entry_count
      0,
      0,
      0,
      12,
      // entry_size
      117,
      114,
      108,
      32,
      // 'url' type
      0,
      // version 0
      0,
      0,
      1
      // entry_flags
    ]), i = new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0
      // entry_count
    ]);
    $.STTS = $.STSC = $.STCO = i, $.STSZ = new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      // sample_size
      0,
      0,
      0,
      0
      // sample_count
    ]), $.VMHD = new Uint8Array([
      0,
      // version
      0,
      0,
      1,
      // flags
      0,
      0,
      // graphicsmode
      0,
      0,
      0,
      0,
      0,
      0
      // opcolor
    ]), $.SMHD = new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      0,
      0,
      // balance
      0,
      0
      // reserved
    ]), $.STSD = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      1
    ]);
    const s = new Uint8Array([105, 115, 111, 109]), a = new Uint8Array([97, 118, 99, 49]), l = new Uint8Array([0, 0, 0, 1]);
    $.FTYP = $.box($.types.ftyp, s, l, s, a), $.DINF = $.box($.types.dinf, $.box($.types.dref, r));
  }
  static box(e, ...t) {
    let n = 8, r = t.length;
    const i = r;
    for (; r--; )
      n += t[r].byteLength;
    const s = new Uint8Array(n);
    for (s[0] = n >> 24 & 255, s[1] = n >> 16 & 255, s[2] = n >> 8 & 255, s[3] = n & 255, s.set(e, 4), r = 0, n = 8; r < i; r++)
      s.set(t[r], n), n += t[r].byteLength;
    return s;
  }
  static hdlr(e) {
    return $.box($.types.hdlr, $.HDLR_TYPES[e]);
  }
  static mdat(e) {
    return $.box($.types.mdat, e);
  }
  static mdhd(e, t) {
    t *= e;
    const n = Math.floor(t / (Jt + 1)), r = Math.floor(t % (Jt + 1));
    return $.box($.types.mdhd, new Uint8Array([
      1,
      // version 1
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      // modification_time
      e >> 24 & 255,
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255,
      // timescale
      n >> 24,
      n >> 16 & 255,
      n >> 8 & 255,
      n & 255,
      r >> 24,
      r >> 16 & 255,
      r >> 8 & 255,
      r & 255,
      85,
      196,
      // 'und' language (undetermined)
      0,
      0
    ]));
  }
  static mdia(e) {
    return $.box($.types.mdia, $.mdhd(e.timescale, e.duration), $.hdlr(e.type), $.minf(e));
  }
  static mfhd(e) {
    return $.box($.types.mfhd, new Uint8Array([
      0,
      0,
      0,
      0,
      // flags
      e >> 24,
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255
      // sequence_number
    ]));
  }
  static minf(e) {
    return e.type === "audio" ? $.box($.types.minf, $.box($.types.smhd, $.SMHD), $.DINF, $.stbl(e)) : $.box($.types.minf, $.box($.types.vmhd, $.VMHD), $.DINF, $.stbl(e));
  }
  static moof(e, t, n) {
    return $.box($.types.moof, $.mfhd(e), $.traf(n, t));
  }
  static moov(e) {
    let t = e.length;
    const n = [];
    for (; t--; )
      n[t] = $.trak(e[t]);
    return $.box.apply(null, [$.types.moov, $.mvhd(e[0].timescale, e[0].duration)].concat(n).concat($.mvex(e)));
  }
  static mvex(e) {
    let t = e.length;
    const n = [];
    for (; t--; )
      n[t] = $.trex(e[t]);
    return $.box.apply(null, [$.types.mvex, ...n]);
  }
  static mvhd(e, t) {
    t *= e;
    const n = Math.floor(t / (Jt + 1)), r = Math.floor(t % (Jt + 1)), i = new Uint8Array([
      1,
      // version 1
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      // modification_time
      e >> 24 & 255,
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255,
      // timescale
      n >> 24,
      n >> 16 & 255,
      n >> 8 & 255,
      n & 255,
      r >> 24,
      r >> 16 & 255,
      r >> 8 & 255,
      r & 255,
      0,
      1,
      0,
      0,
      // 1.0 rate
      1,
      0,
      // 1.0 volume
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // pre_defined
      255,
      255,
      255,
      255
      // next_track_ID
    ]);
    return $.box($.types.mvhd, i);
  }
  static sdtp(e) {
    const t = e.samples || [], n = new Uint8Array(4 + t.length);
    let r, i;
    for (r = 0; r < t.length; r++)
      i = t[r].flags, n[r + 4] = i.dependsOn << 4 | i.isDependedOn << 2 | i.hasRedundancy;
    return $.box($.types.sdtp, n);
  }
  static stbl(e) {
    return $.box($.types.stbl, $.stsd(e), $.box($.types.stts, $.STTS), $.box($.types.stsc, $.STSC), $.box($.types.stsz, $.STSZ), $.box($.types.stco, $.STCO));
  }
  static avc1(e) {
    let t = [], n = [], r, i, s;
    for (r = 0; r < e.sps.length; r++)
      i = e.sps[r], s = i.byteLength, t.push(s >>> 8 & 255), t.push(s & 255), t = t.concat(Array.prototype.slice.call(i));
    for (r = 0; r < e.pps.length; r++)
      i = e.pps[r], s = i.byteLength, n.push(s >>> 8 & 255), n.push(s & 255), n = n.concat(Array.prototype.slice.call(i));
    const a = $.box($.types.avcC, new Uint8Array([
      1,
      // version
      t[3],
      // profile
      t[4],
      // profile compat
      t[5],
      // level
      255,
      // lengthSizeMinusOne, hard-coded to 4 bytes
      224 | e.sps.length
      // 3bit reserved (111) + numOfSequenceParameterSets
    ].concat(t).concat([
      e.pps.length
      // numOfPictureParameterSets
    ]).concat(n))), l = e.width, d = e.height, h = e.pixelRatio[0], u = e.pixelRatio[1];
    return $.box(
      $.types.avc1,
      new Uint8Array([
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        // reserved
        0,
        1,
        // data_reference_index
        0,
        0,
        // pre_defined
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // pre_defined
        l >> 8 & 255,
        l & 255,
        // width
        d >> 8 & 255,
        d & 255,
        // height
        0,
        72,
        0,
        0,
        // horizresolution
        0,
        72,
        0,
        0,
        // vertresolution
        0,
        0,
        0,
        0,
        // reserved
        0,
        1,
        // frame_count
        18,
        100,
        97,
        105,
        108,
        // dailymotion/hls.js
        121,
        109,
        111,
        116,
        105,
        111,
        110,
        47,
        104,
        108,
        115,
        46,
        106,
        115,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // compressorname
        0,
        24,
        // depth = 24
        17,
        17
      ]),
      // pre_defined = -1
      a,
      $.box($.types.btrt, new Uint8Array([
        0,
        28,
        156,
        128,
        // bufferSizeDB
        0,
        45,
        198,
        192,
        // maxBitrate
        0,
        45,
        198,
        192
      ])),
      // avgBitrate
      $.box($.types.pasp, new Uint8Array([
        h >> 24,
        // hSpacing
        h >> 16 & 255,
        h >> 8 & 255,
        h & 255,
        u >> 24,
        // vSpacing
        u >> 16 & 255,
        u >> 8 & 255,
        u & 255
      ]))
    );
  }
  static hvc1(e) {
    let t = new Uint8Array(), n = new Uint8Array(), r = new Uint8Array(), i, s;
    const a = e.width, l = e.height, d = new Uint8Array([
      0,
      0,
      0,
      0,
      // reserved(4)
      0,
      0,
      0,
      1,
      // reserved(2) + data_reference_index(2)
      0,
      0,
      0,
      0,
      // pre_defined(2) + reserved(2)
      0,
      0,
      0,
      0,
      // pre_defined: 3 * 4 bytes
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      a >>> 8 & 255,
      // width: 2 bytes
      a & 255,
      l >>> 8 & 255,
      // height: 2 bytes
      l & 255,
      0,
      72,
      0,
      0,
      // horizresolution: 4 bytes
      0,
      72,
      0,
      0,
      // vertresolution: 4 bytes
      0,
      0,
      0,
      0,
      // reserved: 4 bytes
      0,
      1,
      // frame_count
      10,
      // strlen
      120,
      113,
      113,
      47,
      // compressorname: 32 bytes
      102,
      108,
      118,
      46,
      106,
      115,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      24,
      // depth
      255,
      255
      // pre_defined = -1
    ]);
    for (i = 0; i < e.vps.length; i++) {
      s = e.vps[i];
      const u = new Uint8Array(t.length + s.length);
      u.set(t), u.set(s, t.length), t = u;
    }
    for (i = 0; i < e.sps.length; i++) {
      s = e.sps[i];
      const u = new Uint8Array(n.length + s.length);
      u.set(n), u.set(s, n.length), n = u;
    }
    for (i = 0; i < e.pps.length; i++) {
      s = e.pps[i];
      const u = new Uint8Array(r.length + s.length);
      u.set(r), u.set(s, r.length), r = u;
    }
    const h = new rh(t, n, r, e.details);
    return $.box($.types.hvc1, d, $.box($.types.hvcC, h.getData()));
  }
  static esds(e) {
    const t = e.config.length;
    return new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      3,
      // descriptor_type
      23 + t,
      // length
      0,
      1,
      // es_id
      0,
      // stream_priority
      4,
      // descriptor_type
      15 + t,
      // length
      64,
      // codec : mpeg4_audio
      21,
      // stream_type
      0,
      0,
      0,
      // buffer_size
      0,
      0,
      0,
      0,
      // maxBitrate
      0,
      0,
      0,
      0,
      // avgBitrate
      5
      // descriptor_type
    ].concat([t]).concat(e.config).concat([6, 1, 2]));
  }
  static audioStsd(e) {
    const t = e.samplerate;
    return new Uint8Array([
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      // reserved
      0,
      1,
      // data_reference_index
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // reserved
      0,
      e.channelCount,
      // channelcount
      0,
      16,
      // sampleSize:16bits
      0,
      0,
      0,
      0,
      // reserved2
      t >> 8 & 255,
      t & 255,
      //
      0,
      0
    ]);
  }
  static mp4a(e) {
    return $.box($.types.mp4a, $.audioStsd(e), $.box($.types.esds, $.esds(e)));
  }
  static mp3(e) {
    return $.box($.types[".mp3"], $.audioStsd(e));
  }
  static ac3(e) {
    return $.box($.types["ac-3"], $.audioStsd(e), $.box($.types.dac3, e.config));
  }
  static stsd(e) {
    return e.type === "audio" ? e.segmentCodec === "mp3" && e.codec === "mp3" ? $.box($.types.stsd, $.STSD, $.mp3(e)) : e.segmentCodec === "ac3" ? $.box($.types.stsd, $.STSD, $.ac3(e)) : $.box($.types.stsd, $.STSD, $.mp4a(e)) : e.type === "video" && e.codec.startsWith("hvc1") ? $.box($.types.stsd, $.STSD, $.hvc1(e)) : $.box($.types.stsd, $.STSD, $.avc1(e));
  }
  static tkhd(e) {
    const t = e.id, n = e.duration * e.timescale, r = e.width, i = e.height, s = Math.floor(n / (Jt + 1)), a = Math.floor(n % (Jt + 1));
    return $.box($.types.tkhd, new Uint8Array([
      1,
      // version 1
      0,
      0,
      7,
      // flags
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      // modification_time
      t >> 24 & 255,
      t >> 16 & 255,
      t >> 8 & 255,
      t & 255,
      // track_ID
      0,
      0,
      0,
      0,
      // reserved
      s >> 24,
      s >> 16 & 255,
      s >> 8 & 255,
      s & 255,
      a >> 24,
      a >> 16 & 255,
      a >> 8 & 255,
      a & 255,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      // layer
      0,
      0,
      // alternate_group
      0,
      0,
      // non-audio track volume
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      r >> 8 & 255,
      r & 255,
      0,
      0,
      // width
      i >> 8 & 255,
      i & 255,
      0,
      0
      // height
    ]));
  }
  static traf(e, t) {
    const n = $.sdtp(e), r = e.id, i = Math.floor(t / (Jt + 1)), s = Math.floor(t % (Jt + 1));
    return $.box(
      $.types.traf,
      $.box($.types.tfhd, new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        r >> 24,
        r >> 16 & 255,
        r >> 8 & 255,
        r & 255
        // track_ID
      ])),
      $.box($.types.tfdt, new Uint8Array([
        1,
        // version 1
        0,
        0,
        0,
        // flags
        i >> 24,
        i >> 16 & 255,
        i >> 8 & 255,
        i & 255,
        s >> 24,
        s >> 16 & 255,
        s >> 8 & 255,
        s & 255
      ])),
      $.trun(e, n.length + 16 + // tfhd
      20 + // tfdt
      8 + // traf header
      16 + // mfhd
      8 + // moof header
      8),
      // mdat header
      n
    );
  }
  /**
   * Generate a track box.
   * @param track a track definition
   */
  static trak(e) {
    return e.duration = e.duration || 4294967295, $.box($.types.trak, $.tkhd(e), $.mdia(e));
  }
  static trex(e) {
    const t = e.id;
    return $.box($.types.trex, new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      t >> 24,
      t >> 16 & 255,
      t >> 8 & 255,
      t & 255,
      // track_ID
      0,
      0,
      0,
      1,
      // default_sample_description_index
      0,
      0,
      0,
      0,
      // default_sample_duration
      0,
      0,
      0,
      0,
      // default_sample_size
      0,
      1,
      0,
      1
      // default_sample_flags
    ]));
  }
  static trun(e, t) {
    const n = e.samples || [], r = n.length, i = 12 + 16 * r, s = new Uint8Array(i);
    let a, l, d, h, u, c;
    for (t += 8 + i, s.set([
      e.type === "video" ? 1 : 0,
      // version 1 for video with signed-int sample_composition_time_offset
      0,
      15,
      1,
      // flags
      r >>> 24 & 255,
      r >>> 16 & 255,
      r >>> 8 & 255,
      r & 255,
      // sample_count
      t >>> 24 & 255,
      t >>> 16 & 255,
      t >>> 8 & 255,
      t & 255
      // data_offset
    ], 0), a = 0; a < r; a++)
      l = n[a], d = l.duration, h = l.size, u = l.flags, c = l.cts, s.set([
        d >>> 24 & 255,
        d >>> 16 & 255,
        d >>> 8 & 255,
        d & 255,
        // sample_duration
        h >>> 24 & 255,
        h >>> 16 & 255,
        h >>> 8 & 255,
        h & 255,
        // sample_size
        u.isLeading << 2 | u.dependsOn,
        u.isDependedOn << 6 | u.hasRedundancy << 4 | u.paddingValue << 1 | u.isNonSync,
        u.degradPrio & 61440,
        u.degradPrio & 15,
        // sample_flags
        c >>> 24 & 255,
        c >>> 16 & 255,
        c >>> 8 & 255,
        c & 255
        // sample_composition_time_offset
      ], 12 + 16 * a);
    return $.box($.types.trun, s);
  }
  static initSegment(e) {
    $.types || $.init();
    const t = $.moov(e);
    return xt($.FTYP, t);
  }
}
$.types = void 0;
$.HDLR_TYPES = void 0;
$.STTS = void 0;
$.STSC = void 0;
$.STCO = void 0;
$.STSZ = void 0;
$.VMHD = void 0;
$.SMHD = void 0;
$.STSD = void 0;
$.FTYP = void 0;
$.DINF = void 0;
const co = 9e4;
function Zi(o, e, t = 1, n = !1) {
  const r = o * e * t;
  return n ? Math.round(r) : r;
}
function ih(o, e, t = 1, n = !1) {
  return Zi(o, e, 1 / t, n);
}
function Qn(o, e = !1) {
  return Zi(o, 1e3, 1 / co, e);
}
function sh(o, e = 1) {
  return Zi(o, co, 1 / e);
}
const ah = 10 * 1e3, Zs = 1024, oh = 1152, lh = 1536;
let xn = null, ci = null;
class Lr {
  constructor(e, t, n, r = "") {
    if (this.observer = void 0, this.config = void 0, this.typeSupported = void 0, this.ISGenerated = !1, this._initPTS = null, this._initDTS = null, this.nextAvcDts = null, this.nextAudioPts = null, this.videoSampleDuration = null, this.isAudioContiguous = !1, this.isVideoContiguous = !1, this.videoTrackConfig = void 0, this.observer = e, this.config = t, this.typeSupported = n, this.ISGenerated = !1, xn === null) {
      const s = (navigator.userAgent || "").match(/Chrome\/(\d+)/i);
      xn = s ? parseInt(s[1]) : 0;
    }
    if (ci === null) {
      const i = navigator.userAgent.match(/Safari\/(\d+)/i);
      ci = i ? parseInt(i[1]) : 0;
    }
  }
  destroy() {
    this.config = this.videoTrackConfig = this._initPTS = this._initDTS = null;
  }
  resetTimeStamp(e) {
    V.log("[mp4-remuxer]: initPTS & initDTS reset"), this._initPTS = this._initDTS = e;
  }
  resetNextTimestamp() {
    V.log("[mp4-remuxer]: reset next timestamp"), this.isVideoContiguous = !1, this.isAudioContiguous = !1;
  }
  resetInitSegment() {
    V.log("[mp4-remuxer]: ISGenerated flag reset"), this.ISGenerated = !1, this.videoTrackConfig = void 0;
  }
  getVideoStartPts(e) {
    let t = !1;
    const n = e.reduce((r, i) => {
      const s = i.pts - r;
      return s < -4294967296 ? (t = !0, Ct(r, i.pts)) : s > 0 ? r : i.pts;
    }, e[0].pts);
    return t && V.debug("PTS rollover detected"), n;
  }
  remux(e, t, n, r, i, s, a, l) {
    let d, h, u, c, m, f, p = i, A = i;
    const v = e.pid > -1, b = t.pid > -1, _ = t.samples.length, T = e.samples.length > 0, E = a && _ > 0 || _ > 1;
    if ((!v || T) && (!b || E) || this.ISGenerated || a) {
      if (this.ISGenerated) {
        var k, D, M, O;
        const G = this.videoTrackConfig;
        G && (t.width !== G.width || t.height !== G.height || ((k = t.pixelRatio) == null ? void 0 : k[0]) !== ((D = G.pixelRatio) == null ? void 0 : D[0]) || ((M = t.pixelRatio) == null ? void 0 : M[1]) !== ((O = G.pixelRatio) == null ? void 0 : O[1])) && this.resetInitSegment();
      } else
        u = this.generateIS(e, t, i, s);
      const N = this.isVideoContiguous;
      let B = -1, U;
      if (E && (B = dh(t.samples), !N && this.config.forceKeyFrameOnDiscontinuity))
        if (f = !0, B > 0) {
          V.warn(`[mp4-remuxer]: Dropped ${B} out of ${_} video samples due to a missing keyframe`);
          const G = this.getVideoStartPts(t.samples);
          t.samples = t.samples.slice(B), t.dropped += B, A += (t.samples[0].pts - G) / t.inputTimeScale, U = A;
        } else
          B === -1 && (V.warn(`[mp4-remuxer]: No keyframe found out of ${_} video samples`), f = !1);
      if (this.ISGenerated) {
        if (T && E) {
          const G = this.getVideoStartPts(t.samples), z = (Ct(e.samples[0].pts, G) - G) / t.inputTimeScale;
          p += Math.max(0, z), A += Math.max(0, -z);
        }
        if (T) {
          if (e.samplerate || (V.warn("[mp4-remuxer]: regenerate InitSegment as audio detected"), u = this.generateIS(e, t, i, s)), h = this.remuxAudio(e, p, this.isAudioContiguous, s, b || E || l === be.AUDIO ? A : void 0), E) {
            const G = h ? h.endPTS - h.startPTS : 0;
            t.inputTimeScale || (V.warn("[mp4-remuxer]: regenerate InitSegment as video detected"), u = this.generateIS(e, t, i, s)), d = this.remuxVideo(t, A, N, G);
          }
        } else
          E && (d = this.remuxVideo(t, A, N, 0));
        d && (d.firstKeyFrame = B, d.independent = B !== -1, d.firstKeyFramePTS = U);
      }
    }
    return this.ISGenerated && this._initPTS && this._initDTS && (n.samples.length && (m = uo(n, i, this._initPTS, this._initDTS)), r.samples.length && (c = ho(r, i, this._initPTS))), {
      audio: h,
      video: d,
      initSegment: u,
      independent: f,
      text: c,
      id3: m
    };
  }
  generateIS(e, t, n, r) {
    const i = e.samples, s = t.samples, a = this.typeSupported, l = {}, d = this._initPTS;
    let h = !d || r, u = "audio/mp4", c, m, f;
    if (h && (c = m = 1 / 0), e.config && i.length) {
      switch (e.timescale = e.samplerate, e.segmentCodec) {
        case "mp3":
          a.mpeg ? (u = "audio/mpeg", e.codec = "") : a.mp3 && (e.codec = "mp3");
          break;
        case "ac3":
          e.codec = "ac-3";
          break;
      }
      l.audio = {
        id: "audio",
        container: u,
        codec: e.codec,
        initSegment: e.segmentCodec === "mp3" && a.mpeg ? new Uint8Array(0) : $.initSegment([e]),
        metadata: {
          channelCount: e.channelCount
        }
      }, h && (f = e.inputTimeScale, !d || f !== d.timescale ? c = m = i[0].pts - Math.round(f * n) : h = !1);
    }
    if (t.sps && t.pps && s.length) {
      if (t.timescale = t.inputTimeScale, l.video = {
        id: "main",
        container: "video/mp4",
        codec: t.codec,
        initSegment: $.initSegment([t]),
        metadata: {
          width: t.width,
          height: t.height
        }
      }, h)
        if (f = t.inputTimeScale, !d || f !== d.timescale) {
          const p = this.getVideoStartPts(s), A = Math.round(f * n);
          m = Math.min(m, Ct(s[0].dts, p) - A), c = Math.min(c, p - A);
        } else
          h = !1;
      this.videoTrackConfig = {
        width: t.width,
        height: t.height,
        pixelRatio: t.pixelRatio
      };
    }
    if (Object.keys(l).length)
      return this.ISGenerated = !0, h ? (this._initPTS = {
        baseTime: c,
        timescale: f
      }, this._initDTS = {
        baseTime: m,
        timescale: f
      }) : c = f = void 0, {
        tracks: l,
        initPTS: c,
        timescale: f
      };
  }
  remuxVideo(e, t, n, r) {
    const i = e.inputTimeScale, s = e.samples, a = [], l = s.length, d = this._initPTS;
    let h = this.nextAvcDts, u = 8, c = this.videoSampleDuration, m, f, p = Number.POSITIVE_INFINITY, A = Number.NEGATIVE_INFINITY, v = !1;
    if (!n || h === null) {
      const W = t * i, Z = s[0].pts - Ct(s[0].dts, s[0].pts);
      xn && h !== null && Math.abs(W - Z - h) < 15e3 ? n = !0 : h = W - Z;
    }
    const b = d.baseTime * i / d.timescale;
    for (let W = 0; W < l; W++) {
      const Z = s[W];
      Z.pts = Ct(Z.pts - b, h), Z.dts = Ct(Z.dts - b, h), Z.dts < s[W > 0 ? W - 1 : W].dts && (v = !0);
    }
    v && s.sort(function(W, Z) {
      const ce = W.dts - Z.dts, ue = W.pts - Z.pts;
      return ce || ue;
    }), m = s[0].dts, f = s[s.length - 1].dts;
    const _ = f - m, T = _ ? Math.round(_ / (l - 1)) : c || e.inputTimeScale / 30;
    if (n) {
      const W = m - h, Z = W > T, ce = W < -1;
      if ((Z || ce) && (Z ? V.warn(`AVC: ${Qn(W, !0)} ms (${W}dts) hole between fragments detected at ${t.toFixed(3)}`) : V.warn(`AVC: ${Qn(-W, !0)} ms (${W}dts) overlapping between fragments detected at ${t.toFixed(3)}`), !ce || h >= s[0].pts || xn)) {
        m = h;
        const ue = s[0].pts - W;
        if (Z)
          s[0].dts = m, s[0].pts = ue;
        else
          for (let re = 0; re < s.length && !(s[re].dts > ue); re++)
            s[re].dts -= W, s[re].pts -= W;
        V.log(`Video: Initial PTS/DTS adjusted: ${Qn(ue, !0)}/${Qn(m, !0)}, delta: ${Qn(W, !0)} ms`);
      }
    }
    m = Math.max(0, m);
    let E = 0, L = 0, k = m;
    for (let W = 0; W < l; W++) {
      const Z = s[W], ce = Z.units, ue = ce.length;
      let re = 0;
      for (let me = 0; me < ue; me++)
        re += ce[me].data.length;
      L += re, E += ue, Z.length = re, Z.dts < k ? (Z.dts = k, k += T / 4 | 0 || 1) : k = Z.dts, p = Math.min(Z.pts, p), A = Math.max(Z.pts, A);
    }
    f = s[l - 1].dts;
    const D = L + 4 * E + 8;
    let M;
    try {
      M = new Uint8Array(D);
    } catch (W) {
      this.observer.emit(I.ERROR, I.ERROR, {
        type: xe.MUX_ERROR,
        details: q.REMUX_ALLOC_ERROR,
        fatal: !1,
        error: W,
        bytes: D,
        reason: `fail allocating video mdat ${D}`
      });
      return;
    }
    const O = new DataView(M.buffer);
    O.setUint32(0, D), M.set($.types.mdat, 4);
    let N = !1, B = Number.POSITIVE_INFINITY, U = Number.POSITIVE_INFINITY, G = Number.NEGATIVE_INFINITY, Y = Number.NEGATIVE_INFINITY;
    for (let W = 0; W < l; W++) {
      const Z = s[W], ce = Z.units;
      let ue = 0;
      for (let Be = 0, ye = ce.length; Be < ye; Be++) {
        const Le = ce[Be], Pe = Le.data, Me = Le.data.byteLength;
        O.setUint32(u, Me), u += 4, M.set(Pe, u), u += Me, ue += 4 + Me;
      }
      let re;
      if (W < l - 1)
        c = s[W + 1].dts - Z.dts, re = s[W + 1].pts - Z.pts;
      else {
        const Be = this.config, ye = W > 0 ? Z.dts - s[W - 1].dts : T;
        if (re = W > 0 ? Z.pts - s[W - 1].pts : T, Be.stretchShortVideoTrack && this.nextAudioPts !== null) {
          const Le = Math.floor(Be.maxBufferHole * i), Pe = (r ? p + r * i : this.nextAudioPts) - Z.pts;
          Pe > Le ? (c = Pe - ye, c < 0 ? c = ye : N = !0, V.log(`[mp4-remuxer]: It is approximately ${Pe / 90} ms to the next segment; using duration ${c / 90} ms for the last video frame.`)) : c = ye;
        } else
          c = ye;
      }
      const me = Math.round(Z.pts - Z.dts);
      B = Math.min(B, c), G = Math.max(G, c), U = Math.min(U, re), Y = Math.max(Y, re), a.push(new Js(Z.key, c, ue, me));
    }
    if (a.length) {
      if (xn) {
        if (xn < 70) {
          const W = a[0].flags;
          W.dependsOn = 2, W.isNonSync = 0;
        }
      } else if (ci && Y - U < G - B && T / G < 0.025 && a[0].cts === 0) {
        V.warn("Found irregular gaps in sample duration. Using PTS instead of DTS to determine MP4 sample duration.");
        let W = m;
        for (let Z = 0, ce = a.length; Z < ce; Z++) {
          const ue = W + a[Z].duration, re = W + a[Z].cts;
          if (Z < ce - 1) {
            const me = ue + a[Z + 1].cts;
            a[Z].duration = me - re;
          } else
            a[Z].duration = Z ? a[Z - 1].duration : T;
          a[Z].cts = 0, W = ue;
        }
      }
    }
    c = N || !c ? T : c, this.nextAvcDts = h = f + c, this.videoSampleDuration = c, this.isVideoContiguous = !0;
    const z = $.moof(e.sequenceNumber++, m, lt({}, e, {
      samples: a
    })), J = "video", le = {
      data1: z,
      data2: M,
      startPTS: p / i,
      endPTS: (A + c) / i,
      startDTS: m / i,
      endDTS: h / i,
      type: J,
      hasAudio: !1,
      hasVideo: !0,
      nb: a.length,
      dropped: e.dropped
    };
    return e.samples = [], e.dropped = 0, le;
  }
  getSamplesPerFrame(e) {
    switch (e.segmentCodec) {
      case "mp3":
        return oh;
      case "ac3":
        return lh;
      default:
        return Zs;
    }
  }
  remuxAudio(e, t, n, r, i) {
    const s = e.inputTimeScale, a = e.samplerate ? e.samplerate : s, l = s / a, d = this.getSamplesPerFrame(e), h = d * l, u = this._initPTS, c = e.segmentCodec === "mp3" && this.typeSupported.mpeg, m = [], f = i !== void 0;
    let p = e.samples, A = c ? 0 : 8, v = this.nextAudioPts || -1;
    const b = t * s, _ = u.baseTime * s / u.timescale;
    if (this.isAudioContiguous = n = n || p.length && v > 0 && (r && Math.abs(b - v) < 9e3 || Math.abs(Ct(p[0].pts - _, b) - v) < 20 * h), p.forEach(function(z) {
      z.pts = Ct(z.pts - _, b);
    }), !n || v < 0) {
      if (p = p.filter((z) => z.pts >= 0), !p.length)
        return;
      i === 0 ? v = 0 : r && !f ? v = Math.max(0, b) : v = p[0].pts;
    }
    if (e.segmentCodec === "aac") {
      const z = this.config.maxAudioFramesDrift;
      for (let J = 0, le = v; J < p.length; J++) {
        const W = p[J], Z = W.pts, ce = Z - le, ue = Math.abs(1e3 * ce / s);
        if (ce <= -z * h && f)
          J === 0 && (V.warn(`Audio frame @ ${(Z / s).toFixed(3)}s overlaps nextAudioPts by ${Math.round(1e3 * ce / s)} ms.`), this.nextAudioPts = v = le = Z);
        else if (ce >= z * h && ue < ah && f) {
          let re = Math.round(ce / h);
          le = Z - re * h, le < 0 && (re--, le += h), J === 0 && (this.nextAudioPts = v = le), V.warn(`[mp4-remuxer]: Injecting ${re} audio frame @ ${(le / s).toFixed(3)}s due to ${Math.round(1e3 * ce / s)} ms gap.`);
          for (let me = 0; me < re; me++) {
            const Be = Math.max(le, 0);
            let ye = Qs.getSilentFrame(e.manifestCodec || e.codec, e.channelCount);
            ye || (V.log("[mp4-remuxer]: Unable to get silent frame for given audio codec; duplicating last frame instead."), ye = W.unit.subarray()), p.splice(J, 0, {
              unit: ye,
              pts: Be
            }), le += h, J++;
          }
        }
        W.pts = le, le += h;
      }
    }
    let T = null, E = null, L, k = 0, D = p.length;
    for (; D--; )
      k += p[D].unit.byteLength;
    for (let z = 0, J = p.length; z < J; z++) {
      const le = p[z], W = le.unit;
      let Z = le.pts;
      if (E !== null) {
        const ue = m[z - 1];
        ue.duration = Math.round((Z - E) / l);
      } else if (n && e.segmentCodec === "aac" && (Z = v), T = Z, k > 0) {
        k += A;
        try {
          L = new Uint8Array(k);
        } catch (ue) {
          this.observer.emit(I.ERROR, I.ERROR, {
            type: xe.MUX_ERROR,
            details: q.REMUX_ALLOC_ERROR,
            fatal: !1,
            error: ue,
            bytes: k,
            reason: `fail allocating audio mdat ${k}`
          });
          return;
        }
        c || (new DataView(L.buffer).setUint32(0, k), L.set($.types.mdat, 4));
      } else
        return;
      L.set(W, A);
      const ce = W.byteLength;
      A += ce, m.push(new Js(!0, d, ce, 0)), E = Z;
    }
    const M = m.length;
    if (!M)
      return;
    const O = m[m.length - 1];
    this.nextAudioPts = v = E + l * O.duration;
    const N = c ? new Uint8Array(0) : $.moof(e.sequenceNumber++, T / l, lt({}, e, {
      samples: m
    }));
    e.samples = [];
    const B = T / s, U = v / s, Y = {
      data1: N,
      data2: L,
      startPTS: B,
      endPTS: U,
      startDTS: B,
      endDTS: U,
      type: "audio",
      hasAudio: !0,
      hasVideo: !1,
      nb: M
    };
    return this.isAudioContiguous = !0, Y;
  }
  remuxEmptyAudio(e, t, n, r) {
    const i = e.inputTimeScale, s = e.samplerate ? e.samplerate : i, a = i / s, l = this.nextAudioPts, d = this._initDTS, h = d.baseTime * 9e4 / d.timescale, u = (l !== null ? l : r.startDTS * i) + h, c = r.endDTS * i + h, m = a * Zs, f = Math.ceil((c - u) / m), p = Qs.getSilentFrame(e.manifestCodec || e.codec, e.channelCount);
    if (V.warn("[mp4-remuxer]: remux empty Audio"), !p) {
      V.trace("[mp4-remuxer]: Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec");
      return;
    }
    const A = [];
    for (let v = 0; v < f; v++) {
      const b = u + v * m;
      A.push({
        unit: p,
        pts: b,
        dts: b
      });
    }
    return e.samples = A, this.remuxAudio(e, t, n, !1);
  }
}
function Ct(o, e) {
  let t;
  if (e === null)
    return o;
  for (e < o ? t = -8589934592 : t = 8589934592; Math.abs(o - e) > 4294967296; )
    o += t;
  return o;
}
function dh(o) {
  for (let e = 0; e < o.length; e++)
    if (o[e].key)
      return e;
  return -1;
}
function uo(o, e, t, n) {
  const r = o.samples.length;
  if (!r)
    return;
  const i = o.inputTimeScale;
  for (let a = 0; a < r; a++) {
    const l = o.samples[a];
    l.pts = Ct(l.pts - t.baseTime * i / t.timescale, e * i) / i, l.dts = Ct(l.dts - n.baseTime * i / n.timescale, e * i) / i;
  }
  const s = o.samples;
  return o.samples = [], {
    samples: s
  };
}
function ho(o, e, t) {
  const n = o.samples.length;
  if (!n)
    return;
  const r = o.inputTimeScale;
  for (let s = 0; s < n; s++) {
    const a = o.samples[s];
    a.pts = Ct(a.pts - t.baseTime * r / t.timescale, e * r) / r;
  }
  o.samples.sort((s, a) => s.pts - a.pts);
  const i = o.samples;
  return o.samples = [], {
    samples: i
  };
}
class Js {
  constructor(e, t, n, r) {
    this.size = void 0, this.duration = void 0, this.cts = void 0, this.flags = void 0, this.duration = t, this.size = n, this.cts = r, this.flags = {
      isLeading: 0,
      isDependedOn: 0,
      hasRedundancy: 0,
      degradPrio: 0,
      dependsOn: e ? 2 : 1,
      isNonSync: e ? 0 : 1
    };
  }
}
class ch {
  constructor() {
    this.emitInitSegment = !1, this.audioCodec = void 0, this.videoCodec = void 0, this.initData = void 0, this.initPTS = null, this.initTracks = void 0, this.lastEndTime = null;
  }
  destroy() {
  }
  resetTimeStamp(e) {
    this.initPTS = e, this.lastEndTime = null;
  }
  resetNextTimestamp() {
    this.lastEndTime = null;
  }
  resetInitSegment(e, t, n, r) {
    this.audioCodec = t, this.videoCodec = n, this.generateInitSegment(bc(e, r)), this.emitInitSegment = !0;
  }
  generateInitSegment(e) {
    let {
      audioCodec: t,
      videoCodec: n
    } = this;
    if (!(e != null && e.byteLength)) {
      this.initTracks = void 0, this.initData = void 0;
      return;
    }
    const r = this.initData = Fa(e);
    r.audio && (t = ea(r.audio, Ge.AUDIO)), r.video && (n = ea(r.video, Ge.VIDEO));
    const i = {};
    r.audio && r.video ? i.audiovideo = {
      container: "video/mp4",
      codec: t + "," + n,
      initSegment: e,
      id: "main"
    } : r.audio ? i.audio = {
      container: "audio/mp4",
      codec: t,
      initSegment: e,
      id: "audio"
    } : r.video ? i.video = {
      container: "video/mp4",
      codec: n,
      initSegment: e,
      id: "main"
    } : V.warn("[passthrough-remuxer.ts]: initSegment does not contain moov or trak boxes."), this.initTracks = i;
  }
  remux(e, t, n, r, i, s) {
    var a, l;
    let {
      initPTS: d,
      lastEndTime: h
    } = this;
    const u = {
      audio: void 0,
      video: void 0,
      text: r,
      id3: n,
      initSegment: void 0
    };
    ge(h) || (h = this.lastEndTime = i || 0);
    const c = t.samples;
    if (!(c != null && c.length))
      return u;
    const m = {
      initPTS: void 0,
      timescale: 1
    };
    let f = this.initData;
    if ((a = f) != null && a.length || (this.generateInitSegment(c), f = this.initData), !((l = f) != null && l.length))
      return V.warn("[passthrough-remuxer.ts]: Failed to generate initSegment."), u;
    this.emitInitSegment && (m.tracks = this.initTracks, this.emitInitSegment = !1);
    const p = Ec(c, f), A = xc(f, c), v = A === null ? i : A;
    (uh(d, v, i, p) || m.timescale !== d.timescale && s) && (m.initPTS = v - i, d && d.timescale === 1 && V.warn(`Adjusting initPTS by ${m.initPTS - d.baseTime}`), this.initPTS = d = {
      baseTime: m.initPTS,
      timescale: 1
    });
    const b = e ? v - d.baseTime / d.timescale : h, _ = b + p;
    Sc(f, c, d.baseTime / d.timescale), p > 0 ? this.lastEndTime = _ : (V.warn("Duration parsed from mp4 should be greater than zero"), this.resetNextTimestamp());
    const T = !!f.audio, E = !!f.video;
    let L = "";
    T && (L += "audio"), E && (L += "video");
    const k = {
      data1: c,
      startPTS: b,
      startDTS: b,
      endPTS: _,
      endDTS: _,
      type: L,
      hasAudio: T,
      hasVideo: E,
      nb: 1,
      dropped: 0
    };
    return u.audio = k.type === "audio" ? k : void 0, u.video = k.type !== "audio" ? k : void 0, u.initSegment = m, u.id3 = uo(n, i, d, d), r.samples.length && (u.text = ho(r, i, d)), u;
  }
}
function uh(o, e, t, n) {
  if (o === null)
    return !0;
  const r = Math.max(n, 1), i = e - o.baseTime / o.timescale;
  return Math.abs(i - t) > r;
}
function ea(o, e) {
  const t = o == null ? void 0 : o.codec;
  if (t && t.length > 4)
    return t;
  if (e === Ge.AUDIO) {
    if (t === "ec-3" || t === "ac-3" || t === "alac")
      return t;
    if (t === "fLaC" || t === "Opus")
      return Or(t, !1);
    const n = "mp4a.40.5";
    return V.info(`Parsed audio codec "${t}" or audio object type not handled. Using "${n}"`), n;
  }
  return V.warn(`Unhandled video codec "${t}"`), t === "hvc1" || t === "hev1" ? "hvc1.1.6.L120.90" : t === "av01" ? "av01.0.04M.08" : "avc1.42e01e";
}
let zt;
try {
  zt = self.performance.now.bind(self.performance);
} catch {
  V.debug("Unable to use Performance API on this environment"), zt = typeof self < "u" && self.Date.now;
}
const wr = [{
  demux: qu,
  remux: ch
}, {
  demux: en,
  remux: Lr
}, {
  demux: zu,
  remux: Lr
}, {
  demux: nh,
  remux: Lr
}];
wr.splice(2, 0, {
  demux: Xu,
  remux: Lr
});
class ta {
  constructor(e, t, n, r, i) {
    this.async = !1, this.observer = void 0, this.typeSupported = void 0, this.config = void 0, this.vendor = void 0, this.id = void 0, this.demuxer = void 0, this.remuxer = void 0, this.decrypter = void 0, this.probe = void 0, this.decryptionPromise = null, this.transmuxConfig = void 0, this.currentTransmuxState = void 0, this.observer = e, this.typeSupported = t, this.config = n, this.vendor = r, this.id = i;
  }
  configure(e) {
    this.transmuxConfig = e, this.decrypter && this.decrypter.reset();
  }
  push(e, t, n, r) {
    const i = n.transmuxing;
    i.executeStart = zt();
    let s = new Uint8Array(e);
    const {
      currentTransmuxState: a,
      transmuxConfig: l
    } = this;
    r && (this.currentTransmuxState = r);
    const {
      contiguous: d,
      discontinuity: h,
      trackSwitch: u,
      accurateTimeOffset: c,
      timeOffset: m,
      initSegmentChange: f
    } = r || a, {
      audioCodec: p,
      videoCodec: A,
      defaultInitPts: v,
      duration: b,
      initSegmentData: _
    } = l, T = hh(s, t);
    if (T && T.method === "AES-128") {
      const D = this.getDecrypter();
      if (D.isSync()) {
        let M = D.softwareDecrypt(s, T.key.buffer, T.iv.buffer);
        if (n.part > -1 && (M = D.flush()), !M)
          return i.executeEnd = zt(), ui(n);
        s = new Uint8Array(M);
      } else
        return this.decryptionPromise = D.webCryptoDecrypt(s, T.key.buffer, T.iv.buffer).then((M) => {
          const O = this.push(M, null, n);
          return this.decryptionPromise = null, O;
        }), this.decryptionPromise;
    }
    const E = this.needsProbing(h, u);
    if (E) {
      const D = this.configureTransmuxer(s);
      if (D)
        return V.warn(`[transmuxer] ${D.message}`), this.observer.emit(I.ERROR, I.ERROR, {
          type: xe.MEDIA_ERROR,
          details: q.FRAG_PARSING_ERROR,
          fatal: !1,
          error: D,
          reason: D.message
        }), i.executeEnd = zt(), ui(n);
    }
    (h || u || f || E) && this.resetInitSegment(_, p, A, b, t), (h || f || E) && this.resetInitialTimestamp(v), d || this.resetContiguity();
    const L = this.transmux(s, T, m, c, n), k = this.currentTransmuxState;
    return k.contiguous = !0, k.discontinuity = !1, k.trackSwitch = !1, i.executeEnd = zt(), L;
  }
  // Due to data caching, flush calls can produce more than one TransmuxerResult (hence the Array type)
  flush(e) {
    const t = e.transmuxing;
    t.executeStart = zt();
    const {
      decrypter: n,
      currentTransmuxState: r,
      decryptionPromise: i
    } = this;
    if (i)
      return i.then(() => this.flush(e));
    const s = [], {
      timeOffset: a
    } = r;
    if (n) {
      const u = n.flush();
      u && s.push(this.push(u, null, e));
    }
    const {
      demuxer: l,
      remuxer: d
    } = this;
    if (!l || !d)
      return t.executeEnd = zt(), [ui(e)];
    const h = l.flush(a);
    return Rr(h) ? h.then((u) => (this.flushRemux(s, u, e), s)) : (this.flushRemux(s, h, e), s);
  }
  flushRemux(e, t, n) {
    const {
      audioTrack: r,
      videoTrack: i,
      id3Track: s,
      textTrack: a
    } = t, {
      accurateTimeOffset: l,
      timeOffset: d
    } = this.currentTransmuxState;
    V.log(`[transmuxer.ts]: Flushed fragment ${n.sn}${n.part > -1 ? " p: " + n.part : ""} of level ${n.level}`);
    const h = this.remuxer.remux(r, i, s, a, d, l, !0, this.id);
    e.push({
      remuxResult: h,
      chunkMeta: n
    }), n.transmuxing.executeEnd = zt();
  }
  resetInitialTimestamp(e) {
    const {
      demuxer: t,
      remuxer: n
    } = this;
    !t || !n || (t.resetTimeStamp(e), n.resetTimeStamp(e));
  }
  resetContiguity() {
    const {
      demuxer: e,
      remuxer: t
    } = this;
    !e || !t || (e.resetContiguity(), t.resetNextTimestamp());
  }
  resetInitSegment(e, t, n, r, i) {
    const {
      demuxer: s,
      remuxer: a
    } = this;
    !s || !a || (s.resetInitSegment(e, t, n, r), a.resetInitSegment(e, t, n, i));
  }
  destroy() {
    this.demuxer && (this.demuxer.destroy(), this.demuxer = void 0), this.remuxer && (this.remuxer.destroy(), this.remuxer = void 0);
  }
  transmux(e, t, n, r, i) {
    let s;
    return t && t.method === "SAMPLE-AES" ? s = this.transmuxSampleAes(e, t, n, r, i) : s = this.transmuxUnencrypted(e, n, r, i), s;
  }
  transmuxUnencrypted(e, t, n, r) {
    const {
      audioTrack: i,
      videoTrack: s,
      id3Track: a,
      textTrack: l
    } = this.demuxer.demux(e, t, !1, !this.config.progressive);
    return {
      remuxResult: this.remuxer.remux(i, s, a, l, t, n, !1, this.id),
      chunkMeta: r
    };
  }
  transmuxSampleAes(e, t, n, r, i) {
    return this.demuxer.demuxSampleAes(e, t, n).then((s) => ({
      remuxResult: this.remuxer.remux(s.audioTrack, s.videoTrack, s.id3Track, s.textTrack, n, r, !1, this.id),
      chunkMeta: i
    }));
  }
  configureTransmuxer(e) {
    const {
      config: t,
      observer: n,
      typeSupported: r,
      vendor: i
    } = this;
    let s;
    for (let c = 0, m = wr.length; c < m; c++) {
      var a;
      if ((a = wr[c].demux) != null && a.probe(e)) {
        s = wr[c];
        break;
      }
    }
    if (!s)
      return new Error("Failed to find demuxer by probing fragment data");
    const l = this.demuxer, d = this.remuxer, h = s.remux, u = s.demux;
    (!d || !(d instanceof h)) && (this.remuxer = new h(n, t, r, i)), (!l || !(l instanceof u)) && (this.demuxer = new u(n, t, r), this.probe = u.probe);
  }
  needsProbing(e, t) {
    return !this.demuxer || !this.remuxer || e || t;
  }
  getDecrypter() {
    let e = this.decrypter;
    return e || (e = this.decrypter = new zi(this.config)), e;
  }
}
function hh(o, e) {
  let t = null;
  return o.byteLength > 0 && e != null && e.key != null && e.iv !== null && e.method != null && (t = e), t;
}
const ui = (o) => ({
  remuxResult: {},
  chunkMeta: o
});
function Rr(o) {
  return "then" in o && o.then instanceof Function;
}
class fh {
  constructor(e, t, n, r, i) {
    this.audioCodec = void 0, this.videoCodec = void 0, this.initSegmentData = void 0, this.duration = void 0, this.defaultInitPts = void 0, this.audioCodec = e, this.videoCodec = t, this.initSegmentData = n, this.duration = r, this.defaultInitPts = i || null;
  }
}
class ph {
  constructor(e, t, n, r, i, s) {
    this.discontinuity = void 0, this.contiguous = void 0, this.accurateTimeOffset = void 0, this.trackSwitch = void 0, this.timeOffset = void 0, this.initSegmentChange = void 0, this.discontinuity = e, this.contiguous = t, this.accurateTimeOffset = n, this.trackSwitch = r, this.timeOffset = i, this.initSegmentChange = s;
  }
}
var fo = { exports: {} };
(function(o) {
  var e = Object.prototype.hasOwnProperty, t = "~";
  function n() {
  }
  Object.create && (n.prototype = /* @__PURE__ */ Object.create(null), new n().__proto__ || (t = !1));
  function r(l, d, h) {
    this.fn = l, this.context = d, this.once = h || !1;
  }
  function i(l, d, h, u, c) {
    if (typeof h != "function")
      throw new TypeError("The listener must be a function");
    var m = new r(h, u || l, c), f = t ? t + d : d;
    return l._events[f] ? l._events[f].fn ? l._events[f] = [l._events[f], m] : l._events[f].push(m) : (l._events[f] = m, l._eventsCount++), l;
  }
  function s(l, d) {
    --l._eventsCount === 0 ? l._events = new n() : delete l._events[d];
  }
  function a() {
    this._events = new n(), this._eventsCount = 0;
  }
  a.prototype.eventNames = function() {
    var d = [], h, u;
    if (this._eventsCount === 0)
      return d;
    for (u in h = this._events)
      e.call(h, u) && d.push(t ? u.slice(1) : u);
    return Object.getOwnPropertySymbols ? d.concat(Object.getOwnPropertySymbols(h)) : d;
  }, a.prototype.listeners = function(d) {
    var h = t ? t + d : d, u = this._events[h];
    if (!u)
      return [];
    if (u.fn)
      return [u.fn];
    for (var c = 0, m = u.length, f = new Array(m); c < m; c++)
      f[c] = u[c].fn;
    return f;
  }, a.prototype.listenerCount = function(d) {
    var h = t ? t + d : d, u = this._events[h];
    return u ? u.fn ? 1 : u.length : 0;
  }, a.prototype.emit = function(d, h, u, c, m, f) {
    var p = t ? t + d : d;
    if (!this._events[p])
      return !1;
    var A = this._events[p], v = arguments.length, b, _;
    if (A.fn) {
      switch (A.once && this.removeListener(d, A.fn, void 0, !0), v) {
        case 1:
          return A.fn.call(A.context), !0;
        case 2:
          return A.fn.call(A.context, h), !0;
        case 3:
          return A.fn.call(A.context, h, u), !0;
        case 4:
          return A.fn.call(A.context, h, u, c), !0;
        case 5:
          return A.fn.call(A.context, h, u, c, m), !0;
        case 6:
          return A.fn.call(A.context, h, u, c, m, f), !0;
      }
      for (_ = 1, b = new Array(v - 1); _ < v; _++)
        b[_ - 1] = arguments[_];
      A.fn.apply(A.context, b);
    } else {
      var T = A.length, E;
      for (_ = 0; _ < T; _++)
        switch (A[_].once && this.removeListener(d, A[_].fn, void 0, !0), v) {
          case 1:
            A[_].fn.call(A[_].context);
            break;
          case 2:
            A[_].fn.call(A[_].context, h);
            break;
          case 3:
            A[_].fn.call(A[_].context, h, u);
            break;
          case 4:
            A[_].fn.call(A[_].context, h, u, c);
            break;
          default:
            if (!b)
              for (E = 1, b = new Array(v - 1); E < v; E++)
                b[E - 1] = arguments[E];
            A[_].fn.apply(A[_].context, b);
        }
    }
    return !0;
  }, a.prototype.on = function(d, h, u) {
    return i(this, d, h, u, !1);
  }, a.prototype.once = function(d, h, u) {
    return i(this, d, h, u, !0);
  }, a.prototype.removeListener = function(d, h, u, c) {
    var m = t ? t + d : d;
    if (!this._events[m])
      return this;
    if (!h)
      return s(this, m), this;
    var f = this._events[m];
    if (f.fn)
      f.fn === h && (!c || f.once) && (!u || f.context === u) && s(this, m);
    else {
      for (var p = 0, A = [], v = f.length; p < v; p++)
        (f[p].fn !== h || c && !f[p].once || u && f[p].context !== u) && A.push(f[p]);
      A.length ? this._events[m] = A.length === 1 ? A[0] : A : s(this, m);
    }
    return this;
  }, a.prototype.removeAllListeners = function(d) {
    var h;
    return d ? (h = t ? t + d : d, this._events[h] && s(this, h)) : (this._events = new n(), this._eventsCount = 0), this;
  }, a.prototype.off = a.prototype.removeListener, a.prototype.addListener = a.prototype.on, a.prefixed = t, a.EventEmitter = a, o.exports = a;
})(fo);
var mh = fo.exports, Ji = /* @__PURE__ */ Vd(mh);
class po {
  constructor(e, t, n, r) {
    this.error = null, this.hls = void 0, this.id = void 0, this.observer = void 0, this.frag = null, this.part = null, this.useWorker = void 0, this.workerContext = null, this.onwmsg = void 0, this.transmuxer = null, this.onTransmuxComplete = void 0, this.onFlush = void 0;
    const i = e.config;
    this.hls = e, this.id = t, this.useWorker = !!i.enableWorker, this.onTransmuxComplete = n, this.onFlush = r;
    const s = (h, u) => {
      u = u || {}, u.frag = this.frag, u.id = this.id, h === I.ERROR && (this.error = u.error), this.hls.trigger(h, u);
    };
    this.observer = new Ji(), this.observer.on(I.FRAG_DECRYPTED, s), this.observer.on(I.ERROR, s);
    const a = Gr(i.preferManagedMediaSource) || {
      isTypeSupported: () => !1
    }, l = {
      mpeg: a.isTypeSupported("audio/mpeg"),
      mp3: a.isTypeSupported('audio/mp4; codecs="mp3"'),
      ac3: a.isTypeSupported('audio/mp4; codecs="ac-3"')
    }, d = navigator.vendor;
    if (this.useWorker && typeof Worker < "u" && (i.workerPath || Ou())) {
      try {
        i.workerPath ? (V.log(`loading Web Worker ${i.workerPath} for "${t}"`), this.workerContext = Pu(i.workerPath)) : (V.log(`injecting Web Worker for "${t}"`), this.workerContext = Bu()), this.onwmsg = (c) => this.onWorkerMessage(c);
        const {
          worker: u
        } = this.workerContext;
        u.addEventListener("message", this.onwmsg), u.onerror = (c) => {
          const m = new Error(`${c.message}  (${c.filename}:${c.lineno})`);
          i.enableWorker = !1, V.warn(`Error in "${t}" Web Worker, fallback to inline`), this.hls.trigger(I.ERROR, {
            type: xe.OTHER_ERROR,
            details: q.INTERNAL_EXCEPTION,
            fatal: !1,
            event: "demuxerWorker",
            error: m
          });
        }, u.postMessage({
          cmd: "init",
          typeSupported: l,
          vendor: d,
          id: t,
          config: JSON.stringify(i)
        });
      } catch (u) {
        V.warn(`Error setting up "${t}" Web Worker, fallback to inline`, u), this.resetWorker(), this.error = null, this.transmuxer = new ta(this.observer, l, i, d, t);
      }
      return;
    }
    this.transmuxer = new ta(this.observer, l, i, d, t);
  }
  resetWorker() {
    if (this.workerContext) {
      const {
        worker: e,
        objectURL: t
      } = this.workerContext;
      t && self.URL.revokeObjectURL(t), e.removeEventListener("message", this.onwmsg), e.onerror = null, e.terminate(), this.workerContext = null;
    }
  }
  destroy() {
    if (this.workerContext)
      this.resetWorker(), this.onwmsg = void 0;
    else {
      const t = this.transmuxer;
      t && (t.destroy(), this.transmuxer = null);
    }
    const e = this.observer;
    e && e.removeAllListeners(), this.frag = null, this.observer = null, this.hls = null;
  }
  push(e, t, n, r, i, s, a, l, d, h) {
    var u, c;
    d.transmuxing.start = self.performance.now();
    const {
      transmuxer: m
    } = this, f = s ? s.start : i.start, p = i.decryptdata, A = this.frag, v = !(A && i.cc === A.cc), b = !(A && d.level === A.level), _ = A ? d.sn - A.sn : -1, T = this.part ? d.part - this.part.index : -1, E = _ === 0 && d.id > 1 && d.id === (A == null ? void 0 : A.stats.chunkCount), L = !b && (_ === 1 || _ === 0 && (T === 1 || E && T <= 0)), k = self.performance.now();
    (b || _ || i.stats.parsing.start === 0) && (i.stats.parsing.start = k), s && (T || !L) && (s.stats.parsing.start = k);
    const D = !(A && ((u = i.initSegment) == null ? void 0 : u.url) === ((c = A.initSegment) == null ? void 0 : c.url)), M = new ph(v, L, l, b, f, D);
    if (!L || v || D) {
      V.log(`[transmuxer-interface, ${i.type}]: Starting new transmux session for sn: ${d.sn} p: ${d.part} level: ${d.level} id: ${d.id}
        discontinuity: ${v}
        trackSwitch: ${b}
        contiguous: ${L}
        accurateTimeOffset: ${l}
        timeOffset: ${f}
        initSegmentChange: ${D}`);
      const O = new fh(n, r, t, a, h);
      this.configureTransmuxer(O);
    }
    if (this.frag = i, this.part = s, this.workerContext)
      this.workerContext.worker.postMessage({
        cmd: "demux",
        data: e,
        decryptdata: p,
        chunkMeta: d,
        state: M
      }, e instanceof ArrayBuffer ? [e] : []);
    else if (m) {
      const O = m.push(e, p, d, M);
      Rr(O) ? (m.async = !0, O.then((N) => {
        this.handleTransmuxComplete(N);
      }).catch((N) => {
        this.transmuxerError(N, d, "transmuxer-interface push error");
      })) : (m.async = !1, this.handleTransmuxComplete(O));
    }
  }
  flush(e) {
    e.transmuxing.start = self.performance.now();
    const {
      transmuxer: t
    } = this;
    if (this.workerContext)
      this.workerContext.worker.postMessage({
        cmd: "flush",
        chunkMeta: e
      });
    else if (t) {
      let n = t.flush(e);
      Rr(n) || t.async ? (Rr(n) || (n = Promise.resolve(n)), n.then((i) => {
        this.handleFlushResult(i, e);
      }).catch((i) => {
        this.transmuxerError(i, e, "transmuxer-interface flush error");
      })) : this.handleFlushResult(n, e);
    }
  }
  transmuxerError(e, t, n) {
    this.hls && (this.error = e, this.hls.trigger(I.ERROR, {
      type: xe.MEDIA_ERROR,
      details: q.FRAG_PARSING_ERROR,
      chunkMeta: t,
      fatal: !1,
      error: e,
      err: e,
      reason: n
    }));
  }
  handleFlushResult(e, t) {
    e.forEach((n) => {
      this.handleTransmuxComplete(n);
    }), this.onFlush(t);
  }
  onWorkerMessage(e) {
    const t = e.data, n = this.hls;
    switch (t.event) {
      case "init": {
        var r;
        const i = (r = this.workerContext) == null ? void 0 : r.objectURL;
        i && self.URL.revokeObjectURL(i);
        break;
      }
      case "transmuxComplete": {
        this.handleTransmuxComplete(t.data);
        break;
      }
      case "flush": {
        this.onFlush(t.data);
        break;
      }
      case "workerLog":
        V[t.data.logType] && V[t.data.logType](t.data.message);
        break;
      default: {
        t.data = t.data || {}, t.data.frag = this.frag, t.data.id = this.id, n.trigger(t.event, t.data);
        break;
      }
    }
  }
  configureTransmuxer(e) {
    const {
      transmuxer: t
    } = this;
    this.workerContext ? this.workerContext.worker.postMessage({
      cmd: "configure",
      config: e
    }) : t && t.configure(e);
  }
  handleTransmuxComplete(e) {
    e.chunkMeta.transmuxing.end = self.performance.now(), this.onTransmuxComplete(e);
  }
}
const na = 100;
class gh extends Yi {
  constructor(e, t, n) {
    super(e, t, n, "[audio-stream-controller]", be.AUDIO), this.videoBuffer = null, this.videoTrackCC = -1, this.waitingVideoCC = -1, this.bufferedTrack = null, this.switchingTrack = null, this.trackId = -1, this.waitingData = null, this.mainDetails = null, this.bufferFlushed = !1, this.cachedTrackLoadedData = null, this._registerListeners();
  }
  onHandlerDestroying() {
    this._unregisterListeners(), this.mainDetails = null, this.bufferedTrack = null, this.switchingTrack = null;
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(I.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(I.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(I.MANIFEST_LOADING, this.onManifestLoading, this), e.on(I.LEVEL_LOADED, this.onLevelLoaded, this), e.on(I.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this), e.on(I.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.on(I.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.on(I.ERROR, this.onError, this), e.on(I.BUFFER_RESET, this.onBufferReset, this), e.on(I.BUFFER_CREATED, this.onBufferCreated, this), e.on(I.BUFFER_FLUSHED, this.onBufferFlushed, this), e.on(I.INIT_PTS_FOUND, this.onInitPtsFound, this), e.on(I.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(I.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(I.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(I.MANIFEST_LOADING, this.onManifestLoading, this), e.off(I.LEVEL_LOADED, this.onLevelLoaded, this), e.off(I.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this), e.off(I.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.off(I.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.off(I.ERROR, this.onError, this), e.off(I.BUFFER_RESET, this.onBufferReset, this), e.off(I.BUFFER_CREATED, this.onBufferCreated, this), e.off(I.BUFFER_FLUSHED, this.onBufferFlushed, this), e.off(I.INIT_PTS_FOUND, this.onInitPtsFound, this), e.off(I.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  // INIT_PTS_FOUND is triggered when the video track parsed in the stream-controller has a new PTS value
  onInitPtsFound(e, {
    frag: t,
    id: n,
    initPTS: r,
    timescale: i
  }) {
    if (n === "main") {
      const s = t.cc;
      this.initPTS[t.cc] = {
        baseTime: r,
        timescale: i
      }, this.log(`InitPTS for cc: ${s} found from main: ${r}`), this.videoTrackCC = s, this.state === ee.WAITING_INIT_PTS && this.tick();
    }
  }
  startLoad(e) {
    if (!this.levels) {
      this.startPosition = e, this.state = ee.STOPPED;
      return;
    }
    const t = this.lastCurrentTime;
    this.stopLoad(), this.setInterval(na), t > 0 && e === -1 ? (this.log(`Override startPosition with lastCurrentTime @${t.toFixed(3)}`), e = t, this.state = ee.IDLE) : (this.loadedmetadata = !1, this.state = ee.WAITING_TRACK), this.nextLoadPosition = this.startPosition = this.lastCurrentTime = e, this.tick();
  }
  doTick() {
    switch (this.state) {
      case ee.IDLE:
        this.doTickIdle();
        break;
      case ee.WAITING_TRACK: {
        var e;
        const {
          levels: n,
          trackId: r
        } = this, i = n == null || (e = n[r]) == null ? void 0 : e.details;
        if (i) {
          if (this.waitForCdnTuneIn(i))
            break;
          this.state = ee.WAITING_INIT_PTS;
        }
        break;
      }
      case ee.FRAG_LOADING_WAITING_RETRY: {
        var t;
        const n = performance.now(), r = this.retryDate;
        if (!r || n >= r || (t = this.media) != null && t.seeking) {
          const {
            levels: i,
            trackId: s
          } = this;
          this.log("RetryDate reached, switch back to IDLE state"), this.resetStartWhenNotLoaded((i == null ? void 0 : i[s]) || null), this.state = ee.IDLE;
        }
        break;
      }
      case ee.WAITING_INIT_PTS: {
        const n = this.waitingData;
        if (n) {
          const {
            frag: r,
            part: i,
            cache: s,
            complete: a
          } = n;
          if (this.initPTS[r.cc] !== void 0) {
            this.waitingData = null, this.waitingVideoCC = -1, this.state = ee.FRAG_LOADING;
            const l = s.flush(), d = {
              frag: r,
              part: i,
              payload: l,
              networkDetails: null
            };
            this._handleFragmentLoadProgress(d), a && super._handleFragmentLoadComplete(d);
          } else if (this.videoTrackCC !== this.waitingVideoCC)
            this.log(`Waiting fragment cc (${r.cc}) cancelled because video is at cc ${this.videoTrackCC}`), this.clearWaitingFragment();
          else {
            const l = this.getLoadPosition(), d = He.bufferInfo(this.mediaBuffer, l, this.config.maxBufferHole);
            Di(d.end, this.config.maxFragLookUpTolerance, r) < 0 && (this.log(`Waiting fragment cc (${r.cc}) @ ${r.start} cancelled because another fragment at ${d.end} is needed`), this.clearWaitingFragment());
          }
        } else
          this.state = ee.IDLE;
      }
    }
    this.onTickEnd();
  }
  clearWaitingFragment() {
    const e = this.waitingData;
    e && (this.fragmentTracker.removeFragment(e.frag), this.waitingData = null, this.waitingVideoCC = -1, this.state = ee.IDLE);
  }
  resetLoadingState() {
    this.clearWaitingFragment(), super.resetLoadingState();
  }
  onTickEnd() {
    const {
      media: e
    } = this;
    e != null && e.readyState && (this.lastCurrentTime = e.currentTime);
  }
  doTickIdle() {
    const {
      hls: e,
      levels: t,
      media: n,
      trackId: r
    } = this, i = e.config;
    if (!(t != null && t[r]) || !n && (this.startFragRequested || !i.startFragPrefetch))
      return;
    const s = t[r], a = s.details;
    if (!a || a.live && this.levelLastLoaded !== s || this.waitForCdnTuneIn(a)) {
      this.state = ee.WAITING_TRACK;
      return;
    }
    const l = this.mediaBuffer ? this.mediaBuffer : this.media;
    this.bufferFlushed && l && (this.bufferFlushed = !1, this.afterBufferFlushed(l, Ge.AUDIO, be.AUDIO));
    const d = this.getFwdBufferInfo(l, be.AUDIO);
    if (d === null)
      return;
    const {
      bufferedTrack: h,
      switchingTrack: u
    } = this;
    if (!u && this._streamEnded(d, a)) {
      e.trigger(I.BUFFER_EOS, {
        type: "audio"
      }), this.state = ee.ENDED;
      return;
    }
    const c = this.getFwdBufferInfo(this.videoBuffer ? this.videoBuffer : this.media, be.MAIN), m = d.len, f = this.getMaxBufferLength(c == null ? void 0 : c.len), p = a.fragments, A = p[0].start;
    let v = d.end;
    if (u && n) {
      const E = this.getLoadPosition();
      h && u.attrs !== h.attrs && (v = E), a.PTSKnown && E < A && (d.end > A || d.nextStart) && (this.log("Alt audio track ahead of main track, seek to start of alt audio track"), n.currentTime = A + 0.05);
    }
    if (m >= f && !u && v < p[p.length - 1].start)
      return;
    let b = this.getNextFragment(v, a), _ = !1;
    if (b && this.isLoopLoading(b, v) && (_ = !!b.gap, b = this.getNextFragmentLoopLoading(b, a, d, be.MAIN, f)), !b) {
      this.bufferFlushed = !0;
      return;
    }
    const T = c && b.start > c.end + a.targetduration;
    if (T || // Or wait for main buffer after buffing some audio
    !(c != null && c.len) && d.len) {
      const E = this.getAppendedFrag(b.start, be.MAIN);
      if (E === null || (_ || (_ = !!E.gap || !!T && c.len === 0), T && !_ || _ && d.nextStart && d.nextStart < E.end))
        return;
    }
    this.loadFragment(b, s, v);
  }
  getMaxBufferLength(e) {
    const t = super.getMaxBufferLength();
    return e ? Math.min(Math.max(t, e), this.config.maxMaxBufferLength) : t;
  }
  onMediaDetaching() {
    this.videoBuffer = null, super.onMediaDetaching();
  }
  onAudioTracksUpdated(e, {
    audioTracks: t
  }) {
    this.resetTransmuxer(), this.levels = t.map((n) => new rr(n));
  }
  onAudioTrackSwitching(e, t) {
    const n = !!t.url;
    this.trackId = t.id;
    const {
      fragCurrent: r
    } = this;
    r && (r.abortRequests(), this.removeUnbufferedFrags(r.start)), this.resetLoadingState(), n ? this.setInterval(na) : this.resetTransmuxer(), n ? (this.switchingTrack = t, this.state = ee.IDLE, this.flushAudioIfNeeded(t)) : (this.switchingTrack = null, this.bufferedTrack = t, this.state = ee.STOPPED), this.tick();
  }
  onManifestLoading() {
    this.fragmentTracker.removeAllFragments(), this.startPosition = this.lastCurrentTime = 0, this.bufferFlushed = !1, this.levels = this.mainDetails = this.waitingData = this.bufferedTrack = this.cachedTrackLoadedData = this.switchingTrack = null, this.startFragRequested = !1, this.trackId = this.videoTrackCC = this.waitingVideoCC = -1;
  }
  onLevelLoaded(e, t) {
    this.mainDetails = t.details, this.cachedTrackLoadedData !== null && (this.hls.trigger(I.AUDIO_TRACK_LOADED, this.cachedTrackLoadedData), this.cachedTrackLoadedData = null);
  }
  onAudioTrackLoaded(e, t) {
    var n;
    if (this.mainDetails == null) {
      this.cachedTrackLoadedData = t;
      return;
    }
    const {
      levels: r
    } = this, {
      details: i,
      id: s
    } = t;
    if (!r) {
      this.warn(`Audio tracks were reset while loading level ${s}`);
      return;
    }
    this.log(`Track ${s} loaded [${i.startSN},${i.endSN}]${i.lastPartSn ? `[part-${i.lastPartSn}-${i.lastPartIndex}]` : ""},duration:${i.totalduration}`);
    const a = r[s];
    let l = 0;
    if (i.live || (n = a.details) != null && n.live) {
      this.checkLiveUpdate(i);
      const h = this.mainDetails;
      if (i.deltaUpdateFailed || !h)
        return;
      if (!a.details && i.hasProgramDateTime && h.hasProgramDateTime)
        Mr(i, h), l = i.fragments[0].start;
      else {
        var d;
        l = this.alignPlaylists(i, a.details, (d = this.levelLastLoaded) == null ? void 0 : d.details);
      }
    }
    a.details = i, this.levelLastLoaded = a, !this.startFragRequested && (this.mainDetails || !i.live) && this.setStartPosition(a.details, l), this.state === ee.WAITING_TRACK && !this.waitForCdnTuneIn(i) && (this.state = ee.IDLE), this.tick();
  }
  _handleFragmentLoadProgress(e) {
    var t;
    const {
      frag: n,
      part: r,
      payload: i
    } = e, {
      config: s,
      trackId: a,
      levels: l
    } = this;
    if (!l) {
      this.warn(`Audio tracks were reset while fragment load was in progress. Fragment ${n.sn} of level ${n.level} will not be buffered`);
      return;
    }
    const d = l[a];
    if (!d) {
      this.warn("Audio track is undefined on fragment load progress");
      return;
    }
    const h = d.details;
    if (!h) {
      this.warn("Audio track details undefined on fragment load progress"), this.removeUnbufferedFrags(n.start);
      return;
    }
    const u = s.defaultAudioCodec || d.audioCodec || "mp4a.40.2";
    let c = this.transmuxer;
    c || (c = this.transmuxer = new po(this.hls, be.AUDIO, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this)));
    const m = this.initPTS[n.cc], f = (t = n.initSegment) == null ? void 0 : t.data;
    if (m !== void 0) {
      const A = r ? r.index : -1, v = A !== -1, b = new Hi(n.level, n.sn, n.stats.chunkCount, i.byteLength, A, v);
      c.push(i, f, u, "", n, r, h.totalduration, !1, b, m);
    } else {
      this.log(`Unknown video PTS for cc ${n.cc}, waiting for video PTS before demuxing audio frag ${n.sn} of [${h.startSN} ,${h.endSN}],track ${a}`);
      const {
        cache: p
      } = this.waitingData = this.waitingData || {
        frag: n,
        part: r,
        cache: new Xa(),
        complete: !1
      };
      p.push(new Uint8Array(i)), this.waitingVideoCC = this.videoTrackCC, this.state = ee.WAITING_INIT_PTS;
    }
  }
  _handleFragmentLoadComplete(e) {
    if (this.waitingData) {
      this.waitingData.complete = !0;
      return;
    }
    super._handleFragmentLoadComplete(e);
  }
  onBufferReset() {
    this.mediaBuffer = this.videoBuffer = null, this.loadedmetadata = !1;
  }
  onBufferCreated(e, t) {
    const n = t.tracks.audio;
    n && (this.mediaBuffer = n.buffer || null), t.tracks.video && (this.videoBuffer = t.tracks.video.buffer || null);
  }
  onFragBuffered(e, t) {
    const {
      frag: n,
      part: r
    } = t;
    if (n.type !== be.AUDIO) {
      if (!this.loadedmetadata && n.type === be.MAIN) {
        const i = this.videoBuffer || this.media;
        i && He.getBuffered(i).length && (this.loadedmetadata = !0);
      }
      return;
    }
    if (this.fragContextChanged(n)) {
      this.warn(`Fragment ${n.sn}${r ? " p: " + r.index : ""} of level ${n.level} finished buffering, but was aborted. state: ${this.state}, audioSwitch: ${this.switchingTrack ? this.switchingTrack.name : "false"}`);
      return;
    }
    if (n.sn !== "initSegment") {
      this.fragPrevious = n;
      const i = this.switchingTrack;
      i && (this.bufferedTrack = i, this.switchingTrack = null, this.hls.trigger(I.AUDIO_TRACK_SWITCHED, it({}, i)));
    }
    this.fragBufferedComplete(n, r);
  }
  onError(e, t) {
    var n;
    if (t.fatal) {
      this.state = ee.ERROR;
      return;
    }
    switch (t.details) {
      case q.FRAG_GAP:
      case q.FRAG_PARSING_ERROR:
      case q.FRAG_DECRYPT_ERROR:
      case q.FRAG_LOAD_ERROR:
      case q.FRAG_LOAD_TIMEOUT:
      case q.KEY_LOAD_ERROR:
      case q.KEY_LOAD_TIMEOUT:
        this.onFragmentOrKeyLoadError(be.AUDIO, t);
        break;
      case q.AUDIO_TRACK_LOAD_ERROR:
      case q.AUDIO_TRACK_LOAD_TIMEOUT:
      case q.LEVEL_PARSING_ERROR:
        !t.levelRetry && this.state === ee.WAITING_TRACK && ((n = t.context) == null ? void 0 : n.type) === Ue.AUDIO_TRACK && (this.state = ee.IDLE);
        break;
      case q.BUFFER_APPEND_ERROR:
      case q.BUFFER_FULL_ERROR:
        if (!t.parent || t.parent !== "audio")
          return;
        if (t.details === q.BUFFER_APPEND_ERROR) {
          this.resetLoadingState();
          return;
        }
        this.reduceLengthAndFlushBuffer(t) && (this.bufferedTrack = null, super.flushMainBuffer(0, Number.POSITIVE_INFINITY, "audio"));
        break;
      case q.INTERNAL_EXCEPTION:
        this.recoverWorkerError(t);
        break;
    }
  }
  onBufferFlushed(e, {
    type: t
  }) {
    if (t === Ge.AUDIO) {
      this.bufferFlushed = !0, this.state === ee.ENDED && (this.state = ee.IDLE);
      const n = this.mediaBuffer || this.media;
      n && (this.afterBufferFlushed(n, t, be.AUDIO), this.tick());
    }
  }
  _handleTransmuxComplete(e) {
    var t;
    const n = "audio", {
      hls: r
    } = this, {
      remuxResult: i,
      chunkMeta: s
    } = e, a = this.getCurrentContext(s);
    if (!a) {
      this.resetWhenMissingContext(s);
      return;
    }
    const {
      frag: l,
      part: d,
      level: h
    } = a, {
      details: u
    } = h, {
      audio: c,
      text: m,
      id3: f,
      initSegment: p
    } = i;
    if (this.fragContextChanged(l) || !u) {
      this.fragmentTracker.removeFragment(l);
      return;
    }
    if (this.state = ee.PARSING, this.switchingTrack && c && this.completeAudioSwitch(this.switchingTrack), p != null && p.tracks) {
      const A = l.initSegment || l;
      this._bufferInitSegment(h, p.tracks, A, s), r.trigger(I.FRAG_PARSING_INIT_SEGMENT, {
        frag: A,
        id: n,
        tracks: p.tracks
      });
    }
    if (c) {
      const {
        startPTS: A,
        endPTS: v,
        startDTS: b,
        endDTS: _
      } = c;
      d && (d.elementaryStreams[Ge.AUDIO] = {
        startPTS: A,
        endPTS: v,
        startDTS: b,
        endDTS: _
      }), l.setElementaryStreamInfo(Ge.AUDIO, A, v, b, _), this.bufferFragmentData(c, l, d, s);
    }
    if (f != null && (t = f.samples) != null && t.length) {
      const A = lt({
        id: n,
        frag: l,
        details: u
      }, f);
      r.trigger(I.FRAG_PARSING_METADATA, A);
    }
    if (m) {
      const A = lt({
        id: n,
        frag: l,
        details: u
      }, m);
      r.trigger(I.FRAG_PARSING_USERDATA, A);
    }
  }
  _bufferInitSegment(e, t, n, r) {
    if (this.state !== ee.PARSING)
      return;
    t.video && delete t.video;
    const i = t.audio;
    if (!i)
      return;
    i.id = "audio";
    const s = e.audioCodec;
    this.log(`Init audio buffer, container:${i.container}, codecs[level/parsed]=[${s}/${i.codec}]`), s && s.split(",").length === 1 && (i.levelCodec = s), this.hls.trigger(I.BUFFER_CODECS, t);
    const a = i.initSegment;
    if (a != null && a.byteLength) {
      const l = {
        type: "audio",
        frag: n,
        part: null,
        chunkMeta: r,
        parent: n.type,
        data: a
      };
      this.hls.trigger(I.BUFFER_APPENDING, l);
    }
    this.tickImmediate();
  }
  loadFragment(e, t, n) {
    const r = this.fragmentTracker.getState(e);
    if (this.fragCurrent = e, this.switchingTrack || r === dt.NOT_LOADED || r === dt.PARTIAL) {
      var i;
      if (e.sn === "initSegment")
        this._loadInitSegment(e, t);
      else if ((i = t.details) != null && i.live && !this.initPTS[e.cc]) {
        this.log(`Waiting for video PTS in continuity counter ${e.cc} of live stream before loading audio fragment ${e.sn} of level ${this.trackId}`), this.state = ee.WAITING_INIT_PTS;
        const s = this.mainDetails;
        s && s.fragments[0].start !== t.details.fragments[0].start && Mr(t.details, s);
      } else
        this.startFragRequested = !0, super.loadFragment(e, t, n);
    } else
      this.clearTrackerIfNeeded(e);
  }
  flushAudioIfNeeded(e) {
    const {
      media: t,
      bufferedTrack: n
    } = this, r = n == null ? void 0 : n.attrs, i = e.attrs;
    t && r && (r.CHANNELS !== i.CHANNELS || n.name !== e.name || n.lang !== e.lang) && (this.log("Switching audio track : flushing all audio"), super.flushMainBuffer(0, Number.POSITIVE_INFINITY, "audio"), this.bufferedTrack = null);
  }
  completeAudioSwitch(e) {
    const {
      hls: t
    } = this;
    this.flushAudioIfNeeded(e), this.bufferedTrack = e, this.switchingTrack = null, t.trigger(I.AUDIO_TRACK_SWITCHED, it({}, e));
  }
}
class yh extends Wi {
  constructor(e) {
    super(e, "[audio-track-controller]"), this.tracks = [], this.groupId = null, this.tracksInGroup = [], this.trackId = -1, this.currentTrack = null, this.selectDefaultTrack = !0, this.registerListeners();
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(I.MANIFEST_LOADING, this.onManifestLoading, this), e.on(I.MANIFEST_PARSED, this.onManifestParsed, this), e.on(I.LEVEL_LOADING, this.onLevelLoading, this), e.on(I.LEVEL_SWITCHING, this.onLevelSwitching, this), e.on(I.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.on(I.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(I.MANIFEST_LOADING, this.onManifestLoading, this), e.off(I.MANIFEST_PARSED, this.onManifestParsed, this), e.off(I.LEVEL_LOADING, this.onLevelLoading, this), e.off(I.LEVEL_SWITCHING, this.onLevelSwitching, this), e.off(I.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.off(I.ERROR, this.onError, this);
  }
  destroy() {
    this.unregisterListeners(), this.tracks.length = 0, this.tracksInGroup.length = 0, this.currentTrack = null, super.destroy();
  }
  onManifestLoading() {
    this.tracks = [], this.groupId = null, this.tracksInGroup = [], this.trackId = -1, this.currentTrack = null, this.selectDefaultTrack = !0;
  }
  onManifestParsed(e, t) {
    this.tracks = t.audioTracks || [];
  }
  onAudioTrackLoaded(e, t) {
    const {
      id: n,
      groupId: r,
      details: i
    } = t, s = this.tracksInGroup[n];
    if (!s || s.groupId !== r) {
      this.warn(`Track with id:${n} and group:${r} not found in active group ${s.groupId}`);
      return;
    }
    const a = s.details;
    s.details = t.details, this.log(`audio-track ${n} "${s.name}" lang:${s.lang} group:${r} loaded [${i.startSN}-${i.endSN}]`), n === this.trackId && this.playlistLoaded(n, t, a);
  }
  onLevelLoading(e, t) {
    this.switchLevel(t.level);
  }
  onLevelSwitching(e, t) {
    this.switchLevel(t.level);
  }
  switchLevel(e) {
    const t = this.hls.levels[e];
    if (!(t != null && t.audioGroupIds))
      return;
    const n = t.audioGroupIds[t.urlId];
    if (this.groupId !== n) {
      this.groupId = n || null;
      const r = this.tracks.filter((s) => !n || s.groupId === n);
      this.selectDefaultTrack && !r.some((s) => s.default) && (this.selectDefaultTrack = !1), this.tracksInGroup = r;
      const i = {
        audioTracks: r
      };
      this.log(`Updating audio tracks, ${r.length} track(s) found in group:${n}`), this.hls.trigger(I.AUDIO_TRACKS_UPDATED, i), this.selectInitialTrack();
    } else
      this.shouldReloadPlaylist(this.currentTrack) && this.setAudioTrack(this.trackId);
  }
  onError(e, t) {
    t.fatal || !t.context || t.context.type === Ue.AUDIO_TRACK && t.context.id === this.trackId && t.context.groupId === this.groupId && (this.requestScheduled = -1, this.checkRetry(t));
  }
  get allAudioTracks() {
    return this.tracks;
  }
  get audioTracks() {
    return this.tracksInGroup;
  }
  get audioTrack() {
    return this.trackId;
  }
  set audioTrack(e) {
    this.selectDefaultTrack = !1, this.setAudioTrack(e);
  }
  setAudioTrack(e) {
    const t = this.tracksInGroup;
    if (e < 0 || e >= t.length) {
      this.warn("Invalid id passed to audio-track controller");
      return;
    }
    this.clearTimer();
    const n = this.currentTrack;
    t[this.trackId];
    const r = t[e], {
      groupId: i,
      name: s
    } = r;
    if (this.log(`Switching to audio-track ${e} "${s}" lang:${r.lang} group:${i}`), this.trackId = e, this.currentTrack = r, this.selectDefaultTrack = !1, this.hls.trigger(I.AUDIO_TRACK_SWITCHING, it({}, r)), r.details && !r.details.live)
      return;
    const a = this.switchParams(r.url, n == null ? void 0 : n.details);
    this.loadPlaylist(a);
  }
  selectInitialTrack() {
    const e = this.tracksInGroup;
    let t = this.findTrackId(this.currentTrack);
    if (t === -1 && (t = this.findTrackId(null)), t !== -1)
      this.setAudioTrack(t);
    else {
      const n = new Error(`No track found for running audio group-ID: ${this.groupId} track count: ${e.length}`);
      this.warn(n.message), this.hls.trigger(I.ERROR, {
        type: xe.MEDIA_ERROR,
        details: q.AUDIO_TRACK_LOAD_ERROR,
        fatal: !0,
        error: n
      });
    }
  }
  findTrackId(e) {
    const t = this.tracksInGroup;
    for (let n = 0; n < t.length; n++) {
      const r = t[n];
      if ((!this.selectDefaultTrack || r.default) && (!e || e.attrs["STABLE-RENDITION-ID"] !== void 0 && e.attrs["STABLE-RENDITION-ID"] === r.attrs["STABLE-RENDITION-ID"] || e.name === r.name && e.lang === r.lang))
        return r.id;
    }
    return -1;
  }
  loadPlaylist(e) {
    super.loadPlaylist();
    const t = this.tracksInGroup[this.trackId];
    if (this.shouldLoadPlaylist(t)) {
      const n = t.id, r = t.groupId;
      let i = t.url;
      if (e)
        try {
          i = e.addDirectives(i);
        } catch (s) {
          this.warn(`Could not construct new URL with HLS Delivery Directives: ${s}`);
        }
      this.log(`loading audio-track playlist ${n} "${t.name}" lang:${t.lang} group:${r}`), this.clearTimer(), this.hls.trigger(I.AUDIO_TRACK_LOADING, {
        url: i,
        id: n,
        groupId: r,
        deliveryDirectives: e || null
      });
    }
  }
}
function mo(o, e) {
  if (o.length !== e.length)
    return !1;
  for (let t = 0; t < o.length; t++)
    if (!Ah(o[t].attrs, e[t].attrs))
      return !1;
  return !0;
}
function Ah(o, e) {
  const t = o["STABLE-RENDITION-ID"];
  return t ? t === e["STABLE-RENDITION-ID"] : !["LANGUAGE", "NAME", "CHARACTERISTICS", "AUTOSELECT", "DEFAULT", "FORCED"].some((n) => o[n] !== e[n]);
}
const ra = 500;
class vh extends Yi {
  constructor(e, t, n) {
    super(e, t, n, "[subtitle-stream-controller]", be.SUBTITLE), this.levels = [], this.currentTrackId = -1, this.tracksBuffered = [], this.mainDetails = null, this._registerListeners();
  }
  onHandlerDestroying() {
    this._unregisterListeners(), this.mainDetails = null;
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(I.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(I.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(I.MANIFEST_LOADING, this.onManifestLoading, this), e.on(I.LEVEL_LOADED, this.onLevelLoaded, this), e.on(I.ERROR, this.onError, this), e.on(I.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.on(I.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), e.on(I.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.on(I.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this), e.on(I.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(I.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(I.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(I.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(I.MANIFEST_LOADING, this.onManifestLoading, this), e.off(I.LEVEL_LOADED, this.onLevelLoaded, this), e.off(I.ERROR, this.onError, this), e.off(I.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.off(I.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), e.off(I.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.off(I.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this), e.off(I.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(I.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  startLoad(e) {
    this.stopLoad(), this.state = ee.IDLE, this.setInterval(ra), this.nextLoadPosition = this.startPosition = this.lastCurrentTime = e, this.tick();
  }
  onManifestLoading() {
    this.mainDetails = null, this.fragmentTracker.removeAllFragments();
  }
  onMediaDetaching() {
    this.tracksBuffered = [], super.onMediaDetaching();
  }
  onLevelLoaded(e, t) {
    this.mainDetails = t.details;
  }
  onSubtitleFragProcessed(e, t) {
    const {
      frag: n,
      success: r
    } = t;
    if (this.fragPrevious = n, this.state = ee.IDLE, !r)
      return;
    const i = this.tracksBuffered[this.currentTrackId];
    if (!i)
      return;
    let s;
    const a = n.start;
    for (let d = 0; d < i.length; d++)
      if (a >= i[d].start && a <= i[d].end) {
        s = i[d];
        break;
      }
    const l = n.start + n.duration;
    s ? s.end = l : (s = {
      start: a,
      end: l
    }, i.push(s)), this.fragmentTracker.fragBuffered(n), this.fragBufferedComplete(n, null);
  }
  onBufferFlushing(e, t) {
    const {
      startOffset: n,
      endOffset: r
    } = t;
    if (n === 0 && r !== Number.POSITIVE_INFINITY) {
      const i = r - 1;
      if (i <= 0)
        return;
      t.endOffsetSubtitles = Math.max(0, i), this.tracksBuffered.forEach((s) => {
        for (let a = 0; a < s.length; ) {
          if (s[a].end <= i) {
            s.shift();
            continue;
          } else if (s[a].start < i)
            s[a].start = i;
          else
            break;
          a++;
        }
      }), this.fragmentTracker.removeFragmentsInRange(n, i, be.SUBTITLE);
    }
  }
  onFragBuffered(e, t) {
    if (!this.loadedmetadata && t.frag.type === be.MAIN) {
      var n;
      (n = this.media) != null && n.buffered.length && (this.loadedmetadata = !0);
    }
  }
  // If something goes wrong, proceed to next frag, if we were processing one.
  onError(e, t) {
    const n = t.frag;
    (n == null ? void 0 : n.type) === be.SUBTITLE && (this.fragCurrent && this.fragCurrent.abortRequests(), this.state !== ee.STOPPED && (this.state = ee.IDLE));
  }
  // Got all new subtitle levels.
  onSubtitleTracksUpdated(e, {
    subtitleTracks: t
  }) {
    if (mo(this.levels, t)) {
      this.levels = t.map((n) => new rr(n));
      return;
    }
    this.tracksBuffered = [], this.levels = t.map((n) => {
      const r = new rr(n);
      return this.tracksBuffered[r.id] = [], r;
    }), this.fragmentTracker.removeFragmentsInRange(0, Number.POSITIVE_INFINITY, be.SUBTITLE), this.fragPrevious = null, this.mediaBuffer = null;
  }
  onSubtitleTrackSwitch(e, t) {
    if (this.currentTrackId = t.id, !this.levels.length || this.currentTrackId === -1) {
      this.clearInterval();
      return;
    }
    const n = this.levels[this.currentTrackId];
    n != null && n.details ? this.mediaBuffer = this.mediaBufferTimeRanges : this.mediaBuffer = null, n && this.setInterval(ra);
  }
  // Got a new set of subtitle fragments.
  onSubtitleTrackLoaded(e, t) {
    var n;
    const {
      details: r,
      id: i
    } = t, {
      currentTrackId: s,
      levels: a
    } = this;
    if (!a.length)
      return;
    const l = a[s];
    if (i >= a.length || i !== s || !l)
      return;
    this.mediaBuffer = this.mediaBufferTimeRanges;
    let d = 0;
    if (r.live || (n = l.details) != null && n.live) {
      const u = this.mainDetails;
      if (r.deltaUpdateFailed || !u)
        return;
      const c = u.fragments[0];
      if (!l.details)
        r.hasProgramDateTime && u.hasProgramDateTime ? (Mr(r, u), d = r.fragments[0].start) : c && (d = c.start, ki(r, d));
      else {
        var h;
        d = this.alignPlaylists(r, l.details, (h = this.levelLastLoaded) == null ? void 0 : h.details), d === 0 && c && (d = c.start, ki(r, d));
      }
    }
    l.details = r, this.levelLastLoaded = l, !this.startFragRequested && (this.mainDetails || !r.live) && this.setStartPosition(l.details, d), this.tick(), r.live && !this.fragCurrent && this.media && this.state === ee.IDLE && (ir(null, r.fragments, this.media.currentTime, 0) || (this.warn("Subtitle playlist not aligned with playback"), l.details = void 0));
  }
  _handleFragmentLoadComplete(e) {
    const {
      frag: t,
      payload: n
    } = e, r = t.decryptdata, i = this.hls;
    if (!this.fragContextChanged(t) && n && n.byteLength > 0 && r && r.key && r.iv && r.method === "AES-128") {
      const s = performance.now();
      this.decrypter.decrypt(new Uint8Array(n), r.key.buffer, r.iv.buffer).catch((a) => {
        throw i.trigger(I.ERROR, {
          type: xe.MEDIA_ERROR,
          details: q.FRAG_DECRYPT_ERROR,
          fatal: !1,
          error: a,
          reason: a.message,
          frag: t
        }), a;
      }).then((a) => {
        const l = performance.now();
        i.trigger(I.FRAG_DECRYPTED, {
          frag: t,
          payload: a,
          stats: {
            tstart: s,
            tdecrypt: l
          }
        });
      }).catch((a) => {
        this.warn(`${a.name}: ${a.message}`), this.state = ee.IDLE;
      });
    }
  }
  doTick() {
    if (!this.media) {
      this.state = ee.IDLE;
      return;
    }
    if (this.state === ee.IDLE) {
      const {
        currentTrackId: e,
        levels: t
      } = this, n = t[e];
      if (!t.length || !n || !n.details)
        return;
      const {
        config: r
      } = this, i = this.getLoadPosition(), s = He.bufferedInfo(this.tracksBuffered[this.currentTrackId] || [], i, r.maxBufferHole), {
        end: a,
        len: l
      } = s, d = this.getFwdBufferInfo(this.media, be.MAIN), h = n.details, u = this.getMaxBufferLength(d == null ? void 0 : d.len) + h.levelTargetDuration;
      if (l > u)
        return;
      const c = h.fragments, m = c.length, f = h.edge;
      let p = null;
      const A = this.fragPrevious;
      if (a < f) {
        const v = r.maxFragLookUpTolerance, b = a > f - v ? 0 : v;
        p = ir(A, c, Math.max(c[0].start, a), b), !p && A && A.start < c[0].start && (p = c[0]);
      } else
        p = c[m - 1];
      if (!p)
        return;
      if (p = this.mapToInitFragWhenRequired(p), p.sn !== "initSegment") {
        const v = p.sn - h.startSN, b = c[v - 1];
        b && b.cc === p.cc && this.fragmentTracker.getState(b) === dt.NOT_LOADED && (p = b);
      }
      this.fragmentTracker.getState(p) === dt.NOT_LOADED && this.loadFragment(p, n, a);
    }
  }
  getMaxBufferLength(e) {
    const t = super.getMaxBufferLength();
    return e ? Math.max(t, e) : t;
  }
  loadFragment(e, t, n) {
    this.fragCurrent = e, e.sn === "initSegment" ? this._loadInitSegment(e, t) : (this.startFragRequested = !0, super.loadFragment(e, t, n));
  }
  get mediaBufferTimeRanges() {
    return new bh(this.tracksBuffered[this.currentTrackId] || []);
  }
}
class bh {
  constructor(e) {
    this.buffered = void 0;
    const t = (n, r, i) => {
      if (r = r >>> 0, r > i - 1)
        throw new DOMException(`Failed to execute '${n}' on 'TimeRanges': The index provided (${r}) is greater than the maximum bound (${i})`);
      return e[r][n];
    };
    this.buffered = {
      get length() {
        return e.length;
      },
      end(n) {
        return t("end", n, e.length);
      },
      start(n) {
        return t("start", n, e.length);
      }
    };
  }
}
class xh extends Wi {
  constructor(e) {
    super(e, "[subtitle-track-controller]"), this.media = null, this.tracks = [], this.groupId = null, this.tracksInGroup = [], this.trackId = -1, this.selectDefaultTrack = !0, this.queuedDefaultTrack = -1, this.trackChangeListener = () => this.onTextTracksChanged(), this.asyncPollTrackChange = () => this.pollTrackChange(0), this.useTextTrackPolling = !1, this.subtitlePollingInterval = -1, this._subtitleDisplay = !0, this.registerListeners();
  }
  destroy() {
    this.unregisterListeners(), this.tracks.length = 0, this.tracksInGroup.length = 0, this.trackChangeListener = this.asyncPollTrackChange = null, super.destroy();
  }
  get subtitleDisplay() {
    return this._subtitleDisplay;
  }
  set subtitleDisplay(e) {
    this._subtitleDisplay = e, this.trackId > -1 && this.toggleTrackModes(this.trackId);
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(I.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(I.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(I.MANIFEST_LOADING, this.onManifestLoading, this), e.on(I.MANIFEST_PARSED, this.onManifestParsed, this), e.on(I.LEVEL_LOADING, this.onLevelLoading, this), e.on(I.LEVEL_SWITCHING, this.onLevelSwitching, this), e.on(I.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.on(I.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(I.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(I.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(I.MANIFEST_LOADING, this.onManifestLoading, this), e.off(I.MANIFEST_PARSED, this.onManifestParsed, this), e.off(I.LEVEL_LOADING, this.onLevelLoading, this), e.off(I.LEVEL_SWITCHING, this.onLevelSwitching, this), e.off(I.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.off(I.ERROR, this.onError, this);
  }
  // Listen for subtitle track change, then extract the current track ID.
  onMediaAttached(e, t) {
    this.media = t.media, this.media && (this.queuedDefaultTrack > -1 && (this.subtitleTrack = this.queuedDefaultTrack, this.queuedDefaultTrack = -1), this.useTextTrackPolling = !(this.media.textTracks && "onchange" in this.media.textTracks), this.useTextTrackPolling ? this.pollTrackChange(500) : this.media.textTracks.addEventListener("change", this.asyncPollTrackChange));
  }
  pollTrackChange(e) {
    self.clearInterval(this.subtitlePollingInterval), this.subtitlePollingInterval = self.setInterval(this.trackChangeListener, e);
  }
  onMediaDetaching() {
    if (!this.media)
      return;
    self.clearInterval(this.subtitlePollingInterval), this.useTextTrackPolling || this.media.textTracks.removeEventListener("change", this.asyncPollTrackChange), this.trackId > -1 && (this.queuedDefaultTrack = this.trackId), hi(this.media.textTracks).forEach((t) => {
      _n(t);
    }), this.subtitleTrack = -1, this.media = null;
  }
  onManifestLoading() {
    this.tracks = [], this.groupId = null, this.tracksInGroup = [], this.trackId = -1, this.selectDefaultTrack = !0;
  }
  // Fired whenever a new manifest is loaded.
  onManifestParsed(e, t) {
    this.tracks = t.subtitleTracks;
  }
  onSubtitleTrackLoaded(e, t) {
    const {
      id: n,
      details: r
    } = t, {
      trackId: i
    } = this, s = this.tracksInGroup[i];
    if (!s) {
      this.warn(`Invalid subtitle track id ${n}`);
      return;
    }
    const a = s.details;
    s.details = t.details, this.log(`subtitle track ${n} loaded [${r.startSN}-${r.endSN}]`), n === this.trackId && this.playlistLoaded(n, t, a);
  }
  onLevelLoading(e, t) {
    this.switchLevel(t.level);
  }
  onLevelSwitching(e, t) {
    this.switchLevel(t.level);
  }
  switchLevel(e) {
    const t = this.hls.levels[e];
    if (!(t != null && t.textGroupIds))
      return;
    const n = t.textGroupIds[t.urlId], r = this.tracksInGroup ? this.tracksInGroup[this.trackId] : void 0;
    if (this.groupId !== n) {
      const i = this.tracks.filter((l) => !n || l.groupId === n);
      this.tracksInGroup = i;
      const s = this.findTrackId(r == null ? void 0 : r.name) || this.findTrackId();
      this.groupId = n || null;
      const a = {
        subtitleTracks: i
      };
      this.log(`Updating subtitle tracks, ${i.length} track(s) found in "${n}" group-id`), this.hls.trigger(I.SUBTITLE_TRACKS_UPDATED, a), s !== -1 && this.setSubtitleTrack(s, r);
    } else
      this.shouldReloadPlaylist(r) && this.setSubtitleTrack(this.trackId, r);
  }
  findTrackId(e) {
    const t = this.tracksInGroup;
    for (let n = 0; n < t.length; n++) {
      const r = t[n];
      if ((!this.selectDefaultTrack || r.default) && (!e || e === r.name))
        return r.id;
    }
    return -1;
  }
  onError(e, t) {
    t.fatal || !t.context || t.context.type === Ue.SUBTITLE_TRACK && t.context.id === this.trackId && t.context.groupId === this.groupId && this.checkRetry(t);
  }
  get allSubtitleTracks() {
    return this.tracks;
  }
  /** get alternate subtitle tracks list from playlist **/
  get subtitleTracks() {
    return this.tracksInGroup;
  }
  /** get/set index of the selected subtitle track (based on index in subtitle track lists) **/
  get subtitleTrack() {
    return this.trackId;
  }
  set subtitleTrack(e) {
    this.selectDefaultTrack = !1;
    const t = this.tracksInGroup ? this.tracksInGroup[this.trackId] : void 0;
    this.setSubtitleTrack(e, t);
  }
  loadPlaylist(e) {
    super.loadPlaylist();
    const t = this.tracksInGroup[this.trackId];
    if (this.shouldLoadPlaylist(t)) {
      const n = t.id, r = t.groupId;
      let i = t.url;
      if (e)
        try {
          i = e.addDirectives(i);
        } catch (s) {
          this.warn(`Could not construct new URL with HLS Delivery Directives: ${s}`);
        }
      this.log(`Loading subtitle playlist for id ${n}`), this.hls.trigger(I.SUBTITLE_TRACK_LOADING, {
        url: i,
        id: n,
        groupId: r,
        deliveryDirectives: e || null
      });
    }
  }
  /**
   * Disables the old subtitleTrack and sets current mode on the next subtitleTrack.
   * This operates on the DOM textTracks.
   * A value of -1 will disable all subtitle tracks.
   */
  toggleTrackModes(e) {
    const {
      media: t,
      trackId: n
    } = this;
    if (!t)
      return;
    const r = hi(t.textTracks), i = r.filter((a) => a.groupId === this.groupId);
    if (e === -1)
      [].slice.call(r).forEach((a) => {
        a.mode = "disabled";
      });
    else {
      const a = i[n];
      a && (a.mode = "disabled");
    }
    const s = i[e];
    s && (s.mode = this.subtitleDisplay ? "showing" : "hidden");
  }
  /**
   * This method is responsible for validating the subtitle index and periodically reloading if live.
   * Dispatches the SUBTITLE_TRACK_SWITCH event, which instructs the subtitle-stream-controller to load the selected track.
   */
  setSubtitleTrack(e, t) {
    var n;
    const r = this.tracksInGroup;
    if (!this.media) {
      this.queuedDefaultTrack = e;
      return;
    }
    if (this.trackId !== e && this.toggleTrackModes(e), this.trackId === e && (e === -1 || (n = r[e]) != null && n.details) || e < -1 || e >= r.length)
      return;
    this.clearTimer();
    const i = r[e];
    if (this.log(`Switching to subtitle-track ${e}` + (i ? ` "${i.name}" lang:${i.lang} group:${i.groupId}` : "")), this.trackId = e, i) {
      const {
        id: s,
        groupId: a = "",
        name: l,
        type: d,
        url: h
      } = i;
      this.hls.trigger(I.SUBTITLE_TRACK_SWITCH, {
        id: s,
        groupId: a,
        name: l,
        type: d,
        url: h
      });
      const u = this.switchParams(i.url, t == null ? void 0 : t.details);
      this.loadPlaylist(u);
    } else
      this.hls.trigger(I.SUBTITLE_TRACK_SWITCH, {
        id: e
      });
  }
  onTextTracksChanged() {
    if (this.useTextTrackPolling || self.clearInterval(this.subtitlePollingInterval), !this.media || !this.hls.config.renderTextTracksNatively)
      return;
    let e = -1;
    const t = hi(this.media.textTracks);
    for (let n = 0; n < t.length; n++)
      if (t[n].mode === "hidden")
        e = n;
      else if (t[n].mode === "showing") {
        e = n;
        break;
      }
    this.subtitleTrack !== e && (this.subtitleTrack = e);
  }
}
function hi(o) {
  const e = [];
  for (let t = 0; t < o.length; t++) {
    const n = o[t];
    (n.kind === "subtitles" || n.kind === "captions") && n.label && e.push(o[t]);
  }
  return e;
}
class Eh {
  constructor(e) {
    this.buffers = void 0, this.queues = {
      video: [],
      audio: [],
      audiovideo: []
    }, this.buffers = e;
  }
  append(e, t, n) {
    const r = this.queues[t];
    r.push(e), r.length === 1 && !n && this.executeNext(t);
  }
  insertAbort(e, t) {
    this.queues[t].unshift(e), this.executeNext(t);
  }
  appendBlocker(e) {
    let t;
    const n = new Promise((i) => {
      t = i;
    }), r = {
      execute: t,
      onStart: () => {
      },
      onComplete: () => {
      },
      onError: () => {
      }
    };
    return this.append(r, e), n;
  }
  executeNext(e) {
    const t = this.queues[e];
    if (t.length) {
      const n = t[0];
      try {
        n.execute();
      } catch (r) {
        V.warn(`[buffer-operation-queue]: Exception executing "${e}" SourceBuffer operation: ${r}`), n.onError(r);
        const i = this.buffers[e];
        i != null && i.updating || this.shiftAndExecuteNext(e);
      }
    }
  }
  shiftAndExecuteNext(e) {
    this.queues[e].shift(), this.executeNext(e);
  }
  current(e) {
    return this.queues[e][0];
  }
}
class sr {
  constructor(e) {
    this.hls = void 0, this.autoLevelCapping = void 0, this.firstLevel = void 0, this.media = void 0, this.restrictedLevels = void 0, this.timer = void 0, this.clientRect = void 0, this.streamController = void 0, this.hls = e, this.autoLevelCapping = Number.POSITIVE_INFINITY, this.firstLevel = -1, this.media = null, this.restrictedLevels = [], this.timer = void 0, this.clientRect = null, this.registerListeners();
  }
  setStreamController(e) {
    this.streamController = e;
  }
  destroy() {
    this.hls && this.unregisterListener(), this.timer && this.stopCapping(), this.media = null, this.clientRect = null, this.hls = this.streamController = null;
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(I.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this), e.on(I.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(I.MANIFEST_PARSED, this.onManifestParsed, this), e.on(I.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(I.BUFFER_CODECS, this.onBufferCodecs, this), e.on(I.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  unregisterListener() {
    const {
      hls: e
    } = this;
    e.off(I.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this), e.off(I.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(I.MANIFEST_PARSED, this.onManifestParsed, this), e.off(I.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(I.BUFFER_CODECS, this.onBufferCodecs, this), e.off(I.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  onFpsDropLevelCapping(e, t) {
    const n = this.hls.levels[t.droppedLevel];
    this.isLevelAllowed(n) && this.restrictedLevels.push({
      bitrate: n.bitrate,
      height: n.height,
      width: n.width
    });
  }
  onMediaAttaching(e, t) {
    this.media = t.media instanceof HTMLVideoElement ? t.media : null, this.clientRect = null, this.timer && this.hls.levels.length && this.detectPlayerSize();
  }
  onManifestParsed(e, t) {
    const n = this.hls;
    this.restrictedLevels = [], this.firstLevel = t.firstLevel, n.config.capLevelToPlayerSize && t.video && this.startCapping();
  }
  onLevelsUpdated(e, t) {
    this.timer && ge(this.autoLevelCapping) && this.detectPlayerSize();
  }
  // Only activate capping when playing a video stream; otherwise, multi-bitrate audio-only streams will be restricted
  // to the first level
  onBufferCodecs(e, t) {
    this.hls.config.capLevelToPlayerSize && t.video && this.startCapping();
  }
  onMediaDetaching() {
    this.stopCapping();
  }
  detectPlayerSize() {
    if (this.media) {
      if (this.mediaHeight <= 0 || this.mediaWidth <= 0) {
        this.clientRect = null;
        return;
      }
      const e = this.hls.levels;
      if (e.length) {
        const t = this.hls, n = this.getMaxLevel(e.length - 1);
        n !== this.autoLevelCapping && V.log(`Setting autoLevelCapping to ${n}: ${e[n].height}p@${e[n].bitrate} for media ${this.mediaWidth}x${this.mediaHeight}`), t.autoLevelCapping = n, t.autoLevelCapping > this.autoLevelCapping && this.streamController && this.streamController.nextLevelSwitch(), this.autoLevelCapping = t.autoLevelCapping;
      }
    }
  }
  /*
   * returns level should be the one with the dimensions equal or greater than the media (player) dimensions (so the video will be downscaled)
   */
  getMaxLevel(e) {
    const t = this.hls.levels;
    if (!t.length)
      return -1;
    const n = t.filter((r, i) => this.isLevelAllowed(r) && i <= e);
    return this.clientRect = null, sr.getMaxLevelByMediaSize(n, this.mediaWidth, this.mediaHeight);
  }
  startCapping() {
    this.timer || (this.autoLevelCapping = Number.POSITIVE_INFINITY, self.clearInterval(this.timer), this.timer = self.setInterval(this.detectPlayerSize.bind(this), 1e3), this.detectPlayerSize());
  }
  stopCapping() {
    this.restrictedLevels = [], this.firstLevel = -1, this.autoLevelCapping = Number.POSITIVE_INFINITY, this.timer && (self.clearInterval(this.timer), this.timer = void 0);
  }
  getDimensions() {
    if (this.clientRect)
      return this.clientRect;
    const e = this.media, t = {
      width: 0,
      height: 0
    };
    if (e) {
      const n = e.getBoundingClientRect();
      t.width = n.width, t.height = n.height, !t.width && !t.height && (t.width = n.right - n.left || e.width || 0, t.height = n.bottom - n.top || e.height || 0);
    }
    return this.clientRect = t, t;
  }
  get mediaWidth() {
    return this.getDimensions().width * this.contentScaleFactor;
  }
  get mediaHeight() {
    return this.getDimensions().height * this.contentScaleFactor;
  }
  get contentScaleFactor() {
    let e = 1;
    if (!this.hls.config.ignoreDevicePixelRatio)
      try {
        e = self.devicePixelRatio;
      } catch {
      }
    return e;
  }
  isLevelAllowed(e) {
    return !this.restrictedLevels.some((n) => e.bitrate === n.bitrate && e.width === n.width && e.height === n.height);
  }
  static getMaxLevelByMediaSize(e, t, n) {
    if (!(e != null && e.length))
      return -1;
    const r = (a, l) => l ? a.width !== l.width || a.height !== l.height : !0;
    let i = e.length - 1;
    const s = Math.max(t, n);
    for (let a = 0; a < e.length; a += 1) {
      const l = e[a];
      if ((l.width >= s || l.height >= s) && r(l, e[a + 1])) {
        i = a;
        break;
      }
    }
    return i;
  }
}
const ia = /(avc[1234]|hvc1|hev1|dvh[1e]|vp09|av01)(?:\.[^.,]+)+/;
class _h {
  constructor(e) {
    this.details = null, this._objectUrl = null, this.operationQueue = void 0, this.listeners = void 0, this.hls = void 0, this.bufferCodecEventsExpected = 0, this._bufferCodecEventsTotal = 0, this.media = null, this.mediaSource = null, this.lastMpegAudioChunk = null, this.appendSource = void 0, this.appendErrors = {
      audio: 0,
      video: 0,
      audiovideo: 0
    }, this.tracks = {}, this.pendingTracks = {}, this.sourceBuffer = void 0, this.log = void 0, this.warn = void 0, this.error = void 0, this._onEndStreaming = (n) => {
      this.hls.pauseBuffering();
    }, this._onStartStreaming = (n) => {
      const {
        hls: r,
        mediaSource: i
      } = this;
      !r || !i || ("quality" in i && (i.quality === "low" ? r.autoLevelCapping = sr.getMaxLevelByMediaSize(r.levels, 1280, 720) : i.quality === "medium" ? r.autoLevelCapping = sr.getMaxLevelByMediaSize(r.levels, 1920, 1080) : r.autoLevelCapping = -1), r.resumeBuffering());
    }, this._onMediaSourceOpen = () => {
      const {
        media: n,
        mediaSource: r
      } = this;
      this.log("Media source opened"), n && (n.removeEventListener("emptied", this._onMediaEmptied), this.updateMediaElementDuration(), this.hls.trigger(I.MEDIA_ATTACHED, {
        media: n,
        mediaSource: r
      })), r && r.removeEventListener("sourceopen", this._onMediaSourceOpen), this.checkPendingTracks();
    }, this._onMediaSourceClose = () => {
      this.log("Media source closed");
    }, this._onMediaSourceEnded = () => {
      this.log("Media source ended");
    }, this._onMediaEmptied = () => {
      const {
        mediaSrc: n,
        _objectUrl: r
      } = this;
      n !== r && V.error(`Media element src was set while attaching MediaSource (${r} > ${n})`);
    }, this.hls = e;
    const t = "[buffer-controller]";
    this.appendSource = e.config.preferManagedMediaSource, this.log = V.log.bind(V, t), this.warn = V.warn.bind(V, t), this.error = V.error.bind(V, t), this._initSourceBuffer(), this.registerListeners();
  }
  hasSourceTypes() {
    return this.getSourceBufferTypes().length > 0 || Object.keys(this.pendingTracks).length > 0;
  }
  destroy() {
    this.unregisterListeners(), this.details = null, this.lastMpegAudioChunk = null;
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(I.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(I.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(I.MANIFEST_LOADING, this.onManifestLoading, this), e.on(I.MANIFEST_PARSED, this.onManifestParsed, this), e.on(I.BUFFER_RESET, this.onBufferReset, this), e.on(I.BUFFER_APPENDING, this.onBufferAppending, this), e.on(I.BUFFER_CODECS, this.onBufferCodecs, this), e.on(I.BUFFER_EOS, this.onBufferEos, this), e.on(I.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(I.LEVEL_UPDATED, this.onLevelUpdated, this), e.on(I.FRAG_PARSED, this.onFragParsed, this), e.on(I.FRAG_CHANGED, this.onFragChanged, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(I.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(I.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(I.MANIFEST_LOADING, this.onManifestLoading, this), e.off(I.MANIFEST_PARSED, this.onManifestParsed, this), e.off(I.BUFFER_RESET, this.onBufferReset, this), e.off(I.BUFFER_APPENDING, this.onBufferAppending, this), e.off(I.BUFFER_CODECS, this.onBufferCodecs, this), e.off(I.BUFFER_EOS, this.onBufferEos, this), e.off(I.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(I.LEVEL_UPDATED, this.onLevelUpdated, this), e.off(I.FRAG_PARSED, this.onFragParsed, this), e.off(I.FRAG_CHANGED, this.onFragChanged, this);
  }
  _initSourceBuffer() {
    this.sourceBuffer = {}, this.operationQueue = new Eh(this.sourceBuffer), this.listeners = {
      audio: [],
      video: [],
      audiovideo: []
    }, this.appendErrors = {
      audio: 0,
      video: 0,
      audiovideo: 0
    }, this.lastMpegAudioChunk = null;
  }
  onManifestLoading() {
    this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = 0, this.details = null;
  }
  onManifestParsed(e, t) {
    let n = 2;
    (t.audio && !t.video || !t.altAudio) && (n = 1), this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = n, this.log(`${this.bufferCodecEventsExpected} bufferCodec event(s) expected`);
  }
  onMediaAttaching(e, t) {
    const n = this.media = t.media, r = Gr(this.appendSource);
    if (n && r) {
      var i;
      const s = this.mediaSource = new r();
      this.log(`created media source: ${(i = s.constructor) == null ? void 0 : i.name}`), s.addEventListener("sourceopen", this._onMediaSourceOpen), s.addEventListener("sourceended", this._onMediaSourceEnded), s.addEventListener("sourceclose", this._onMediaSourceClose), s.addEventListener("startstreaming", this._onStartStreaming), s.addEventListener("endstreaming", this._onEndStreaming);
      const a = this._objectUrl = self.URL.createObjectURL(s);
      if (this.appendSource)
        try {
          n.removeAttribute("src"), n.disableRemotePlayback = n.disableRemotePlayback || s instanceof self.ManagedMediaSource, sa(n), Sh(n, a), n.load();
        } catch {
          n.src = a;
        }
      else
        n.src = a;
      n.addEventListener("emptied", this._onMediaEmptied);
    }
  }
  onMediaDetaching() {
    const {
      media: e,
      mediaSource: t,
      _objectUrl: n
    } = this;
    if (t) {
      if (this.log("media source detaching"), t.readyState === "open")
        try {
          t.endOfStream();
        } catch (r) {
          this.warn(`onMediaDetaching: ${r.message} while calling endOfStream`);
        }
      this.onBufferReset(), t.removeEventListener("sourceopen", this._onMediaSourceOpen), t.removeEventListener("sourceended", this._onMediaSourceEnded), t.removeEventListener("sourceclose", this._onMediaSourceClose), t.removeEventListener("startstreaming", this._onStartStreaming), t.removeEventListener("endstreaming", this._onEndStreaming), e && (e.removeEventListener("emptied", this._onMediaEmptied), n && self.URL.revokeObjectURL(n), this.mediaSrc === n ? (e.removeAttribute("src"), this.appendSource && sa(e), e.load()) : this.warn("media|source.src was changed by a third party - skip cleanup")), this.mediaSource = null, this.media = null, this._objectUrl = null, this.bufferCodecEventsExpected = this._bufferCodecEventsTotal, this.pendingTracks = {}, this.tracks = {};
    }
    this.hls.trigger(I.MEDIA_DETACHED, void 0);
  }
  onBufferReset() {
    this.getSourceBufferTypes().forEach((e) => {
      this.resetBuffer(e);
    }), this._initSourceBuffer();
  }
  resetBuffer(e) {
    const t = this.sourceBuffer[e];
    try {
      if (t) {
        var n;
        this.removeBufferListeners(e), this.sourceBuffer[e] = void 0, (n = this.mediaSource) != null && n.sourceBuffers.length && this.mediaSource.removeSourceBuffer(t);
      }
    } catch (r) {
      this.warn(`onBufferReset ${e}`, r);
    }
  }
  onBufferCodecs(e, t) {
    const n = this.getSourceBufferTypes().length;
    Object.keys(t).forEach((r) => {
      if (n) {
        const s = this.tracks[r];
        if (s && typeof s.buffer.changeType == "function") {
          var i;
          const {
            id: a,
            codec: l,
            levelCodec: d,
            container: h,
            metadata: u
          } = t[r], c = ks(s.codec, s.levelCodec), m = c == null ? void 0 : c.replace(ia, "$1");
          let f = ks(l, d);
          const p = (i = f) == null ? void 0 : i.replace(ia, "$1");
          if (f && m !== p) {
            r.slice(0, 5) === "audio" && (f = Or(f, this.hls.config.preferManagedMediaSource));
            const A = `${h};codecs=${f}`;
            this.appendChangeType(r, A), this.log(`switching codec ${c} to ${f}`), this.tracks[r] = {
              buffer: s.buffer,
              codec: l,
              container: h,
              levelCodec: d,
              metadata: u,
              id: a
            };
          }
        }
      } else
        this.pendingTracks[r] = t[r];
    }), !n && (this.bufferCodecEventsExpected = Math.max(this.bufferCodecEventsExpected - 1, 0), this.mediaSource && this.mediaSource.readyState === "open" && this.checkPendingTracks());
  }
  appendChangeType(e, t) {
    const {
      operationQueue: n
    } = this, r = {
      execute: () => {
        const i = this.sourceBuffer[e];
        i && (this.log(`changing ${e} sourceBuffer type to ${t}`), i.changeType(t)), n.shiftAndExecuteNext(e);
      },
      onStart: () => {
      },
      onComplete: () => {
      },
      onError: (i) => {
        this.warn(`Failed to change ${e} SourceBuffer type`, i);
      }
    };
    n.append(r, e, !!this.pendingTracks[e]);
  }
  onBufferAppending(e, t) {
    const {
      hls: n,
      operationQueue: r,
      tracks: i
    } = this, {
      data: s,
      type: a,
      frag: l,
      part: d,
      chunkMeta: h
    } = t, u = h.buffering[a], c = self.performance.now();
    u.start = c;
    const m = l.stats.buffering, f = d ? d.stats.buffering : null;
    m.start === 0 && (m.start = c), f && f.start === 0 && (f.start = c);
    const p = i.audio;
    let A = !1;
    a === "audio" && (p == null ? void 0 : p.container) === "audio/mpeg" && (A = !this.lastMpegAudioChunk || h.id === 1 || this.lastMpegAudioChunk.sn !== h.sn, this.lastMpegAudioChunk = h);
    const v = l.start, b = {
      execute: () => {
        if (u.executeStart = self.performance.now(), A) {
          const _ = this.sourceBuffer[a];
          if (_) {
            const T = v - _.timestampOffset;
            Math.abs(T) >= 0.1 && (this.log(`Updating audio SourceBuffer timestampOffset to ${v} (delta: ${T}) sn: ${l.sn})`), _.timestampOffset = v);
          }
        }
        this.appendExecutor(s, a);
      },
      onStart: () => {
      },
      onComplete: () => {
        const _ = self.performance.now();
        u.executeEnd = u.end = _, m.first === 0 && (m.first = _), f && f.first === 0 && (f.first = _);
        const {
          sourceBuffer: T
        } = this, E = {};
        for (const L in T)
          E[L] = He.getBuffered(T[L]);
        this.appendErrors[a] = 0, a === "audio" || a === "video" ? this.appendErrors.audiovideo = 0 : (this.appendErrors.audio = 0, this.appendErrors.video = 0), this.hls.trigger(I.BUFFER_APPENDED, {
          type: a,
          frag: l,
          part: d,
          chunkMeta: h,
          parent: l.type,
          timeRanges: E
        });
      },
      onError: (_) => {
        const T = {
          type: xe.MEDIA_ERROR,
          parent: l.type,
          details: q.BUFFER_APPEND_ERROR,
          sourceBufferName: a,
          frag: l,
          part: d,
          chunkMeta: h,
          error: _,
          err: _,
          fatal: !1
        };
        if (_.code === DOMException.QUOTA_EXCEEDED_ERR)
          T.details = q.BUFFER_FULL_ERROR;
        else {
          const E = ++this.appendErrors[a];
          T.details = q.BUFFER_APPEND_ERROR, this.warn(`Failed ${E}/${n.config.appendErrorMaxRetry} times to append segment in "${a}" sourceBuffer`), E >= n.config.appendErrorMaxRetry && (T.fatal = !0);
        }
        n.trigger(I.ERROR, T);
      }
    };
    r.append(b, a, !!this.pendingTracks[a]);
  }
  onBufferFlushing(e, t) {
    const {
      operationQueue: n
    } = this, r = (i) => ({
      execute: this.removeExecutor.bind(this, i, t.startOffset, t.endOffset),
      onStart: () => {
      },
      onComplete: () => {
        this.hls.trigger(I.BUFFER_FLUSHED, {
          type: i
        });
      },
      onError: (s) => {
        this.warn(`Failed to remove from ${i} SourceBuffer`, s);
      }
    });
    t.type ? n.append(r(t.type), t.type) : this.getSourceBufferTypes().forEach((i) => {
      n.append(r(i), i);
    });
  }
  onFragParsed(e, t) {
    const {
      frag: n,
      part: r
    } = t, i = [], s = r ? r.elementaryStreams : n.elementaryStreams;
    s[Ge.AUDIOVIDEO] ? i.push("audiovideo") : (s[Ge.AUDIO] && i.push("audio"), s[Ge.VIDEO] && i.push("video"));
    const a = () => {
      const l = self.performance.now();
      n.stats.buffering.end = l, r && (r.stats.buffering.end = l);
      const d = r ? r.stats : n.stats;
      this.hls.trigger(I.FRAG_BUFFERED, {
        frag: n,
        part: r,
        stats: d,
        id: n.type
      });
    };
    i.length === 0 && this.warn(`Fragments must have at least one ElementaryStreamType set. type: ${n.type} level: ${n.level} sn: ${n.sn}`), this.blockBuffers(a, i);
  }
  onFragChanged(e, t) {
    this.trimBuffers();
  }
  // on BUFFER_EOS mark matching sourcebuffer(s) as ended and trigger checkEos()
  // an undefined data.type will mark all buffers as EOS.
  onBufferEos(e, t) {
    this.getSourceBufferTypes().reduce((r, i) => {
      const s = this.sourceBuffer[i];
      return s && (!t.type || t.type === i) && (s.ending = !0, s.ended || (s.ended = !0, this.log(`${i} sourceBuffer now EOS`))), r && !!(!s || s.ended);
    }, !0) && (this.log("Queueing mediaSource.endOfStream()"), this.blockBuffers(() => {
      this.getSourceBufferTypes().forEach((i) => {
        const s = this.sourceBuffer[i];
        s && (s.ending = !1);
      });
      const {
        mediaSource: r
      } = this;
      if (!r || r.readyState !== "open") {
        r && this.log(`Could not call mediaSource.endOfStream(). mediaSource.readyState: ${r.readyState}`);
        return;
      }
      this.log("Calling mediaSource.endOfStream()"), r.endOfStream();
    }));
  }
  onLevelUpdated(e, {
    details: t
  }) {
    t.fragments.length && (this.details = t, this.getSourceBufferTypes().length ? this.blockBuffers(this.updateMediaElementDuration.bind(this)) : this.updateMediaElementDuration());
  }
  trimBuffers() {
    const {
      hls: e,
      details: t,
      media: n
    } = this;
    if (!n || t === null || !this.getSourceBufferTypes().length)
      return;
    const i = e.config, s = n.currentTime, a = t.levelTargetDuration, l = t.live && i.liveBackBufferLength !== null ? i.liveBackBufferLength : i.backBufferLength;
    if (ge(l) && l > 0) {
      const d = Math.max(l, a), h = Math.floor(s / a) * a - d;
      this.flushBackBuffer(s, a, h);
    }
    if (ge(i.frontBufferFlushThreshold) && i.frontBufferFlushThreshold > 0) {
      const d = Math.max(i.maxBufferLength, i.frontBufferFlushThreshold), h = Math.max(d, a), u = Math.floor(s / a) * a + h;
      this.flushFrontBuffer(s, a, u);
    }
  }
  flushBackBuffer(e, t, n) {
    const {
      details: r,
      sourceBuffer: i
    } = this;
    this.getSourceBufferTypes().forEach((a) => {
      const l = i[a];
      if (l) {
        const d = He.getBuffered(l);
        if (d.length > 0 && n > d.start(0)) {
          if (this.hls.trigger(I.BACK_BUFFER_REACHED, {
            bufferEnd: n
          }), r != null && r.live)
            this.hls.trigger(I.LIVE_BACK_BUFFER_REACHED, {
              bufferEnd: n
            });
          else if (l.ended && d.end(d.length - 1) - e < t * 2) {
            this.log(`Cannot flush ${a} back buffer while SourceBuffer is in ended state`);
            return;
          }
          this.hls.trigger(I.BUFFER_FLUSHING, {
            startOffset: 0,
            endOffset: n,
            type: a
          });
        }
      }
    });
  }
  flushFrontBuffer(e, t, n) {
    const {
      sourceBuffer: r
    } = this;
    this.getSourceBufferTypes().forEach((s) => {
      const a = r[s];
      if (a) {
        const l = He.getBuffered(a), d = l.length;
        if (d < 2)
          return;
        const h = l.start(d - 1), u = l.end(d - 1);
        if (n > h || e >= h && e <= u)
          return;
        if (a.ended && e - u < 2 * t) {
          this.log(`Cannot flush ${s} front buffer while SourceBuffer is in ended state`);
          return;
        }
        this.hls.trigger(I.BUFFER_FLUSHING, {
          startOffset: h,
          endOffset: 1 / 0,
          type: s
        });
      }
    });
  }
  /**
   * Update Media Source duration to current level duration or override to Infinity if configuration parameter
   * 'liveDurationInfinity` is set to `true`
   * More details: https://github.com/video-dev/hls.js/issues/355
   */
  updateMediaElementDuration() {
    if (!this.details || !this.media || !this.mediaSource || this.mediaSource.readyState !== "open")
      return;
    const {
      details: e,
      hls: t,
      media: n,
      mediaSource: r
    } = this, i = e.fragments[0].start + e.totalduration, s = n.duration, a = ge(r.duration) ? r.duration : 0;
    e.live && t.config.liveDurationInfinity ? (r.duration = 1 / 0, this.updateSeekableRange(e)) : (i > a && i > s || !ge(s)) && (this.log(`Updating Media Source duration to ${i.toFixed(3)}`), r.duration = i);
  }
  updateSeekableRange(e) {
    const t = this.mediaSource, n = e.fragments;
    if (n.length && e.live && t != null && t.setLiveSeekableRange) {
      const i = Math.max(0, n[0].start), s = Math.max(i, i + e.totalduration);
      this.log(`Media Source duration is set to ${t.duration}. Setting seekable range to ${i}-${s}.`), t.setLiveSeekableRange(i, s);
    }
  }
  checkPendingTracks() {
    const {
      bufferCodecEventsExpected: e,
      operationQueue: t,
      pendingTracks: n
    } = this, r = Object.keys(n).length;
    if (r && !e || r === 2) {
      this.createSourceBuffers(n), this.pendingTracks = {};
      const i = this.getSourceBufferTypes();
      if (i.length)
        this.hls.trigger(I.BUFFER_CREATED, {
          tracks: this.tracks
        }), i.forEach((s) => {
          t.executeNext(s);
        });
      else {
        const s = new Error("could not create source buffer for media codec(s)");
        this.hls.trigger(I.ERROR, {
          type: xe.MEDIA_ERROR,
          details: q.BUFFER_INCOMPATIBLE_CODECS_ERROR,
          fatal: !0,
          error: s,
          reason: s.message
        });
      }
    }
  }
  createSourceBuffers(e) {
    const {
      sourceBuffer: t,
      mediaSource: n
    } = this;
    if (!n)
      throw Error("createSourceBuffers called when mediaSource was null");
    for (const r in e)
      if (!t[r]) {
        const i = e[r];
        if (!i)
          throw Error(`source buffer exists for track ${r}, however track does not`);
        let s = i.levelCodec || i.codec;
        s && r.slice(0, 5) === "audio" && (s = Or(s, this.hls.config.preferManagedMediaSource));
        const a = `${i.container};codecs=${s}`;
        this.log(`creating sourceBuffer(${a})`);
        try {
          const l = t[r] = n.addSourceBuffer(a), d = r;
          this.addBufferListener(d, "updatestart", this._onSBUpdateStart), this.addBufferListener(d, "updateend", this._onSBUpdateEnd), this.addBufferListener(d, "error", this._onSBUpdateError), this.addBufferListener(d, "bufferedchange", (h) => {
            this.hls.trigger(I.BUFFER_FLUSHED, {
              type: r
            });
          }), this.tracks[r] = {
            buffer: l,
            codec: s,
            container: i.container,
            levelCodec: i.levelCodec,
            metadata: i.metadata,
            id: i.id
          };
        } catch (l) {
          this.error(`error while trying to add sourceBuffer: ${l.message}`), this.hls.trigger(I.ERROR, {
            type: xe.MEDIA_ERROR,
            details: q.BUFFER_ADD_CODEC_ERROR,
            fatal: !1,
            error: l,
            sourceBufferName: r,
            mimeType: a
          });
        }
      }
  }
  get mediaSrc() {
    var e;
    const t = ((e = this.media) == null ? void 0 : e.firstChild) || this.media;
    return t == null ? void 0 : t.src;
  }
  _onSBUpdateStart(e) {
    const {
      operationQueue: t
    } = this;
    t.current(e).onStart();
  }
  _onSBUpdateEnd(e) {
    var t;
    if (((t = this.mediaSource) == null ? void 0 : t.readyState) === "closed") {
      this.resetBuffer(e);
      return;
    }
    const {
      operationQueue: n
    } = this;
    n.current(e).onComplete(), n.shiftAndExecuteNext(e);
  }
  _onSBUpdateError(e, t) {
    const n = new Error(`${e} SourceBuffer error`);
    this.error(`${n}`, t), this.hls.trigger(I.ERROR, {
      type: xe.MEDIA_ERROR,
      details: q.BUFFER_APPENDING_ERROR,
      sourceBufferName: e,
      error: n,
      fatal: !1
    });
    const r = this.operationQueue.current(e);
    r && r.onError(t);
  }
  // This method must result in an updateend event; if remove is not called, _onSBUpdateEnd must be called manually
  removeExecutor(e, t, n) {
    const {
      media: r,
      mediaSource: i,
      operationQueue: s,
      sourceBuffer: a
    } = this, l = a[e];
    if (!r || !i || !l) {
      this.warn(`Attempting to remove from the ${e} SourceBuffer, but it does not exist`), s.shiftAndExecuteNext(e);
      return;
    }
    const d = ge(r.duration) ? r.duration : 1 / 0, h = ge(i.duration) ? i.duration : 1 / 0, u = Math.max(0, t), c = Math.min(n, d, h);
    c > u && (!l.ending || l.ended) ? (l.ended = !1, this.log(`Removing [${u},${c}] from the ${e} SourceBuffer`), l.remove(u, c)) : s.shiftAndExecuteNext(e);
  }
  // This method must result in an updateend event; if append is not called, _onSBUpdateEnd must be called manually
  appendExecutor(e, t) {
    const n = this.sourceBuffer[t];
    if (!n) {
      if (!this.pendingTracks[t])
        throw new Error(`Attempting to append to the ${t} SourceBuffer, but it does not exist`);
      return;
    }
    n.ended = !1, n.appendBuffer(e);
  }
  // Enqueues an operation to each SourceBuffer queue which, upon execution, resolves a promise. When all promises
  // resolve, the onUnblocked function is executed. Functions calling this method do not need to unblock the queue
  // upon completion, since we already do it here
  blockBuffers(e, t = this.getSourceBufferTypes()) {
    if (!t.length) {
      this.log("Blocking operation requested, but no SourceBuffers exist"), Promise.resolve().then(e);
      return;
    }
    const {
      operationQueue: n
    } = this, r = t.map((i) => n.appendBlocker(i));
    Promise.all(r).then(() => {
      e(), t.forEach((i) => {
        const s = this.sourceBuffer[i];
        s != null && s.updating || n.shiftAndExecuteNext(i);
      });
    });
  }
  getSourceBufferTypes() {
    return Object.keys(this.sourceBuffer);
  }
  addBufferListener(e, t, n) {
    const r = this.sourceBuffer[e];
    if (!r)
      return;
    const i = n.bind(this, e);
    this.listeners[e].push({
      event: t,
      listener: i
    }), r.addEventListener(t, i);
  }
  removeBufferListeners(e) {
    const t = this.sourceBuffer[e];
    t && this.listeners[e].forEach((n) => {
      t.removeEventListener(n.event, n.listener);
    });
  }
}
function sa(o) {
  for (; o.firstChild; )
    o.removeChild(o.firstChild);
}
function Sh(o, e) {
  const t = self.document.createElement("source");
  t.type = "video/mp4", t.src = e, o.appendChild(t);
}
const aa = {
  42: 225,
  // lowercase a, acute accent
  92: 233,
  // lowercase e, acute accent
  94: 237,
  // lowercase i, acute accent
  95: 243,
  // lowercase o, acute accent
  96: 250,
  // lowercase u, acute accent
  123: 231,
  // lowercase c with cedilla
  124: 247,
  // division symbol
  125: 209,
  // uppercase N tilde
  126: 241,
  // lowercase n tilde
  127: 9608,
  // Full block
  // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
  // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
  128: 174,
  // Registered symbol (R)
  129: 176,
  // degree sign
  130: 189,
  // 1/2 symbol
  131: 191,
  // Inverted (open) question mark
  132: 8482,
  // Trademark symbol (TM)
  133: 162,
  // Cents symbol
  134: 163,
  // Pounds sterling
  135: 9834,
  // Music 8'th note
  136: 224,
  // lowercase a, grave accent
  137: 32,
  // transparent space (regular)
  138: 232,
  // lowercase e, grave accent
  139: 226,
  // lowercase a, circumflex accent
  140: 234,
  // lowercase e, circumflex accent
  141: 238,
  // lowercase i, circumflex accent
  142: 244,
  // lowercase o, circumflex accent
  143: 251,
  // lowercase u, circumflex accent
  // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
  144: 193,
  // capital letter A with acute
  145: 201,
  // capital letter E with acute
  146: 211,
  // capital letter O with acute
  147: 218,
  // capital letter U with acute
  148: 220,
  // capital letter U with diaresis
  149: 252,
  // lowercase letter U with diaeresis
  150: 8216,
  // opening single quote
  151: 161,
  // inverted exclamation mark
  152: 42,
  // asterisk
  153: 8217,
  // closing single quote
  154: 9473,
  // box drawings heavy horizontal
  155: 169,
  // copyright sign
  156: 8480,
  // Service mark
  157: 8226,
  // (round) bullet
  158: 8220,
  // Left double quotation mark
  159: 8221,
  // Right double quotation mark
  160: 192,
  // uppercase A, grave accent
  161: 194,
  // uppercase A, circumflex
  162: 199,
  // uppercase C with cedilla
  163: 200,
  // uppercase E, grave accent
  164: 202,
  // uppercase E, circumflex
  165: 203,
  // capital letter E with diaresis
  166: 235,
  // lowercase letter e with diaresis
  167: 206,
  // uppercase I, circumflex
  168: 207,
  // uppercase I, with diaresis
  169: 239,
  // lowercase i, with diaresis
  170: 212,
  // uppercase O, circumflex
  171: 217,
  // uppercase U, grave accent
  172: 249,
  // lowercase u, grave accent
  173: 219,
  // uppercase U, circumflex
  174: 171,
  // left-pointing double angle quotation mark
  175: 187,
  // right-pointing double angle quotation mark
  // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
  176: 195,
  // Uppercase A, tilde
  177: 227,
  // Lowercase a, tilde
  178: 205,
  // Uppercase I, acute accent
  179: 204,
  // Uppercase I, grave accent
  180: 236,
  // Lowercase i, grave accent
  181: 210,
  // Uppercase O, grave accent
  182: 242,
  // Lowercase o, grave accent
  183: 213,
  // Uppercase O, tilde
  184: 245,
  // Lowercase o, tilde
  185: 123,
  // Open curly brace
  186: 125,
  // Closing curly brace
  187: 92,
  // Backslash
  188: 94,
  // Caret
  189: 95,
  // Underscore
  190: 124,
  // Pipe (vertical line)
  191: 8764,
  // Tilde operator
  192: 196,
  // Uppercase A, umlaut
  193: 228,
  // Lowercase A, umlaut
  194: 214,
  // Uppercase O, umlaut
  195: 246,
  // Lowercase o, umlaut
  196: 223,
  // Esszett (sharp S)
  197: 165,
  // Yen symbol
  198: 164,
  // Generic currency sign
  199: 9475,
  // Box drawings heavy vertical
  200: 197,
  // Uppercase A, ring
  201: 229,
  // Lowercase A, ring
  202: 216,
  // Uppercase O, stroke
  203: 248,
  // Lowercase o, strok
  204: 9487,
  // Box drawings heavy down and right
  205: 9491,
  // Box drawings heavy down and left
  206: 9495,
  // Box drawings heavy up and right
  207: 9499
  // Box drawings heavy up and left
}, go = function(e) {
  let t = e;
  return aa.hasOwnProperty(e) && (t = aa[e]), String.fromCharCode(t);
}, It = 15, Wt = 100, Th = {
  17: 1,
  18: 3,
  21: 5,
  22: 7,
  23: 9,
  16: 11,
  19: 12,
  20: 14
}, Ch = {
  17: 2,
  18: 4,
  21: 6,
  22: 8,
  23: 10,
  19: 13,
  20: 15
}, Lh = {
  25: 1,
  26: 3,
  29: 5,
  30: 7,
  31: 9,
  24: 11,
  27: 12,
  28: 14
}, wh = {
  25: 2,
  26: 4,
  29: 6,
  30: 8,
  31: 10,
  27: 13,
  28: 15
}, Rh = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "black", "transparent"];
class Ih {
  constructor() {
    this.time = null, this.verboseLevel = 0;
  }
  log(e, t) {
    if (this.verboseLevel >= e) {
      const n = typeof t == "function" ? t() : t;
      V.log(`${this.time} [${e}] ${n}`);
    }
  }
}
const on = function(e) {
  const t = [];
  for (let n = 0; n < e.length; n++)
    t.push(e[n].toString(16));
  return t;
};
class yo {
  constructor() {
    this.foreground = "white", this.underline = !1, this.italics = !1, this.background = "black", this.flash = !1;
  }
  reset() {
    this.foreground = "white", this.underline = !1, this.italics = !1, this.background = "black", this.flash = !1;
  }
  setStyles(e) {
    const t = ["foreground", "underline", "italics", "background", "flash"];
    for (let n = 0; n < t.length; n++) {
      const r = t[n];
      e.hasOwnProperty(r) && (this[r] = e[r]);
    }
  }
  isDefault() {
    return this.foreground === "white" && !this.underline && !this.italics && this.background === "black" && !this.flash;
  }
  equals(e) {
    return this.foreground === e.foreground && this.underline === e.underline && this.italics === e.italics && this.background === e.background && this.flash === e.flash;
  }
  copy(e) {
    this.foreground = e.foreground, this.underline = e.underline, this.italics = e.italics, this.background = e.background, this.flash = e.flash;
  }
  toString() {
    return "color=" + this.foreground + ", underline=" + this.underline + ", italics=" + this.italics + ", background=" + this.background + ", flash=" + this.flash;
  }
}
class kh {
  constructor() {
    this.uchar = " ", this.penState = new yo();
  }
  reset() {
    this.uchar = " ", this.penState.reset();
  }
  setChar(e, t) {
    this.uchar = e, this.penState.copy(t);
  }
  setPenState(e) {
    this.penState.copy(e);
  }
  equals(e) {
    return this.uchar === e.uchar && this.penState.equals(e.penState);
  }
  copy(e) {
    this.uchar = e.uchar, this.penState.copy(e.penState);
  }
  isEmpty() {
    return this.uchar === " " && this.penState.isDefault();
  }
}
class Dh {
  constructor(e) {
    this.chars = [], this.pos = 0, this.currPenState = new yo(), this.cueStartTime = null, this.logger = void 0;
    for (let t = 0; t < Wt; t++)
      this.chars.push(new kh());
    this.logger = e;
  }
  equals(e) {
    for (let t = 0; t < Wt; t++)
      if (!this.chars[t].equals(e.chars[t]))
        return !1;
    return !0;
  }
  copy(e) {
    for (let t = 0; t < Wt; t++)
      this.chars[t].copy(e.chars[t]);
  }
  isEmpty() {
    let e = !0;
    for (let t = 0; t < Wt; t++)
      if (!this.chars[t].isEmpty()) {
        e = !1;
        break;
      }
    return e;
  }
  /**
   *  Set the cursor to a valid column.
   */
  setCursor(e) {
    this.pos !== e && (this.pos = e), this.pos < 0 ? (this.logger.log(3, "Negative cursor position " + this.pos), this.pos = 0) : this.pos > Wt && (this.logger.log(3, "Too large cursor position " + this.pos), this.pos = Wt);
  }
  /**
   * Move the cursor relative to current position.
   */
  moveCursor(e) {
    const t = this.pos + e;
    if (e > 1)
      for (let n = this.pos + 1; n < t + 1; n++)
        this.chars[n].setPenState(this.currPenState);
    this.setCursor(t);
  }
  /**
   * Backspace, move one step back and clear character.
   */
  backSpace() {
    this.moveCursor(-1), this.chars[this.pos].setChar(" ", this.currPenState);
  }
  insertChar(e) {
    e >= 144 && this.backSpace();
    const t = go(e);
    if (this.pos >= Wt) {
      this.logger.log(0, () => "Cannot insert " + e.toString(16) + " (" + t + ") at position " + this.pos + ". Skipping it!");
      return;
    }
    this.chars[this.pos].setChar(t, this.currPenState), this.moveCursor(1);
  }
  clearFromPos(e) {
    let t;
    for (t = e; t < Wt; t++)
      this.chars[t].reset();
  }
  clear() {
    this.clearFromPos(0), this.pos = 0, this.currPenState.reset();
  }
  clearToEndOfRow() {
    this.clearFromPos(this.pos);
  }
  getTextString() {
    const e = [];
    let t = !0;
    for (let n = 0; n < Wt; n++) {
      const r = this.chars[n].uchar;
      r !== " " && (t = !1), e.push(r);
    }
    return t ? "" : e.join("");
  }
  setPenStyles(e) {
    this.currPenState.setStyles(e), this.chars[this.pos].setPenState(this.currPenState);
  }
}
class fi {
  constructor(e) {
    this.rows = [], this.currRow = It - 1, this.nrRollUpRows = null, this.lastOutputScreen = null, this.logger = void 0;
    for (let t = 0; t < It; t++)
      this.rows.push(new Dh(e));
    this.logger = e;
  }
  reset() {
    for (let e = 0; e < It; e++)
      this.rows[e].clear();
    this.currRow = It - 1;
  }
  equals(e) {
    let t = !0;
    for (let n = 0; n < It; n++)
      if (!this.rows[n].equals(e.rows[n])) {
        t = !1;
        break;
      }
    return t;
  }
  copy(e) {
    for (let t = 0; t < It; t++)
      this.rows[t].copy(e.rows[t]);
  }
  isEmpty() {
    let e = !0;
    for (let t = 0; t < It; t++)
      if (!this.rows[t].isEmpty()) {
        e = !1;
        break;
      }
    return e;
  }
  backSpace() {
    this.rows[this.currRow].backSpace();
  }
  clearToEndOfRow() {
    this.rows[this.currRow].clearToEndOfRow();
  }
  /**
   * Insert a character (without styling) in the current row.
   */
  insertChar(e) {
    this.rows[this.currRow].insertChar(e);
  }
  setPen(e) {
    this.rows[this.currRow].setPenStyles(e);
  }
  moveCursor(e) {
    this.rows[this.currRow].moveCursor(e);
  }
  setCursor(e) {
    this.logger.log(2, "setCursor: " + e), this.rows[this.currRow].setCursor(e);
  }
  setPAC(e) {
    this.logger.log(2, () => "pacData = " + JSON.stringify(e));
    let t = e.row - 1;
    if (this.nrRollUpRows && t < this.nrRollUpRows - 1 && (t = this.nrRollUpRows - 1), this.nrRollUpRows && this.currRow !== t) {
      for (let a = 0; a < It; a++)
        this.rows[a].clear();
      const i = this.currRow + 1 - this.nrRollUpRows, s = this.lastOutputScreen;
      if (s) {
        const a = s.rows[i].cueStartTime, l = this.logger.time;
        if (a !== null && l !== null && a < l)
          for (let d = 0; d < this.nrRollUpRows; d++)
            this.rows[t - this.nrRollUpRows + d + 1].copy(s.rows[i + d]);
      }
    }
    this.currRow = t;
    const n = this.rows[this.currRow];
    if (e.indent !== null) {
      const i = e.indent, s = Math.max(i - 1, 0);
      n.setCursor(e.indent), e.color = n.chars[s].penState.foreground;
    }
    const r = {
      foreground: e.color,
      underline: e.underline,
      italics: e.italics,
      background: "black",
      flash: !1
    };
    this.setPen(r);
  }
  /**
   * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
   */
  setBkgData(e) {
    this.logger.log(2, () => "bkgData = " + JSON.stringify(e)), this.backSpace(), this.setPen(e), this.insertChar(32);
  }
  setRollUpRows(e) {
    this.nrRollUpRows = e;
  }
  rollUp() {
    if (this.nrRollUpRows === null) {
      this.logger.log(3, "roll_up but nrRollUpRows not set yet");
      return;
    }
    this.logger.log(1, () => this.getDisplayText());
    const e = this.currRow + 1 - this.nrRollUpRows, t = this.rows.splice(e, 1)[0];
    t.clear(), this.rows.splice(this.currRow, 0, t), this.logger.log(2, "Rolling up");
  }
  /**
   * Get all non-empty rows with as unicode text.
   */
  getDisplayText(e) {
    e = e || !1;
    const t = [];
    let n = "", r = -1;
    for (let i = 0; i < It; i++) {
      const s = this.rows[i].getTextString();
      s && (r = i + 1, e ? t.push("Row " + r + ": '" + s + "'") : t.push(s.trim()));
    }
    return t.length > 0 && (e ? n = "[" + t.join(" | ") + "]" : n = t.join(`
`)), n;
  }
  getTextAndFormat() {
    return this.rows;
  }
}
class oa {
  constructor(e, t, n) {
    this.chNr = void 0, this.outputFilter = void 0, this.mode = void 0, this.verbose = void 0, this.displayedMemory = void 0, this.nonDisplayedMemory = void 0, this.lastOutputScreen = void 0, this.currRollUpRow = void 0, this.writeScreen = void 0, this.cueStartTime = void 0, this.logger = void 0, this.chNr = e, this.outputFilter = t, this.mode = null, this.verbose = 0, this.displayedMemory = new fi(n), this.nonDisplayedMemory = new fi(n), this.lastOutputScreen = new fi(n), this.currRollUpRow = this.displayedMemory.rows[It - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null, this.logger = n;
  }
  reset() {
    this.mode = null, this.displayedMemory.reset(), this.nonDisplayedMemory.reset(), this.lastOutputScreen.reset(), this.outputFilter.reset(), this.currRollUpRow = this.displayedMemory.rows[It - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null;
  }
  getHandler() {
    return this.outputFilter;
  }
  setHandler(e) {
    this.outputFilter = e;
  }
  setPAC(e) {
    this.writeScreen.setPAC(e);
  }
  setBkgData(e) {
    this.writeScreen.setBkgData(e);
  }
  setMode(e) {
    e !== this.mode && (this.mode = e, this.logger.log(2, () => "MODE=" + e), this.mode === "MODE_POP-ON" ? this.writeScreen = this.nonDisplayedMemory : (this.writeScreen = this.displayedMemory, this.writeScreen.reset()), this.mode !== "MODE_ROLL-UP" && (this.displayedMemory.nrRollUpRows = null, this.nonDisplayedMemory.nrRollUpRows = null), this.mode = e);
  }
  insertChars(e) {
    for (let n = 0; n < e.length; n++)
      this.writeScreen.insertChar(e[n]);
    const t = this.writeScreen === this.displayedMemory ? "DISP" : "NON_DISP";
    this.logger.log(2, () => t + ": " + this.writeScreen.getDisplayText(!0)), (this.mode === "MODE_PAINT-ON" || this.mode === "MODE_ROLL-UP") && (this.logger.log(1, () => "DISPLAYED: " + this.displayedMemory.getDisplayText(!0)), this.outputDataUpdate());
  }
  ccRCL() {
    this.logger.log(2, "RCL - Resume Caption Loading"), this.setMode("MODE_POP-ON");
  }
  ccBS() {
    this.logger.log(2, "BS - BackSpace"), this.mode !== "MODE_TEXT" && (this.writeScreen.backSpace(), this.writeScreen === this.displayedMemory && this.outputDataUpdate());
  }
  ccAOF() {
  }
  ccAON() {
  }
  ccDER() {
    this.logger.log(2, "DER- Delete to End of Row"), this.writeScreen.clearToEndOfRow(), this.outputDataUpdate();
  }
  ccRU(e) {
    this.logger.log(2, "RU(" + e + ") - Roll Up"), this.writeScreen = this.displayedMemory, this.setMode("MODE_ROLL-UP"), this.writeScreen.setRollUpRows(e);
  }
  ccFON() {
    this.logger.log(2, "FON - Flash On"), this.writeScreen.setPen({
      flash: !0
    });
  }
  ccRDC() {
    this.logger.log(2, "RDC - Resume Direct Captioning"), this.setMode("MODE_PAINT-ON");
  }
  ccTR() {
    this.logger.log(2, "TR"), this.setMode("MODE_TEXT");
  }
  ccRTD() {
    this.logger.log(2, "RTD"), this.setMode("MODE_TEXT");
  }
  ccEDM() {
    this.logger.log(2, "EDM - Erase Displayed Memory"), this.displayedMemory.reset(), this.outputDataUpdate(!0);
  }
  ccCR() {
    this.logger.log(2, "CR - Carriage Return"), this.writeScreen.rollUp(), this.outputDataUpdate(!0);
  }
  ccENM() {
    this.logger.log(2, "ENM - Erase Non-displayed Memory"), this.nonDisplayedMemory.reset();
  }
  ccEOC() {
    if (this.logger.log(2, "EOC - End Of Caption"), this.mode === "MODE_POP-ON") {
      const e = this.displayedMemory;
      this.displayedMemory = this.nonDisplayedMemory, this.nonDisplayedMemory = e, this.writeScreen = this.nonDisplayedMemory, this.logger.log(1, () => "DISP: " + this.displayedMemory.getDisplayText());
    }
    this.outputDataUpdate(!0);
  }
  ccTO(e) {
    this.logger.log(2, "TO(" + e + ") - Tab Offset"), this.writeScreen.moveCursor(e);
  }
  ccMIDROW(e) {
    const t = {
      flash: !1
    };
    if (t.underline = e % 2 === 1, t.italics = e >= 46, t.italics)
      t.foreground = "white";
    else {
      const n = Math.floor(e / 2) - 16, r = ["white", "green", "blue", "cyan", "red", "yellow", "magenta"];
      t.foreground = r[n];
    }
    this.logger.log(2, "MIDROW: " + JSON.stringify(t)), this.writeScreen.setPen(t);
  }
  outputDataUpdate(e = !1) {
    const t = this.logger.time;
    t !== null && this.outputFilter && (this.cueStartTime === null && !this.displayedMemory.isEmpty() ? this.cueStartTime = t : this.displayedMemory.equals(this.lastOutputScreen) || (this.outputFilter.newCue(this.cueStartTime, t, this.lastOutputScreen), e && this.outputFilter.dispatchCue && this.outputFilter.dispatchCue(), this.cueStartTime = this.displayedMemory.isEmpty() ? null : t), this.lastOutputScreen.copy(this.displayedMemory));
  }
  cueSplitAtTime(e) {
    this.outputFilter && (this.displayedMemory.isEmpty() || (this.outputFilter.newCue && this.outputFilter.newCue(this.cueStartTime, e, this.displayedMemory), this.cueStartTime = e));
  }
}
class la {
  constructor(e, t, n) {
    this.channels = void 0, this.currentChannel = 0, this.cmdHistory = ca(), this.logger = void 0;
    const r = this.logger = new Ih();
    this.channels = [null, new oa(e, t, r), new oa(e + 1, n, r)];
  }
  getHandler(e) {
    return this.channels[e].getHandler();
  }
  setHandler(e, t) {
    this.channels[e].setHandler(t);
  }
  /**
   * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
   */
  addData(e, t) {
    let n, r, i, s = !1;
    this.logger.time = e;
    for (let a = 0; a < t.length; a += 2)
      if (r = t[a] & 127, i = t[a + 1] & 127, !(r === 0 && i === 0)) {
        if (this.logger.log(3, "[" + on([t[a], t[a + 1]]) + "] -> (" + on([r, i]) + ")"), n = this.parseCmd(r, i), n || (n = this.parseMidrow(r, i)), n || (n = this.parsePAC(r, i)), n || (n = this.parseBackgroundAttributes(r, i)), !n && (s = this.parseChars(r, i), s)) {
          const l = this.currentChannel;
          l && l > 0 ? this.channels[l].insertChars(s) : this.logger.log(2, "No channel found yet. TEXT-MODE?");
        }
        !n && !s && this.logger.log(2, "Couldn't parse cleaned data " + on([r, i]) + " orig: " + on([t[a], t[a + 1]]));
      }
  }
  /**
   * Parse Command.
   * @returns True if a command was found
   */
  parseCmd(e, t) {
    const {
      cmdHistory: n
    } = this, r = (e === 20 || e === 28 || e === 21 || e === 29) && t >= 32 && t <= 47, i = (e === 23 || e === 31) && t >= 33 && t <= 35;
    if (!(r || i))
      return !1;
    if (da(e, t, n))
      return En(null, null, n), this.logger.log(3, "Repeated command (" + on([e, t]) + ") is dropped"), !0;
    const s = e === 20 || e === 21 || e === 23 ? 1 : 2, a = this.channels[s];
    return e === 20 || e === 21 || e === 28 || e === 29 ? t === 32 ? a.ccRCL() : t === 33 ? a.ccBS() : t === 34 ? a.ccAOF() : t === 35 ? a.ccAON() : t === 36 ? a.ccDER() : t === 37 ? a.ccRU(2) : t === 38 ? a.ccRU(3) : t === 39 ? a.ccRU(4) : t === 40 ? a.ccFON() : t === 41 ? a.ccRDC() : t === 42 ? a.ccTR() : t === 43 ? a.ccRTD() : t === 44 ? a.ccEDM() : t === 45 ? a.ccCR() : t === 46 ? a.ccENM() : t === 47 && a.ccEOC() : a.ccTO(t - 32), En(e, t, n), this.currentChannel = s, !0;
  }
  /**
   * Parse midrow styling command
   */
  parseMidrow(e, t) {
    let n = 0;
    if ((e === 17 || e === 25) && t >= 32 && t <= 47) {
      if (e === 17 ? n = 1 : n = 2, n !== this.currentChannel)
        return this.logger.log(0, "Mismatch channel in midrow parsing"), !1;
      const r = this.channels[n];
      return r ? (r.ccMIDROW(t), this.logger.log(3, "MIDROW (" + on([e, t]) + ")"), !0) : !1;
    }
    return !1;
  }
  /**
   * Parse Preable Access Codes (Table 53).
   * @returns {Boolean} Tells if PAC found
   */
  parsePAC(e, t) {
    let n;
    const r = this.cmdHistory, i = (e >= 17 && e <= 23 || e >= 25 && e <= 31) && t >= 64 && t <= 127, s = (e === 16 || e === 24) && t >= 64 && t <= 95;
    if (!(i || s))
      return !1;
    if (da(e, t, r))
      return En(null, null, r), !0;
    const a = e <= 23 ? 1 : 2;
    t >= 64 && t <= 95 ? n = a === 1 ? Th[e] : Lh[e] : n = a === 1 ? Ch[e] : wh[e];
    const l = this.channels[a];
    return l ? (l.setPAC(this.interpretPAC(n, t)), En(e, t, r), this.currentChannel = a, !0) : !1;
  }
  /**
   * Interpret the second byte of the pac, and return the information.
   * @returns pacData with style parameters
   */
  interpretPAC(e, t) {
    let n;
    const r = {
      color: null,
      italics: !1,
      indent: null,
      underline: !1,
      row: e
    };
    return t > 95 ? n = t - 96 : n = t - 64, r.underline = (n & 1) === 1, n <= 13 ? r.color = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "white"][Math.floor(n / 2)] : n <= 15 ? (r.italics = !0, r.color = "white") : r.indent = Math.floor((n - 16) / 2) * 4, r;
  }
  /**
   * Parse characters.
   * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
   */
  parseChars(e, t) {
    let n, r = null, i = null;
    if (e >= 25 ? (n = 2, i = e - 8) : (n = 1, i = e), i >= 17 && i <= 19) {
      let s;
      i === 17 ? s = t + 80 : i === 18 ? s = t + 112 : s = t + 144, this.logger.log(2, "Special char '" + go(s) + "' in channel " + n), r = [s];
    } else
      e >= 32 && e <= 127 && (r = t === 0 ? [e] : [e, t]);
    if (r) {
      const s = on(r);
      this.logger.log(3, "Char codes =  " + s.join(",")), En(e, t, this.cmdHistory);
    }
    return r;
  }
  /**
   * Parse extended background attributes as well as new foreground color black.
   * @returns True if background attributes are found
   */
  parseBackgroundAttributes(e, t) {
    const n = (e === 16 || e === 24) && t >= 32 && t <= 47, r = (e === 23 || e === 31) && t >= 45 && t <= 47;
    if (!(n || r))
      return !1;
    let i;
    const s = {};
    e === 16 || e === 24 ? (i = Math.floor((t - 32) / 2), s.background = Rh[i], t % 2 === 1 && (s.background = s.background + "_semi")) : t === 45 ? s.background = "transparent" : (s.foreground = "black", t === 47 && (s.underline = !0));
    const a = e <= 23 ? 1 : 2;
    return this.channels[a].setBkgData(s), En(e, t, this.cmdHistory), !0;
  }
  /**
   * Reset state of parser and its channels.
   */
  reset() {
    for (let e = 0; e < Object.keys(this.channels).length; e++) {
      const t = this.channels[e];
      t && t.reset();
    }
    this.cmdHistory = ca();
  }
  /**
   * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
   */
  cueSplitAtTime(e) {
    for (let t = 0; t < this.channels.length; t++) {
      const n = this.channels[t];
      n && n.cueSplitAtTime(e);
    }
  }
}
function En(o, e, t) {
  t.a = o, t.b = e;
}
function da(o, e, t) {
  return t.a === o && t.b === e;
}
function ca() {
  return {
    a: null,
    b: null
  };
}
class _r {
  constructor(e, t) {
    this.timelineController = void 0, this.cueRanges = [], this.trackName = void 0, this.startTime = null, this.endTime = null, this.screen = null, this.timelineController = e, this.trackName = t;
  }
  dispatchCue() {
    this.startTime !== null && (this.timelineController.addCues(this.trackName, this.startTime, this.endTime, this.screen, this.cueRanges), this.startTime = null);
  }
  newCue(e, t, n) {
    (this.startTime === null || this.startTime > e) && (this.startTime = e), this.endTime = t, this.screen = n, this.timelineController.createCaptionsTrack(this.trackName);
  }
  reset() {
    this.cueRanges = [], this.startTime = null;
  }
}
var es = function() {
  if (typeof self < "u" && self.VTTCue)
    return self.VTTCue;
  const o = ["", "lr", "rl"], e = ["start", "middle", "end", "left", "right"];
  function t(a, l) {
    if (typeof l != "string" || !Array.isArray(a))
      return !1;
    const d = l.toLowerCase();
    return ~a.indexOf(d) ? d : !1;
  }
  function n(a) {
    return t(o, a);
  }
  function r(a) {
    return t(e, a);
  }
  function i(a, ...l) {
    let d = 1;
    for (; d < arguments.length; d++) {
      const h = arguments[d];
      for (const u in h)
        a[u] = h[u];
    }
    return a;
  }
  function s(a, l, d) {
    const h = this, u = {
      enumerable: !0
    };
    h.hasBeenReset = !1;
    let c = "", m = !1, f = a, p = l, A = d, v = null, b = "", _ = !0, T = "auto", E = "start", L = 50, k = "middle", D = 50, M = "middle";
    Object.defineProperty(h, "id", i({}, u, {
      get: function() {
        return c;
      },
      set: function(O) {
        c = "" + O;
      }
    })), Object.defineProperty(h, "pauseOnExit", i({}, u, {
      get: function() {
        return m;
      },
      set: function(O) {
        m = !!O;
      }
    })), Object.defineProperty(h, "startTime", i({}, u, {
      get: function() {
        return f;
      },
      set: function(O) {
        if (typeof O != "number")
          throw new TypeError("Start time must be set to a number.");
        f = O, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(h, "endTime", i({}, u, {
      get: function() {
        return p;
      },
      set: function(O) {
        if (typeof O != "number")
          throw new TypeError("End time must be set to a number.");
        p = O, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(h, "text", i({}, u, {
      get: function() {
        return A;
      },
      set: function(O) {
        A = "" + O, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(h, "region", i({}, u, {
      get: function() {
        return v;
      },
      set: function(O) {
        v = O, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(h, "vertical", i({}, u, {
      get: function() {
        return b;
      },
      set: function(O) {
        const N = n(O);
        if (N === !1)
          throw new SyntaxError("An invalid or illegal string was specified.");
        b = N, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(h, "snapToLines", i({}, u, {
      get: function() {
        return _;
      },
      set: function(O) {
        _ = !!O, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(h, "line", i({}, u, {
      get: function() {
        return T;
      },
      set: function(O) {
        if (typeof O != "number" && O !== "auto")
          throw new SyntaxError("An invalid number or illegal string was specified.");
        T = O, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(h, "lineAlign", i({}, u, {
      get: function() {
        return E;
      },
      set: function(O) {
        const N = r(O);
        if (!N)
          throw new SyntaxError("An invalid or illegal string was specified.");
        E = N, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(h, "position", i({}, u, {
      get: function() {
        return L;
      },
      set: function(O) {
        if (O < 0 || O > 100)
          throw new Error("Position must be between 0 and 100.");
        L = O, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(h, "positionAlign", i({}, u, {
      get: function() {
        return k;
      },
      set: function(O) {
        const N = r(O);
        if (!N)
          throw new SyntaxError("An invalid or illegal string was specified.");
        k = N, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(h, "size", i({}, u, {
      get: function() {
        return D;
      },
      set: function(O) {
        if (O < 0 || O > 100)
          throw new Error("Size must be between 0 and 100.");
        D = O, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(h, "align", i({}, u, {
      get: function() {
        return M;
      },
      set: function(O) {
        const N = r(O);
        if (!N)
          throw new SyntaxError("An invalid or illegal string was specified.");
        M = N, this.hasBeenReset = !0;
      }
    })), h.displayState = void 0;
  }
  return s.prototype.getCueAsHTML = function() {
    return self.WebVTT.convertCueToDOMTree(self, this.text);
  }, s;
}();
class Oh {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  decode(e, t) {
    if (!e)
      return "";
    if (typeof e != "string")
      throw new Error("Error - expected string data.");
    return decodeURIComponent(encodeURIComponent(e));
  }
}
function Ao(o) {
  function e(n, r, i, s) {
    return (n | 0) * 3600 + (r | 0) * 60 + (i | 0) + parseFloat(s || 0);
  }
  const t = o.match(/^(?:(\d+):)?(\d{2}):(\d{2})(\.\d+)?/);
  return t ? parseFloat(t[2]) > 59 ? e(t[2], t[3], 0, t[4]) : e(t[1], t[2], t[3], t[4]) : null;
}
class Bh {
  constructor() {
    this.values = /* @__PURE__ */ Object.create(null);
  }
  // Only accept the first assignment to any key.
  set(e, t) {
    !this.get(e) && t !== "" && (this.values[e] = t);
  }
  // Return the value for a key, or a default value.
  // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
  // a number of possible default values as properties where 'defaultKey' is
  // the key of the property that will be chosen; otherwise it's assumed to be
  // a single value.
  get(e, t, n) {
    return n ? this.has(e) ? this.values[e] : t[n] : this.has(e) ? this.values[e] : t;
  }
  // Check whether we have a value for a key.
  has(e) {
    return e in this.values;
  }
  // Accept a setting if its one of the given alternatives.
  alt(e, t, n) {
    for (let r = 0; r < n.length; ++r)
      if (t === n[r]) {
        this.set(e, t);
        break;
      }
  }
  // Accept a setting if its a valid (signed) integer.
  integer(e, t) {
    /^-?\d+$/.test(t) && this.set(e, parseInt(t, 10));
  }
  // Accept a setting if its a valid percentage.
  percent(e, t) {
    if (/^([\d]{1,3})(\.[\d]*)?%$/.test(t)) {
      const n = parseFloat(t);
      if (n >= 0 && n <= 100)
        return this.set(e, n), !0;
    }
    return !1;
  }
}
function vo(o, e, t, n) {
  const r = n ? o.split(n) : [o];
  for (const i in r) {
    if (typeof r[i] != "string")
      continue;
    const s = r[i].split(t);
    if (s.length !== 2)
      continue;
    const a = s[0], l = s[1];
    e(a, l);
  }
}
const Bi = new es(0, 0, ""), Sr = Bi.align === "middle" ? "middle" : "center";
function Ph(o, e, t) {
  const n = o;
  function r() {
    const a = Ao(o);
    if (a === null)
      throw new Error("Malformed timestamp: " + n);
    return o = o.replace(/^[^\sa-zA-Z-]+/, ""), a;
  }
  function i(a, l) {
    const d = new Bh();
    vo(a, function(c, m) {
      let f;
      switch (c) {
        case "region":
          for (let p = t.length - 1; p >= 0; p--)
            if (t[p].id === m) {
              d.set(c, t[p].region);
              break;
            }
          break;
        case "vertical":
          d.alt(c, m, ["rl", "lr"]);
          break;
        case "line":
          f = m.split(","), d.integer(c, f[0]), d.percent(c, f[0]) && d.set("snapToLines", !1), d.alt(c, f[0], ["auto"]), f.length === 2 && d.alt("lineAlign", f[1], ["start", Sr, "end"]);
          break;
        case "position":
          f = m.split(","), d.percent(c, f[0]), f.length === 2 && d.alt("positionAlign", f[1], ["start", Sr, "end", "line-left", "line-right", "auto"]);
          break;
        case "size":
          d.percent(c, m);
          break;
        case "align":
          d.alt(c, m, ["start", Sr, "end", "left", "right"]);
          break;
      }
    }, /:/, /\s/), l.region = d.get("region", null), l.vertical = d.get("vertical", "");
    let h = d.get("line", "auto");
    h === "auto" && Bi.line === -1 && (h = -1), l.line = h, l.lineAlign = d.get("lineAlign", "start"), l.snapToLines = d.get("snapToLines", !0), l.size = d.get("size", 100), l.align = d.get("align", Sr);
    let u = d.get("position", "auto");
    u === "auto" && Bi.position === 50 && (u = l.align === "start" || l.align === "left" ? 0 : l.align === "end" || l.align === "right" ? 100 : 50), l.position = u;
  }
  function s() {
    o = o.replace(/^\s+/, "");
  }
  if (s(), e.startTime = r(), s(), o.slice(0, 3) !== "-->")
    throw new Error("Malformed time stamp (time stamps must be separated by '-->'): " + n);
  o = o.slice(3), s(), e.endTime = r(), s(), i(o, e);
}
function bo(o) {
  return o.replace(/<br(?: \/)?>/gi, `
`);
}
class Fh {
  constructor() {
    this.state = "INITIAL", this.buffer = "", this.decoder = new Oh(), this.regionList = [], this.cue = null, this.oncue = void 0, this.onparsingerror = void 0, this.onflush = void 0;
  }
  parse(e) {
    const t = this;
    e && (t.buffer += t.decoder.decode(e, {
      stream: !0
    }));
    function n() {
      let i = t.buffer, s = 0;
      for (i = bo(i); s < i.length && i[s] !== "\r" && i[s] !== `
`; )
        ++s;
      const a = i.slice(0, s);
      return i[s] === "\r" && ++s, i[s] === `
` && ++s, t.buffer = i.slice(s), a;
    }
    function r(i) {
      vo(i, function(s, a) {
      }, /:/);
    }
    try {
      let i = "";
      if (t.state === "INITIAL") {
        if (!/\r\n|\n/.test(t.buffer))
          return this;
        i = n();
        const a = i.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
        if (!(a != null && a[0]))
          throw new Error("Malformed WebVTT signature.");
        t.state = "HEADER";
      }
      let s = !1;
      for (; t.buffer; ) {
        if (!/\r\n|\n/.test(t.buffer))
          return this;
        switch (s ? s = !1 : i = n(), t.state) {
          case "HEADER":
            /:/.test(i) ? r(i) : i || (t.state = "ID");
            continue;
          case "NOTE":
            i || (t.state = "ID");
            continue;
          case "ID":
            if (/^NOTE($|[ \t])/.test(i)) {
              t.state = "NOTE";
              break;
            }
            if (!i)
              continue;
            if (t.cue = new es(0, 0, ""), t.state = "CUE", i.indexOf("-->") === -1) {
              t.cue.id = i;
              continue;
            }
          case "CUE":
            if (!t.cue) {
              t.state = "BADCUE";
              continue;
            }
            try {
              Ph(i, t.cue, t.regionList);
            } catch {
              t.cue = null, t.state = "BADCUE";
              continue;
            }
            t.state = "CUETEXT";
            continue;
          case "CUETEXT":
            {
              const a = i.indexOf("-->") !== -1;
              if (!i || a && (s = !0)) {
                t.oncue && t.cue && t.oncue(t.cue), t.cue = null, t.state = "ID";
                continue;
              }
              if (t.cue === null)
                continue;
              t.cue.text && (t.cue.text += `
`), t.cue.text += i;
            }
            continue;
          case "BADCUE":
            i || (t.state = "ID");
        }
      }
    } catch {
      t.state === "CUETEXT" && t.cue && t.oncue && t.oncue(t.cue), t.cue = null, t.state = t.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
    }
    return this;
  }
  flush() {
    const e = this;
    try {
      if ((e.cue || e.state === "HEADER") && (e.buffer += `

`, e.parse()), e.state === "INITIAL" || e.state === "BADWEBVTT")
        throw new Error("Malformed WebVTT signature.");
    } catch (t) {
      e.onparsingerror && e.onparsingerror(t);
    }
    return e.onflush && e.onflush(), this;
  }
}
const Mh = /\r\n|\n\r|\n|\r/g, pi = function(e, t, n = 0) {
  return e.slice(n, n + t.length) === t;
}, Uh = function(e) {
  let t = parseInt(e.slice(-3));
  const n = parseInt(e.slice(-6, -4)), r = parseInt(e.slice(-9, -7)), i = e.length > 9 ? parseInt(e.substring(0, e.indexOf(":"))) : 0;
  if (!ge(t) || !ge(n) || !ge(r) || !ge(i))
    throw Error(`Malformed X-TIMESTAMP-MAP: Local:${e}`);
  return t += 1e3 * n, t += 60 * 1e3 * r, t += 60 * 60 * 1e3 * i, t;
}, mi = function(e) {
  let t = 5381, n = e.length;
  for (; n; )
    t = t * 33 ^ e.charCodeAt(--n);
  return (t >>> 0).toString();
};
function ts(o, e, t) {
  return mi(o.toString()) + mi(e.toString()) + mi(t);
}
const Nh = function(e, t, n) {
  let r = e[t], i = e[r.prevCC];
  if (!i || !i.new && r.new) {
    e.ccOffset = e.presentationOffset = r.start, r.new = !1;
    return;
  }
  for (; (s = i) != null && s.new; ) {
    var s;
    e.ccOffset += r.start - i.start, r.new = !1, r = i, i = e[r.prevCC];
  }
  e.presentationOffset = n;
};
function jh(o, e, t, n, r, i, s) {
  const a = new Fh(), l = jt(new Uint8Array(o)).trim().replace(Mh, `
`).split(`
`), d = [], h = e ? sh(e.baseTime, e.timescale) : 0;
  let u = "00:00.000", c = 0, m = 0, f, p = !0;
  a.oncue = function(A) {
    const v = t[n];
    let b = t.ccOffset;
    const _ = (c - h) / 9e4;
    if (v != null && v.new && (m !== void 0 ? b = t.ccOffset = v.start : Nh(t, n, _)), _) {
      if (!e) {
        f = new Error("Missing initPTS for VTT MPEGTS");
        return;
      }
      b = _ - t.presentationOffset;
    }
    const T = A.endTime - A.startTime, E = Ct((A.startTime + b - m) * 9e4, r * 9e4) / 9e4;
    A.startTime = Math.max(E, 0), A.endTime = Math.max(E + T, 0);
    const L = A.text.trim();
    A.text = decodeURIComponent(encodeURIComponent(L)), A.id || (A.id = ts(A.startTime, A.endTime, L)), A.endTime > 0 && d.push(A);
  }, a.onparsingerror = function(A) {
    f = A;
  }, a.onflush = function() {
    if (f) {
      s(f);
      return;
    }
    i(d);
  }, l.forEach((A) => {
    if (p)
      if (pi(A, "X-TIMESTAMP-MAP=")) {
        p = !1, A.slice(16).split(",").forEach((v) => {
          pi(v, "LOCAL:") ? u = v.slice(6) : pi(v, "MPEGTS:") && (c = parseInt(v.slice(7)));
        });
        try {
          m = Uh(u) / 1e3;
        } catch (v) {
          f = v;
        }
        return;
      } else
        A === "" && (p = !1);
    a.parse(A + `
`);
  }), a.flush();
}
const gi = "stpp.ttml.im1t", xo = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/, Eo = /^(\d*(?:\.\d*)?)(h|m|s|ms|f|t)$/, Gh = {
  left: "start",
  center: "center",
  right: "end",
  start: "start",
  end: "end"
};
function ua(o, e, t, n) {
  const r = Re(new Uint8Array(o), ["mdat"]);
  if (r.length === 0) {
    n(new Error("Could not parse IMSC1 mdat"));
    return;
  }
  const i = r.map((a) => jt(a)), s = ih(e.baseTime, 1, e.timescale);
  try {
    i.forEach((a) => t(Kh(a, s)));
  } catch (a) {
    n(a);
  }
}
function Kh(o, e) {
  const r = new DOMParser().parseFromString(o, "text/xml").getElementsByTagName("tt")[0];
  if (!r)
    throw new Error("Invalid ttml");
  const i = {
    frameRate: 30,
    subFrameRate: 1,
    frameRateMultiplier: 0,
    tickRate: 0
  }, s = Object.keys(i).reduce((u, c) => (u[c] = r.getAttribute(`ttp:${c}`) || i[c], u), {}), a = r.getAttribute("xml:space") !== "preserve", l = ha(yi(r, "styling", "style")), d = ha(yi(r, "layout", "region")), h = yi(r, "body", "[begin]");
  return [].map.call(h, (u) => {
    const c = _o(u, a);
    if (!c || !u.hasAttribute("begin"))
      return null;
    const m = vi(u.getAttribute("begin"), s), f = vi(u.getAttribute("dur"), s);
    let p = vi(u.getAttribute("end"), s);
    if (m === null)
      throw fa(u);
    if (p === null) {
      if (f === null)
        throw fa(u);
      p = m + f;
    }
    const A = new es(m - e, p - e, c);
    A.id = ts(A.startTime, A.endTime, A.text);
    const v = d[u.getAttribute("region")], b = l[u.getAttribute("style")], _ = $h(v, b, l), {
      textAlign: T
    } = _;
    if (T) {
      const E = Gh[T];
      E && (A.lineAlign = E), A.align = T;
    }
    return lt(A, _), A;
  }).filter((u) => u !== null);
}
function yi(o, e, t) {
  const n = o.getElementsByTagName(e)[0];
  return n ? [].slice.call(n.querySelectorAll(t)) : [];
}
function ha(o) {
  return o.reduce((e, t) => {
    const n = t.getAttribute("xml:id");
    return n && (e[n] = t), e;
  }, {});
}
function _o(o, e) {
  return [].slice.call(o.childNodes).reduce((t, n, r) => {
    var i;
    return n.nodeName === "br" && r ? t + `
` : (i = n.childNodes) != null && i.length ? _o(n, e) : e ? t + n.textContent.trim().replace(/\s+/g, " ") : t + n.textContent;
  }, "");
}
function $h(o, e, t) {
  const n = "http://www.w3.org/ns/ttml#styling";
  let r = null;
  const i = [
    "displayAlign",
    "textAlign",
    "color",
    "backgroundColor",
    "fontSize",
    "fontFamily"
    // 'fontWeight',
    // 'lineHeight',
    // 'wrapOption',
    // 'fontStyle',
    // 'direction',
    // 'writingMode'
  ], s = o != null && o.hasAttribute("style") ? o.getAttribute("style") : null;
  return s && t.hasOwnProperty(s) && (r = t[s]), i.reduce((a, l) => {
    const d = Ai(e, n, l) || Ai(o, n, l) || Ai(r, n, l);
    return d && (a[l] = d), a;
  }, {});
}
function Ai(o, e, t) {
  return o && o.hasAttributeNS(e, t) ? o.getAttributeNS(e, t) : null;
}
function fa(o) {
  return new Error(`Could not parse ttml timestamp ${o}`);
}
function vi(o, e) {
  if (!o)
    return null;
  let t = Ao(o);
  return t === null && (xo.test(o) ? t = Vh(o, e) : Eo.test(o) && (t = Wh(o, e))), t;
}
function Vh(o, e) {
  const t = xo.exec(o), n = (t[4] | 0) + (t[5] | 0) / e.subFrameRate;
  return (t[1] | 0) * 3600 + (t[2] | 0) * 60 + (t[3] | 0) + n / e.frameRate;
}
function Wh(o, e) {
  const t = Eo.exec(o), n = Number(t[1]);
  switch (t[2]) {
    case "h":
      return n * 3600;
    case "m":
      return n * 60;
    case "ms":
      return n * 1e3;
    case "f":
      return n / e.frameRate;
    case "t":
      return n / e.tickRate;
  }
  return n;
}
class Hh {
  constructor(e) {
    this.hls = void 0, this.media = null, this.config = void 0, this.enabled = !0, this.Cues = void 0, this.textTracks = [], this.tracks = [], this.initPTS = [], this.unparsedVttFrags = [], this.captionsTracks = {}, this.nonNativeCaptionsTracks = {}, this.cea608Parser1 = void 0, this.cea608Parser2 = void 0, this.lastCc = -1, this.lastSn = -1, this.lastPartIndex = -1, this.prevCC = -1, this.vttCCs = pa(), this.captionsProperties = void 0, this.hls = e, this.config = e.config, this.Cues = e.config.cueHandler, this.captionsProperties = {
      textTrack1: {
        label: this.config.captionsTextTrack1Label,
        languageCode: this.config.captionsTextTrack1LanguageCode
      },
      textTrack2: {
        label: this.config.captionsTextTrack2Label,
        languageCode: this.config.captionsTextTrack2LanguageCode
      },
      textTrack3: {
        label: this.config.captionsTextTrack3Label,
        languageCode: this.config.captionsTextTrack3LanguageCode
      },
      textTrack4: {
        label: this.config.captionsTextTrack4Label,
        languageCode: this.config.captionsTextTrack4LanguageCode
      }
    }, e.on(I.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(I.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(I.MANIFEST_LOADING, this.onManifestLoading, this), e.on(I.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(I.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.on(I.FRAG_LOADING, this.onFragLoading, this), e.on(I.FRAG_LOADED, this.onFragLoaded, this), e.on(I.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this), e.on(I.FRAG_DECRYPTED, this.onFragDecrypted, this), e.on(I.INIT_PTS_FOUND, this.onInitPtsFound, this), e.on(I.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this), e.on(I.BUFFER_FLUSHING, this.onBufferFlushing, this);
  }
  destroy() {
    const {
      hls: e
    } = this;
    e.off(I.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(I.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(I.MANIFEST_LOADING, this.onManifestLoading, this), e.off(I.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(I.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.off(I.FRAG_LOADING, this.onFragLoading, this), e.off(I.FRAG_LOADED, this.onFragLoaded, this), e.off(I.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this), e.off(I.FRAG_DECRYPTED, this.onFragDecrypted, this), e.off(I.INIT_PTS_FOUND, this.onInitPtsFound, this), e.off(I.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this), e.off(I.BUFFER_FLUSHING, this.onBufferFlushing, this), this.hls = this.config = this.cea608Parser1 = this.cea608Parser2 = null;
  }
  lazyInit608() {
    if (this.config.enableCEA708Captions && (!this.cea608Parser1 || !this.cea608Parser2)) {
      const e = new _r(this, "textTrack1"), t = new _r(this, "textTrack2"), n = new _r(this, "textTrack3"), r = new _r(this, "textTrack4");
      this.cea608Parser1 = new la(1, e, t), this.cea608Parser2 = new la(3, n, r);
    }
  }
  addCues(e, t, n, r, i) {
    let s = !1;
    for (let a = i.length; a--; ) {
      const l = i[a], d = Yh(l[0], l[1], t, n);
      if (d >= 0 && (l[0] = Math.min(l[0], t), l[1] = Math.max(l[1], n), s = !0, d / (n - t) > 0.5))
        return;
    }
    if (s || i.push([t, n]), this.config.renderTextTracksNatively) {
      const a = this.captionsTracks[e];
      this.Cues.newCue(a, t, n, r);
    } else {
      const a = this.Cues.newCue(null, t, n, r);
      this.hls.trigger(I.CUES_PARSED, {
        type: "captions",
        cues: a,
        track: e
      });
    }
  }
  // Triggered when an initial PTS is found; used for synchronisation of WebVTT.
  onInitPtsFound(e, {
    frag: t,
    id: n,
    initPTS: r,
    timescale: i
  }) {
    const {
      unparsedVttFrags: s
    } = this;
    n === "main" && (this.initPTS[t.cc] = {
      baseTime: r,
      timescale: i
    }), s.length && (this.unparsedVttFrags = [], s.forEach((a) => {
      this.onFragLoaded(I.FRAG_LOADED, a);
    }));
  }
  getExistingTrack(e) {
    const {
      media: t
    } = this;
    if (t)
      for (let n = 0; n < t.textTracks.length; n++) {
        const r = t.textTracks[n];
        if (r[e])
          return r;
      }
    return null;
  }
  createCaptionsTrack(e) {
    this.config.renderTextTracksNatively ? this.createNativeTrack(e) : this.createNonNativeTrack(e);
  }
  createNativeTrack(e) {
    if (this.captionsTracks[e])
      return;
    const {
      captionsProperties: t,
      captionsTracks: n,
      media: r
    } = this, {
      label: i,
      languageCode: s
    } = t[e], a = this.getExistingTrack(e);
    if (a)
      n[e] = a, _n(n[e]), Ga(n[e], r);
    else {
      const l = this.createTextTrack("captions", i, s);
      l && (l[e] = !0, n[e] = l);
    }
  }
  createNonNativeTrack(e) {
    if (this.nonNativeCaptionsTracks[e])
      return;
    const t = this.captionsProperties[e];
    if (!t)
      return;
    const n = t.label, r = {
      _id: e,
      label: n,
      kind: "captions",
      default: t.media ? !!t.media.default : !1,
      closedCaptions: t.media
    };
    this.nonNativeCaptionsTracks[e] = r, this.hls.trigger(I.NON_NATIVE_TEXT_TRACKS_FOUND, {
      tracks: [r]
    });
  }
  createTextTrack(e, t, n) {
    const r = this.media;
    if (r)
      return r.addTextTrack(e, t, n);
  }
  onMediaAttaching(e, t) {
    this.media = t.media, this._cleanTracks();
  }
  onMediaDetaching() {
    const {
      captionsTracks: e
    } = this;
    Object.keys(e).forEach((t) => {
      _n(e[t]), delete e[t];
    }), this.nonNativeCaptionsTracks = {};
  }
  onManifestLoading() {
    this.lastCc = -1, this.lastSn = -1, this.lastPartIndex = -1, this.prevCC = -1, this.vttCCs = pa(), this._cleanTracks(), this.tracks = [], this.captionsTracks = {}, this.nonNativeCaptionsTracks = {}, this.textTracks = [], this.unparsedVttFrags = [], this.initPTS = [], this.cea608Parser1 && this.cea608Parser2 && (this.cea608Parser1.reset(), this.cea608Parser2.reset());
  }
  _cleanTracks() {
    const {
      media: e
    } = this;
    if (!e)
      return;
    const t = e.textTracks;
    if (t)
      for (let n = 0; n < t.length; n++)
        _n(t[n]);
  }
  onSubtitleTracksUpdated(e, t) {
    const n = t.subtitleTracks || [], r = n.some((i) => i.textCodec === gi);
    if (this.config.enableWebVTT || r && this.config.enableIMSC1) {
      if (mo(this.tracks, n)) {
        this.tracks = n;
        return;
      }
      if (this.textTracks = [], this.tracks = n, this.config.renderTextTracksNatively) {
        const s = this.media ? this.media.textTracks : null;
        this.tracks.forEach((a, l) => {
          let d;
          if (s && l < s.length) {
            let h = null;
            for (let u = 0; u < s.length; u++)
              if (zh(s[u], a)) {
                h = s[u];
                break;
              }
            h && (d = h);
          }
          if (d)
            _n(d);
          else {
            const h = this._captionsOrSubtitlesFromCharacteristics(a);
            d = this.createTextTrack(h, a.name, a.lang), d && (d.mode = "disabled");
          }
          d && (d.groupId = a.groupId, this.textTracks.push(d));
        });
      } else if (this.tracks.length) {
        const s = this.tracks.map((a) => ({
          label: a.name,
          kind: a.type.toLowerCase(),
          default: a.default,
          subtitleTrack: a
        }));
        this.hls.trigger(I.NON_NATIVE_TEXT_TRACKS_FOUND, {
          tracks: s
        });
      }
    }
  }
  _captionsOrSubtitlesFromCharacteristics(e) {
    return e.attrs.CHARACTERISTICS && /transcribes-spoken-dialog/gi.test(e.attrs.CHARACTERISTICS) && /describes-music-and-sound/gi.test(e.attrs.CHARACTERISTICS) ? "captions" : "subtitles";
  }
  onManifestLoaded(e, t) {
    this.config.enableCEA708Captions && t.captions && t.captions.forEach((n) => {
      const r = /(?:CC|SERVICE)([1-4])/.exec(n.instreamId);
      if (!r)
        return;
      const i = `textTrack${r[1]}`, s = this.captionsProperties[i];
      s && (s.label = n.name, n.lang && (s.languageCode = n.lang), s.media = n);
    });
  }
  closedCaptionsForLevel(e) {
    const t = this.hls.levels[e.level];
    return t == null ? void 0 : t.attrs["CLOSED-CAPTIONS"];
  }
  onFragLoading(e, t) {
    const {
      cea608Parser1: n,
      cea608Parser2: r,
      lastCc: i,
      lastSn: s,
      lastPartIndex: a
    } = this;
    if (!(!this.enabled || !(n && r)) && t.frag.type === be.MAIN) {
      var l, d;
      const {
        cc: h,
        sn: u
      } = t.frag, c = (l = t == null || (d = t.part) == null ? void 0 : d.index) != null ? l : -1;
      u === s + 1 || u === s && c === a + 1 || h === i || (n.reset(), r.reset()), this.lastCc = h, this.lastSn = u, this.lastPartIndex = c;
    }
  }
  onFragLoaded(e, t) {
    const {
      frag: n,
      payload: r
    } = t;
    if (n.type === be.SUBTITLE)
      if (r.byteLength) {
        const i = n.decryptdata, s = "stats" in t;
        if (i == null || !i.encrypted || s) {
          const a = this.tracks[n.level], l = this.vttCCs;
          l[n.cc] || (l[n.cc] = {
            start: n.start,
            prevCC: this.prevCC,
            new: !0
          }, this.prevCC = n.cc), a && a.textCodec === gi ? this._parseIMSC1(n, r) : this._parseVTTs(t);
        }
      } else
        this.hls.trigger(I.SUBTITLE_FRAG_PROCESSED, {
          success: !1,
          frag: n,
          error: new Error("Empty subtitle payload")
        });
  }
  _parseIMSC1(e, t) {
    const n = this.hls;
    ua(t, this.initPTS[e.cc], (r) => {
      this._appendCues(r, e.level), n.trigger(I.SUBTITLE_FRAG_PROCESSED, {
        success: !0,
        frag: e
      });
    }, (r) => {
      V.log(`Failed to parse IMSC1: ${r}`), n.trigger(I.SUBTITLE_FRAG_PROCESSED, {
        success: !1,
        frag: e,
        error: r
      });
    });
  }
  _parseVTTs(e) {
    var t;
    const {
      frag: n,
      payload: r
    } = e, {
      initPTS: i,
      unparsedVttFrags: s
    } = this, a = i.length - 1;
    if (!i[n.cc] && a === -1) {
      s.push(e);
      return;
    }
    const l = this.hls, d = (t = n.initSegment) != null && t.data ? xt(n.initSegment.data, new Uint8Array(r)) : r;
    jh(d, this.initPTS[n.cc], this.vttCCs, n.cc, n.start, (h) => {
      this._appendCues(h, n.level), l.trigger(I.SUBTITLE_FRAG_PROCESSED, {
        success: !0,
        frag: n
      });
    }, (h) => {
      const u = h.message === "Missing initPTS for VTT MPEGTS";
      u ? s.push(e) : this._fallbackToIMSC1(n, r), V.log(`Failed to parse VTT cue: ${h}`), !(u && a > n.cc) && l.trigger(I.SUBTITLE_FRAG_PROCESSED, {
        success: !1,
        frag: n,
        error: h
      });
    });
  }
  _fallbackToIMSC1(e, t) {
    const n = this.tracks[e.level];
    n.textCodec || ua(t, this.initPTS[e.cc], () => {
      n.textCodec = gi, this._parseIMSC1(e, t);
    }, () => {
      n.textCodec = "wvtt";
    });
  }
  _appendCues(e, t) {
    const n = this.hls;
    if (this.config.renderTextTracksNatively) {
      const r = this.textTracks[t];
      if (!r || r.mode === "disabled")
        return;
      e.forEach((i) => Ka(r, i));
    } else {
      const r = this.tracks[t];
      if (!r)
        return;
      const i = r.default ? "default" : "subtitles" + t;
      n.trigger(I.CUES_PARSED, {
        type: "subtitles",
        cues: e,
        track: i
      });
    }
  }
  onFragDecrypted(e, t) {
    const {
      frag: n
    } = t;
    n.type === be.SUBTITLE && this.onFragLoaded(I.FRAG_LOADED, t);
  }
  onSubtitleTracksCleared() {
    this.tracks = [], this.captionsTracks = {};
  }
  onFragParsingUserdata(e, t) {
    if (!this.enabled)
      return;
    const {
      frag: n,
      samples: r
    } = t;
    if (n.type === be.MAIN && this.closedCaptionsForLevel(n) === "NONE")
      return;
    this.lazyInit608();
    const {
      cea608Parser1: i,
      cea608Parser2: s
    } = this;
    if (!(!i || !s))
      for (let a = 0; a < r.length; a++) {
        const l = r[a].bytes;
        if (l) {
          const d = this.extractCea608Data(l);
          i.addData(r[a].pts, d[0]), s.addData(r[a].pts, d[1]);
        }
      }
  }
  onBufferFlushing(e, {
    startOffset: t,
    endOffset: n,
    endOffsetSubtitles: r,
    type: i
  }) {
    const {
      media: s
    } = this;
    if (!(!s || s.currentTime < n)) {
      if (!i || i === "video") {
        const {
          captionsTracks: a
        } = this;
        Object.keys(a).forEach((l) => Li(a[l], t, n));
      }
      if (this.config.renderTextTracksNatively && t === 0 && r !== void 0) {
        const {
          textTracks: a
        } = this;
        Object.keys(a).forEach((l) => Li(a[l], t, r));
      }
    }
  }
  extractCea608Data(e) {
    const t = [[], []], n = e[0] & 31;
    let r = 2;
    for (let i = 0; i < n; i++) {
      const s = e[r++], a = 127 & e[r++], l = 127 & e[r++];
      if (a === 0 && l === 0)
        continue;
      if ((4 & s) !== 0) {
        const h = 3 & s;
        (h === 0 || h === 1) && (t[h].push(a), t[h].push(l));
      }
    }
    return t;
  }
}
function zh(o, e) {
  return !!o && o.label === e.name && !(o.textTrack1 || o.textTrack2);
}
function Yh(o, e, t, n) {
  return Math.min(e, n) - Math.max(o, t);
}
function pa() {
  return {
    ccOffset: 0,
    presentationOffset: 0,
    0: {
      start: 0,
      prevCC: -1,
      new: !0
    }
  };
}
class qh {
  constructor(e) {
    this.hls = void 0, this.isVideoPlaybackQualityAvailable = !1, this.timer = void 0, this.media = null, this.lastTime = void 0, this.lastDroppedFrames = 0, this.lastDecodedFrames = 0, this.streamController = void 0, this.hls = e, this.registerListeners();
  }
  setStreamController(e) {
    this.streamController = e;
  }
  registerListeners() {
    this.hls.on(I.MEDIA_ATTACHING, this.onMediaAttaching, this);
  }
  unregisterListeners() {
    this.hls.off(I.MEDIA_ATTACHING, this.onMediaAttaching, this);
  }
  destroy() {
    this.timer && clearInterval(this.timer), this.unregisterListeners(), this.isVideoPlaybackQualityAvailable = !1, this.media = null;
  }
  onMediaAttaching(e, t) {
    const n = this.hls.config;
    if (n.capLevelOnFPSDrop) {
      const r = t.media instanceof self.HTMLVideoElement ? t.media : null;
      this.media = r, r && typeof r.getVideoPlaybackQuality == "function" && (this.isVideoPlaybackQualityAvailable = !0), self.clearInterval(this.timer), this.timer = self.setInterval(this.checkFPSInterval.bind(this), n.fpsDroppedMonitoringPeriod);
    }
  }
  checkFPS(e, t, n) {
    const r = performance.now();
    if (t) {
      if (this.lastTime) {
        const i = r - this.lastTime, s = n - this.lastDroppedFrames, a = t - this.lastDecodedFrames, l = 1e3 * s / i, d = this.hls;
        if (d.trigger(I.FPS_DROP, {
          currentDropped: s,
          currentDecoded: a,
          totalDroppedFrames: n
        }), l > 0 && s > d.config.fpsDroppedMonitoringThreshold * a) {
          let h = d.currentLevel;
          V.warn("drop FPS ratio greater than max allowed value for currentLevel: " + h), h > 0 && (d.autoLevelCapping === -1 || d.autoLevelCapping >= h) && (h = h - 1, d.trigger(I.FPS_DROP_LEVEL_CAPPING, {
            level: h,
            droppedLevel: d.currentLevel
          }), d.autoLevelCapping = h, this.streamController.nextLevelSwitch());
        }
      }
      this.lastTime = r, this.lastDroppedFrames = n, this.lastDecodedFrames = t;
    }
  }
  checkFPSInterval() {
    const e = this.media;
    if (e)
      if (this.isVideoPlaybackQualityAvailable) {
        const t = e.getVideoPlaybackQuality();
        this.checkFPS(e, t.totalVideoFrames, t.droppedVideoFrames);
      } else
        this.checkFPS(e, e.webkitDecodedFrameCount, e.webkitDroppedFrameCount);
  }
}
const Tr = "[eme]";
class Sn {
  constructor(e) {
    this.hls = void 0, this.config = void 0, this.media = null, this.keyFormatPromise = null, this.keySystemAccessPromises = {}, this._requestLicenseFailureCount = 0, this.mediaKeySessions = [], this.keyIdToKeySessionPromise = {}, this.setMediaKeysQueue = Sn.CDMCleanupPromise ? [Sn.CDMCleanupPromise] : [], this.onMediaEncrypted = this._onMediaEncrypted.bind(this), this.onWaitingForKey = this._onWaitingForKey.bind(this), this.debug = V.debug.bind(V, Tr), this.log = V.log.bind(V, Tr), this.warn = V.warn.bind(V, Tr), this.error = V.error.bind(V, Tr), this.hls = e, this.config = e.config, this.registerListeners();
  }
  destroy() {
    this.unregisterListeners(), this.onMediaDetached();
    const e = this.config;
    e.requestMediaKeySystemAccessFunc = null, e.licenseXhrSetup = e.licenseResponseCallback = void 0, e.drmSystems = e.drmSystemOptions = {}, this.hls = this.onMediaEncrypted = this.onWaitingForKey = this.keyIdToKeySessionPromise = null, this.config = null;
  }
  registerListeners() {
    this.hls.on(I.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.on(I.MEDIA_DETACHED, this.onMediaDetached, this), this.hls.on(I.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.on(I.MANIFEST_LOADED, this.onManifestLoaded, this);
  }
  unregisterListeners() {
    this.hls.off(I.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.off(I.MEDIA_DETACHED, this.onMediaDetached, this), this.hls.off(I.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.off(I.MANIFEST_LOADED, this.onManifestLoaded, this);
  }
  getLicenseServerUrl(e) {
    const {
      drmSystems: t,
      widevineLicenseUrl: n
    } = this.config, r = t[e];
    if (r)
      return r.licenseUrl;
    if (e === Ye.WIDEVINE && n)
      return n;
    throw new Error(`no license server URL configured for key-system "${e}"`);
  }
  getServerCertificateUrl(e) {
    const {
      drmSystems: t
    } = this.config, n = t[e];
    if (n)
      return n.serverCertificateUrl;
    this.log(`No Server Certificate in config.drmSystems["${e}"]`);
  }
  attemptKeySystemAccess(e) {
    const t = this.hls.levels, n = (s, a, l) => !!s && l.indexOf(s) === a, r = t.map((s) => s.audioCodec).filter(n), i = t.map((s) => s.videoCodec).filter(n);
    return r.length + i.length === 0 && i.push("avc1.42e01e"), new Promise((s, a) => {
      const l = (d) => {
        const h = d.shift();
        this.getMediaKeysPromise(h, r, i).then((u) => s({
          keySystem: h,
          mediaKeys: u
        })).catch((u) => {
          d.length ? l(d) : u instanceof St ? a(u) : a(new St({
            type: xe.KEY_SYSTEM_ERROR,
            details: q.KEY_SYSTEM_NO_ACCESS,
            error: u,
            fatal: !0
          }, u.message));
        });
      };
      l(e);
    });
  }
  requestMediaKeySystemAccess(e, t) {
    const {
      requestMediaKeySystemAccessFunc: n
    } = this.config;
    if (typeof n != "function") {
      let r = `Configured requestMediaKeySystemAccess is not a function ${n}`;
      return Ra === null && self.location.protocol === "http:" && (r = `navigator.requestMediaKeySystemAccess is not available over insecure protocol ${location.protocol}`), Promise.reject(new Error(r));
    }
    return n(e, t);
  }
  getMediaKeysPromise(e, t, n) {
    const r = oc(e, t, n, this.config.drmSystemOptions), i = this.keySystemAccessPromises[e];
    let s = i == null ? void 0 : i.keySystemAccess;
    if (!s) {
      this.log(`Requesting encrypted media "${e}" key-system access with config: ${JSON.stringify(r)}`), s = this.requestMediaKeySystemAccess(e, r);
      const a = this.keySystemAccessPromises[e] = {
        keySystemAccess: s
      };
      return s.catch((l) => {
        this.log(`Failed to obtain access to key-system "${e}": ${l}`);
      }), s.then((l) => {
        this.log(`Access for key-system "${l.keySystem}" obtained`);
        const d = this.fetchServerCertificate(e);
        return this.log(`Create media-keys for "${e}"`), a.mediaKeys = l.createMediaKeys().then((h) => (this.log(`Media-keys created for "${e}"`), d.then((u) => u ? this.setMediaKeysServerCertificate(h, e, u) : h))), a.mediaKeys.catch((h) => {
          this.error(`Failed to create media-keys for "${e}"}: ${h}`);
        }), a.mediaKeys;
      });
    }
    return s.then(() => i.mediaKeys);
  }
  createMediaKeySessionContext({
    decryptdata: e,
    keySystem: t,
    mediaKeys: n
  }) {
    this.log(`Creating key-system session "${t}" keyId: ${Mt.hexDump(e.keyId || [])}`);
    const r = n.createSession(), i = {
      decryptdata: e,
      keySystem: t,
      mediaKeys: n,
      mediaKeysSession: r,
      keyStatus: "status-pending"
    };
    return this.mediaKeySessions.push(i), i;
  }
  renewKeySession(e) {
    const t = e.decryptdata;
    if (t.pssh) {
      const n = this.createMediaKeySessionContext(e), r = this.getKeyIdString(t), i = "cenc";
      this.keyIdToKeySessionPromise[r] = this.generateRequestWithPreferredKeySession(n, i, t.pssh, "expired");
    } else
      this.warn("Could not renew expired session. Missing pssh initData.");
    this.removeSession(e);
  }
  getKeyIdString(e) {
    if (!e)
      throw new Error("Could not read keyId of undefined decryptdata");
    if (e.keyId === null)
      throw new Error("keyId is null");
    return Mt.hexDump(e.keyId);
  }
  updateKeySession(e, t) {
    var n;
    const r = e.mediaKeysSession;
    return this.log(`Updating key-session "${r.sessionId}" for keyID ${Mt.hexDump(((n = e.decryptdata) == null ? void 0 : n.keyId) || [])}
      } (data length: ${t && t.byteLength})`), r.update(t);
  }
  selectKeySystemFormat(e) {
    const t = Object.keys(e.levelkeys || {});
    return this.keyFormatPromise || (this.log(`Selecting key-system from fragment (sn: ${e.sn} ${e.type}: ${e.level}) key formats ${t.join(", ")}`), this.keyFormatPromise = this.getKeyFormatPromise(t)), this.keyFormatPromise;
  }
  getKeyFormatPromise(e) {
    return new Promise((t, n) => {
      const r = ti(this.config), i = e.map(Cs).filter((s) => !!s && r.indexOf(s) !== -1);
      return this.getKeySystemSelectionPromise(i).then(({
        keySystem: s
      }) => {
        const a = Ls(s);
        a ? t(a) : n(new Error(`Unable to find format for key-system "${s}"`));
      }).catch(n);
    });
  }
  loadKey(e) {
    const t = e.keyInfo.decryptdata, n = this.getKeyIdString(t), r = `(keyId: ${n} format: "${t.keyFormat}" method: ${t.method} uri: ${t.uri})`;
    this.log(`Starting session for key ${r}`);
    let i = this.keyIdToKeySessionPromise[n];
    return i || (i = this.keyIdToKeySessionPromise[n] = this.getKeySystemForKeyPromise(t).then(({
      keySystem: s,
      mediaKeys: a
    }) => (this.throwIfDestroyed(), this.log(`Handle encrypted media sn: ${e.frag.sn} ${e.frag.type}: ${e.frag.level} using key ${r}`), this.attemptSetMediaKeys(s, a).then(() => {
      this.throwIfDestroyed();
      const l = this.createMediaKeySessionContext({
        keySystem: s,
        mediaKeys: a,
        decryptdata: t
      }), d = "cenc";
      return this.generateRequestWithPreferredKeySession(l, d, t.pssh, "playlist-key");
    }))), i.catch((s) => this.handleError(s))), i;
  }
  throwIfDestroyed(e = "Invalid state") {
    if (!this.hls)
      throw new Error("invalid state");
  }
  handleError(e) {
    this.hls && (this.error(e.message), e instanceof St ? this.hls.trigger(I.ERROR, e.data) : this.hls.trigger(I.ERROR, {
      type: xe.KEY_SYSTEM_ERROR,
      details: q.KEY_SYSTEM_NO_KEYS,
      error: e,
      fatal: !0
    }));
  }
  getKeySystemForKeyPromise(e) {
    const t = this.getKeyIdString(e), n = this.keyIdToKeySessionPromise[t];
    if (!n) {
      const r = Cs(e.keyFormat), i = r ? [r] : ti(this.config);
      return this.attemptKeySystemAccess(i);
    }
    return n;
  }
  getKeySystemSelectionPromise(e) {
    if (e.length || (e = ti(this.config)), e.length === 0)
      throw new St({
        type: xe.KEY_SYSTEM_ERROR,
        details: q.KEY_SYSTEM_NO_CONFIGURED_LICENSE,
        fatal: !0
      }, `Missing key-system license configuration options ${JSON.stringify({
        drmSystems: this.config.drmSystems
      })}`);
    return this.attemptKeySystemAccess(e);
  }
  _onMediaEncrypted(e) {
    const {
      initDataType: t,
      initData: n
    } = e;
    if (this.debug(`"${e.type}" event: init data type: "${t}"`), n === null)
      return;
    let r, i;
    if (t === "sinf" && this.config.drmSystems[Ye.FAIRPLAY]) {
      const h = ot(new Uint8Array(n));
      try {
        const u = ji(JSON.parse(h).sinf), c = Ma(new Uint8Array(u));
        if (!c)
          return;
        r = c.subarray(8, 24), i = Ye.FAIRPLAY;
      } catch {
        this.warn('Failed to parse sinf "encrypted" event message initData');
        return;
      }
    } else {
      const h = kc(n);
      if (h === null)
        return;
      h.version === 0 && h.systemId === wa.WIDEVINE && h.data && (r = h.data.subarray(8, 24)), i = ac(h.systemId);
    }
    if (!i || !r)
      return;
    const s = Mt.hexDump(r), {
      keyIdToKeySessionPromise: a,
      mediaKeySessions: l
    } = this;
    let d = a[s];
    for (let h = 0; h < l.length; h++) {
      const u = l[h], c = u.decryptdata;
      if (c.pssh || !c.keyId)
        continue;
      const m = Mt.hexDump(c.keyId);
      if (s === m || c.uri.replace(/-/g, "").indexOf(s) !== -1) {
        d = a[m], delete a[m], c.pssh = new Uint8Array(n), c.keyId = r, d = a[s] = d.then(() => this.generateRequestWithPreferredKeySession(u, t, n, "encrypted-event-key-match"));
        break;
      }
    }
    d || (d = a[s] = this.getKeySystemSelectionPromise([i]).then(({
      keySystem: h,
      mediaKeys: u
    }) => {
      var c;
      this.throwIfDestroyed();
      const m = new nr("ISO-23001-7", s, (c = Ls(h)) != null ? c : "");
      return m.pssh = new Uint8Array(n), m.keyId = r, this.attemptSetMediaKeys(h, u).then(() => {
        this.throwIfDestroyed();
        const f = this.createMediaKeySessionContext({
          decryptdata: m,
          keySystem: h,
          mediaKeys: u
        });
        return this.generateRequestWithPreferredKeySession(f, t, n, "encrypted-event-no-match");
      });
    })), d.catch((h) => this.handleError(h));
  }
  _onWaitingForKey(e) {
    this.log(`"${e.type}" event`);
  }
  attemptSetMediaKeys(e, t) {
    const n = this.setMediaKeysQueue.slice();
    this.log(`Setting media-keys for "${e}"`);
    const r = Promise.all(n).then(() => {
      if (!this.media)
        throw new Error("Attempted to set mediaKeys without media element attached");
      return this.media.setMediaKeys(t);
    });
    return this.setMediaKeysQueue.push(r), r.then(() => {
      this.log(`Media-keys set for "${e}"`), n.push(r), this.setMediaKeysQueue = this.setMediaKeysQueue.filter((i) => n.indexOf(i) === -1);
    });
  }
  generateRequestWithPreferredKeySession(e, t, n, r) {
    var i, s;
    const a = (i = this.config.drmSystems) == null || (s = i[e.keySystem]) == null ? void 0 : s.generateRequest;
    if (a)
      try {
        const c = a.call(this.hls, t, n, e);
        if (!c)
          throw new Error("Invalid response from configured generateRequest filter");
        t = c.initDataType, n = e.decryptdata.pssh = c.initData ? new Uint8Array(c.initData) : null;
      } catch (c) {
        var l;
        if (this.warn(c.message), (l = this.hls) != null && l.config.debug)
          throw c;
      }
    if (n === null)
      return this.log(`Skipping key-session request for "${r}" (no initData)`), Promise.resolve(e);
    const d = this.getKeyIdString(e.decryptdata);
    this.log(`Generating key-session request for "${r}": ${d} (init data type: ${t} length: ${n ? n.byteLength : null})`);
    const h = new Ji();
    e.mediaKeysSession.onmessage = (c) => {
      const m = e.mediaKeysSession;
      if (!m) {
        h.emit("error", new Error("invalid state"));
        return;
      }
      const {
        messageType: f,
        message: p
      } = c;
      this.log(`"${f}" message event for session "${m.sessionId}" message size: ${p.byteLength}`), f === "license-request" || f === "license-renewal" ? this.renewLicense(e, p).catch((A) => {
        this.handleError(A), h.emit("error", A);
      }) : f === "license-release" ? e.keySystem === Ye.FAIRPLAY && (this.updateKeySession(e, _i("acknowledged")), this.removeSession(e)) : this.warn(`unhandled media key message type "${f}"`);
    }, e.mediaKeysSession.onkeystatuseschange = (c) => {
      if (!e.mediaKeysSession) {
        h.emit("error", new Error("invalid state"));
        return;
      }
      this.onKeyStatusChange(e);
      const f = e.keyStatus;
      h.emit("keyStatus", f), f === "expired" && (this.warn(`${e.keySystem} expired for key ${d}`), this.renewKeySession(e));
    };
    const u = new Promise((c, m) => {
      h.on("error", m), h.on("keyStatus", (f) => {
        f.startsWith("usable") ? c() : f === "output-restricted" ? m(new St({
          type: xe.KEY_SYSTEM_ERROR,
          details: q.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED,
          fatal: !1
        }, "HDCP level output restricted")) : f === "internal-error" ? m(new St({
          type: xe.KEY_SYSTEM_ERROR,
          details: q.KEY_SYSTEM_STATUS_INTERNAL_ERROR,
          fatal: !0
        }, `key status changed to "${f}"`)) : f === "expired" ? m(new Error("key expired while generating request")) : this.warn(`unhandled key status change "${f}"`);
      });
    });
    return e.mediaKeysSession.generateRequest(t, n).then(() => {
      var c;
      this.log(`Request generated for key-session "${(c = e.mediaKeysSession) == null ? void 0 : c.sessionId}" keyId: ${d}`);
    }).catch((c) => {
      throw new St({
        type: xe.KEY_SYSTEM_ERROR,
        details: q.KEY_SYSTEM_NO_SESSION,
        error: c,
        fatal: !1
      }, `Error generating key-session request: ${c}`);
    }).then(() => u).catch((c) => {
      throw h.removeAllListeners(), this.removeSession(e), c;
    }).then(() => (h.removeAllListeners(), e));
  }
  onKeyStatusChange(e) {
    e.mediaKeysSession.keyStatuses.forEach((t, n) => {
      this.log(`key status change "${t}" for keyStatuses keyId: ${Mt.hexDump("buffer" in n ? new Uint8Array(n.buffer, n.byteOffset, n.byteLength) : new Uint8Array(n))} session keyId: ${Mt.hexDump(new Uint8Array(e.decryptdata.keyId || []))} uri: ${e.decryptdata.uri}`), e.keyStatus = t;
    });
  }
  fetchServerCertificate(e) {
    const t = this.config, n = t.loader, r = new n(t), i = this.getServerCertificateUrl(e);
    return i ? (this.log(`Fetching server certificate for "${e}"`), new Promise((s, a) => {
      const l = {
        responseType: "arraybuffer",
        url: i
      }, d = t.certLoadPolicy.default, h = {
        loadPolicy: d,
        timeout: d.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0
      }, u = {
        onSuccess: (c, m, f, p) => {
          s(c.data);
        },
        onError: (c, m, f, p) => {
          a(new St({
            type: xe.KEY_SYSTEM_ERROR,
            details: q.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
            fatal: !0,
            networkDetails: f,
            response: it({
              url: l.url,
              data: void 0
            }, c)
          }, `"${e}" certificate request failed (${i}). Status: ${c.code} (${c.text})`));
        },
        onTimeout: (c, m, f) => {
          a(new St({
            type: xe.KEY_SYSTEM_ERROR,
            details: q.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
            fatal: !0,
            networkDetails: f,
            response: {
              url: l.url,
              data: void 0
            }
          }, `"${e}" certificate request timed out (${i})`));
        },
        onAbort: (c, m, f) => {
          a(new Error("aborted"));
        }
      };
      r.load(l, h, u);
    })) : Promise.resolve();
  }
  setMediaKeysServerCertificate(e, t, n) {
    return new Promise((r, i) => {
      e.setServerCertificate(n).then((s) => {
        this.log(`setServerCertificate ${s ? "success" : "not supported by CDM"} (${n == null ? void 0 : n.byteLength}) on "${t}"`), r(e);
      }).catch((s) => {
        i(new St({
          type: xe.KEY_SYSTEM_ERROR,
          details: q.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED,
          error: s,
          fatal: !0
        }, s.message));
      });
    });
  }
  renewLicense(e, t) {
    return this.requestLicense(e, new Uint8Array(t)).then((n) => this.updateKeySession(e, new Uint8Array(n)).catch((r) => {
      throw new St({
        type: xe.KEY_SYSTEM_ERROR,
        details: q.KEY_SYSTEM_SESSION_UPDATE_FAILED,
        error: r,
        fatal: !0
      }, r.message);
    }));
  }
  unpackPlayReadyKeyMessage(e, t) {
    const n = String.fromCharCode.apply(null, new Uint16Array(t.buffer));
    if (!n.includes("PlayReadyKeyMessage"))
      return e.setRequestHeader("Content-Type", "text/xml; charset=utf-8"), t;
    const r = new DOMParser().parseFromString(n, "application/xml"), i = r.querySelectorAll("HttpHeader");
    if (i.length > 0) {
      let h;
      for (let u = 0, c = i.length; u < c; u++) {
        var s, a;
        h = i[u];
        const m = (s = h.querySelector("name")) == null ? void 0 : s.textContent, f = (a = h.querySelector("value")) == null ? void 0 : a.textContent;
        m && f && e.setRequestHeader(m, f);
      }
    }
    const l = r.querySelector("Challenge"), d = l == null ? void 0 : l.textContent;
    if (!d)
      throw new Error("Cannot find <Challenge> in key message");
    return _i(atob(d));
  }
  setupLicenseXHR(e, t, n, r) {
    const i = this.config.licenseXhrSetup;
    return i ? Promise.resolve().then(() => {
      if (!n.decryptdata)
        throw new Error("Key removed");
      return i.call(this.hls, e, t, n, r);
    }).catch((s) => {
      if (!n.decryptdata)
        throw s;
      return e.open("POST", t, !0), i.call(this.hls, e, t, n, r);
    }).then((s) => (e.readyState || e.open("POST", t, !0), {
      xhr: e,
      licenseChallenge: s || r
    })) : (e.open("POST", t, !0), Promise.resolve({
      xhr: e,
      licenseChallenge: r
    }));
  }
  requestLicense(e, t) {
    const n = this.config.keyLoadPolicy.default;
    return new Promise((r, i) => {
      const s = this.getLicenseServerUrl(e.keySystem);
      this.log(`Sending license request to URL: ${s}`);
      const a = new XMLHttpRequest();
      a.responseType = "arraybuffer", a.onreadystatechange = () => {
        if (!this.hls || !e.mediaKeysSession)
          return i(new Error("invalid state"));
        if (a.readyState === 4)
          if (a.status === 200) {
            this._requestLicenseFailureCount = 0;
            let l = a.response;
            this.log(`License received ${l instanceof ArrayBuffer ? l.byteLength : l}`);
            const d = this.config.licenseResponseCallback;
            if (d)
              try {
                l = d.call(this.hls, a, s, e);
              } catch (h) {
                this.error(h);
              }
            r(l);
          } else {
            const l = n.errorRetry, d = l ? l.maxNumRetry : 0;
            if (this._requestLicenseFailureCount++, this._requestLicenseFailureCount > d || a.status >= 400 && a.status < 500)
              i(new St({
                type: xe.KEY_SYSTEM_ERROR,
                details: q.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                fatal: !0,
                networkDetails: a,
                response: {
                  url: s,
                  data: void 0,
                  code: a.status,
                  text: a.statusText
                }
              }, `License Request XHR failed (${s}). Status: ${a.status} (${a.statusText})`));
            else {
              const h = d - this._requestLicenseFailureCount + 1;
              this.warn(`Retrying license request, ${h} attempts left`), this.requestLicense(e, t).then(r, i);
            }
          }
      }, e.licenseXhr && e.licenseXhr.readyState !== XMLHttpRequest.DONE && e.licenseXhr.abort(), e.licenseXhr = a, this.setupLicenseXHR(a, s, e, t).then(({
        xhr: l,
        licenseChallenge: d
      }) => {
        e.keySystem == Ye.PLAYREADY && (d = this.unpackPlayReadyKeyMessage(l, d)), l.send(d);
      });
    });
  }
  onMediaAttached(e, t) {
    if (!this.config.emeEnabled)
      return;
    const n = t.media;
    this.media = n, n.addEventListener("encrypted", this.onMediaEncrypted), n.addEventListener("waitingforkey", this.onWaitingForKey);
  }
  onMediaDetached() {
    const e = this.media, t = this.mediaKeySessions;
    e && (e.removeEventListener("encrypted", this.onMediaEncrypted), e.removeEventListener("waitingforkey", this.onWaitingForKey), this.media = null), this._requestLicenseFailureCount = 0, this.setMediaKeysQueue = [], this.mediaKeySessions = [], this.keyIdToKeySessionPromise = {}, nr.clearKeyUriToKeyIdMap();
    const n = t.length;
    Sn.CDMCleanupPromise = Promise.all(t.map((r) => this.removeSession(r)).concat(e == null ? void 0 : e.setMediaKeys(null).catch((r) => {
      this.log(`Could not clear media keys: ${r}`);
    }))).then(() => {
      n && (this.log("finished closing key sessions and clearing media keys"), t.length = 0);
    }).catch((r) => {
      this.log(`Could not close sessions and clear media keys: ${r}`);
    });
  }
  onManifestLoading() {
    this.keyFormatPromise = null;
  }
  onManifestLoaded(e, {
    sessionKeys: t
  }) {
    if (!(!t || !this.config.emeEnabled) && !this.keyFormatPromise) {
      const n = t.reduce((r, i) => (r.indexOf(i.keyFormat) === -1 && r.push(i.keyFormat), r), []);
      this.log(`Selecting key-system from session-keys ${n.join(", ")}`), this.keyFormatPromise = this.getKeyFormatPromise(n);
    }
  }
  removeSession(e) {
    const {
      mediaKeysSession: t,
      licenseXhr: n
    } = e;
    if (t) {
      this.log(`Remove licenses and keys and close session ${t.sessionId}`), t.onmessage = null, t.onkeystatuseschange = null, n && n.readyState !== XMLHttpRequest.DONE && n.abort(), e.mediaKeysSession = e.decryptdata = e.licenseXhr = void 0;
      const r = this.mediaKeySessions.indexOf(e);
      return r > -1 && this.mediaKeySessions.splice(r, 1), t.remove().catch((i) => {
        this.log(`Could not remove session: ${i}`);
      }).then(() => t.close()).catch((i) => {
        this.log(`Could not close session: ${i}`);
      });
    }
  }
}
Sn.CDMCleanupPromise = void 0;
class St extends Error {
  constructor(e, t) {
    super(t), this.data = void 0, e.error || (e.error = new Error(t)), this.data = e, e.err = e.error;
  }
}
const Xh = 1;
var At = {
  MANIFEST: "m",
  AUDIO: "a",
  VIDEO: "v",
  MUXED: "av",
  INIT: "i",
  CAPTION: "c",
  TIMED_TEXT: "tt",
  KEY: "k",
  OTHER: "o"
};
const Qh = "h";
class tn {
  // eslint-disable-line no-restricted-globals
  constructor(e) {
    this.hls = void 0, this.config = void 0, this.media = void 0, this.sid = void 0, this.cid = void 0, this.useHeaders = !1, this.initialized = !1, this.starved = !1, this.buffering = !0, this.audioBuffer = void 0, this.videoBuffer = void 0, this.onWaiting = () => {
      this.initialized && (this.starved = !0), this.buffering = !0;
    }, this.onPlaying = () => {
      this.initialized || (this.initialized = !0), this.buffering = !1;
    }, this.applyPlaylistData = (r) => {
      try {
        this.apply(r, {
          ot: At.MANIFEST,
          su: !this.initialized
        });
      } catch (i) {
        V.warn("Could not generate manifest CMCD data.", i);
      }
    }, this.applyFragmentData = (r) => {
      try {
        const i = r.frag, s = this.hls.levels[i.level], a = this.getObjectType(i), l = {
          d: i.duration * 1e3,
          ot: a
        };
        (a === At.VIDEO || a === At.AUDIO || a == At.MUXED) && (l.br = s.bitrate / 1e3, l.tb = this.getTopBandwidth(a) / 1e3, l.bl = this.getBufferLength(a)), this.apply(r, l);
      } catch (i) {
        V.warn("Could not generate segment CMCD data.", i);
      }
    }, this.hls = e;
    const t = this.config = e.config, {
      cmcd: n
    } = t;
    n != null && (t.pLoader = this.createPlaylistLoader(), t.fLoader = this.createFragmentLoader(), this.sid = n.sessionId || tn.uuid(), this.cid = n.contentId, this.useHeaders = n.useHeaders === !0, this.registerListeners());
  }
  registerListeners() {
    const e = this.hls;
    e.on(I.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(I.MEDIA_DETACHED, this.onMediaDetached, this), e.on(I.BUFFER_CREATED, this.onBufferCreated, this);
  }
  unregisterListeners() {
    const e = this.hls;
    e.off(I.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(I.MEDIA_DETACHED, this.onMediaDetached, this), e.off(I.BUFFER_CREATED, this.onBufferCreated, this);
  }
  destroy() {
    this.unregisterListeners(), this.onMediaDetached(), this.hls = this.config = this.audioBuffer = this.videoBuffer = null;
  }
  onMediaAttached(e, t) {
    this.media = t.media, this.media.addEventListener("waiting", this.onWaiting), this.media.addEventListener("playing", this.onPlaying);
  }
  onMediaDetached() {
    this.media && (this.media.removeEventListener("waiting", this.onWaiting), this.media.removeEventListener("playing", this.onPlaying), this.media = null);
  }
  onBufferCreated(e, t) {
    var n, r;
    this.audioBuffer = (n = t.tracks.audio) == null ? void 0 : n.buffer, this.videoBuffer = (r = t.tracks.video) == null ? void 0 : r.buffer;
  }
  /**
   * Create baseline CMCD data
   */
  createData() {
    var e;
    return {
      v: Xh,
      sf: Qh,
      sid: this.sid,
      cid: this.cid,
      pr: (e = this.media) == null ? void 0 : e.playbackRate,
      mtp: this.hls.bandwidthEstimate / 1e3
    };
  }
  /**
   * Apply CMCD data to a request.
   */
  apply(e, t = {}) {
    lt(t, this.createData());
    const n = t.ot === At.INIT || t.ot === At.VIDEO || t.ot === At.MUXED;
    if (this.starved && n && (t.bs = !0, t.su = !0, this.starved = !1), t.su == null && (t.su = this.buffering), this.useHeaders) {
      const r = tn.toHeaders(t);
      if (!Object.keys(r).length)
        return;
      e.headers || (e.headers = {}), lt(e.headers, r);
    } else {
      const r = tn.toQuery(t);
      if (!r)
        return;
      e.url = tn.appendQueryToUri(e.url, r);
    }
  }
  /**
   * The CMCD object type.
   */
  getObjectType(e) {
    const {
      type: t
    } = e;
    if (t === "subtitle")
      return At.TIMED_TEXT;
    if (e.sn === "initSegment")
      return At.INIT;
    if (t === "audio")
      return At.AUDIO;
    if (t === "main")
      return this.hls.audioTracks.length ? At.VIDEO : At.MUXED;
  }
  /**
   * Get the highest bitrate.
   */
  getTopBandwidth(e) {
    let t = 0, n;
    const r = this.hls;
    if (e === At.AUDIO)
      n = r.audioTracks;
    else {
      const i = r.maxAutoLevel, s = i > -1 ? i + 1 : r.levels.length;
      n = r.levels.slice(0, s);
    }
    for (const i of n)
      i.bitrate > t && (t = i.bitrate);
    return t > 0 ? t : NaN;
  }
  /**
   * Get the buffer length for a media type in milliseconds
   */
  getBufferLength(e) {
    const t = this.hls.media, n = e === At.AUDIO ? this.audioBuffer : this.videoBuffer;
    return !n || !t ? NaN : He.bufferInfo(n, t.currentTime, this.config.maxBufferHole).len * 1e3;
  }
  /**
   * Create a playlist loader
   */
  createPlaylistLoader() {
    const {
      pLoader: e
    } = this.config, t = this.applyPlaylistData, n = e || this.config.loader;
    return class {
      constructor(i) {
        this.loader = void 0, this.loader = new n(i);
      }
      get stats() {
        return this.loader.stats;
      }
      get context() {
        return this.loader.context;
      }
      destroy() {
        this.loader.destroy();
      }
      abort() {
        this.loader.abort();
      }
      load(i, s, a) {
        t(i), this.loader.load(i, s, a);
      }
    };
  }
  /**
   * Create a playlist loader
   */
  createFragmentLoader() {
    const {
      fLoader: e
    } = this.config, t = this.applyFragmentData, n = e || this.config.loader;
    return class {
      constructor(i) {
        this.loader = void 0, this.loader = new n(i);
      }
      get stats() {
        return this.loader.stats;
      }
      get context() {
        return this.loader.context;
      }
      destroy() {
        this.loader.destroy();
      }
      abort() {
        this.loader.abort();
      }
      load(i, s, a) {
        t(i), this.loader.load(i, s, a);
      }
    };
  }
  /**
   * Generate a random v4 UUI
   *
   * @returns {string}
   */
  static uuid() {
    const e = URL.createObjectURL(new Blob()), t = e.toString();
    return URL.revokeObjectURL(e), t.slice(t.lastIndexOf("/") + 1);
  }
  /**
   * Serialize a CMCD data object according to the rules defined in the
   * section 3.2 of
   * [CTA-5004](https://cdn.cta.tech/cta/media/media/resources/standards/pdfs/cta-5004-final.pdf).
   */
  static serialize(e) {
    const t = [], n = (d) => !Number.isNaN(d) && d != null && d !== "" && d !== !1, r = (d) => Math.round(d), i = (d) => r(d / 100) * 100, a = {
      br: r,
      d: r,
      bl: i,
      dl: i,
      mtp: i,
      nor: (d) => encodeURIComponent(d),
      rtp: i,
      tb: r
    }, l = Object.keys(e || {}).sort();
    for (const d of l) {
      let h = e[d];
      if (!n(h) || d === "v" && h === 1 || d == "pr" && h === 1)
        continue;
      const u = a[d];
      u && (h = u(h));
      const c = typeof h;
      let m;
      d === "ot" || d === "sf" || d === "st" ? m = `${d}=${h}` : c === "boolean" ? m = d : c === "number" ? m = `${d}=${h}` : m = `${d}=${JSON.stringify(h)}`, t.push(m);
    }
    return t.join(",");
  }
  /**
   * Convert a CMCD data object to request headers according to the rules
   * defined in the section 2.1 and 3.2 of
   * [CTA-5004](https://cdn.cta.tech/cta/media/media/resources/standards/pdfs/cta-5004-final.pdf).
   */
  static toHeaders(e) {
    const t = Object.keys(e), n = {}, r = ["Object", "Request", "Session", "Status"], i = [{}, {}, {}, {}], s = {
      br: 0,
      d: 0,
      ot: 0,
      tb: 0,
      bl: 1,
      dl: 1,
      mtp: 1,
      nor: 1,
      nrr: 1,
      su: 1,
      cid: 2,
      pr: 2,
      sf: 2,
      sid: 2,
      st: 2,
      v: 2,
      bs: 3,
      rtp: 3
    };
    for (const a of t) {
      const l = s[a] != null ? s[a] : 1;
      i[l][a] = e[a];
    }
    for (let a = 0; a < i.length; a++) {
      const l = tn.serialize(i[a]);
      l && (n[`CMCD-${r[a]}`] = l);
    }
    return n;
  }
  /**
   * Convert a CMCD data object to query args according to the rules
   * defined in the section 2.2 and 3.2 of
   * [CTA-5004](https://cdn.cta.tech/cta/media/media/resources/standards/pdfs/cta-5004-final.pdf).
   */
  static toQuery(e) {
    return `CMCD=${encodeURIComponent(tn.serialize(e))}`;
  }
  /**
   * Append query args to a uri.
   */
  static appendQueryToUri(e, t) {
    if (!t)
      return e;
    const n = e.includes("?") ? "&" : "?";
    return `${e}${n}${t}`;
  }
}
const Zh = 3e5;
class Jh {
  constructor(e) {
    this.hls = void 0, this.log = void 0, this.loader = null, this.uri = null, this.pathwayId = ".", this.pathwayPriority = null, this.timeToLoad = 300, this.reloadTimer = -1, this.updated = 0, this.started = !1, this.enabled = !0, this.levels = null, this.audioTracks = null, this.subtitleTracks = null, this.penalizedPathways = {}, this.hls = e, this.log = V.log.bind(V, "[content-steering]:"), this.registerListeners();
  }
  registerListeners() {
    const e = this.hls;
    e.on(I.MANIFEST_LOADING, this.onManifestLoading, this), e.on(I.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(I.MANIFEST_PARSED, this.onManifestParsed, this), e.on(I.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const e = this.hls;
    e && (e.off(I.MANIFEST_LOADING, this.onManifestLoading, this), e.off(I.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(I.MANIFEST_PARSED, this.onManifestParsed, this), e.off(I.ERROR, this.onError, this));
  }
  startLoad() {
    if (this.started = !0, this.clearTimeout(), this.enabled && this.uri)
      if (this.updated) {
        const e = Math.max(this.timeToLoad * 1e3 - (performance.now() - this.updated), 0);
        this.scheduleRefresh(this.uri, e);
      } else
        this.loadSteeringManifest(this.uri);
  }
  stopLoad() {
    this.started = !1, this.loader && (this.loader.destroy(), this.loader = null), this.clearTimeout();
  }
  clearTimeout() {
    this.reloadTimer !== -1 && (self.clearTimeout(this.reloadTimer), this.reloadTimer = -1);
  }
  destroy() {
    this.unregisterListeners(), this.stopLoad(), this.hls = null, this.levels = this.audioTracks = this.subtitleTracks = null;
  }
  removeLevel(e) {
    const t = this.levels;
    t && (this.levels = t.filter((n) => n !== e));
  }
  onManifestLoading() {
    this.stopLoad(), this.enabled = !0, this.timeToLoad = 300, this.updated = 0, this.uri = null, this.pathwayId = ".", this.levels = this.audioTracks = this.subtitleTracks = null;
  }
  onManifestLoaded(e, t) {
    const {
      contentSteering: n
    } = t;
    n !== null && (this.pathwayId = n.pathwayId, this.uri = n.uri, this.started && this.startLoad());
  }
  onManifestParsed(e, t) {
    this.audioTracks = t.audioTracks, this.subtitleTracks = t.subtitleTracks;
  }
  onError(e, t) {
    const {
      errorAction: n
    } = t;
    if ((n == null ? void 0 : n.action) === ut.SendAlternateToPenaltyBox && n.flags === Tt.MoveAllAlternatesMatchingHost) {
      let r = this.pathwayPriority;
      const i = this.pathwayId;
      this.penalizedPathways[i] || (this.penalizedPathways[i] = performance.now()), !r && this.levels && (r = this.levels.reduce((s, a) => (s.indexOf(a.pathwayId) === -1 && s.push(a.pathwayId), s), [])), r && r.length > 1 && (this.updatePathwayPriority(r), n.resolved = this.pathwayId !== i);
    }
  }
  filterParsedLevels(e) {
    this.levels = e;
    let t = this.getLevelsForPathway(this.pathwayId);
    if (t.length === 0) {
      const n = e[0].pathwayId;
      this.log(`No levels found in Pathway ${this.pathwayId}. Setting initial Pathway to "${n}"`), t = this.getLevelsForPathway(n), this.pathwayId = n;
    }
    return t.length !== e.length ? (this.log(`Found ${t.length}/${e.length} levels in Pathway "${this.pathwayId}"`), t) : e;
  }
  getLevelsForPathway(e) {
    return this.levels === null ? [] : this.levels.filter((t) => e === t.pathwayId);
  }
  updatePathwayPriority(e) {
    this.pathwayPriority = e;
    let t;
    const n = this.penalizedPathways, r = performance.now();
    Object.keys(n).forEach((i) => {
      r - n[i] > Zh && delete n[i];
    });
    for (let i = 0; i < e.length; i++) {
      const s = e[i];
      if (n[s])
        continue;
      if (s === this.pathwayId)
        return;
      const a = this.hls.nextLoadLevel, l = this.hls.levels[a];
      if (t = this.getLevelsForPathway(s), t.length > 0) {
        this.log(`Setting Pathway to "${s}"`), this.pathwayId = s, Ha(t), this.hls.trigger(I.LEVELS_UPDATED, {
          levels: t
        });
        const d = this.hls.levels[a];
        l && d && this.levels && (d.attrs["STABLE-VARIANT-ID"] !== l.attrs["STABLE-VARIANT-ID"] && d.bitrate !== l.bitrate && this.log(`Unstable Pathways change from bitrate ${l.bitrate} to ${d.bitrate}`), this.hls.nextLoadLevel = a);
        break;
      }
    }
  }
  clonePathways(e) {
    const t = this.levels;
    if (!t)
      return;
    const n = {}, r = {};
    e.forEach((i) => {
      const {
        ID: s,
        "BASE-ID": a,
        "URI-REPLACEMENT": l
      } = i;
      if (t.some((h) => h.pathwayId === s))
        return;
      const d = this.getLevelsForPathway(a).map((h) => {
        const u = lt({}, h);
        u.details = void 0, u.url = So(h.uri, h.attrs["STABLE-VARIANT-ID"], "PER-VARIANT-URIS", l);
        const c = new Ze(h.attrs);
        c["PATHWAY-ID"] = s;
        const m = c.AUDIO && `${c.AUDIO}_clone_${s}`, f = c.SUBTITLES && `${c.SUBTITLES}_clone_${s}`;
        m && (n[c.AUDIO] = m, c.AUDIO = m), f && (r[c.SUBTITLES] = f, c.SUBTITLES = f), u.attrs = c;
        const p = new rr(u);
        return Br(p, "audio", m), Br(p, "text", f), p;
      });
      t.push(...d), ma(this.audioTracks, n, l, s), ma(this.subtitleTracks, r, l, s);
    });
  }
  loadSteeringManifest(e) {
    const t = this.hls.config, n = t.loader;
    this.loader && this.loader.destroy(), this.loader = new n(t);
    let r;
    try {
      r = new self.URL(e);
    } catch {
      this.enabled = !1, this.log(`Failed to parse Steering Manifest URI: ${e}`);
      return;
    }
    if (r.protocol !== "data:") {
      const h = (this.hls.bandwidthEstimate || t.abrEwmaDefaultEstimate) | 0;
      r.searchParams.set("_HLS_pathway", this.pathwayId), r.searchParams.set("_HLS_throughput", "" + h);
    }
    const i = {
      responseType: "json",
      url: r.href
    }, s = t.steeringManifestLoadPolicy.default, a = s.errorRetry || s.timeoutRetry || {}, l = {
      loadPolicy: s,
      timeout: s.maxLoadTimeMs,
      maxRetry: a.maxNumRetry || 0,
      retryDelay: a.retryDelayMs || 0,
      maxRetryDelay: a.maxRetryDelayMs || 0
    }, d = {
      onSuccess: (h, u, c, m) => {
        this.log(`Loaded steering manifest: "${r}"`);
        const f = h.data;
        if (f.VERSION !== 1) {
          this.log(`Steering VERSION ${f.VERSION} not supported!`);
          return;
        }
        this.updated = performance.now(), this.timeToLoad = f.TTL;
        const {
          "RELOAD-URI": p,
          "PATHWAY-CLONES": A,
          "PATHWAY-PRIORITY": v
        } = f;
        if (p)
          try {
            this.uri = new self.URL(p, r).href;
          } catch {
            this.enabled = !1, this.log(`Failed to parse Steering Manifest RELOAD-URI: ${p}`);
            return;
          }
        this.scheduleRefresh(this.uri || c.url), A && this.clonePathways(A);
        const b = {
          steeringManifest: f,
          url: r.toString()
        };
        this.hls.trigger(I.STEERING_MANIFEST_LOADED, b), v && this.updatePathwayPriority(v);
      },
      onError: (h, u, c, m) => {
        if (this.log(`Error loading steering manifest: ${h.code} ${h.text} (${u.url})`), this.stopLoad(), h.code === 410) {
          this.enabled = !1, this.log(`Steering manifest ${u.url} no longer available`);
          return;
        }
        let f = this.timeToLoad * 1e3;
        if (h.code === 429) {
          const p = this.loader;
          if (typeof (p == null ? void 0 : p.getResponseHeader) == "function") {
            const A = p.getResponseHeader("Retry-After");
            A && (f = parseFloat(A) * 1e3);
          }
          this.log(`Steering manifest ${u.url} rate limited`);
          return;
        }
        this.scheduleRefresh(this.uri || u.url, f);
      },
      onTimeout: (h, u, c) => {
        this.log(`Timeout loading steering manifest (${u.url})`), this.scheduleRefresh(this.uri || u.url);
      }
    };
    this.log(`Requesting steering manifest: ${r}`), this.loader.load(i, l, d);
  }
  scheduleRefresh(e, t = this.timeToLoad * 1e3) {
    this.clearTimeout(), this.reloadTimer = self.setTimeout(() => {
      this.loadSteeringManifest(e);
    }, t);
  }
}
function ma(o, e, t, n) {
  o && Object.keys(e).forEach((r) => {
    const i = o.filter((s) => s.groupId === r).map((s) => {
      const a = lt({}, s);
      return a.details = void 0, a.attrs = new Ze(a.attrs), a.url = a.attrs.URI = So(s.url, s.attrs["STABLE-RENDITION-ID"], "PER-RENDITION-URIS", t), a.groupId = a.attrs["GROUP-ID"] = e[r], a.attrs["PATHWAY-ID"] = n, a;
    });
    o.push(...i);
  });
}
function So(o, e, t, n) {
  const {
    HOST: r,
    PARAMS: i,
    [t]: s
  } = n;
  let a;
  e && (a = s == null ? void 0 : s[e], a && (o = a));
  const l = new self.URL(o);
  return r && !a && (l.host = r), i && Object.keys(i).sort().forEach((d) => {
    d && l.searchParams.set(d, i[d]);
  }), l.href;
}
const ef = /^age:\s*[\d.]+\s*$/im;
class To {
  constructor(e) {
    this.xhrSetup = void 0, this.requestTimeout = void 0, this.retryTimeout = void 0, this.retryDelay = void 0, this.config = null, this.callbacks = null, this.context = null, this.loader = null, this.stats = void 0, this.xhrSetup = e && e.xhrSetup || null, this.stats = new Nr(), this.retryDelay = 0;
  }
  destroy() {
    this.callbacks = null, this.abortInternal(), this.loader = null, this.config = null, this.context = null, this.xhrSetup = null, this.stats = null;
  }
  abortInternal() {
    const e = this.loader;
    self.clearTimeout(this.requestTimeout), self.clearTimeout(this.retryTimeout), e && (e.onreadystatechange = null, e.onprogress = null, e.readyState !== 4 && (this.stats.aborted = !0, e.abort()));
  }
  abort() {
    var e;
    this.abortInternal(), (e = this.callbacks) != null && e.onAbort && this.callbacks.onAbort(this.stats, this.context, this.loader);
  }
  load(e, t, n) {
    if (this.stats.loading.start)
      throw new Error("Loader can only be used once.");
    this.stats.loading.start = self.performance.now(), this.context = e, this.config = t, this.callbacks = n, this.loadInternal();
  }
  loadInternal() {
    const {
      config: e,
      context: t
    } = this;
    if (!e || !t)
      return;
    const n = this.loader = new self.XMLHttpRequest(), r = this.stats;
    r.loading.first = 0, r.loaded = 0, r.aborted = !1;
    const i = this.xhrSetup;
    i ? Promise.resolve().then(() => {
      if (!this.stats.aborted)
        return i(n, t.url);
    }).catch((s) => (n.open("GET", t.url, !0), i(n, t.url))).then(() => {
      this.stats.aborted || this.openAndSendXhr(n, t, e);
    }).catch((s) => {
      this.callbacks.onError({
        code: n.status,
        text: s.message
      }, t, n, r);
    }) : this.openAndSendXhr(n, t, e);
  }
  openAndSendXhr(e, t, n) {
    e.readyState || e.open("GET", t.url, !0);
    const r = t.headers, {
      maxTimeToFirstByteMs: i,
      maxLoadTimeMs: s
    } = n.loadPolicy;
    if (r)
      for (const a in r)
        e.setRequestHeader(a, r[a]);
    t.rangeEnd && e.setRequestHeader("Range", "bytes=" + t.rangeStart + "-" + (t.rangeEnd - 1)), e.onreadystatechange = this.readystatechange.bind(this), e.onprogress = this.loadprogress.bind(this), e.responseType = t.responseType, self.clearTimeout(this.requestTimeout), n.timeout = i && ge(i) ? i : s, this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), n.timeout), e.send();
  }
  readystatechange() {
    const {
      context: e,
      loader: t,
      stats: n
    } = this;
    if (!e || !t)
      return;
    const r = t.readyState, i = this.config;
    if (!n.aborted && r >= 2 && (n.loading.first === 0 && (n.loading.first = Math.max(self.performance.now(), n.loading.start), i.timeout !== i.loadPolicy.maxLoadTimeMs && (self.clearTimeout(this.requestTimeout), i.timeout = i.loadPolicy.maxLoadTimeMs, this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), i.loadPolicy.maxLoadTimeMs - (n.loading.first - n.loading.start)))), r === 4)) {
      self.clearTimeout(this.requestTimeout), t.onreadystatechange = null, t.onprogress = null;
      const s = t.status, a = t.responseType !== "text";
      if (s >= 200 && s < 300 && (a && t.response || t.responseText !== null)) {
        n.loading.end = Math.max(self.performance.now(), n.loading.first);
        const l = a ? t.response : t.responseText, d = t.responseType === "arraybuffer" ? l.byteLength : l.length;
        if (n.loaded = n.total = d, n.bwEstimate = n.total * 8e3 / (n.loading.end - n.loading.first), !this.callbacks)
          return;
        const h = this.callbacks.onProgress;
        if (h && h(n, e, l, t), !this.callbacks)
          return;
        const u = {
          url: t.responseURL,
          data: l,
          code: s
        };
        this.callbacks.onSuccess(u, n, e, t);
      } else {
        const l = i.loadPolicy.errorRetry, d = n.retry, h = {
          url: e.url,
          data: void 0,
          code: s
        };
        Fr(l, d, !1, h) ? this.retry(l) : (V.error(`${s} while loading ${e.url}`), this.callbacks.onError({
          code: s,
          text: t.statusText
        }, e, t, n));
      }
    }
  }
  loadtimeout() {
    var e;
    const t = (e = this.config) == null ? void 0 : e.loadPolicy.timeoutRetry, n = this.stats.retry;
    if (Fr(t, n, !0))
      this.retry(t);
    else {
      var r;
      V.warn(`timeout while loading ${(r = this.context) == null ? void 0 : r.url}`);
      const i = this.callbacks;
      i && (this.abortInternal(), i.onTimeout(this.stats, this.context, this.loader));
    }
  }
  retry(e) {
    const {
      context: t,
      stats: n
    } = this;
    this.retryDelay = Vi(e, n.retry), n.retry++, V.warn(`${status ? "HTTP Status " + status : "Timeout"} while loading ${t == null ? void 0 : t.url}, retrying ${n.retry}/${e.maxNumRetry} in ${this.retryDelay}ms`), this.abortInternal(), this.loader = null, self.clearTimeout(this.retryTimeout), this.retryTimeout = self.setTimeout(this.loadInternal.bind(this), this.retryDelay);
  }
  loadprogress(e) {
    const t = this.stats;
    t.loaded = e.loaded, e.lengthComputable && (t.total = e.total);
  }
  getCacheAge() {
    let e = null;
    if (this.loader && ef.test(this.loader.getAllResponseHeaders())) {
      const t = this.loader.getResponseHeader("age");
      e = t ? parseFloat(t) : null;
    }
    return e;
  }
  getResponseHeader(e) {
    return this.loader && new RegExp(`^${e}:\\s*[\\d.]+\\s*$`, "im").test(this.loader.getAllResponseHeaders()) ? this.loader.getResponseHeader(e) : null;
  }
}
function tf() {
  if (
    // @ts-ignore
    self.fetch && self.AbortController && self.ReadableStream && self.Request
  )
    try {
      return new self.ReadableStream({}), !0;
    } catch {
    }
  return !1;
}
const nf = /(\d+)-(\d+)\/(\d+)/;
class ga {
  constructor(e) {
    this.fetchSetup = void 0, this.requestTimeout = void 0, this.request = null, this.response = null, this.controller = void 0, this.context = null, this.config = null, this.callbacks = null, this.stats = void 0, this.loader = null, this.fetchSetup = e.fetchSetup || of, this.controller = new self.AbortController(), this.stats = new Nr();
  }
  destroy() {
    this.loader = this.callbacks = this.context = this.config = this.request = null, this.abortInternal(), this.response = null, this.fetchSetup = this.controller = this.stats = null;
  }
  abortInternal() {
    const e = this.response;
    this.controller && !(e != null && e.ok) && (this.stats.aborted = !0, this.controller.abort());
  }
  abort() {
    var e;
    this.abortInternal(), (e = this.callbacks) != null && e.onAbort && this.callbacks.onAbort(this.stats, this.context, this.response);
  }
  load(e, t, n) {
    const r = this.stats;
    if (r.loading.start)
      throw new Error("Loader can only be used once.");
    r.loading.start = self.performance.now();
    const i = rf(e, this.controller.signal), s = n.onProgress, a = e.responseType === "arraybuffer", l = a ? "byteLength" : "length", {
      maxTimeToFirstByteMs: d,
      maxLoadTimeMs: h
    } = t.loadPolicy;
    this.context = e, this.config = t, this.callbacks = n, this.request = this.fetchSetup(e, i), self.clearTimeout(this.requestTimeout), t.timeout = d && ge(d) ? d : h, this.requestTimeout = self.setTimeout(() => {
      this.abortInternal(), n.onTimeout(r, e, this.response);
    }, t.timeout), self.fetch(this.request).then((u) => {
      this.response = this.loader = u;
      const c = Math.max(self.performance.now(), r.loading.start);
      if (self.clearTimeout(this.requestTimeout), t.timeout = h, this.requestTimeout = self.setTimeout(() => {
        this.abortInternal(), n.onTimeout(r, e, this.response);
      }, h - (c - r.loading.start)), !u.ok) {
        const {
          status: m,
          statusText: f
        } = u;
        throw new lf(f || "fetch, bad network response", m, u);
      }
      return r.loading.first = c, r.total = af(u.headers) || r.total, s && ge(t.highWaterMark) ? this.loadProgressively(u, r, e, t.highWaterMark, s) : a ? u.arrayBuffer() : e.responseType === "json" ? u.json() : u.text();
    }).then((u) => {
      const c = this.response;
      if (!c)
        throw new Error("loader destroyed");
      self.clearTimeout(this.requestTimeout), r.loading.end = Math.max(self.performance.now(), r.loading.first);
      const m = u[l];
      m && (r.loaded = r.total = m);
      const f = {
        url: c.url,
        data: u,
        code: c.status
      };
      s && !ge(t.highWaterMark) && s(r, e, u, c), n.onSuccess(f, r, e, c);
    }).catch((u) => {
      if (self.clearTimeout(this.requestTimeout), r.aborted)
        return;
      const c = u && u.code || 0, m = u ? u.message : null;
      n.onError({
        code: c,
        text: m
      }, e, u ? u.details : null, r);
    });
  }
  getCacheAge() {
    let e = null;
    if (this.response) {
      const t = this.response.headers.get("age");
      e = t ? parseFloat(t) : null;
    }
    return e;
  }
  getResponseHeader(e) {
    return this.response ? this.response.headers.get(e) : null;
  }
  loadProgressively(e, t, n, r = 0, i) {
    const s = new Xa(), a = e.body.getReader(), l = () => a.read().then((d) => {
      if (d.done)
        return s.dataLength && i(t, n, s.flush(), e), Promise.resolve(new ArrayBuffer(0));
      const h = d.value, u = h.length;
      return t.loaded += u, u < r || s.dataLength ? (s.push(h), s.dataLength >= r && i(t, n, s.flush(), e)) : i(t, n, h, e), l();
    }).catch(() => Promise.reject());
    return l();
  }
}
function rf(o, e) {
  const t = {
    method: "GET",
    mode: "cors",
    credentials: "same-origin",
    signal: e,
    headers: new self.Headers(lt({}, o.headers))
  };
  return o.rangeEnd && t.headers.set("Range", "bytes=" + o.rangeStart + "-" + String(o.rangeEnd - 1)), t;
}
function sf(o) {
  const e = nf.exec(o);
  if (e)
    return parseInt(e[2]) - parseInt(e[1]) + 1;
}
function af(o) {
  const e = o.get("Content-Range");
  if (e) {
    const n = sf(e);
    if (ge(n))
      return n;
  }
  const t = o.get("Content-Length");
  if (t)
    return parseInt(t);
}
function of(o, e) {
  return new self.Request(o.url, e);
}
class lf extends Error {
  constructor(e, t, n) {
    super(e), this.code = void 0, this.details = void 0, this.code = t, this.details = n;
  }
}
const df = /\s/, cf = {
  newCue(o, e, t, n) {
    const r = [];
    let i, s, a, l, d;
    const h = self.VTTCue || self.TextTrackCue;
    for (let c = 0; c < n.rows.length; c++)
      if (i = n.rows[c], a = !0, l = 0, d = "", !i.isEmpty()) {
        var u;
        for (let p = 0; p < i.chars.length; p++)
          df.test(i.chars[p].uchar) && a ? l++ : (d += i.chars[p].uchar, a = !1);
        i.cueStartTime = e, e === t && (t += 1e-4), l >= 16 ? l-- : l++;
        const m = bo(d.trim()), f = ts(e, t, m);
        o != null && (u = o.cues) != null && u.getCueById(f) || (s = new h(e, t, m), s.id = f, s.line = c + 1, s.align = "left", s.position = 10 + Math.min(80, Math.floor(l * 8 / 32) * 10), r.push(s));
      }
    return o && r.length && (r.sort((c, m) => c.line === "auto" || m.line === "auto" ? 0 : c.line > 8 && m.line > 8 ? m.line - c.line : c.line - m.line), r.forEach((c) => Ka(o, c))), r;
  }
}, uf = {
  maxTimeToFirstByteMs: 8e3,
  maxLoadTimeMs: 2e4,
  timeoutRetry: null,
  errorRetry: null
}, Co = it(it({
  autoStartLoad: !0,
  // used by stream-controller
  startPosition: -1,
  // used by stream-controller
  defaultAudioCodec: void 0,
  // used by stream-controller
  debug: !1,
  // used by logger
  capLevelOnFPSDrop: !1,
  // used by fps-controller
  capLevelToPlayerSize: !1,
  // used by cap-level-controller
  ignoreDevicePixelRatio: !1,
  // used by cap-level-controller
  preferManagedMediaSource: !0,
  initialLiveManifestSize: 1,
  // used by stream-controller
  maxBufferLength: 30,
  // used by stream-controller
  backBufferLength: 1 / 0,
  // used by buffer-controller
  frontBufferFlushThreshold: 1 / 0,
  maxBufferSize: 60 * 1e3 * 1e3,
  // used by stream-controller
  maxBufferHole: 0.1,
  // used by stream-controller
  highBufferWatchdogPeriod: 2,
  // used by stream-controller
  nudgeOffset: 0.1,
  // used by stream-controller
  nudgeMaxRetry: 3,
  // used by stream-controller
  maxFragLookUpTolerance: 0.25,
  // used by stream-controller
  liveSyncDurationCount: 3,
  // used by latency-controller
  liveMaxLatencyDurationCount: 1 / 0,
  // used by latency-controller
  liveSyncDuration: void 0,
  // used by latency-controller
  liveMaxLatencyDuration: void 0,
  // used by latency-controller
  maxLiveSyncPlaybackRate: 1,
  // used by latency-controller
  liveDurationInfinity: !1,
  // used by buffer-controller
  /**
   * @deprecated use backBufferLength
   */
  liveBackBufferLength: null,
  // used by buffer-controller
  maxMaxBufferLength: 600,
  // used by stream-controller
  enableWorker: !0,
  // used by transmuxer
  workerPath: null,
  // used by transmuxer
  enableSoftwareAES: !0,
  // used by decrypter
  startLevel: void 0,
  // used by level-controller
  startFragPrefetch: !1,
  // used by stream-controller
  fpsDroppedMonitoringPeriod: 5e3,
  // used by fps-controller
  fpsDroppedMonitoringThreshold: 0.2,
  // used by fps-controller
  appendErrorMaxRetry: 3,
  // used by buffer-controller
  loader: To,
  // loader: FetchLoader,
  fLoader: void 0,
  // used by fragment-loader
  pLoader: void 0,
  // used by playlist-loader
  xhrSetup: void 0,
  // used by xhr-loader
  licenseXhrSetup: void 0,
  // used by eme-controller
  licenseResponseCallback: void 0,
  // used by eme-controller
  abrController: yu,
  bufferController: _h,
  capLevelController: sr,
  errorController: lu,
  fpsController: qh,
  stretchShortVideoTrack: !1,
  // used by mp4-remuxer
  maxAudioFramesDrift: 1,
  // used by mp4-remuxer
  forceKeyFrameOnDiscontinuity: !0,
  // used by ts-demuxer
  abrEwmaFastLive: 3,
  // used by abr-controller
  abrEwmaSlowLive: 9,
  // used by abr-controller
  abrEwmaFastVoD: 3,
  // used by abr-controller
  abrEwmaSlowVoD: 9,
  // used by abr-controller
  abrEwmaDefaultEstimate: 5e5,
  // 500 kbps  // used by abr-controller
  abrEwmaDefaultEstimateMax: 5e6,
  // 5 mbps
  abrBandWidthFactor: 0.95,
  // used by abr-controller
  abrBandWidthUpFactor: 0.7,
  // used by abr-controller
  abrMaxWithRealBitrate: !1,
  // used by abr-controller
  maxStarvationDelay: 4,
  // used by abr-controller
  maxLoadingDelay: 4,
  // used by abr-controller
  minAutoBitrate: 0,
  // used by hls
  emeEnabled: !1,
  // used by eme-controller
  widevineLicenseUrl: void 0,
  // used by eme-controller
  drmSystems: {},
  // used by eme-controller
  drmSystemOptions: {},
  // used by eme-controller
  requestMediaKeySystemAccessFunc: Ra,
  // used by eme-controller
  testBandwidth: !0,
  progressive: !1,
  lowLatencyMode: !0,
  cmcd: void 0,
  enableDateRangeMetadataCues: !0,
  enableEmsgMetadataCues: !0,
  enableID3MetadataCues: !0,
  useMediaCapabilities: !0,
  certLoadPolicy: {
    default: uf
  },
  keyLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 8e3,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 2e4,
        backoff: "linear"
      },
      errorRetry: {
        maxNumRetry: 8,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 2e4,
        backoff: "linear"
      }
    }
  },
  manifestLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1 / 0,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  playlistLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 2,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  fragLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 12e4,
      timeoutRetry: {
        maxNumRetry: 4,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 6,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  steeringManifestLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  // These default settings are deprecated in favor of the above policies
  // and are maintained for backwards compatibility
  manifestLoadingTimeOut: 1e4,
  manifestLoadingMaxRetry: 1,
  manifestLoadingRetryDelay: 1e3,
  manifestLoadingMaxRetryTimeout: 64e3,
  levelLoadingTimeOut: 1e4,
  levelLoadingMaxRetry: 4,
  levelLoadingRetryDelay: 1e3,
  levelLoadingMaxRetryTimeout: 64e3,
  fragLoadingTimeOut: 2e4,
  fragLoadingMaxRetry: 6,
  fragLoadingRetryDelay: 1e3,
  fragLoadingMaxRetryTimeout: 64e3
}, hf()), {}, {
  subtitleStreamController: vh,
  subtitleTrackController: xh,
  timelineController: Hh,
  audioStreamController: gh,
  audioTrackController: yh,
  emeController: Sn,
  cmcdController: tn,
  contentSteeringController: Jh
});
function hf() {
  return {
    cueHandler: cf,
    // used by timeline-controller
    enableWebVTT: !0,
    // used by timeline-controller
    enableIMSC1: !0,
    // used by timeline-controller
    enableCEA708Captions: !0,
    // used by timeline-controller
    captionsTextTrack1Label: "English",
    // used by timeline-controller
    captionsTextTrack1LanguageCode: "en",
    // used by timeline-controller
    captionsTextTrack2Label: "Spanish",
    // used by timeline-controller
    captionsTextTrack2LanguageCode: "es",
    // used by timeline-controller
    captionsTextTrack3Label: "Unknown CC",
    // used by timeline-controller
    captionsTextTrack3LanguageCode: "",
    // used by timeline-controller
    captionsTextTrack4Label: "Unknown CC",
    // used by timeline-controller
    captionsTextTrack4LanguageCode: "",
    // used by timeline-controller
    renderTextTracksNatively: !0
  };
}
function ff(o, e) {
  if ((e.liveSyncDurationCount || e.liveMaxLatencyDurationCount) && (e.liveSyncDuration || e.liveMaxLatencyDuration))
    throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");
  if (e.liveMaxLatencyDurationCount !== void 0 && (e.liveSyncDurationCount === void 0 || e.liveMaxLatencyDurationCount <= e.liveSyncDurationCount))
    throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be greater than "liveSyncDurationCount"');
  if (e.liveMaxLatencyDuration !== void 0 && (e.liveSyncDuration === void 0 || e.liveMaxLatencyDuration <= e.liveSyncDuration))
    throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be greater than "liveSyncDuration"');
  const t = Pi(o), n = ["manifest", "level", "frag"], r = ["TimeOut", "MaxRetry", "RetryDelay", "MaxRetryTimeout"];
  return n.forEach((i) => {
    const s = `${i === "level" ? "playlist" : i}LoadPolicy`, a = e[s] === void 0, l = [];
    r.forEach((d) => {
      const h = `${i}Loading${d}`, u = e[h];
      if (u !== void 0 && a) {
        l.push(h);
        const c = t[s].default;
        switch (e[s] = {
          default: c
        }, d) {
          case "TimeOut":
            c.maxLoadTimeMs = u, c.maxTimeToFirstByteMs = u;
            break;
          case "MaxRetry":
            c.errorRetry.maxNumRetry = u, c.timeoutRetry.maxNumRetry = u;
            break;
          case "RetryDelay":
            c.errorRetry.retryDelayMs = u, c.timeoutRetry.retryDelayMs = u;
            break;
          case "MaxRetryTimeout":
            c.errorRetry.maxRetryDelayMs = u, c.timeoutRetry.maxRetryDelayMs = u;
            break;
        }
      }
    }), l.length && V.warn(`hls.js config: "${l.join('", "')}" setting(s) are deprecated, use "${s}": ${JSON.stringify(e[s])}`);
  }), it(it({}, t), e);
}
function Pi(o) {
  return o && typeof o == "object" ? Array.isArray(o) ? o.map(Pi) : Object.keys(o).reduce((e, t) => (e[t] = Pi(o[t]), e), {}) : o;
}
function pf(o) {
  const e = o.loader;
  e !== ga && e !== To ? (V.log("[config]: Custom loader detected, cannot enable progressive streaming"), o.progressive = !1) : tf() && (o.loader = ga, o.progressive = !0, o.enableSoftwareAES = !0, V.log("[config]: Progressive streaming enabled, using FetchLoader"));
}
let bi;
class mf extends Wi {
  constructor(e, t) {
    super(e, "[level-controller]"), this._levels = [], this._firstLevel = -1, this._maxAutoLevel = -1, this._startLevel = void 0, this.currentLevel = null, this.currentLevelIndex = -1, this.manualLevelIndex = -1, this.steering = void 0, this.onParsedComplete = void 0, this.steering = t, this._registerListeners();
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(I.MANIFEST_LOADING, this.onManifestLoading, this), e.on(I.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(I.LEVEL_LOADED, this.onLevelLoaded, this), e.on(I.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(I.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), e.on(I.FRAG_BUFFERED, this.onFragBuffered, this), e.on(I.ERROR, this.onError, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(I.MANIFEST_LOADING, this.onManifestLoading, this), e.off(I.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(I.LEVEL_LOADED, this.onLevelLoaded, this), e.off(I.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(I.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), e.off(I.FRAG_BUFFERED, this.onFragBuffered, this), e.off(I.ERROR, this.onError, this);
  }
  destroy() {
    this._unregisterListeners(), this.steering = null, this.resetLevels(), super.destroy();
  }
  stopLoad() {
    this._levels.forEach((t) => {
      t.loadError = 0, t.fragmentError = 0;
    }), super.stopLoad();
  }
  resetLevels() {
    this._startLevel = void 0, this.manualLevelIndex = -1, this.currentLevelIndex = -1, this.currentLevel = null, this._levels = [], this._maxAutoLevel = -1;
  }
  onManifestLoading(e, t) {
    this.resetLevels();
  }
  onManifestLoaded(e, t) {
    const n = [], r = {};
    let i;
    t.levels.forEach((s) => {
      var a;
      const l = s.attrs;
      ((a = s.audioCodec) == null ? void 0 : a.indexOf("mp4a.40.34")) !== -1 && (bi || (bi = /chrome|firefox/i.test(navigator.userAgent)), bi && (s.audioCodec = void 0)), s.audioCodec && (s.audioCodec = Or(s.audioCodec, this.hls.config.preferManagedMediaSource));
      const {
        AUDIO: d,
        CODECS: h,
        "FRAME-RATE": u,
        "PATHWAY-ID": c,
        RESOLUTION: m,
        SUBTITLES: f
      } = l, A = `${`${c || "."}-`}${s.bitrate}-${m}-${u}-${h}`;
      i = r[A], i ? i.addFallback(s) : (i = new rr(s), r[A] = i, n.push(i)), Br(i, "audio", d), Br(i, "text", f);
    }), this.filterAndSortMediaOptions(n, t);
  }
  filterAndSortMediaOptions(e, t) {
    const {
      preferManagedMediaSource: n
    } = this.hls.config;
    let r = [], i = [], s = !1, a = !1, l = !1, d = e.filter(({
      audioCodec: p,
      videoCodec: A,
      width: v,
      height: b,
      unknownCodecs: _
    }) => (s || (s = !!(v && b)), a || (a = !!A), l || (l = !!p), !(_ != null && _.length) && (!p || ii(p, "audio", n)) && (!A || ii(A, "video", n))));
    if ((s || a) && l && (d = d.filter(({
      videoCodec: p,
      videoRange: A,
      width: v,
      height: b
    }) => (!!p || !!(v && b)) && qc(A))), d.length === 0) {
      Promise.resolve().then(() => {
        if (this.hls) {
          e.length && this.warn(`One or more CODECS in variant not supported: ${JSON.stringify(e[0].attrs)}`);
          const p = new Error("no level with compatible codecs found in manifest");
          this.hls.trigger(I.ERROR, {
            type: xe.MEDIA_ERROR,
            details: q.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
            fatal: !0,
            url: t.url,
            error: p,
            reason: p.message
          });
        }
      });
      return;
    }
    t.audioTracks && (r = t.audioTracks.filter((p) => !p.audioCodec || ii(p.audioCodec, "audio", n)), ya(r)), t.subtitles && (i = t.subtitles, ya(i));
    const h = d.slice(0);
    d.sort((p, A) => {
      if (p.attrs["HDCP-LEVEL"] !== A.attrs["HDCP-LEVEL"])
        return (p.attrs["HDCP-LEVEL"] || "") > (A.attrs["HDCP-LEVEL"] || "") ? 1 : -1;
      if (s && p.height !== A.height)
        return p.height - A.height;
      if (p.frameRate !== A.frameRate)
        return p.frameRate - A.frameRate;
      if (p.codecSet !== A.codecSet) {
        const v = Dr(p.codecSet), b = Dr(A.codecSet);
        if (v !== b)
          return b - v;
      }
      return p.videoRange !== A.videoRange ? Ii.indexOf(p.videoRange) - Ii.indexOf(A.videoRange) : p.bitrate !== A.bitrate ? p.bitrate - A.bitrate : 0;
    });
    let u = h[0];
    if (this.steering && (d = this.steering.filterParsedLevels(d), d.length !== h.length)) {
      for (let p = 0; p < h.length; p++)
        if (h[p].pathwayId === d[0].pathwayId) {
          u = h[p];
          break;
        }
    }
    this._levels = d;
    for (let p = 0; p < d.length; p++)
      if (d[p] === u) {
        var c;
        this._firstLevel = p;
        const A = u.bitrate, v = this.hls.bandwidthEstimate;
        if (this.log(`manifest loaded, ${d.length} level(s) found, first bitrate: ${A}`), ((c = this.hls.userConfig) == null ? void 0 : c.abrEwmaDefaultEstimate) === void 0) {
          const b = Math.min(A, this.hls.config.abrEwmaDefaultEstimateMax);
          b > v && v === Co.abrEwmaDefaultEstimate && (this.hls.bandwidthEstimate = b);
        }
        break;
      }
    const m = l && !a, f = {
      levels: d,
      audioTracks: r,
      subtitleTracks: i,
      sessionData: t.sessionData,
      sessionKeys: t.sessionKeys,
      firstLevel: this._firstLevel,
      stats: t.stats,
      audio: l,
      video: a,
      altAudio: !m && r.some((p) => !!p.url)
    };
    this.hls.trigger(I.MANIFEST_PARSED, f), (this.hls.config.autoStartLoad || this.hls.forceStartLoad) && this.hls.startLoad(this.hls.config.startPosition);
  }
  get levels() {
    return this._levels.length === 0 ? null : this._levels;
  }
  get level() {
    return this.currentLevelIndex;
  }
  set level(e) {
    const t = this._levels;
    if (t.length === 0)
      return;
    if (e < 0 || e >= t.length) {
      const h = new Error("invalid level idx"), u = e < 0;
      if (this.hls.trigger(I.ERROR, {
        type: xe.OTHER_ERROR,
        details: q.LEVEL_SWITCH_ERROR,
        level: e,
        fatal: u,
        error: h,
        reason: h.message
      }), u)
        return;
      e = Math.min(e, t.length - 1);
    }
    const n = this.currentLevelIndex, r = this.currentLevel, i = r ? r.attrs["PATHWAY-ID"] : void 0, s = t[e], a = s.attrs["PATHWAY-ID"];
    if (this.currentLevelIndex = e, this.currentLevel = s, n === e && s.details && r && i === a)
      return;
    this.log(`Switching to level ${e} (${s.height ? s.height + "p " : ""}${s.videoRange ? s.videoRange + " " : ""}${s.codecSet ? s.codecSet + " " : ""}@${s.bitrate})${a ? " with Pathway " + a : ""} from level ${n}${i ? " with Pathway " + i : ""}`);
    const l = lt({}, s, {
      level: e,
      maxBitrate: s.maxBitrate,
      attrs: s.attrs,
      uri: s.uri,
      urlId: s.urlId
    });
    delete l._attrs, delete l._urlId, delete l._avgBitrate, this.hls.trigger(I.LEVEL_SWITCHING, l);
    const d = s.details;
    if (!d || d.live) {
      const h = this.switchParams(s.uri, r == null ? void 0 : r.details);
      this.loadPlaylist(h);
    }
  }
  get manualLevel() {
    return this.manualLevelIndex;
  }
  set manualLevel(e) {
    this.manualLevelIndex = e, this._startLevel === void 0 && (this._startLevel = e), e !== -1 && (this.level = e);
  }
  get firstLevel() {
    return this._firstLevel;
  }
  set firstLevel(e) {
    this._firstLevel = e;
  }
  get startLevel() {
    if (this._startLevel === void 0) {
      const e = this.hls.config.startLevel;
      return e !== void 0 ? e : this.hls.firstAutoLevel;
    }
    return this._startLevel;
  }
  set startLevel(e) {
    this._startLevel = e;
  }
  onError(e, t) {
    t.fatal || !t.context || t.context.type === Ue.LEVEL && t.context.level === this.level && this.checkRetry(t);
  }
  // reset errors on the successful load of a fragment
  onFragBuffered(e, {
    frag: t
  }) {
    if (t !== void 0 && t.type === be.MAIN) {
      const n = t.elementaryStreams;
      if (!Object.keys(n).some((i) => !!n[i]))
        return;
      const r = this._levels[t.level];
      r != null && r.loadError && (this.log(`Resetting level error count of ${r.loadError} on frag buffered`), r.loadError = 0);
    }
  }
  onLevelLoaded(e, t) {
    var n;
    const {
      level: r,
      details: i
    } = t, s = this._levels[r];
    if (!s) {
      var a;
      this.warn(`Invalid level index ${r}`), (a = t.deliveryDirectives) != null && a.skip && (i.deltaUpdateFailed = !0);
      return;
    }
    r === this.currentLevelIndex ? (s.fragmentError === 0 && (s.loadError = 0), this.playlistLoaded(r, t, s.details)) : (n = t.deliveryDirectives) != null && n.skip && (i.deltaUpdateFailed = !0);
  }
  onAudioTrackSwitched(e, t) {
    const n = this.currentLevel;
    if (!n)
      return;
    const r = this.hls.audioTracks[t.id].groupId;
    if (n.audioGroupIds && n.audioGroupId !== r) {
      let i = -1;
      for (let s = 0; s < n.audioGroupIds.length; s++)
        if (n.audioGroupIds[s] === r) {
          i = s;
          break;
        }
      i !== -1 && i !== n.urlId && (n.urlId = i, this.canLoad && this.startLoad());
    }
  }
  loadPlaylist(e) {
    super.loadPlaylist();
    const t = this.currentLevelIndex, n = this.currentLevel;
    if (n && this.shouldLoadPlaylist(n)) {
      const r = n.urlId;
      let i = n.uri;
      if (e)
        try {
          i = e.addDirectives(i);
        } catch (a) {
          this.warn(`Could not construct new URL with HLS Delivery Directives: ${a}`);
        }
      const s = n.attrs["PATHWAY-ID"];
      this.log(`Loading level index ${t}${(e == null ? void 0 : e.msn) !== void 0 ? " at sn " + e.msn + " part " + e.part : ""} with${s ? " Pathway " + s : ""} URI ${r + 1}/${n.url.length} ${i}`), this.clearTimer(), this.hls.trigger(I.LEVEL_LOADING, {
        url: i,
        level: t,
        id: r,
        deliveryDirectives: e || null
      });
    }
  }
  get nextLoadLevel() {
    return this.manualLevelIndex !== -1 ? this.manualLevelIndex : this.hls.nextAutoLevel;
  }
  set nextLoadLevel(e) {
    this.level = e, this.manualLevelIndex === -1 && (this.hls.nextAutoLevel = e);
  }
  removeLevel(e, t) {
    var n;
    const r = (s, a) => a !== t, i = this._levels.filter((s, a) => a !== e ? !0 : s.url.length > 1 && t !== void 0 ? (s.url = s.url.filter(r), s.audioGroupIds && (s.audioGroupIds = s.audioGroupIds.filter(r)), s.textGroupIds && (s.textGroupIds = s.textGroupIds.filter(r)), s.urlId = 0, !0) : (this.steering && this.steering.removeLevel(s), s === this.currentLevel && (this.currentLevel = null, this.currentLevelIndex = -1, s.details && s.details.fragments.forEach((l) => l.level = -1)), !1));
    Ha(i), this._levels = i, this.currentLevelIndex > -1 && (n = this.currentLevel) != null && n.details && (this.currentLevelIndex = this.currentLevel.details.fragments[0].level), this.hls.trigger(I.LEVELS_UPDATED, {
      levels: i
    });
  }
  onLevelsUpdated(e, {
    levels: t
  }) {
    this._levels = t;
  }
  checkMaxAutoUpdated() {
    const {
      autoLevelCapping: e,
      maxAutoLevel: t,
      maxHdcpLevel: n
    } = this.hls;
    this._maxAutoLevel !== t && (this._maxAutoLevel = t, this.hls.trigger(I.MAX_AUTO_LEVEL_UPDATED, {
      autoLevelCapping: e,
      levels: this.levels,
      maxAutoLevel: t,
      minAutoLevel: this.hls.minAutoLevel,
      maxHdcpLevel: n
    }));
  }
}
function ya(o) {
  const e = {};
  o.forEach((t) => {
    const n = t.groupId || "";
    t.id = e[n] = e[n] || 0, e[n]++;
  });
}
class gf {
  constructor(e) {
    this.config = void 0, this.keyUriToKeyInfo = {}, this.emeController = null, this.config = e;
  }
  abort(e) {
    for (const n in this.keyUriToKeyInfo) {
      const r = this.keyUriToKeyInfo[n].loader;
      if (r) {
        var t;
        if (e && e !== ((t = r.context) == null ? void 0 : t.frag.type))
          return;
        r.abort();
      }
    }
  }
  detach() {
    for (const e in this.keyUriToKeyInfo) {
      const t = this.keyUriToKeyInfo[e];
      (t.mediaKeySessionContext || t.decryptdata.isCommonEncryption) && delete this.keyUriToKeyInfo[e];
    }
  }
  destroy() {
    this.detach();
    for (const e in this.keyUriToKeyInfo) {
      const t = this.keyUriToKeyInfo[e].loader;
      t && t.destroy();
    }
    this.keyUriToKeyInfo = {};
  }
  createKeyLoadError(e, t = q.KEY_LOAD_ERROR, n, r, i) {
    return new Ht({
      type: xe.NETWORK_ERROR,
      details: t,
      fatal: !1,
      frag: e,
      response: i,
      error: n,
      networkDetails: r
    });
  }
  loadClear(e, t) {
    if (this.emeController && this.config.emeEnabled) {
      const {
        sn: n,
        cc: r
      } = e;
      for (let i = 0; i < t.length; i++) {
        const s = t[i];
        if (r <= s.cc && (n === "initSegment" || s.sn === "initSegment" || n < s.sn)) {
          this.emeController.selectKeySystemFormat(s).then((a) => {
            s.setKeyFormat(a);
          });
          break;
        }
      }
    }
  }
  load(e) {
    return !e.decryptdata && e.encrypted && this.emeController ? this.emeController.selectKeySystemFormat(e).then((t) => this.loadInternal(e, t)) : this.loadInternal(e);
  }
  loadInternal(e, t) {
    var n, r;
    t && e.setKeyFormat(t);
    const i = e.decryptdata;
    if (!i) {
      const d = new Error(t ? `Expected frag.decryptdata to be defined after setting format ${t}` : "Missing decryption data on fragment in onKeyLoading");
      return Promise.reject(this.createKeyLoadError(e, q.KEY_LOAD_ERROR, d));
    }
    const s = i.uri;
    if (!s)
      return Promise.reject(this.createKeyLoadError(e, q.KEY_LOAD_ERROR, new Error(`Invalid key URI: "${s}"`)));
    let a = this.keyUriToKeyInfo[s];
    if ((n = a) != null && n.decryptdata.key)
      return i.key = a.decryptdata.key, Promise.resolve({
        frag: e,
        keyInfo: a
      });
    if ((r = a) != null && r.keyLoadPromise) {
      var l;
      switch ((l = a.mediaKeySessionContext) == null ? void 0 : l.keyStatus) {
        case void 0:
        case "status-pending":
        case "usable":
        case "usable-in-future":
          return a.keyLoadPromise.then((d) => (i.key = d.keyInfo.decryptdata.key, {
            frag: e,
            keyInfo: a
          }));
      }
    }
    switch (a = this.keyUriToKeyInfo[s] = {
      decryptdata: i,
      keyLoadPromise: null,
      loader: null,
      mediaKeySessionContext: null
    }, i.method) {
      case "ISO-23001-7":
      case "SAMPLE-AES":
      case "SAMPLE-AES-CENC":
      case "SAMPLE-AES-CTR":
        return i.keyFormat === "identity" ? this.loadKeyHTTP(a, e) : this.loadKeyEME(a, e);
      case "AES-128":
        return this.loadKeyHTTP(a, e);
      default:
        return Promise.reject(this.createKeyLoadError(e, q.KEY_LOAD_ERROR, new Error(`Key supplied with unsupported METHOD: "${i.method}"`)));
    }
  }
  loadKeyEME(e, t) {
    const n = {
      frag: t,
      keyInfo: e
    };
    if (this.emeController && this.config.emeEnabled) {
      const r = this.emeController.loadKey(n);
      if (r)
        return (e.keyLoadPromise = r.then((i) => (e.mediaKeySessionContext = i, n))).catch((i) => {
          throw e.keyLoadPromise = null, i;
        });
    }
    return Promise.resolve(n);
  }
  loadKeyHTTP(e, t) {
    const n = this.config, r = n.loader, i = new r(n);
    return t.keyLoader = e.loader = i, e.keyLoadPromise = new Promise((s, a) => {
      const l = {
        keyInfo: e,
        frag: t,
        responseType: "arraybuffer",
        url: e.decryptdata.uri
      }, d = n.keyLoadPolicy.default, h = {
        loadPolicy: d,
        timeout: d.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0
      }, u = {
        onSuccess: (c, m, f, p) => {
          const {
            frag: A,
            keyInfo: v,
            url: b
          } = f;
          if (!A.decryptdata || v !== this.keyUriToKeyInfo[b])
            return a(this.createKeyLoadError(A, q.KEY_LOAD_ERROR, new Error("after key load, decryptdata unset or changed"), p));
          v.decryptdata.key = A.decryptdata.key = new Uint8Array(c.data), A.keyLoader = null, v.loader = null, s({
            frag: A,
            keyInfo: v
          });
        },
        onError: (c, m, f, p) => {
          this.resetLoader(m), a(this.createKeyLoadError(t, q.KEY_LOAD_ERROR, new Error(`HTTP Error ${c.code} loading key ${c.text}`), f, it({
            url: l.url,
            data: void 0
          }, c)));
        },
        onTimeout: (c, m, f) => {
          this.resetLoader(m), a(this.createKeyLoadError(t, q.KEY_LOAD_TIMEOUT, new Error("key loading timed out"), f));
        },
        onAbort: (c, m, f) => {
          this.resetLoader(m), a(this.createKeyLoadError(t, q.INTERNAL_ABORTED, new Error("key loading aborted"), f));
        }
      };
      i.load(l, h, u);
    });
  }
  resetLoader(e) {
    const {
      frag: t,
      keyInfo: n,
      url: r
    } = e, i = n.loader;
    t.keyLoader === i && (t.keyLoader = null, n.loader = null), delete this.keyUriToKeyInfo[r], i && i.destroy();
  }
}
function Lo() {
  return self.SourceBuffer || self.WebKitSourceBuffer;
}
function yf() {
  const o = Gr();
  if (!o)
    return !1;
  const e = Lo(), t = o && typeof o.isTypeSupported == "function" && o.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'), n = !e || e.prototype && typeof e.prototype.appendBuffer == "function" && typeof e.prototype.remove == "function";
  return !!t && !!n;
}
function Af() {
  var o;
  const e = Lo();
  return typeof (e == null || (o = e.prototype) == null ? void 0 : o.changeType) == "function";
}
const vf = 250, Ir = 2, bf = 0.1, xf = 0.05;
class Ef {
  constructor(e, t, n, r) {
    this.config = void 0, this.media = null, this.fragmentTracker = void 0, this.hls = void 0, this.nudgeRetry = 0, this.stallReported = !1, this.stalled = null, this.moved = !1, this.seeking = !1, this.config = e, this.media = t, this.fragmentTracker = n, this.hls = r;
  }
  destroy() {
    this.media = null, this.hls = this.fragmentTracker = null;
  }
  /**
   * Checks if the playhead is stuck within a gap, and if so, attempts to free it.
   * A gap is an unbuffered range between two buffered ranges (or the start and the first buffered range).
   *
   * @param lastCurrentTime - Previously read playhead position
   */
  poll(e, t) {
    const {
      config: n,
      media: r,
      stalled: i
    } = this;
    if (r === null)
      return;
    const {
      currentTime: s,
      seeking: a
    } = r, l = this.seeking && !a, d = !this.seeking && a;
    if (this.seeking = a, s !== e) {
      if (this.moved = !0, i !== null) {
        if (this.stallReported) {
          const A = self.performance.now() - i;
          V.warn(`playback not stuck anymore @${s}, after ${Math.round(A)}ms`), this.stallReported = !1;
        }
        this.stalled = null, this.nudgeRetry = 0;
      }
      return;
    }
    if (d || l) {
      this.stalled = null;
      return;
    }
    if (r.paused && !a || r.ended || r.playbackRate === 0 || !He.getBuffered(r).length)
      return;
    const h = He.bufferInfo(r, s, 0), u = h.nextStart || 0;
    if (a) {
      const A = h.len > Ir, v = !u || t && t.start <= s || u - s > Ir && !this.fragmentTracker.getPartialFragment(s);
      if (A || v)
        return;
      this.moved = !1;
    }
    if (!this.moved && this.stalled !== null) {
      var c;
      if (!(h.len > 0) && !u)
        return;
      const v = Math.max(u, h.start || 0) - s, b = this.hls.levels ? this.hls.levels[this.hls.currentLevel] : null, T = (b == null || (c = b.details) == null ? void 0 : c.live) ? b.details.targetduration * 2 : Ir, E = this.fragmentTracker.getPartialFragment(s);
      if (v > 0 && (v <= T || E)) {
        r.paused || this._trySkipBufferHole(E);
        return;
      }
    }
    const m = self.performance.now();
    if (i === null) {
      this.stalled = m;
      return;
    }
    const f = m - i;
    if (!a && f >= vf && (this._reportStall(h), !this.media))
      return;
    const p = He.bufferInfo(r, s, n.maxBufferHole);
    this._tryFixBufferStall(p, f);
  }
  /**
   * Detects and attempts to fix known buffer stalling issues.
   * @param bufferInfo - The properties of the current buffer.
   * @param stalledDurationMs - The amount of time Hls.js has been stalling for.
   * @private
   */
  _tryFixBufferStall(e, t) {
    const {
      config: n,
      fragmentTracker: r,
      media: i
    } = this;
    if (i === null)
      return;
    const s = i.currentTime, a = r.getPartialFragment(s);
    a && (this._trySkipBufferHole(a) || !this.media) || (e.len > n.maxBufferHole || e.nextStart && e.nextStart - s < n.maxBufferHole) && t > n.highBufferWatchdogPeriod * 1e3 && (V.warn("Trying to nudge playhead over buffer-hole"), this.stalled = null, this._tryNudgeBuffer());
  }
  /**
   * Triggers a BUFFER_STALLED_ERROR event, but only once per stall period.
   * @param bufferLen - The playhead distance from the end of the current buffer segment.
   * @private
   */
  _reportStall(e) {
    const {
      hls: t,
      media: n,
      stallReported: r
    } = this;
    if (!r && n) {
      this.stallReported = !0;
      const i = new Error(`Playback stalling at @${n.currentTime} due to low buffer (${JSON.stringify(e)})`);
      V.warn(i.message), t.trigger(I.ERROR, {
        type: xe.MEDIA_ERROR,
        details: q.BUFFER_STALLED_ERROR,
        fatal: !1,
        error: i,
        buffer: e.len
      });
    }
  }
  /**
   * Attempts to fix buffer stalls by jumping over known gaps caused by partial fragments
   * @param partial - The partial fragment found at the current time (where playback is stalling).
   * @private
   */
  _trySkipBufferHole(e) {
    const {
      config: t,
      hls: n,
      media: r
    } = this;
    if (r === null)
      return 0;
    const i = r.currentTime, s = He.bufferInfo(r, i, 0), a = i < s.start ? s.start : s.nextStart;
    if (a) {
      const l = s.len <= t.maxBufferHole, d = s.len > 0 && s.len < 1 && r.readyState < 3, h = a - i;
      if (h > 0 && (l || d)) {
        if (h > t.maxBufferHole) {
          const {
            fragmentTracker: c
          } = this;
          let m = !1;
          if (i === 0) {
            const f = c.getAppendedFrag(0, be.MAIN);
            f && a < f.end && (m = !0);
          }
          if (!m) {
            const f = e || c.getAppendedFrag(i, be.MAIN);
            if (f) {
              let p = !1, A = f.end;
              for (; A < a; ) {
                const v = c.getPartialFragment(A);
                if (v)
                  A += v.duration;
                else {
                  p = !0;
                  break;
                }
              }
              if (p)
                return 0;
            }
          }
        }
        const u = Math.max(a + xf, i + bf);
        if (V.warn(`skipping hole, adjusting currentTime from ${i} to ${u}`), this.moved = !0, this.stalled = null, r.currentTime = u, e && !e.gap) {
          const c = new Error(`fragment loaded with buffer holes, seeking from ${i} to ${u}`);
          n.trigger(I.ERROR, {
            type: xe.MEDIA_ERROR,
            details: q.BUFFER_SEEK_OVER_HOLE,
            fatal: !1,
            error: c,
            reason: c.message,
            frag: e
          });
        }
        return u;
      }
    }
    return 0;
  }
  /**
   * Attempts to fix buffer stalls by advancing the mediaElement's current time by a small amount.
   * @private
   */
  _tryNudgeBuffer() {
    const {
      config: e,
      hls: t,
      media: n,
      nudgeRetry: r
    } = this;
    if (n === null)
      return;
    const i = n.currentTime;
    if (this.nudgeRetry++, r < e.nudgeMaxRetry) {
      const s = i + (r + 1) * e.nudgeOffset, a = new Error(`Nudging 'currentTime' from ${i} to ${s}`);
      V.warn(a.message), n.currentTime = s, t.trigger(I.ERROR, {
        type: xe.MEDIA_ERROR,
        details: q.BUFFER_NUDGE_ON_STALL,
        error: a,
        fatal: !1
      });
    } else {
      const s = new Error(`Playhead still not moving while enough data buffered @${i} after ${e.nudgeMaxRetry} nudges`);
      V.error(s.message), t.trigger(I.ERROR, {
        type: xe.MEDIA_ERROR,
        details: q.BUFFER_STALLED_ERROR,
        error: s,
        fatal: !0
      });
    }
  }
}
const _f = 100;
class Sf extends Yi {
  constructor(e, t, n) {
    super(e, t, n, "[stream-controller]", be.MAIN), this.audioCodecSwap = !1, this.gapController = null, this.level = -1, this._forceStartLoad = !1, this.altAudio = !1, this.audioOnly = !1, this.fragPlaying = null, this.onvplaying = null, this.onvseeked = null, this.fragLastKbps = 0, this.couldBacktrack = !1, this.backtrackFragment = null, this.audioCodecSwitch = !1, this.videoBuffer = null, this._registerListeners();
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(I.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(I.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(I.MANIFEST_LOADING, this.onManifestLoading, this), e.on(I.MANIFEST_PARSED, this.onManifestParsed, this), e.on(I.LEVEL_LOADING, this.onLevelLoading, this), e.on(I.LEVEL_LOADED, this.onLevelLoaded, this), e.on(I.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this), e.on(I.ERROR, this.onError, this), e.on(I.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.on(I.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), e.on(I.BUFFER_CREATED, this.onBufferCreated, this), e.on(I.BUFFER_FLUSHED, this.onBufferFlushed, this), e.on(I.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(I.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(I.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(I.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(I.MANIFEST_LOADING, this.onManifestLoading, this), e.off(I.MANIFEST_PARSED, this.onManifestParsed, this), e.off(I.LEVEL_LOADED, this.onLevelLoaded, this), e.off(I.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this), e.off(I.ERROR, this.onError, this), e.off(I.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.off(I.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), e.off(I.BUFFER_CREATED, this.onBufferCreated, this), e.off(I.BUFFER_FLUSHED, this.onBufferFlushed, this), e.off(I.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(I.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  onHandlerDestroying() {
    this._unregisterListeners(), this.onMediaDetaching();
  }
  startLoad(e) {
    if (this.levels) {
      const {
        lastCurrentTime: t,
        hls: n
      } = this;
      if (this.stopLoad(), this.setInterval(_f), this.level = -1, !this.startFragRequested) {
        let r = n.startLevel;
        r === -1 && (n.config.testBandwidth && this.levels.length > 1 ? (r = 0, this.bitrateTest = !0) : r = n.firstAutoLevel), this.level = n.nextLoadLevel = r, this.loadedmetadata = !1;
      }
      t > 0 && e === -1 && (this.log(`Override startPosition with lastCurrentTime @${t.toFixed(3)}`), e = t), this.state = ee.IDLE, this.nextLoadPosition = this.startPosition = this.lastCurrentTime = e, this.tick();
    } else
      this._forceStartLoad = !0, this.state = ee.STOPPED;
  }
  stopLoad() {
    this._forceStartLoad = !1, super.stopLoad();
  }
  doTick() {
    switch (this.state) {
      case ee.WAITING_LEVEL: {
        const {
          levels: t,
          level: n
        } = this, r = t == null ? void 0 : t[n], i = r == null ? void 0 : r.details;
        if (i && (!i.live || this.levelLastLoaded === r)) {
          if (this.waitForCdnTuneIn(i))
            break;
          this.state = ee.IDLE;
          break;
        } else if (this.hls.nextLoadLevel !== this.level) {
          this.state = ee.IDLE;
          break;
        }
        break;
      }
      case ee.FRAG_LOADING_WAITING_RETRY:
        {
          var e;
          const t = self.performance.now(), n = this.retryDate;
          if (!n || t >= n || (e = this.media) != null && e.seeking) {
            const {
              levels: r,
              level: i
            } = this, s = r == null ? void 0 : r[i];
            this.resetStartWhenNotLoaded(s || null), this.state = ee.IDLE;
          }
        }
        break;
    }
    this.state === ee.IDLE && this.doTickIdle(), this.onTickEnd();
  }
  onTickEnd() {
    super.onTickEnd(), this.checkBuffer(), this.checkFragmentChanged();
  }
  doTickIdle() {
    const {
      hls: e,
      levelLastLoaded: t,
      levels: n,
      media: r
    } = this, {
      config: i,
      nextLoadLevel: s
    } = e;
    if (t === null || !r && (this.startFragRequested || !i.startFragPrefetch) || this.altAudio && this.audioOnly || !(n != null && n[s]))
      return;
    const a = n[s], l = this.getMainFwdBufferInfo();
    if (l === null)
      return;
    const d = this.getLevelDetails();
    if (d && this._streamEnded(l, d)) {
      const A = {};
      this.altAudio && (A.type = "video"), this.hls.trigger(I.BUFFER_EOS, A), this.state = ee.ENDED;
      return;
    }
    e.loadLevel !== s && e.manualLevel === -1 && this.log(`Adapting to level ${s} from level ${this.level}`), this.level = e.nextLoadLevel = s;
    const h = a.details;
    if (!h || this.state === ee.WAITING_LEVEL || h.live && this.levelLastLoaded !== a) {
      this.level = s, this.state = ee.WAITING_LEVEL;
      return;
    }
    const u = l.len, c = this.getMaxBufferLength(a.maxBitrate);
    if (u >= c)
      return;
    this.backtrackFragment && this.backtrackFragment.start > l.end && (this.backtrackFragment = null);
    const m = this.backtrackFragment ? this.backtrackFragment.start : l.end;
    let f = this.getNextFragment(m, h);
    if (this.couldBacktrack && !this.fragPrevious && f && f.sn !== "initSegment" && this.fragmentTracker.getState(f) !== dt.OK) {
      var p;
      const v = ((p = this.backtrackFragment) != null ? p : f).sn - h.startSN, b = h.fragments[v - 1];
      b && f.cc === b.cc && (f = b, this.fragmentTracker.removeFragment(b));
    } else
      this.backtrackFragment && l.len && (this.backtrackFragment = null);
    if (f && this.isLoopLoading(f, m)) {
      if (!f.gap) {
        const v = this.audioOnly && !this.altAudio ? Ge.AUDIO : Ge.VIDEO, b = (v === Ge.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
        b && this.afterBufferFlushed(b, v, be.MAIN);
      }
      f = this.getNextFragmentLoopLoading(f, h, l, be.MAIN, c);
    }
    f && (f.initSegment && !f.initSegment.data && !this.bitrateTest && (f = f.initSegment), this.loadFragment(f, a, m));
  }
  loadFragment(e, t, n) {
    const r = this.fragmentTracker.getState(e);
    this.fragCurrent = e, r === dt.NOT_LOADED || r === dt.PARTIAL ? e.sn === "initSegment" ? this._loadInitSegment(e, t) : this.bitrateTest ? (this.log(`Fragment ${e.sn} of level ${e.level} is being downloaded to test bitrate and will not be buffered`), this._loadBitrateTestFrag(e, t)) : (this.startFragRequested = !0, super.loadFragment(e, t, n)) : this.clearTrackerIfNeeded(e);
  }
  getBufferedFrag(e) {
    return this.fragmentTracker.getBufferedFrag(e, be.MAIN);
  }
  followingBufferedFrag(e) {
    return e ? this.getBufferedFrag(e.end + 0.5) : null;
  }
  /*
    on immediate level switch :
     - pause playback if playing
     - cancel any pending load request
     - and trigger a buffer flush
  */
  immediateLevelSwitch() {
    this.abortCurrentFrag(), this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
  }
  /**
   * try to switch ASAP without breaking video playback:
   * in order to ensure smooth but quick level switching,
   * we need to find the next flushable buffer range
   * we should take into account new segment fetch time
   */
  nextLevelSwitch() {
    const {
      levels: e,
      media: t
    } = this;
    if (t != null && t.readyState) {
      let n;
      const r = this.getAppendedFrag(t.currentTime);
      r && r.start > 1 && this.flushMainBuffer(0, r.start - 1);
      const i = this.getLevelDetails();
      if (i != null && i.live) {
        const a = this.getMainFwdBufferInfo();
        if (!a || a.len < i.targetduration * 2)
          return;
      }
      if (!t.paused && e) {
        const a = this.hls.nextLoadLevel, l = e[a], d = this.fragLastKbps;
        d && this.fragCurrent ? n = this.fragCurrent.duration * l.maxBitrate / (1e3 * d) + 1 : n = 0;
      } else
        n = 0;
      const s = this.getBufferedFrag(t.currentTime + n);
      if (s) {
        const a = this.followingBufferedFrag(s);
        if (a) {
          this.abortCurrentFrag();
          const l = a.maxStartPTS ? a.maxStartPTS : a.start, d = a.duration, h = Math.max(s.end, l + Math.min(Math.max(d - this.config.maxFragLookUpTolerance, d * (this.couldBacktrack ? 0.5 : 0.125)), d * (this.couldBacktrack ? 0.75 : 0.25)));
          this.flushMainBuffer(h, Number.POSITIVE_INFINITY);
        }
      }
    }
  }
  abortCurrentFrag() {
    const e = this.fragCurrent;
    switch (this.fragCurrent = null, this.backtrackFragment = null, e && (e.abortRequests(), this.fragmentTracker.removeFragment(e)), this.state) {
      case ee.KEY_LOADING:
      case ee.FRAG_LOADING:
      case ee.FRAG_LOADING_WAITING_RETRY:
      case ee.PARSING:
      case ee.PARSED:
        this.state = ee.IDLE;
        break;
    }
    this.nextLoadPosition = this.getLoadPosition();
  }
  flushMainBuffer(e, t) {
    super.flushMainBuffer(e, t, this.altAudio ? "video" : null);
  }
  onMediaAttached(e, t) {
    super.onMediaAttached(e, t);
    const n = t.media;
    this.onvplaying = this.onMediaPlaying.bind(this), this.onvseeked = this.onMediaSeeked.bind(this), n.addEventListener("playing", this.onvplaying), n.addEventListener("seeked", this.onvseeked), this.gapController = new Ef(this.config, n, this.fragmentTracker, this.hls);
  }
  onMediaDetaching() {
    const {
      media: e
    } = this;
    e && this.onvplaying && this.onvseeked && (e.removeEventListener("playing", this.onvplaying), e.removeEventListener("seeked", this.onvseeked), this.onvplaying = this.onvseeked = null, this.videoBuffer = null), this.fragPlaying = null, this.gapController && (this.gapController.destroy(), this.gapController = null), super.onMediaDetaching();
  }
  onMediaPlaying() {
    this.tick();
  }
  onMediaSeeked() {
    const e = this.media, t = e ? e.currentTime : null;
    ge(t) && this.log(`Media seeked to ${t.toFixed(3)}`);
    const n = this.getMainFwdBufferInfo();
    if (n === null || n.len === 0) {
      this.warn(`Main forward buffer length on "seeked" event ${n ? n.len : "empty"})`);
      return;
    }
    this.tick();
  }
  onManifestLoading() {
    this.log("Trigger BUFFER_RESET"), this.hls.trigger(I.BUFFER_RESET, void 0), this.fragmentTracker.removeAllFragments(), this.couldBacktrack = !1, this.startPosition = this.lastCurrentTime = 0, this.levels = this.fragPlaying = this.backtrackFragment = null, this.altAudio = this.audioOnly = !1;
  }
  onManifestParsed(e, t) {
    let n = !1, r = !1, i;
    t.levels.forEach((s) => {
      i = s.audioCodec, i && (i.indexOf("mp4a.40.2") !== -1 && (n = !0), i.indexOf("mp4a.40.5") !== -1 && (r = !0));
    }), this.audioCodecSwitch = n && r && !Af(), this.audioCodecSwitch && this.log("Both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC"), this.levels = t.levels, this.startFragRequested = !1;
  }
  onLevelLoading(e, t) {
    const {
      levels: n
    } = this;
    if (!n || this.state !== ee.IDLE)
      return;
    const r = n[t.level];
    (!r.details || r.details.live && this.levelLastLoaded !== r || this.waitForCdnTuneIn(r.details)) && (this.state = ee.WAITING_LEVEL);
  }
  onLevelLoaded(e, t) {
    var n;
    const {
      levels: r
    } = this, i = t.level, s = t.details, a = s.totalduration;
    if (!r) {
      this.warn(`Levels were reset while loading level ${i}`);
      return;
    }
    this.log(`Level ${i} loaded [${s.startSN},${s.endSN}]${s.lastPartSn ? `[part-${s.lastPartSn}-${s.lastPartIndex}]` : ""}, cc [${s.startCC}, ${s.endCC}] duration:${a}`);
    const l = r[i], d = this.fragCurrent;
    d && (this.state === ee.FRAG_LOADING || this.state === ee.FRAG_LOADING_WAITING_RETRY) && (d.level !== t.level || d.urlId !== l.urlId) && d.loader && this.abortCurrentFrag();
    let h = 0;
    if (s.live || (n = l.details) != null && n.live) {
      var u;
      if (this.checkLiveUpdate(s), s.deltaUpdateFailed)
        return;
      h = this.alignPlaylists(s, l.details, (u = this.levelLastLoaded) == null ? void 0 : u.details);
    }
    if (l.details = s, this.levelLastLoaded = l, this.hls.trigger(I.LEVEL_UPDATED, {
      details: s,
      level: i
    }), this.state === ee.WAITING_LEVEL) {
      if (this.waitForCdnTuneIn(s))
        return;
      this.state = ee.IDLE;
    }
    this.startFragRequested ? s.live && this.synchronizeToLiveEdge(s) : this.setStartPosition(s, h), this.tick();
  }
  _handleFragmentLoadProgress(e) {
    var t;
    const {
      frag: n,
      part: r,
      payload: i
    } = e, {
      levels: s
    } = this;
    if (!s) {
      this.warn(`Levels were reset while fragment load was in progress. Fragment ${n.sn} of level ${n.level} will not be buffered`);
      return;
    }
    const a = s[n.level], l = a.details;
    if (!l) {
      this.warn(`Dropping fragment ${n.sn} of level ${n.level} after level details were reset`), this.fragmentTracker.removeFragment(n);
      return;
    }
    const d = a.videoCodec, h = l.PTSKnown || !l.live, u = (t = n.initSegment) == null ? void 0 : t.data, c = this._getAudioCodec(a), m = this.transmuxer = this.transmuxer || new po(this.hls, be.MAIN, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this)), f = r ? r.index : -1, p = f !== -1, A = new Hi(n.level, n.sn, n.stats.chunkCount, i.byteLength, f, p), v = this.initPTS[n.cc];
    m.push(i, u, c, d, n, r, l.totalduration, h, A, v);
  }
  onAudioTrackSwitching(e, t) {
    const n = this.altAudio;
    if (!!!t.url) {
      if (this.mediaBuffer !== this.media) {
        this.log("Switching on main audio, use media.buffered to schedule main fragment loading"), this.mediaBuffer = this.media;
        const s = this.fragCurrent;
        s && (this.log("Switching to main audio track, cancel main fragment load"), s.abortRequests(), this.fragmentTracker.removeFragment(s)), this.resetTransmuxer(), this.resetLoadingState();
      } else
        this.audioOnly && this.resetTransmuxer();
      const i = this.hls;
      n && (i.trigger(I.BUFFER_FLUSHING, {
        startOffset: 0,
        endOffset: Number.POSITIVE_INFINITY,
        type: null
      }), this.fragmentTracker.removeAllFragments()), i.trigger(I.AUDIO_TRACK_SWITCHED, t);
    }
  }
  onAudioTrackSwitched(e, t) {
    const n = t.id, r = !!this.hls.audioTracks[n].url;
    if (r) {
      const i = this.videoBuffer;
      i && this.mediaBuffer !== i && (this.log("Switching on alternate audio, use video.buffered to schedule main fragment loading"), this.mediaBuffer = i);
    }
    this.altAudio = r, this.tick();
  }
  onBufferCreated(e, t) {
    const n = t.tracks;
    let r, i, s = !1;
    for (const a in n) {
      const l = n[a];
      if (l.id === "main") {
        if (i = a, r = l, a === "video") {
          const d = n[a];
          d && (this.videoBuffer = d.buffer);
        }
      } else
        s = !0;
    }
    s && r ? (this.log(`Alternate track found, use ${i}.buffered to schedule main fragment loading`), this.mediaBuffer = r.buffer) : this.mediaBuffer = this.media;
  }
  onFragBuffered(e, t) {
    const {
      frag: n,
      part: r
    } = t;
    if (n && n.type !== be.MAIN)
      return;
    if (this.fragContextChanged(n)) {
      this.warn(`Fragment ${n.sn}${r ? " p: " + r.index : ""} of level ${n.level} finished buffering, but was aborted. state: ${this.state}`), this.state === ee.PARSED && (this.state = ee.IDLE);
      return;
    }
    const i = r ? r.stats : n.stats;
    this.fragLastKbps = Math.round(8 * i.total / (i.buffering.end - i.loading.first)), n.sn !== "initSegment" && (this.fragPrevious = n), this.fragBufferedComplete(n, r);
  }
  onError(e, t) {
    var n;
    if (t.fatal) {
      this.state = ee.ERROR;
      return;
    }
    switch (t.details) {
      case q.FRAG_GAP:
      case q.FRAG_PARSING_ERROR:
      case q.FRAG_DECRYPT_ERROR:
      case q.FRAG_LOAD_ERROR:
      case q.FRAG_LOAD_TIMEOUT:
      case q.KEY_LOAD_ERROR:
      case q.KEY_LOAD_TIMEOUT:
        this.onFragmentOrKeyLoadError(be.MAIN, t);
        break;
      case q.LEVEL_LOAD_ERROR:
      case q.LEVEL_LOAD_TIMEOUT:
      case q.LEVEL_PARSING_ERROR:
        !t.levelRetry && this.state === ee.WAITING_LEVEL && ((n = t.context) == null ? void 0 : n.type) === Ue.LEVEL && (this.state = ee.IDLE);
        break;
      case q.BUFFER_APPEND_ERROR:
      case q.BUFFER_FULL_ERROR:
        if (!t.parent || t.parent !== "main")
          return;
        if (t.details === q.BUFFER_APPEND_ERROR) {
          this.resetLoadingState();
          return;
        }
        this.reduceLengthAndFlushBuffer(t) && this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
        break;
      case q.INTERNAL_EXCEPTION:
        this.recoverWorkerError(t);
        break;
    }
  }
  // Checks the health of the buffer and attempts to resolve playback stalls.
  checkBuffer() {
    const {
      media: e,
      gapController: t
    } = this;
    if (!(!e || !t || !e.readyState)) {
      if (this.loadedmetadata || !He.getBuffered(e).length) {
        const n = this.state !== ee.IDLE ? this.fragCurrent : null;
        t.poll(this.lastCurrentTime, n);
      }
      this.lastCurrentTime = e.currentTime;
    }
  }
  onFragLoadEmergencyAborted() {
    this.state = ee.IDLE, this.loadedmetadata || (this.startFragRequested = !1, this.nextLoadPosition = this.startPosition), this.tickImmediate();
  }
  onBufferFlushed(e, {
    type: t
  }) {
    if (t !== Ge.AUDIO || this.audioOnly && !this.altAudio) {
      const n = (t === Ge.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
      this.afterBufferFlushed(n, t, be.MAIN), this.tick();
    }
  }
  onLevelsUpdated(e, t) {
    this.level > -1 && this.fragCurrent && (this.level = this.fragCurrent.level), this.levels = t.levels;
  }
  swapAudioCodec() {
    this.audioCodecSwap = !this.audioCodecSwap;
  }
  /**
   * Seeks to the set startPosition if not equal to the mediaElement's current time.
   */
  seekToStartPos() {
    const {
      media: e
    } = this;
    if (!e)
      return;
    const t = e.currentTime;
    let n = this.startPosition;
    if (n >= 0 && t < n) {
      if (e.seeking) {
        this.log(`could not seek to ${n}, already seeking at ${t}`);
        return;
      }
      const r = He.getBuffered(e), s = (r.length ? r.start(0) : 0) - n;
      s > 0 && (s < this.config.maxBufferHole || s < this.config.maxFragLookUpTolerance) && (this.log(`adjusting start position by ${s} to match buffer start`), n += s, this.startPosition = n), this.log(`seek to target start position ${n} from current time ${t}`), e.currentTime = n;
    }
  }
  _getAudioCodec(e) {
    let t = this.config.defaultAudioCodec || e.audioCodec;
    return this.audioCodecSwap && t && (this.log("Swapping audio codec"), t.indexOf("mp4a.40.5") !== -1 ? t = "mp4a.40.2" : t = "mp4a.40.5"), t;
  }
  _loadBitrateTestFrag(e, t) {
    e.bitrateTest = !0, this._doFragLoad(e, t).then((n) => {
      const {
        hls: r
      } = this;
      if (!n || this.fragContextChanged(e))
        return;
      t.fragmentError = 0, this.state = ee.IDLE, this.startFragRequested = !1, this.bitrateTest = !1;
      const i = e.stats;
      i.parsing.start = i.parsing.end = i.buffering.start = i.buffering.end = self.performance.now(), r.trigger(I.FRAG_LOADED, n), e.bitrateTest = !1;
    });
  }
  _handleTransmuxComplete(e) {
    var t;
    const n = "main", {
      hls: r
    } = this, {
      remuxResult: i,
      chunkMeta: s
    } = e, a = this.getCurrentContext(s);
    if (!a) {
      this.resetWhenMissingContext(s);
      return;
    }
    const {
      frag: l,
      part: d,
      level: h
    } = a, {
      video: u,
      text: c,
      id3: m,
      initSegment: f
    } = i, {
      details: p
    } = h, A = this.altAudio ? void 0 : i.audio;
    if (this.fragContextChanged(l)) {
      this.fragmentTracker.removeFragment(l);
      return;
    }
    if (this.state = ee.PARSING, f) {
      if (f != null && f.tracks) {
        const _ = l.initSegment || l;
        this._bufferInitSegment(h, f.tracks, _, s), r.trigger(I.FRAG_PARSING_INIT_SEGMENT, {
          frag: _,
          id: n,
          tracks: f.tracks
        });
      }
      const v = f.initPTS, b = f.timescale;
      ge(v) && (this.initPTS[l.cc] = {
        baseTime: v,
        timescale: b
      }, r.trigger(I.INIT_PTS_FOUND, {
        frag: l,
        id: n,
        initPTS: v,
        timescale: b
      }));
    }
    if (u && p && l.sn !== "initSegment") {
      const v = p.fragments[l.sn - 1 - p.startSN], b = l.sn === p.startSN, _ = !v || l.cc > v.cc;
      if (i.independent !== !1) {
        const {
          startPTS: T,
          endPTS: E,
          startDTS: L,
          endDTS: k
        } = u;
        if (d)
          d.elementaryStreams[u.type] = {
            startPTS: T,
            endPTS: E,
            startDTS: L,
            endDTS: k
          };
        else if (u.firstKeyFrame && u.independent && s.id === 1 && !_ && (this.couldBacktrack = !0), u.dropped && u.independent) {
          const D = this.getMainFwdBufferInfo(), M = (D ? D.end : this.getLoadPosition()) + this.config.maxBufferHole, O = u.firstKeyFramePTS ? u.firstKeyFramePTS : T;
          if (!b && M < O - this.config.maxBufferHole && !_) {
            this.backtrack(l);
            return;
          } else
            _ && (l.gap = !0);
          l.setElementaryStreamInfo(u.type, l.start, E, l.start, k, !0);
        } else
          b && T > Ir && (l.gap = !0);
        l.setElementaryStreamInfo(u.type, T, E, L, k), this.backtrackFragment && (this.backtrackFragment = l), this.bufferFragmentData(u, l, d, s, b || _);
      } else if (b || _)
        l.gap = !0;
      else {
        this.backtrack(l);
        return;
      }
    }
    if (A) {
      const {
        startPTS: v,
        endPTS: b,
        startDTS: _,
        endDTS: T
      } = A;
      d && (d.elementaryStreams[Ge.AUDIO] = {
        startPTS: v,
        endPTS: b,
        startDTS: _,
        endDTS: T
      }), l.setElementaryStreamInfo(Ge.AUDIO, v, b, _, T), this.bufferFragmentData(A, l, d, s);
    }
    if (p && m != null && (t = m.samples) != null && t.length) {
      const v = {
        id: n,
        frag: l,
        details: p,
        samples: m.samples
      };
      r.trigger(I.FRAG_PARSING_METADATA, v);
    }
    if (p && c) {
      const v = {
        id: n,
        frag: l,
        details: p,
        samples: c.samples
      };
      r.trigger(I.FRAG_PARSING_USERDATA, v);
    }
  }
  _bufferInitSegment(e, t, n, r) {
    if (this.state !== ee.PARSING)
      return;
    this.audioOnly = !!t.audio && !t.video, this.altAudio && !this.audioOnly && delete t.audio;
    const {
      audio: i,
      video: s,
      audiovideo: a
    } = t;
    if (i) {
      let l = e.audioCodec;
      const d = navigator.userAgent.toLowerCase();
      this.audioCodecSwitch && (l && (l.indexOf("mp4a.40.5") !== -1 ? l = "mp4a.40.2" : l = "mp4a.40.5"), i.metadata.channelCount !== 1 && d.indexOf("firefox") === -1 && (l = "mp4a.40.5")), l && l.indexOf("mp4a.40.5") !== -1 && d.indexOf("android") !== -1 && i.container !== "audio/mpeg" && (l = "mp4a.40.2", this.log(`Android: force audio codec to ${l}`)), e.audioCodec && e.audioCodec !== l && this.log(`Swapping manifest audio codec "${e.audioCodec}" for "${l}"`), i.levelCodec = l, i.id = "main", this.log(`Init audio buffer, container:${i.container}, codecs[selected/level/parsed]=[${l || ""}/${e.audioCodec || ""}/${i.codec}]`);
    }
    s && (s.levelCodec = e.videoCodec, s.id = "main", this.log(`Init video buffer, container:${s.container}, codecs[level/parsed]=[${e.videoCodec || ""}/${s.codec}]`)), a && this.log(`Init audiovideo buffer, container:${a.container}, codecs[level/parsed]=[${e.codecs}/${a.codec}]`), this.hls.trigger(I.BUFFER_CODECS, t), Object.keys(t).forEach((l) => {
      const h = t[l].initSegment;
      h != null && h.byteLength && this.hls.trigger(I.BUFFER_APPENDING, {
        type: l,
        data: h,
        frag: n,
        part: null,
        chunkMeta: r,
        parent: n.type
      });
    }), this.tickImmediate();
  }
  getMainFwdBufferInfo() {
    return this.getFwdBufferInfo(this.mediaBuffer ? this.mediaBuffer : this.media, be.MAIN);
  }
  backtrack(e) {
    this.couldBacktrack = !0, this.backtrackFragment = e, this.resetTransmuxer(), this.flushBufferGap(e), this.fragmentTracker.removeFragment(e), this.fragPrevious = null, this.nextLoadPosition = e.start, this.state = ee.IDLE;
  }
  checkFragmentChanged() {
    const e = this.media;
    let t = null;
    if (e && e.readyState > 1 && e.seeking === !1) {
      const n = e.currentTime;
      if (He.isBuffered(e, n) ? t = this.getAppendedFrag(n) : He.isBuffered(e, n + 0.1) && (t = this.getAppendedFrag(n + 0.1)), t) {
        this.backtrackFragment = null;
        const r = this.fragPlaying, i = t.level;
        (!r || t.sn !== r.sn || r.level !== i || t.urlId !== r.urlId) && (this.fragPlaying = t, this.hls.trigger(I.FRAG_CHANGED, {
          frag: t
        }), (!r || r.level !== i) && this.hls.trigger(I.LEVEL_SWITCHED, {
          level: i
        }));
      }
    }
  }
  get nextLevel() {
    const e = this.nextBufferedFrag;
    return e ? e.level : -1;
  }
  get currentFrag() {
    const e = this.media;
    return e ? this.fragPlaying || this.getAppendedFrag(e.currentTime) : null;
  }
  get currentProgramDateTime() {
    const e = this.media;
    if (e) {
      const t = e.currentTime, n = this.currentFrag;
      if (n && ge(t) && ge(n.programDateTime)) {
        const r = n.programDateTime + (t - n.start) * 1e3;
        return new Date(r);
      }
    }
    return null;
  }
  get currentLevel() {
    const e = this.currentFrag;
    return e ? e.level : -1;
  }
  get nextBufferedFrag() {
    const e = this.currentFrag;
    return e ? this.followingBufferedFrag(e) : null;
  }
  get forceStartLoad() {
    return this._forceStartLoad;
  }
}
class dn {
  /**
   * Get the video-dev/hls.js package version.
   */
  static get version() {
  }
  /**
   * Check if the required MediaSource Extensions are available.
   */
  static isSupported() {
    return yf();
  }
  static get Events() {
    return I;
  }
  static get ErrorTypes() {
    return xe;
  }
  static get ErrorDetails() {
    return q;
  }
  /**
   * Get the default configuration applied to new instances.
   */
  static get DefaultConfig() {
    return dn.defaultConfig ? dn.defaultConfig : Co;
  }
  /**
   * Replace the default configuration applied to new instances.
   */
  static set DefaultConfig(e) {
    dn.defaultConfig = e;
  }
  /**
   * Creates an instance of an HLS client that can attach to exactly one `HTMLMediaElement`.
   * @param userConfig - Configuration options applied over `Hls.DefaultConfig`
   */
  constructor(e = {}) {
    this.config = void 0, this.userConfig = void 0, this.coreComponents = void 0, this.networkControllers = void 0, this.started = !1, this._emitter = new Ji(), this._autoLevelCapping = -1, this._maxHdcpLevel = null, this.abrController = void 0, this.bufferController = void 0, this.capLevelController = void 0, this.latencyController = void 0, this.levelController = void 0, this.streamController = void 0, this.audioTrackController = void 0, this.subtitleTrackController = void 0, this.emeController = void 0, this.cmcdController = void 0, this._media = null, this.url = null, this.triggeringException = void 0, Xd(e.debug || !1, "Hls instance");
    const t = this.config = ff(dn.DefaultConfig, e);
    this.userConfig = e, t.progressive && pf(t);
    const {
      abrController: n,
      bufferController: r,
      capLevelController: i,
      errorController: s,
      fpsController: a
    } = t, l = new s(this), d = this.abrController = new n(this), h = this.bufferController = new r(this), u = this.capLevelController = new i(this), c = new a(this), m = new Gc(this), f = new Hc(this), p = t.contentSteeringController, A = p ? new p(this) : null, v = this.levelController = new mf(this, A), b = new vu(this), _ = new gf(this.config), T = this.streamController = new Sf(this, b, _);
    u.setStreamController(T), c.setStreamController(T);
    const E = [m, v, T];
    A && E.splice(1, 0, A), this.networkControllers = E;
    const L = [d, h, u, c, f, b];
    this.audioTrackController = this.createController(t.audioTrackController, E);
    const k = t.audioStreamController;
    k && E.push(new k(this, b, _)), this.subtitleTrackController = this.createController(t.subtitleTrackController, E);
    const D = t.subtitleStreamController;
    D && E.push(new D(this, b, _)), this.createController(t.timelineController, L), _.emeController = this.emeController = this.createController(t.emeController, L), this.cmcdController = this.createController(t.cmcdController, L), this.latencyController = this.createController(zc, L), this.coreComponents = L, E.push(l);
    const M = l.onErrorOut;
    typeof M == "function" && this.on(I.ERROR, M, l);
  }
  createController(e, t) {
    if (e) {
      const n = new e(this);
      return t && t.push(n), n;
    }
    return null;
  }
  // Delegate the EventEmitter through the public API of Hls.js
  on(e, t, n = this) {
    this._emitter.on(e, t, n);
  }
  once(e, t, n = this) {
    this._emitter.once(e, t, n);
  }
  removeAllListeners(e) {
    this._emitter.removeAllListeners(e);
  }
  off(e, t, n = this, r) {
    this._emitter.off(e, t, n, r);
  }
  listeners(e) {
    return this._emitter.listeners(e);
  }
  emit(e, t, n) {
    return this._emitter.emit(e, t, n);
  }
  trigger(e, t) {
    if (this.config.debug)
      return this.emit(e, e, t);
    try {
      return this.emit(e, e, t);
    } catch (n) {
      if (V.error("An internal error happened while handling event " + e + '. Error message: "' + n.message + '". Here is a stacktrace:', n), !this.triggeringException) {
        this.triggeringException = !0;
        const r = e === I.ERROR;
        this.trigger(I.ERROR, {
          type: xe.OTHER_ERROR,
          details: q.INTERNAL_EXCEPTION,
          fatal: r,
          event: e,
          error: n
        }), this.triggeringException = !1;
      }
    }
    return !1;
  }
  listenerCount(e) {
    return this._emitter.listenerCount(e);
  }
  /**
   * Dispose of the instance
   */
  destroy() {
    V.log("destroy"), this.trigger(I.DESTROYING, void 0), this.detachMedia(), this.removeAllListeners(), this._autoLevelCapping = -1, this.url = null, this.networkControllers.forEach((t) => t.destroy()), this.networkControllers.length = 0, this.coreComponents.forEach((t) => t.destroy()), this.coreComponents.length = 0;
    const e = this.config;
    e.xhrSetup = e.fetchSetup = void 0, this.userConfig = null;
  }
  /**
   * Attaches Hls.js to a media element
   */
  attachMedia(e) {
    V.log("attachMedia"), this._media = e, this.trigger(I.MEDIA_ATTACHING, {
      media: e
    });
  }
  /**
   * Detach Hls.js from the media
   */
  detachMedia() {
    V.log("detachMedia"), this.trigger(I.MEDIA_DETACHING, void 0), this._media = null;
  }
  /**
   * Set the source URL. Can be relative or absolute.
   */
  loadSource(e) {
    this.stopLoad();
    const t = this.media, n = this.url, r = this.url = Ni.buildAbsoluteURL(self.location.href, e, {
      alwaysNormalize: !0
    });
    this._autoLevelCapping = -1, this._maxHdcpLevel = null, V.log(`loadSource:${r}`), t && n && (n !== r || this.bufferController.hasSourceTypes()) && (this.detachMedia(), this.attachMedia(t)), this.trigger(I.MANIFEST_LOADING, {
      url: e
    });
  }
  /**
   * Start loading data from the stream source.
   * Depending on default config, client starts loading automatically when a source is set.
   *
   * @param startPosition - Set the start position to stream from.
   * Defaults to -1 (None: starts from earliest point)
   */
  startLoad(e = -1) {
    V.log(`startLoad(${e})`), this.started = !0, this.networkControllers.forEach((t) => {
      t.startLoad(e);
    });
  }
  /**
   * Stop loading of any stream data.
   */
  stopLoad() {
    V.log("stopLoad"), this.started = !1, this.networkControllers.forEach((e) => {
      e.stopLoad();
    });
  }
  /**
   * Resumes stream controller segment loading if previously started.
   */
  resumeBuffering() {
    this.started && this.networkControllers.forEach((e) => {
      "fragmentLoader" in e && e.startLoad(-1);
    });
  }
  /**
   * Stops stream controller segment loading without changing 'started' state like stopLoad().
   * This allows for media buffering to be paused without interupting playlist loading.
   */
  pauseBuffering() {
    this.networkControllers.forEach((e) => {
      "fragmentLoader" in e && e.stopLoad();
    });
  }
  /**
   * Swap through possible audio codecs in the stream (for example to switch from stereo to 5.1)
   */
  swapAudioCodec() {
    V.log("swapAudioCodec"), this.streamController.swapAudioCodec();
  }
  /**
   * When the media-element fails, this allows to detach and then re-attach it
   * as one call (convenience method).
   *
   * Automatic recovery of media-errors by this process is configurable.
   */
  recoverMediaError() {
    V.log("recoverMediaError");
    const e = this._media;
    this.detachMedia(), e && this.attachMedia(e);
  }
  removeLevel(e, t = 0) {
    this.levelController.removeLevel(e, t);
  }
  /**
   * @returns an array of levels (variants) sorted by HDCP-LEVEL, RESOLUTION (height), FRAME-RATE, CODECS, VIDEO-RANGE, and BANDWIDTH
   */
  get levels() {
    const e = this.levelController.levels;
    return e || [];
  }
  /**
   * Index of quality level (variant) currently played
   */
  get currentLevel() {
    return this.streamController.currentLevel;
  }
  /**
   * Set quality level index immediately. This will flush the current buffer to replace the quality asap. That means playback will interrupt at least shortly to re-buffer and re-sync eventually. Set to -1 for automatic level selection.
   */
  set currentLevel(e) {
    V.log(`set currentLevel:${e}`), this.loadLevel = e, this.abrController.clearTimer(), this.streamController.immediateLevelSwitch();
  }
  /**
   * Index of next quality level loaded as scheduled by stream controller.
   */
  get nextLevel() {
    return this.streamController.nextLevel;
  }
  /**
   * Set quality level index for next loaded data.
   * This will switch the video quality asap, without interrupting playback.
   * May abort current loading of data, and flush parts of buffer (outside currently played fragment region).
   * @param newLevel - Pass -1 for automatic level selection
   */
  set nextLevel(e) {
    V.log(`set nextLevel:${e}`), this.levelController.manualLevel = e, this.streamController.nextLevelSwitch();
  }
  /**
   * Return the quality level of the currently or last (of none is loaded currently) segment
   */
  get loadLevel() {
    return this.levelController.level;
  }
  /**
   * Set quality level index for next loaded data in a conservative way.
   * This will switch the quality without flushing, but interrupt current loading.
   * Thus the moment when the quality switch will appear in effect will only be after the already existing buffer.
   * @param newLevel - Pass -1 for automatic level selection
   */
  set loadLevel(e) {
    V.log(`set loadLevel:${e}`), this.levelController.manualLevel = e;
  }
  /**
   * get next quality level loaded
   */
  get nextLoadLevel() {
    return this.levelController.nextLoadLevel;
  }
  /**
   * Set quality level of next loaded segment in a fully "non-destructive" way.
   * Same as `loadLevel` but will wait for next switch (until current loading is done).
   */
  set nextLoadLevel(e) {
    this.levelController.nextLoadLevel = e;
  }
  /**
   * Return "first level": like a default level, if not set,
   * falls back to index of first level referenced in manifest
   */
  get firstLevel() {
    return Math.max(this.levelController.firstLevel, this.minAutoLevel);
  }
  /**
   * Sets "first-level", see getter.
   */
  set firstLevel(e) {
    V.log(`set firstLevel:${e}`), this.levelController.firstLevel = e;
  }
  /**
   * Return the desired start level for the first fragment that will be loaded.
   * The default value of -1 indicates automatic start level selection.
   * Setting hls.nextAutoLevel without setting a startLevel will result in
   * the nextAutoLevel value being used for one fragment load.
   */
  get startLevel() {
    const e = this.levelController.startLevel;
    return e === -1 && this.abrController.forcedAutoLevel > -1 ? this.abrController.forcedAutoLevel : e;
  }
  /**
   * set  start level (level of first fragment that will be played back)
   * if not overrided by user, first level appearing in manifest will be used as start level
   * if -1 : automatic start level selection, playback will start from level matching download bandwidth
   * (determined from download of first segment)
   */
  set startLevel(e) {
    V.log(`set startLevel:${e}`), e !== -1 && (e = Math.max(e, this.minAutoLevel)), this.levelController.startLevel = e;
  }
  /**
   * Whether level capping is enabled.
   * Default value is set via `config.capLevelToPlayerSize`.
   */
  get capLevelToPlayerSize() {
    return this.config.capLevelToPlayerSize;
  }
  /**
   * Enables or disables level capping. If disabled after previously enabled, `nextLevelSwitch` will be immediately called.
   */
  set capLevelToPlayerSize(e) {
    const t = !!e;
    t !== this.config.capLevelToPlayerSize && (t ? this.capLevelController.startCapping() : (this.capLevelController.stopCapping(), this.autoLevelCapping = -1, this.streamController.nextLevelSwitch()), this.config.capLevelToPlayerSize = t);
  }
  /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */
  get autoLevelCapping() {
    return this._autoLevelCapping;
  }
  /**
   * Returns the current bandwidth estimate in bits per second, when available. Otherwise, `NaN` is returned.
   */
  get bandwidthEstimate() {
    const {
      bwEstimator: e
    } = this.abrController;
    return e ? e.getEstimate() : NaN;
  }
  set bandwidthEstimate(e) {
    this.abrController.resetEstimator(e);
  }
  /**
   * get time to first byte estimate
   * @type {number}
   */
  get ttfbEstimate() {
    const {
      bwEstimator: e
    } = this.abrController;
    return e ? e.getEstimateTTFB() : NaN;
  }
  /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */
  set autoLevelCapping(e) {
    this._autoLevelCapping !== e && (V.log(`set autoLevelCapping:${e}`), this._autoLevelCapping = e, this.levelController.checkMaxAutoUpdated());
  }
  get maxHdcpLevel() {
    return this._maxHdcpLevel;
  }
  set maxHdcpLevel(e) {
    Yc(e) && this._maxHdcpLevel !== e && (this._maxHdcpLevel = e, this.levelController.checkMaxAutoUpdated());
  }
  /**
   * True when automatic level selection enabled
   */
  get autoLevelEnabled() {
    return this.levelController.manualLevel === -1;
  }
  /**
   * Level set manually (if any)
   */
  get manualLevel() {
    return this.levelController.manualLevel;
  }
  /**
   * min level selectable in auto mode according to config.minAutoBitrate
   */
  get minAutoLevel() {
    const {
      levels: e,
      config: {
        minAutoBitrate: t
      }
    } = this;
    if (!e)
      return 0;
    const n = e.length;
    for (let r = 0; r < n; r++)
      if (e[r].maxBitrate >= t)
        return r;
    return 0;
  }
  /**
   * max level selectable in auto mode according to autoLevelCapping
   */
  get maxAutoLevel() {
    const {
      levels: e,
      autoLevelCapping: t,
      maxHdcpLevel: n
    } = this;
    let r;
    if (t === -1 && e && e.length ? r = e.length - 1 : r = t, n)
      for (let i = r; i--; ) {
        const s = e[i].attrs["HDCP-LEVEL"];
        if (s && s <= n)
          return i;
      }
    return r;
  }
  get firstAutoLevel() {
    return this.abrController.firstAutoLevel;
  }
  /**
   * next automatically selected quality level
   */
  get nextAutoLevel() {
    return this.abrController.nextAutoLevel;
  }
  /**
   * this setter is used to force next auto level.
   * this is useful to force a switch down in auto mode:
   * in case of load error on level N, hls.js can set nextAutoLevel to N-1 for example)
   * forced value is valid for one fragment. upon successful frag loading at forced level,
   * this value will be resetted to -1 by ABR controller.
   */
  set nextAutoLevel(e) {
    this.abrController.nextAutoLevel = e;
  }
  /**
   * get the datetime value relative to media.currentTime for the active level Program Date Time if present
   */
  get playingDate() {
    return this.streamController.currentProgramDateTime;
  }
  get mainForwardBufferInfo() {
    return this.streamController.getMainFwdBufferInfo();
  }
  /**
   * Get the complete list of audio tracks across all media groups
   */
  get allAudioTracks() {
    const e = this.audioTrackController;
    return e ? e.allAudioTracks : [];
  }
  /**
   * Get the list of selectable audio tracks
   */
  get audioTracks() {
    const e = this.audioTrackController;
    return e ? e.audioTracks : [];
  }
  /**
   * index of the selected audio track (index in audio track lists)
   */
  get audioTrack() {
    const e = this.audioTrackController;
    return e ? e.audioTrack : -1;
  }
  /**
   * selects an audio track, based on its index in audio track lists
   */
  set audioTrack(e) {
    const t = this.audioTrackController;
    t && (t.audioTrack = e);
  }
  /**
   * get the complete list of subtitle tracks across all media groups
   */
  get allSubtitleTracks() {
    const e = this.subtitleTrackController;
    return e ? e.allSubtitleTracks : [];
  }
  /**
   * get alternate subtitle tracks list from playlist
   */
  get subtitleTracks() {
    const e = this.subtitleTrackController;
    return e ? e.subtitleTracks : [];
  }
  /**
   * index of the selected subtitle track (index in subtitle track lists)
   */
  get subtitleTrack() {
    const e = this.subtitleTrackController;
    return e ? e.subtitleTrack : -1;
  }
  get media() {
    return this._media;
  }
  /**
   * select an subtitle track, based on its index in subtitle track lists
   */
  set subtitleTrack(e) {
    const t = this.subtitleTrackController;
    t && (t.subtitleTrack = e);
  }
  /**
   * Whether subtitle display is enabled or not
   */
  get subtitleDisplay() {
    const e = this.subtitleTrackController;
    return e ? e.subtitleDisplay : !1;
  }
  /**
   * Enable/disable subtitle display rendering
   */
  set subtitleDisplay(e) {
    const t = this.subtitleTrackController;
    t && (t.subtitleDisplay = e);
  }
  /**
   * get mode for Low-Latency HLS loading
   */
  get lowLatencyMode() {
    return this.config.lowLatencyMode;
  }
  /**
   * Enable/disable Low-Latency HLS part playlist and segment loading, and start live streams at playlist PART-HOLD-BACK rather than HOLD-BACK.
   */
  set lowLatencyMode(e) {
    this.config.lowLatencyMode = e;
  }
  /**
   * Position (in seconds) of live sync point (ie edge of live position minus safety delay defined by ```hls.config.liveSyncDuration```)
   * @returns null prior to loading live Playlist
   */
  get liveSyncPosition() {
    return this.latencyController.liveSyncPosition;
  }
  /**
   * Estimated position (in seconds) of live edge (ie edge of live playlist plus time sync playlist advanced)
   * @returns 0 before first playlist is loaded
   */
  get latency() {
    return this.latencyController.latency;
  }
  /**
   * maximum distance from the edge before the player seeks forward to ```hls.liveSyncPosition```
   * configured using ```liveMaxLatencyDurationCount``` (multiple of target duration) or ```liveMaxLatencyDuration```
   * @returns 0 before first playlist is loaded
   */
  get maxLatency() {
    return this.latencyController.maxLatency;
  }
  /**
   * target distance from the edge as calculated by the latency controller
   */
  get targetLatency() {
    return this.latencyController.targetLatency;
  }
  /**
   * the rate at which the edge of the current live playlist is advancing or 1 if there is none
   */
  get drift() {
    return this.latencyController.drift;
  }
  /**
   * set to true when startLoad is called before MANIFEST_PARSED event
   */
  get forceStartLoad() {
    return this.streamController.forceStartLoad;
  }
}
dn.defaultConfig = void 0;
var wo = { exports: {} };
(function(o, e) {
  (function(n, r) {
    o.exports = r();
  })(self, function() {
    return (
      /******/
      function() {
        var t = {
          /***/
          "./node_modules/es6-promise/dist/es6-promise.js": (
            /*!******************************************************!*\
              !*** ./node_modules/es6-promise/dist/es6-promise.js ***!
              \******************************************************/
            /***/
            function(s, a, l) {
              /*!
               * @overview es6-promise - a tiny implementation of Promises/A+.
               * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
               * @license   Licensed under MIT license
               *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
               * @version   v4.2.8+1e68dce6
               */
              (function(d, h) {
                s.exports = h();
              })(this, function() {
                function d(Q) {
                  var ne = typeof Q;
                  return Q !== null && (ne === "object" || ne === "function");
                }
                function h(Q) {
                  return typeof Q == "function";
                }
                var u = void 0;
                Array.isArray ? u = Array.isArray : u = function(Q) {
                  return Object.prototype.toString.call(Q) === "[object Array]";
                };
                var c = u, m = 0, f = void 0, p = void 0, A = function(ne, K) {
                  U[m] = ne, U[m + 1] = K, m += 2, m === 2 && (p ? p(G) : z());
                };
                function v(Q) {
                  p = Q;
                }
                function b(Q) {
                  A = Q;
                }
                var _ = typeof window < "u" ? window : void 0, T = _ || {}, E = T.MutationObserver || T.WebKitMutationObserver, L = typeof self > "u" && typeof process < "u" && {}.toString.call(process) === "[object process]", k = typeof Uint8ClampedArray < "u" && typeof importScripts < "u" && typeof MessageChannel < "u";
                function D() {
                  return function() {
                    return process.nextTick(G);
                  };
                }
                function M() {
                  return typeof f < "u" ? function() {
                    f(G);
                  } : B();
                }
                function O() {
                  var Q = 0, ne = new E(G), K = document.createTextNode("");
                  return ne.observe(K, { characterData: !0 }), function() {
                    K.data = Q = ++Q % 2;
                  };
                }
                function N() {
                  var Q = new MessageChannel();
                  return Q.port1.onmessage = G, function() {
                    return Q.port2.postMessage(0);
                  };
                }
                function B() {
                  var Q = setTimeout;
                  return function() {
                    return Q(G, 1);
                  };
                }
                var U = new Array(1e3);
                function G() {
                  for (var Q = 0; Q < m; Q += 2) {
                    var ne = U[Q], K = U[Q + 1];
                    ne(K), U[Q] = void 0, U[Q + 1] = void 0;
                  }
                  m = 0;
                }
                function Y() {
                  try {
                    var Q = Function("return this")().require("vertx");
                    return f = Q.runOnLoop || Q.runOnContext, M();
                  } catch {
                    return B();
                  }
                }
                var z = void 0;
                L ? z = D() : E ? z = O() : k ? z = N() : _ === void 0 ? z = Y() : z = B();
                function J(Q, ne) {
                  var K = this, fe = new this.constructor(Z);
                  fe[W] === void 0 && et(fe);
                  var Te = K._state;
                  if (Te) {
                    var we = arguments[Te - 1];
                    A(function() {
                      return Oe(Te, fe, we, K._result);
                    });
                  } else
                    Je(K, fe, Q, ne);
                  return fe;
                }
                function le(Q) {
                  var ne = this;
                  if (Q && typeof Q == "object" && Q.constructor === ne)
                    return Q;
                  var K = new ne(Z);
                  return qe(K, Q), K;
                }
                var W = Math.random().toString(36).substring(2);
                function Z() {
                }
                var ce = void 0, ue = 1, re = 2;
                function me() {
                  return new TypeError("You cannot resolve a promise with itself");
                }
                function Be() {
                  return new TypeError("A promises callback cannot return that same promise.");
                }
                function ye(Q, ne, K, fe) {
                  try {
                    Q.call(ne, K, fe);
                  } catch (Te) {
                    return Te;
                  }
                }
                function Le(Q, ne, K) {
                  A(function(fe) {
                    var Te = !1, we = ye(K, ne, function(Ee) {
                      Te || (Te = !0, ne !== Ee ? qe(fe, Ee) : De(fe, Ee));
                    }, function(Ee) {
                      Te || (Te = !0, ve(fe, Ee));
                    }, "Settle: " + (fe._label || " unknown promise"));
                    !Te && we && (Te = !0, ve(fe, we));
                  }, Q);
                }
                function Pe(Q, ne) {
                  ne._state === ue ? De(Q, ne._result) : ne._state === re ? ve(Q, ne._result) : Je(ne, void 0, function(K) {
                    return qe(Q, K);
                  }, function(K) {
                    return ve(Q, K);
                  });
                }
                function Me(Q, ne, K) {
                  ne.constructor === Q.constructor && K === J && ne.constructor.resolve === le ? Pe(Q, ne) : K === void 0 ? De(Q, ne) : h(K) ? Le(Q, ne, K) : De(Q, ne);
                }
                function qe(Q, ne) {
                  if (Q === ne)
                    ve(Q, me());
                  else if (d(ne)) {
                    var K = void 0;
                    try {
                      K = ne.then;
                    } catch (fe) {
                      ve(Q, fe);
                      return;
                    }
                    Me(Q, ne, K);
                  } else
                    De(Q, ne);
                }
                function ft(Q) {
                  Q._onerror && Q._onerror(Q._result), Xe(Q);
                }
                function De(Q, ne) {
                  Q._state === ce && (Q._result = ne, Q._state = ue, Q._subscribers.length !== 0 && A(Xe, Q));
                }
                function ve(Q, ne) {
                  Q._state === ce && (Q._state = re, Q._result = ne, A(ft, Q));
                }
                function Je(Q, ne, K, fe) {
                  var Te = Q._subscribers, we = Te.length;
                  Q._onerror = null, Te[we] = ne, Te[we + ue] = K, Te[we + re] = fe, we === 0 && Q._state && A(Xe, Q);
                }
                function Xe(Q) {
                  var ne = Q._subscribers, K = Q._state;
                  if (ne.length !== 0) {
                    for (var fe = void 0, Te = void 0, we = Q._result, Ee = 0; Ee < ne.length; Ee += 3)
                      fe = ne[Ee], Te = ne[Ee + K], fe ? Oe(K, fe, Te, we) : Te(we);
                    Q._subscribers.length = 0;
                  }
                }
                function Oe(Q, ne, K, fe) {
                  var Te = h(K), we = void 0, Ee = void 0, Bt = !0;
                  if (Te) {
                    try {
                      we = K(fe);
                    } catch (Pt) {
                      Bt = !1, Ee = Pt;
                    }
                    if (ne === we) {
                      ve(ne, Be());
                      return;
                    }
                  } else
                    we = fe;
                  ne._state !== ce || (Te && Bt ? qe(ne, we) : Bt === !1 ? ve(ne, Ee) : Q === ue ? De(ne, we) : Q === re && ve(ne, we));
                }
                function Ke(Q, ne) {
                  try {
                    ne(function(fe) {
                      qe(Q, fe);
                    }, function(fe) {
                      ve(Q, fe);
                    });
                  } catch (K) {
                    ve(Q, K);
                  }
                }
                var We = 0;
                function tt() {
                  return We++;
                }
                function et(Q) {
                  Q[W] = We++, Q._state = void 0, Q._result = void 0, Q._subscribers = [];
                }
                function ze() {
                  return new Error("Array Methods must be provided an Array");
                }
                var $e = function() {
                  function Q(ne, K) {
                    this._instanceConstructor = ne, this.promise = new ne(Z), this.promise[W] || et(this.promise), c(K) ? (this.length = K.length, this._remaining = K.length, this._result = new Array(this.length), this.length === 0 ? De(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(K), this._remaining === 0 && De(this.promise, this._result))) : ve(this.promise, ze());
                  }
                  return Q.prototype._enumerate = function(K) {
                    for (var fe = 0; this._state === ce && fe < K.length; fe++)
                      this._eachEntry(K[fe], fe);
                  }, Q.prototype._eachEntry = function(K, fe) {
                    var Te = this._instanceConstructor, we = Te.resolve;
                    if (we === le) {
                      var Ee = void 0, Bt = void 0, Pt = !1;
                      try {
                        Ee = K.then;
                      } catch (Gt) {
                        Pt = !0, Bt = Gt;
                      }
                      if (Ee === J && K._state !== ce)
                        this._settledAt(K._state, fe, K._result);
                      else if (typeof Ee != "function")
                        this._remaining--, this._result[fe] = K;
                      else if (Te === nt) {
                        var wt = new Te(Z);
                        Pt ? ve(wt, Bt) : Me(wt, K, Ee), this._willSettleAt(wt, fe);
                      } else
                        this._willSettleAt(new Te(function(Gt) {
                          return Gt(K);
                        }), fe);
                    } else
                      this._willSettleAt(we(K), fe);
                  }, Q.prototype._settledAt = function(K, fe, Te) {
                    var we = this.promise;
                    we._state === ce && (this._remaining--, K === re ? ve(we, Te) : this._result[fe] = Te), this._remaining === 0 && De(we, this._result);
                  }, Q.prototype._willSettleAt = function(K, fe) {
                    var Te = this;
                    Je(K, void 0, function(we) {
                      return Te._settledAt(ue, fe, we);
                    }, function(we) {
                      return Te._settledAt(re, fe, we);
                    });
                  }, Q;
                }();
                function gt(Q) {
                  return new $e(this, Q).promise;
                }
                function pt(Q) {
                  var ne = this;
                  return c(Q) ? new ne(function(K, fe) {
                    for (var Te = Q.length, we = 0; we < Te; we++)
                      ne.resolve(Q[we]).then(K, fe);
                  }) : new ne(function(K, fe) {
                    return fe(new TypeError("You must pass an array to race."));
                  });
                }
                function Lt(Q) {
                  var ne = this, K = new ne(Z);
                  return ve(K, Q), K;
                }
                function Et() {
                  throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
                }
                function _t() {
                  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
                }
                var nt = function() {
                  function Q(ne) {
                    this[W] = tt(), this._result = this._state = void 0, this._subscribers = [], Z !== ne && (typeof ne != "function" && Et(), this instanceof Q ? Ke(this, ne) : _t());
                  }
                  return Q.prototype.catch = function(K) {
                    return this.then(null, K);
                  }, Q.prototype.finally = function(K) {
                    var fe = this, Te = fe.constructor;
                    return h(K) ? fe.then(function(we) {
                      return Te.resolve(K()).then(function() {
                        return we;
                      });
                    }, function(we) {
                      return Te.resolve(K()).then(function() {
                        throw we;
                      });
                    }) : fe.then(K, K);
                  }, Q;
                }();
                nt.prototype.then = J, nt.all = gt, nt.race = pt, nt.resolve = le, nt.reject = Lt, nt._setScheduler = v, nt._setAsap = b, nt._asap = A;
                function Ot() {
                  var Q = void 0;
                  if (typeof l.g < "u")
                    Q = l.g;
                  else if (typeof self < "u")
                    Q = self;
                  else
                    try {
                      Q = Function("return this")();
                    } catch {
                      throw new Error("polyfill failed because global object is unavailable in this environment");
                    }
                  var ne = Q.Promise;
                  if (ne) {
                    var K = null;
                    try {
                      K = Object.prototype.toString.call(ne.resolve());
                    } catch {
                    }
                    if (K === "[object Promise]" && !ne.cast)
                      return;
                  }
                  Q.Promise = nt;
                }
                return nt.polyfill = Ot, nt.Promise = nt, nt;
              });
            }
          ),
          /***/
          "./node_modules/events/events.js": (
            /*!***************************************!*\
              !*** ./node_modules/events/events.js ***!
              \***************************************/
            /***/
            function(s) {
              var a = typeof Reflect == "object" ? Reflect : null, l = a && typeof a.apply == "function" ? a.apply : function(B, U, G) {
                return Function.prototype.apply.call(B, U, G);
              }, d;
              a && typeof a.ownKeys == "function" ? d = a.ownKeys : Object.getOwnPropertySymbols ? d = function(B) {
                return Object.getOwnPropertyNames(B).concat(Object.getOwnPropertySymbols(B));
              } : d = function(B) {
                return Object.getOwnPropertyNames(B);
              };
              function h(N) {
                console && console.warn && console.warn(N);
              }
              var u = Number.isNaN || function(B) {
                return B !== B;
              };
              function c() {
                c.init.call(this);
              }
              s.exports = c, s.exports.once = D, c.EventEmitter = c, c.prototype._events = void 0, c.prototype._eventsCount = 0, c.prototype._maxListeners = void 0;
              var m = 10;
              function f(N) {
                if (typeof N != "function")
                  throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof N);
              }
              Object.defineProperty(c, "defaultMaxListeners", {
                enumerable: !0,
                get: function() {
                  return m;
                },
                set: function(N) {
                  if (typeof N != "number" || N < 0 || u(N))
                    throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + N + ".");
                  m = N;
                }
              }), c.init = function() {
                (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
              }, c.prototype.setMaxListeners = function(B) {
                if (typeof B != "number" || B < 0 || u(B))
                  throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + B + ".");
                return this._maxListeners = B, this;
              };
              function p(N) {
                return N._maxListeners === void 0 ? c.defaultMaxListeners : N._maxListeners;
              }
              c.prototype.getMaxListeners = function() {
                return p(this);
              }, c.prototype.emit = function(B) {
                for (var U = [], G = 1; G < arguments.length; G++)
                  U.push(arguments[G]);
                var Y = B === "error", z = this._events;
                if (z !== void 0)
                  Y = Y && z.error === void 0;
                else if (!Y)
                  return !1;
                if (Y) {
                  var J;
                  if (U.length > 0 && (J = U[0]), J instanceof Error)
                    throw J;
                  var le = new Error("Unhandled error." + (J ? " (" + J.message + ")" : ""));
                  throw le.context = J, le;
                }
                var W = z[B];
                if (W === void 0)
                  return !1;
                if (typeof W == "function")
                  l(W, this, U);
                else
                  for (var Z = W.length, ce = E(W, Z), G = 0; G < Z; ++G)
                    l(ce[G], this, U);
                return !0;
              };
              function A(N, B, U, G) {
                var Y, z, J;
                if (f(U), z = N._events, z === void 0 ? (z = N._events = /* @__PURE__ */ Object.create(null), N._eventsCount = 0) : (z.newListener !== void 0 && (N.emit("newListener", B, U.listener ? U.listener : U), z = N._events), J = z[B]), J === void 0)
                  J = z[B] = U, ++N._eventsCount;
                else if (typeof J == "function" ? J = z[B] = G ? [U, J] : [J, U] : G ? J.unshift(U) : J.push(U), Y = p(N), Y > 0 && J.length > Y && !J.warned) {
                  J.warned = !0;
                  var le = new Error("Possible EventEmitter memory leak detected. " + J.length + " " + String(B) + " listeners added. Use emitter.setMaxListeners() to increase limit");
                  le.name = "MaxListenersExceededWarning", le.emitter = N, le.type = B, le.count = J.length, h(le);
                }
                return N;
              }
              c.prototype.addListener = function(B, U) {
                return A(this, B, U, !1);
              }, c.prototype.on = c.prototype.addListener, c.prototype.prependListener = function(B, U) {
                return A(this, B, U, !0);
              };
              function v() {
                if (!this.fired)
                  return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
              }
              function b(N, B, U) {
                var G = { fired: !1, wrapFn: void 0, target: N, type: B, listener: U }, Y = v.bind(G);
                return Y.listener = U, G.wrapFn = Y, Y;
              }
              c.prototype.once = function(B, U) {
                return f(U), this.on(B, b(this, B, U)), this;
              }, c.prototype.prependOnceListener = function(B, U) {
                return f(U), this.prependListener(B, b(this, B, U)), this;
              }, c.prototype.removeListener = function(B, U) {
                var G, Y, z, J, le;
                if (f(U), Y = this._events, Y === void 0)
                  return this;
                if (G = Y[B], G === void 0)
                  return this;
                if (G === U || G.listener === U)
                  --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete Y[B], Y.removeListener && this.emit("removeListener", B, G.listener || U));
                else if (typeof G != "function") {
                  for (z = -1, J = G.length - 1; J >= 0; J--)
                    if (G[J] === U || G[J].listener === U) {
                      le = G[J].listener, z = J;
                      break;
                    }
                  if (z < 0)
                    return this;
                  z === 0 ? G.shift() : L(G, z), G.length === 1 && (Y[B] = G[0]), Y.removeListener !== void 0 && this.emit("removeListener", B, le || U);
                }
                return this;
              }, c.prototype.off = c.prototype.removeListener, c.prototype.removeAllListeners = function(B) {
                var U, G, Y;
                if (G = this._events, G === void 0)
                  return this;
                if (G.removeListener === void 0)
                  return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : G[B] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete G[B]), this;
                if (arguments.length === 0) {
                  var z = Object.keys(G), J;
                  for (Y = 0; Y < z.length; ++Y)
                    J = z[Y], J !== "removeListener" && this.removeAllListeners(J);
                  return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
                }
                if (U = G[B], typeof U == "function")
                  this.removeListener(B, U);
                else if (U !== void 0)
                  for (Y = U.length - 1; Y >= 0; Y--)
                    this.removeListener(B, U[Y]);
                return this;
              };
              function _(N, B, U) {
                var G = N._events;
                if (G === void 0)
                  return [];
                var Y = G[B];
                return Y === void 0 ? [] : typeof Y == "function" ? U ? [Y.listener || Y] : [Y] : U ? k(Y) : E(Y, Y.length);
              }
              c.prototype.listeners = function(B) {
                return _(this, B, !0);
              }, c.prototype.rawListeners = function(B) {
                return _(this, B, !1);
              }, c.listenerCount = function(N, B) {
                return typeof N.listenerCount == "function" ? N.listenerCount(B) : T.call(N, B);
              }, c.prototype.listenerCount = T;
              function T(N) {
                var B = this._events;
                if (B !== void 0) {
                  var U = B[N];
                  if (typeof U == "function")
                    return 1;
                  if (U !== void 0)
                    return U.length;
                }
                return 0;
              }
              c.prototype.eventNames = function() {
                return this._eventsCount > 0 ? d(this._events) : [];
              };
              function E(N, B) {
                for (var U = new Array(B), G = 0; G < B; ++G)
                  U[G] = N[G];
                return U;
              }
              function L(N, B) {
                for (; B + 1 < N.length; B++)
                  N[B] = N[B + 1];
                N.pop();
              }
              function k(N) {
                for (var B = new Array(N.length), U = 0; U < B.length; ++U)
                  B[U] = N[U].listener || N[U];
                return B;
              }
              function D(N, B) {
                return new Promise(function(U, G) {
                  function Y(J) {
                    N.removeListener(B, z), G(J);
                  }
                  function z() {
                    typeof N.removeListener == "function" && N.removeListener("error", Y), U([].slice.call(arguments));
                  }
                  O(N, B, z, { once: !0 }), B !== "error" && M(N, Y, { once: !0 });
                });
              }
              function M(N, B, U) {
                typeof N.on == "function" && O(N, "error", B, U);
              }
              function O(N, B, U, G) {
                if (typeof N.on == "function")
                  G.once ? N.once(B, U) : N.on(B, U);
                else if (typeof N.addEventListener == "function")
                  N.addEventListener(B, function Y(z) {
                    G.once && N.removeEventListener(B, Y), U(z);
                  });
                else
                  throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof N);
              }
            }
          ),
          /***/
          "./node_modules/webworkify-webpack/index.js": (
            /*!**************************************************!*\
              !*** ./node_modules/webworkify-webpack/index.js ***!
              \**************************************************/
            /***/
            function(s, a, l) {
              function d(v) {
                var b = {};
                function _(E) {
                  if (b[E])
                    return b[E].exports;
                  var L = b[E] = {
                    /******/
                    i: E,
                    /******/
                    l: !1,
                    /******/
                    exports: {}
                    /******/
                  };
                  return v[E].call(L.exports, L, L.exports, _), L.l = !0, L.exports;
                }
                _.m = v, _.c = b, _.i = function(E) {
                  return E;
                }, _.d = function(E, L, k) {
                  _.o(E, L) || Object.defineProperty(E, L, {
                    /******/
                    configurable: !1,
                    /******/
                    enumerable: !0,
                    /******/
                    get: k
                    /******/
                  });
                }, _.r = function(E) {
                  Object.defineProperty(E, "__esModule", { value: !0 });
                }, _.n = function(E) {
                  var L = E && E.__esModule ? (
                    /******/
                    function() {
                      return E.default;
                    }
                  ) : (
                    /******/
                    function() {
                      return E;
                    }
                  );
                  return _.d(L, "a", L), L;
                }, _.o = function(E, L) {
                  return Object.prototype.hasOwnProperty.call(E, L);
                }, _.p = "/", _.oe = function(E) {
                  throw console.error(E), E;
                };
                var T = _(_.s = ENTRY_MODULE);
                return T.default || T;
              }
              var h = "[\\.|\\-|\\+|\\w|/|@]+", u = "\\(\\s*(/\\*.*?\\*/)?\\s*.*?(" + h + ").*?\\)";
              function c(v) {
                return (v + "").replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
              }
              function m(v) {
                return !isNaN(1 * v);
              }
              function f(v, b, _) {
                var T = {};
                T[_] = [];
                var E = b.toString(), L = E.match(/^function\s?\w*\(\w+,\s*\w+,\s*(\w+)\)/);
                if (!L)
                  return T;
                for (var k = L[1], D = new RegExp("(\\\\n|\\W)" + c(k) + u, "g"), M; M = D.exec(E); )
                  M[3] !== "dll-reference" && T[_].push(M[3]);
                for (D = new RegExp("\\(" + c(k) + '\\("(dll-reference\\s(' + h + '))"\\)\\)' + u, "g"); M = D.exec(E); )
                  v[M[2]] || (T[_].push(M[1]), v[M[2]] = l(M[1]).m), T[M[2]] = T[M[2]] || [], T[M[2]].push(M[4]);
                for (var O = Object.keys(T), N = 0; N < O.length; N++)
                  for (var B = 0; B < T[O[N]].length; B++)
                    m(T[O[N]][B]) && (T[O[N]][B] = 1 * T[O[N]][B]);
                return T;
              }
              function p(v) {
                var b = Object.keys(v);
                return b.reduce(function(_, T) {
                  return _ || v[T].length > 0;
                }, !1);
              }
              function A(v, b) {
                for (var _ = {
                  main: [b]
                }, T = {
                  main: []
                }, E = {
                  main: {}
                }; p(_); )
                  for (var L = Object.keys(_), k = 0; k < L.length; k++) {
                    var D = L[k], M = _[D], O = M.pop();
                    if (E[D] = E[D] || {}, !(E[D][O] || !v[D][O])) {
                      E[D][O] = !0, T[D] = T[D] || [], T[D].push(O);
                      for (var N = f(v, v[D][O], D), B = Object.keys(N), U = 0; U < B.length; U++)
                        _[B[U]] = _[B[U]] || [], _[B[U]] = _[B[U]].concat(N[B[U]]);
                    }
                  }
                return T;
              }
              s.exports = function(v, b) {
                b = b || {};
                var _ = {
                  main: l.m
                }, T = b.all ? { main: Object.keys(_.main) } : A(_, v), E = "";
                Object.keys(T).filter(function(O) {
                  return O !== "main";
                }).forEach(function(O) {
                  for (var N = 0; T[O][N]; )
                    N++;
                  T[O].push(N), _[O][N] = "(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })", E = E + "var " + O + " = (" + d.toString().replace("ENTRY_MODULE", JSON.stringify(N)) + ")({" + T[O].map(function(B) {
                    return "" + JSON.stringify(B) + ": " + _[O][B].toString();
                  }).join(",") + `});
`;
                }), E = E + "new ((" + d.toString().replace("ENTRY_MODULE", JSON.stringify(v)) + ")({" + T.main.map(function(O) {
                  return "" + JSON.stringify(O) + ": " + _.main[O].toString();
                }).join(",") + "}))(self);";
                var L = new window.Blob([E], { type: "text/javascript" });
                if (b.bare)
                  return L;
                var k = window.URL || window.webkitURL || window.mozURL || window.msURL, D = k.createObjectURL(L), M = new window.Worker(D);
                return M.objectURL = D, M;
              };
            }
          ),
          /***/
          "./src/config.js": (
            /*!***********************!*\
              !*** ./src/config.js ***!
              \***********************/
            /***/
            function(s, a, l) {
              l.r(a), l.d(a, {
                /* harmony export */
                defaultConfig: function() {
                  return (
                    /* binding */
                    d
                  );
                },
                /* harmony export */
                createDefaultConfig: function() {
                  return (
                    /* binding */
                    h
                  );
                }
                /* harmony export */
              });
              var d = {
                enableWorker: !1,
                enableStashBuffer: !0,
                stashInitialSize: void 0,
                isLive: !1,
                lazyLoad: !0,
                lazyLoadMaxDuration: 3 * 60,
                lazyLoadRecoverDuration: 30,
                deferLoadAfterSourceOpen: !0,
                // autoCleanupSourceBuffer: default as false, leave unspecified
                autoCleanupMaxBackwardDuration: 3 * 60,
                autoCleanupMinBackwardDuration: 2 * 60,
                statisticsInfoReportInterval: 600,
                fixAudioTimestampGap: !0,
                accurateSeek: !1,
                seekType: "range",
                seekParamStart: "bstart",
                seekParamEnd: "bend",
                rangeLoadZeroStart: !1,
                customSeekHandler: void 0,
                reuseRedirectedURL: !1,
                // referrerPolicy: leave as unspecified
                headers: void 0,
                customLoader: void 0
              };
              function h() {
                return Object.assign({}, d);
              }
            }
          ),
          /***/
          "./src/core/features.js": (
            /*!******************************!*\
              !*** ./src/core/features.js ***!
              \******************************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = l(
                /*! ../io/io-controller.js */
                "./src/io/io-controller.js"
              ), h = l(
                /*! ../config.js */
                "./src/config.js"
              ), u = (
                /** @class */
                function() {
                  function c() {
                  }
                  return c.supportMSEH264Playback = function() {
                    return window.MediaSource && window.MediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"');
                  }, c.supportNetworkStreamIO = function() {
                    var m = new d.default({}, (0, h.createDefaultConfig)()), f = m.loaderType;
                    return m.destroy(), f == "fetch-stream-loader" || f == "xhr-moz-chunked-loader";
                  }, c.getNetworkLoaderTypeName = function() {
                    var m = new d.default({}, (0, h.createDefaultConfig)()), f = m.loaderType;
                    return m.destroy(), f;
                  }, c.supportNativeMediaPlayback = function(m) {
                    c.videoElement == null && (c.videoElement = window.document.createElement("video"));
                    var f = c.videoElement.canPlayType(m);
                    return f === "probably" || f == "maybe";
                  }, c.getFeatureList = function() {
                    var m = {
                      mseFlvPlayback: !1,
                      mseLiveFlvPlayback: !1,
                      networkStreamIO: !1,
                      networkLoaderName: "",
                      nativeMP4H264Playback: !1,
                      nativeWebmVP8Playback: !1,
                      nativeWebmVP9Playback: !1
                    };
                    return m.mseFlvPlayback = c.supportMSEH264Playback(), m.networkStreamIO = c.supportNetworkStreamIO(), m.networkLoaderName = c.getNetworkLoaderTypeName(), m.mseLiveFlvPlayback = m.mseFlvPlayback && m.networkStreamIO, m.nativeMP4H264Playback = c.supportNativeMediaPlayback('video/mp4; codecs="avc1.42001E, mp4a.40.2"'), m.nativeWebmVP8Playback = c.supportNativeMediaPlayback('video/webm; codecs="vp8.0, vorbis"'), m.nativeWebmVP9Playback = c.supportNativeMediaPlayback('video/webm; codecs="vp9"'), m;
                  }, c;
                }()
              );
              a.default = u;
            }
          ),
          /***/
          "./src/core/media-info.js": (
            /*!********************************!*\
              !*** ./src/core/media-info.js ***!
              \********************************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = (
                /** @class */
                function() {
                  function h() {
                    this.mimeType = null, this.duration = null, this.hasAudio = null, this.hasVideo = null, this.audioCodec = null, this.videoCodec = null, this.audioDataRate = null, this.videoDataRate = null, this.audioSampleRate = null, this.audioChannelCount = null, this.width = null, this.height = null, this.fps = null, this.profile = null, this.level = null, this.refFrames = null, this.chromaFormat = null, this.sarNum = null, this.sarDen = null, this.metadata = null, this.segments = null, this.segmentCount = null, this.hasKeyframesIndex = null, this.keyframesIndex = null;
                  }
                  return h.prototype.isComplete = function() {
                    var u = this.hasAudio === !1 || this.hasAudio === !0 && this.audioCodec != null && this.audioSampleRate != null && this.audioChannelCount != null, c = this.hasVideo === !1 || this.hasVideo === !0 && this.videoCodec != null && this.width != null && this.height != null && this.fps != null && this.profile != null && this.level != null && this.refFrames != null && this.chromaFormat != null && this.sarNum != null && this.sarDen != null;
                    return this.mimeType != null && this.duration != null && this.metadata != null && this.hasKeyframesIndex != null && u && c;
                  }, h.prototype.isSeekable = function() {
                    return this.hasKeyframesIndex === !0;
                  }, h.prototype.getNearestKeyframe = function(u) {
                    if (this.keyframesIndex == null)
                      return null;
                    var c = this.keyframesIndex, m = this._search(c.times, u);
                    return {
                      index: m,
                      milliseconds: c.times[m],
                      fileposition: c.filepositions[m]
                    };
                  }, h.prototype._search = function(u, c) {
                    var m = 0, f = u.length - 1, p = 0, A = 0, v = f;
                    for (c < u[0] && (m = 0, A = v + 1); A <= v; )
                      if (p = A + Math.floor((v - A) / 2), p === f || c >= u[p] && c < u[p + 1]) {
                        m = p;
                        break;
                      } else
                        u[p] < c ? A = p + 1 : v = p - 1;
                    return m;
                  }, h;
                }()
              );
              a.default = d;
            }
          ),
          /***/
          "./src/core/media-segment-info.js": (
            /*!****************************************!*\
              !*** ./src/core/media-segment-info.js ***!
              \****************************************/
            /***/
            function(s, a, l) {
              l.r(a), l.d(a, {
                /* harmony export */
                SampleInfo: function() {
                  return (
                    /* binding */
                    d
                  );
                },
                /* harmony export */
                MediaSegmentInfo: function() {
                  return (
                    /* binding */
                    h
                  );
                },
                /* harmony export */
                IDRSampleList: function() {
                  return (
                    /* binding */
                    u
                  );
                },
                /* harmony export */
                MediaSegmentInfoList: function() {
                  return (
                    /* binding */
                    c
                  );
                }
                /* harmony export */
              });
              var d = (
                /** @class */
                function() {
                  function m(f, p, A, v, b) {
                    this.dts = f, this.pts = p, this.duration = A, this.originalDts = v, this.isSyncPoint = b, this.fileposition = null;
                  }
                  return m;
                }()
              ), h = (
                /** @class */
                function() {
                  function m() {
                    this.beginDts = 0, this.endDts = 0, this.beginPts = 0, this.endPts = 0, this.originalBeginDts = 0, this.originalEndDts = 0, this.syncPoints = [], this.firstSample = null, this.lastSample = null;
                  }
                  return m.prototype.appendSyncPoint = function(f) {
                    f.isSyncPoint = !0, this.syncPoints.push(f);
                  }, m;
                }()
              ), u = (
                /** @class */
                function() {
                  function m() {
                    this._list = [];
                  }
                  return m.prototype.clear = function() {
                    this._list = [];
                  }, m.prototype.appendArray = function(f) {
                    var p = this._list;
                    f.length !== 0 && (p.length > 0 && f[0].originalDts < p[p.length - 1].originalDts && this.clear(), Array.prototype.push.apply(p, f));
                  }, m.prototype.getLastSyncPointBeforeDts = function(f) {
                    if (this._list.length == 0)
                      return null;
                    var p = this._list, A = 0, v = p.length - 1, b = 0, _ = 0, T = v;
                    for (f < p[0].dts && (A = 0, _ = T + 1); _ <= T; )
                      if (b = _ + Math.floor((T - _) / 2), b === v || f >= p[b].dts && f < p[b + 1].dts) {
                        A = b;
                        break;
                      } else
                        p[b].dts < f ? _ = b + 1 : T = b - 1;
                    return this._list[A];
                  }, m;
                }()
              ), c = (
                /** @class */
                function() {
                  function m(f) {
                    this._type = f, this._list = [], this._lastAppendLocation = -1;
                  }
                  return Object.defineProperty(m.prototype, "type", {
                    get: function() {
                      return this._type;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(m.prototype, "length", {
                    get: function() {
                      return this._list.length;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), m.prototype.isEmpty = function() {
                    return this._list.length === 0;
                  }, m.prototype.clear = function() {
                    this._list = [], this._lastAppendLocation = -1;
                  }, m.prototype._searchNearestSegmentBefore = function(f) {
                    var p = this._list;
                    if (p.length === 0)
                      return -2;
                    var A = p.length - 1, v = 0, b = 0, _ = A, T = 0;
                    if (f < p[0].originalBeginDts)
                      return T = -1, T;
                    for (; b <= _; )
                      if (v = b + Math.floor((_ - b) / 2), v === A || f > p[v].lastSample.originalDts && f < p[v + 1].originalBeginDts) {
                        T = v;
                        break;
                      } else
                        p[v].originalBeginDts < f ? b = v + 1 : _ = v - 1;
                    return T;
                  }, m.prototype._searchNearestSegmentAfter = function(f) {
                    return this._searchNearestSegmentBefore(f) + 1;
                  }, m.prototype.append = function(f) {
                    var p = this._list, A = f, v = this._lastAppendLocation, b = 0;
                    v !== -1 && v < p.length && A.originalBeginDts >= p[v].lastSample.originalDts && (v === p.length - 1 || v < p.length - 1 && A.originalBeginDts < p[v + 1].originalBeginDts) ? b = v + 1 : p.length > 0 && (b = this._searchNearestSegmentBefore(A.originalBeginDts) + 1), this._lastAppendLocation = b, this._list.splice(b, 0, A);
                  }, m.prototype.getLastSegmentBefore = function(f) {
                    var p = this._searchNearestSegmentBefore(f);
                    return p >= 0 ? this._list[p] : null;
                  }, m.prototype.getLastSampleBefore = function(f) {
                    var p = this.getLastSegmentBefore(f);
                    return p != null ? p.lastSample : null;
                  }, m.prototype.getLastSyncPointBefore = function(f) {
                    for (var p = this._searchNearestSegmentBefore(f), A = this._list[p].syncPoints; A.length === 0 && p > 0; )
                      p--, A = this._list[p].syncPoints;
                    return A.length > 0 ? A[A.length - 1] : null;
                  }, m;
                }()
              );
            }
          ),
          /***/
          "./src/core/mse-controller.js": (
            /*!************************************!*\
              !*** ./src/core/mse-controller.js ***!
              \************************************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = l(
                /*! events */
                "./node_modules/events/events.js"
              ), h = /* @__PURE__ */ l.n(d), u = l(
                /*! ../utils/logger.js */
                "./src/utils/logger.js"
              ), c = l(
                /*! ../utils/browser.js */
                "./src/utils/browser.js"
              ), m = l(
                /*! ./mse-events.js */
                "./src/core/mse-events.js"
              ), f = l(
                /*! ./media-segment-info.js */
                "./src/core/media-segment-info.js"
              ), p = l(
                /*! ../utils/exception.js */
                "./src/utils/exception.js"
              ), A = (
                /** @class */
                function() {
                  function v(b) {
                    this.TAG = "MSEController", this._config = b, this._emitter = new (h())(), this._config.isLive && this._config.autoCleanupSourceBuffer == null && (this._config.autoCleanupSourceBuffer = !0), this.e = {
                      onSourceOpen: this._onSourceOpen.bind(this),
                      onSourceEnded: this._onSourceEnded.bind(this),
                      onSourceClose: this._onSourceClose.bind(this),
                      onSourceBufferError: this._onSourceBufferError.bind(this),
                      onSourceBufferUpdateEnd: this._onSourceBufferUpdateEnd.bind(this)
                    }, this._mediaSource = null, this._mediaSourceObjectURL = null, this._mediaElement = null, this._isBufferFull = !1, this._hasPendingEos = !1, this._requireSetMediaDuration = !1, this._pendingMediaDuration = 0, this._pendingSourceBufferInit = [], this._mimeTypes = {
                      video: null,
                      audio: null
                    }, this._sourceBuffers = {
                      video: null,
                      audio: null
                    }, this._lastInitSegments = {
                      video: null,
                      audio: null
                    }, this._pendingSegments = {
                      video: [],
                      audio: []
                    }, this._pendingRemoveRanges = {
                      video: [],
                      audio: []
                    }, this._idrList = new f.IDRSampleList();
                  }
                  return v.prototype.destroy = function() {
                    (this._mediaElement || this._mediaSource) && this.detachMediaElement(), this.e = null, this._emitter.removeAllListeners(), this._emitter = null;
                  }, v.prototype.on = function(b, _) {
                    this._emitter.addListener(b, _);
                  }, v.prototype.off = function(b, _) {
                    this._emitter.removeListener(b, _);
                  }, v.prototype.attachMediaElement = function(b) {
                    if (this._mediaSource)
                      throw new p.IllegalStateException("MediaSource has been attached to an HTMLMediaElement!");
                    var _ = this._mediaSource = new window.MediaSource();
                    _.addEventListener("sourceopen", this.e.onSourceOpen), _.addEventListener("sourceended", this.e.onSourceEnded), _.addEventListener("sourceclose", this.e.onSourceClose), this._mediaElement = b, this._mediaSourceObjectURL = window.URL.createObjectURL(this._mediaSource), b.src = this._mediaSourceObjectURL;
                  }, v.prototype.detachMediaElement = function() {
                    if (this._mediaSource) {
                      var b = this._mediaSource;
                      for (var _ in this._sourceBuffers) {
                        var T = this._pendingSegments[_];
                        T.splice(0, T.length), this._pendingSegments[_] = null, this._pendingRemoveRanges[_] = null, this._lastInitSegments[_] = null;
                        var E = this._sourceBuffers[_];
                        if (E) {
                          if (b.readyState !== "closed") {
                            try {
                              b.removeSourceBuffer(E);
                            } catch (L) {
                              u.default.e(this.TAG, L.message);
                            }
                            E.removeEventListener("error", this.e.onSourceBufferError), E.removeEventListener("updateend", this.e.onSourceBufferUpdateEnd);
                          }
                          this._mimeTypes[_] = null, this._sourceBuffers[_] = null;
                        }
                      }
                      if (b.readyState === "open")
                        try {
                          b.endOfStream();
                        } catch (L) {
                          u.default.e(this.TAG, L.message);
                        }
                      b.removeEventListener("sourceopen", this.e.onSourceOpen), b.removeEventListener("sourceended", this.e.onSourceEnded), b.removeEventListener("sourceclose", this.e.onSourceClose), this._pendingSourceBufferInit = [], this._isBufferFull = !1, this._idrList.clear(), this._mediaSource = null;
                    }
                    this._mediaElement && (this._mediaElement.src = "", this._mediaElement.removeAttribute("src"), this._mediaElement = null), this._mediaSourceObjectURL && (window.URL.revokeObjectURL(this._mediaSourceObjectURL), this._mediaSourceObjectURL = null);
                  }, v.prototype.appendInitSegment = function(b, _) {
                    if (!this._mediaSource || this._mediaSource.readyState !== "open") {
                      this._pendingSourceBufferInit.push(b), this._pendingSegments[b.type].push(b);
                      return;
                    }
                    var T = b, E = "" + T.container;
                    T.codec && T.codec.length > 0 && (E += ";codecs=" + T.codec);
                    var L = !1;
                    if (u.default.v(this.TAG, "Received Initialization Segment, mimeType: " + E), this._lastInitSegments[T.type] = T, E !== this._mimeTypes[T.type]) {
                      if (this._mimeTypes[T.type])
                        u.default.v(this.TAG, "Notice: " + T.type + " mimeType changed, origin: " + this._mimeTypes[T.type] + ", target: " + E);
                      else {
                        L = !0;
                        try {
                          var k = this._sourceBuffers[T.type] = this._mediaSource.addSourceBuffer(E);
                          k.addEventListener("error", this.e.onSourceBufferError), k.addEventListener("updateend", this.e.onSourceBufferUpdateEnd);
                        } catch (D) {
                          u.default.e(this.TAG, D.message), this._emitter.emit(m.default.ERROR, { code: D.code, msg: D.message });
                          return;
                        }
                      }
                      this._mimeTypes[T.type] = E;
                    }
                    _ || this._pendingSegments[T.type].push(T), L || this._sourceBuffers[T.type] && !this._sourceBuffers[T.type].updating && this._doAppendSegments(), c.default.safari && T.container === "audio/mpeg" && T.mediaDuration > 0 && (this._requireSetMediaDuration = !0, this._pendingMediaDuration = T.mediaDuration / 1e3, this._updateMediaSourceDuration());
                  }, v.prototype.appendMediaSegment = function(b) {
                    var _ = b;
                    this._pendingSegments[_.type].push(_), this._config.autoCleanupSourceBuffer && this._needCleanupSourceBuffer() && this._doCleanupSourceBuffer();
                    var T = this._sourceBuffers[_.type];
                    T && !T.updating && !this._hasPendingRemoveRanges() && this._doAppendSegments();
                  }, v.prototype.seek = function(b) {
                    for (var _ in this._sourceBuffers)
                      if (this._sourceBuffers[_]) {
                        var T = this._sourceBuffers[_];
                        if (this._mediaSource.readyState === "open")
                          try {
                            T.abort();
                          } catch (O) {
                            u.default.e(this.TAG, O.message);
                          }
                        this._idrList.clear();
                        var E = this._pendingSegments[_];
                        if (E.splice(0, E.length), this._mediaSource.readyState !== "closed") {
                          for (var L = 0; L < T.buffered.length; L++) {
                            var k = T.buffered.start(L), D = T.buffered.end(L);
                            this._pendingRemoveRanges[_].push({ start: k, end: D });
                          }
                          if (T.updating || this._doRemoveRanges(), c.default.safari) {
                            var M = this._lastInitSegments[_];
                            M && (this._pendingSegments[_].push(M), T.updating || this._doAppendSegments());
                          }
                        }
                      }
                  }, v.prototype.endOfStream = function() {
                    var b = this._mediaSource, _ = this._sourceBuffers;
                    if (!b || b.readyState !== "open") {
                      b && b.readyState === "closed" && this._hasPendingSegments() && (this._hasPendingEos = !0);
                      return;
                    }
                    _.video && _.video.updating || _.audio && _.audio.updating ? this._hasPendingEos = !0 : (this._hasPendingEos = !1, b.endOfStream());
                  }, v.prototype.getNearestKeyframe = function(b) {
                    return this._idrList.getLastSyncPointBeforeDts(b);
                  }, v.prototype._needCleanupSourceBuffer = function() {
                    if (!this._config.autoCleanupSourceBuffer)
                      return !1;
                    var b = this._mediaElement.currentTime;
                    for (var _ in this._sourceBuffers) {
                      var T = this._sourceBuffers[_];
                      if (T) {
                        var E = T.buffered;
                        if (E.length >= 1 && b - E.start(0) >= this._config.autoCleanupMaxBackwardDuration)
                          return !0;
                      }
                    }
                    return !1;
                  }, v.prototype._doCleanupSourceBuffer = function() {
                    var b = this._mediaElement.currentTime;
                    for (var _ in this._sourceBuffers) {
                      var T = this._sourceBuffers[_];
                      if (T) {
                        for (var E = T.buffered, L = !1, k = 0; k < E.length; k++) {
                          var D = E.start(k), M = E.end(k);
                          if (D <= b && b < M + 3) {
                            if (b - D >= this._config.autoCleanupMaxBackwardDuration) {
                              L = !0;
                              var O = b - this._config.autoCleanupMinBackwardDuration;
                              this._pendingRemoveRanges[_].push({ start: D, end: O });
                            }
                          } else
                            M < b && (L = !0, this._pendingRemoveRanges[_].push({ start: D, end: M }));
                        }
                        L && !T.updating && this._doRemoveRanges();
                      }
                    }
                  }, v.prototype._updateMediaSourceDuration = function() {
                    var b = this._sourceBuffers;
                    if (!(this._mediaElement.readyState === 0 || this._mediaSource.readyState !== "open") && !(b.video && b.video.updating || b.audio && b.audio.updating)) {
                      var _ = this._mediaSource.duration, T = this._pendingMediaDuration;
                      T > 0 && (isNaN(_) || T > _) && (u.default.v(this.TAG, "Update MediaSource duration from " + _ + " to " + T), this._mediaSource.duration = T), this._requireSetMediaDuration = !1, this._pendingMediaDuration = 0;
                    }
                  }, v.prototype._doRemoveRanges = function() {
                    for (var b in this._pendingRemoveRanges)
                      if (!(!this._sourceBuffers[b] || this._sourceBuffers[b].updating))
                        for (var _ = this._sourceBuffers[b], T = this._pendingRemoveRanges[b]; T.length && !_.updating; ) {
                          var E = T.shift();
                          _.remove(E.start, E.end);
                        }
                  }, v.prototype._doAppendSegments = function() {
                    var b = this._pendingSegments;
                    for (var _ in b)
                      if (!(!this._sourceBuffers[_] || this._sourceBuffers[_].updating) && b[_].length > 0) {
                        var T = b[_].shift();
                        if (T.timestampOffset) {
                          var E = this._sourceBuffers[_].timestampOffset, L = T.timestampOffset / 1e3, k = Math.abs(E - L);
                          k > 0.1 && (u.default.v(this.TAG, "Update MPEG audio timestampOffset from " + E + " to " + L), this._sourceBuffers[_].timestampOffset = L), delete T.timestampOffset;
                        }
                        if (!T.data || T.data.byteLength === 0)
                          continue;
                        try {
                          this._sourceBuffers[_].appendBuffer(T.data), this._isBufferFull = !1, _ === "video" && T.hasOwnProperty("info") && this._idrList.appendArray(T.info.syncPoints);
                        } catch (D) {
                          this._pendingSegments[_].unshift(T), D.code === 22 ? (this._isBufferFull || this._emitter.emit(m.default.BUFFER_FULL), this._isBufferFull = !0) : (u.default.e(this.TAG, D.message), this._emitter.emit(m.default.ERROR, { code: D.code, msg: D.message }));
                        }
                      }
                  }, v.prototype._onSourceOpen = function() {
                    if (u.default.v(this.TAG, "MediaSource onSourceOpen"), this._mediaSource.removeEventListener("sourceopen", this.e.onSourceOpen), this._pendingSourceBufferInit.length > 0)
                      for (var b = this._pendingSourceBufferInit; b.length; ) {
                        var _ = b.shift();
                        this.appendInitSegment(_, !0);
                      }
                    this._hasPendingSegments() && this._doAppendSegments(), this._emitter.emit(m.default.SOURCE_OPEN);
                  }, v.prototype._onSourceEnded = function() {
                    u.default.v(this.TAG, "MediaSource onSourceEnded");
                  }, v.prototype._onSourceClose = function() {
                    u.default.v(this.TAG, "MediaSource onSourceClose"), this._mediaSource && this.e != null && (this._mediaSource.removeEventListener("sourceopen", this.e.onSourceOpen), this._mediaSource.removeEventListener("sourceended", this.e.onSourceEnded), this._mediaSource.removeEventListener("sourceclose", this.e.onSourceClose));
                  }, v.prototype._hasPendingSegments = function() {
                    var b = this._pendingSegments;
                    return b.video.length > 0 || b.audio.length > 0;
                  }, v.prototype._hasPendingRemoveRanges = function() {
                    var b = this._pendingRemoveRanges;
                    return b.video.length > 0 || b.audio.length > 0;
                  }, v.prototype._onSourceBufferUpdateEnd = function() {
                    this._requireSetMediaDuration ? this._updateMediaSourceDuration() : this._hasPendingRemoveRanges() ? this._doRemoveRanges() : this._hasPendingSegments() ? this._doAppendSegments() : this._hasPendingEos && this.endOfStream(), this._emitter.emit(m.default.UPDATE_END);
                  }, v.prototype._onSourceBufferError = function(b) {
                    u.default.e(this.TAG, "SourceBuffer Error: " + b);
                  }, v;
                }()
              );
              a.default = A;
            }
          ),
          /***/
          "./src/core/mse-events.js": (
            /*!********************************!*\
              !*** ./src/core/mse-events.js ***!
              \********************************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = {
                ERROR: "error",
                SOURCE_OPEN: "source_open",
                UPDATE_END: "update_end",
                BUFFER_FULL: "buffer_full"
              };
              a.default = d;
            }
          ),
          /***/
          "./src/core/transmuxer.js": (
            /*!********************************!*\
              !*** ./src/core/transmuxer.js ***!
              \********************************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = l(
                /*! events */
                "./node_modules/events/events.js"
              ), h = /* @__PURE__ */ l.n(d), u = l(
                /*! webworkify-webpack */
                "./node_modules/webworkify-webpack/index.js"
              ), c = /* @__PURE__ */ l.n(u), m = l(
                /*! ../utils/logger.js */
                "./src/utils/logger.js"
              ), f = l(
                /*! ../utils/logging-control.js */
                "./src/utils/logging-control.js"
              ), p = l(
                /*! ./transmuxing-controller.js */
                "./src/core/transmuxing-controller.js"
              ), A = l(
                /*! ./transmuxing-events.js */
                "./src/core/transmuxing-events.js"
              ), v = l(
                /*! ./media-info.js */
                "./src/core/media-info.js"
              ), b = (
                /** @class */
                function() {
                  function _(T, E) {
                    if (this.TAG = "Transmuxer", this._emitter = new (h())(), E.enableWorker && typeof Worker < "u")
                      try {
                        this._worker = c()(
                          /*require.resolve*/
                          /*! ./transmuxing-worker */
                          "./src/core/transmuxing-worker.js"
                        ), this._workerDestroying = !1, this._worker.addEventListener("message", this._onWorkerMessage.bind(this)), this._worker.postMessage({ cmd: "init", param: [T, E] }), this.e = {
                          onLoggingConfigChanged: this._onLoggingConfigChanged.bind(this)
                        }, f.default.registerListener(this.e.onLoggingConfigChanged), this._worker.postMessage({ cmd: "logging_config", param: f.default.getConfig() });
                      } catch {
                        m.default.e(this.TAG, "Error while initialize transmuxing worker, fallback to inline transmuxing"), this._worker = null, this._controller = new p.default(T, E);
                      }
                    else
                      this._controller = new p.default(T, E);
                    if (this._controller) {
                      var L = this._controller;
                      L.on(A.default.IO_ERROR, this._onIOError.bind(this)), L.on(A.default.DEMUX_ERROR, this._onDemuxError.bind(this)), L.on(A.default.INIT_SEGMENT, this._onInitSegment.bind(this)), L.on(A.default.MEDIA_SEGMENT, this._onMediaSegment.bind(this)), L.on(A.default.LOADING_COMPLETE, this._onLoadingComplete.bind(this)), L.on(A.default.RECOVERED_EARLY_EOF, this._onRecoveredEarlyEof.bind(this)), L.on(A.default.MEDIA_INFO, this._onMediaInfo.bind(this)), L.on(A.default.METADATA_ARRIVED, this._onMetaDataArrived.bind(this)), L.on(A.default.SCRIPTDATA_ARRIVED, this._onScriptDataArrived.bind(this)), L.on(A.default.STATISTICS_INFO, this._onStatisticsInfo.bind(this)), L.on(A.default.RECOMMEND_SEEKPOINT, this._onRecommendSeekpoint.bind(this));
                    }
                  }
                  return _.prototype.destroy = function() {
                    this._worker ? this._workerDestroying || (this._workerDestroying = !0, this._worker.postMessage({ cmd: "destroy" }), f.default.removeListener(this.e.onLoggingConfigChanged), this.e = null) : (this._controller.destroy(), this._controller = null), this._emitter.removeAllListeners(), this._emitter = null;
                  }, _.prototype.on = function(T, E) {
                    this._emitter.addListener(T, E);
                  }, _.prototype.off = function(T, E) {
                    this._emitter.removeListener(T, E);
                  }, _.prototype.hasWorker = function() {
                    return this._worker != null;
                  }, _.prototype.open = function() {
                    this._worker ? this._worker.postMessage({ cmd: "start" }) : this._controller.start();
                  }, _.prototype.close = function() {
                    this._worker ? this._worker.postMessage({ cmd: "stop" }) : this._controller.stop();
                  }, _.prototype.seek = function(T) {
                    this._worker ? this._worker.postMessage({ cmd: "seek", param: T }) : this._controller.seek(T);
                  }, _.prototype.pause = function() {
                    this._worker ? this._worker.postMessage({ cmd: "pause" }) : this._controller.pause();
                  }, _.prototype.resume = function() {
                    this._worker ? this._worker.postMessage({ cmd: "resume" }) : this._controller.resume();
                  }, _.prototype._onInitSegment = function(T, E) {
                    var L = this;
                    Promise.resolve().then(function() {
                      L._emitter.emit(A.default.INIT_SEGMENT, T, E);
                    });
                  }, _.prototype._onMediaSegment = function(T, E) {
                    var L = this;
                    Promise.resolve().then(function() {
                      L._emitter.emit(A.default.MEDIA_SEGMENT, T, E);
                    });
                  }, _.prototype._onLoadingComplete = function() {
                    var T = this;
                    Promise.resolve().then(function() {
                      T._emitter.emit(A.default.LOADING_COMPLETE);
                    });
                  }, _.prototype._onRecoveredEarlyEof = function() {
                    var T = this;
                    Promise.resolve().then(function() {
                      T._emitter.emit(A.default.RECOVERED_EARLY_EOF);
                    });
                  }, _.prototype._onMediaInfo = function(T) {
                    var E = this;
                    Promise.resolve().then(function() {
                      E._emitter.emit(A.default.MEDIA_INFO, T);
                    });
                  }, _.prototype._onMetaDataArrived = function(T) {
                    var E = this;
                    Promise.resolve().then(function() {
                      E._emitter.emit(A.default.METADATA_ARRIVED, T);
                    });
                  }, _.prototype._onScriptDataArrived = function(T) {
                    var E = this;
                    Promise.resolve().then(function() {
                      E._emitter.emit(A.default.SCRIPTDATA_ARRIVED, T);
                    });
                  }, _.prototype._onStatisticsInfo = function(T) {
                    var E = this;
                    Promise.resolve().then(function() {
                      E._emitter.emit(A.default.STATISTICS_INFO, T);
                    });
                  }, _.prototype._onIOError = function(T, E) {
                    var L = this;
                    Promise.resolve().then(function() {
                      L._emitter.emit(A.default.IO_ERROR, T, E);
                    });
                  }, _.prototype._onDemuxError = function(T, E) {
                    var L = this;
                    Promise.resolve().then(function() {
                      L._emitter.emit(A.default.DEMUX_ERROR, T, E);
                    });
                  }, _.prototype._onRecommendSeekpoint = function(T) {
                    var E = this;
                    Promise.resolve().then(function() {
                      E._emitter.emit(A.default.RECOMMEND_SEEKPOINT, T);
                    });
                  }, _.prototype._onLoggingConfigChanged = function(T) {
                    this._worker && this._worker.postMessage({ cmd: "logging_config", param: T });
                  }, _.prototype._onWorkerMessage = function(T) {
                    var E = T.data, L = E.data;
                    if (E.msg === "destroyed" || this._workerDestroying) {
                      this._workerDestroying = !1, this._worker.terminate(), this._worker = null;
                      return;
                    }
                    switch (E.msg) {
                      case A.default.INIT_SEGMENT:
                      case A.default.MEDIA_SEGMENT:
                        this._emitter.emit(E.msg, L.type, L.data);
                        break;
                      case A.default.LOADING_COMPLETE:
                      case A.default.RECOVERED_EARLY_EOF:
                        this._emitter.emit(E.msg);
                        break;
                      case A.default.MEDIA_INFO:
                        Object.setPrototypeOf(L, v.default.prototype), this._emitter.emit(E.msg, L);
                        break;
                      case A.default.METADATA_ARRIVED:
                      case A.default.SCRIPTDATA_ARRIVED:
                      case A.default.STATISTICS_INFO:
                        this._emitter.emit(E.msg, L);
                        break;
                      case A.default.IO_ERROR:
                      case A.default.DEMUX_ERROR:
                        this._emitter.emit(E.msg, L.type, L.info);
                        break;
                      case A.default.RECOMMEND_SEEKPOINT:
                        this._emitter.emit(E.msg, L);
                        break;
                      case "logcat_callback":
                        m.default.emitter.emit("log", L.type, L.logcat);
                        break;
                    }
                  }, _;
                }()
              );
              a.default = b;
            }
          ),
          /***/
          "./src/core/transmuxing-controller.js": (
            /*!********************************************!*\
              !*** ./src/core/transmuxing-controller.js ***!
              \********************************************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = l(
                /*! events */
                "./node_modules/events/events.js"
              ), h = /* @__PURE__ */ l.n(d), u = l(
                /*! ../utils/logger.js */
                "./src/utils/logger.js"
              ), c = l(
                /*! ../utils/browser.js */
                "./src/utils/browser.js"
              ), m = l(
                /*! ./media-info.js */
                "./src/core/media-info.js"
              ), f = l(
                /*! ../demux/flv-demuxer.js */
                "./src/demux/flv-demuxer.js"
              ), p = l(
                /*! ../remux/mp4-remuxer.js */
                "./src/remux/mp4-remuxer.js"
              ), A = l(
                /*! ../demux/demux-errors.js */
                "./src/demux/demux-errors.js"
              ), v = l(
                /*! ../io/io-controller.js */
                "./src/io/io-controller.js"
              ), b = l(
                /*! ./transmuxing-events.js */
                "./src/core/transmuxing-events.js"
              ), _ = (
                /** @class */
                function() {
                  function T(E, L) {
                    this.TAG = "TransmuxingController", this._emitter = new (h())(), this._config = L, E.segments || (E.segments = [{
                      duration: E.duration,
                      filesize: E.filesize,
                      url: E.url
                    }]), typeof E.cors != "boolean" && (E.cors = !0), typeof E.withCredentials != "boolean" && (E.withCredentials = !1), this._mediaDataSource = E, this._currentSegmentIndex = 0;
                    var k = 0;
                    this._mediaDataSource.segments.forEach(function(D) {
                      D.timestampBase = k, k += D.duration, D.cors = E.cors, D.withCredentials = E.withCredentials, L.referrerPolicy && (D.referrerPolicy = L.referrerPolicy);
                    }), !isNaN(k) && this._mediaDataSource.duration !== k && (this._mediaDataSource.duration = k), this._mediaInfo = null, this._demuxer = null, this._remuxer = null, this._ioctl = null, this._pendingSeekTime = null, this._pendingResolveSeekPoint = null, this._statisticsReporter = null;
                  }
                  return T.prototype.destroy = function() {
                    this._mediaInfo = null, this._mediaDataSource = null, this._statisticsReporter && this._disableStatisticsReporter(), this._ioctl && (this._ioctl.destroy(), this._ioctl = null), this._demuxer && (this._demuxer.destroy(), this._demuxer = null), this._remuxer && (this._remuxer.destroy(), this._remuxer = null), this._emitter.removeAllListeners(), this._emitter = null;
                  }, T.prototype.on = function(E, L) {
                    this._emitter.addListener(E, L);
                  }, T.prototype.off = function(E, L) {
                    this._emitter.removeListener(E, L);
                  }, T.prototype.start = function() {
                    this._loadSegment(0), this._enableStatisticsReporter();
                  }, T.prototype._loadSegment = function(E, L) {
                    this._currentSegmentIndex = E;
                    var k = this._mediaDataSource.segments[E], D = this._ioctl = new v.default(k, this._config, E);
                    D.onError = this._onIOException.bind(this), D.onSeeked = this._onIOSeeked.bind(this), D.onComplete = this._onIOComplete.bind(this), D.onRedirect = this._onIORedirect.bind(this), D.onRecoveredEarlyEof = this._onIORecoveredEarlyEof.bind(this), L ? this._demuxer.bindDataSource(this._ioctl) : D.onDataArrival = this._onInitChunkArrival.bind(this), D.open(L);
                  }, T.prototype.stop = function() {
                    this._internalAbort(), this._disableStatisticsReporter();
                  }, T.prototype._internalAbort = function() {
                    this._ioctl && (this._ioctl.destroy(), this._ioctl = null);
                  }, T.prototype.pause = function() {
                    this._ioctl && this._ioctl.isWorking() && (this._ioctl.pause(), this._disableStatisticsReporter());
                  }, T.prototype.resume = function() {
                    this._ioctl && this._ioctl.isPaused() && (this._ioctl.resume(), this._enableStatisticsReporter());
                  }, T.prototype.seek = function(E) {
                    if (!(this._mediaInfo == null || !this._mediaInfo.isSeekable())) {
                      var L = this._searchSegmentIndexContains(E);
                      if (L === this._currentSegmentIndex) {
                        var k = this._mediaInfo.segments[L];
                        if (k == null)
                          this._pendingSeekTime = E;
                        else {
                          var D = k.getNearestKeyframe(E);
                          this._remuxer.seek(D.milliseconds), this._ioctl.seek(D.fileposition), this._pendingResolveSeekPoint = D.milliseconds;
                        }
                      } else {
                        var M = this._mediaInfo.segments[L];
                        if (M == null)
                          this._pendingSeekTime = E, this._internalAbort(), this._remuxer.seek(), this._remuxer.insertDiscontinuity(), this._loadSegment(L);
                        else {
                          var D = M.getNearestKeyframe(E);
                          this._internalAbort(), this._remuxer.seek(E), this._remuxer.insertDiscontinuity(), this._demuxer.resetMediaInfo(), this._demuxer.timestampBase = this._mediaDataSource.segments[L].timestampBase, this._loadSegment(L, D.fileposition), this._pendingResolveSeekPoint = D.milliseconds, this._reportSegmentMediaInfo(L);
                        }
                      }
                      this._enableStatisticsReporter();
                    }
                  }, T.prototype._searchSegmentIndexContains = function(E) {
                    for (var L = this._mediaDataSource.segments, k = L.length - 1, D = 0; D < L.length; D++)
                      if (E < L[D].timestampBase) {
                        k = D - 1;
                        break;
                      }
                    return k;
                  }, T.prototype._onInitChunkArrival = function(E, L) {
                    var k = this, D = null, M = 0;
                    if (L > 0)
                      this._demuxer.bindDataSource(this._ioctl), this._demuxer.timestampBase = this._mediaDataSource.segments[this._currentSegmentIndex].timestampBase, M = this._demuxer.parseChunks(E, L);
                    else if ((D = f.default.probe(E)).match) {
                      this._demuxer = new f.default(D, this._config), this._remuxer || (this._remuxer = new p.default(this._config));
                      var O = this._mediaDataSource;
                      O.duration != null && !isNaN(O.duration) && (this._demuxer.overridedDuration = O.duration), typeof O.hasAudio == "boolean" && (this._demuxer.overridedHasAudio = O.hasAudio), typeof O.hasVideo == "boolean" && (this._demuxer.overridedHasVideo = O.hasVideo), this._demuxer.timestampBase = O.segments[this._currentSegmentIndex].timestampBase, this._demuxer.onError = this._onDemuxException.bind(this), this._demuxer.onMediaInfo = this._onMediaInfo.bind(this), this._demuxer.onMetaDataArrived = this._onMetaDataArrived.bind(this), this._demuxer.onScriptDataArrived = this._onScriptDataArrived.bind(this), this._remuxer.bindDataSource(this._demuxer.bindDataSource(this._ioctl)), this._remuxer.onInitSegment = this._onRemuxerInitSegmentArrival.bind(this), this._remuxer.onMediaSegment = this._onRemuxerMediaSegmentArrival.bind(this), M = this._demuxer.parseChunks(E, L);
                    } else
                      D = null, u.default.e(this.TAG, "Non-FLV, Unsupported media type!"), Promise.resolve().then(function() {
                        k._internalAbort();
                      }), this._emitter.emit(b.default.DEMUX_ERROR, A.default.FORMAT_UNSUPPORTED, "Non-FLV, Unsupported media type"), M = 0;
                    return M;
                  }, T.prototype._onMediaInfo = function(E) {
                    var L = this;
                    this._mediaInfo == null && (this._mediaInfo = Object.assign({}, E), this._mediaInfo.keyframesIndex = null, this._mediaInfo.segments = [], this._mediaInfo.segmentCount = this._mediaDataSource.segments.length, Object.setPrototypeOf(this._mediaInfo, m.default.prototype));
                    var k = Object.assign({}, E);
                    Object.setPrototypeOf(k, m.default.prototype), this._mediaInfo.segments[this._currentSegmentIndex] = k, this._reportSegmentMediaInfo(this._currentSegmentIndex), this._pendingSeekTime != null && Promise.resolve().then(function() {
                      var D = L._pendingSeekTime;
                      L._pendingSeekTime = null, L.seek(D);
                    });
                  }, T.prototype._onMetaDataArrived = function(E) {
                    this._emitter.emit(b.default.METADATA_ARRIVED, E);
                  }, T.prototype._onScriptDataArrived = function(E) {
                    this._emitter.emit(b.default.SCRIPTDATA_ARRIVED, E);
                  }, T.prototype._onIOSeeked = function() {
                    this._remuxer.insertDiscontinuity();
                  }, T.prototype._onIOComplete = function(E) {
                    var L = E, k = L + 1;
                    k < this._mediaDataSource.segments.length ? (this._internalAbort(), this._remuxer.flushStashedSamples(), this._loadSegment(k)) : (this._remuxer.flushStashedSamples(), this._emitter.emit(b.default.LOADING_COMPLETE), this._disableStatisticsReporter());
                  }, T.prototype._onIORedirect = function(E) {
                    var L = this._ioctl.extraData;
                    this._mediaDataSource.segments[L].redirectedURL = E;
                  }, T.prototype._onIORecoveredEarlyEof = function() {
                    this._emitter.emit(b.default.RECOVERED_EARLY_EOF);
                  }, T.prototype._onIOException = function(E, L) {
                    u.default.e(this.TAG, "IOException: type = " + E + ", code = " + L.code + ", msg = " + L.msg), this._emitter.emit(b.default.IO_ERROR, E, L), this._disableStatisticsReporter();
                  }, T.prototype._onDemuxException = function(E, L) {
                    u.default.e(this.TAG, "DemuxException: type = " + E + ", info = " + L), this._emitter.emit(b.default.DEMUX_ERROR, E, L);
                  }, T.prototype._onRemuxerInitSegmentArrival = function(E, L) {
                    this._emitter.emit(b.default.INIT_SEGMENT, E, L);
                  }, T.prototype._onRemuxerMediaSegmentArrival = function(E, L) {
                    if (this._pendingSeekTime == null && (this._emitter.emit(b.default.MEDIA_SEGMENT, E, L), this._pendingResolveSeekPoint != null && E === "video")) {
                      var k = L.info.syncPoints, D = this._pendingResolveSeekPoint;
                      this._pendingResolveSeekPoint = null, c.default.safari && k.length > 0 && k[0].originalDts === D && (D = k[0].pts), this._emitter.emit(b.default.RECOMMEND_SEEKPOINT, D);
                    }
                  }, T.prototype._enableStatisticsReporter = function() {
                    this._statisticsReporter == null && (this._statisticsReporter = self.setInterval(this._reportStatisticsInfo.bind(this), this._config.statisticsInfoReportInterval));
                  }, T.prototype._disableStatisticsReporter = function() {
                    this._statisticsReporter && (self.clearInterval(this._statisticsReporter), this._statisticsReporter = null);
                  }, T.prototype._reportSegmentMediaInfo = function(E) {
                    var L = this._mediaInfo.segments[E], k = Object.assign({}, L);
                    k.duration = this._mediaInfo.duration, k.segmentCount = this._mediaInfo.segmentCount, delete k.segments, delete k.keyframesIndex, this._emitter.emit(b.default.MEDIA_INFO, k);
                  }, T.prototype._reportStatisticsInfo = function() {
                    var E = {};
                    E.url = this._ioctl.currentURL, E.hasRedirect = this._ioctl.hasRedirect, E.hasRedirect && (E.redirectedURL = this._ioctl.currentRedirectedURL), E.speed = this._ioctl.currentSpeed, E.loaderType = this._ioctl.loaderType, E.currentSegmentIndex = this._currentSegmentIndex, E.totalSegmentCount = this._mediaDataSource.segments.length, this._emitter.emit(b.default.STATISTICS_INFO, E);
                  }, T;
                }()
              );
              a.default = _;
            }
          ),
          /***/
          "./src/core/transmuxing-events.js": (
            /*!****************************************!*\
              !*** ./src/core/transmuxing-events.js ***!
              \****************************************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = {
                IO_ERROR: "io_error",
                DEMUX_ERROR: "demux_error",
                INIT_SEGMENT: "init_segment",
                MEDIA_SEGMENT: "media_segment",
                LOADING_COMPLETE: "loading_complete",
                RECOVERED_EARLY_EOF: "recovered_early_eof",
                MEDIA_INFO: "media_info",
                METADATA_ARRIVED: "metadata_arrived",
                SCRIPTDATA_ARRIVED: "scriptdata_arrived",
                STATISTICS_INFO: "statistics_info",
                RECOMMEND_SEEKPOINT: "recommend_seekpoint"
              };
              a.default = d;
            }
          ),
          /***/
          "./src/core/transmuxing-worker.js": (
            /*!****************************************!*\
              !*** ./src/core/transmuxing-worker.js ***!
              \****************************************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = l(
                /*! ../utils/logging-control.js */
                "./src/utils/logging-control.js"
              ), h = l(
                /*! ../utils/polyfill.js */
                "./src/utils/polyfill.js"
              ), u = l(
                /*! ./transmuxing-controller.js */
                "./src/core/transmuxing-controller.js"
              ), c = l(
                /*! ./transmuxing-events.js */
                "./src/core/transmuxing-events.js"
              ), m = function(f) {
                var p = null, A = B.bind(this);
                h.default.install(), f.addEventListener("message", function(U) {
                  switch (U.data.cmd) {
                    case "init":
                      p = new u.default(U.data.param[0], U.data.param[1]), p.on(c.default.IO_ERROR, M.bind(this)), p.on(c.default.DEMUX_ERROR, O.bind(this)), p.on(c.default.INIT_SEGMENT, v.bind(this)), p.on(c.default.MEDIA_SEGMENT, b.bind(this)), p.on(c.default.LOADING_COMPLETE, _.bind(this)), p.on(c.default.RECOVERED_EARLY_EOF, T.bind(this)), p.on(c.default.MEDIA_INFO, E.bind(this)), p.on(c.default.METADATA_ARRIVED, L.bind(this)), p.on(c.default.SCRIPTDATA_ARRIVED, k.bind(this)), p.on(c.default.STATISTICS_INFO, D.bind(this)), p.on(c.default.RECOMMEND_SEEKPOINT, N.bind(this));
                      break;
                    case "destroy":
                      p && (p.destroy(), p = null), f.postMessage({ msg: "destroyed" });
                      break;
                    case "start":
                      p.start();
                      break;
                    case "stop":
                      p.stop();
                      break;
                    case "seek":
                      p.seek(U.data.param);
                      break;
                    case "pause":
                      p.pause();
                      break;
                    case "resume":
                      p.resume();
                      break;
                    case "logging_config": {
                      var G = U.data.param;
                      d.default.applyConfig(G), G.enableCallback === !0 ? d.default.addLogListener(A) : d.default.removeLogListener(A);
                      break;
                    }
                  }
                });
                function v(U, G) {
                  var Y = {
                    msg: c.default.INIT_SEGMENT,
                    data: {
                      type: U,
                      data: G
                    }
                  };
                  f.postMessage(Y, [G.data]);
                }
                function b(U, G) {
                  var Y = {
                    msg: c.default.MEDIA_SEGMENT,
                    data: {
                      type: U,
                      data: G
                    }
                  };
                  f.postMessage(Y, [G.data]);
                }
                function _() {
                  var U = {
                    msg: c.default.LOADING_COMPLETE
                  };
                  f.postMessage(U);
                }
                function T() {
                  var U = {
                    msg: c.default.RECOVERED_EARLY_EOF
                  };
                  f.postMessage(U);
                }
                function E(U) {
                  var G = {
                    msg: c.default.MEDIA_INFO,
                    data: U
                  };
                  f.postMessage(G);
                }
                function L(U) {
                  var G = {
                    msg: c.default.METADATA_ARRIVED,
                    data: U
                  };
                  f.postMessage(G);
                }
                function k(U) {
                  var G = {
                    msg: c.default.SCRIPTDATA_ARRIVED,
                    data: U
                  };
                  f.postMessage(G);
                }
                function D(U) {
                  var G = {
                    msg: c.default.STATISTICS_INFO,
                    data: U
                  };
                  f.postMessage(G);
                }
                function M(U, G) {
                  f.postMessage({
                    msg: c.default.IO_ERROR,
                    data: {
                      type: U,
                      info: G
                    }
                  });
                }
                function O(U, G) {
                  f.postMessage({
                    msg: c.default.DEMUX_ERROR,
                    data: {
                      type: U,
                      info: G
                    }
                  });
                }
                function N(U) {
                  f.postMessage({
                    msg: c.default.RECOMMEND_SEEKPOINT,
                    data: U
                  });
                }
                function B(U, G) {
                  f.postMessage({
                    msg: "logcat_callback",
                    data: {
                      type: U,
                      logcat: G
                    }
                  });
                }
              };
              a.default = m;
            }
          ),
          /***/
          "./src/demux/amf-parser.js": (
            /*!*********************************!*\
              !*** ./src/demux/amf-parser.js ***!
              \*********************************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = l(
                /*! ../utils/logger.js */
                "./src/utils/logger.js"
              ), h = l(
                /*! ../utils/utf8-conv.js */
                "./src/utils/utf8-conv.js"
              ), u = l(
                /*! ../utils/exception.js */
                "./src/utils/exception.js"
              ), c = function() {
                var f = new ArrayBuffer(2);
                return new DataView(f).setInt16(0, 256, !0), new Int16Array(f)[0] === 256;
              }(), m = (
                /** @class */
                function() {
                  function f() {
                  }
                  return f.parseScriptData = function(p, A, v) {
                    var b = {};
                    try {
                      var _ = f.parseValue(p, A, v), T = f.parseValue(p, A + _.size, v - _.size);
                      b[_.data] = T.data;
                    } catch (E) {
                      d.default.e("AMF", E.toString());
                    }
                    return b;
                  }, f.parseObject = function(p, A, v) {
                    if (v < 3)
                      throw new u.IllegalStateException("Data not enough when parse ScriptDataObject");
                    var b = f.parseString(p, A, v), _ = f.parseValue(p, A + b.size, v - b.size), T = _.objectEnd;
                    return {
                      data: {
                        name: b.data,
                        value: _.data
                      },
                      size: b.size + _.size,
                      objectEnd: T
                    };
                  }, f.parseVariable = function(p, A, v) {
                    return f.parseObject(p, A, v);
                  }, f.parseString = function(p, A, v) {
                    if (v < 2)
                      throw new u.IllegalStateException("Data not enough when parse String");
                    var b = new DataView(p, A, v), _ = b.getUint16(0, !c), T;
                    return _ > 0 ? T = (0, h.default)(new Uint8Array(p, A + 2, _)) : T = "", {
                      data: T,
                      size: 2 + _
                    };
                  }, f.parseLongString = function(p, A, v) {
                    if (v < 4)
                      throw new u.IllegalStateException("Data not enough when parse LongString");
                    var b = new DataView(p, A, v), _ = b.getUint32(0, !c), T;
                    return _ > 0 ? T = (0, h.default)(new Uint8Array(p, A + 4, _)) : T = "", {
                      data: T,
                      size: 4 + _
                    };
                  }, f.parseDate = function(p, A, v) {
                    if (v < 10)
                      throw new u.IllegalStateException("Data size invalid when parse Date");
                    var b = new DataView(p, A, v), _ = b.getFloat64(0, !c), T = b.getInt16(8, !c);
                    return _ += T * 60 * 1e3, {
                      data: new Date(_),
                      size: 8 + 2
                    };
                  }, f.parseValue = function(p, A, v) {
                    if (v < 1)
                      throw new u.IllegalStateException("Data not enough when parse Value");
                    var b = new DataView(p, A, v), _ = 1, T = b.getUint8(0), E, L = !1;
                    try {
                      switch (T) {
                        case 0:
                          E = b.getFloat64(1, !c), _ += 8;
                          break;
                        case 1: {
                          var k = b.getUint8(1);
                          E = !!k, _ += 1;
                          break;
                        }
                        case 2: {
                          var D = f.parseString(p, A + 1, v - 1);
                          E = D.data, _ += D.size;
                          break;
                        }
                        case 3: {
                          E = {};
                          var M = 0;
                          for ((b.getUint32(v - 4, !c) & 16777215) === 9 && (M = 3); _ < v - 4; ) {
                            var O = f.parseObject(p, A + _, v - _ - M);
                            if (O.objectEnd)
                              break;
                            E[O.data.name] = O.data.value, _ += O.size;
                          }
                          if (_ <= v - 3) {
                            var N = b.getUint32(_ - 1, !c) & 16777215;
                            N === 9 && (_ += 3);
                          }
                          break;
                        }
                        case 8: {
                          E = {}, _ += 4;
                          var M = 0;
                          for ((b.getUint32(v - 4, !c) & 16777215) === 9 && (M = 3); _ < v - 8; ) {
                            var B = f.parseVariable(p, A + _, v - _ - M);
                            if (B.objectEnd)
                              break;
                            E[B.data.name] = B.data.value, _ += B.size;
                          }
                          if (_ <= v - 3) {
                            var N = b.getUint32(_ - 1, !c) & 16777215;
                            N === 9 && (_ += 3);
                          }
                          break;
                        }
                        case 9:
                          E = void 0, _ = 1, L = !0;
                          break;
                        case 10: {
                          E = [];
                          var U = b.getUint32(1, !c);
                          _ += 4;
                          for (var G = 0; G < U; G++) {
                            var Y = f.parseValue(p, A + _, v - _);
                            E.push(Y.data), _ += Y.size;
                          }
                          break;
                        }
                        case 11: {
                          var z = f.parseDate(p, A + 1, v - 1);
                          E = z.data, _ += z.size;
                          break;
                        }
                        case 12: {
                          var J = f.parseString(p, A + 1, v - 1);
                          E = J.data, _ += J.size;
                          break;
                        }
                        default:
                          _ = v, d.default.w("AMF", "Unsupported AMF value type " + T);
                      }
                    } catch (le) {
                      d.default.e("AMF", le.toString());
                    }
                    return {
                      data: E,
                      size: _,
                      objectEnd: L
                    };
                  }, f;
                }()
              );
              a.default = m;
            }
          ),
          /***/
          "./src/demux/demux-errors.js": (
            /*!***********************************!*\
              !*** ./src/demux/demux-errors.js ***!
              \***********************************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = {
                OK: "OK",
                FORMAT_ERROR: "FormatError",
                FORMAT_UNSUPPORTED: "FormatUnsupported",
                CODEC_UNSUPPORTED: "CodecUnsupported"
              };
              a.default = d;
            }
          ),
          /***/
          "./src/demux/exp-golomb.js": (
            /*!*********************************!*\
              !*** ./src/demux/exp-golomb.js ***!
              \*********************************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = l(
                /*! ../utils/exception.js */
                "./src/utils/exception.js"
              ), h = (
                /** @class */
                function() {
                  function u(c) {
                    this.TAG = "ExpGolomb", this._buffer = c, this._buffer_index = 0, this._total_bytes = c.byteLength, this._total_bits = c.byteLength * 8, this._current_word = 0, this._current_word_bits_left = 0;
                  }
                  return u.prototype.destroy = function() {
                    this._buffer = null;
                  }, u.prototype._fillCurrentWord = function() {
                    var c = this._total_bytes - this._buffer_index;
                    if (c <= 0)
                      throw new d.IllegalStateException("ExpGolomb: _fillCurrentWord() but no bytes available");
                    var m = Math.min(4, c), f = new Uint8Array(4);
                    f.set(this._buffer.subarray(this._buffer_index, this._buffer_index + m)), this._current_word = new DataView(f.buffer).getUint32(0, !1), this._buffer_index += m, this._current_word_bits_left = m * 8;
                  }, u.prototype.readBits = function(c) {
                    if (c > 32)
                      throw new d.InvalidArgumentException("ExpGolomb: readBits() bits exceeded max 32bits!");
                    if (c <= this._current_word_bits_left) {
                      var m = this._current_word >>> 32 - c;
                      return this._current_word <<= c, this._current_word_bits_left -= c, m;
                    }
                    var f = this._current_word_bits_left ? this._current_word : 0;
                    f = f >>> 32 - this._current_word_bits_left;
                    var p = c - this._current_word_bits_left;
                    this._fillCurrentWord();
                    var A = Math.min(p, this._current_word_bits_left), v = this._current_word >>> 32 - A;
                    return this._current_word <<= A, this._current_word_bits_left -= A, f = f << A | v, f;
                  }, u.prototype.readBool = function() {
                    return this.readBits(1) === 1;
                  }, u.prototype.readByte = function() {
                    return this.readBits(8);
                  }, u.prototype._skipLeadingZero = function() {
                    var c;
                    for (c = 0; c < this._current_word_bits_left; c++)
                      if (this._current_word & 2147483648 >>> c)
                        return this._current_word <<= c, this._current_word_bits_left -= c, c;
                    return this._fillCurrentWord(), c + this._skipLeadingZero();
                  }, u.prototype.readUEG = function() {
                    var c = this._skipLeadingZero();
                    return this.readBits(c + 1) - 1;
                  }, u.prototype.readSEG = function() {
                    var c = this.readUEG();
                    return c & 1 ? c + 1 >>> 1 : -1 * (c >>> 1);
                  }, u;
                }()
              );
              a.default = h;
            }
          ),
          /***/
          "./src/demux/flv-demuxer.js": (
            /*!**********************************!*\
              !*** ./src/demux/flv-demuxer.js ***!
              \**********************************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = l(
                /*! ../utils/logger.js */
                "./src/utils/logger.js"
              ), h = l(
                /*! ./amf-parser.js */
                "./src/demux/amf-parser.js"
              ), u = l(
                /*! ./sps-parser.js */
                "./src/demux/sps-parser.js"
              ), c = l(
                /*! ./demux-errors.js */
                "./src/demux/demux-errors.js"
              ), m = l(
                /*! ../core/media-info.js */
                "./src/core/media-info.js"
              ), f = l(
                /*! ../utils/exception.js */
                "./src/utils/exception.js"
              );
              function p(v, b) {
                return v[b] << 24 | v[b + 1] << 16 | v[b + 2] << 8 | v[b + 3];
              }
              var A = (
                /** @class */
                function() {
                  function v(b, _) {
                    this.TAG = "FLVDemuxer", this._config = _, this._onError = null, this._onMediaInfo = null, this._onMetaDataArrived = null, this._onScriptDataArrived = null, this._onTrackMetadata = null, this._onDataAvailable = null, this._dataOffset = b.dataOffset, this._firstParse = !0, this._dispatch = !1, this._hasAudio = b.hasAudioTrack, this._hasVideo = b.hasVideoTrack, this._hasAudioFlagOverrided = !1, this._hasVideoFlagOverrided = !1, this._audioInitialMetadataDispatched = !1, this._videoInitialMetadataDispatched = !1, this._mediaInfo = new m.default(), this._mediaInfo.hasAudio = this._hasAudio, this._mediaInfo.hasVideo = this._hasVideo, this._metadata = null, this._audioMetadata = null, this._videoMetadata = null, this._naluLengthSize = 4, this._timestampBase = 0, this._timescale = 1e3, this._duration = 0, this._durationOverrided = !1, this._referenceFrameRate = {
                      fixed: !0,
                      fps: 23.976,
                      fps_num: 23976,
                      fps_den: 1e3
                    }, this._flvSoundRateTable = [5500, 11025, 22050, 44100, 48e3], this._mpegSamplingRates = [
                      96e3,
                      88200,
                      64e3,
                      48e3,
                      44100,
                      32e3,
                      24e3,
                      22050,
                      16e3,
                      12e3,
                      11025,
                      8e3,
                      7350
                    ], this._mpegAudioV10SampleRateTable = [44100, 48e3, 32e3, 0], this._mpegAudioV20SampleRateTable = [22050, 24e3, 16e3, 0], this._mpegAudioV25SampleRateTable = [11025, 12e3, 8e3, 0], this._mpegAudioL1BitRateTable = [0, 32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448, -1], this._mpegAudioL2BitRateTable = [0, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384, -1], this._mpegAudioL3BitRateTable = [0, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, -1], this._videoTrack = { type: "video", id: 1, sequenceNumber: 0, samples: [], length: 0 }, this._audioTrack = { type: "audio", id: 2, sequenceNumber: 0, samples: [], length: 0 }, this._littleEndian = function() {
                      var T = new ArrayBuffer(2);
                      return new DataView(T).setInt16(0, 256, !0), new Int16Array(T)[0] === 256;
                    }();
                  }
                  return v.prototype.destroy = function() {
                    this._mediaInfo = null, this._metadata = null, this._audioMetadata = null, this._videoMetadata = null, this._videoTrack = null, this._audioTrack = null, this._onError = null, this._onMediaInfo = null, this._onMetaDataArrived = null, this._onScriptDataArrived = null, this._onTrackMetadata = null, this._onDataAvailable = null;
                  }, v.probe = function(b) {
                    var _ = new Uint8Array(b), T = { match: !1 };
                    if (_[0] !== 70 || _[1] !== 76 || _[2] !== 86 || _[3] !== 1)
                      return T;
                    var E = (_[4] & 4) >>> 2 !== 0, L = (_[4] & 1) !== 0, k = p(_, 5);
                    return k < 9 ? T : {
                      match: !0,
                      consumed: k,
                      dataOffset: k,
                      hasAudioTrack: E,
                      hasVideoTrack: L
                    };
                  }, v.prototype.bindDataSource = function(b) {
                    return b.onDataArrival = this.parseChunks.bind(this), this;
                  }, Object.defineProperty(v.prototype, "onTrackMetadata", {
                    // prototype: function(type: string, metadata: any): void
                    get: function() {
                      return this._onTrackMetadata;
                    },
                    set: function(b) {
                      this._onTrackMetadata = b;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(v.prototype, "onMediaInfo", {
                    // prototype: function(mediaInfo: MediaInfo): void
                    get: function() {
                      return this._onMediaInfo;
                    },
                    set: function(b) {
                      this._onMediaInfo = b;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(v.prototype, "onMetaDataArrived", {
                    get: function() {
                      return this._onMetaDataArrived;
                    },
                    set: function(b) {
                      this._onMetaDataArrived = b;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(v.prototype, "onScriptDataArrived", {
                    get: function() {
                      return this._onScriptDataArrived;
                    },
                    set: function(b) {
                      this._onScriptDataArrived = b;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(v.prototype, "onError", {
                    // prototype: function(type: number, info: string): void
                    get: function() {
                      return this._onError;
                    },
                    set: function(b) {
                      this._onError = b;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(v.prototype, "onDataAvailable", {
                    // prototype: function(videoTrack: any, audioTrack: any): void
                    get: function() {
                      return this._onDataAvailable;
                    },
                    set: function(b) {
                      this._onDataAvailable = b;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(v.prototype, "timestampBase", {
                    // timestamp base for output samples, must be in milliseconds
                    get: function() {
                      return this._timestampBase;
                    },
                    set: function(b) {
                      this._timestampBase = b;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(v.prototype, "overridedDuration", {
                    get: function() {
                      return this._duration;
                    },
                    // Force-override media duration. Must be in milliseconds, int32
                    set: function(b) {
                      this._durationOverrided = !0, this._duration = b, this._mediaInfo.duration = b;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(v.prototype, "overridedHasAudio", {
                    // Force-override audio track present flag, boolean
                    set: function(b) {
                      this._hasAudioFlagOverrided = !0, this._hasAudio = b, this._mediaInfo.hasAudio = b;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(v.prototype, "overridedHasVideo", {
                    // Force-override video track present flag, boolean
                    set: function(b) {
                      this._hasVideoFlagOverrided = !0, this._hasVideo = b, this._mediaInfo.hasVideo = b;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), v.prototype.resetMediaInfo = function() {
                    this._mediaInfo = new m.default();
                  }, v.prototype._isInitialMetadataDispatched = function() {
                    return this._hasAudio && this._hasVideo ? this._audioInitialMetadataDispatched && this._videoInitialMetadataDispatched : this._hasAudio && !this._hasVideo ? this._audioInitialMetadataDispatched : !this._hasAudio && this._hasVideo ? this._videoInitialMetadataDispatched : !1;
                  }, v.prototype.parseChunks = function(b, _) {
                    if (!this._onError || !this._onMediaInfo || !this._onTrackMetadata || !this._onDataAvailable)
                      throw new f.IllegalStateException("Flv: onError & onMediaInfo & onTrackMetadata & onDataAvailable callback must be specified");
                    var T = 0, E = this._littleEndian;
                    if (_ === 0)
                      if (b.byteLength > 13) {
                        var L = v.probe(b);
                        T = L.dataOffset;
                      } else
                        return 0;
                    if (this._firstParse) {
                      this._firstParse = !1, _ + T !== this._dataOffset && d.default.w(this.TAG, "First time parsing but chunk byteStart invalid!");
                      var k = new DataView(b, T), D = k.getUint32(0, !E);
                      D !== 0 && d.default.w(this.TAG, "PrevTagSize0 !== 0 !!!"), T += 4;
                    }
                    for (; T < b.byteLength; ) {
                      this._dispatch = !0;
                      var k = new DataView(b, T);
                      if (T + 11 + 4 > b.byteLength)
                        break;
                      var M = k.getUint8(0), O = k.getUint32(0, !E) & 16777215;
                      if (T + 11 + O + 4 > b.byteLength)
                        break;
                      if (M !== 8 && M !== 9 && M !== 18) {
                        d.default.w(this.TAG, "Unsupported tag type " + M + ", skipped"), T += 11 + O + 4;
                        continue;
                      }
                      var N = k.getUint8(4), B = k.getUint8(5), U = k.getUint8(6), G = k.getUint8(7), Y = U | B << 8 | N << 16 | G << 24, z = k.getUint32(7, !E) & 16777215;
                      z !== 0 && d.default.w(this.TAG, "Meet tag which has StreamID != 0!");
                      var J = T + 11;
                      switch (M) {
                        case 8:
                          this._parseAudioData(b, J, O, Y);
                          break;
                        case 9:
                          this._parseVideoData(b, J, O, Y, _ + T);
                          break;
                        case 18:
                          this._parseScriptData(b, J, O);
                          break;
                      }
                      var le = k.getUint32(11 + O, !E);
                      le !== 11 + O && d.default.w(this.TAG, "Invalid PrevTagSize " + le), T += 11 + O + 4;
                    }
                    return this._isInitialMetadataDispatched() && this._dispatch && (this._audioTrack.length || this._videoTrack.length) && this._onDataAvailable(this._audioTrack, this._videoTrack), T;
                  }, v.prototype._parseScriptData = function(b, _, T) {
                    var E = h.default.parseScriptData(b, _, T);
                    if (E.hasOwnProperty("onMetaData")) {
                      if (E.onMetaData == null || typeof E.onMetaData != "object") {
                        d.default.w(this.TAG, "Invalid onMetaData structure!");
                        return;
                      }
                      this._metadata && d.default.w(this.TAG, "Found another onMetaData tag!"), this._metadata = E;
                      var L = this._metadata.onMetaData;
                      if (this._onMetaDataArrived && this._onMetaDataArrived(Object.assign({}, L)), typeof L.hasAudio == "boolean" && this._hasAudioFlagOverrided === !1 && (this._hasAudio = L.hasAudio, this._mediaInfo.hasAudio = this._hasAudio), typeof L.hasVideo == "boolean" && this._hasVideoFlagOverrided === !1 && (this._hasVideo = L.hasVideo, this._mediaInfo.hasVideo = this._hasVideo), typeof L.audiodatarate == "number" && (this._mediaInfo.audioDataRate = L.audiodatarate), typeof L.videodatarate == "number" && (this._mediaInfo.videoDataRate = L.videodatarate), typeof L.width == "number" && (this._mediaInfo.width = L.width), typeof L.height == "number" && (this._mediaInfo.height = L.height), typeof L.duration == "number") {
                        if (!this._durationOverrided) {
                          var k = Math.floor(L.duration * this._timescale);
                          this._duration = k, this._mediaInfo.duration = k;
                        }
                      } else
                        this._mediaInfo.duration = 0;
                      if (typeof L.framerate == "number") {
                        var D = Math.floor(L.framerate * 1e3);
                        if (D > 0) {
                          var M = D / 1e3;
                          this._referenceFrameRate.fixed = !0, this._referenceFrameRate.fps = M, this._referenceFrameRate.fps_num = D, this._referenceFrameRate.fps_den = 1e3, this._mediaInfo.fps = M;
                        }
                      }
                      if (typeof L.keyframes == "object") {
                        this._mediaInfo.hasKeyframesIndex = !0;
                        var O = L.keyframes;
                        this._mediaInfo.keyframesIndex = this._parseKeyframesIndex(O), L.keyframes = null;
                      } else
                        this._mediaInfo.hasKeyframesIndex = !1;
                      this._dispatch = !1, this._mediaInfo.metadata = L, d.default.v(this.TAG, "Parsed onMetaData"), this._mediaInfo.isComplete() && this._onMediaInfo(this._mediaInfo);
                    }
                    Object.keys(E).length > 0 && this._onScriptDataArrived && this._onScriptDataArrived(Object.assign({}, E));
                  }, v.prototype._parseKeyframesIndex = function(b) {
                    for (var _ = [], T = [], E = 1; E < b.times.length; E++) {
                      var L = this._timestampBase + Math.floor(b.times[E] * 1e3);
                      _.push(L), T.push(b.filepositions[E]);
                    }
                    return {
                      times: _,
                      filepositions: T
                    };
                  }, v.prototype._parseAudioData = function(b, _, T, E) {
                    if (T <= 1) {
                      d.default.w(this.TAG, "Flv: Invalid audio packet, missing SoundData payload!");
                      return;
                    }
                    if (!(this._hasAudioFlagOverrided === !0 && this._hasAudio === !1)) {
                      this._littleEndian;
                      var L = new DataView(b, _, T), k = L.getUint8(0), D = k >>> 4;
                      if (D !== 2 && D !== 10) {
                        this._onError(c.default.CODEC_UNSUPPORTED, "Flv: Unsupported audio codec idx: " + D);
                        return;
                      }
                      var M = 0, O = (k & 12) >>> 2;
                      if (O >= 0 && O <= 4)
                        M = this._flvSoundRateTable[O];
                      else {
                        this._onError(c.default.FORMAT_ERROR, "Flv: Invalid audio sample rate idx: " + O);
                        return;
                      }
                      var N = k & 1, B = this._audioMetadata, U = this._audioTrack;
                      if (B || (this._hasAudio === !1 && this._hasAudioFlagOverrided === !1 && (this._hasAudio = !0, this._mediaInfo.hasAudio = !0), B = this._audioMetadata = {}, B.type = "audio", B.id = U.id, B.timescale = this._timescale, B.duration = this._duration, B.audioSampleRate = M, B.channelCount = N === 0 ? 1 : 2), D === 10) {
                        var G = this._parseAACAudioData(b, _ + 1, T - 1);
                        if (G == null)
                          return;
                        if (G.packetType === 0) {
                          B.config && d.default.w(this.TAG, "Found another AudioSpecificConfig!");
                          var Y = G.data;
                          B.audioSampleRate = Y.samplingRate, B.channelCount = Y.channelCount, B.codec = Y.codec, B.originalCodec = Y.originalCodec, B.config = Y.config, B.refSampleDuration = 1024 / B.audioSampleRate * B.timescale, d.default.v(this.TAG, "Parsed AudioSpecificConfig"), this._isInitialMetadataDispatched() ? this._dispatch && (this._audioTrack.length || this._videoTrack.length) && this._onDataAvailable(this._audioTrack, this._videoTrack) : this._audioInitialMetadataDispatched = !0, this._dispatch = !1, this._onTrackMetadata("audio", B);
                          var z = this._mediaInfo;
                          z.audioCodec = B.originalCodec, z.audioSampleRate = B.audioSampleRate, z.audioChannelCount = B.channelCount, z.hasVideo ? z.videoCodec != null && (z.mimeType = 'video/x-flv; codecs="' + z.videoCodec + "," + z.audioCodec + '"') : z.mimeType = 'video/x-flv; codecs="' + z.audioCodec + '"', z.isComplete() && this._onMediaInfo(z);
                        } else if (G.packetType === 1) {
                          var J = this._timestampBase + E, le = { unit: G.data, length: G.data.byteLength, dts: J, pts: J };
                          U.samples.push(le), U.length += G.data.length;
                        } else
                          d.default.e(this.TAG, "Flv: Unsupported AAC data type " + G.packetType);
                      } else if (D === 2) {
                        if (!B.codec) {
                          var Y = this._parseMP3AudioData(b, _ + 1, T - 1, !0);
                          if (Y == null)
                            return;
                          B.audioSampleRate = Y.samplingRate, B.channelCount = Y.channelCount, B.codec = Y.codec, B.originalCodec = Y.originalCodec, B.refSampleDuration = 1152 / B.audioSampleRate * B.timescale, d.default.v(this.TAG, "Parsed MPEG Audio Frame Header"), this._audioInitialMetadataDispatched = !0, this._onTrackMetadata("audio", B);
                          var z = this._mediaInfo;
                          z.audioCodec = B.codec, z.audioSampleRate = B.audioSampleRate, z.audioChannelCount = B.channelCount, z.audioDataRate = Y.bitRate, z.hasVideo ? z.videoCodec != null && (z.mimeType = 'video/x-flv; codecs="' + z.videoCodec + "," + z.audioCodec + '"') : z.mimeType = 'video/x-flv; codecs="' + z.audioCodec + '"', z.isComplete() && this._onMediaInfo(z);
                        }
                        var W = this._parseMP3AudioData(b, _ + 1, T - 1, !1);
                        if (W == null)
                          return;
                        var J = this._timestampBase + E, Z = { unit: W, length: W.byteLength, dts: J, pts: J };
                        U.samples.push(Z), U.length += W.length;
                      }
                    }
                  }, v.prototype._parseAACAudioData = function(b, _, T) {
                    if (T <= 1) {
                      d.default.w(this.TAG, "Flv: Invalid AAC packet, missing AACPacketType or/and Data!");
                      return;
                    }
                    var E = {}, L = new Uint8Array(b, _, T);
                    return E.packetType = L[0], L[0] === 0 ? E.data = this._parseAACAudioSpecificConfig(b, _ + 1, T - 1) : E.data = L.subarray(1), E;
                  }, v.prototype._parseAACAudioSpecificConfig = function(b, _, T) {
                    var E = new Uint8Array(b, _, T), L = null, k = 0, D = 0, M = 0, O = null;
                    if (k = D = E[0] >>> 3, M = (E[0] & 7) << 1 | E[1] >>> 7, M < 0 || M >= this._mpegSamplingRates.length) {
                      this._onError(c.default.FORMAT_ERROR, "Flv: AAC invalid sampling frequency index!");
                      return;
                    }
                    var N = this._mpegSamplingRates[M], B = (E[1] & 120) >>> 3;
                    if (B < 0 || B >= 8) {
                      this._onError(c.default.FORMAT_ERROR, "Flv: AAC invalid channel configuration");
                      return;
                    }
                    k === 5 && (O = (E[1] & 7) << 1 | E[2] >>> 7, (E[2] & 124) >>> 2);
                    var U = self.navigator.userAgent.toLowerCase();
                    return U.indexOf("firefox") !== -1 ? M >= 6 ? (k = 5, L = new Array(4), O = M - 3) : (k = 2, L = new Array(2), O = M) : U.indexOf("android") !== -1 ? (k = 2, L = new Array(2), O = M) : (k = 5, O = M, L = new Array(4), M >= 6 ? O = M - 3 : B === 1 && (k = 2, L = new Array(2), O = M)), L[0] = k << 3, L[0] |= (M & 15) >>> 1, L[1] = (M & 15) << 7, L[1] |= (B & 15) << 3, k === 5 && (L[1] |= (O & 15) >>> 1, L[2] = (O & 1) << 7, L[2] |= 8, L[3] = 0), {
                      config: L,
                      samplingRate: N,
                      channelCount: B,
                      codec: "mp4a.40." + k,
                      originalCodec: "mp4a.40." + D
                    };
                  }, v.prototype._parseMP3AudioData = function(b, _, T, E) {
                    if (T < 4) {
                      d.default.w(this.TAG, "Flv: Invalid MP3 packet, header missing!");
                      return;
                    }
                    this._littleEndian;
                    var L = new Uint8Array(b, _, T), k = null;
                    if (E) {
                      if (L[0] !== 255)
                        return;
                      var D = L[1] >>> 3 & 3, M = (L[1] & 6) >> 1, O = (L[2] & 240) >>> 4, N = (L[2] & 12) >>> 2, B = L[3] >>> 6 & 3, U = B !== 3 ? 2 : 1, G = 0, Y = 0, z = "mp3";
                      switch (D) {
                        case 0:
                          G = this._mpegAudioV25SampleRateTable[N];
                          break;
                        case 2:
                          G = this._mpegAudioV20SampleRateTable[N];
                          break;
                        case 3:
                          G = this._mpegAudioV10SampleRateTable[N];
                          break;
                      }
                      switch (M) {
                        case 1:
                          O < this._mpegAudioL3BitRateTable.length && (Y = this._mpegAudioL3BitRateTable[O]);
                          break;
                        case 2:
                          O < this._mpegAudioL2BitRateTable.length && (Y = this._mpegAudioL2BitRateTable[O]);
                          break;
                        case 3:
                          O < this._mpegAudioL1BitRateTable.length && (Y = this._mpegAudioL1BitRateTable[O]);
                          break;
                      }
                      k = {
                        bitRate: Y,
                        samplingRate: G,
                        channelCount: U,
                        codec: z,
                        originalCodec: z
                      };
                    } else
                      k = L;
                    return k;
                  }, v.prototype._parseVideoData = function(b, _, T, E, L) {
                    if (T <= 1) {
                      d.default.w(this.TAG, "Flv: Invalid video packet, missing VideoData payload!");
                      return;
                    }
                    if (!(this._hasVideoFlagOverrided === !0 && this._hasVideo === !1)) {
                      var k = new Uint8Array(b, _, T)[0], D = (k & 240) >>> 4, M = k & 15;
                      if (M !== 7) {
                        this._onError(c.default.CODEC_UNSUPPORTED, "Flv: Unsupported codec in video frame: " + M);
                        return;
                      }
                      this._parseAVCVideoPacket(b, _ + 1, T - 1, E, L, D);
                    }
                  }, v.prototype._parseAVCVideoPacket = function(b, _, T, E, L, k) {
                    if (T < 4) {
                      d.default.w(this.TAG, "Flv: Invalid AVC packet, missing AVCPacketType or/and CompositionTime");
                      return;
                    }
                    var D = this._littleEndian, M = new DataView(b, _, T), O = M.getUint8(0), N = M.getUint32(0, !D) & 16777215, B = N << 8 >> 8;
                    if (O === 0)
                      this._parseAVCDecoderConfigurationRecord(b, _ + 4, T - 4);
                    else if (O === 1)
                      this._parseAVCVideoData(b, _ + 4, T - 4, E, L, k, B);
                    else if (O !== 2) {
                      this._onError(c.default.FORMAT_ERROR, "Flv: Invalid video packet type " + O);
                      return;
                    }
                  }, v.prototype._parseAVCDecoderConfigurationRecord = function(b, _, T) {
                    if (T < 7) {
                      d.default.w(this.TAG, "Flv: Invalid AVCDecoderConfigurationRecord, lack of data!");
                      return;
                    }
                    var E = this._videoMetadata, L = this._videoTrack, k = this._littleEndian, D = new DataView(b, _, T);
                    E ? typeof E.avcc < "u" && d.default.w(this.TAG, "Found another AVCDecoderConfigurationRecord!") : (this._hasVideo === !1 && this._hasVideoFlagOverrided === !1 && (this._hasVideo = !0, this._mediaInfo.hasVideo = !0), E = this._videoMetadata = {}, E.type = "video", E.id = L.id, E.timescale = this._timescale, E.duration = this._duration);
                    var M = D.getUint8(0), O = D.getUint8(1);
                    if (D.getUint8(2), D.getUint8(3), M !== 1 || O === 0) {
                      this._onError(c.default.FORMAT_ERROR, "Flv: Invalid AVCDecoderConfigurationRecord");
                      return;
                    }
                    if (this._naluLengthSize = (D.getUint8(4) & 3) + 1, this._naluLengthSize !== 3 && this._naluLengthSize !== 4) {
                      this._onError(c.default.FORMAT_ERROR, "Flv: Strange NaluLengthSizeMinusOne: " + (this._naluLengthSize - 1));
                      return;
                    }
                    var N = D.getUint8(5) & 31;
                    if (N === 0) {
                      this._onError(c.default.FORMAT_ERROR, "Flv: Invalid AVCDecoderConfigurationRecord: No SPS");
                      return;
                    } else
                      N > 1 && d.default.w(this.TAG, "Flv: Strange AVCDecoderConfigurationRecord: SPS Count = " + N);
                    for (var B = 6, U = 0; U < N; U++) {
                      var G = D.getUint16(B, !k);
                      if (B += 2, G !== 0) {
                        var Y = new Uint8Array(b, _ + B, G);
                        B += G;
                        var z = u.default.parseSPS(Y);
                        if (U === 0) {
                          E.codecWidth = z.codec_size.width, E.codecHeight = z.codec_size.height, E.presentWidth = z.present_size.width, E.presentHeight = z.present_size.height, E.profile = z.profile_string, E.level = z.level_string, E.bitDepth = z.bit_depth, E.chromaFormat = z.chroma_format, E.sarRatio = z.sar_ratio, E.frameRate = z.frame_rate, (z.frame_rate.fixed === !1 || z.frame_rate.fps_num === 0 || z.frame_rate.fps_den === 0) && (E.frameRate = this._referenceFrameRate);
                          var J = E.frameRate.fps_den, le = E.frameRate.fps_num;
                          E.refSampleDuration = E.timescale * (J / le);
                          for (var W = Y.subarray(1, 4), Z = "avc1.", ce = 0; ce < 3; ce++) {
                            var ue = W[ce].toString(16);
                            ue.length < 2 && (ue = "0" + ue), Z += ue;
                          }
                          E.codec = Z;
                          var re = this._mediaInfo;
                          re.width = E.codecWidth, re.height = E.codecHeight, re.fps = E.frameRate.fps, re.profile = E.profile, re.level = E.level, re.refFrames = z.ref_frames, re.chromaFormat = z.chroma_format_string, re.sarNum = E.sarRatio.width, re.sarDen = E.sarRatio.height, re.videoCodec = Z, re.hasAudio ? re.audioCodec != null && (re.mimeType = 'video/x-flv; codecs="' + re.videoCodec + "," + re.audioCodec + '"') : re.mimeType = 'video/x-flv; codecs="' + re.videoCodec + '"', re.isComplete() && this._onMediaInfo(re);
                        }
                      }
                    }
                    var me = D.getUint8(B);
                    if (me === 0) {
                      this._onError(c.default.FORMAT_ERROR, "Flv: Invalid AVCDecoderConfigurationRecord: No PPS");
                      return;
                    } else
                      me > 1 && d.default.w(this.TAG, "Flv: Strange AVCDecoderConfigurationRecord: PPS Count = " + me);
                    B++;
                    for (var U = 0; U < me; U++) {
                      var G = D.getUint16(B, !k);
                      B += 2, G !== 0 && (B += G);
                    }
                    E.avcc = new Uint8Array(T), E.avcc.set(new Uint8Array(b, _, T), 0), d.default.v(this.TAG, "Parsed AVCDecoderConfigurationRecord"), this._isInitialMetadataDispatched() ? this._dispatch && (this._audioTrack.length || this._videoTrack.length) && this._onDataAvailable(this._audioTrack, this._videoTrack) : this._videoInitialMetadataDispatched = !0, this._dispatch = !1, this._onTrackMetadata("video", E);
                  }, v.prototype._parseAVCVideoData = function(b, _, T, E, L, k, D) {
                    for (var M = this._littleEndian, O = new DataView(b, _, T), N = [], B = 0, U = 0, G = this._naluLengthSize, Y = this._timestampBase + E, z = k === 1; U < T; ) {
                      if (U + 4 >= T) {
                        d.default.w(this.TAG, "Malformed Nalu near timestamp " + Y + ", offset = " + U + ", dataSize = " + T);
                        break;
                      }
                      var J = O.getUint32(U, !M);
                      if (G === 3 && (J >>>= 8), J > T - G) {
                        d.default.w(this.TAG, "Malformed Nalus near timestamp " + Y + ", NaluSize > DataSize!");
                        return;
                      }
                      var le = O.getUint8(U + G) & 31;
                      le === 5 && (z = !0);
                      var W = new Uint8Array(b, _ + U, G + J), Z = { type: le, data: W };
                      N.push(Z), B += W.byteLength, U += G + J;
                    }
                    if (N.length) {
                      var ce = this._videoTrack, ue = {
                        units: N,
                        length: B,
                        isKeyframe: z,
                        dts: Y,
                        cts: D,
                        pts: Y + D
                      };
                      z && (ue.fileposition = L), ce.samples.push(ue), ce.length += B;
                    }
                  }, v;
                }()
              );
              a.default = A;
            }
          ),
          /***/
          "./src/demux/sps-parser.js": (
            /*!*********************************!*\
              !*** ./src/demux/sps-parser.js ***!
              \*********************************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = l(
                /*! ./exp-golomb.js */
                "./src/demux/exp-golomb.js"
              ), h = (
                /** @class */
                function() {
                  function u() {
                  }
                  return u._ebsp2rbsp = function(c) {
                    for (var m = c, f = m.byteLength, p = new Uint8Array(f), A = 0, v = 0; v < f; v++)
                      v >= 2 && m[v] === 3 && m[v - 1] === 0 && m[v - 2] === 0 || (p[A] = m[v], A++);
                    return new Uint8Array(p.buffer, 0, A);
                  }, u.parseSPS = function(c) {
                    var m = u._ebsp2rbsp(c), f = new d.default(m);
                    f.readByte();
                    var p = f.readByte();
                    f.readByte();
                    var A = f.readByte();
                    f.readUEG();
                    var v = u.getProfileString(p), b = u.getLevelString(A), _ = 1, T = 420, E = [0, 420, 422, 444], L = 8;
                    if ((p === 100 || p === 110 || p === 122 || p === 244 || p === 44 || p === 83 || p === 86 || p === 118 || p === 128 || p === 138 || p === 144) && (_ = f.readUEG(), _ === 3 && f.readBits(1), _ <= 3 && (T = E[_]), L = f.readUEG() + 8, f.readUEG(), f.readBits(1), f.readBool()))
                      for (var k = _ !== 3 ? 8 : 12, D = 0; D < k; D++)
                        f.readBool() && (D < 6 ? u._skipScalingList(f, 16) : u._skipScalingList(f, 64));
                    f.readUEG();
                    var M = f.readUEG();
                    if (M === 0)
                      f.readUEG();
                    else if (M === 1) {
                      f.readBits(1), f.readSEG(), f.readSEG();
                      for (var O = f.readUEG(), D = 0; D < O; D++)
                        f.readSEG();
                    }
                    var N = f.readUEG();
                    f.readBits(1);
                    var B = f.readUEG(), U = f.readUEG(), G = f.readBits(1);
                    G === 0 && f.readBits(1), f.readBits(1);
                    var Y = 0, z = 0, J = 0, le = 0, W = f.readBool();
                    W && (Y = f.readUEG(), z = f.readUEG(), J = f.readUEG(), le = f.readUEG());
                    var Z = 1, ce = 1, ue = 0, re = !0, me = 0, Be = 0, ye = f.readBool();
                    if (ye) {
                      if (f.readBool()) {
                        var Le = f.readByte(), Pe = [1, 12, 10, 16, 40, 24, 20, 32, 80, 18, 15, 64, 160, 4, 3, 2], Me = [1, 11, 11, 11, 33, 11, 11, 11, 33, 11, 11, 33, 99, 3, 2, 1];
                        Le > 0 && Le < 16 ? (Z = Pe[Le - 1], ce = Me[Le - 1]) : Le === 255 && (Z = f.readByte() << 8 | f.readByte(), ce = f.readByte() << 8 | f.readByte());
                      }
                      if (f.readBool() && f.readBool(), f.readBool() && (f.readBits(4), f.readBool() && f.readBits(24)), f.readBool() && (f.readUEG(), f.readUEG()), f.readBool()) {
                        var qe = f.readBits(32), ft = f.readBits(32);
                        re = f.readBool(), me = ft, Be = qe * 2, ue = me / Be;
                      }
                    }
                    var De = 1;
                    (Z !== 1 || ce !== 1) && (De = Z / ce);
                    var ve = 0, Je = 0;
                    if (_ === 0)
                      ve = 1, Je = 2 - G;
                    else {
                      var Xe = _ === 3 ? 1 : 2, Oe = _ === 1 ? 2 : 1;
                      ve = Xe, Je = Oe * (2 - G);
                    }
                    var Ke = (B + 1) * 16, We = (2 - G) * ((U + 1) * 16);
                    Ke -= (Y + z) * ve, We -= (J + le) * Je;
                    var tt = Math.ceil(Ke * De);
                    return f.destroy(), f = null, {
                      profile_string: v,
                      level_string: b,
                      bit_depth: L,
                      ref_frames: N,
                      chroma_format: T,
                      chroma_format_string: u.getChromaFormatString(T),
                      frame_rate: {
                        fixed: re,
                        fps: ue,
                        fps_den: Be,
                        fps_num: me
                      },
                      sar_ratio: {
                        width: Z,
                        height: ce
                      },
                      codec_size: {
                        width: Ke,
                        height: We
                      },
                      present_size: {
                        width: tt,
                        height: We
                      }
                    };
                  }, u._skipScalingList = function(c, m) {
                    for (var f = 8, p = 8, A = 0, v = 0; v < m; v++)
                      p !== 0 && (A = c.readSEG(), p = (f + A + 256) % 256), f = p === 0 ? f : p;
                  }, u.getProfileString = function(c) {
                    switch (c) {
                      case 66:
                        return "Baseline";
                      case 77:
                        return "Main";
                      case 88:
                        return "Extended";
                      case 100:
                        return "High";
                      case 110:
                        return "High10";
                      case 122:
                        return "High422";
                      case 244:
                        return "High444";
                      default:
                        return "Unknown";
                    }
                  }, u.getLevelString = function(c) {
                    return (c / 10).toFixed(1);
                  }, u.getChromaFormatString = function(c) {
                    switch (c) {
                      case 420:
                        return "4:2:0";
                      case 422:
                        return "4:2:2";
                      case 444:
                        return "4:4:4";
                      default:
                        return "Unknown";
                    }
                  }, u;
                }()
              );
              a.default = h;
            }
          ),
          /***/
          "./src/flv.js": (
            /*!********************!*\
              !*** ./src/flv.js ***!
              \********************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = l(
                /*! ./utils/polyfill.js */
                "./src/utils/polyfill.js"
              ), h = l(
                /*! ./core/features.js */
                "./src/core/features.js"
              ), u = l(
                /*! ./io/loader.js */
                "./src/io/loader.js"
              ), c = l(
                /*! ./player/flv-player.js */
                "./src/player/flv-player.js"
              ), m = l(
                /*! ./player/native-player.js */
                "./src/player/native-player.js"
              ), f = l(
                /*! ./player/player-events.js */
                "./src/player/player-events.js"
              ), p = l(
                /*! ./player/player-errors.js */
                "./src/player/player-errors.js"
              ), A = l(
                /*! ./utils/logging-control.js */
                "./src/utils/logging-control.js"
              ), v = l(
                /*! ./utils/exception.js */
                "./src/utils/exception.js"
              );
              d.default.install();
              function b(L, k) {
                var D = L;
                if (D == null || typeof D != "object")
                  throw new v.InvalidArgumentException("MediaDataSource must be an javascript object!");
                if (!D.hasOwnProperty("type"))
                  throw new v.InvalidArgumentException("MediaDataSource must has type field to indicate video file type!");
                switch (D.type) {
                  case "flv":
                    return new c.default(D, k);
                  default:
                    return new m.default(D, k);
                }
              }
              function _() {
                return h.default.supportMSEH264Playback();
              }
              function T() {
                return h.default.getFeatureList();
              }
              var E = {};
              E.createPlayer = b, E.isSupported = _, E.getFeatureList = T, E.BaseLoader = u.BaseLoader, E.LoaderStatus = u.LoaderStatus, E.LoaderErrors = u.LoaderErrors, E.Events = f.default, E.ErrorTypes = p.ErrorTypes, E.ErrorDetails = p.ErrorDetails, E.FlvPlayer = c.default, E.NativePlayer = m.default, E.LoggingControl = A.default, Object.defineProperty(E, "version", {
                enumerable: !0,
                get: function() {
                  return "1.6.2";
                }
              }), a.default = E;
            }
          ),
          /***/
          "./src/index.js": (
            /*!**********************!*\
              !*** ./src/index.js ***!
              \**********************/
            /***/
            function(s, a, l) {
              s.exports = l(
                /*! ./flv.js */
                "./src/flv.js"
              ).default;
            }
          ),
          /***/
          "./src/io/fetch-stream-loader.js": (
            /*!***************************************!*\
              !*** ./src/io/fetch-stream-loader.js ***!
              \***************************************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = l(
                /*! ../utils/browser.js */
                "./src/utils/browser.js"
              ), h = l(
                /*! ./loader.js */
                "./src/io/loader.js"
              ), u = l(
                /*! ../utils/exception.js */
                "./src/utils/exception.js"
              ), c = function() {
                var f = function(p, A) {
                  return f = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(v, b) {
                    v.__proto__ = b;
                  } || function(v, b) {
                    for (var _ in b)
                      Object.prototype.hasOwnProperty.call(b, _) && (v[_] = b[_]);
                  }, f(p, A);
                };
                return function(p, A) {
                  if (typeof A != "function" && A !== null)
                    throw new TypeError("Class extends value " + String(A) + " is not a constructor or null");
                  f(p, A);
                  function v() {
                    this.constructor = p;
                  }
                  p.prototype = A === null ? Object.create(A) : (v.prototype = A.prototype, new v());
                };
              }(), m = (
                /** @class */
                function(f) {
                  c(p, f);
                  function p(A, v) {
                    var b = f.call(this, "fetch-stream-loader") || this;
                    return b.TAG = "FetchStreamLoader", b._seekHandler = A, b._config = v, b._needStash = !0, b._requestAbort = !1, b._contentLength = null, b._receivedLength = 0, b;
                  }
                  return p.isSupported = function() {
                    try {
                      var A = d.default.msedge && d.default.version.minor >= 15048, v = d.default.msedge ? A : !0;
                      return self.fetch && self.ReadableStream && v;
                    } catch {
                      return !1;
                    }
                  }, p.prototype.destroy = function() {
                    this.isWorking() && this.abort(), f.prototype.destroy.call(this);
                  }, p.prototype.open = function(A, v) {
                    var b = this;
                    this._dataSource = A, this._range = v;
                    var _ = A.url;
                    this._config.reuseRedirectedURL && A.redirectedURL != null && (_ = A.redirectedURL);
                    var T = this._seekHandler.getConfig(_, v), E = new self.Headers();
                    if (typeof T.headers == "object") {
                      var L = T.headers;
                      for (var k in L)
                        L.hasOwnProperty(k) && E.append(k, L[k]);
                    }
                    var D = {
                      method: "GET",
                      headers: E,
                      mode: "cors",
                      cache: "default",
                      // The default policy of Fetch API in the whatwg standard
                      // Safari incorrectly indicates 'no-referrer' as default policy, fuck it
                      referrerPolicy: "no-referrer-when-downgrade"
                    };
                    if (typeof this._config.headers == "object")
                      for (var k in this._config.headers)
                        E.append(k, this._config.headers[k]);
                    A.cors === !1 && (D.mode = "same-origin"), A.withCredentials && (D.credentials = "include"), A.referrerPolicy && (D.referrerPolicy = A.referrerPolicy), self.AbortController && (this._abortController = new self.AbortController(), D.signal = this._abortController.signal), this._status = h.LoaderStatus.kConnecting, self.fetch(T.url, D).then(function(M) {
                      if (b._requestAbort) {
                        b._status = h.LoaderStatus.kIdle, M.body.cancel();
                        return;
                      }
                      if (M.ok && M.status >= 200 && M.status <= 299) {
                        if (M.url !== T.url && b._onURLRedirect) {
                          var O = b._seekHandler.removeURLParameters(M.url);
                          b._onURLRedirect(O);
                        }
                        var N = M.headers.get("Content-Length");
                        return N != null && (b._contentLength = parseInt(N), b._contentLength !== 0 && b._onContentLengthKnown && b._onContentLengthKnown(b._contentLength)), b._pump.call(b, M.body.getReader());
                      } else if (b._status = h.LoaderStatus.kError, b._onError)
                        b._onError(h.LoaderErrors.HTTP_STATUS_CODE_INVALID, { code: M.status, msg: M.statusText });
                      else
                        throw new u.RuntimeException("FetchStreamLoader: Http code invalid, " + M.status + " " + M.statusText);
                    }).catch(function(M) {
                      if (!(b._abortController && b._abortController.signal.aborted))
                        if (b._status = h.LoaderStatus.kError, b._onError)
                          b._onError(h.LoaderErrors.EXCEPTION, { code: -1, msg: M.message });
                        else
                          throw M;
                    });
                  }, p.prototype.abort = function() {
                    if (this._requestAbort = !0, (this._status !== h.LoaderStatus.kBuffering || !d.default.chrome) && this._abortController)
                      try {
                        this._abortController.abort();
                      } catch {
                      }
                  }, p.prototype._pump = function(A) {
                    var v = this;
                    return A.read().then(function(b) {
                      if (b.done)
                        if (v._contentLength !== null && v._receivedLength < v._contentLength) {
                          v._status = h.LoaderStatus.kError;
                          var _ = h.LoaderErrors.EARLY_EOF, T = { code: -1, msg: "Fetch stream meet Early-EOF" };
                          if (v._onError)
                            v._onError(_, T);
                          else
                            throw new u.RuntimeException(T.msg);
                        } else
                          v._status = h.LoaderStatus.kComplete, v._onComplete && v._onComplete(v._range.from, v._range.from + v._receivedLength - 1);
                      else {
                        if (v._abortController && v._abortController.signal.aborted) {
                          v._status = h.LoaderStatus.kComplete;
                          return;
                        } else if (v._requestAbort === !0)
                          return v._status = h.LoaderStatus.kComplete, A.cancel();
                        v._status = h.LoaderStatus.kBuffering;
                        var E = b.value.buffer, L = v._range.from + v._receivedLength;
                        v._receivedLength += E.byteLength, v._onDataArrival && v._onDataArrival(E, L, v._receivedLength), v._pump(A);
                      }
                    }).catch(function(b) {
                      if (v._abortController && v._abortController.signal.aborted) {
                        v._status = h.LoaderStatus.kComplete;
                        return;
                      }
                      if (!(b.code === 11 && d.default.msedge)) {
                        v._status = h.LoaderStatus.kError;
                        var _ = 0, T = null;
                        if ((b.code === 19 || b.message === "network error") && // NETWORK_ERR
                        (v._contentLength === null || v._contentLength !== null && v._receivedLength < v._contentLength) ? (_ = h.LoaderErrors.EARLY_EOF, T = { code: b.code, msg: "Fetch stream meet Early-EOF" }) : (_ = h.LoaderErrors.EXCEPTION, T = { code: b.code, msg: b.message }), v._onError)
                          v._onError(_, T);
                        else
                          throw new u.RuntimeException(T.msg);
                      }
                    });
                  }, p;
                }(h.BaseLoader)
              );
              a.default = m;
            }
          ),
          /***/
          "./src/io/io-controller.js": (
            /*!*********************************!*\
              !*** ./src/io/io-controller.js ***!
              \*********************************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = l(
                /*! ../utils/logger.js */
                "./src/utils/logger.js"
              ), h = l(
                /*! ./speed-sampler.js */
                "./src/io/speed-sampler.js"
              ), u = l(
                /*! ./loader.js */
                "./src/io/loader.js"
              ), c = l(
                /*! ./fetch-stream-loader.js */
                "./src/io/fetch-stream-loader.js"
              ), m = l(
                /*! ./xhr-moz-chunked-loader.js */
                "./src/io/xhr-moz-chunked-loader.js"
              ), f = l(
                /*! ./xhr-range-loader.js */
                "./src/io/xhr-range-loader.js"
              ), p = l(
                /*! ./websocket-loader.js */
                "./src/io/websocket-loader.js"
              ), A = l(
                /*! ./range-seek-handler.js */
                "./src/io/range-seek-handler.js"
              ), v = l(
                /*! ./param-seek-handler.js */
                "./src/io/param-seek-handler.js"
              ), b = l(
                /*! ../utils/exception.js */
                "./src/utils/exception.js"
              ), _ = (
                /** @class */
                function() {
                  function T(E, L, k) {
                    this.TAG = "IOController", this._config = L, this._extraData = k, this._stashInitialSize = 1024 * 384, L.stashInitialSize != null && L.stashInitialSize > 0 && (this._stashInitialSize = L.stashInitialSize), this._stashUsed = 0, this._stashSize = this._stashInitialSize, this._bufferSize = 1024 * 1024 * 3, this._stashBuffer = new ArrayBuffer(this._bufferSize), this._stashByteStart = 0, this._enableStash = !0, L.enableStashBuffer === !1 && (this._enableStash = !1), this._loader = null, this._loaderClass = null, this._seekHandler = null, this._dataSource = E, this._isWebSocketURL = /wss?:\/\/(.+?)/.test(E.url), this._refTotalLength = E.filesize ? E.filesize : null, this._totalLength = this._refTotalLength, this._fullRequestFlag = !1, this._currentRange = null, this._redirectedURL = null, this._speedNormalized = 0, this._speedSampler = new h.default(), this._speedNormalizeList = [64, 128, 256, 384, 512, 768, 1024, 1536, 2048, 3072, 4096], this._isEarlyEofReconnecting = !1, this._paused = !1, this._resumeFrom = 0, this._onDataArrival = null, this._onSeeked = null, this._onError = null, this._onComplete = null, this._onRedirect = null, this._onRecoveredEarlyEof = null, this._selectSeekHandler(), this._selectLoader(), this._createLoader();
                  }
                  return T.prototype.destroy = function() {
                    this._loader.isWorking() && this._loader.abort(), this._loader.destroy(), this._loader = null, this._loaderClass = null, this._dataSource = null, this._stashBuffer = null, this._stashUsed = this._stashSize = this._bufferSize = this._stashByteStart = 0, this._currentRange = null, this._speedSampler = null, this._isEarlyEofReconnecting = !1, this._onDataArrival = null, this._onSeeked = null, this._onError = null, this._onComplete = null, this._onRedirect = null, this._onRecoveredEarlyEof = null, this._extraData = null;
                  }, T.prototype.isWorking = function() {
                    return this._loader && this._loader.isWorking() && !this._paused;
                  }, T.prototype.isPaused = function() {
                    return this._paused;
                  }, Object.defineProperty(T.prototype, "status", {
                    get: function() {
                      return this._loader.status;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(T.prototype, "extraData", {
                    get: function() {
                      return this._extraData;
                    },
                    set: function(E) {
                      this._extraData = E;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(T.prototype, "onDataArrival", {
                    // prototype: function onDataArrival(chunks: ArrayBuffer, byteStart: number): number
                    get: function() {
                      return this._onDataArrival;
                    },
                    set: function(E) {
                      this._onDataArrival = E;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(T.prototype, "onSeeked", {
                    get: function() {
                      return this._onSeeked;
                    },
                    set: function(E) {
                      this._onSeeked = E;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(T.prototype, "onError", {
                    // prototype: function onError(type: number, info: {code: number, msg: string}): void
                    get: function() {
                      return this._onError;
                    },
                    set: function(E) {
                      this._onError = E;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(T.prototype, "onComplete", {
                    get: function() {
                      return this._onComplete;
                    },
                    set: function(E) {
                      this._onComplete = E;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(T.prototype, "onRedirect", {
                    get: function() {
                      return this._onRedirect;
                    },
                    set: function(E) {
                      this._onRedirect = E;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(T.prototype, "onRecoveredEarlyEof", {
                    get: function() {
                      return this._onRecoveredEarlyEof;
                    },
                    set: function(E) {
                      this._onRecoveredEarlyEof = E;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(T.prototype, "currentURL", {
                    get: function() {
                      return this._dataSource.url;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(T.prototype, "hasRedirect", {
                    get: function() {
                      return this._redirectedURL != null || this._dataSource.redirectedURL != null;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(T.prototype, "currentRedirectedURL", {
                    get: function() {
                      return this._redirectedURL || this._dataSource.redirectedURL;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(T.prototype, "currentSpeed", {
                    // in KB/s
                    get: function() {
                      return this._loaderClass === f.default ? this._loader.currentSpeed : this._speedSampler.lastSecondKBps;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(T.prototype, "loaderType", {
                    get: function() {
                      return this._loader.type;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), T.prototype._selectSeekHandler = function() {
                    var E = this._config;
                    if (E.seekType === "range")
                      this._seekHandler = new A.default(this._config.rangeLoadZeroStart);
                    else if (E.seekType === "param") {
                      var L = E.seekParamStart || "bstart", k = E.seekParamEnd || "bend";
                      this._seekHandler = new v.default(L, k);
                    } else if (E.seekType === "custom") {
                      if (typeof E.customSeekHandler != "function")
                        throw new b.InvalidArgumentException("Custom seekType specified in config but invalid customSeekHandler!");
                      this._seekHandler = new E.customSeekHandler();
                    } else
                      throw new b.InvalidArgumentException("Invalid seekType in config: " + E.seekType);
                  }, T.prototype._selectLoader = function() {
                    if (this._config.customLoader != null)
                      this._loaderClass = this._config.customLoader;
                    else if (this._isWebSocketURL)
                      this._loaderClass = p.default;
                    else if (c.default.isSupported())
                      this._loaderClass = c.default;
                    else if (m.default.isSupported())
                      this._loaderClass = m.default;
                    else if (f.default.isSupported())
                      this._loaderClass = f.default;
                    else
                      throw new b.RuntimeException("Your browser doesn't support xhr with arraybuffer responseType!");
                  }, T.prototype._createLoader = function() {
                    this._loader = new this._loaderClass(this._seekHandler, this._config), this._loader.needStashBuffer === !1 && (this._enableStash = !1), this._loader.onContentLengthKnown = this._onContentLengthKnown.bind(this), this._loader.onURLRedirect = this._onURLRedirect.bind(this), this._loader.onDataArrival = this._onLoaderChunkArrival.bind(this), this._loader.onComplete = this._onLoaderComplete.bind(this), this._loader.onError = this._onLoaderError.bind(this);
                  }, T.prototype.open = function(E) {
                    this._currentRange = { from: 0, to: -1 }, E && (this._currentRange.from = E), this._speedSampler.reset(), E || (this._fullRequestFlag = !0), this._loader.open(this._dataSource, Object.assign({}, this._currentRange));
                  }, T.prototype.abort = function() {
                    this._loader.abort(), this._paused && (this._paused = !1, this._resumeFrom = 0);
                  }, T.prototype.pause = function() {
                    this.isWorking() && (this._loader.abort(), this._stashUsed !== 0 ? (this._resumeFrom = this._stashByteStart, this._currentRange.to = this._stashByteStart - 1) : this._resumeFrom = this._currentRange.to + 1, this._stashUsed = 0, this._stashByteStart = 0, this._paused = !0);
                  }, T.prototype.resume = function() {
                    if (this._paused) {
                      this._paused = !1;
                      var E = this._resumeFrom;
                      this._resumeFrom = 0, this._internalSeek(E, !0);
                    }
                  }, T.prototype.seek = function(E) {
                    this._paused = !1, this._stashUsed = 0, this._stashByteStart = 0, this._internalSeek(E, !0);
                  }, T.prototype._internalSeek = function(E, L) {
                    this._loader.isWorking() && this._loader.abort(), this._flushStashBuffer(L), this._loader.destroy(), this._loader = null;
                    var k = { from: E, to: -1 };
                    this._currentRange = { from: k.from, to: -1 }, this._speedSampler.reset(), this._stashSize = this._stashInitialSize, this._createLoader(), this._loader.open(this._dataSource, k), this._onSeeked && this._onSeeked();
                  }, T.prototype.updateUrl = function(E) {
                    if (!E || typeof E != "string" || E.length === 0)
                      throw new b.InvalidArgumentException("Url must be a non-empty string!");
                    this._dataSource.url = E;
                  }, T.prototype._expandBuffer = function(E) {
                    for (var L = this._stashSize; L + 1024 * 1024 * 1 < E; )
                      L *= 2;
                    if (L += 1024 * 1024 * 1, L !== this._bufferSize) {
                      var k = new ArrayBuffer(L);
                      if (this._stashUsed > 0) {
                        var D = new Uint8Array(this._stashBuffer, 0, this._stashUsed), M = new Uint8Array(k, 0, L);
                        M.set(D, 0);
                      }
                      this._stashBuffer = k, this._bufferSize = L;
                    }
                  }, T.prototype._normalizeSpeed = function(E) {
                    var L = this._speedNormalizeList, k = L.length - 1, D = 0, M = 0, O = k;
                    if (E < L[0])
                      return L[0];
                    for (; M <= O; ) {
                      if (D = M + Math.floor((O - M) / 2), D === k || E >= L[D] && E < L[D + 1])
                        return L[D];
                      L[D] < E ? M = D + 1 : O = D - 1;
                    }
                  }, T.prototype._adjustStashSize = function(E) {
                    var L = 0;
                    this._config.isLive || E < 512 ? L = E : E >= 512 && E <= 1024 ? L = Math.floor(E * 1.5) : L = E * 2, L > 8192 && (L = 8192);
                    var k = L * 1024 + 1024 * 1024 * 1;
                    this._bufferSize < k && this._expandBuffer(k), this._stashSize = L * 1024;
                  }, T.prototype._dispatchChunks = function(E, L) {
                    return this._currentRange.to = L + E.byteLength - 1, this._onDataArrival(E, L);
                  }, T.prototype._onURLRedirect = function(E) {
                    this._redirectedURL = E, this._onRedirect && this._onRedirect(E);
                  }, T.prototype._onContentLengthKnown = function(E) {
                    E && this._fullRequestFlag && (this._totalLength = E, this._fullRequestFlag = !1);
                  }, T.prototype._onLoaderChunkArrival = function(E, L, k) {
                    if (!this._onDataArrival)
                      throw new b.IllegalStateException("IOController: No existing consumer (onDataArrival) callback!");
                    if (!this._paused) {
                      this._isEarlyEofReconnecting && (this._isEarlyEofReconnecting = !1, this._onRecoveredEarlyEof && this._onRecoveredEarlyEof()), this._speedSampler.addBytes(E.byteLength);
                      var D = this._speedSampler.lastSecondKBps;
                      if (D !== 0) {
                        var M = this._normalizeSpeed(D);
                        this._speedNormalized !== M && (this._speedNormalized = M, this._adjustStashSize(M));
                      }
                      if (this._enableStash)
                        if (this._stashUsed === 0 && this._stashByteStart === 0 && (this._stashByteStart = L), this._stashUsed + E.byteLength <= this._stashSize) {
                          var B = new Uint8Array(this._stashBuffer, 0, this._stashSize);
                          B.set(new Uint8Array(E), this._stashUsed), this._stashUsed += E.byteLength;
                        } else {
                          var B = new Uint8Array(this._stashBuffer, 0, this._bufferSize);
                          if (this._stashUsed > 0) {
                            var G = this._stashBuffer.slice(0, this._stashUsed), O = this._dispatchChunks(G, this._stashByteStart);
                            if (O < G.byteLength) {
                              if (O > 0) {
                                var U = new Uint8Array(G, O);
                                B.set(U, 0), this._stashUsed = U.byteLength, this._stashByteStart += O;
                              }
                            } else
                              this._stashUsed = 0, this._stashByteStart += O;
                            this._stashUsed + E.byteLength > this._bufferSize && (this._expandBuffer(this._stashUsed + E.byteLength), B = new Uint8Array(this._stashBuffer, 0, this._bufferSize)), B.set(new Uint8Array(E), this._stashUsed), this._stashUsed += E.byteLength;
                          } else {
                            var O = this._dispatchChunks(E, L);
                            if (O < E.byteLength) {
                              var N = E.byteLength - O;
                              N > this._bufferSize && (this._expandBuffer(N), B = new Uint8Array(this._stashBuffer, 0, this._bufferSize)), B.set(new Uint8Array(E, O), 0), this._stashUsed += N, this._stashByteStart = L + O;
                            }
                          }
                        }
                      else if (this._stashUsed === 0) {
                        var O = this._dispatchChunks(E, L);
                        if (O < E.byteLength) {
                          var N = E.byteLength - O;
                          N > this._bufferSize && this._expandBuffer(N);
                          var B = new Uint8Array(this._stashBuffer, 0, this._bufferSize);
                          B.set(new Uint8Array(E, O), 0), this._stashUsed += N, this._stashByteStart = L + O;
                        }
                      } else {
                        this._stashUsed + E.byteLength > this._bufferSize && this._expandBuffer(this._stashUsed + E.byteLength);
                        var B = new Uint8Array(this._stashBuffer, 0, this._bufferSize);
                        B.set(new Uint8Array(E), this._stashUsed), this._stashUsed += E.byteLength;
                        var O = this._dispatchChunks(this._stashBuffer.slice(0, this._stashUsed), this._stashByteStart);
                        if (O < this._stashUsed && O > 0) {
                          var U = new Uint8Array(this._stashBuffer, O);
                          B.set(U, 0);
                        }
                        this._stashUsed -= O, this._stashByteStart += O;
                      }
                    }
                  }, T.prototype._flushStashBuffer = function(E) {
                    if (this._stashUsed > 0) {
                      var L = this._stashBuffer.slice(0, this._stashUsed), k = this._dispatchChunks(L, this._stashByteStart), D = L.byteLength - k;
                      if (k < L.byteLength)
                        if (E)
                          d.default.w(this.TAG, D + " bytes unconsumed data remain when flush buffer, dropped");
                        else {
                          if (k > 0) {
                            var M = new Uint8Array(this._stashBuffer, 0, this._bufferSize), O = new Uint8Array(L, k);
                            M.set(O, 0), this._stashUsed = O.byteLength, this._stashByteStart += k;
                          }
                          return 0;
                        }
                      return this._stashUsed = 0, this._stashByteStart = 0, D;
                    }
                    return 0;
                  }, T.prototype._onLoaderComplete = function(E, L) {
                    this._flushStashBuffer(!0), this._onComplete && this._onComplete(this._extraData);
                  }, T.prototype._onLoaderError = function(E, L) {
                    switch (d.default.e(this.TAG, "Loader error, code = " + L.code + ", msg = " + L.msg), this._flushStashBuffer(!1), this._isEarlyEofReconnecting && (this._isEarlyEofReconnecting = !1, E = u.LoaderErrors.UNRECOVERABLE_EARLY_EOF), E) {
                      case u.LoaderErrors.EARLY_EOF: {
                        if (!this._config.isLive && this._totalLength) {
                          var k = this._currentRange.to + 1;
                          k < this._totalLength && (d.default.w(this.TAG, "Connection lost, trying reconnect..."), this._isEarlyEofReconnecting = !0, this._internalSeek(k, !1));
                          return;
                        }
                        E = u.LoaderErrors.UNRECOVERABLE_EARLY_EOF;
                        break;
                      }
                      case u.LoaderErrors.UNRECOVERABLE_EARLY_EOF:
                      case u.LoaderErrors.CONNECTING_TIMEOUT:
                      case u.LoaderErrors.HTTP_STATUS_CODE_INVALID:
                      case u.LoaderErrors.EXCEPTION:
                        break;
                    }
                    if (this._onError)
                      this._onError(E, L);
                    else
                      throw new b.RuntimeException("IOException: " + L.msg);
                  }, T;
                }()
              );
              a.default = _;
            }
          ),
          /***/
          "./src/io/loader.js": (
            /*!**************************!*\
              !*** ./src/io/loader.js ***!
              \**************************/
            /***/
            function(s, a, l) {
              l.r(a), l.d(a, {
                /* harmony export */
                LoaderStatus: function() {
                  return (
                    /* binding */
                    h
                  );
                },
                /* harmony export */
                LoaderErrors: function() {
                  return (
                    /* binding */
                    u
                  );
                },
                /* harmony export */
                BaseLoader: function() {
                  return (
                    /* binding */
                    c
                  );
                }
                /* harmony export */
              });
              var d = l(
                /*! ../utils/exception.js */
                "./src/utils/exception.js"
              ), h = {
                kIdle: 0,
                kConnecting: 1,
                kBuffering: 2,
                kError: 3,
                kComplete: 4
              }, u = {
                OK: "OK",
                EXCEPTION: "Exception",
                HTTP_STATUS_CODE_INVALID: "HttpStatusCodeInvalid",
                CONNECTING_TIMEOUT: "ConnectingTimeout",
                EARLY_EOF: "EarlyEof",
                UNRECOVERABLE_EARLY_EOF: "UnrecoverableEarlyEof"
              }, c = (
                /** @class */
                function() {
                  function m(f) {
                    this._type = f || "undefined", this._status = h.kIdle, this._needStash = !1, this._onContentLengthKnown = null, this._onURLRedirect = null, this._onDataArrival = null, this._onError = null, this._onComplete = null;
                  }
                  return m.prototype.destroy = function() {
                    this._status = h.kIdle, this._onContentLengthKnown = null, this._onURLRedirect = null, this._onDataArrival = null, this._onError = null, this._onComplete = null;
                  }, m.prototype.isWorking = function() {
                    return this._status === h.kConnecting || this._status === h.kBuffering;
                  }, Object.defineProperty(m.prototype, "type", {
                    get: function() {
                      return this._type;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(m.prototype, "status", {
                    get: function() {
                      return this._status;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(m.prototype, "needStashBuffer", {
                    get: function() {
                      return this._needStash;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(m.prototype, "onContentLengthKnown", {
                    get: function() {
                      return this._onContentLengthKnown;
                    },
                    set: function(f) {
                      this._onContentLengthKnown = f;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(m.prototype, "onURLRedirect", {
                    get: function() {
                      return this._onURLRedirect;
                    },
                    set: function(f) {
                      this._onURLRedirect = f;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(m.prototype, "onDataArrival", {
                    get: function() {
                      return this._onDataArrival;
                    },
                    set: function(f) {
                      this._onDataArrival = f;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(m.prototype, "onError", {
                    get: function() {
                      return this._onError;
                    },
                    set: function(f) {
                      this._onError = f;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(m.prototype, "onComplete", {
                    get: function() {
                      return this._onComplete;
                    },
                    set: function(f) {
                      this._onComplete = f;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), m.prototype.open = function(f, p) {
                    throw new d.NotImplementedException("Unimplemented abstract function!");
                  }, m.prototype.abort = function() {
                    throw new d.NotImplementedException("Unimplemented abstract function!");
                  }, m;
                }()
              );
            }
          ),
          /***/
          "./src/io/param-seek-handler.js": (
            /*!**************************************!*\
              !*** ./src/io/param-seek-handler.js ***!
              \**************************************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = (
                /** @class */
                function() {
                  function h(u, c) {
                    this._startName = u, this._endName = c;
                  }
                  return h.prototype.getConfig = function(u, c) {
                    var m = u;
                    if (c.from !== 0 || c.to !== -1) {
                      var f = !0;
                      m.indexOf("?") === -1 && (m += "?", f = !1), f && (m += "&"), m += this._startName + "=" + c.from.toString(), c.to !== -1 && (m += "&" + this._endName + "=" + c.to.toString());
                    }
                    return {
                      url: m,
                      headers: {}
                    };
                  }, h.prototype.removeURLParameters = function(u) {
                    var c = u.split("?")[0], m = void 0, f = u.indexOf("?");
                    f !== -1 && (m = u.substring(f + 1));
                    var p = "";
                    if (m != null && m.length > 0)
                      for (var A = m.split("&"), v = 0; v < A.length; v++) {
                        var b = A[v].split("="), _ = v > 0;
                        b[0] !== this._startName && b[0] !== this._endName && (_ && (p += "&"), p += A[v]);
                      }
                    return p.length === 0 ? c : c + "?" + p;
                  }, h;
                }()
              );
              a.default = d;
            }
          ),
          /***/
          "./src/io/range-seek-handler.js": (
            /*!**************************************!*\
              !*** ./src/io/range-seek-handler.js ***!
              \**************************************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = (
                /** @class */
                function() {
                  function h(u) {
                    this._zeroStart = u || !1;
                  }
                  return h.prototype.getConfig = function(u, c) {
                    var m = {};
                    if (c.from !== 0 || c.to !== -1) {
                      var f = void 0;
                      c.to !== -1 ? f = "bytes=" + c.from.toString() + "-" + c.to.toString() : f = "bytes=" + c.from.toString() + "-", m.Range = f;
                    } else
                      this._zeroStart && (m.Range = "bytes=0-");
                    return {
                      url: u,
                      headers: m
                    };
                  }, h.prototype.removeURLParameters = function(u) {
                    return u;
                  }, h;
                }()
              );
              a.default = d;
            }
          ),
          /***/
          "./src/io/speed-sampler.js": (
            /*!*********************************!*\
              !*** ./src/io/speed-sampler.js ***!
              \*********************************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = (
                /** @class */
                function() {
                  function h() {
                    this._firstCheckpoint = 0, this._lastCheckpoint = 0, this._intervalBytes = 0, this._totalBytes = 0, this._lastSecondBytes = 0, self.performance && self.performance.now ? this._now = self.performance.now.bind(self.performance) : this._now = Date.now;
                  }
                  return h.prototype.reset = function() {
                    this._firstCheckpoint = this._lastCheckpoint = 0, this._totalBytes = this._intervalBytes = 0, this._lastSecondBytes = 0;
                  }, h.prototype.addBytes = function(u) {
                    this._firstCheckpoint === 0 ? (this._firstCheckpoint = this._now(), this._lastCheckpoint = this._firstCheckpoint, this._intervalBytes += u, this._totalBytes += u) : this._now() - this._lastCheckpoint < 1e3 ? (this._intervalBytes += u, this._totalBytes += u) : (this._lastSecondBytes = this._intervalBytes, this._intervalBytes = u, this._totalBytes += u, this._lastCheckpoint = this._now());
                  }, Object.defineProperty(h.prototype, "currentKBps", {
                    get: function() {
                      this.addBytes(0);
                      var u = (this._now() - this._lastCheckpoint) / 1e3;
                      return u == 0 && (u = 1), this._intervalBytes / u / 1024;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(h.prototype, "lastSecondKBps", {
                    get: function() {
                      return this.addBytes(0), this._lastSecondBytes !== 0 ? this._lastSecondBytes / 1024 : this._now() - this._lastCheckpoint >= 500 ? this.currentKBps : 0;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(h.prototype, "averageKBps", {
                    get: function() {
                      var u = (this._now() - this._firstCheckpoint) / 1e3;
                      return this._totalBytes / u / 1024;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), h;
                }()
              );
              a.default = d;
            }
          ),
          /***/
          "./src/io/websocket-loader.js": (
            /*!************************************!*\
              !*** ./src/io/websocket-loader.js ***!
              \************************************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = l(
                /*! ./loader.js */
                "./src/io/loader.js"
              ), h = l(
                /*! ../utils/exception.js */
                "./src/utils/exception.js"
              ), u = function() {
                var m = function(f, p) {
                  return m = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(A, v) {
                    A.__proto__ = v;
                  } || function(A, v) {
                    for (var b in v)
                      Object.prototype.hasOwnProperty.call(v, b) && (A[b] = v[b]);
                  }, m(f, p);
                };
                return function(f, p) {
                  if (typeof p != "function" && p !== null)
                    throw new TypeError("Class extends value " + String(p) + " is not a constructor or null");
                  m(f, p);
                  function A() {
                    this.constructor = f;
                  }
                  f.prototype = p === null ? Object.create(p) : (A.prototype = p.prototype, new A());
                };
              }(), c = (
                /** @class */
                function(m) {
                  u(f, m);
                  function f() {
                    var p = m.call(this, "websocket-loader") || this;
                    return p.TAG = "WebSocketLoader", p._needStash = !0, p._ws = null, p._requestAbort = !1, p._receivedLength = 0, p;
                  }
                  return f.isSupported = function() {
                    try {
                      return typeof self.WebSocket < "u";
                    } catch {
                      return !1;
                    }
                  }, f.prototype.destroy = function() {
                    this._ws && this.abort(), m.prototype.destroy.call(this);
                  }, f.prototype.open = function(p) {
                    try {
                      var A = this._ws = new self.WebSocket(p.url);
                      A.binaryType = "arraybuffer", A.onopen = this._onWebSocketOpen.bind(this), A.onclose = this._onWebSocketClose.bind(this), A.onmessage = this._onWebSocketMessage.bind(this), A.onerror = this._onWebSocketError.bind(this), this._status = d.LoaderStatus.kConnecting;
                    } catch (b) {
                      this._status = d.LoaderStatus.kError;
                      var v = { code: b.code, msg: b.message };
                      if (this._onError)
                        this._onError(d.LoaderErrors.EXCEPTION, v);
                      else
                        throw new h.RuntimeException(v.msg);
                    }
                  }, f.prototype.abort = function() {
                    var p = this._ws;
                    p && (p.readyState === 0 || p.readyState === 1) && (this._requestAbort = !0, p.close()), this._ws = null, this._status = d.LoaderStatus.kComplete;
                  }, f.prototype._onWebSocketOpen = function(p) {
                    this._status = d.LoaderStatus.kBuffering;
                  }, f.prototype._onWebSocketClose = function(p) {
                    if (this._requestAbort === !0) {
                      this._requestAbort = !1;
                      return;
                    }
                    this._status = d.LoaderStatus.kComplete, this._onComplete && this._onComplete(0, this._receivedLength - 1);
                  }, f.prototype._onWebSocketMessage = function(p) {
                    var A = this;
                    if (p.data instanceof ArrayBuffer)
                      this._dispatchArrayBuffer(p.data);
                    else if (p.data instanceof Blob) {
                      var v = new FileReader();
                      v.onload = function() {
                        A._dispatchArrayBuffer(v.result);
                      }, v.readAsArrayBuffer(p.data);
                    } else {
                      this._status = d.LoaderStatus.kError;
                      var b = { code: -1, msg: "Unsupported WebSocket message type: " + p.data.constructor.name };
                      if (this._onError)
                        this._onError(d.LoaderErrors.EXCEPTION, b);
                      else
                        throw new h.RuntimeException(b.msg);
                    }
                  }, f.prototype._dispatchArrayBuffer = function(p) {
                    var A = p, v = this._receivedLength;
                    this._receivedLength += A.byteLength, this._onDataArrival && this._onDataArrival(A, v, this._receivedLength);
                  }, f.prototype._onWebSocketError = function(p) {
                    this._status = d.LoaderStatus.kError;
                    var A = {
                      code: p.code,
                      msg: p.message
                    };
                    if (this._onError)
                      this._onError(d.LoaderErrors.EXCEPTION, A);
                    else
                      throw new h.RuntimeException(A.msg);
                  }, f;
                }(d.BaseLoader)
              );
              a.default = c;
            }
          ),
          /***/
          "./src/io/xhr-moz-chunked-loader.js": (
            /*!******************************************!*\
              !*** ./src/io/xhr-moz-chunked-loader.js ***!
              \******************************************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = l(
                /*! ../utils/logger.js */
                "./src/utils/logger.js"
              ), h = l(
                /*! ./loader.js */
                "./src/io/loader.js"
              ), u = l(
                /*! ../utils/exception.js */
                "./src/utils/exception.js"
              ), c = function() {
                var f = function(p, A) {
                  return f = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(v, b) {
                    v.__proto__ = b;
                  } || function(v, b) {
                    for (var _ in b)
                      Object.prototype.hasOwnProperty.call(b, _) && (v[_] = b[_]);
                  }, f(p, A);
                };
                return function(p, A) {
                  if (typeof A != "function" && A !== null)
                    throw new TypeError("Class extends value " + String(A) + " is not a constructor or null");
                  f(p, A);
                  function v() {
                    this.constructor = p;
                  }
                  p.prototype = A === null ? Object.create(A) : (v.prototype = A.prototype, new v());
                };
              }(), m = (
                /** @class */
                function(f) {
                  c(p, f);
                  function p(A, v) {
                    var b = f.call(this, "xhr-moz-chunked-loader") || this;
                    return b.TAG = "MozChunkedLoader", b._seekHandler = A, b._config = v, b._needStash = !0, b._xhr = null, b._requestAbort = !1, b._contentLength = null, b._receivedLength = 0, b;
                  }
                  return p.isSupported = function() {
                    try {
                      var A = new XMLHttpRequest();
                      return A.open("GET", "https://example.com", !0), A.responseType = "moz-chunked-arraybuffer", A.responseType === "moz-chunked-arraybuffer";
                    } catch (v) {
                      return d.default.w("MozChunkedLoader", v.message), !1;
                    }
                  }, p.prototype.destroy = function() {
                    this.isWorking() && this.abort(), this._xhr && (this._xhr.onreadystatechange = null, this._xhr.onprogress = null, this._xhr.onloadend = null, this._xhr.onerror = null, this._xhr = null), f.prototype.destroy.call(this);
                  }, p.prototype.open = function(A, v) {
                    this._dataSource = A, this._range = v;
                    var b = A.url;
                    this._config.reuseRedirectedURL && A.redirectedURL != null && (b = A.redirectedURL);
                    var _ = this._seekHandler.getConfig(b, v);
                    this._requestURL = _.url;
                    var T = this._xhr = new XMLHttpRequest();
                    if (T.open("GET", _.url, !0), T.responseType = "moz-chunked-arraybuffer", T.onreadystatechange = this._onReadyStateChange.bind(this), T.onprogress = this._onProgress.bind(this), T.onloadend = this._onLoadEnd.bind(this), T.onerror = this._onXhrError.bind(this), A.withCredentials && (T.withCredentials = !0), typeof _.headers == "object") {
                      var E = _.headers;
                      for (var L in E)
                        E.hasOwnProperty(L) && T.setRequestHeader(L, E[L]);
                    }
                    if (typeof this._config.headers == "object") {
                      var E = this._config.headers;
                      for (var L in E)
                        E.hasOwnProperty(L) && T.setRequestHeader(L, E[L]);
                    }
                    this._status = h.LoaderStatus.kConnecting, T.send();
                  }, p.prototype.abort = function() {
                    this._requestAbort = !0, this._xhr && this._xhr.abort(), this._status = h.LoaderStatus.kComplete;
                  }, p.prototype._onReadyStateChange = function(A) {
                    var v = A.target;
                    if (v.readyState === 2) {
                      if (v.responseURL != null && v.responseURL !== this._requestURL && this._onURLRedirect) {
                        var b = this._seekHandler.removeURLParameters(v.responseURL);
                        this._onURLRedirect(b);
                      }
                      if (v.status !== 0 && (v.status < 200 || v.status > 299))
                        if (this._status = h.LoaderStatus.kError, this._onError)
                          this._onError(h.LoaderErrors.HTTP_STATUS_CODE_INVALID, { code: v.status, msg: v.statusText });
                        else
                          throw new u.RuntimeException("MozChunkedLoader: Http code invalid, " + v.status + " " + v.statusText);
                      else
                        this._status = h.LoaderStatus.kBuffering;
                    }
                  }, p.prototype._onProgress = function(A) {
                    if (this._status !== h.LoaderStatus.kError) {
                      this._contentLength === null && A.total !== null && A.total !== 0 && (this._contentLength = A.total, this._onContentLengthKnown && this._onContentLengthKnown(this._contentLength));
                      var v = A.target.response, b = this._range.from + this._receivedLength;
                      this._receivedLength += v.byteLength, this._onDataArrival && this._onDataArrival(v, b, this._receivedLength);
                    }
                  }, p.prototype._onLoadEnd = function(A) {
                    if (this._requestAbort === !0) {
                      this._requestAbort = !1;
                      return;
                    } else if (this._status === h.LoaderStatus.kError)
                      return;
                    this._status = h.LoaderStatus.kComplete, this._onComplete && this._onComplete(this._range.from, this._range.from + this._receivedLength - 1);
                  }, p.prototype._onXhrError = function(A) {
                    this._status = h.LoaderStatus.kError;
                    var v = 0, b = null;
                    if (this._contentLength && A.loaded < this._contentLength ? (v = h.LoaderErrors.EARLY_EOF, b = { code: -1, msg: "Moz-Chunked stream meet Early-Eof" }) : (v = h.LoaderErrors.EXCEPTION, b = { code: -1, msg: A.constructor.name + " " + A.type }), this._onError)
                      this._onError(v, b);
                    else
                      throw new u.RuntimeException(b.msg);
                  }, p;
                }(h.BaseLoader)
              );
              a.default = m;
            }
          ),
          /***/
          "./src/io/xhr-range-loader.js": (
            /*!************************************!*\
              !*** ./src/io/xhr-range-loader.js ***!
              \************************************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = l(
                /*! ../utils/logger.js */
                "./src/utils/logger.js"
              ), h = l(
                /*! ./speed-sampler.js */
                "./src/io/speed-sampler.js"
              ), u = l(
                /*! ./loader.js */
                "./src/io/loader.js"
              ), c = l(
                /*! ../utils/exception.js */
                "./src/utils/exception.js"
              ), m = function() {
                var p = function(A, v) {
                  return p = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(b, _) {
                    b.__proto__ = _;
                  } || function(b, _) {
                    for (var T in _)
                      Object.prototype.hasOwnProperty.call(_, T) && (b[T] = _[T]);
                  }, p(A, v);
                };
                return function(A, v) {
                  if (typeof v != "function" && v !== null)
                    throw new TypeError("Class extends value " + String(v) + " is not a constructor or null");
                  p(A, v);
                  function b() {
                    this.constructor = A;
                  }
                  A.prototype = v === null ? Object.create(v) : (b.prototype = v.prototype, new b());
                };
              }(), f = (
                /** @class */
                function(p) {
                  m(A, p);
                  function A(v, b) {
                    var _ = p.call(this, "xhr-range-loader") || this;
                    return _.TAG = "RangeLoader", _._seekHandler = v, _._config = b, _._needStash = !1, _._chunkSizeKBList = [
                      128,
                      256,
                      384,
                      512,
                      768,
                      1024,
                      1536,
                      2048,
                      3072,
                      4096,
                      5120,
                      6144,
                      7168,
                      8192
                    ], _._currentChunkSizeKB = 384, _._currentSpeedNormalized = 0, _._zeroSpeedChunkCount = 0, _._xhr = null, _._speedSampler = new h.default(), _._requestAbort = !1, _._waitForTotalLength = !1, _._totalLengthReceived = !1, _._currentRequestURL = null, _._currentRedirectedURL = null, _._currentRequestRange = null, _._totalLength = null, _._contentLength = null, _._receivedLength = 0, _._lastTimeLoaded = 0, _;
                  }
                  return A.isSupported = function() {
                    try {
                      var v = new XMLHttpRequest();
                      return v.open("GET", "https://example.com", !0), v.responseType = "arraybuffer", v.responseType === "arraybuffer";
                    } catch (b) {
                      return d.default.w("RangeLoader", b.message), !1;
                    }
                  }, A.prototype.destroy = function() {
                    this.isWorking() && this.abort(), this._xhr && (this._xhr.onreadystatechange = null, this._xhr.onprogress = null, this._xhr.onload = null, this._xhr.onerror = null, this._xhr = null), p.prototype.destroy.call(this);
                  }, Object.defineProperty(A.prototype, "currentSpeed", {
                    get: function() {
                      return this._speedSampler.lastSecondKBps;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), A.prototype.open = function(v, b) {
                    this._dataSource = v, this._range = b, this._status = u.LoaderStatus.kConnecting;
                    var _ = !1;
                    this._dataSource.filesize != null && this._dataSource.filesize !== 0 && (_ = !0, this._totalLength = this._dataSource.filesize), !this._totalLengthReceived && !_ ? (this._waitForTotalLength = !0, this._internalOpen(this._dataSource, { from: 0, to: -1 })) : this._openSubRange();
                  }, A.prototype._openSubRange = function() {
                    var v = this._currentChunkSizeKB * 1024, b = this._range.from + this._receivedLength, _ = b + v;
                    this._contentLength != null && _ - this._range.from >= this._contentLength && (_ = this._range.from + this._contentLength - 1), this._currentRequestRange = { from: b, to: _ }, this._internalOpen(this._dataSource, this._currentRequestRange);
                  }, A.prototype._internalOpen = function(v, b) {
                    this._lastTimeLoaded = 0;
                    var _ = v.url;
                    this._config.reuseRedirectedURL && (this._currentRedirectedURL != null ? _ = this._currentRedirectedURL : v.redirectedURL != null && (_ = v.redirectedURL));
                    var T = this._seekHandler.getConfig(_, b);
                    this._currentRequestURL = T.url;
                    var E = this._xhr = new XMLHttpRequest();
                    if (E.open("GET", T.url, !0), E.responseType = "arraybuffer", E.onreadystatechange = this._onReadyStateChange.bind(this), E.onprogress = this._onProgress.bind(this), E.onload = this._onLoad.bind(this), E.onerror = this._onXhrError.bind(this), v.withCredentials && (E.withCredentials = !0), typeof T.headers == "object") {
                      var L = T.headers;
                      for (var k in L)
                        L.hasOwnProperty(k) && E.setRequestHeader(k, L[k]);
                    }
                    if (typeof this._config.headers == "object") {
                      var L = this._config.headers;
                      for (var k in L)
                        L.hasOwnProperty(k) && E.setRequestHeader(k, L[k]);
                    }
                    E.send();
                  }, A.prototype.abort = function() {
                    this._requestAbort = !0, this._internalAbort(), this._status = u.LoaderStatus.kComplete;
                  }, A.prototype._internalAbort = function() {
                    this._xhr && (this._xhr.onreadystatechange = null, this._xhr.onprogress = null, this._xhr.onload = null, this._xhr.onerror = null, this._xhr.abort(), this._xhr = null);
                  }, A.prototype._onReadyStateChange = function(v) {
                    var b = v.target;
                    if (b.readyState === 2) {
                      if (b.responseURL != null) {
                        var _ = this._seekHandler.removeURLParameters(b.responseURL);
                        b.responseURL !== this._currentRequestURL && _ !== this._currentRedirectedURL && (this._currentRedirectedURL = _, this._onURLRedirect && this._onURLRedirect(_));
                      }
                      if (b.status >= 200 && b.status <= 299) {
                        if (this._waitForTotalLength)
                          return;
                        this._status = u.LoaderStatus.kBuffering;
                      } else if (this._status = u.LoaderStatus.kError, this._onError)
                        this._onError(u.LoaderErrors.HTTP_STATUS_CODE_INVALID, { code: b.status, msg: b.statusText });
                      else
                        throw new c.RuntimeException("RangeLoader: Http code invalid, " + b.status + " " + b.statusText);
                    }
                  }, A.prototype._onProgress = function(v) {
                    if (this._status !== u.LoaderStatus.kError) {
                      if (this._contentLength === null) {
                        var b = !1;
                        if (this._waitForTotalLength) {
                          this._waitForTotalLength = !1, this._totalLengthReceived = !0, b = !0;
                          var _ = v.total;
                          this._internalAbort(), _ != null & _ !== 0 && (this._totalLength = _);
                        }
                        if (this._range.to === -1 ? this._contentLength = this._totalLength - this._range.from : this._contentLength = this._range.to - this._range.from + 1, b) {
                          this._openSubRange();
                          return;
                        }
                        this._onContentLengthKnown && this._onContentLengthKnown(this._contentLength);
                      }
                      var T = v.loaded - this._lastTimeLoaded;
                      this._lastTimeLoaded = v.loaded, this._speedSampler.addBytes(T);
                    }
                  }, A.prototype._normalizeSpeed = function(v) {
                    var b = this._chunkSizeKBList, _ = b.length - 1, T = 0, E = 0, L = _;
                    if (v < b[0])
                      return b[0];
                    for (; E <= L; ) {
                      if (T = E + Math.floor((L - E) / 2), T === _ || v >= b[T] && v < b[T + 1])
                        return b[T];
                      b[T] < v ? E = T + 1 : L = T - 1;
                    }
                  }, A.prototype._onLoad = function(v) {
                    if (this._status !== u.LoaderStatus.kError) {
                      if (this._waitForTotalLength) {
                        this._waitForTotalLength = !1;
                        return;
                      }
                      this._lastTimeLoaded = 0;
                      var b = this._speedSampler.lastSecondKBps;
                      if (b === 0 && (this._zeroSpeedChunkCount++, this._zeroSpeedChunkCount >= 3 && (b = this._speedSampler.currentKBps)), b !== 0) {
                        var _ = this._normalizeSpeed(b);
                        this._currentSpeedNormalized !== _ && (this._currentSpeedNormalized = _, this._currentChunkSizeKB = _);
                      }
                      var T = v.target.response, E = this._range.from + this._receivedLength;
                      this._receivedLength += T.byteLength;
                      var L = !1;
                      this._contentLength != null && this._receivedLength < this._contentLength ? this._openSubRange() : L = !0, this._onDataArrival && this._onDataArrival(T, E, this._receivedLength), L && (this._status = u.LoaderStatus.kComplete, this._onComplete && this._onComplete(this._range.from, this._range.from + this._receivedLength - 1));
                    }
                  }, A.prototype._onXhrError = function(v) {
                    this._status = u.LoaderStatus.kError;
                    var b = 0, _ = null;
                    if (this._contentLength && this._receivedLength > 0 && this._receivedLength < this._contentLength ? (b = u.LoaderErrors.EARLY_EOF, _ = { code: -1, msg: "RangeLoader meet Early-Eof" }) : (b = u.LoaderErrors.EXCEPTION, _ = { code: -1, msg: v.constructor.name + " " + v.type }), this._onError)
                      this._onError(b, _);
                    else
                      throw new c.RuntimeException(_.msg);
                  }, A;
                }(u.BaseLoader)
              );
              a.default = f;
            }
          ),
          /***/
          "./src/player/flv-player.js": (
            /*!**********************************!*\
              !*** ./src/player/flv-player.js ***!
              \**********************************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = l(
                /*! events */
                "./node_modules/events/events.js"
              ), h = /* @__PURE__ */ l.n(d), u = l(
                /*! ../utils/logger.js */
                "./src/utils/logger.js"
              ), c = l(
                /*! ../utils/browser.js */
                "./src/utils/browser.js"
              ), m = l(
                /*! ./player-events.js */
                "./src/player/player-events.js"
              ), f = l(
                /*! ../core/transmuxer.js */
                "./src/core/transmuxer.js"
              ), p = l(
                /*! ../core/transmuxing-events.js */
                "./src/core/transmuxing-events.js"
              ), A = l(
                /*! ../core/mse-controller.js */
                "./src/core/mse-controller.js"
              ), v = l(
                /*! ../core/mse-events.js */
                "./src/core/mse-events.js"
              ), b = l(
                /*! ./player-errors.js */
                "./src/player/player-errors.js"
              ), _ = l(
                /*! ../config.js */
                "./src/config.js"
              ), T = l(
                /*! ../utils/exception.js */
                "./src/utils/exception.js"
              ), E = (
                /** @class */
                function() {
                  function L(k, D) {
                    if (this.TAG = "FlvPlayer", this._type = "FlvPlayer", this._emitter = new (h())(), this._config = (0, _.createDefaultConfig)(), typeof D == "object" && Object.assign(this._config, D), k.type.toLowerCase() !== "flv")
                      throw new T.InvalidArgumentException("FlvPlayer requires an flv MediaDataSource input!");
                    k.isLive === !0 && (this._config.isLive = !0), this.e = {
                      onvLoadedMetadata: this._onvLoadedMetadata.bind(this),
                      onvSeeking: this._onvSeeking.bind(this),
                      onvCanPlay: this._onvCanPlay.bind(this),
                      onvStalled: this._onvStalled.bind(this),
                      onvProgress: this._onvProgress.bind(this)
                    }, self.performance && self.performance.now ? this._now = self.performance.now.bind(self.performance) : this._now = Date.now, this._pendingSeekTime = null, this._requestSetTime = !1, this._seekpointRecord = null, this._progressChecker = null, this._mediaDataSource = k, this._mediaElement = null, this._msectl = null, this._transmuxer = null, this._mseSourceOpened = !1, this._hasPendingLoad = !1, this._receivedCanPlay = !1, this._mediaInfo = null, this._statisticsInfo = null;
                    var M = c.default.chrome && (c.default.version.major < 50 || c.default.version.major === 50 && c.default.version.build < 2661);
                    this._alwaysSeekKeyframe = !!(M || c.default.msedge || c.default.msie), this._alwaysSeekKeyframe && (this._config.accurateSeek = !1);
                  }
                  return L.prototype.destroy = function() {
                    this._progressChecker != null && (window.clearInterval(this._progressChecker), this._progressChecker = null), this._transmuxer && this.unload(), this._mediaElement && this.detachMediaElement(), this.e = null, this._mediaDataSource = null, this._emitter.removeAllListeners(), this._emitter = null;
                  }, L.prototype.on = function(k, D) {
                    var M = this;
                    k === m.default.MEDIA_INFO ? this._mediaInfo != null && Promise.resolve().then(function() {
                      M._emitter.emit(m.default.MEDIA_INFO, M.mediaInfo);
                    }) : k === m.default.STATISTICS_INFO && this._statisticsInfo != null && Promise.resolve().then(function() {
                      M._emitter.emit(m.default.STATISTICS_INFO, M.statisticsInfo);
                    }), this._emitter.addListener(k, D);
                  }, L.prototype.off = function(k, D) {
                    this._emitter.removeListener(k, D);
                  }, L.prototype.attachMediaElement = function(k) {
                    var D = this;
                    if (this._mediaElement = k, k.addEventListener("loadedmetadata", this.e.onvLoadedMetadata), k.addEventListener("seeking", this.e.onvSeeking), k.addEventListener("canplay", this.e.onvCanPlay), k.addEventListener("stalled", this.e.onvStalled), k.addEventListener("progress", this.e.onvProgress), this._msectl = new A.default(this._config), this._msectl.on(v.default.UPDATE_END, this._onmseUpdateEnd.bind(this)), this._msectl.on(v.default.BUFFER_FULL, this._onmseBufferFull.bind(this)), this._msectl.on(v.default.SOURCE_OPEN, function() {
                      D._mseSourceOpened = !0, D._hasPendingLoad && (D._hasPendingLoad = !1, D.load());
                    }), this._msectl.on(v.default.ERROR, function(M) {
                      D._emitter.emit(m.default.ERROR, b.ErrorTypes.MEDIA_ERROR, b.ErrorDetails.MEDIA_MSE_ERROR, M);
                    }), this._msectl.attachMediaElement(k), this._pendingSeekTime != null)
                      try {
                        k.currentTime = this._pendingSeekTime, this._pendingSeekTime = null;
                      } catch {
                      }
                  }, L.prototype.detachMediaElement = function() {
                    this._mediaElement && (this._msectl.detachMediaElement(), this._mediaElement.removeEventListener("loadedmetadata", this.e.onvLoadedMetadata), this._mediaElement.removeEventListener("seeking", this.e.onvSeeking), this._mediaElement.removeEventListener("canplay", this.e.onvCanPlay), this._mediaElement.removeEventListener("stalled", this.e.onvStalled), this._mediaElement.removeEventListener("progress", this.e.onvProgress), this._mediaElement = null), this._msectl && (this._msectl.destroy(), this._msectl = null);
                  }, L.prototype.load = function() {
                    var k = this;
                    if (!this._mediaElement)
                      throw new T.IllegalStateException("HTMLMediaElement must be attached before load()!");
                    if (this._transmuxer)
                      throw new T.IllegalStateException("FlvPlayer.load() has been called, please call unload() first!");
                    if (!this._hasPendingLoad) {
                      if (this._config.deferLoadAfterSourceOpen && this._mseSourceOpened === !1) {
                        this._hasPendingLoad = !0;
                        return;
                      }
                      this._mediaElement.readyState > 0 && (this._requestSetTime = !0, this._mediaElement.currentTime = 0), this._transmuxer = new f.default(this._mediaDataSource, this._config), this._transmuxer.on(p.default.INIT_SEGMENT, function(D, M) {
                        k._msectl.appendInitSegment(M);
                      }), this._transmuxer.on(p.default.MEDIA_SEGMENT, function(D, M) {
                        if (k._msectl.appendMediaSegment(M), k._config.lazyLoad && !k._config.isLive) {
                          var O = k._mediaElement.currentTime;
                          M.info.endDts >= (O + k._config.lazyLoadMaxDuration) * 1e3 && k._progressChecker == null && (u.default.v(k.TAG, "Maximum buffering duration exceeded, suspend transmuxing task"), k._suspendTransmuxer());
                        }
                      }), this._transmuxer.on(p.default.LOADING_COMPLETE, function() {
                        k._msectl.endOfStream(), k._emitter.emit(m.default.LOADING_COMPLETE);
                      }), this._transmuxer.on(p.default.RECOVERED_EARLY_EOF, function() {
                        k._emitter.emit(m.default.RECOVERED_EARLY_EOF);
                      }), this._transmuxer.on(p.default.IO_ERROR, function(D, M) {
                        k._emitter.emit(m.default.ERROR, b.ErrorTypes.NETWORK_ERROR, D, M);
                      }), this._transmuxer.on(p.default.DEMUX_ERROR, function(D, M) {
                        k._emitter.emit(m.default.ERROR, b.ErrorTypes.MEDIA_ERROR, D, { code: -1, msg: M });
                      }), this._transmuxer.on(p.default.MEDIA_INFO, function(D) {
                        k._mediaInfo = D, k._emitter.emit(m.default.MEDIA_INFO, Object.assign({}, D));
                      }), this._transmuxer.on(p.default.METADATA_ARRIVED, function(D) {
                        k._emitter.emit(m.default.METADATA_ARRIVED, D);
                      }), this._transmuxer.on(p.default.SCRIPTDATA_ARRIVED, function(D) {
                        k._emitter.emit(m.default.SCRIPTDATA_ARRIVED, D);
                      }), this._transmuxer.on(p.default.STATISTICS_INFO, function(D) {
                        k._statisticsInfo = k._fillStatisticsInfo(D), k._emitter.emit(m.default.STATISTICS_INFO, Object.assign({}, k._statisticsInfo));
                      }), this._transmuxer.on(p.default.RECOMMEND_SEEKPOINT, function(D) {
                        k._mediaElement && !k._config.accurateSeek && (k._requestSetTime = !0, k._mediaElement.currentTime = D / 1e3);
                      }), this._transmuxer.open();
                    }
                  }, L.prototype.unload = function() {
                    this._mediaElement && this._mediaElement.pause(), this._msectl && this._msectl.seek(0), this._transmuxer && (this._transmuxer.close(), this._transmuxer.destroy(), this._transmuxer = null);
                  }, L.prototype.play = function() {
                    return this._mediaElement.play();
                  }, L.prototype.pause = function() {
                    this._mediaElement.pause();
                  }, Object.defineProperty(L.prototype, "type", {
                    get: function() {
                      return this._type;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(L.prototype, "buffered", {
                    get: function() {
                      return this._mediaElement.buffered;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(L.prototype, "duration", {
                    get: function() {
                      return this._mediaElement.duration;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(L.prototype, "volume", {
                    get: function() {
                      return this._mediaElement.volume;
                    },
                    set: function(k) {
                      this._mediaElement.volume = k;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(L.prototype, "muted", {
                    get: function() {
                      return this._mediaElement.muted;
                    },
                    set: function(k) {
                      this._mediaElement.muted = k;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(L.prototype, "currentTime", {
                    get: function() {
                      return this._mediaElement ? this._mediaElement.currentTime : 0;
                    },
                    set: function(k) {
                      this._mediaElement ? this._internalSeek(k) : this._pendingSeekTime = k;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(L.prototype, "mediaInfo", {
                    get: function() {
                      return Object.assign({}, this._mediaInfo);
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(L.prototype, "statisticsInfo", {
                    get: function() {
                      return this._statisticsInfo == null && (this._statisticsInfo = {}), this._statisticsInfo = this._fillStatisticsInfo(this._statisticsInfo), Object.assign({}, this._statisticsInfo);
                    },
                    enumerable: !1,
                    configurable: !0
                  }), L.prototype._fillStatisticsInfo = function(k) {
                    if (k.playerType = this._type, !(this._mediaElement instanceof HTMLVideoElement))
                      return k;
                    var D = !0, M = 0, O = 0;
                    if (this._mediaElement.getVideoPlaybackQuality) {
                      var N = this._mediaElement.getVideoPlaybackQuality();
                      M = N.totalVideoFrames, O = N.droppedVideoFrames;
                    } else
                      this._mediaElement.webkitDecodedFrameCount != null ? (M = this._mediaElement.webkitDecodedFrameCount, O = this._mediaElement.webkitDroppedFrameCount) : D = !1;
                    return D && (k.decodedFrames = M, k.droppedFrames = O), k;
                  }, L.prototype._onmseUpdateEnd = function() {
                    if (!(!this._config.lazyLoad || this._config.isLive)) {
                      for (var k = this._mediaElement.buffered, D = this._mediaElement.currentTime, M = 0, O = 0; O < k.length; O++) {
                        var N = k.start(O), B = k.end(O);
                        if (N <= D && D < B) {
                          M = B;
                          break;
                        }
                      }
                      M >= D + this._config.lazyLoadMaxDuration && this._progressChecker == null && (u.default.v(this.TAG, "Maximum buffering duration exceeded, suspend transmuxing task"), this._suspendTransmuxer());
                    }
                  }, L.prototype._onmseBufferFull = function() {
                    u.default.v(this.TAG, "MSE SourceBuffer is full, suspend transmuxing task"), this._progressChecker == null && this._suspendTransmuxer();
                  }, L.prototype._suspendTransmuxer = function() {
                    this._transmuxer && (this._transmuxer.pause(), this._progressChecker == null && (this._progressChecker = window.setInterval(this._checkProgressAndResume.bind(this), 1e3)));
                  }, L.prototype._checkProgressAndResume = function() {
                    for (var k = this._mediaElement.currentTime, D = this._mediaElement.buffered, M = !1, O = 0; O < D.length; O++) {
                      var N = D.start(O), B = D.end(O);
                      if (k >= N && k < B) {
                        k >= B - this._config.lazyLoadRecoverDuration && (M = !0);
                        break;
                      }
                    }
                    M && (window.clearInterval(this._progressChecker), this._progressChecker = null, M && (u.default.v(this.TAG, "Continue loading from paused position"), this._transmuxer.resume()));
                  }, L.prototype._isTimepointBuffered = function(k) {
                    for (var D = this._mediaElement.buffered, M = 0; M < D.length; M++) {
                      var O = D.start(M), N = D.end(M);
                      if (k >= O && k < N)
                        return !0;
                    }
                    return !1;
                  }, L.prototype._internalSeek = function(k) {
                    var D = this._isTimepointBuffered(k), M = !1, O = 0;
                    if (k < 1 && this._mediaElement.buffered.length > 0) {
                      var N = this._mediaElement.buffered.start(0);
                      (N < 1 && k < N || c.default.safari) && (M = !0, O = c.default.safari ? 0.1 : N);
                    }
                    if (M)
                      this._requestSetTime = !0, this._mediaElement.currentTime = O;
                    else if (D) {
                      if (!this._alwaysSeekKeyframe)
                        this._requestSetTime = !0, this._mediaElement.currentTime = k;
                      else {
                        var B = this._msectl.getNearestKeyframe(Math.floor(k * 1e3));
                        this._requestSetTime = !0, B != null ? this._mediaElement.currentTime = B.dts / 1e3 : this._mediaElement.currentTime = k;
                      }
                      this._progressChecker != null && this._checkProgressAndResume();
                    } else
                      this._progressChecker != null && (window.clearInterval(this._progressChecker), this._progressChecker = null), this._msectl.seek(k), this._transmuxer.seek(Math.floor(k * 1e3)), this._config.accurateSeek && (this._requestSetTime = !0, this._mediaElement.currentTime = k);
                  }, L.prototype._checkAndApplyUnbufferedSeekpoint = function() {
                    if (this._seekpointRecord)
                      if (this._seekpointRecord.recordTime <= this._now() - 100) {
                        var k = this._mediaElement.currentTime;
                        this._seekpointRecord = null, this._isTimepointBuffered(k) || (this._progressChecker != null && (window.clearTimeout(this._progressChecker), this._progressChecker = null), this._msectl.seek(k), this._transmuxer.seek(Math.floor(k * 1e3)), this._config.accurateSeek && (this._requestSetTime = !0, this._mediaElement.currentTime = k));
                      } else
                        window.setTimeout(this._checkAndApplyUnbufferedSeekpoint.bind(this), 50);
                  }, L.prototype._checkAndResumeStuckPlayback = function(k) {
                    var D = this._mediaElement;
                    if (k || !this._receivedCanPlay || D.readyState < 2) {
                      var M = D.buffered;
                      M.length > 0 && D.currentTime < M.start(0) && (u.default.w(this.TAG, "Playback seems stuck at " + D.currentTime + ", seek to " + M.start(0)), this._requestSetTime = !0, this._mediaElement.currentTime = M.start(0), this._mediaElement.removeEventListener("progress", this.e.onvProgress));
                    } else
                      this._mediaElement.removeEventListener("progress", this.e.onvProgress);
                  }, L.prototype._onvLoadedMetadata = function(k) {
                    this._pendingSeekTime != null && (this._mediaElement.currentTime = this._pendingSeekTime, this._pendingSeekTime = null);
                  }, L.prototype._onvSeeking = function(k) {
                    var D = this._mediaElement.currentTime, M = this._mediaElement.buffered;
                    if (this._requestSetTime) {
                      this._requestSetTime = !1;
                      return;
                    }
                    if (D < 1 && M.length > 0) {
                      var O = M.start(0);
                      if (O < 1 && D < O || c.default.safari) {
                        this._requestSetTime = !0, this._mediaElement.currentTime = c.default.safari ? 0.1 : O;
                        return;
                      }
                    }
                    if (this._isTimepointBuffered(D)) {
                      if (this._alwaysSeekKeyframe) {
                        var N = this._msectl.getNearestKeyframe(Math.floor(D * 1e3));
                        N != null && (this._requestSetTime = !0, this._mediaElement.currentTime = N.dts / 1e3);
                      }
                      this._progressChecker != null && this._checkProgressAndResume();
                      return;
                    }
                    this._seekpointRecord = {
                      seekPoint: D,
                      recordTime: this._now()
                    }, window.setTimeout(this._checkAndApplyUnbufferedSeekpoint.bind(this), 50);
                  }, L.prototype._onvCanPlay = function(k) {
                    this._receivedCanPlay = !0, this._mediaElement.removeEventListener("canplay", this.e.onvCanPlay);
                  }, L.prototype._onvStalled = function(k) {
                    this._checkAndResumeStuckPlayback(!0);
                  }, L.prototype._onvProgress = function(k) {
                    this._checkAndResumeStuckPlayback();
                  }, L;
                }()
              );
              a.default = E;
            }
          ),
          /***/
          "./src/player/native-player.js": (
            /*!*************************************!*\
              !*** ./src/player/native-player.js ***!
              \*************************************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = l(
                /*! events */
                "./node_modules/events/events.js"
              ), h = /* @__PURE__ */ l.n(d), u = l(
                /*! ./player-events.js */
                "./src/player/player-events.js"
              ), c = l(
                /*! ../config.js */
                "./src/config.js"
              ), m = l(
                /*! ../utils/exception.js */
                "./src/utils/exception.js"
              ), f = (
                /** @class */
                function() {
                  function p(A, v) {
                    if (this.TAG = "NativePlayer", this._type = "NativePlayer", this._emitter = new (h())(), this._config = (0, c.createDefaultConfig)(), typeof v == "object" && Object.assign(this._config, v), A.type.toLowerCase() === "flv")
                      throw new m.InvalidArgumentException("NativePlayer does't support flv MediaDataSource input!");
                    if (A.hasOwnProperty("segments"))
                      throw new m.InvalidArgumentException("NativePlayer(" + A.type + ") doesn't support multipart playback!");
                    this.e = {
                      onvLoadedMetadata: this._onvLoadedMetadata.bind(this)
                    }, this._pendingSeekTime = null, this._statisticsReporter = null, this._mediaDataSource = A, this._mediaElement = null;
                  }
                  return p.prototype.destroy = function() {
                    this._mediaElement && (this.unload(), this.detachMediaElement()), this.e = null, this._mediaDataSource = null, this._emitter.removeAllListeners(), this._emitter = null;
                  }, p.prototype.on = function(A, v) {
                    var b = this;
                    A === u.default.MEDIA_INFO ? this._mediaElement != null && this._mediaElement.readyState !== 0 && Promise.resolve().then(function() {
                      b._emitter.emit(u.default.MEDIA_INFO, b.mediaInfo);
                    }) : A === u.default.STATISTICS_INFO && this._mediaElement != null && this._mediaElement.readyState !== 0 && Promise.resolve().then(function() {
                      b._emitter.emit(u.default.STATISTICS_INFO, b.statisticsInfo);
                    }), this._emitter.addListener(A, v);
                  }, p.prototype.off = function(A, v) {
                    this._emitter.removeListener(A, v);
                  }, p.prototype.attachMediaElement = function(A) {
                    if (this._mediaElement = A, A.addEventListener("loadedmetadata", this.e.onvLoadedMetadata), this._pendingSeekTime != null)
                      try {
                        A.currentTime = this._pendingSeekTime, this._pendingSeekTime = null;
                      } catch {
                      }
                  }, p.prototype.detachMediaElement = function() {
                    this._mediaElement && (this._mediaElement.src = "", this._mediaElement.removeAttribute("src"), this._mediaElement.removeEventListener("loadedmetadata", this.e.onvLoadedMetadata), this._mediaElement = null), this._statisticsReporter != null && (window.clearInterval(this._statisticsReporter), this._statisticsReporter = null);
                  }, p.prototype.load = function() {
                    if (!this._mediaElement)
                      throw new m.IllegalStateException("HTMLMediaElement must be attached before load()!");
                    this._mediaElement.src = this._mediaDataSource.url, this._mediaElement.readyState > 0 && (this._mediaElement.currentTime = 0), this._mediaElement.preload = "auto", this._mediaElement.load(), this._statisticsReporter = window.setInterval(this._reportStatisticsInfo.bind(this), this._config.statisticsInfoReportInterval);
                  }, p.prototype.unload = function() {
                    this._mediaElement && (this._mediaElement.src = "", this._mediaElement.removeAttribute("src")), this._statisticsReporter != null && (window.clearInterval(this._statisticsReporter), this._statisticsReporter = null);
                  }, p.prototype.play = function() {
                    return this._mediaElement.play();
                  }, p.prototype.pause = function() {
                    this._mediaElement.pause();
                  }, Object.defineProperty(p.prototype, "type", {
                    get: function() {
                      return this._type;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(p.prototype, "buffered", {
                    get: function() {
                      return this._mediaElement.buffered;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(p.prototype, "duration", {
                    get: function() {
                      return this._mediaElement.duration;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(p.prototype, "volume", {
                    get: function() {
                      return this._mediaElement.volume;
                    },
                    set: function(A) {
                      this._mediaElement.volume = A;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(p.prototype, "muted", {
                    get: function() {
                      return this._mediaElement.muted;
                    },
                    set: function(A) {
                      this._mediaElement.muted = A;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(p.prototype, "currentTime", {
                    get: function() {
                      return this._mediaElement ? this._mediaElement.currentTime : 0;
                    },
                    set: function(A) {
                      this._mediaElement ? this._mediaElement.currentTime = A : this._pendingSeekTime = A;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(p.prototype, "mediaInfo", {
                    get: function() {
                      var A = this._mediaElement instanceof HTMLAudioElement ? "audio/" : "video/", v = {
                        mimeType: A + this._mediaDataSource.type
                      };
                      return this._mediaElement && (v.duration = Math.floor(this._mediaElement.duration * 1e3), this._mediaElement instanceof HTMLVideoElement && (v.width = this._mediaElement.videoWidth, v.height = this._mediaElement.videoHeight)), v;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(p.prototype, "statisticsInfo", {
                    get: function() {
                      var A = {
                        playerType: this._type,
                        url: this._mediaDataSource.url
                      };
                      if (!(this._mediaElement instanceof HTMLVideoElement))
                        return A;
                      var v = !0, b = 0, _ = 0;
                      if (this._mediaElement.getVideoPlaybackQuality) {
                        var T = this._mediaElement.getVideoPlaybackQuality();
                        b = T.totalVideoFrames, _ = T.droppedVideoFrames;
                      } else
                        this._mediaElement.webkitDecodedFrameCount != null ? (b = this._mediaElement.webkitDecodedFrameCount, _ = this._mediaElement.webkitDroppedFrameCount) : v = !1;
                      return v && (A.decodedFrames = b, A.droppedFrames = _), A;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), p.prototype._onvLoadedMetadata = function(A) {
                    this._pendingSeekTime != null && (this._mediaElement.currentTime = this._pendingSeekTime, this._pendingSeekTime = null), this._emitter.emit(u.default.MEDIA_INFO, this.mediaInfo);
                  }, p.prototype._reportStatisticsInfo = function() {
                    this._emitter.emit(u.default.STATISTICS_INFO, this.statisticsInfo);
                  }, p;
                }()
              );
              a.default = f;
            }
          ),
          /***/
          "./src/player/player-errors.js": (
            /*!*************************************!*\
              !*** ./src/player/player-errors.js ***!
              \*************************************/
            /***/
            function(s, a, l) {
              l.r(a), l.d(a, {
                /* harmony export */
                ErrorTypes: function() {
                  return (
                    /* binding */
                    u
                  );
                },
                /* harmony export */
                ErrorDetails: function() {
                  return (
                    /* binding */
                    c
                  );
                }
                /* harmony export */
              });
              var d = l(
                /*! ../io/loader.js */
                "./src/io/loader.js"
              ), h = l(
                /*! ../demux/demux-errors.js */
                "./src/demux/demux-errors.js"
              ), u = {
                NETWORK_ERROR: "NetworkError",
                MEDIA_ERROR: "MediaError",
                OTHER_ERROR: "OtherError"
              }, c = {
                NETWORK_EXCEPTION: d.LoaderErrors.EXCEPTION,
                NETWORK_STATUS_CODE_INVALID: d.LoaderErrors.HTTP_STATUS_CODE_INVALID,
                NETWORK_TIMEOUT: d.LoaderErrors.CONNECTING_TIMEOUT,
                NETWORK_UNRECOVERABLE_EARLY_EOF: d.LoaderErrors.UNRECOVERABLE_EARLY_EOF,
                MEDIA_MSE_ERROR: "MediaMSEError",
                MEDIA_FORMAT_ERROR: h.default.FORMAT_ERROR,
                MEDIA_FORMAT_UNSUPPORTED: h.default.FORMAT_UNSUPPORTED,
                MEDIA_CODEC_UNSUPPORTED: h.default.CODEC_UNSUPPORTED
              };
            }
          ),
          /***/
          "./src/player/player-events.js": (
            /*!*************************************!*\
              !*** ./src/player/player-events.js ***!
              \*************************************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = {
                ERROR: "error",
                LOADING_COMPLETE: "loading_complete",
                RECOVERED_EARLY_EOF: "recovered_early_eof",
                MEDIA_INFO: "media_info",
                METADATA_ARRIVED: "metadata_arrived",
                SCRIPTDATA_ARRIVED: "scriptdata_arrived",
                STATISTICS_INFO: "statistics_info"
              };
              a.default = d;
            }
          ),
          /***/
          "./src/remux/aac-silent.js": (
            /*!*********************************!*\
              !*** ./src/remux/aac-silent.js ***!
              \*********************************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = (
                /** @class */
                function() {
                  function h() {
                  }
                  return h.getSilentFrame = function(u, c) {
                    if (u === "mp4a.40.2") {
                      if (c === 1)
                        return new Uint8Array([0, 200, 0, 128, 35, 128]);
                      if (c === 2)
                        return new Uint8Array([33, 0, 73, 144, 2, 25, 0, 35, 128]);
                      if (c === 3)
                        return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 142]);
                      if (c === 4)
                        return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 128, 44, 128, 8, 2, 56]);
                      if (c === 5)
                        return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 56]);
                      if (c === 6)
                        return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 0, 178, 0, 32, 8, 224]);
                    } else {
                      if (c === 1)
                        return new Uint8Array([1, 64, 34, 128, 163, 78, 230, 128, 186, 8, 0, 0, 0, 28, 6, 241, 193, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
                      if (c === 2)
                        return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
                      if (c === 3)
                        return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
                    }
                    return null;
                  }, h;
                }()
              );
              a.default = d;
            }
          ),
          /***/
          "./src/remux/mp4-generator.js": (
            /*!************************************!*\
              !*** ./src/remux/mp4-generator.js ***!
              \************************************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = (
                /** @class */
                function() {
                  function h() {
                  }
                  return h.init = function() {
                    h.types = {
                      avc1: [],
                      avcC: [],
                      btrt: [],
                      dinf: [],
                      dref: [],
                      esds: [],
                      ftyp: [],
                      hdlr: [],
                      mdat: [],
                      mdhd: [],
                      mdia: [],
                      mfhd: [],
                      minf: [],
                      moof: [],
                      moov: [],
                      mp4a: [],
                      mvex: [],
                      mvhd: [],
                      sdtp: [],
                      stbl: [],
                      stco: [],
                      stsc: [],
                      stsd: [],
                      stsz: [],
                      stts: [],
                      tfdt: [],
                      tfhd: [],
                      traf: [],
                      trak: [],
                      trun: [],
                      trex: [],
                      tkhd: [],
                      vmhd: [],
                      smhd: [],
                      ".mp3": []
                    };
                    for (var u in h.types)
                      h.types.hasOwnProperty(u) && (h.types[u] = [
                        u.charCodeAt(0),
                        u.charCodeAt(1),
                        u.charCodeAt(2),
                        u.charCodeAt(3)
                      ]);
                    var c = h.constants = {};
                    c.FTYP = new Uint8Array([
                      105,
                      115,
                      111,
                      109,
                      0,
                      0,
                      0,
                      1,
                      105,
                      115,
                      111,
                      109,
                      97,
                      118,
                      99,
                      49
                      // avc1
                    ]), c.STSD_PREFIX = new Uint8Array([
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      1
                      // entry_count
                    ]), c.STTS = new Uint8Array([
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0
                      // entry_count
                    ]), c.STSC = c.STCO = c.STTS, c.STSZ = new Uint8Array([
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0
                      // sample_count
                    ]), c.HDLR_VIDEO = new Uint8Array([
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      118,
                      105,
                      100,
                      101,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      86,
                      105,
                      100,
                      101,
                      111,
                      72,
                      97,
                      110,
                      100,
                      108,
                      101,
                      114,
                      0
                      // name: VideoHandler
                    ]), c.HDLR_AUDIO = new Uint8Array([
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      115,
                      111,
                      117,
                      110,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      83,
                      111,
                      117,
                      110,
                      100,
                      72,
                      97,
                      110,
                      100,
                      108,
                      101,
                      114,
                      0
                      // name: SoundHandler
                    ]), c.DREF = new Uint8Array([
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      1,
                      0,
                      0,
                      0,
                      12,
                      117,
                      114,
                      108,
                      32,
                      0,
                      0,
                      0,
                      1
                      // version(0) + flags
                    ]), c.SMHD = new Uint8Array([
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0
                      // balance(2) + reserved(2)
                    ]), c.VMHD = new Uint8Array([
                      0,
                      0,
                      0,
                      1,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0
                    ]);
                  }, h.box = function(u) {
                    for (var c = 8, m = null, f = Array.prototype.slice.call(arguments, 1), p = f.length, A = 0; A < p; A++)
                      c += f[A].byteLength;
                    m = new Uint8Array(c), m[0] = c >>> 24 & 255, m[1] = c >>> 16 & 255, m[2] = c >>> 8 & 255, m[3] = c & 255, m.set(u, 4);
                    for (var v = 8, A = 0; A < p; A++)
                      m.set(f[A], v), v += f[A].byteLength;
                    return m;
                  }, h.generateInitSegment = function(u) {
                    var c = h.box(h.types.ftyp, h.constants.FTYP), m = h.moov(u), f = new Uint8Array(c.byteLength + m.byteLength);
                    return f.set(c, 0), f.set(m, c.byteLength), f;
                  }, h.moov = function(u) {
                    var c = h.mvhd(u.timescale, u.duration), m = h.trak(u), f = h.mvex(u);
                    return h.box(h.types.moov, c, m, f);
                  }, h.mvhd = function(u, c) {
                    return h.box(h.types.mvhd, new Uint8Array([
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      u >>> 24 & 255,
                      u >>> 16 & 255,
                      u >>> 8 & 255,
                      u & 255,
                      c >>> 24 & 255,
                      c >>> 16 & 255,
                      c >>> 8 & 255,
                      c & 255,
                      0,
                      1,
                      0,
                      0,
                      1,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      1,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      1,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      64,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      255,
                      255,
                      255,
                      255
                      // next_track_ID
                    ]));
                  }, h.trak = function(u) {
                    return h.box(h.types.trak, h.tkhd(u), h.mdia(u));
                  }, h.tkhd = function(u) {
                    var c = u.id, m = u.duration, f = u.presentWidth, p = u.presentHeight;
                    return h.box(h.types.tkhd, new Uint8Array([
                      0,
                      0,
                      0,
                      7,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      c >>> 24 & 255,
                      c >>> 16 & 255,
                      c >>> 8 & 255,
                      c & 255,
                      0,
                      0,
                      0,
                      0,
                      m >>> 24 & 255,
                      m >>> 16 & 255,
                      m >>> 8 & 255,
                      m & 255,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      1,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      1,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      64,
                      0,
                      0,
                      0,
                      f >>> 8 & 255,
                      f & 255,
                      0,
                      0,
                      p >>> 8 & 255,
                      p & 255,
                      0,
                      0
                    ]));
                  }, h.mdia = function(u) {
                    return h.box(h.types.mdia, h.mdhd(u), h.hdlr(u), h.minf(u));
                  }, h.mdhd = function(u) {
                    var c = u.timescale, m = u.duration;
                    return h.box(h.types.mdhd, new Uint8Array([
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      c >>> 24 & 255,
                      c >>> 16 & 255,
                      c >>> 8 & 255,
                      c & 255,
                      m >>> 24 & 255,
                      m >>> 16 & 255,
                      m >>> 8 & 255,
                      m & 255,
                      85,
                      196,
                      0,
                      0
                      // pre_defined = 0
                    ]));
                  }, h.hdlr = function(u) {
                    var c = null;
                    return u.type === "audio" ? c = h.constants.HDLR_AUDIO : c = h.constants.HDLR_VIDEO, h.box(h.types.hdlr, c);
                  }, h.minf = function(u) {
                    var c = null;
                    return u.type === "audio" ? c = h.box(h.types.smhd, h.constants.SMHD) : c = h.box(h.types.vmhd, h.constants.VMHD), h.box(h.types.minf, c, h.dinf(), h.stbl(u));
                  }, h.dinf = function() {
                    var u = h.box(h.types.dinf, h.box(h.types.dref, h.constants.DREF));
                    return u;
                  }, h.stbl = function(u) {
                    var c = h.box(
                      h.types.stbl,
                      // type: stbl
                      h.stsd(u),
                      // Sample Description Table
                      h.box(h.types.stts, h.constants.STTS),
                      // Time-To-Sample
                      h.box(h.types.stsc, h.constants.STSC),
                      // Sample-To-Chunk
                      h.box(h.types.stsz, h.constants.STSZ),
                      // Sample size
                      h.box(h.types.stco, h.constants.STCO)
                      // Chunk offset
                    );
                    return c;
                  }, h.stsd = function(u) {
                    return u.type === "audio" ? u.codec === "mp3" ? h.box(h.types.stsd, h.constants.STSD_PREFIX, h.mp3(u)) : h.box(h.types.stsd, h.constants.STSD_PREFIX, h.mp4a(u)) : h.box(h.types.stsd, h.constants.STSD_PREFIX, h.avc1(u));
                  }, h.mp3 = function(u) {
                    var c = u.channelCount, m = u.audioSampleRate, f = new Uint8Array([
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      1,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      c,
                      0,
                      16,
                      0,
                      0,
                      0,
                      0,
                      m >>> 8 & 255,
                      m & 255,
                      0,
                      0
                    ]);
                    return h.box(h.types[".mp3"], f);
                  }, h.mp4a = function(u) {
                    var c = u.channelCount, m = u.audioSampleRate, f = new Uint8Array([
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      1,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      c,
                      0,
                      16,
                      0,
                      0,
                      0,
                      0,
                      m >>> 8 & 255,
                      m & 255,
                      0,
                      0
                    ]);
                    return h.box(h.types.mp4a, f, h.esds(u));
                  }, h.esds = function(u) {
                    var c = u.config || [], m = c.length, f = new Uint8Array([
                      0,
                      0,
                      0,
                      0,
                      3,
                      23 + m,
                      0,
                      1,
                      0,
                      4,
                      15 + m,
                      64,
                      21,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      5
                      // descriptor_type
                    ].concat([
                      m
                    ]).concat(c).concat([
                      6,
                      1,
                      2
                      // GASpecificConfig
                    ]));
                    return h.box(h.types.esds, f);
                  }, h.avc1 = function(u) {
                    var c = u.avcc, m = u.codecWidth, f = u.codecHeight, p = new Uint8Array([
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      1,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      m >>> 8 & 255,
                      m & 255,
                      f >>> 8 & 255,
                      f & 255,
                      0,
                      72,
                      0,
                      0,
                      0,
                      72,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      1,
                      10,
                      120,
                      113,
                      113,
                      47,
                      102,
                      108,
                      118,
                      46,
                      106,
                      115,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      24,
                      255,
                      255
                      // pre_defined = -1
                    ]);
                    return h.box(h.types.avc1, p, h.box(h.types.avcC, c));
                  }, h.mvex = function(u) {
                    return h.box(h.types.mvex, h.trex(u));
                  }, h.trex = function(u) {
                    var c = u.id, m = new Uint8Array([
                      0,
                      0,
                      0,
                      0,
                      c >>> 24 & 255,
                      c >>> 16 & 255,
                      c >>> 8 & 255,
                      c & 255,
                      0,
                      0,
                      0,
                      1,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      1,
                      0,
                      1
                      // default_sample_flags
                    ]);
                    return h.box(h.types.trex, m);
                  }, h.moof = function(u, c) {
                    return h.box(h.types.moof, h.mfhd(u.sequenceNumber), h.traf(u, c));
                  }, h.mfhd = function(u) {
                    var c = new Uint8Array([
                      0,
                      0,
                      0,
                      0,
                      u >>> 24 & 255,
                      u >>> 16 & 255,
                      u >>> 8 & 255,
                      u & 255
                    ]);
                    return h.box(h.types.mfhd, c);
                  }, h.traf = function(u, c) {
                    var m = u.id, f = h.box(h.types.tfhd, new Uint8Array([
                      0,
                      0,
                      0,
                      0,
                      m >>> 24 & 255,
                      m >>> 16 & 255,
                      m >>> 8 & 255,
                      m & 255
                    ])), p = h.box(h.types.tfdt, new Uint8Array([
                      0,
                      0,
                      0,
                      0,
                      c >>> 24 & 255,
                      c >>> 16 & 255,
                      c >>> 8 & 255,
                      c & 255
                    ])), A = h.sdtp(u), v = h.trun(u, A.byteLength + 16 + 16 + 8 + 16 + 8 + 8);
                    return h.box(h.types.traf, f, p, v, A);
                  }, h.sdtp = function(u) {
                    for (var c = u.samples || [], m = c.length, f = new Uint8Array(4 + m), p = 0; p < m; p++) {
                      var A = c[p].flags;
                      f[p + 4] = A.isLeading << 6 | A.dependsOn << 4 | A.isDependedOn << 2 | A.hasRedundancy;
                    }
                    return h.box(h.types.sdtp, f);
                  }, h.trun = function(u, c) {
                    var m = u.samples || [], f = m.length, p = 12 + 16 * f, A = new Uint8Array(p);
                    c += 8 + p, A.set([
                      0,
                      0,
                      15,
                      1,
                      f >>> 24 & 255,
                      f >>> 16 & 255,
                      f >>> 8 & 255,
                      f & 255,
                      c >>> 24 & 255,
                      c >>> 16 & 255,
                      c >>> 8 & 255,
                      c & 255
                    ], 0);
                    for (var v = 0; v < f; v++) {
                      var b = m[v].duration, _ = m[v].size, T = m[v].flags, E = m[v].cts;
                      A.set([
                        b >>> 24 & 255,
                        b >>> 16 & 255,
                        b >>> 8 & 255,
                        b & 255,
                        _ >>> 24 & 255,
                        _ >>> 16 & 255,
                        _ >>> 8 & 255,
                        _ & 255,
                        T.isLeading << 2 | T.dependsOn,
                        T.isDependedOn << 6 | T.hasRedundancy << 4 | T.isNonSync,
                        0,
                        0,
                        E >>> 24 & 255,
                        E >>> 16 & 255,
                        E >>> 8 & 255,
                        E & 255
                      ], 12 + 16 * v);
                    }
                    return h.box(h.types.trun, A);
                  }, h.mdat = function(u) {
                    return h.box(h.types.mdat, u);
                  }, h;
                }()
              );
              d.init(), a.default = d;
            }
          ),
          /***/
          "./src/remux/mp4-remuxer.js": (
            /*!**********************************!*\
              !*** ./src/remux/mp4-remuxer.js ***!
              \**********************************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = l(
                /*! ../utils/logger.js */
                "./src/utils/logger.js"
              ), h = l(
                /*! ./mp4-generator.js */
                "./src/remux/mp4-generator.js"
              ), u = l(
                /*! ./aac-silent.js */
                "./src/remux/aac-silent.js"
              ), c = l(
                /*! ../utils/browser.js */
                "./src/utils/browser.js"
              ), m = l(
                /*! ../core/media-segment-info.js */
                "./src/core/media-segment-info.js"
              ), f = l(
                /*! ../utils/exception.js */
                "./src/utils/exception.js"
              ), p = (
                /** @class */
                function() {
                  function A(v) {
                    this.TAG = "MP4Remuxer", this._config = v, this._isLive = v.isLive === !0, this._dtsBase = -1, this._dtsBaseInited = !1, this._audioDtsBase = 1 / 0, this._videoDtsBase = 1 / 0, this._audioNextDts = void 0, this._videoNextDts = void 0, this._audioStashedLastSample = null, this._videoStashedLastSample = null, this._audioMeta = null, this._videoMeta = null, this._audioSegmentInfoList = new m.MediaSegmentInfoList("audio"), this._videoSegmentInfoList = new m.MediaSegmentInfoList("video"), this._onInitSegment = null, this._onMediaSegment = null, this._forceFirstIDR = !!(c.default.chrome && (c.default.version.major < 50 || c.default.version.major === 50 && c.default.version.build < 2661)), this._fillSilentAfterSeek = c.default.msedge || c.default.msie, this._mp3UseMpegAudio = !c.default.firefox, this._fillAudioTimestampGap = this._config.fixAudioTimestampGap;
                  }
                  return A.prototype.destroy = function() {
                    this._dtsBase = -1, this._dtsBaseInited = !1, this._audioMeta = null, this._videoMeta = null, this._audioSegmentInfoList.clear(), this._audioSegmentInfoList = null, this._videoSegmentInfoList.clear(), this._videoSegmentInfoList = null, this._onInitSegment = null, this._onMediaSegment = null;
                  }, A.prototype.bindDataSource = function(v) {
                    return v.onDataAvailable = this.remux.bind(this), v.onTrackMetadata = this._onTrackMetadataReceived.bind(this), this;
                  }, Object.defineProperty(A.prototype, "onInitSegment", {
                    /* prototype: function onInitSegment(type: string, initSegment: ArrayBuffer): void
                       InitSegment: {
                           type: string,
                           data: ArrayBuffer,
                           codec: string,
                           container: string
                       }
                    */
                    get: function() {
                      return this._onInitSegment;
                    },
                    set: function(v) {
                      this._onInitSegment = v;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(A.prototype, "onMediaSegment", {
                    /* prototype: function onMediaSegment(type: string, mediaSegment: MediaSegment): void
                       MediaSegment: {
                           type: string,
                           data: ArrayBuffer,
                           sampleCount: int32
                           info: MediaSegmentInfo
                       }
                    */
                    get: function() {
                      return this._onMediaSegment;
                    },
                    set: function(v) {
                      this._onMediaSegment = v;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), A.prototype.insertDiscontinuity = function() {
                    this._audioNextDts = this._videoNextDts = void 0;
                  }, A.prototype.seek = function(v) {
                    this._audioStashedLastSample = null, this._videoStashedLastSample = null, this._videoSegmentInfoList.clear(), this._audioSegmentInfoList.clear();
                  }, A.prototype.remux = function(v, b) {
                    if (!this._onMediaSegment)
                      throw new f.IllegalStateException("MP4Remuxer: onMediaSegment callback must be specificed!");
                    this._dtsBaseInited || this._calculateDtsBase(v, b), this._remuxVideo(b), this._remuxAudio(v);
                  }, A.prototype._onTrackMetadataReceived = function(v, b) {
                    var _ = null, T = "mp4", E = b.codec;
                    if (v === "audio")
                      this._audioMeta = b, b.codec === "mp3" && this._mp3UseMpegAudio ? (T = "mpeg", E = "", _ = new Uint8Array()) : _ = h.default.generateInitSegment(b);
                    else if (v === "video")
                      this._videoMeta = b, _ = h.default.generateInitSegment(b);
                    else
                      return;
                    if (!this._onInitSegment)
                      throw new f.IllegalStateException("MP4Remuxer: onInitSegment callback must be specified!");
                    this._onInitSegment(v, {
                      type: v,
                      data: _.buffer,
                      codec: E,
                      container: v + "/" + T,
                      mediaDuration: b.duration
                      // in timescale 1000 (milliseconds)
                    });
                  }, A.prototype._calculateDtsBase = function(v, b) {
                    this._dtsBaseInited || (v.samples && v.samples.length && (this._audioDtsBase = v.samples[0].dts), b.samples && b.samples.length && (this._videoDtsBase = b.samples[0].dts), this._dtsBase = Math.min(this._audioDtsBase, this._videoDtsBase), this._dtsBaseInited = !0);
                  }, A.prototype.flushStashedSamples = function() {
                    var v = this._videoStashedLastSample, b = this._audioStashedLastSample, _ = {
                      type: "video",
                      id: 1,
                      sequenceNumber: 0,
                      samples: [],
                      length: 0
                    };
                    v != null && (_.samples.push(v), _.length = v.length);
                    var T = {
                      type: "audio",
                      id: 2,
                      sequenceNumber: 0,
                      samples: [],
                      length: 0
                    };
                    b != null && (T.samples.push(b), T.length = b.length), this._videoStashedLastSample = null, this._audioStashedLastSample = null, this._remuxVideo(_, !0), this._remuxAudio(T, !0);
                  }, A.prototype._remuxAudio = function(v, b) {
                    if (this._audioMeta != null) {
                      var _ = v, T = _.samples, E = void 0, L = -1, k = -1, D = this._audioMeta.refSampleDuration, M = this._audioMeta.codec === "mp3" && this._mp3UseMpegAudio, O = this._dtsBaseInited && this._audioNextDts === void 0, N = !1;
                      if (!(!T || T.length === 0) && !(T.length === 1 && !b)) {
                        var B = 0, U = null, G = 0;
                        M ? (B = 0, G = _.length) : (B = 8, G = 8 + _.length);
                        var Y = null;
                        if (T.length > 1 && (Y = T.pop(), G -= Y.length), this._audioStashedLastSample != null) {
                          var z = this._audioStashedLastSample;
                          this._audioStashedLastSample = null, T.unshift(z), G += z.length;
                        }
                        Y != null && (this._audioStashedLastSample = Y);
                        var J = T[0].dts - this._dtsBase;
                        if (this._audioNextDts)
                          E = J - this._audioNextDts;
                        else if (this._audioSegmentInfoList.isEmpty())
                          E = 0, this._fillSilentAfterSeek && !this._videoSegmentInfoList.isEmpty() && this._audioMeta.originalCodec !== "mp3" && (N = !0);
                        else {
                          var le = this._audioSegmentInfoList.getLastSampleBefore(J);
                          if (le != null) {
                            var W = J - (le.originalDts + le.duration);
                            W <= 3 && (W = 0);
                            var Z = le.dts + le.duration + W;
                            E = J - Z;
                          } else
                            E = 0;
                        }
                        if (N) {
                          var ce = J - E, ue = this._videoSegmentInfoList.getLastSegmentBefore(J);
                          if (ue != null && ue.beginDts < ce) {
                            var re = u.default.getSilentFrame(this._audioMeta.originalCodec, this._audioMeta.channelCount);
                            if (re) {
                              var me = ue.beginDts, Be = ce - ue.beginDts;
                              d.default.v(this.TAG, "InsertPrefixSilentAudio: dts: " + me + ", duration: " + Be), T.unshift({ unit: re, dts: me, pts: me }), G += re.byteLength;
                            }
                          } else
                            N = !1;
                        }
                        for (var ye = [], Le = 0; Le < T.length; Le++) {
                          var z = T[Le], Pe = z.unit, Me = z.dts - this._dtsBase, me = Me, qe = !1, ft = null, De = 0;
                          if (!(Me < -1e-3)) {
                            if (this._audioMeta.codec !== "mp3") {
                              var ve = Me, Je = 3;
                              if (this._audioNextDts && (ve = this._audioNextDts), E = Me - ve, E <= -Je * D) {
                                d.default.w(this.TAG, "Dropping 1 audio frame (originalDts: " + Me + " ms ,curRefDts: " + ve + " ms)  due to dtsCorrection: " + E + " ms overlap.");
                                continue;
                              } else if (E >= Je * D && this._fillAudioTimestampGap && !c.default.safari) {
                                qe = !0;
                                var Xe = Math.floor(E / D);
                                d.default.w(this.TAG, `Large audio timestamp gap detected, may cause AV sync to drift. Silent frames will be generated to avoid unsync.
` + ("originalDts: " + Me + " ms, curRefDts: " + ve + " ms, ") + ("dtsCorrection: " + Math.round(E) + " ms, generate: " + Xe + " frames")), me = Math.floor(ve), De = Math.floor(ve + D) - me;
                                var re = u.default.getSilentFrame(this._audioMeta.originalCodec, this._audioMeta.channelCount);
                                re == null && (d.default.w(this.TAG, "Unable to generate silent frame for " + (this._audioMeta.originalCodec + " with " + this._audioMeta.channelCount + " channels, repeat last frame")), re = Pe), ft = [];
                                for (var Oe = 0; Oe < Xe; Oe++) {
                                  ve = ve + D;
                                  var Ke = Math.floor(ve), We = Math.floor(ve + D) - Ke, tt = {
                                    dts: Ke,
                                    pts: Ke,
                                    cts: 0,
                                    unit: re,
                                    size: re.byteLength,
                                    duration: We,
                                    originalDts: Me,
                                    flags: {
                                      isLeading: 0,
                                      dependsOn: 1,
                                      isDependedOn: 0,
                                      hasRedundancy: 0
                                    }
                                  };
                                  ft.push(tt), G += tt.size;
                                }
                                this._audioNextDts = ve + D;
                              } else
                                me = Math.floor(ve), De = Math.floor(ve + D) - me, this._audioNextDts = ve + D;
                            } else {
                              if (me = Me - E, Le !== T.length - 1) {
                                var et = T[Le + 1].dts - this._dtsBase - E;
                                De = et - me;
                              } else if (Y != null) {
                                var et = Y.dts - this._dtsBase - E;
                                De = et - me;
                              } else
                                ye.length >= 1 ? De = ye[ye.length - 1].duration : De = Math.floor(D);
                              this._audioNextDts = me + De;
                            }
                            L === -1 && (L = me), ye.push({
                              dts: me,
                              pts: me,
                              cts: 0,
                              unit: z.unit,
                              size: z.unit.byteLength,
                              duration: De,
                              originalDts: Me,
                              flags: {
                                isLeading: 0,
                                dependsOn: 1,
                                isDependedOn: 0,
                                hasRedundancy: 0
                              }
                            }), qe && ye.push.apply(ye, ft);
                          }
                        }
                        if (ye.length === 0) {
                          _.samples = [], _.length = 0;
                          return;
                        }
                        M ? U = new Uint8Array(G) : (U = new Uint8Array(G), U[0] = G >>> 24 & 255, U[1] = G >>> 16 & 255, U[2] = G >>> 8 & 255, U[3] = G & 255, U.set(h.default.types.mdat, 4));
                        for (var Le = 0; Le < ye.length; Le++) {
                          var Pe = ye[Le].unit;
                          U.set(Pe, B), B += Pe.byteLength;
                        }
                        var ze = ye[ye.length - 1];
                        k = ze.dts + ze.duration;
                        var $e = new m.MediaSegmentInfo();
                        $e.beginDts = L, $e.endDts = k, $e.beginPts = L, $e.endPts = k, $e.originalBeginDts = ye[0].originalDts, $e.originalEndDts = ze.originalDts + ze.duration, $e.firstSample = new m.SampleInfo(ye[0].dts, ye[0].pts, ye[0].duration, ye[0].originalDts, !1), $e.lastSample = new m.SampleInfo(ze.dts, ze.pts, ze.duration, ze.originalDts, !1), this._isLive || this._audioSegmentInfoList.append($e), _.samples = ye, _.sequenceNumber++;
                        var gt = null;
                        M ? gt = new Uint8Array() : gt = h.default.moof(_, L), _.samples = [], _.length = 0;
                        var pt = {
                          type: "audio",
                          data: this._mergeBoxes(gt, U).buffer,
                          sampleCount: ye.length,
                          info: $e
                        };
                        M && O && (pt.timestampOffset = L), this._onMediaSegment("audio", pt);
                      }
                    }
                  }, A.prototype._remuxVideo = function(v, b) {
                    if (this._videoMeta != null) {
                      var _ = v, T = _.samples, E = void 0, L = -1, k = -1, D = -1, M = -1;
                      if (!(!T || T.length === 0) && !(T.length === 1 && !b)) {
                        var O = 8, N = null, B = 8 + v.length, U = null;
                        if (T.length > 1 && (U = T.pop(), B -= U.length), this._videoStashedLastSample != null) {
                          var G = this._videoStashedLastSample;
                          this._videoStashedLastSample = null, T.unshift(G), B += G.length;
                        }
                        U != null && (this._videoStashedLastSample = U);
                        var Y = T[0].dts - this._dtsBase;
                        if (this._videoNextDts)
                          E = Y - this._videoNextDts;
                        else if (this._videoSegmentInfoList.isEmpty())
                          E = 0;
                        else {
                          var z = this._videoSegmentInfoList.getLastSampleBefore(Y);
                          if (z != null) {
                            var J = Y - (z.originalDts + z.duration);
                            J <= 3 && (J = 0);
                            var le = z.dts + z.duration + J;
                            E = Y - le;
                          } else
                            E = 0;
                        }
                        for (var W = new m.MediaSegmentInfo(), Z = [], ce = 0; ce < T.length; ce++) {
                          var G = T[ce], ue = G.dts - this._dtsBase, re = G.isKeyframe, me = ue - E, Be = G.cts, ye = me + Be;
                          L === -1 && (L = me, D = ye);
                          var Le = 0;
                          if (ce !== T.length - 1) {
                            var Pe = T[ce + 1].dts - this._dtsBase - E;
                            Le = Pe - me;
                          } else if (U != null) {
                            var Pe = U.dts - this._dtsBase - E;
                            Le = Pe - me;
                          } else
                            Z.length >= 1 ? Le = Z[Z.length - 1].duration : Le = Math.floor(this._videoMeta.refSampleDuration);
                          if (re) {
                            var Me = new m.SampleInfo(me, ye, Le, G.dts, !0);
                            Me.fileposition = G.fileposition, W.appendSyncPoint(Me);
                          }
                          Z.push({
                            dts: me,
                            pts: ye,
                            cts: Be,
                            units: G.units,
                            size: G.length,
                            isKeyframe: re,
                            duration: Le,
                            originalDts: ue,
                            flags: {
                              isLeading: 0,
                              dependsOn: re ? 2 : 1,
                              isDependedOn: re ? 1 : 0,
                              hasRedundancy: 0,
                              isNonSync: re ? 0 : 1
                            }
                          });
                        }
                        N = new Uint8Array(B), N[0] = B >>> 24 & 255, N[1] = B >>> 16 & 255, N[2] = B >>> 8 & 255, N[3] = B & 255, N.set(h.default.types.mdat, 4);
                        for (var ce = 0; ce < Z.length; ce++)
                          for (var qe = Z[ce].units; qe.length; ) {
                            var ft = qe.shift(), De = ft.data;
                            N.set(De, O), O += De.byteLength;
                          }
                        var ve = Z[Z.length - 1];
                        if (k = ve.dts + ve.duration, M = ve.pts + ve.duration, this._videoNextDts = k, W.beginDts = L, W.endDts = k, W.beginPts = D, W.endPts = M, W.originalBeginDts = Z[0].originalDts, W.originalEndDts = ve.originalDts + ve.duration, W.firstSample = new m.SampleInfo(Z[0].dts, Z[0].pts, Z[0].duration, Z[0].originalDts, Z[0].isKeyframe), W.lastSample = new m.SampleInfo(ve.dts, ve.pts, ve.duration, ve.originalDts, ve.isKeyframe), this._isLive || this._videoSegmentInfoList.append(W), _.samples = Z, _.sequenceNumber++, this._forceFirstIDR) {
                          var Je = Z[0].flags;
                          Je.dependsOn = 2, Je.isNonSync = 0;
                        }
                        var Xe = h.default.moof(_, L);
                        _.samples = [], _.length = 0, this._onMediaSegment("video", {
                          type: "video",
                          data: this._mergeBoxes(Xe, N).buffer,
                          sampleCount: Z.length,
                          info: W
                        });
                      }
                    }
                  }, A.prototype._mergeBoxes = function(v, b) {
                    var _ = new Uint8Array(v.byteLength + b.byteLength);
                    return _.set(v, 0), _.set(b, v.byteLength), _;
                  }, A;
                }()
              );
              a.default = p;
            }
          ),
          /***/
          "./src/utils/browser.js": (
            /*!******************************!*\
              !*** ./src/utils/browser.js ***!
              \******************************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = {};
              function h() {
                var u = self.navigator.userAgent.toLowerCase(), c = /(edge)\/([\w.]+)/.exec(u) || /(opr)[\/]([\w.]+)/.exec(u) || /(chrome)[ \/]([\w.]+)/.exec(u) || /(iemobile)[\/]([\w.]+)/.exec(u) || /(version)(applewebkit)[ \/]([\w.]+).*(safari)[ \/]([\w.]+)/.exec(u) || /(webkit)[ \/]([\w.]+).*(version)[ \/]([\w.]+).*(safari)[ \/]([\w.]+)/.exec(u) || /(webkit)[ \/]([\w.]+)/.exec(u) || /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(u) || /(msie) ([\w.]+)/.exec(u) || u.indexOf("trident") >= 0 && /(rv)(?::| )([\w.]+)/.exec(u) || u.indexOf("compatible") < 0 && /(firefox)[ \/]([\w.]+)/.exec(u) || [], m = /(ipad)/.exec(u) || /(ipod)/.exec(u) || /(windows phone)/.exec(u) || /(iphone)/.exec(u) || /(kindle)/.exec(u) || /(android)/.exec(u) || /(windows)/.exec(u) || /(mac)/.exec(u) || /(linux)/.exec(u) || /(cros)/.exec(u) || [], f = {
                  browser: c[5] || c[3] || c[1] || "",
                  version: c[2] || c[4] || "0",
                  majorVersion: c[4] || c[2] || "0",
                  platform: m[0] || ""
                }, p = {};
                if (f.browser) {
                  p[f.browser] = !0;
                  var A = f.majorVersion.split(".");
                  p.version = {
                    major: parseInt(f.majorVersion, 10),
                    string: f.version
                  }, A.length > 1 && (p.version.minor = parseInt(A[1], 10)), A.length > 2 && (p.version.build = parseInt(A[2], 10));
                }
                if (f.platform && (p[f.platform] = !0), (p.chrome || p.opr || p.safari) && (p.webkit = !0), p.rv || p.iemobile) {
                  p.rv && delete p.rv;
                  var v = "msie";
                  f.browser = v, p[v] = !0;
                }
                if (p.edge) {
                  delete p.edge;
                  var b = "msedge";
                  f.browser = b, p[b] = !0;
                }
                if (p.opr) {
                  var _ = "opera";
                  f.browser = _, p[_] = !0;
                }
                if (p.safari && p.android) {
                  var T = "android";
                  f.browser = T, p[T] = !0;
                }
                p.name = f.browser, p.platform = f.platform;
                for (var E in d)
                  d.hasOwnProperty(E) && delete d[E];
                Object.assign(d, p);
              }
              h(), a.default = d;
            }
          ),
          /***/
          "./src/utils/exception.js": (
            /*!********************************!*\
              !*** ./src/utils/exception.js ***!
              \********************************/
            /***/
            function(s, a, l) {
              l.r(a), l.d(a, {
                /* harmony export */
                RuntimeException: function() {
                  return (
                    /* binding */
                    h
                  );
                },
                /* harmony export */
                IllegalStateException: function() {
                  return (
                    /* binding */
                    u
                  );
                },
                /* harmony export */
                InvalidArgumentException: function() {
                  return (
                    /* binding */
                    c
                  );
                },
                /* harmony export */
                NotImplementedException: function() {
                  return (
                    /* binding */
                    m
                  );
                }
                /* harmony export */
              });
              var d = function() {
                var f = function(p, A) {
                  return f = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(v, b) {
                    v.__proto__ = b;
                  } || function(v, b) {
                    for (var _ in b)
                      Object.prototype.hasOwnProperty.call(b, _) && (v[_] = b[_]);
                  }, f(p, A);
                };
                return function(p, A) {
                  if (typeof A != "function" && A !== null)
                    throw new TypeError("Class extends value " + String(A) + " is not a constructor or null");
                  f(p, A);
                  function v() {
                    this.constructor = p;
                  }
                  p.prototype = A === null ? Object.create(A) : (v.prototype = A.prototype, new v());
                };
              }(), h = (
                /** @class */
                function() {
                  function f(p) {
                    this._message = p;
                  }
                  return Object.defineProperty(f.prototype, "name", {
                    get: function() {
                      return "RuntimeException";
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(f.prototype, "message", {
                    get: function() {
                      return this._message;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), f.prototype.toString = function() {
                    return this.name + ": " + this.message;
                  }, f;
                }()
              ), u = (
                /** @class */
                function(f) {
                  d(p, f);
                  function p(A) {
                    return f.call(this, A) || this;
                  }
                  return Object.defineProperty(p.prototype, "name", {
                    get: function() {
                      return "IllegalStateException";
                    },
                    enumerable: !1,
                    configurable: !0
                  }), p;
                }(h)
              ), c = (
                /** @class */
                function(f) {
                  d(p, f);
                  function p(A) {
                    return f.call(this, A) || this;
                  }
                  return Object.defineProperty(p.prototype, "name", {
                    get: function() {
                      return "InvalidArgumentException";
                    },
                    enumerable: !1,
                    configurable: !0
                  }), p;
                }(h)
              ), m = (
                /** @class */
                function(f) {
                  d(p, f);
                  function p(A) {
                    return f.call(this, A) || this;
                  }
                  return Object.defineProperty(p.prototype, "name", {
                    get: function() {
                      return "NotImplementedException";
                    },
                    enumerable: !1,
                    configurable: !0
                  }), p;
                }(h)
              );
            }
          ),
          /***/
          "./src/utils/logger.js": (
            /*!*****************************!*\
              !*** ./src/utils/logger.js ***!
              \*****************************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = l(
                /*! events */
                "./node_modules/events/events.js"
              ), h = /* @__PURE__ */ l.n(d), u = (
                /** @class */
                function() {
                  function c() {
                  }
                  return c.e = function(m, f) {
                    (!m || c.FORCE_GLOBAL_TAG) && (m = c.GLOBAL_TAG);
                    var p = "[" + m + "] > " + f;
                    c.ENABLE_CALLBACK && c.emitter.emit("log", "error", p), c.ENABLE_ERROR && (console.error ? console.error(p) : console.warn ? console.warn(p) : console.log(p));
                  }, c.i = function(m, f) {
                    (!m || c.FORCE_GLOBAL_TAG) && (m = c.GLOBAL_TAG);
                    var p = "[" + m + "] > " + f;
                    c.ENABLE_CALLBACK && c.emitter.emit("log", "info", p), c.ENABLE_INFO && (console.info ? console.info(p) : console.log(p));
                  }, c.w = function(m, f) {
                    (!m || c.FORCE_GLOBAL_TAG) && (m = c.GLOBAL_TAG);
                    var p = "[" + m + "] > " + f;
                    c.ENABLE_CALLBACK && c.emitter.emit("log", "warn", p), c.ENABLE_WARN && (console.warn ? console.warn(p) : console.log(p));
                  }, c.d = function(m, f) {
                    (!m || c.FORCE_GLOBAL_TAG) && (m = c.GLOBAL_TAG);
                    var p = "[" + m + "] > " + f;
                    c.ENABLE_CALLBACK && c.emitter.emit("log", "debug", p), c.ENABLE_DEBUG && (console.debug ? console.debug(p) : console.log(p));
                  }, c.v = function(m, f) {
                    (!m || c.FORCE_GLOBAL_TAG) && (m = c.GLOBAL_TAG);
                    var p = "[" + m + "] > " + f;
                    c.ENABLE_CALLBACK && c.emitter.emit("log", "verbose", p), c.ENABLE_VERBOSE && console.log(p);
                  }, c;
                }()
              );
              u.GLOBAL_TAG = "flv.js", u.FORCE_GLOBAL_TAG = !1, u.ENABLE_ERROR = !0, u.ENABLE_INFO = !0, u.ENABLE_WARN = !0, u.ENABLE_DEBUG = !0, u.ENABLE_VERBOSE = !0, u.ENABLE_CALLBACK = !1, u.emitter = new (h())(), a.default = u;
            }
          ),
          /***/
          "./src/utils/logging-control.js": (
            /*!**************************************!*\
              !*** ./src/utils/logging-control.js ***!
              \**************************************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = l(
                /*! events */
                "./node_modules/events/events.js"
              ), h = /* @__PURE__ */ l.n(d), u = l(
                /*! ./logger.js */
                "./src/utils/logger.js"
              ), c = (
                /** @class */
                function() {
                  function m() {
                  }
                  return Object.defineProperty(m, "forceGlobalTag", {
                    get: function() {
                      return u.default.FORCE_GLOBAL_TAG;
                    },
                    set: function(f) {
                      u.default.FORCE_GLOBAL_TAG = f, m._notifyChange();
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(m, "globalTag", {
                    get: function() {
                      return u.default.GLOBAL_TAG;
                    },
                    set: function(f) {
                      u.default.GLOBAL_TAG = f, m._notifyChange();
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(m, "enableAll", {
                    get: function() {
                      return u.default.ENABLE_VERBOSE && u.default.ENABLE_DEBUG && u.default.ENABLE_INFO && u.default.ENABLE_WARN && u.default.ENABLE_ERROR;
                    },
                    set: function(f) {
                      u.default.ENABLE_VERBOSE = f, u.default.ENABLE_DEBUG = f, u.default.ENABLE_INFO = f, u.default.ENABLE_WARN = f, u.default.ENABLE_ERROR = f, m._notifyChange();
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(m, "enableDebug", {
                    get: function() {
                      return u.default.ENABLE_DEBUG;
                    },
                    set: function(f) {
                      u.default.ENABLE_DEBUG = f, m._notifyChange();
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(m, "enableVerbose", {
                    get: function() {
                      return u.default.ENABLE_VERBOSE;
                    },
                    set: function(f) {
                      u.default.ENABLE_VERBOSE = f, m._notifyChange();
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(m, "enableInfo", {
                    get: function() {
                      return u.default.ENABLE_INFO;
                    },
                    set: function(f) {
                      u.default.ENABLE_INFO = f, m._notifyChange();
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(m, "enableWarn", {
                    get: function() {
                      return u.default.ENABLE_WARN;
                    },
                    set: function(f) {
                      u.default.ENABLE_WARN = f, m._notifyChange();
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(m, "enableError", {
                    get: function() {
                      return u.default.ENABLE_ERROR;
                    },
                    set: function(f) {
                      u.default.ENABLE_ERROR = f, m._notifyChange();
                    },
                    enumerable: !1,
                    configurable: !0
                  }), m.getConfig = function() {
                    return {
                      globalTag: u.default.GLOBAL_TAG,
                      forceGlobalTag: u.default.FORCE_GLOBAL_TAG,
                      enableVerbose: u.default.ENABLE_VERBOSE,
                      enableDebug: u.default.ENABLE_DEBUG,
                      enableInfo: u.default.ENABLE_INFO,
                      enableWarn: u.default.ENABLE_WARN,
                      enableError: u.default.ENABLE_ERROR,
                      enableCallback: u.default.ENABLE_CALLBACK
                    };
                  }, m.applyConfig = function(f) {
                    u.default.GLOBAL_TAG = f.globalTag, u.default.FORCE_GLOBAL_TAG = f.forceGlobalTag, u.default.ENABLE_VERBOSE = f.enableVerbose, u.default.ENABLE_DEBUG = f.enableDebug, u.default.ENABLE_INFO = f.enableInfo, u.default.ENABLE_WARN = f.enableWarn, u.default.ENABLE_ERROR = f.enableError, u.default.ENABLE_CALLBACK = f.enableCallback;
                  }, m._notifyChange = function() {
                    var f = m.emitter;
                    if (f.listenerCount("change") > 0) {
                      var p = m.getConfig();
                      f.emit("change", p);
                    }
                  }, m.registerListener = function(f) {
                    m.emitter.addListener("change", f);
                  }, m.removeListener = function(f) {
                    m.emitter.removeListener("change", f);
                  }, m.addLogListener = function(f) {
                    u.default.emitter.addListener("log", f), u.default.emitter.listenerCount("log") > 0 && (u.default.ENABLE_CALLBACK = !0, m._notifyChange());
                  }, m.removeLogListener = function(f) {
                    u.default.emitter.removeListener("log", f), u.default.emitter.listenerCount("log") === 0 && (u.default.ENABLE_CALLBACK = !1, m._notifyChange());
                  }, m;
                }()
              );
              c.emitter = new (h())(), a.default = c;
            }
          ),
          /***/
          "./src/utils/polyfill.js": (
            /*!*******************************!*\
              !*** ./src/utils/polyfill.js ***!
              \*******************************/
            /***/
            function(s, a, l) {
              l.r(a);
              var d = (
                /** @class */
                function() {
                  function h() {
                  }
                  return h.install = function() {
                    Object.setPrototypeOf = Object.setPrototypeOf || function(u, c) {
                      return u.__proto__ = c, u;
                    }, Object.assign = Object.assign || function(u) {
                      if (u == null)
                        throw new TypeError("Cannot convert undefined or null to object");
                      for (var c = Object(u), m = 1; m < arguments.length; m++) {
                        var f = arguments[m];
                        if (f != null)
                          for (var p in f)
                            f.hasOwnProperty(p) && (c[p] = f[p]);
                      }
                      return c;
                    }, typeof self.Promise != "function" && l(
                      /*! es6-promise */
                      "./node_modules/es6-promise/dist/es6-promise.js"
                    ).polyfill();
                  }, h;
                }()
              );
              d.install(), a.default = d;
            }
          ),
          /***/
          "./src/utils/utf8-conv.js": (
            /*!********************************!*\
              !*** ./src/utils/utf8-conv.js ***!
              \********************************/
            /***/
            function(s, a, l) {
              l.r(a);
              function d(u, c, m) {
                var f = u;
                if (c + m < f.length) {
                  for (; m--; )
                    if ((f[++c] & 192) !== 128)
                      return !1;
                  return !0;
                } else
                  return !1;
              }
              function h(u) {
                for (var c = [], m = u, f = 0, p = u.length; f < p; ) {
                  if (m[f] < 128) {
                    c.push(String.fromCharCode(m[f])), ++f;
                    continue;
                  } else if (!(m[f] < 192)) {
                    if (m[f] < 224) {
                      if (d(m, f, 1)) {
                        var A = (m[f] & 31) << 6 | m[f + 1] & 63;
                        if (A >= 128) {
                          c.push(String.fromCharCode(A & 65535)), f += 2;
                          continue;
                        }
                      }
                    } else if (m[f] < 240) {
                      if (d(m, f, 2)) {
                        var A = (m[f] & 15) << 12 | (m[f + 1] & 63) << 6 | m[f + 2] & 63;
                        if (A >= 2048 && (A & 63488) !== 55296) {
                          c.push(String.fromCharCode(A & 65535)), f += 3;
                          continue;
                        }
                      }
                    } else if (m[f] < 248 && d(m, f, 3)) {
                      var A = (m[f] & 7) << 18 | (m[f + 1] & 63) << 12 | (m[f + 2] & 63) << 6 | m[f + 3] & 63;
                      if (A > 65536 && A < 1114112) {
                        A -= 65536, c.push(String.fromCharCode(A >>> 10 | 55296)), c.push(String.fromCharCode(A & 1023 | 56320)), f += 4;
                        continue;
                      }
                    }
                  }
                  c.push(String.fromCharCode(65533)), ++f;
                }
                return c.join("");
              }
              a.default = h;
            }
          )
          /******/
        }, n = {};
        function r(s) {
          var a = n[s];
          if (a !== void 0)
            return a.exports;
          var l = n[s] = {
            /******/
            // no module.id needed
            /******/
            // no module.loaded needed
            /******/
            exports: {}
            /******/
          };
          return t[s].call(l.exports, l, l.exports, r), l.exports;
        }
        r.m = t, function() {
          r.n = function(s) {
            var a = s && s.__esModule ? (
              /******/
              function() {
                return s.default;
              }
            ) : (
              /******/
              function() {
                return s;
              }
            );
            return r.d(a, { a }), a;
          };
        }(), function() {
          r.d = function(s, a) {
            for (var l in a)
              r.o(a, l) && !r.o(s, l) && Object.defineProperty(s, l, { enumerable: !0, get: a[l] });
          };
        }(), function() {
          r.g = function() {
            if (typeof globalThis == "object")
              return globalThis;
            try {
              return this || new Function("return this")();
            } catch {
              if (typeof window == "object")
                return window;
            }
          }();
        }(), function() {
          r.o = function(s, a) {
            return Object.prototype.hasOwnProperty.call(s, a);
          };
        }(), function() {
          r.r = function(s) {
            typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(s, "__esModule", { value: !0 });
          };
        }();
        var i = r("./src/index.js");
        return i;
      }()
    );
  });
})(wo);
var Tf = wo.exports;
const Cf = /* @__PURE__ */ Fi(Tf), Lf = (o, e) => ({
  [un.hls]: {
    type: "customHls",
    customType: {
      customHls: function(n) {
        const r = new dn();
        r.loadSource(n.src), r.attachMedia(n), e.current = r;
      }
    }
  },
  [un.flv]: {
    type: "customFlv",
    customType: {
      customFlv: function(n) {
        const r = Cf.createPlayer({
          type: "flv",
          url: n.src
        });
        r.attachMediaElement(n), r.load(), e.current = r;
      }
    }
  },
  [un.default]: {}
})[o], wf = (o) => {
  switch (o) {
    case "m3u8":
      return un.hls;
    case "flv":
      return un.flv;
    default:
      return un.default;
  }
}, Rf = Sa("rc-dplayer"), If = ({
  src: o,
  mseType: e,
  options: t = {},
  autoLoad: n = !0,
  customControllers: r = [],
  className: i,
  onLoad: s,
  ...a
}, l) => {
  const d = cn(null), h = cn(), u = cn(null), c = Md(), m = () => {
    var A, v, b;
    (A = h.current) == null || A.destroy(), (b = (v = u.current) == null ? void 0 : v.destroy) == null || b.call(v);
  }, f = $d(a), p = Mi((A = o, v = e) => {
    if (!A)
      return;
    let b;
    if (v)
      b = v;
    else {
      const L = A.split(".").at(-1);
      b = wf(L);
    }
    const _ = Lf(b, u);
    h.current && m();
    const { video: T, ...E } = t;
    return h.current = new jd({
      container: d.current,
      video: {
        url: A,
        ..._,
        ...T
      },
      ...E
    }), f(h.current), c(), s == null || s(h.current), h.current;
  });
  return Sd(l, () => ({
    load: p
  })), va(() => {
    n && o && p(o);
  }, [n, o]), Pd(() => {
    m();
  }), /* @__PURE__ */ Ut.jsxs(Ut.Fragment, { children: [
    /* @__PURE__ */ Ut.jsx("div", { ref: d, className: Ui(Rf(), i) }),
    /* @__PURE__ */ Ut.jsx(Kd, { dom: d, customControllers: r })
  ] });
}, Ff = _d(If);
export {
  jd as DPlayer,
  Ce as DPlayerEvents,
  un as MseType,
  Ff as Player,
  wf as ext2MseType
};
